webpackJsonp([45],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1490),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdAlert__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdAlert__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__EdAlert___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdButton__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__EdButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdForm__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdForm__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__EdForm___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdModal__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EdModal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__EdModal___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdInputText__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdInputText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EdInputText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__EdInputText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EdInputTextArea__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__EdInputTextArea___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__EdInputSelectTipo___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EdInputSelect__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EdInputSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EdInputSelect__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__EdInputSelect___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EdInputSwitch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__EdInputSwitch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EdInputEditor__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EdInputEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__EdInputEditor__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_9__EdInputEditor___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EdInputDate__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EdInputDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__EdInputDate__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__EdInputDate___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__EdInputAutoComplete___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EdInputUpload__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EdInputUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__EdInputUpload__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__EdInputUpload___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EdInputTime__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EdInputTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__EdInputTime__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__EdInputTime___default.a; });















/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(1514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1540),
  /* scopeId */
  "data-v-76b7d6d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1587),
  /* scopeId */
  "data-v-e0139152",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1467),
  /* scopeId */
  "data-v-2e68636d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1466),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1487),
  /* scopeId */
  "data-v-43108a21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1472),
  /* scopeId */
  "data-v-33efc7d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.495817c.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1537),
  /* scopeId */
  "data-v-7331f698",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EffectScope", function() { return EffectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createApp", function() { return createApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customRef", function() { return customRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineAsyncComponent", function() { return defineAsyncComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineComponent", function() { return defineComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "del", function() { return del; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effectScope", function() { return effectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentInstance", function() { return getCurrentInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentScope", function() { return getCurrentScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRaw", function() { return isRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReactive", function() { return isReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadonly", function() { return isReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRef", function() { return isRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "markRaw", function() { return markRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextTick", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onActivated", function() { return onActivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeMount", function() { return onBeforeMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUnmount", function() { return onBeforeUnmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUpdate", function() { return onBeforeUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onDeactivated", function() { return onDeactivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorCaptured", function() { return onErrorCaptured; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onMounted", function() { return onMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onScopeDispose", function() { return onScopeDispose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onServerPrefetch", function() { return onServerPrefetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUnmounted", function() { return onUnmounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUpdated", function() { return onUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provide", function() { return provide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "proxyRefs", function() { return proxyRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reactive", function() { return reactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readonly", function() { return readonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ref", function() { return ref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReactive", function() { return shallowReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReadonly", function() { return shallowReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowRef", function() { return shallowRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRaw", function() { return toRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRef", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRefs", function() { return toRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerRef", function() { return triggerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unref", function() { return unref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useAttrs", function() { return useAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCSSModule", function() { return useCSSModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCssModule", function() { return useCssModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSlots", function() { return useSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watch", function() { return watch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchEffect", function() { return watchEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchPostEffect", function() { return watchPostEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchSyncEffect", function() { return watchSyncEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] " + msg);
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn$1(msg, vm) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn$1("Error in " + info + ": \"" + err.toString() + "\"", vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn(message) {
    var _a;
    warn$1(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destory on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(22);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn$1('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$" + prop];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn$1(hook + " is called when there is no active component instance to be " +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn$1("slots." + slotName + "() got called outside of the \"render()\" scope", vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn$1("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    value.value = value.value;
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn$1('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    setupAccessControl(observed);
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                var value = getter ? getter.call(obj) : val;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return value;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn$1('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob.__raw__ = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a, _b;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_b = (_a = observed) === null || _a === void 0 ? void 0 : _a.__ob__) === null || _b === void 0 ? void 0 : _b.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn$1("value cannot be made reactive: " + String(target));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn$1("value cannot be made reactive: " + String(obj));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn$1("Set operation on key \"" + key + "\" failed: target is readonly.");
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on" + (name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got " + mode);
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn$1("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn$1("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args)));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn$1("Invalid watch source: " + JSON.stringify(s) + ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.", vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn$1("Invalid watch source: " + JSON.stringify(source) + ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.", vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return Object.is(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn$1("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn$1('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn$1('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn$1("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn$1("injection \"" + String(key) + "\" not found.", vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    if (defaultValue === undefined && ("production" !== 'production')) {
        warn$1("Injection \"" + String(key) + "\" not found", vm);
    }
    return treatDefaultAsFactory && isFunction(defaultValue)
        ? defaultValue()
        : defaultValue;
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn$1("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn$1("Current instance does not have CSS module named \"" + name + "\".");
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign({ propsData: rootProps }, rootComponent));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn$1("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn$1("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!instance) {
        ("production" !== 'production') &&
            warn$1('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn$1("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn$1("The setup binding property \"" + propName + "\" is already declared as a prop.", vm);
        }
        else {
            warn$1("The setup binding property \"" + propName + "\" is already declared.", vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn$1("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            updateTemplateRef(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            var _a;
            updateTemplateRef(this);
            if ((_a = this.$vnode) === null || _a === void 0 ? void 0 : _a.context) {
                updateTemplateRef(this.$vnode.context);
            }
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn$1('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"" + Object.prototype.toString
                .call(binding)
                .slice(8, -1) + "\"");
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$" + key;
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn$1("Cannot assign to '" + key + "' because it is a read-only property", vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$" + key;
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn$1('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn$1("[vue-composition-api] only works with Vue 2, v" + Vue.version + " found.");
            }
        }
        else {
            warn$1('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$1("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$1("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: " + comp);
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.4.4";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Pessoais'
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    maxlength: 200,
    label: 'Nome',
    rules: ['required']
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    field: 'rg',
    label: 'RG',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'date',
    field: 'dt_nas',
    label: 'Data de Nascimento',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 59,
    valor: 'valor',
    field: 'sexo',
    label: 'Sexo',
    rules: ['required']
}, {
    id: 3,
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'email',
    field: 'email',
    maxlength: 100,
    label: 'Email',
    rules: ['email']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'tel_res',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'tel_cel',
    label: 'Celular',
    mask: 'celular',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Trabalhistas'
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_funcao',
    label: 'Função',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-ghe',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    info: 'Somente se tiver PCMSO cadastrado',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    maxlength: 100,
    field: 'pis',
    label: 'PIS',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    maxlength: 100,
    field: 'mat',
    label: 'Matrícula',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_num',
    label: 'Carteira de Trabalho (Número):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_serie',
    label: 'Carteira de Trabalho (Série):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 100,
    field: 'ct_uf',
    label: 'Carteira de Trabalho (UF):',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Endereço Residencial'
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['']
}]);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'laboratorio',
    label: 'Laboratório',
    option: {
        key: 'id',
        label: 'nome',
        value: 'object'
    },
    info: 'Para cadastrar um novo laboratório por favor acesso o menú: LTCAT > Laboratórios',
    rules: ['required']
}]);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 100,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'nome_comercial',
    label: 'Nome Comercial',
    maxlength: 255,
    info: 'Campo utilizado para fins de orçamentos',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 269,
    field: 'cat_esocial',
    valor: 'descricao',
    multiple: false,
    label: 'Categoria - Tabela 23 do eSocial',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_metodologia',
    label: 'Código Metodologia',
    maxlength: 45,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_cas',
    label: 'Código CAS',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-tipo',
    tipo: 290,
    field: 'id_tipo_unidade_medida',
    multiple: false,
    label: 'Unidade de Medida - eSocial',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_esocial',
    label: 'Código eSocial (Tabela 24)',
    maxlength: 45,
    mask: 'esocial',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'esocial_atividade_per',
    label: 'Atividades Periculosas, Instalubres ou Especiais - Tabela 28 do eSocial',
    option: {
        key: 'id',
        label: 'esocial',
        title: 'nome',
        value: 'id'
    },
    info: 'Campo obrigatório para gerar o E-Social',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'vazao',
    label: 'Vazão',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'volume',
    label: 'Volume',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'cod_amostrador',
    label: 'Código Tipo Amostrador',
    maxlength: 45,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_tab',
    label: 'Tabela Dinâmica',
    option: {
        key: 'id',
        label: 'tabela_dinamica',
        value: 'id'
    },
    info: 'Selecione o modelo de tabela que esse fator de risco pertence',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'desc_metodologia',
    label: 'Descrição Metodologia',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'amostra',
    label: 'Cuidados Amostra',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'desc_amostrador',
    label: 'Descrição Tipo Amostrador',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Ativo?',
    info: 'Esse campo serve para inativar o fator de risco em outras partes no sistema.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Laboratórios'
}]);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-cnae',
    field: 'cnae',
    label: 'CNAE',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'ie',
    label: 'Inscrição Estadual',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'cep',
    field: 'cep',
    label: 'CEP',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'end',
    label: 'Endereço',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'num',
    label: 'Número',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'comp',
    label: 'Complemento',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'text',
    field: 'bairro',
    label: 'Bairro',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'tel_cel',
    label: 'Celular',
    mask: 'celular',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
    type: 'email',
    field: 'email',
    label: 'Email',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-6',
    type: 'text',
    field: 'site',
    label: 'Site',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'resp',
    label: 'Responsável',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'r_obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'color',
    field: 'cor',
    label: 'Cor das Colunas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Tabela Ativo?',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'copiar',
    label: 'Copiar Versão',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Caso desejar copiar um modelo de tabela já cadastrado, selecione aqui a tabela para ser copiada.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 438 */,
/* 439 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1591),
  /* scopeId */
  "data-v-ec5ba4d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1498),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1575),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1462),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1590),
  /* scopeId */
  "data-v-eb65ac26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(1433),
  /* scopeId */
  "data-v-057ca674",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1589),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1565),
  /* scopeId */
  "data-v-abd7595c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mask__ = __webpack_require__(980);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_lib_locale_pt__ = __webpack_require__(1602);





__webpack_require__(267);
__webpack_require__(266);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
  lang: {
    locales: { pt: __WEBPACK_IMPORTED_MODULE_3_vuetify_lib_locale_pt__["a" /* default */] },
    current: 'pt'
  },
  icons: {
    iconfont: 'fa4' },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1280
    },
    scrollBarWidth: 24
  },
  theme: {
    themes: {
      light: {
        primary: '#3777a2',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
}));

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empresa__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__credenciada__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parceiro__ = __webpack_require__(984);







var hostname = window.location.hostname,
    urlParams = null,
    ambiente = null,
    routes = [];

console.log('**hostname ' + hostname + '**');

if (false) {
  urlParams = new URLSearchParams(window.location.search);
  ambiente = urlParams.get('t');

  if (ambiente == 'emp') {
    routes = empresa;
  } else if (ambiente == 'cre') {
    routes = credenciada;
  } else {
    routes = web;
  }
} else {
  if (hostname == "web1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_2__web__["a" /* default */];
  } else if (hostname == "empresa1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_3__empresa__["a" /* default */];
  } else if (hostname == "credenciada1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_4__credenciada__["a" /* default */];
  } else if (hostname == "parceiro1.softwareatento.com.br") {
    routes = __WEBPACK_IMPORTED_MODULE_5__parceiro__["a" /* default */];
  } else {
    routes = __WEBPACK_IMPORTED_MODULE_2__web__["a" /* default */];
  }
}

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  history: true,
  mode: 'history',
  routes: routes
}));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilidade__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie__ = __webpack_require__(986);



/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cliente__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__credenciada__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__empresa__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ltcat__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__usuario__ = __webpack_require__(1015);










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var Store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      common: __WEBPACK_IMPORTED_MODULE_2__common__["a" /* default */],
      cliente: __WEBPACK_IMPORTED_MODULE_3__cliente__["a" /* default */],
      credenciada: __WEBPACK_IMPORTED_MODULE_4__credenciada__["a" /* default */],
      empresa: __WEBPACK_IMPORTED_MODULE_5__empresa__["a" /* default */],
      ltcat: __WEBPACK_IMPORTED_MODULE_6__ltcat__["a" /* default */],
      usuario: __WEBPACK_IMPORTED_MODULE_7__usuario__["a" /* default */]
    }
  });

  return Store;
});

/***/ }),
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */,
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_par',
    label: 'Copiar Tabela de Preço',
    placeholder: 'Selecione o parceiro...',
    clearable: true,
    info: 'Você pode copiar uma tabela de preço de outro parceiro. Escolha aqui o parceiro que deseja utilizar como modelo que o sistema vai duplicar a base de exames.',
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_exa',
    label: 'Exame',
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'parceiro_padrao',
    label: 'Parceiro Padrão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'valor_custo',
    label: 'Valor de Custo',
    mask: 'money',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'valor_venda',
    label: 'Valor de Venda',
    mask: 'money',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'boolean',
    field: 'padrao',
    label: 'Definir esse Parceiro como Padrão',
    info: 'Aqui você pode habilitar esse parceiro como padrão para esse exame.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'atualizar_tb_empresa',
    label: 'Atualizar Tabela de Preço das Empresas',
    info: 'Se habilitar essa opção o sistema vai inserir na tabela de preço das empresas, caso não existir, esse parceiro como padrão para esse exame. Se existir esse parceiro cadastrado o sistema vai apenas definir o exame como esse parceiro padrão.',
    rules: ['']
}]);

/***/ }),
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var TeleportDropdown = {
  name: 'TeleportDropdown',
  props: {
    visible: Boolean,
    triggerEl: { default: null }
  },
  data: function data() {
    return {
      dropdownEl: null,
      position: { top: 0, left: 0, width: 0 },
      openDirection: 'down'
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.mount();
      } else {
        this.unmount();
      }
    }
  },
  methods: {
    mount: function mount() {
      var self = this;

      if (!this.dropdownEl) {
        this.dropdownEl = document.createElement('div');
        this.dropdownEl.className = 'ed-select-tipo-dropdown';
        document.body.appendChild(this.dropdownEl);
      }

      this.updatePosition();

      this.$nextTick(function () {
        if (self.$refs.content) {
          self.dropdownEl.innerHTML = '';
          self.dropdownEl.appendChild(self.$refs.content);
        }
        self.dropdownEl.style.display = 'block';

        self._onScroll = function () {
          self.updatePosition();
        };
        self._onClickOutside = function (e) {
          if (self.dropdownEl && !self.dropdownEl.contains(e.target) && self.triggerEl && !self.triggerEl.contains(e.target)) {
            self.$emit('close');
          }
        };

        window.addEventListener('scroll', self._onScroll, true);
        window.addEventListener('resize', self._onScroll);
        document.addEventListener('mousedown', self._onClickOutside);
      });
    },

    unmount: function unmount() {
      if (this.dropdownEl) {
        this.dropdownEl.style.display = 'none';
      }
      window.removeEventListener('scroll', this._onScroll, true);
      window.removeEventListener('resize', this._onScroll);
      document.removeEventListener('mousedown', this._onClickOutside);
    },

    updatePosition: function updatePosition() {
      if (!this.triggerEl || !this.dropdownEl) return;

      var rect = this.triggerEl.getBoundingClientRect();
      var dropdownHeight = this.dropdownEl.offsetHeight || 250;
      var viewportHeight = window.innerHeight;
      var spaceBelow = viewportHeight - rect.bottom;
      var spaceAbove = rect.top;
      var top;

      if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
        top = rect.top - dropdownHeight;
        this.openDirection = 'up';
      } else {
        top = rect.bottom;
        this.openDirection = 'down';
      }

      this.dropdownEl.style.position = 'fixed';
      this.dropdownEl.style.top = top + 'px';
      this.dropdownEl.style.left = rect.left + 'px';
      this.dropdownEl.style.width = rect.width + 'px';
      this.dropdownEl.style.zIndex = '99999';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.unmount();
    if (this.dropdownEl && this.dropdownEl.parentNode) {
      this.dropdownEl.parentNode.removeChild(this.dropdownEl);
    }
  },

  render: function render(h) {
    return h('div', { ref: 'content', style: { display: this.visible ? 'block' : 'none' } }, this.$slots.default);
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EdSelectTipo',
  components: { TeleportDropdown: TeleportDropdown },
  props: {
    value: {
      type: [Number, String, Array],
      default: null
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Selecione'
    },
    valorField: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      open: false,
      search: '',
      hoverIndex: null
    };
  },

  computed: {
    safeItems: function safeItems() {
      return this.items || [];
    },

    filteredItems: function filteredItems() {
      if (!this.search) return this.safeItems;
      var s = this.search.toLowerCase();
      return this.safeItems.filter(function (item) {
        return item.descricao && item.descricao.toLowerCase().indexOf(s) !== -1 || item.obs && item.obs.toLowerCase().indexOf(s) !== -1;
      });
    },

    hasValue: function hasValue() {
      if (this.multiple) {
        return Array.isArray(this.value) && this.value.length > 0;
      }
      return this.value !== null && this.value !== '' && this.value !== undefined;
    },

    selectedItems: function selectedItems() {
      var self = this;
      if (!this.multiple || !Array.isArray(this.value)) return [];
      return this.safeItems.filter(function (item) {
        var val = self.getItemValue(item);
        return self.value.indexOf(val) !== -1;
      });
    },

    visibleTags: function visibleTags() {
      return this.selectedItems.slice(0, 1);
    },

    hiddenCount: function hiddenCount() {
      return Math.max(0, this.selectedItems.length - 1);
    },

    selectedLabel: function selectedLabel() {
      if (this.multiple || !this.hasValue) return '';
      var self = this;
      var found = this.safeItems.find(function (item) {
        return self.getItemValue(item) === self.value;
      });
      return found ? found.descricao : '';
    }
  },

  methods: {
    getItemValue: function getItemValue(item) {
      if (this.valorField) {
        return item[this.valorField] !== undefined ? String(item[this.valorField]) : '';
      }
      return parseInt(item.id);
    },

    isSelected: function isSelected(item) {
      var val = this.getItemValue(item);
      if (this.multiple && Array.isArray(this.value)) {
        return this.value.indexOf(val) !== -1;
      }
      return this.value === val;
    },

    toggle: function toggle() {
      if (this.disabled) return;
      if (this.open) {
        this.close();
      } else {
        this.openDropdown();
      }
    },

    openDropdown: function openDropdown() {
      this.search = '';
      this.open = true;
      var self = this;
      this.$nextTick(function () {
        if (self.$refs.searchInput) {
          self.$refs.searchInput.focus();
        }
      });
    },

    close: function close() {
      this.open = false;
      this.search = '';
    },

    select: function select(item) {
      var val = this.getItemValue(item);

      if (this.multiple) {
        var arr = Array.isArray(this.value) ? this.value.slice() : [];
        var idx = arr.indexOf(val);
        if (idx !== -1) {
          arr.splice(idx, 1);
        } else {
          arr.push(val);
        }
        this.$emit('input', arr);
      } else {
        this.$emit('input', val);
        this.close();
      }
    },

    removeTag: function removeTag(item) {
      if (this.disabled) return;
      var val = this.getItemValue(item);
      var arr = Array.isArray(this.value) ? this.value.slice() : [];
      var idx = arr.indexOf(val);
      if (idx !== -1) {
        arr.splice(idx, 1);
      }
      this.$emit('input', arr);
    },

    clear: function clear() {
      this.$emit('input', this.multiple ? [] : null);
      this.close();
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.close();
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-alert",
  components: {},
  mixins: [],
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    },
    description: {
      type: String,
      default: ''
    }

  },
  watch: {
    title: function title() {},
    type: function type() {},
    description: function description() {}
  },

  data: function data() {
    return {
      showModal: false
    };
  },
  mounted: function mounted() {},


  methods: {}
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_laravel_echo__ = __webpack_require__(490);





/* harmony default export */ __webpack_exports__["default"] = ({
      name: "broadcast",
      components: {},
      mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],

      data: function data() {
            return {
                  pusher: null
            };
      },
      created: function created() {},
      beforeDestroy: function beforeDestroy() {
            window.Echo = null;
      },
      mounted: function mounted() {
            this.inicialize();
      },


      watch: {},

      methods: {
            inicialize: function inicialize() {

                  if (false) {
                        window.io = require('socket.io-client');
                        window.Echo = new Echo({
                              broadcaster: 'socket.io',
                              key: process.env.PUSHER_KEY,
                              host: process.env.URL_API.web + ':6001'
                        });
                  }
            },
            onBroadcast: function onBroadcast(_channel, _event, _onEvent, _notClear) {
                  var self = this;

                  _channel = (this.cliente.logged ? this.cliente.logged.id : '0') + (_channel ? '.' + _channel : '');
                  _event = (this.cliente.logged ? this.cliente.logged.id : '0') + (_event ? '.' + _event : '');;
            },


            unSubscribe: function unSubscribe(_channel) {
                  this.pusher.unsubscribe(_channel);
            },

            sendBroadcastEvent: function sendBroadcastEvent(_channel, _event, _data) {}

      }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-button",
  components: {},
  mixins: [],
  props: {
    icon: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    type: {
      type: String,
      default: function _default() {
        return 'primary';
      }
    },
    size: {
      type: String,
      default: function _default() {
        return 'medium';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    loading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    click: {
      type: Function,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    icon: function icon() {},
    type: function type() {},
    size: function size() {},
    title: function title() {},
    value: function value() {},
    disabled: function disabled() {},
    loading: function loading() {},
    click: function click() {}
  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);



var _methods;



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ckeditor",
    components: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],

    props: {
        model: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        conteudo: {
            type: String,
            default: function _default() {
                return null;
            }
        },

        reload: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },

    data: function data() {
        return {
            loadingContent: true,
            urlRemove: [],
            initControls: null,
            deleteAll: null,
            mensagem: null,
            froalaConfig: {
                language: 'pt_br',
                placeholderText: "Escreva seu texto aqui",
                disableRightClick: true,
                key: "mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==",

                imageUploadParam: 'froala_image',
                imageUploadURL: '',
                imageUploadParams: { id: 'my_editor' },
                imageUploadMethod: 'POST',
                imageMaxSize: 5 * 1024 * 1024,
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                requestHeaders: {},
                imageStyles: {
                    imageAddBorda: 'Adicionar Borda'
                },

                imageManagerPageSize: 20,
                imageManagerScrollOffset: 10,
                imageManagerLoadURL: "",
                imageManagerLoadMethod: "GET",
                imageManagerLoadParams: { user_id: 4219762 },
                imageManagerDeleteURL: "",
                imageManagerDeleteMethod: "POST",
                imageManagerDeleteParams: { param: 'value' },
                toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'embedly', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo'],
                imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],

                events: {}
            }
        };
    },
    mounted: function mounted() {
        this.init();
    },


    watch: {
        'conteudo': function conteudo() {
            this.init();
        },
        'mensagem': function mensagem() {
            this.setConteudo();
        },
        'model': function model() {},
        reload: function reload() {
            this.init();
        }
    },

    methods: (_methods = {
        setConteudo: function setConteudo() {
            this.$events.fire('ckeditor-' + this.model, this.mensagem);
        },


        init: function init() {

            var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.froalaConfig);

            this.froalaConfig = config;
            this.mensagem = this.conteudo;
            this.loadingContent = false;
        },

        initialize: function initialize(initControls) {
            var _this = this;

            this.initControls = initControls;
            this.deleteAll = function () {
                _this.initControls.getEditor()('html.set', '');
                _this.initControls.getEditor()('undo.reset');
                _this.initControls.getEditor()('undo.saveStep');
            };

            this.initControls.initialize();
        },

        initialized: function initialized() {},

        imageBeforeUpload: function imageBeforeUpload(e, editor, files) {},

        imageUploaded: function imageUploaded(e, editor, response) {},

        imageInserted: function imageInserted(e, editor, $img, response) {},

        imageReplaced: function imageReplaced(e, editor, $img, response) {},

        imagesLoaded: function imagesLoaded(e, editor, data) {},

        imageLoaded: function imageLoaded(e, editor, $img) {},

        beforeDeleteImage: function beforeDeleteImage(e, editor, $img) {},

        imageDeleted: function imageDeleted(e, editor, data) {}

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imageDeleted', function imageDeleted(e, editor, $img) {

        var src = $img[0] && $img[0]['currentSrc'] ? $img[0]['currentSrc'] : null;

        if (src) {
            this.post('froala/delete', { src: src }).then(function (result) {

                result = result[0];
                console.log(result);
            });
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'imageError', function imageError(e, editor, error, response) {}), _methods)
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "upload",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],

  props: {
    arquivo: {
      type: [Object, String],
      default: function _default() {
        return null;
      }
    },
    fullWidth: {
      type: [Boolean],
      default: function _default() {
        return false;
      }
    }
  },

  data: function data() {
    return {
      id: 0,
      loadingDelete: false
    };
  },
  mounted: function mounted() {
    this.inicialize();
  },


  watch: {
    arquivo: function arquivo() {
      this.inicialize();
    }
  },

  methods: {

    inicialize: function inicialize() {
      this.id = new Date().getTime().toString();
    },

    downloadFile: function downloadFile(arquivo) {

      var id = arquivo && arquivo.id ? arquivo.id : this.arquivo && this.arquivo.id ? this.arquivo.id : null;

      if (!id) alert('Arquivo inválido');

      this.open('arquivo/' + this.toMd5(id) + '/download');
    },

    displayFile: function displayFile(arquivo) {
      return this.getUrl('arquivo/' + this.toMd5(arquivo.id) + '/display');
    },
    deleteFile: function deleteFile(arquivo) {
      var _this = this;

      this.loadingDelete = true;
      this.post('arquivo/' + this.toMd5(arquivo.id) + '/deletar').then(function (result) {
        _this.loadingDelete = false;
        result = result[0];
        if (result.status == 200) {
          _this.edMsg('Arquivo removido com sucesso');
          _this.$emit('deleted', arquivo);
        } else {
          _this.edMsg('Erro ao remover arquivo', 'error');
        }
      });
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-error",
  components: {},
  mixins: [],

  props: {

    response: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  watch: {
    response: function response() {}
  },

  methods: {}
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);



var FileSaver = __webpack_require__(1226);






__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale("pt-br");

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "fct",
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    getLocation: function getLocation(type) {
      var hostname = window.location;

      type = type ? type : 'hostname';

      return hostname[type];

      return '';
    },
    random: function random(min, max) {
      return Math.random() * (max - min) + min;
    },
    arrFindByField: function arrFindByField(arr, field, value) {
      if (!field || !arr || !arr.length > 0) return null;

      var arr = arr.filter(function (x) {
        return x[field] == value;
      });

      if (arr.length == 1) return arr[0];

      return null;
    },
    onlyNumber: function onlyNumber(value) {
      if (!value) return "";

      return value.replace(/[\. ,:-]+/g, "-").replace(/[^0-9\.]+/g, "");
    },
    onlyText: function onlyText(value) {
      if (!value) return "";

      value = this.toString(value);
      return value.replace(/(<([^>]+)>)/gi, "");
    },
    tempoSessao: function tempoSessao() {
      var jwt = null,
          iat = 0,
          exp = 0;

      try {
        jwt = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(this.jwt);
      } catch (error) {
        jwt = null;
      }

      if (jwt) {
        exp = this.toDate(jwt.exp * 1000, false, "YYYY-MM-DD HH:mm:ss");

        var diffSecs = Math.abs(this.diffDays(null, exp, "s")).toFixed(0);

        var hours = Math.floor(diffSecs / 3600);
        var minutes = Math.floor((diffSecs - hours * 3600) / 60);

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;

        return hours + "h " + minutes + "m";
      }

      return "00h 00m";
    },
    stringToArray: function stringToArray(string) {
      if (!string) return [];

      return JSON.parse(string);
    },
    toFormUpload: function toFormUpload(form) {
      var data = new FormData();

      for (var key in form) {
        data.append(key, form[key] != null ? form[key] : '');
      }

      return data;
    },
    toJoin: function toJoin(data) {

      var retorno = '';

      if ((typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) == 'object') {
        for (var key in data) {
          retorno += key + ": " + data[key] + "\n";
        }
      } else if (typeof data == 'array') {
        retorno = data.join('\n');
      } else {
        retorno = data;
      }

      return retorno;
    },
    textSpace: function textSpace(text) {
      try {
        text = this.toString(text).split(' ');
        return text[0];
      } catch (error) {
        return text;
      }
    },
    booleanToInteger: function booleanToInteger(form) {
      for (var key in form) {
        if (form[key] === true) form[key] = 1;

        if (form[key] === false) form[key] = 0;
      }

      return form;
    },
    base64Decode: function base64Decode(value) {
      try {
        return __WEBPACK_IMPORTED_MODULE_2_base_64___default.a.decode(value);
      } catch (err) {
        return null;
      }
    },
    base64Encode: function base64Encode(value) {
      try {
        return __WEBPACK_IMPORTED_MODULE_2_base_64___default.a.encode(value);
      } catch (err) {
        return null;
      }
    },
    utf8Decode: function utf8Decode(t) {
      if (!t) return t;

      try {
        return decodeURIComponent(escape(t));
      } catch (err) {
        return t;
      }
    },
    intervaloMes: function intervaloMes(mes, ano) {
      if (!mes || !ano) {
        mes = new Date().getMonth() + 1;
        ano = new Date().getFullYear();
      }

      var data = new Date(ano + "-" + mes + "-01");
      return data;
    },
    now: function now() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("dddd");
    },
    toDate: function toDate(date, disableHours, format) {
      if (!date) {
        date = new Date();
      }

      if (!format) {
        format = "DD/MM/YYYY HH:mm:ss";

        if (disableHours) {
          format = "DD/MM/YYYY";
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(format);
    },
    convertDate: function convertDate(date, format) {
      if (!date) {
        return new Date();
      }

      format = format ? format : 'DD/MM/YYYY';

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(format);
    },
    moneyToFloat: function moneyToFloat(value) {
      if (!value || value == "") {
        return 0;
      }

      value = this.toString(value);

      return parseFloat(value.replace(".", "").replace(",", "."));
    },
    floatToMoney: function floatToMoney(value) {
      if (!value) {
        return "0,00";
      }

      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

      value = formatter.format(value).replace("R$", "").trim();

      return value;
    },
    formataCampo: function formataCampo(text, left, format) {

      format = !format ? '0' : format;
      left = !left ? 0 : left;

      if (!text) return text;

      return text.toString().padStart(left, format);
    },
    formataRevisao: function formataRevisao(data) {

      var retorno = [],
          tmpEmp = [];

      for (var i = 0; i < data.length; i++) {
        var element = data[i];

        if (element.empresa && element.fdt) {
          var key = element.empresa.id + '_' + element.fdt.id;

          if (tmpEmp.indexOf(key) == -1) {
            tmpEmp.push(key);
            retorno.push({
              id: key,
              label: element.empresa.nome + ' :: ' + element.fdt.pcmso + ' (' + element.fdt.descricao + ')',
              options: []
            });
          }

          retorno[tmpEmp.indexOf(key)]['options'].push(element);
        }
      }
      return retorno;
    },
    addDate: function addDate(value, date, type, utc) {

      if (!date) {
        date = new Date();
      } else {
        date = new Date(date);
      }

      switch (type) {
        case "y":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'years').toDate();
          break;
        case "M":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'months').toDate();
          break;
        case "D":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'days').toDate();
          break;
        case "h":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'hours').toDate();
          break;
        case "m":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'minutes').toDate();
          break;
        case "s":
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'secounds').toDate();
          break;
        default:
          date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).add(value, 'days').toDate();
      }

      if (utc) {
        return date.toUTCString();
      }
      return date;
    },
    diffDays: function diffDays(date1, date2, type) {
      type = !type ? "d" : type;
      date1 = !date1 ? __WEBPACK_IMPORTED_MODULE_1_moment___default()() : __WEBPACK_IMPORTED_MODULE_1_moment___default()(date1);
      date2 = !date2 ? __WEBPACK_IMPORTED_MODULE_1_moment___default()() : __WEBPACK_IMPORTED_MODULE_1_moment___default()(date2);

      switch (type) {
        case "y":
          return date1.diff(date2, "years", true);
          break;
        case "d":
          return date1.diff(date2, "days", true);
          break;
        case "h":
          return date1.diff(date2, "hours", true);
          break;
        case "m":
          return date1.diff(date2, "minutes", true);
          break;
        case "s":
          return date1.diff(date2, "seconds", true);
          break;
        default:
          return date1.diff(date2, "days", true);
          break;
      }
    },
    b64toBlob: function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });

      return blob;
    },
    download: function download(blobData, filename) {
      FileSaver.saveAs(blobData, filename);
    },
    utf8_encode: function utf8_encode(s) {
      return unescape(encodeURIComponent(s));
    },
    utf8_decode: function utf8_decode(s) {
      return decodeURIComponent(escape(s));
    },


    toMb: function toMb(bytes) {

      if (!bytes) return '0 MB';

      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    },

    toString: function toString(value) {
      if (value == null || value == undefined) return '';

      return value.toString();
    },
    toMd5: function toMd5(text) {

      try {
        text = this.toString(text);
        text = __WEBPACK_IMPORTED_MODULE_3_js_md5___default()(text);
        return text;
      } catch (e) {
        return text;
      }
    },
    edAlert: function edAlert(_msg, _type, _items) {

      _type = _type ? _type : 'success';

      this.$alert(_msg, 'Atenção', {
        type: _type,
        confirmButtonText: 'OK'
      });
    },
    edMsg: function edMsg(_msg, _type) {

      _type = _type ? _type : 'success';

      this.$message({
        showClose: true,
        type: _type,
        message: _msg
      });
    },
    edNotification: function edNotification(_msg, _type) {

      _type = _type ? _type : 'success';

      this.$notify({
        showClose: true,
        type: _type,
        message: _msg
      });
    },
    validateEmail: function validateEmail(email) {

      email = email ? email.trim() : null;

      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    getPreco: function getPreco(value, type) {
      if (!value) return null;

      var arr = value.split(',');

      if (arr.length != 2) return null;

      if (type == 'unit') return arr[0];else return arr[1];
    },
    textLimit: function textLimit(value, limit) {

      limit = limit ? limit : 100;

      if (value && value.length > limit) {
        return value.substring(0, limit) + "...";
      }

      return value;
    }
  }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_error__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_ckeditor__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_EdSelectTipo__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_EdSelectTipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_EdSelectTipo__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-form",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, EdError: __WEBPACK_IMPORTED_MODULE_4_common_error___default.a, EdUpload: __WEBPACK_IMPORTED_MODULE_2_common_upload___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_5_common_alert___default.a, EdEditor: __WEBPACK_IMPORTED_MODULE_6_common_ckeditor___default.a, EdSelectTipo: __WEBPACK_IMPORTED_MODULE_7_common_EdSelectTipo___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    response: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    save: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    itens: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tooltipClick: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data: function data() {
      this.inicialize();
    },
    response: function response() {
      this.inicialize();
    },
    save: function save() {},
    config: function config() {
      this.inicialize();
    },
    "config.click": function configClick() {
      this.inicialize();
    },
    "config.list": function configList() {
      this.inicialize();
    },
    "config.tipo_exclude": function configTipo_exclude() {
      this.inicialize();
    },
    "config.obs": function configObs() {},
    itens: function itens() {}
  },

  data: function data() {
    return {
      id: this.toString(new Date().getTime()),
      rules: {
        required: { required: true, message: "Campo Obrigatório", trigger: "blur" },
        email: { type: "email", message: "Informe um email válido", trigger: ["blur", "change"] }
      },
      mask: {
        money: "money",
        number: "999999999999999999",
        cep: "99.999-999",
        cbo: "9999-99",
        time: "99:99:99",
        cpf: "999.999.999-99",
        cnpj: "SS.SSS.SSS/SSSS-99",
        documento: "SS.SSS.SSS/SSSS-99",
        celular: "(99)99999-9999",
        telefone: "(99) 9999-9999",
        date: "99/99/9999",
        esocial: "99.99.999"
      },
      predefineColors: ["#ff4500", "#d72d12", "#ff8c00", "#ffd700", "#90ee90", "#18BE31", "#00ced1", "#1e90ff", "#c71585", "#9C5317"],
      error: {},
      tipos: {},
      cidades: [],
      estados: [],
      funcoes: [],
      events: [],
      cnaes: [],
      revisoesEmp: [],
      status: 200,
      loadingEstado: false,
      loadingCidade: false,
      loadingCnae: false,
      handleCidadeDebounce: null,
      handleCnaeDebounce: null,
      maxDaysTomorrow: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.handlerClear();
  },
  mounted: function mounted() {
    this.inicialize();
    this.handleCidadeDebounce = _.debounce(this.handleCidade, 1000);
    this.handleCnaeDebounce = _.debounce(this.handleCnae, 1000);
  },


  methods: {
    inicialize: function inicialize() {
      this.error = {};

      if (this.response.options && this.response.options.data) {
        this.error = this.response.options.data;
      }
      this.status = this.response.status ? this.response.status : 200;

      if (this.config.estado) {
        this.handleEstado();
      }

      if (this.config.cnae) {
        this.handleCnae(this.data.cnae && this.data.cnae.cnae ? this.data.cnae.cnae : this.data.cnae);
      }

      if (this.config.tipo && this.config.tipo.length > 0) {
        this.handleParametros();
      }
    },
    handlerClear: function handlerClear() {
      this.id = null;
      this.error = {};
      this.tipos = {};
      this.cidades = [], this.estados = [];
      this.funcoes = [];
      this.events = [];
      this.cnaes = [];
    },
    handlerUpload: function handlerUpload() {
      var _this = this;

      var _loop = function _loop() {
        var event = "upload-" + field;

        if (field.search("arquivo") != -1 && _this.events.indexOf(event) == -1) {
          _this.$events.on(event, function (eventData) {
            if (_this.events.indexOf(event) != -1) {}
          });

          _this.events.push(event);
        }
      };

      for (var field in this.data) {
        _loop();
      }
    },
    handleValidation: function handleValidation() {
      var retorno = true;

      for (var i = 0; i < this.itens.length; i++) {
        var item = this.itens[i];

        if (item && item.rules) {
          var field = item.field,
              input = this.data[field];

          for (var j = 0; j < item.rules.length; j++) {
            var element = item.rules[j];

            switch (element) {
              case "required":
                if (input == null || input == "") {
                  this.error[field] = ["Campo obrigatório"];
                  retorno = false;
                }
                break;
            }
          }
        }
      }

      return retorno;
    },
    handlerSave: function handlerSave() {
      this.config.click.save();
    },
    handleValueSelect: function handleValueSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.value) {
        switch (item.option.value) {
          case "object":
            return val;
            break;

          case "id":
            return parseInt(val[item.option.value]);
            break;

          default:
            return val[item.option.value];
            break;
        }
      }

      return val.id;
    },
    handleLabelSelect: function handleLabelSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            var parent = "";

            if (val.parent) {
              parent = val.parent.rev + " (" + val.parent.descricao + ") / ";
            }

            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + parent + val.rev + " (" + val.descricao + ")";

            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          case "esocial":
            return val.codigo;
            break;

          case "fator_risco":
          case "tabela_dinamica":
            return val.nome;
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },
    handleTitleSelect: function handleTitleSelect(item, val) {
      if (!val) return val;

      if (item.option && item.option.title) {
        switch (item.option.title) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return (val.empresa ? val.empresa.nome + " :: " : "") + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ") :: " : "") + val.rev + " (" + val.descricao + ")";
            break;

          case "funcionario":
            return val.nome + " (" + val.cpf + ")";
            break;

          case "ltcat_orcamento":
            return val.codigo;
            break;

          case "empresa":
            return val.nome + " (" + val.cnpj + ")";
            break;

          case "equipamento_medicao":
            return val.nome + " / " + val.marca + " / " + val.modelo + " / " + val.serie;
            break;

          case "financeiro.conta":
            return "AG: " + val.agencia + " CC: " + val.conta;
            break;

          case "tabela.preco":
            return (val.empresa ? val.empresa.nome : "") + " / " + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")" : "");
            break;

          default:
            return val[item.option.title];
            break;
        }
      }

      return val.nome;
    },
    handleLabelSelectHtml: function handleLabelSelectHtml(item, val) {
      var width = this.window.width,
          limit = width * 0.98 / 10;

      limit = 80;

      if (!val) return val;

      if (item.option && item.option.label) {
        switch (item.option.label) {
          case "fdt":
            return val.pcmso + " (" + val.descricao + ")";
            break;

          case "ghe":
            return val.ghe + " (" + val.descricao + ")";
            break;

          case "modelo":
            return val.id + " (" + val.nome + ")";
            break;

          case "revisao":
            return '<span style="' + (val.style ? val.style : "") + '">' + (!val.parent ? "<b>" + val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")" + "</b>" : val.rev + " (" + val.descricao + (val.data ? " em " + this.toDate(val.data, true) : "") + ")") + "</span>";
            break;

          case "funcionario":
            return "<b>" + val.nome + "</b>" + (val.empresa ? ' (<span style="font-size:9pt">' + val.empresa.nome + "</span>)" : "") + (val.cpf ? '<br><span style="font-size:9pt">' + val.cpf + "</span>" : "");
            break;

          case "ltcat_orcamento":
            return "<b>" + val.codigo + " (" + this.toDate(val.updated_at) + ")" + "</b>" + (val.descricao ? '<br><span style="font-size:9pt">' + val.descricao + "</span>" : "");
            break;

          case "financeiro.conta":
            return "<br>AG:</b> " + val.agencia + " <b>CC:</b> " + val.conta;
            break;

          case "tabela.preco":
            return "<b>" + (val.empresa ? val.empresa.nome + "</b>" : "") + '<br><span style="font-size:9pt">' + (val.fdt ? val.fdt.pcmso + " (" + val.fdt.descricao + ")</span>" : "");
            break;

          case "consulta":
            return "<b>CÓD: " + val.id_con + " (" + this.toDate(val.dt_cad, true) + ")</b>" + (val.empresa ? '<br><span style="font-size:9pt">' + val.empresa.nome + "</span>" : "") + (val.funcionario ? '<br><span style="font-size:9pt">' + val.funcionario.nome + "</span>" : "");
            break;

          case "empresa":
            return "<b>" + val.nome + "</b>" + (val.cnpj ? '<br><span style="font-size:9pt">' + val.cnpj + "</span>" : "");
            break;

          case "esocial":
            return "<b>" + this.textLimit(val.nome, limit) + "</b>" + (val.codigo ? '<br><span style="font-size:9pt">' + val.codigo + "</span>" : "");
            break;

          case "fator_risco":
            return "<b>" + this.textLimit(val.nome, limit) + "</b>" + (val.cod_esocial ? '<br><span style="font-size:9pt">' + val.cod_esocial + "</span>" : "") + (val.cod_metodologia && val.cod_metodologia != "***" ? (!val.cod_esocial ? "<br>" : "") + '<span style="font-size:9pt"> (' + val.cod_metodologia + ")</span>" : "");
            break;

          case "tabela_dinamica":
            return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + val.cor + '">&nbsp;</span>' + val.nome;
            break;

          case "equipamento_medicao":
            return "<b>" + val.nome + "</b>" + (val.marca ? '<br><span style="font-size:9pt">' + val.marca + " / " + val.modelo + " / " + val.serie + "</span>" : "");
            break;

          default:
            return val[item.option.label];
            break;
        }
      }

      return val.nome;
    },
    handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        var diff = this.diffDays(date);
        if (diff > this.maxDaysTomorrow) {
          return true;
        }
      }

      return date < hoje;
    },
    handlerDisableTomorrowDate: function handlerDisableTomorrowDate(date) {
      var hoje = this.toDate(null, true, "YYYY-MM-DD");
      date = this.toDate(date, true, "YYYY-MM-DD");

      if (this.maxDaysTomorrow) {
        var diff = this.addDate(this.maxDaysTomorrow, date, "d");
        if (diff > this.maxDaysTomorrow) {
          return false;
        }
      }

      return date > hoje;
    },
    handleTimeOptions: function handleTimeOptions() {
      return {
        start: "00:00",
        step: "00:15",
        end: "24:00"
      };
    },
    handleDateOptions: function handleDateOptions(item) {
      var options = null;

      this.maxDaysTomorrow = item.maxDaysTomorrow;

      if (item.yesterdayDisabledDate) {
        options = {
          disabledDate: this.handlerDisableYesterdayDate
        };
      } else if (this.config.options && this.config.options[item.field] && this.config.options[item.field].disabledDate) {
        options = {
          disabledDate: this.config.options[item.field].disabledDate
        };
      }

      if (item.tomorrowDisabledDate) {
        options = {
          disabledDate: this.handlerDisableTomorrowDate
        };
      }

      return options;
    },
    handleRules: function handleRules(rules) {
      if (!rules || rules.length == 0) return [];

      var arr = [];

      for (var i = 0; i < rules.length; i++) {
        if (this.rules[rules[i]]) arr.push(this.rules[rules[i]]);
      }

      return arr;
    },
    handlePrefixIcon: function handlePrefixIcon(item) {
      switch (item.mask) {
        case "money":
          return "fas fa-dollar-sign";
          break;

        case "cpf":
        case "cnpj":
        case "documento":
          return "fas fa-credit-card";
          break;

        case "telefone":
          return "fas fa-phone";
          break;

        case "celular":
          return "fas fa-mobile-alt";
          break;
      }
    },
    handleParametros: function handleParametros() {
      var _this2 = this;

      var exclude = this.config.tipo_exclude ? this.config.tipo_exclude : [];

      this.post("tipo/parent", { codigo: this.config.tipo, exclude: exclude }).then(function (result) {
        result = result[0];

        _this2.tipos = {};

        if (result.status == 200) {
          for (var i = 0; i < _this2.config.tipo.length; i++) {
            _this2.tipos[_this2.config.tipo[i]] = result.data[_this2.config.tipo[i]];
          }
        }
      });
    },


    handleCnae: function handleCnae(search) {
      var _this3 = this;

      this.loadingCnae = true;
      this.cnaes = [];

      if ((typeof search === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(search)) == "object" && search) {
        search = search["cnae"];
      }

      this.get("common/cnae", { search: search }).then(function (result) {
        result = result[0];

        _this3.loadingCnae = false;

        if (result.status == 200) {
          _this3.cnaes = result.data.data;
        }
      });
    },

    handleEstado: function handleEstado() {
      var _this4 = this;

      this.loadingEstado = true;

      this.get("common/estado", null, true).then(function (result) {
        result = result[0];

        _this4.loadingEstado = false;
        _this4.estados = [];

        if (result.status == 200) {
          _this4.estados = result.data;

          if (_this4.data.id_estado) _this4.handleCidade(_this4.data.id_cidade ? _this4.data.id_cidade : "");
        }
      });
    },
    handleCidade: function handleCidade(search) {
      var _this5 = this;

      if (!this.data || !this.data.id_estado) return;

      this.cidades = [];
      this.loadingCidade = true;

      this.get("common/cidade/" + this.data.id_estado, { search: search, take: 100 }, true).then(function (result) {
        result = result[0];

        _this5.loadingCidade = false;

        if (result.status == 200) {
          _this5.cidades = result.data;
        }
      });
    },
    handleEndereco: function handleEndereco() {
      var _this6 = this;

      var cep = this.onlyNumber(this.data.cep);

      if (!cep) return;

      this.get("common/cep/" + cep, null, true).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this6.data.end = result.data.endereco.logradouro ? result.data.endereco.logradouro : _this6.data.end;

          _this6.data.bairro = result.data.endereco.bairro ? result.data.endereco.bairro : _this6.data.endereco_bairro;

          _this6.data.comp = result.data.endereco.complemento ? result.data.endereco.complemento : _this6.data.endereco_complemento;

          if (result.data.cidade) {
            _this6.data.id_cidade = result.data.cidade.id_cidade;
            _this6.cidades = [result.data.cidade];
          }

          if (result.data.estado) {
            _this6.data.id_estado = result.data.estado.uf;
          }
        }
      });
    }
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "logout",
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false
    };
  },
  mounted: function mounted() {
    this.inicialize();
  },


  methods: {
    inicialize: function inicialize() {
      var _this = this;

      if (!this.logged()) {
        this.toRoute({ name: this.sub_domain + '.login' });
        return;
      }

      var self = this;

      this.$confirm('Tem certeza que deseja encerrar sua sessão no sistema?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.loadingContent = true;

        _this.post("usuario/logout").then(function (result) {
          result = result[0];
          self.loadingContent = false;
          _this.logout();
        });
      }).catch(function () {
        _this.toRoute({ name: _this.sub_domain + '.home' });
      });
    }
  }
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_session__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_session__);





/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_1_common_session___default.a],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_broadcast__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_broadcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_broadcast__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_2_common_broadcast___default.a],
  components: {},
  created: function created() {},


  mounted: function mounted() {},

  data: function data() {
    return {
      sessao: "08h 00m",
      loadingContent: true,
      items: [{
        text: 'Admin',
        href: '#'
      }, {
        text: 'Manage',
        href: '#'
      }, {
        text: 'Library',
        active: true
      }]
    };
  },

  methods: {
    isSubMenuVisible: function isSubMenuVisible(sub_menu) {
      if (sub_menu.rota && sub_menu.rota.indexOf('conta-whatsapp') !== -1) {
        var clienteId = this.cliente && this.cliente.logged ? this.cliente.logged.id : null;
        return clienteId === 1 || clienteId === 914;
      }
      return true;
    },


    getMensagem: function getMensagem(result) {
      if (result && result.data) {
        var mensagem = result.data;

        this.$notify({
          title: mensagem.title ? mensagem.title : "Atenção",
          message: mensagem.message,
          type: mensagem.type ? mensagem.type : "success",
          offset: 100,
          duration: 10000
        });
      }
    }
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ed-modal",
    components: { EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
    mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],
    props: {
        title: {
            type: String,
            default: 'Modal'
        },
        modal: {
            type: Boolean,
            default: false
        },
        onClear: {
            type: Function,
            default: null
        },
        loadingSave: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '95%'
        },
        saveIcon: {
            type: String,
            default: 'fa fa-save'
        },
        closeESC: {
            type: Boolean,
            default: false
        },
        isModal: {
            type: Boolean,
            default: true
        },
        closeCLICK: {
            type: Boolean,
            default: false
        },
        lodingSave: {
            type: Boolean,
            default: false
        },
        disabledSave: {
            type: Boolean,
            default: false
        },
        saveName: {
            type: String,
            default: 'Salvar'
        },
        onSave: {
            type: Function,
            default: null
        },
        onClose: {
            type: Function,
            default: null
        },
        currentTab: {
            type: String,
            default: ''
        }
    },
    computed: {
        isCurrentTabHistorico: function isCurrentTabHistorico() {
            return this.currentTab.toLowerCase() === 'tab-historico';
        }
    },
    watch: {
        title: function title() {},
        disabledSave: function disabledSave() {},
        modal: function modal() {
            this.showModal = !this.showModal;
        },
        loading: function loading() {},
        loadingSave: function loadingSave() {},
        width: function width() {},
        saveIcon: function saveIcon() {},
        closeESC: function closeESC() {},
        isModal: function isModal() {},
        closeCLICK: function closeCLICK() {},
        lodingSave: function lodingSave() {},
        saveName: function saveName() {},
        onSave: function onSave() {}
    },
    data: function data() {
        return {
            showModal: false
        };
    },
    mounted: function mounted() {},

    methods: {
        handlerClose: function handlerClose() {
            if (this.onClose) {
                this.onClose();
            } else {
                this.showModal = false;
            }
        }
    }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-paginate",
  components: {},
  mixins: [],

  props: {
    pagination: {
      type: Object,
      default: null
    },
    navigation: {
      type: Function,
      default: function _default() {
        return;
      }
    }
  },

  watch: {
    pagination: function pagination() {},
    navigation: function navigation() {}
  },

  data: function data() {
    return {
      page: 1
    };
  },
  mounted: function mounted() {},


  methods: {
    onHandlerPage: function onHandlerPage() {
      this.navigation(this.page);
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_session__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_stringify_safe__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_json_stringify_safe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_broadcast__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_broadcast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_broadcast__);










/* harmony default export */ __webpack_exports__["default"] = ({

	name: "rest",
	components: {},
	mixins: [__WEBPACK_IMPORTED_MODULE_4_common_session___default.a, __WEBPACK_IMPORTED_MODULE_6_common_broadcast___default.a],

	data: function data() {
		return {
			requestParam: {
				force_web: false,
				url: "web1.softwareatento.com.br",
				xToken: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).X_TOKEN,
				appVersion: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).APP_VERSION,
				service: null,
				method: null,
				encryptData: null,
				jwt: null,
				headers: null,
				loginRedirect: true,
				uploadProgress: null
			}
		};
	},
	mounted: function mounted() {},


	methods: {

		getUrl: function getUrl(method) {
			this.setUrl();
			return this.requestParam.url + method + '?token=' + this.logged();
		},

		get: function get(_service, _params, _force_web) {

			_params = !_params ? '' : '?' + $.param(_params);

			this.requestParam.service = _service + _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'GET';

			return this.request();
		},
		post: function post(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'POST';

			return this.request();
		},

		put: function put(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'PUT';

			return this.request();
		},

		delete: function _delete(_service, _params, _filters, _force_web) {

			_filters = !_filters ? '' : '?' + $.param(_filters);

			this.requestParam.service = _service + _filters;
			this.requestParam.param = _params;
			this.requestParam.force_web = _force_web;
			this.requestParam.method = 'DELETE';

			return this.request();
		},

		open: function open(_service, _params) {
			this.setUrl();

			_params = !_params ? '' : '&' + $.param(_params);

			var token = this.logged();

			if (token) _service += '?token=' + token + _params;

			window.open(this.requestParam.url + _service, '_blank');
		},

		removeStyle: function removeStyle() {
			$('body').removeAttr('style');
			$('body').removeClass('el-loading-parent--relative el-loading-parent--hidden');
		},

		getReq: function getReq() {
			var req = {
				date: null,
				hash: null
			};

			req.date = this.addDate(1, null, 'm');
			req.date = this.toDate(req.date, false, 'YYYY-MM-DD HH:mm:ss');

			req.hash = this.toMd5(req.date + "6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E");

			return this.base64Encode(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(req));
		},


		getHeaders: function getHeaders(onlyeJWT) {

			var jwt = this.logged(),
			    version = this.getCookie('version'),
			    req = {
				date: null,
				hash: null
			};

			if (onlyeJWT) {
				return {
					'authorization': jwt ? 'Bearer ' + jwt : null
				};
			}

			var headers = {
				'Authorization': jwt ? 'Bearer ' + jwt : null,
				'Version': version ? version : 'null',
				'Accept': 'application/json',
				'Content-Type': 'application/json;charset=UTF8',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
				'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type'
			};

			headers["xToken"] = this.getReq();

			return headers;
		},

		setHeaders: function setHeaders() {

			this.requestParam.headers = this.getHeaders();

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common = this.requestParam.headers;
		},

		setUrl: function setUrl() {

			var sub_domain = this.requestParam.force_web == true ? 'web' : this.sub_domain,
			    url = "https://" + __webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"})[sub_domain];

			if (true) {
				url += '/commtrol';
			}

			url += '/api/';

			if (sub_domain != 'web') url += this.tenant + '/';

			this.requestParam.url = url;

			return url;
		},

		request: function request() {
			var _this = this;

			this.setUrl();
			this.setHeaders();

			var response = {};

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

				response = { msg: 'OK', status: 200, data: null };
				var promisses = [],
				    self = _this;

				__WEBPACK_IMPORTED_MODULE_3_axios___default()({
					method: _this.requestParam.method,
					url: _this.requestParam.service,
					data: _this.requestParam.param,
					baseURL: _this.requestParam.url,

					onUploadProgress: function onUploadProgress(progressEvent) {
						var uploadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);

						if (uploadProgress == 100) {
							uploadProgress = 99;
						}

						self.requestParam.uploadProgress = uploadProgress;
					},

					onDownloadProgress: function onDownloadProgress(progressEvent) {}
				}).then(function (result) {

					response = result.data;
					promisses.push(response);

					_this.removeStyle();
					_this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

					if (_this.env.log && _this.env.log.request) {
						console.log('[request ' + _this.requestParam.method + ' TO => ' + _this.requestParam.service + ' ' + result.status + ']');
					}

					return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
						resolve(success);
					}, function (err) {});
				}).catch(function (err) {

					var error = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, err).response;
					_this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

					if (!error) {

						error = {
							status: 500,
							msg: 'Não foi possível completar a requisição. Precione as teclas CTRL+F5 para recarregar a página e tente novamente.',
							data: null
						};

						error.data = error;
					}

					if (error) {

						response = error.data;

						switch (response.status) {

							case 400:

								if (response.options && response.options.data) {

									var h = _this.$createElement;
									var items = [],
									    validation_messages = response.options.data;
									_this.edAlert(response.msg, 'error');
								}

								break;

							case 401:
								_this.logout();
								break;

							case 413:
								response.msg = 'A requisição excedeu o tamanho limite.';
								response.data = 'A requisição excedeu o tamanho limite.';
								break;

							case 426:
								window.location.reload(true);
								break;

							case 429:
								_this.edAlert('Servico indisponível. Aguarde 5 minutos e tente novamente.', 'error');
								break;
						}
					}

					promisses.push(response);

					if (_this.env.log && _this.env.log.request) {
						console.log('[request ' + _this.requestParam.method + ' TO => ' + _this.requestParam.service + ' ' + response.status + ']');
						console.log(error);
					}

					if (_this.requestParam.method != 'GET' && response.status != 200 && response.status != 400 && response.status != 426 && response.status != 403 && response.status != 401 && response.status != 404) {
						_this.edAlert(response.msg, 'error');
					}

					_this.removeStyle();

					return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
						resolve(success);
					}, function (err) {});
				});
			});
		}

	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "session",
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
  computed: {
    cliente: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setCliente", value);
      }
    },
    production: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    usuario: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    jwt: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario.jwt;
      },
      set: function set(jwt) {
        this.$store.dispatch("usuario/setJwt", jwt);
      }
    },
    sub_domain: {
      cache: false,
      get: function get() {
        return this.$store.state.common.sub_domain;
      },
      set: function set(value) {
        this.$store.dispatch("common/setSubDomain", value);
      }
    },
    tenant: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente.tenant;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setTenant", value);
      }
    },
    env: {
      cache: false,
      get: function get() {
        return this.$store.state.common.env;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEnv", value);
      }
    },
    navigation: {
      cache: false,
      get: function get() {
        return this.$store.state.common.navigation;
      },
      set: function set(value) {
        this.$store.dispatch("common/setNavigation", value);
      }
    },
    window: {
      cache: false,
      get: function get() {
        return this.$store.state.common.window;
      },
      set: function set(value) {
        this.$store.dispatch("common/setWindow", value);
      }
    },
    device: {
      cache: false,
      get: function get() {
        return this.$store.state.common.device;
      }
    }
  },
  watch: {
    sub_domain: function sub_domain() {},
    navigation: function navigation() {},
    window: function window() {},
    "cliente.logged": function clienteLogged() {
      this.setTitle();
    },
    "usuario.logged": function usuarioLogged() {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    logout: function logout(reload) {
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
      this.clearSession(true);

      this.toRoute({ name: this.sub_domain + ".login" });
    },
    clearSession: function clearSession() {
      this.deleteCookie(this.getJwt());
    },
    validarAcesso: function validarAcesso(modulo) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_modulo.indexOf(modulo) != -1;
    },
    validarPermissao: function validarPermissao(permissao) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_permissao.indexOf(permissao) != -1;
    },
    validarPacote: function validarPacote(pacote) {
      return (this.cliente.logged && this.cliente.logged.pacotes.indexOf(pacote)) != -1;
    },
    toRoute: function toRoute(route, type) {
      type = type ? type : "name";

      var query = this.$route.query;

      switch (type) {
        case "location":
          window.open(route, "_top");
          break;

        default:
          if ((typeof route === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(route)) == "object") {
            route.query = query;
          }

          this.$router.push(route);
          break;
      }
    },
    logged: function logged() {
      var jwt = this.getJwt(),
          cookie = null;

      if (!jwt) return null;

      cookie = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(jwt);

      return cookie;
    },
    getJwt: function getJwt(parse) {
      var jwt = null;

      try {
        jwt = this.env["jwt_" + this.sub_domain];

        if (!jwt) return null;

        if (parse) return __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(jwt);

        return jwt;
      } catch (error) {
        this.edAlert(error, "error");
      }
    },
    setTitle: function setTitle(title) {
      if (!title) {
        var to = this.$route;
        if (to.meta && to.meta.title && to.meta.navigation) {
          title = to.meta.title;
        }
      }

      switch (this.sub_domain) {
        case "web":
          document.title = title + " :: " + (this.cliente.logged ? this.cliente.logged.nome : "");
          break;

        case "empresa":
          document.title = "Area da Empresa" + (title ? " :: " + title : "");
          break;

        case "credenciada":
          document.title = "Area da Credenciada" + (title ? " :: " + title : "");
          break;

        case "parceiro":
          document.title = "Area do Parceiro" + (title ? " :: " + title : "");
          break;
      }
    },
    setCookie: function setCookie(key, value, _expires, toJSONString) {
      if (this.getCookie(key)) return;

      _expires = _expires ? _expires : 8;

      if (toJSONString) {
        value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      }

      if (_expires == -1) {
        _expires = 720;
      }

      var date = this.addDate(_expires, null, "h");

      var test = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set(key, value, {
        expires: date,

        secure: false,
        path: "/"
      });
    },
    getCookie: function getCookie(key, toJSON) {
      if (toJSON) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key));
      }
      return __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key);
    },
    deleteCookie: function deleteCookie(key) {
      if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(key)) {
        __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.delete(key);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_error__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_paginate__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_paginate__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "table",
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_5_common_alert___default.a, EdError: __WEBPACK_IMPORTED_MODULE_6_common_error___default.a, EdPaginate: __WEBPACK_IMPORTED_MODULE_7_common_paginate___default.a, Download: __WEBPACK_IMPORTED_MODULE_2_common_download___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    onEdit: {
      type: Function,
      default: null
    },

    onEditAll: {
      type: Function,
      default: null
    },
    onClear: {
      type: Function,
      default: null
    },

    onDelete: {
      type: Function,
      default: null
    },

    onRegister: {
      type: Function,
      default: null
    },

    onSearch: {
      type: Function,
      default: null
    },

    onFilter: {
      type: Function,
      default: null
    },

    inputSearch: {
      type: String,
      default: null
    },

    inputFilter: {
      type: Object,
      default: null
    },

    onDeleteName: {
      type: String,
      default: "Deletrar Registro"
    },

    registerName: {
      type: String,
      default: "Novo Registro"
    },

    registerIcon: {
      type: String,
      default: "fa fa-plus-circle"
    },

    editAllIcon: {
      type: String,
      default: "fa fa-pencil-square-o"
    },

    editAllName: {
      type: String,
      default: "Editar Registro(s)"
    },

    editAllTitle: {
      type: String,
      default: "Editar Registro(s)"
    },

    emptyTable: {
      type: String,
      default: "Nenhum resultado encontrado"
    },

    tableHead: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableFooter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    disableInputSearch: {
      type: Boolean,
      default: false
    },

    disableInputButtons: {
      type: Boolean,
      default: true
    },

    disableCheckAll: {
      type: Boolean,
      default: false
    },

    disableTableContent: {
      type: Boolean,
      default: false
    },

    editableRows: {
      type: Boolean,
      default: false
    },

    disabledConfigCell: {
      type: Boolean,
      default: false
    },

    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    response: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    loadingTable: {
      type: Boolean,
      default: false
    },

    loadingRegister: {
      type: Boolean,
      default: false
    },

    loadingEditAll: {
      type: Boolean,
      default: false
    },

    filterBadge: {
      type: [Number, String],
      default: 0
    }
  },

  data: function data() {
    return {
      formData: {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null
      },
      items: [],
      fields: [],
      checkAll: [],
      checkItem: [],
      showPopoverCheckAll: false,
      showFilter: false,
      lstPages: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600, 700, 800, 900]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.handlerClear();
  },
  mounted: function mounted() {
    this.inicialize();
  },


  watch: {
    tableHead: function tableHead() {
      this.handleFields();
    },
    tableData: function tableData() {
      this.handleItens();
    },
    tableFooter: function tableFooter() {},
    onEdit: function onEdit() {},
    onEditAll: function onEditAll() {},
    onSearch: function onSearch() {},
    onRegister: function onRegister() {},
    filterBadge: function filterBadge() {},
    loadingTable: function loadingTable() {},
    loadingEditAll: function loadingEditAll() {},
    loadingRegister: function loadingRegister() {},
    disabledConfigCell: function disabledConfigCell() {
      this.handleFields();
    },
    "response.status": function responseStatus() {},
    config: function config() {},
    device: function device() {
      this.handleFields();
    },
    inputSearch: function inputSearch() {
      this.formData.search = this.inputSearch;
    },
    inputFilter: function inputFilter() {
      this.formData.filter = this.inputFilter;
    },
    pagination: function pagination() {
      if (this.pagination && this.pagination.per_page) {
        this.formData.ppage = parseInt(this.pagination.per_page);
      } else {
        this.formData.ppage = 50;
      }
    }
  },

  methods: {
    getUrlFuncionario: function getUrlFuncionario(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/funcionarios/editar/" + (_data.funcionario ? _data.funcionario.id : _data.id);
      } else {
        url = this.env.url_cs + "/app/funcionarios_info.php?abre=" + (_data.funcionario ? _data.funcionario.id : _data.id);
      }
      return url;
    },
    getUrlEmpresa: function getUrlEmpresa(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/meu-cadastro?";
      } else {
        url = this.env.url_cs + "/app/empresas_info.php?abre=" + (_data.empresa ? _data.empresa.id : _data.empresa_id);
      }
      return url;
    },
    getUrlConsulta: function getUrlConsulta(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "#";
      } else {
        url = this.env.url_cs + "/app/consulta.php?con=" + _data.id_con;
      }
      return url;
    },
    getUrlLote: function getUrlLote(_data) {
      var url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/esocial/gerar-lote" + (_data.lote ? "/" + _data.lote : "");
      } else {
        url = "https://" + "web1.softwareatento.com.br" + "/esocial/lotes" + (_data.lote ? "/" + _data.lote : "");
      }

      return url;
    },
    inicialize: function inicialize() {
      this.formData.search = this.inputSearch;
      this.formData.filter = this.inputFilter;
      this.handleItens();
      this.handleFields();
    },
    handleItens: function handleItens() {
      this.items = this.tableData;
      this.checkItem = [];
      this.checkAll = [];
      this.showPopoverCheckAll = false;
    },
    handlerClear: function handlerClear() {
      this.error = {};
      this.items = [], this.fields = [];
      this.checkAll = [];
      this.checkItem = [];
      this.formData = {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null
      };
    },
    handleClear: function handleClear() {
      if (this.onClear) {
        this.onClear();
        this.showFilter = !this.showFilter;
      }
    },
    handleFields: function handleFields() {
      var fields = [];

      if (this.device != "xs" && !this.disableCheckAll) {
        fields.push({
          key: "selected",
          sortable: true,
          width: "50px",
          label: ""
        });
      }

      for (var i = 0; i < this.tableHead.length; i++) {
        fields.push(this.tableHead[i]);
      }

      if (!this.disabledConfigCell) {
        fields.push({
          key: "buttons",
          class: "table-v2-buttons",
          label: ""
        });
      }

      this.fields = fields;
    },
    handleSearch: function handleSearch() {
      this.showPopoverCheckAll = false;
      this.checkAll = [];
      this.checkItem = [];

      if (this.onSearch) this.onSearch(this.formData.search, 1, this.formData.ppage, this.formData.filter);
    },
    handleEdit: function handleEdit(data) {
      if (this.onEdit) this.onEdit(data);
    },
    handleEditAll: function handleEditAll() {
      var data = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];

        if (element._data && element._data.id && this.checkItem.indexOf(element._data.id) != -1) {
          data.push(element._data);
        }
      }

      if (this.onEditAll) this.onEditAll(data);
    },
    handleDelete: function handleDelete(data) {
      var ids = [];

      if (data && data.id) ids = [data.id];else ids = this.checkItem;

      if (ids.length > 0 && this.onDelete) this.onDelete(ids);
    },


    handleFilter: function handleFilter() {
      this.showFilter = !this.showFilter;
      if (this.onFilter) {
        this.onFilter(this.formData.search, 1, this.formData.ppage, this.formData.filter);
      }
    },

    handleSelectAll: function handleSelectAll(check) {
      this.checkItem = [];
      this.showPopoverCheckAll = false;

      if (!check) return;

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];

        if (item && item._data) {
          this.checkItem.push(item._data.id);
        }
      }

      this.showPopoverCheckAll = true;
    },

    handleSelectItem: function handleSelectItem() {
      this.showPopoverCheckAll = this.checkItem.length > 0;
    },
    handleNavigate: function handleNavigate(page) {
      this.formData.page = page;

      if (this.onSearch) this.onSearch(this.formData.search, this.formData.page, this.formData.ppage);
    }
  }
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_download__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-upload",
  components: { Download: __WEBPACK_IMPORTED_MODULE_0_common_download___default.a },
  mixins: [],

  props: {
    onChangeFile: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    currentFile: {
      type: [Object, Array, File],
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    accept: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    input: {
      type: String,
      default: function _default() {
        return new Date().getTime().toString();
      }
    }
  },
  watch: {
    onChangeFile: function onChangeFile() {},
    currentFile: function currentFile() {
      if (this.currentFile && this.currentFile.id) {
        this.file = new File(['foo'], this.currentFile.name, this.currentFile);
      } else {
        this.file = this.currentFile;
      }
    },
    accept: function accept() {},
    multiple: function multiple() {},
    disabled: function disabled() {},
    input: function input() {}
  },

  data: function data() {
    return {
      file: null,
      loadingDelete: false
    };
  },
  mounted: function mounted() {
    this.clearFiles();
  },


  methods: {
    clearFiles: function clearFiles() {
      this.$refs['file-input-' + this.input].reset();
    },
    handleChange: function handleChange(e) {
      if (this.onChangeFile) this.onChangeFile(e);

      e.preventDefault();

      this.$events.fire('upload-' + this.input, e.target.files[0]);
    },
    handleDeleted: function handleDeleted() {
      this.file = null;
      this.$events.fire('upload-' + this.input, null);
      this.$events.fire('upload-deleted-' + this.input);
    }
  }
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '50px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '150px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(data) {
      this.showModal = !this.showModal;
      this.formData.consulta = data;
    },
    getHistorico: function getHistorico(_search) {
      var _this = this;

      if (!this.funcionario || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-5, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_funcionario: this.funcionario.id,
        created_at: [ontem, amanha]
      };

      this.get('consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this.toDate(data[i].dt_cad, true),
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_table__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_2_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};

      this.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:#000'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:#000'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {}
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      formData: null,
      formOption: {
        empty: 0
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
  },


  methods: {
    imprimirASO: function imprimirASO() {
      var _this = this;

      this.loadingSave = true;
      this.tabSelected = 'tab-aso';

      this.post('consulta/externa/editar', this.formData).then(function (result) {

        result = result[0];
        _this.loadingSave = false;

        if (result.status == 200) {

          _this.formOption.empty = _this.formOption.empty ? 1 : 0;

          _this.open('consulta/aso/' + _this.toMd5(_this.formData.id_con), _this.formOption);
        }
      });
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.loadingContent = true;
      this.tabSelected = 'tab-aso';

      this.get("consulta/externa/" + this.consulta.id).then(function (result) {

        result = result[0];
        _this2.loadingContent = false;

        if (result.status == 200) {
          _this2.formData = result.data;
        }
      });
    }
  }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_config_cancelar__ = __webpack_require__(934);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {},
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.senha': function formDataSenha() {
      this.config.disabled.obs = this.formData.senha ? false : true;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [],
        tipo_exclude: [],
        list: {},
        loading: {
          save: false
        },
        disabled: {
          obs: true
        }
      },
      response: {},
      formData: {
        obs: null,
        senha: null
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_config_cancelar__["a" /* default */];
  },


  methods: {

    salvar: function salvar() {
      var _this = this;

      this.$confirm('Ao efetuar o CANCELAMENTO da consulta, não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
        type: 'warning'
      }).then(function () {

        _this.config.loading.save = true;
        _this.response = {};

        _this.post('consulta/liberacao/' + _this.consulta.id_con + '/cancelar', _this.formData).then(function (result) {

          result = result[0];
          _this.response = result;

          _this.config.loading.save = false;

          if (result.status == 200) {
            _this.edMsg('Liberação cadastrado com sucesso!');
            _this.$events.fire('consulta-liberado');
          }
        });
      });
    }

  }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_femo__ = __webpack_require__(935);


var _watch;







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: (_watch = {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.q14': function formDataQ14() {
      this.config.disabled.qd14 = this.formData.q14 != '133' ? false : true;
    },
    'formData.q116': function formDataQ116() {
      this.config.disabled.qd116 = this.formData.q116 != '133' ? false : true;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q14', function formDataQ14() {
    this.config.disabled.qd14 = this.formData.q14 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q11024', function formDataQ11024() {
    this.config.disabled.qd11024 = this.formData.q11024 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q14096', function formDataQ14096() {
    this.config.disabled.qd14096 = this.formData.q14096 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q116384', function formDataQ116384() {
    this.config.disabled.qd116384 = this.formData.q116384 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q132768', function formDataQ132768() {
    this.config.disabled.qd132768 = this.formData.q132768 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q165536', function formDataQ165536() {
    this.config.disabled.qd165536 = this.formData.q165536 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q12048', function formDataQ12048() {
    this.config.disabled.qd12048 = this.formData.q12048 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q18192', function formDataQ18192() {
    this.config.disabled.qd18192 = this.formData.q18192 != '133' ? false : true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'formData.q22', function formDataQ22() {
    this.config.disabled.qd22 = this.formData.q22 != '133' ? false : true;
  }), _watch),
  data: function data() {
    return {
      config: {
        tipo: [122, 131, 134, 139, 144, 152, 158, 164, 167, 171, 180],
        loading: {
          content: false,
          save: false
        },
        disabled: {
          qd14: true,
          qd116: true,
          qd11024: true,
          qd14096: true,
          qd116384: true,
          qd132768: true,
          qd165536: true,
          qd12048: true,
          qd18192: true,
          qd22: true
        }
      },
      response: {},
      formData: {
        id: 0,
        empty: 0,
        grau_estudo: null,
        peso: null,
        altura: null,
        pa1: null,
        pa2: null,
        q14: '133',
        qd14: null,
        q18: '0',
        q116: '133',
        qd116: null,
        q132: '132',
        q164: '133',
        q1128: '133',
        q1256: '133',
        q1512: '133',
        q11024: '133',
        qd11024: null,
        q12048: '133',
        qd12048: null,
        q14096: '133',
        qd14096: null,
        q18192: '133',
        q116384: '133',
        qd116384: null,
        q132768: '133',
        qd132768: null,
        q165536: '133',
        qd165536: null,
        q22: '133',
        qd22: null,

        q34: [],
        q44: [],
        q54: [],
        q64: [],
        q74: [],
        q84: [],
        q94: [],
        conclusao: null,
        observacoes: null
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_femo__["a" /* default */];
    this.getConsulta();
  },


  methods: {
    imprimir: function imprimir() {
      var _this = this;

      this.config.loading.save = true;

      this.post('consulta/femo/' + this.consulta.id_con + '/editar', this.formData).then(function (result) {

        result = result[0];

        _this.config.loading.save = false;

        if (result.status == 200) {
          _this.open('consulta/femo/' + _this.toMd5(_this.consulta.id_con) + '/gerar', { empty: _this.formData.empty ? 1 : 0 });
        }
      });
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.config.loading.content = true;
      this.tabSelected = 'tab-aso';
      this.response = {};

      this.get("consulta/femo/" + this.consulta.id_con).then(function (result) {

        result = result[0];

        _this2.response = result;

        _this2.config.loading.content = false;

        if (result.status == 200) {

          var data = result.data,
              resposta = null;

          if (data) {
            resposta = data.resposta;

            _this2.formData.id = data.id;
            _this2.formData.pa1 = data.pa1;
            _this2.formData.pa2 = data.pa2;
            _this2.formData.peso = data.peso;
            _this2.formData.altura = data.altura;
            _this2.formData.observacoes = data.observacoes;
            _this2.formData.grau_estudo = data.tipo_grau_estudo ? data.tipo_grau_estudo.valor.toString() : null;
            _this2.formData.conclusao = data.conclusao;

            for (var q1 in resposta) {

              if (resposta[q1]) {
                for (var q2 in resposta[q1]) {

                  var form_value = 'q' + q1 + q2,
                      form_desc = 'qd' + q1 + q2,
                      valor = resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].valor : 0,
                      descricao = resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].descricao : null;
                  switch (q1) {
                    case '1':

                      _this2.formData[form_value] = q2 == 8 ? '0' : '133';
                      _this2.formData[form_desc] = null;

                      if (valor == 1) {
                        if (q2 == 8) {
                          _this2.formData[form_value] = (parseInt(descricao) + 8).toString();
                        } else {
                          _this2.formData[form_value] = '132';
                          _this2.formData[form_desc] = descricao;
                        }
                      }
                      break;

                    default:
                      if (valor == 1) {
                        _this2.formData['q' + q1 + '4'].push(q2);
                      }
                      break;
                  }
                }
              }
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aso__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__femo__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__femo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__femo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__liberar__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__liberar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__liberar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancelar__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancelar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cancelar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { Aso: __WEBPACK_IMPORTED_MODULE_0__aso___default.a, Femo: __WEBPACK_IMPORTED_MODULE_1__femo___default.a, Liberar: __WEBPACK_IMPORTED_MODULE_2__liberar___default.a, Cancelar: __WEBPACK_IMPORTED_MODULE_3__cancelar___default.a },
  mixins: [],
  props: {
    consulta: {
      type: Object,
      default: null
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.tabSelected = "tab-aso";
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {
      this.tabSelected = "tab-aso";
    }
  },
  data: function data() {
    return {
      tabSelected: 'tab-aso'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$events.on('consulta-liberado', function (eventData) {
      _this.tabSelected = "tab-aso";
    });
  },


  methods: {}
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_liberacao__ = __webpack_require__(936);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'aso',
  components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    'consulta.tipo_status.id': function consultaTipo_statusId() {},
    'formData.aptidao': function formDataAptidao() {
      this.handleAptidao();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [53, 185, 189],
        tipo_exclude: [54, 55, 68, 56, 57, 58, 69],
        click: {
          exames: this.getExame
        },
        list: {
          exames: []
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false
        },
        disabled: {
          id_tipo_status: false,
          te_alt: false,
          te_esp: false,
          te_ele: false,
          te_ali: false,
          te_rad_ion: false,
          exames: false,
          obs: false
        }
      },
      response: {},
      formData: {
        id: 0,
        id_tipo_status: '69',
        tipo_status: null,
        aptidao: null,
        te_alt: null,
        te_esp: null,
        te_ele: null,
        te_ali: null,
        te_rad_ion: null,
        obs: null,
        senha: null,
        arquivo_aso: null,
        arquivo_femo: null,
        arquivo_exame: null,
        updated_at: null,
        exames: []
      },
      formItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_config_liberacao__["a" /* default */];
    this.getConsulta();

    this.$events.on('upload-arquivo_aso', function (eventData) {
      _this.formData.arquivo_aso = eventData;
    });

    this.$events.on('upload-arquivo_femo', function (eventData) {
      _this.formData.arquivo_femo = eventData;
    });

    this.$events.on('upload-arquivo_exame', function (eventData) {
      _this.formData.arquivo_exame = eventData;
    });
  },


  methods: {
    handleAptidao: function handleAptidao() {

      this.config.disabled.id_tipo_status = this.formData.aptidao == '2' || this.formData.aptidao == '5';
      this.config.disabled.te_alt = this.formData.aptidao == '5';
      this.config.disabled.te_esp = this.formData.aptidao == '5';
      this.config.disabled.te_ele = this.formData.aptidao == '5';
      this.config.disabled.te_ali = this.formData.aptidao == '5';
      this.config.disabled.te_rad_ion = this.formData.aptidao == '5';

      if (this.formData.aptidao == '2') {
        this.formData.id_tipo_status = '67';
      } else if (this.formData.aptidao == '5') {
        this.formData.id_tipo_status = '70';
      } else if (this.formData.aptidao == '1') {
        this.formData.id_tipo_status = '66';
      }
    },
    getExame: function getExame(search) {},
    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.consulta || !this.consulta.id) return;

      this.config.loading.content = true;
      this.tabSelected = 'tab-aso';
      this.response = {};

      this.get("consulta/" + this.consulta.id_con).then(function (result) {

        result = result[0];

        _this2.response = result;

        _this2.config.loading.content = false;
        _this2.config.list.exames = [];

        if (result.status == 200) {
          var _this2$formData;

          _this2.formData = (_this2$formData = {
            id_tipo_status: '66',
            tipo_status: result.data.tipo_status,
            aptidao: _this2.toString(result.data.aptidao) == '0' ? null : _this2.toString(result.data.aptidao),
            te_alt: _this2.toString(result.data.te_alt) == '0' ? null : _this2.toString(result.data.te_alt)
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_alt', _this2.toString(result.data.te_alt) == '0' ? null : _this2.toString(result.data.te_alt)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_esp', _this2.toString(result.data.te_esp) == '0' ? null : _this2.toString(result.data.te_esp)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_ele', _this2.toString(result.data.te_ele) == '0' ? null : _this2.toString(result.data.te_ele)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_ali', _this2.toString(result.data.te_ali) == '0' ? null : _this2.toString(result.data.te_ali)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'te_rad_ion', _this2.toString(result.data.te_rad_ion) == '0' ? null : _this2.toString(result.data.te_rad_ion)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'updated_at', result.data.updated_at ? _this2.toDate(result.data.updated_at) : null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'obs', result.data.obs), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'exames', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'senha', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_aso', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_femo', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this2$formData, 'arquivo_exame', null), _this2$formData);

          for (var i = 0; i < result.data.exames.length; i++) {
            var element = result.data.exames[i];

            if (element.dem == 0) {
              _this2.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },


    salvar: function salvar() {
      var _this3 = this;

      this.$confirm('Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?', 'Atenção', {
        type: 'warning'
      }).then(function () {

        _this3.config.loading.save = true;
        _this3.response = {};

        _this3.post('consulta/liberacao/' + _this3.consulta.id_con + '/cadastrar', _this3.toFormUpload(_this3.formData)).then(function (result) {

          result = result[0];
          _this3.response = result;

          _this3.config.loading.save = false;

          if (result.status == 200) {
            _this3.edMsg('Liberação cadastrado com sucesso!');
            _this3.getConsulta();
            _this3.$events.fire('consulta-liberado');
          }
        });
      });
    }

  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_consulta_editar__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuracao_index__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__configuracao_index__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, Historico: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_includes_historico___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_consulta_includes_pcmso___default.a, Config: __WEBPACK_IMPORTED_MODULE_6__configuracao_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        tipo: [],
        readonly: {
          id_fdt: true,
          id_ghe: true,
          id_funcao: true,
          id_tipo_aso: true,
          data_age: true,
          funcionario: true,
          obs: true
        }
      },
      pcmso: null,
      consulta_historico: null,
      formData: {
        id: 0,
        data_age: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        exames: [],
        obs: null,
        result: null
      },
      showAso: false,
      showFemo: false,
      tabSelected: 'tab-acompanhamento'

    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_consulta_editar__["a" /* default */];
    this.getConsulta();

    this.$events.on('consulta-liberado', function (eventData) {
      _this.getConsulta();
    });
  },


  methods: {
    onASO: function onASO() {
      this.showAso = !this.showAso;
    },
    onFemo: function onFemo() {
      this.showFemo = !this.showFemo;
    },
    getConsulta: function getConsulta() {
      var _this2 = this;

      this.loadingContent = true;
      this.response = {};

      this.get('consulta/externa/' + this.$route.params.consulta).then(function (result) {
        result = result[0];

        _this2.loadingContent = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.formData = {
            id: result.data.id,
            data_age: _this2.convertDate(result.data.data_age),
            funcionario: result.data.funcionario.nome,
            id_tipo_aso: result.data.tipo_aso.descricao,
            id_funcao: result.data.funcao.nome,
            id_fdt: result.data.fdt.pcmso + ' (' + result.data.fdt.descricao + ')',
            id_ghe: result.data.ghe.ghe + ' (' + result.data.ghe.descricao + ')',
            obs: result.data.obs,
            result: result.data
          };
        } else {
          if (result.status == 404) _this2.toRoute({ name: 'credenciada.consulta' });
        }
      });
    }
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuracao_index__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__configuracao_index__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, Config: __WEBPACK_IMPORTED_MODULE_5__configuracao_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formFilter.id_empresa': function formFilterId_empresa() {
      this.getFuncionario();

      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.formFilter.id_funcionario = null;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        tipo_exclude: [68],
        click: {
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario
        },
        list: {
          id_empresa: [],
          id_funcionario: []
        },
        loading: {
          id_empresa: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: true,
          id_fdt: true
        }
      },
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        id_tipo_status: ['54', '55', '69', '68', '70'],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      filterBadge: 0,
      showConfig: false,
      consulta: null,
      pagination: {},
      response: {},
      filterItems: [],
      tableData: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'empresa',
        sortable: true,
        label: 'Empresa'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'data_age',
        sortable: true,
        label: 'Agendamento'
      }, {
        key: 'tipo_status',
        sortable: true,
        label: 'Status'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__["a" /* default */];
    this.getConsulta();
    this.getEmpresa();

    this.$events.on('consulta-liberado', function (eventData) {
      _this.getConsulta();
    });
  },


  methods: {
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'credenciada.consulta.edt', params: { consulta: data.id } });
    },
    onConfig: function onConfig(data) {
      this.consulta = data;
      this.showConfig = !this.showConfig;
    },
    onGerarConsulta: function onGerarConsulta(data) {

      var label = data.funcionario.nome,
          self = this;

      this.$confirm('O sistema vai gerar uma consulta definitiva para o funcionário ' + label + '. Deseja continuar?', 'Atenção', {
        type: 'warning'
      }).then(function () {
        self.config.loading.table = true;

        self.get('consulta/externa/' + data.id + '/gerar').then(function (result) {
          result = result[0];

          self.config.loading.table = false;

          if (result.status == 200) {
            self.onEdit(data);
          } else {
            self.edAlert(result.msg, 'error');
          }
        });
      });
    },


    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/empresa/funcionario/' + this.formFilter.id_empresa, { search: _search }).then(function (result) {

        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(search, page, pagination) {
      var _this4 = this;

      this.config.loading.table = true;

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, 'D'), true),
            amanha = this.toDate(this.addDate(0, null, 'D'), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("consulta/externa", { search: search, page: page, pagination: pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];

        _this4.config.loading.table = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              tipo_status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              data_age: _this4.toDate(data[i].data_age, true),
              _data: data[i],
              options: {
                disable_edit: data[i].deleted_at ? true : false,
                disable_delete: data[i].id_con || data[i].deleted_at ? true : false
              },
              buttons: []
            };

            if (!data[i].deleted_at && data[i].tipo_status.id == 54) {
              item.buttons.push({
                color: 'success',
                icon: 'fa fa-paper-plane',
                title: 'Iniciar Atendimento',
                click: _this4.onGerarConsulta

              });
            } else if (!data[i].deleted_at) {
              item.buttons.push({
                color: 'primary',
                icon: 'fa fa-pencil-square-o',
                title: 'Editar Consulta',
                click: _this4.onEdit

              });

              if (data[i].id_con && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58) {
                item.buttons.push({
                  color: 'success',
                  icon: 'fa fa-cogs',
                  title: 'Ver Opções desta Consulta',
                  click: _this4.onConfig

                });
              }
            }
            tableData.push(item);
          }

          pagination = result.data;
        }

        _this4.tableData = tableData;
        _this4.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_login__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_reset__ = __webpack_require__(940);









/* harmony default export */ __webpack_exports__["default"] = ({
		components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
		mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
		data: function data() {
				return {
						error: {},
						response: {},
						formData: {
								cpf: null,
								cnpj: null,
								senha: null,
								point_type: 'credenciada'
						},
						loginItens: [],
						resetitens: [],
						loadingSave: false,
						loadingRecuperarSenha: false,
						showModal: false,
						loadingContent: true
				};
		},
		created: function created() {

				if (this.logged()) this.toRoute({ name: 'credenciada.consulta' });else this.loadingContent = false;
		},
		mounted: function mounted() {
				this.loginItens = __WEBPACK_IMPORTED_MODULE_4__form_login__["a" /* default */];
				this.resetitens = __WEBPACK_IMPORTED_MODULE_5__form_reset__["a" /* default */];
		},


		methods: {
				login: function login() {
						var _this = this;

						this.loadingSave = true;
						this.error = {};
						this.response = {};

						this.post("login", this.formData).then(function (result) {
								result = result[0];

								_this.loadingSave = false;
								_this.response = result;

								if (result.status == 200) {

										var usuario = result.data.usuario,
										    cliente = result.data.cliente,
										    empresa = result.data.empresa;

										_this.setCookie(_this.env.jwt_credenciada, result.data.jwt, usuario.sessao);

										_this.usuario = usuario;
										_this.cliente = cliente;
										_this.empresa = empresa;

										_this.toRoute({ name: 'credenciada.consulta' });
								}
						});
				},
				recuperarSenha: function recuperarSenha() {
						var _this2 = this;

						this.loadingRecuperarSenha = true;
						this.response = {};

						this.post("recuperar-senha", this.formData).then(function (result) {
								result = result[0];
								_this2.response = result;
								_this2.loadingRecuperarSenha = false;

								if (result.status == 200) {
										_this2.showModal = false;
										_this2.edAlert("Sua nova senha foi enviada para o email: " + result.data + ". Aguarde alguns minutos e verifique sua caixa de entrada.");
								}
						});
				}
		}
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__ = __webpack_require__(941);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {
      this.getFuncao();
    },
    'formData.id_funcao': function formDataId_funcao() {
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        tipo: [],
        readonly: {
          nome: true,
          cnpj: true,
          u_cpf: true,
          u_nome: true
        }
      },
      formData: {
        id: null,
        id_estado: null,
        id_cidade: null,
        nome: null,
        cnpj: null,
        email: null,
        tel_com: null,
        r_nome: null,
        r_email: null,
        r_tel_com: null,
        u_nome: null,
        u_cpf: null,
        u_email: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        log: [],
        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__["a" /* default */];
  },


  methods: {
    getEmpresa: function getEmpresa() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get("meu-cadastro").then(function (result) {

        result = result[0];

        console.log(result);

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          var data = result.data;

          _this.formData = {
            id: data.id,
            id_estado: data.id_estado,
            id_cidade: data.id_cidade,
            nome: data.nome,
            cnpj: data.cnpj,
            email: data.email,
            tel_com: data.tel_com,
            r_nome: data.r_nome,
            r_email: data.r_email,
            r_tel_com: data.r_tel_com,
            cep: data.cep,
            end: data.end,
            num: data.num,
            bairro: data.bairro,
            comp: data.comp,
            obs: data.obs,
            created_at: data.created_at,
            updated_at: data.updated_at,

            senha_atual: null,
            senha_nova: null,
            senha_confirma: null,

            u_nome: _this.usuario.logged.nome,
            u_cpf: _this.usuario.logged.usuario,
            u_email: _this.usuario.logged.email
          };
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('meu-cadastro', this.formData).then(function (result) {
        result = result[0];

        _this2.loadingSave = false;

        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
          _this2.getEmpresa();
        }
      });
    }
  }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    consulta: {
      type: Object,
      default: {}
    },
    showGuia: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'consulta.id': function consultaId() {
      this.getConsulta();
    },
    showGuia: function showGuia() {
      this.showModal = !this.showModal;
    }
  },
  data: function data() {
    return {
      showModal: false,
      loadingContent: false,
      formData: null,
      tabSelected: 'tab-guia',
      parceiros: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
  },


  methods: {
    onAso: function onAso() {
      this.open('consulta/aso/' + this.toMd5(this.formData.id_con));
    },
    onGuia: function onGuia(parceiro) {
      this.open('consulta/externa/guia/' + this.toMd5(this.formData.id));
    },
    getConsulta: function getConsulta() {
      var _this = this;

      if (!this.consulta || !this.consulta.id) return;

      this.loadingContent = true;

      this.get("consulta/externa/" + this.consulta.id).then(function (result) {

        result = result[0];
        _this.loadingContent = false;

        if (result.status == 200) {
          _this.formData = result.data;
          _this.formataParceiro();

          if (_this.formData && _this.formData.tipo_status.id == 54) {
            _this.tabSelected = 'tab-guia';
          } else {
            _this.tabSelected = 'tab-aso';
          }
        }
      });
    },
    formataParceiro: function formataParceiro() {
      var consulta = this.formData,
          parceiros = {};

      try {
        consulta.exames = consulta.exames.sort(function (a, b) {
          return a.parceiro.nome > b.parceiro.nome ? 1 : b.parceiro.nome > a.parceiro.nome ? -1 : 0;
        });
      } catch (error) {}

      for (var i = 0; i < consulta.exames.length; i++) {
        var consulta_exame = consulta.exames[i],
            index = null;

        if (consulta_exame.parceiro && consulta_exame.id_con_rea == 0 && consulta_exame.id_con_dem == 0) {

          index = this.toMd5(consulta_exame.parceiro.id);

          if (!parceiros[index]) {
            parceiros[index] = {
              parceiro: consulta_exame.parceiro,
              exames: []
            };
          }
          parceiros[index]['exames'].push(consulta_exame.exame);
        }
      }
      this.parceiros = parceiros;
    }
  }
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null,
        exames: []
      },
      pagination: {},
      paginationExame: {},
      response: {},
      tableData: [],
      tableDataExame: [],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '90px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '200px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false,
      loadingTableExame: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(consulta) {
      this.showModal = !this.showModal;
      this.formData.consulta = consulta;
      this.getExame();
    },
    ordenar: function ordenar(array) {
      array = array.sort(function (a, b) {
        return a.id_con_rea > b.id_con_rea ? 1 : b.id_con_rea > a.id_con_rea ? -1 : 0;
      });
      return array;
    },
    getExame: function getExame(_search, _page, _pagination) {
      var _this = this;

      this.loadingTableExame = true;
      this.formData.exames = [];

      this.get('consulta/exame/' + this.formData.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        _this.loadingTableExame = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = _this.ordenar(result.data.data);

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              data: data[i].dt_cad ? _this.toDate(data[i].dt_cad, true) : null,
              valor: data[i].valor,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableDataExame = tableData;
        _this.paginationExame = pagination;
      });
    },
    getHistorico: function getHistorico(_search) {
      var _this2 = this;

      if (!this.funcionario || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-10, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_empresa: this.usuario.logged.point.id,
        id_funcionario: this.funcionario.id,
        created_at: [ontem, amanha]
      };

      this.get('consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this2.response = result;
        _this2.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this2.toDate(data[i].dt_cad, true),
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this2.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EmpresaCadastro",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdForm */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_template__["i" /* EdModal */],
    EdAlert: __WEBPACK_IMPORTED_MODULE_2_template__["c" /* EdAlert */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputSelectTipo */]
  },
  mixins: [],
  props: {
    showLote: {
      type: Boolean,
      default: false
    },
    parent: {
      type: Object,
      default: null
    },
    funcionario: {
      type: Array,
      default: null
    },
    tipoAso: {
      type: [String, Number],
      default: 52
    },
    callback: {
      type: Function,
      default: null
    }
  },
  watch: {
    parent: function parent() {},
    funcionario: function funcionario() {},
    tipoAso: function tipoAso() {},
    showLote: function showLote() {
      this.showModal = !this.showModal;
      this.inicialize();
    },
    "$root.$session.event": function $root$sessionEvent() {
      this.$forceUpdate();
    },

    formData: {
      handler: function handler(newVal) {},
      deep: true
    }
  },
  computed: {
    listaPeriodicidade: function listaPeriodicidade() {
      return function (funcionario) {
        if (funcionario.id_tipo_aso == 48) {
          funcionario.periodicidade = 6;
          return [{ id: 6, nome: "6 meses" }];
        }

        funcionario.periodicidade = 12;

        return [{ id: 6, nome: "6 meses" }, { id: 12, nome: "12 meses" }];
      };
    },
    disabilitarConsulta: function disabilitarConsulta() {
      var _this = this;

      return function (item, funcionario) {
        switch (item.id) {
          case 47:
            return _this.formData.funcionario && _this.formData.funcionario.adm == 1;
            break;

          case 48:
            return _this.formData.funcionario && _this.formData.funcionario.apos_adm == 1;
            break;

          case 51:
            return _this.formData.funcionario && _this.formData.funcionario.dem == 1;
            break;

          default:
            return false;
            break;
        }
      };
    }
  },
  data: function data() {
    return {
      showModal: false,
      tabSelected: "tab-guia",
      response: {},
      formDataItems: [],
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: []
      },
      formData: {
        funcionario: null
      },
      loadingFuncionario: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.getFDT();
  },


  methods: {
    getError: function getError(funcionario) {
      if (this.$root.$request.dados && this.$root.$request.dados.options && this.$root.$request.dados.options.data && this.$root.$request.dados.options.data[funcionario.id]) {
        return this.$root.$request.dados.options.data[funcionario.id].join('<br>');
      }

      return null;
    },
    formatarFuncionario: function formatarFuncionario(_funcionario, _id_tipo_aso) {
      if (_funcionario && !this.$utilidade.arrFindByField(this.formData.funcionarios, "id", _funcionario.id)) {
        var funcionario = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_funcionario, {});

        if (!funcionario.id_tipo_aso) {
          funcionario.id_tipo_aso = _id_tipo_aso ? _id_tipo_aso : 52;
          funcionario.id_mf_fdt = null;
          funcionario.id_mf_ghe = null;
          funcionario.id_mf_funcao = null;
        }
        this.formData.funcionarios.push(funcionario);
      }
      this.formData.funcionario = null;
    },
    formatarTipoConsulta: function formatarTipoConsulta(funcionario) {
      var aso = "SELECIONE";

      switch (funcionario.id_tipo_aso) {
        case 47:
          aso = "ADMISSIONAL";
          break;

        case 48:
          aso = "APÓS ADMISSIONAL";
          break;

        case 49:
          aso = "RETORNO AO TRABALHO";
          break;

        case 50:
          aso = "MUDANÇA DE FUNÇÃO";
          break;

        case 51:
          aso = "DEMISSIONAL";
          break;

        case 52:
          aso = "PERIÓDICO" + (funcionario.periodicidade ? " " + funcionario.periodicidade + " MESES" : "");
          break;
      }

      return aso + (funcionario.periodicidade ? " " + funcionario.periodicidade + " MESES" : "");
    },
    inicialize: function inicialize() {
      this.formData = {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        funcionarios: [],
        tabela_preco: null,
        obs: null
      };
      this.list.funcionario = [];

      if (this.funcionario && this.funcionario.length > 0) {
        var self = this;
        this.funcionario.forEach(function (funcionario) {
          self.formatarFuncionario(funcionario, self.tipoAso);
        });
      }
    },
    onDelete: function onDelete(funcionario) {
      var element = this.$utilidade.arrFindByField(this.formData.funcionarios, "id", funcionario.id);

      for (var i = 0; i < this.formData.funcionarios.length; i++) {
        var _element = this.formData.funcionarios[i];

        if (_element.id == funcionario.id) {
          this.formData.funcionarios.splice(i, 1);
        }
      }
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.loadingFuncionario = true;
      this.list.funcionario = [];

      this.$root.$request.get("funcionario/0", { search: _search, pagination: 100 }).then(function (result) {
        _this2.loadingFuncionario = false;

        if (result.status == 200) {
          _this2.list.funcionario = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this3 = this;

      this.loadingFdt = true;
      this.list.fdt = [];

      this.$root.$request.get("pcmso/fdt").then(function (result) {
        _this3.loadingFdt = false;

        if (result.status == 200) {
          _this3.list.fdt = result.data.data;
        }
      });
    },
    getGhe: function getGhe(funcionario) {
      var _this4 = this;

      this.loadingGhe = true;
      this.ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this4.loadingGhe = false;

        if (result.status == 200) {
          _this4.list.ghe = result.data;
        }
      });
    },
    getFuncao: function getFuncao(funcionario) {
      var _this5 = this;

      this.loadingFuncao = true;
      this.list.funcao = [];

      funcionario.id_mf_funcao = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao/" + funcionario.id_mf_ghe, {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this5.loadingFuncao = false;

        if (result.status == 200) {
          _this5.list.funcao = result.data.data;
        }
      });
    },
    fechar: function fechar() {
      this.formDataItems = [];
      if (this.callback) this.callback();
    },
    salvar: function salvar() {
      var _this6 = this;

      this.$root.$loading.set(true);

      this.$root.$request.post("consulta/externa/lote", this.formData).then(function (result) {
        _this6.$root.$loading.set(false);

        console.log(result);
        if (result.status == 200) {
          _this6.showModal = !_this6.showModal;

          if (_this6.parent) {
            _this6.parent.getConsulta();
          }

          _this6.$root.$dialog.alert("Consulta registrada com sucesso. Agora você deve aguardar enquanto o sistema processa a solicitação em segundo plano. Espere alguns minutos e atualize essa página para verificar o andamento da solicitação.");
        }
      });
    }
  }
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a },
  mixins: [],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }, {
        key: 'validade',
        sortable: true,
        show_html: true,
        label: 'Validade do Exame'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};
      this.$root.$session.pcmso = null;

      this.$root.$request.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          _this.$root.$session.pcmso = data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = '';

            if (data[i].periodicidade_a != '0' && data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>" + data[i].periodicidade_a + " meses até " + data[i].per_id1 + " anos, </span>";
            }

            periodicidade += data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            if (data[i].periodicidade_d != '0' && data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>, " + data[i].periodicidade_d + " meses depois dos " + data[i].per_id2 + " anos </span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              validade: data[i].validade != 0 ? '<span style="color:green">' + data[i].validade + ' dias</span>' : '<span style="color:red">---</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_table__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_2_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1_common_alert___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'created_at',
        sortable: true,
        width: '150px',
        label: 'Data'
      }, {
        key: 'usuario',
        sortable: true,
        show_point: true,
        label: 'Usuario'
      }, {
        key: 'tipo_status',
        sortable: true,
        width: '250px',
        label: 'Status'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Observações'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaAcompanhamento();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaAcompanhamento: function getConsultaAcompanhamento(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/acompanhamento/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              created_at: _this.toDate(data[i].created_at),
              usuario: data[i].log_acesso && data[i].log_acesso.usuario ? data[i].log_acesso.usuario.usuario : null,
              tipo_status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              obs: data[i].obs,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__credenciada_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdCredenciada: __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputSelectTipo */]
  },
  watch: {},
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      formData: {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        periodicidade: 12,
        id_tabela_preco: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        id_mf_fdt: null,
        id_mf_ghe: null,
        id_mf_funcao: null,
        exames: [],
        obs: null,
        pcd: 0
      },
      formFilter: {
        order: "ate_cli_cre.nome",
        id_estado: null,
        id_cidade: null,
        id_tipo_tabela_preco: null,
        preco: null
      },
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: []
      },
      tabHistorico: "tab-credenciada",
      loadingPCMSO: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false,
      loadingTabelaPreco: false,
      loadingFuncionario: false,
      loadingConsultaHistorico: false,
      pcmso: null,
      consulta_historico: null,
      tabela_preco: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
  },


  computed: {
    listaPeriodicidade: function listaPeriodicidade() {
      var _this = this;

      var arrayPeriodicidade = [];

      this.formData.periodicidade = 12;

      if (this.formData.id_tipo_aso == 48) {
        this.formData.periodicidade = 6;
      }

      if (this.$root.$session.pcmso) {
        this.$root.$session.pcmso.forEach(function (pcmso, index) {
          var periodicidade = pcmso.periodicidade;

          if (_this.formData.id_tipo_aso == 48) {
            periodicidade = pcmso.apos_adm == 0 ? 6 : pcmso.apos_adm;
          }

          if (periodicidade > 0 && !_this.$utilidade.arrFindByField(arrayPeriodicidade, "id", periodicidade)) {
            arrayPeriodicidade.push({
              id: periodicidade,
              nome: periodicidade + " meses"
            });
          }
        });
      }

      return arrayPeriodicidade.sort(function (a, b) {
        return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
      });;
    },
    disabilitarConsulta: function disabilitarConsulta() {
      var _this2 = this;

      return function (item) {
        switch (item.id) {
          case 47:
            return _this2.formData.funcionario && _this2.formData.funcionario.adm == 1;
            break;

          case 48:
            return _this2.formData.funcionario && _this2.formData.funcionario.apos_adm == 1;
            break;

          case 51:
            return _this2.formData.funcionario && _this2.formData.funcionario.dem == 1;
            break;

          default:
            return false;
            break;
        }
      };
    }
  },

  methods: {
    formatarFuncionario: function formatarFuncionario() {
      if (this.formData.funcionario) {
        this.formData.id_funcionario = this.formData.funcionario.id;
        this.formData.id_fdt = this.formData.funcionario.id_pcmso;
        this.formData.id_funcao = this.formData.funcionario.id_funcao;
        this.formData.id_ghe = this.formData.funcionario.id_ghe;
        this.getFuncao();
      }
    },
    getFDT: function getFDT() {
      var _this3 = this;

      this.loadingFdt = true;
      this.list.fdt = [];

      var filter = {
        ativo: 1
      };

      this.$root.$request.get("pcmso/fdt", {
        filter: filter
      }).then(function (result) {
        _this3.loadingFdt = false;

        if (result.status == 200) {
          _this3.list.fdt = result.data.data;

          if (_this3.formData.id_fdt) {
            if (!_this3.$utilidade.arrFindByField(_this3.list.fdt, "id", _this3.formData.id_fdt)) {
              _this3.formData.id_fdt = null;
              _this3.formData.id_funcao = null;
              _this3.formData.id_ghe = null;
            }
          }
        }
      });
    },
    getFuncao: function getFuncao(_search) {
      var _this4 = this;

      this.list.funcao = [];

      if (!this.formData.id_fdt) return;

      this.loadingFuncao = true;

      var filter = {
        id_fdt: this.formData.id_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao", {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this4.loadingFuncao = false;

        if (result.status == 200) {
          _this4.list.funcao = result.data.data;

          if (_this4.formData.id_funcao) {
            if (!_this4.$utilidade.arrFindByField(_this4.list.funcao, "id", _this4.formData.id_funcao)) {
              _this4.formData.id_funcao = null;
              _this4.formData.id_ghe = null;
            }
          }

          _this4.getGHE();
        }
      });
    },
    getGHE: function getGHE() {
      var _this5 = this;

      this.list.ghe = [];

      if (!this.formData.id_fdt || !this.formData.id_funcao) return;

      this.loadingGhe = true;
      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this5.loadingGhe = false;

        if (result.status == 200) {
          _this5.list.ghe = result.data;

          var encontrado = false;
          _this5.list.ghe.forEach(function (revisao, index) {
            if (_this5.$utilidade.arrFindByField(revisao.options, "id", _this5.formData.id_ghe)) {
              encontrado = true;
            }
          });

          if (_this5.formData.id_ghe && !encontrado) {
            _this5.formData.id_ghe = null;
          }
        }
      });
    },
    getGheMudancaFuncao: function getGheMudancaFuncao() {
      var _this6 = this;

      this.loadingGhe = true;
      this.mf_ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        _this6.loadingGhe = false;

        if (result.status == 200) {
          _this6.list.mf_ghe = result.data;
        }
      });
    },
    getFuncaoMudancaFuncao: function getFuncaoMudancaFuncao(_search) {
      var _this7 = this;

      this.loadingFuncao = true;
      this.list.mf_funcao = [];

      this.formData.id_mf_funcao = null;

      var filter = {
        id_fdt: this.formData.id_mf_fdt
      };

      this.$root.$request.get("pcmso/ghe/funcao/" + this.formData.id_mf_ghe, {
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        _this7.loadingFuncao = false;

        if (result.status == 200) {
          _this7.list.mf_funcao = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this8 = this;

      this.loadingFuncionario = true;
      this.list.funcionario = [];

      if (this.$route.params.funcionario && !_search) {
        _search = this.$route.params.funcionario;
      }

      this.$root.$request.get("funcionario/0", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this8.loadingFuncionario = false;

        if (result.status == 200) {
          _this8.list.funcionario = result.data.data;

          var funcionario = null;
          if (funcionario = _this8.$utilidade.arrFindByField(_this8.list.funcionario, "id", _this8.$route.params.funcionario)) {
            _this8.formData.funcionario = funcionario;
            _this8.formatarFuncionario();
          }
        } else {
          _this8.$utilidade.$notify.error(result.data);
        }

        _this8.getFDT();
      });
    },
    ordenar: function ordenar(tabela_preco) {
      for (var index = 0; index < tabela_preco.length; index++) {
        tabela_preco[index].exames.consulta = tabela_preco[index].exames.consulta.sort(function (a, b) {
          return a.id_con_rea > b.id_con_rea ? 1 : b.id_con_rea > a.id_con_rea ? -1 : 0;
        });

        tabela_preco[index].exames.consulta = tabela_preco[index].exames.consulta.sort(function (a, b) {
          return a.id_con_dem > b.id_con_dem ? 1 : b.id_con_dem > a.id_con_dem ? -1 : 0;
        });

        tabela_preco[index].exames.demonstrativo = tabela_preco[index].exames.demonstrativo.sort(function (a, b) {
          return a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0;
        });
      }
      return tabela_preco;
    },
    getCredenciada: function getCredenciada(page, search) {
      var _this9 = this;

      this.tabHistorico = "tab-credenciada";

      if (this.formData.id_tipo_aso == 50 && (!this.formData.id_mf_fdt || !this.formData.id_mf_ghe) || !this.formData.id_tipo_aso || !this.formData.id_ghe || !this.formData.id_funcionario || !this.formData.data_age) {
        return;
      }

      this.$root.$loading.set(true, "Carregando exames");

      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id_fdt: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_fdt : this.formData.id_fdt,
        id_funcao: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_funcao : this.formData.id_funcao,
        id_ghe: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_ghe : this.formData.id_ghe,
        periodicidade: this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48 ? this.formData.periodicidade : -1,
        id_funcionario: this.formData.id_funcionario,
        id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
        hoje: this.formData.data_age,
        id_tipo_aso: [this.formData.id_tipo_aso],
        pcd: this.formData.pcd
      }, this.formFilter);

      this.$root.$request.get("tabela-preco", {
        search: search,
        page: page,
        filter: filter
      }).then(function (result) {
        _this9.$root.$loading.set(false);

        console.log(result);
        if (result.status == 200) {
          _this9.tabela_preco = _this9.ordenar(result.data);

          for (var index = 0; index < _this9.tabela_preco.length; index++) {
            var tabela_preco = _this9.tabela_preco[index],
                valor = 0,
                valor_servico = 0,
                valor_total = 0;

            if (tabela_preco.credenciada && tabela_preco.credenciada.padrao == "1" || index == 0) {
              _this9.formData.id_tabela_preco = tabela_preco.id;
            }

            for (var j = 0; j < tabela_preco.exames.consulta.length; j++) {
              valor += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_venda);
              valor_servico += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_servico);
              valor_total += _this9.$utilidade.moneyToFloat(tabela_preco.exames.consulta[j].valor_total);
            }

            _this9.tabela_preco[index].total_exames = tabela_preco.exames.consulta.length;

            _this9.tabela_preco[index].total_exames_realizar = tabela_preco.exames.consulta.filter(function (exame) {
              return !exame.id_con_dem && !exame.id_con_rea;
            }).length;

            _this9.tabela_preco[index].valor = _this9.$utilidade.floatToMoney(valor);
            _this9.tabela_preco[index].valor_servico = _this9.$utilidade.floatToMoney(valor_servico);
            _this9.tabela_preco[index].valor_total = _this9.$utilidade.floatToMoney(valor_total);
          }
        } else {
          _this9.tabela_preco = result.data;
        }
      });
    },
    salvar: function salvar() {
      var _this10 = this;

      this.$root.$loading.set(true, "Gerando consulta");
      this.response = {};

      var formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.formData, {});

      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id_fdt: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_fdt : this.formData.id_fdt,
        id_funcao: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_funcao : this.formData.id_funcao,
        id_ghe: this.formData.id_tipo_aso == 50 ? this.formData.id_mf_ghe : this.formData.id_ghe,
        periodicidade: this.formData.id_tipo_aso == 52 || this.formData.id_tipo_aso == 48 ? this.formData.periodicidade : -1,
        id_funcionario: this.formData.id_funcionario,
        id_tipo_tabela_preco: this.formFilter.id_tipo_tabela_preco,
        hoje: this.formData.data_age,
        id_tipo_aso: [this.formData.id_tipo_aso],
        pcd: this.formData.pcd
      }, this.formFilter);

      formData.periodicidade = filter.periodicidade;

      this.$root.$request.put("consulta/externa/cadastrar", formData, {
        filter: filter
      }).then(function (result) {
        _this10.$root.$loading.set(false);
        _this10.response = result;

        if (result.status == 200) {
          _this10.$root.$notify.success("Dados atualizados com sucesso");

          if (_this10.$route.name == "empresa.consulta.cad") {
            _this10.$router.push({
              name: "empresa.consulta.edt",
              params: {
                consulta: result.data.id
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_table__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_4_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: {}
    },
    tabela_preco: {
      type: Object,
      default: {}
    },
    showExame: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showExame: function showExame() {
      this.showModal = !this.showModal;
    },
    showModal: function showModal() {},
    tabela_preco: function tabela_preco() {},
    'tabela_preco.id': function tabela_precoId() {
      this.getData();
    },
    'parent.showExame': function parentShowExame() {
      this.getData();
    },
    'parent.loadingExame': function parentLoadingExame() {}
  },

  data: function data() {
    return {
      showModal: false,
      loadingTable: false,
      tableHead: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data_ultuma_consulta',
        label: 'Data Ultima Consulta'
      }, {
        key: 'valor_total',
        sortable: true,
        show_html: true,
        width: '170px',
        label: 'Valor Total (R$)',
        value: 0
      }],
      tableFooter: [],
      tableData: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {

      if (!this.tabela_preco || !this.tabela_preco.id || !this.tabela_preco.exames || !this.tabela_preco.exames.consulta) return;

      var tableData = [],
          tableFooter = [],
          total_valor_venda = 0,
          total_valor_servico = 0;
      this.loadingTable = true;

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {

        var element = this.tabela_preco.exames.consulta[i];

        var valor_venda = null,
            valor_servico = null,
            valor_total = null;

        if (!element.id_con_rea && element.valor_venda) {
          valor_venda = element.valor_venda;
        }

        if (!element.id_con_rea && element.valor_total) {
          valor_total = element.valor_total;
        }

        if (!element.id_con_rea && element.valor_servico) {
          valor_servico = element.valor_servico;
        }

        var item = {
          id: element.id,
          exame: element.exame ? element.exame.nome : null,
          data_ultuma_consulta: (element.dt_exame ? this.$utilidade.toDate(element.dt_exame, true) : '---') + (element.validade_exame > 0 ? '<br><span style="color:red">Exame válido por ' + element.validade_exame + ' dias</span>' : '') + (element.validade_pcmso ? '<br><span style="color:' + element.validade_pcmso_cor + '">Exame válido até ' + this.$utilidade.toDate(element.validade_pcmso, true) + '</span>' : ''),
          valor: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_venda ? valor_venda : '---',
          valor_servico: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_servico ? valor_servico + ' (' + element.taxa_servico + ')%' : '---',
          valor_total: element.va == '1' ? '<img src="' + this.env.url_cs + 'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : valor_total ? valor_total : '---',
          _data: element,
          buttons: []
        };

        this.tableHead[1].value += this.moneyToFloat(valor_venda);
        this.tableHead[2].value += this.moneyToFloat(valor_servico);


        tableData.push(item);
      }

      for (var _i = 0; _i < this.tabela_preco.exames.demonstrativo.length; _i++) {

        var _element = this.tabela_preco.exames.demonstrativo[_i];

        var item = {
          id: _element.id,
          exame: _element.nome,
          data_ultuma_consulta: _element.dt_exame ? this.$utilidade.toDate(_element.dt_exame, true) : '---',
          valor: '---',
          valor_servico: '---',
          valor_total: '---',
          _data: _element,
          buttons: []
        };

        tableData.push(item);
      }

      this.loadingTable = false;
      this.tableData = tableData;
      this.tableFooter = tableFooter;
    }
  }
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exame__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__exame__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EmpresaCadastro",
  components: { EdPaginate: __WEBPACK_IMPORTED_MODULE_1_common_paginate___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_pcmso___default.a, Historico: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_historico___default.a, Exame: __WEBPACK_IMPORTED_MODULE_6__exame___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: {}
    }
  },
  watch: {
    parent: function parent() {},
    "parent.formData.tabHistorico": function parentFormDataTabHistorico() {},
    "parent.formData.id_tabela_preco": function parentFormDataId_tabela_preco() {},
    "parent.formData.id_funcao": function parentFormDataId_funcao() {},
    "parent.formData.id_ghe": function parentFormDataId_ghe() {},
    "parent.formData.id_mf_ghe": function parentFormDataId_mf_ghe() {},
    "parent.formData.funcionario": function parentFormDataFuncionario() {},
    "parent.loadingTabelaPreco": function parentLoadingTabelaPreco() {},

    "parent.tabela_preco": {
      deep: true,
      handler: function handler() {
        this.inicialize();
      }
    }
  },

  data: function data() {
    return {
      showExame: false,
      loadingExame: false,
      tabela_preco: null,
      lstOrganizar: [{ value: "ate_cli_cre.nome", label: "Nome" }, { value: "ate_cli_cre.rate", label: "Mais Relevantes" }],
      filtros: [],
      estados: [],
      cidades: [],
      tipo_tabela_preco: []
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    inicialize: function inicialize() {
      if (this.parent.tabela_preco && this.parent.tabela_preco.length) {
        this.getEstado();
      }
    },
    onChangeParceiro: function onChangeParceiro(tabela_preco, item) {
      var valor = 0,
          valor_total = 0,
          valor_servico = 0,
          exames = [];

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        var _tabela_preco = this.tabela_preco.exames.consulta[i];

        for (var j = 0; j < _tabela_preco.parceiros.length; j++) {
          if (_tabela_preco.id_par == _tabela_preco.parceiros[j].parceiro.id) {
            var parceiro = _tabela_preco.parceiros[j];

            valor += this.moneyToFloat(parceiro.valor);
            valor_servico += this.moneyToFloat(parceiro.valor_servico);
            valor_total += this.moneyToFloat(parceiro.valor_total);

            this.tabela_preco.exames.consulta[i].valor_venda = parceiro.valor;
            this.tabela_preco.exames.consulta[i].valor_servico = parceiro.valor_servico;
            this.tabela_preco.exames.consulta[i].valor_total = parceiro.valor_total;

            exames.push({
              id_exa: _tabela_preco.exame.id,
              id_par: _tabela_preco.id_par
            });
          }
        }
      }

      this.tabela_preco.valor = this.floatToMoney(valor);
      this.tabela_preco.valor_total = this.floatToMoney(valor_total);
      this.tabela_preco.valor_servico = this.floatToMoney(valor_servico);

      this.parent.formData.exames = exames;

      for (var _i = 0; _i < this.parent.tabela_preco.length; _i++) {
        if (this.parent.tabela_preco[_i].id == this.tabela_preco.id) {
          this.parent.tabela_preco[_i].valor = this.tabela_preco.valor;
          this.parent.tabela_preco[_i].valor_total = this.tabela_preco.valor_total;
          this.parent.tabela_preco[_i].valor_servico = this.tabela_preco.valor_servico;
        }
      }
    },
    onShowExame: function onShowExame(tabela_preco) {
      var _this = this;

      this.tabela_preco = tabela_preco;
      this.showExame = !this.showExame;
      this.loadingExame = true;

      var filter = {
        id_exa: []
      };

      for (var i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        filter.id_exa.push(this.tabela_preco.exames.consulta[i].exame.id);
      }

      this.get("tabela-preco/exame/" + this.tabela_preco.id, {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this.loadingExame = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var _i2 = 0; _i2 < _this.tabela_preco.exames.consulta.length; _i2++) {
            var elementi = _this.tabela_preco.exames.consulta[_i2];

            _this.tabela_preco.exames.consulta[_i2].parceiros = [];

            for (var j = 0; j < data.length; j++) {
              var elementj = data[j];

              if (elementi.exame.id == elementj.exame.id) {
                _this.tabela_preco.exames.consulta[_i2].parceiros = elementj.exames_parceiro;
              }
            }
          }
        }
      });
    },
    getEstado: function getEstado() {
      var tabela_preco = this.parent.tabela_preco;
      this.estados = [];

      var estados = [{
        value: null,
        label: "Todos"
      }];

      for (var i = 0; i < tabela_preco.length; i++) {
        var element = tabela_preco[i];

        if (!element.credenciada_uf) continue;

        if (!this.arrFindByField(this.estados, "value", element.credenciada_uf)) {
          this.estados.push({
            value: element.credenciada_uf,
            label: element.credenciada_estado
          });
        }
      }

      this.estados = this.estados.sort(function (a, b) {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
      this.estados = estados.concat(this.estados);

      this.getCidade();
    },
    getCidade: function getCidade() {
      var tabela_preco = this.parent.tabela_preco;

      this.cidades = [];
      var cidades = [{
        value: null,
        label: "Todos"
      }];

      if (!this.parent.formFilter.id_estado) {
        cidades = [{
          value: null,
          label: "Selecione o Estado"
        }];
        this.parent.formFilter.id_cidade = null;
        return;
      }

      for (var i = 0; i < tabela_preco.length; i++) {
        var element = tabela_preco[i];

        if (!element.credenciada_cidade) continue;

        if (!this.arrFindByField(this.cidades, "value", element.credenciada_cidade)) {
          this.cidades.push({
            value: element.credenciada_cidade_id,
            label: element.credenciada_cidade,
            disable: !this.parent.formFilter.id_estado ? true : false
          });
        }
      }

      this.cidades = this.cidades.sort(function (a, b) {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
      this.cidades = cidades.concat(this.cidades);
    }
  }
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credenciada_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__credenciada_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_editar__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riscos_index__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riscos_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riscos_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exames_index__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exames_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__exames_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__acompanhamento_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Riscos: __WEBPACK_IMPORTED_MODULE_6__riscos_index___default.a, Exames: __WEBPACK_IMPORTED_MODULE_7__exames_index___default.a, Acompanhamento: __WEBPACK_IMPORTED_MODULE_8__acompanhamento_index___default.a, Guia: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_guia___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_consulta_includes_pcmso___default.a, Historico: __WEBPACK_IMPORTED_MODULE_11_appsEmpresa_consulta_includes_historico___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        tipo: [],
        readonly: {
          id_fdt: true,
          id_ghe: true,
          id_funcao: true,
          id_tipo_aso: true,
          data_age: false,
          funcionario: true,
          obs: true
        }
      },
      formData: {
        id: 0,
        data_age: null,
        id_funcionario: null,
        funcionario: null,
        id_tipo_aso: null,
        id_tipo_status: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        exames: [],
        obs: null,
        result: null
      },
      pcmso: null,
      consulta_historico: null,
      showGuia: false,
      tabSelected: 'tab-exames'

    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_editar__["a" /* default */];
    this.getConsulta();
  },


  methods: {
    onGuia: function onGuia() {
      this.showGuia = !this.showGuia;
    },
    getConsulta: function getConsulta() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get('consulta/externa/' + this.$route.params.consulta).then(function (result) {
        result = result[0];

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          _this.formData = {
            id: result.data.id,
            data_age: _this.convertDate(result.data.data_age),
            funcionario: result.data.funcionario.nome,
            id_tipo_aso: result.data.tipo_aso.descricao + (result.data.periodicidade ? ' ' + result.data.periodicidade + ' MESES' : ''),
            id_tipo_status: result.data.tipo_status.id,
            id_funcao: result.data.funcao.nome,
            id_fdt: result.data.fdt.pcmso + ' (' + result.data.fdt.descricao + ')',
            id_ghe: result.data.ghe.ghe + ' (' + result.data.ghe.descricao + ')',
            obs: result.data.obs,
            result: result.data
          };

          if (result.data.tipo_status.id == '194' || result.data.tipo_status.id == '195') {
            _this.tabSelected = 'tab-acompanhamento';
          }
        } else {
          if (result.status == 404) _this.toRoute({ name: 'empresa.consulta' });
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('consulta/externa/editar', this.formData).then(function (result) {

        result = result[0];

        _this2.loadingSave = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
        }
      });
    }
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,

        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data'
      }, {
        key: 'valor',
        sortable: true,
        show_html: true,
        label: 'Valor (R$)'
      }, {
        key: 'valor_servico',
        sortable: true,
        show_html: true,
        label: 'Taxa de Serviço (R$)'
      }, {
        key: 'valor_total',
        sortable: true,
        show_html: true,
        label: 'Valor Total (R$)'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaExame();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaExame: function getConsultaExame(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/exame/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var exa_pcmso = '';

            if (!data[i].pcmso_exame) {
              exa_pcmso = '<br><span style="color:red">Exame não encontrado no PCMSO</span>';
            }
            var item = {
              id: data[i].id,
              exame: data[i].exame ? data[i].exame.nome + exa_pcmso : null,
              data: _this.toDate(data[i].data, true),
              valor: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor,
              valor_servico: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_servico,
              valor_total: data[i].va == '1' ? '<img src="' + _this.env.url_cs + 'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_total,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_consulta_filtro__ = __webpack_require__(943);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, Guia: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_consulta_includes_guia___default.a, Lote: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_includes_lote___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        tipo_exclude: [68, 70],
        click: {
          id_cre: this.getCredenciada,
          id_funcionario: this.getFuncionario
        },
        list: {
          id_cre: [],
          id_funcionario: []
        },
        loading: {
          id_cre: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: false,
          id_fdt: true
        }
      },
      formFilter: {
        id_cre: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      filterBadge: 0,
      loadingTable: false,
      showGuia: false,
      showLote: false,
      consulta: null,
      pagination: {},
      response: {},
      tableData: [],
      filterItems: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'credenciada',
        sortable: true,
        label: 'Credenciada'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'data_age',
        sortable: true,
        label: 'Agendamento'
      }, {
        key: 'status',
        show_status: true,
        sortable: true,
        label: 'Status'
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
    this.getCredenciada();
    this.getFuncionario();

    this.filterItems = __WEBPACK_IMPORTED_MODULE_6__form_consulta_filtro__["a" /* default */];
  },


  methods: {
    onRegister: function onRegister() {
      this.toRoute({ name: 'empresa.consulta.cad' });
    },
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'empresa.consulta.edt', params: { consulta: data.id } });
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.response = {};
        self.loadingTable = true;

        self.delete('consulta/externa/deletar', { itens: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;
          self.response = result;
          self.getConsulta();

          if (result.status == 200) {
            _this.edMsg('Registro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    },
    onGuia: function onGuia(data) {
      this.consulta = data;
      this.showGuia = !this.showGuia;
    },
    onLote: function onLote() {
      this.showLote = !this.showLote;
    },


    getCredenciada: function getCredenciada(_search) {
      var _this2 = this;

      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get('/credenciada', { search: _search }).then(function (result) {

        result = result[0];

        _this2.config.loading.id_cre = false;

        if (result.status == 200) {
          _this2.config.list.id_cre = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/funcionario/0', { search: _search }).then(function (result) {

        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(search, page, pagination) {
      var _this4 = this;

      this.config.loading.table = true;

      if (!this.formFilter.agendamento_at) {
        this.formFilter.agendamento_at = [];
      }

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, 'D'), true),
            amanha = this.toDate(this.addDate(0, null, 'D'), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_cre ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("consulta/externa", { search: search, page: page, pagination: pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];

        _this4.config.loading.table = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].info,
              data_age: _this4.toDate(data[i].data_age, true),
              _data: data[i],
              options: {
                disable_edit: data[i].deleted_at ? true : false,
                disable_delete: data[i].id_con || data[i].deleted_at ? true : false
              },
              buttons: []
            };

            if (!data[i].deleted_at && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58) {
              item.buttons.push({
                color: 'info',
                icon: 'fa fa-file-pdf-o',
                title: 'Abrir Guia de Encaminhamento',
                click: _this4.onGuia
              });
            }
            tableData.push(item);
          }

          pagination = result.data;
        }

        _this4.tableData = tableData;
        _this4.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa.consulta.exame',
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      tableHead: [{
        key: 'categoria',
        sortable: true,
        label: 'Categoria'
      }, {
        key: 'risco',
        sortable: true,
        label: 'Risco'
      }],
      tableData: [],
      loadingTable: false,
      pagination: {},
      response: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsultaRisco();
  },


  computed: {},

  methods: {
    onEdit: function onEdit(data) {},
    getConsultaRisco: function getConsultaRisco(search, page, pagination) {
      var _this = this;

      this.loadingTable = true;
      this.response = {};

      this.get('consulta/externa/risco/' + this.$route.params.consulta, { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this.loadingTable = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              risco: data[i].risco ? data[i].risco.nome : data[i].nome,
              categoria: data[i].risco && data[i].risco.categoria ? data[i].risco.categoria.categoria : data[i].categoria ? data[i].categoria.categoria : null,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_funcionario_editar__ = __webpack_require__(288);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {},
    'formData.id_funcao': function formDataId_funcao() {
      this.formData.id_ghe = null;
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: []
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false
        },
        tipo: [59]
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd: 0,
        obs: null,
        created_user: 0,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_funcionario_editar__["a" /* default */];
    this.getFDT();
  },


  methods: {
    getFuncao: function getFuncao(_search) {
      var _this = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        'id_fdt': this.formData.id_fdt
      };

      this.get('funcao', {
        search: _search,
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this.config.list.id_funcao = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this2 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      var filter = {
        ativo: 1
      };

      this.get('pcmso/fdt', {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },
    getGHE: function getGHE() {
      var _this3 = this;

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];
      this.formData.id_ghe = null;

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.get('pcmso/ghe', {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_ghe = false;

        if (result.status == 200) {
          _this3.config.list.id_ghe = result.data;
        }
      });
    },
    salvar: function salvar() {
      var _this4 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post('funcionario/0/editar', this.formData).then(function (result) {
        result = result[0];
        console.log(result);

        _this4.config.loading.save = false;
        _this4.response = result;

        if (result.status == 200) {
          if (typeof result.data.cadastrado !== 'undefined' && result.data.cadastrado !== null) {
            _this4.$confirm('CPF já cadastrado, deseja transferir o Funcionário de empresa?', 'Atenção', { type: 'warning' }).then(function () {
              _this4.formData.created_user = 1;
              console.log(_this4.formData);

              _this4.salvar();
            }).catch(function () {
              _this4.toRoute({
                name: 'empresa.funcionario'
              });
            });
          } else {
            _this4.edMsg('Dados atualizados com sucesso');
            _this4.toRoute({
              name: 'empresa.funcionario.edt',
              params: {
                id: result.data.id
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_funcionario_editar__ = __webpack_require__(288);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  watch: {
    "formData.id_fdt": function formDataId_fdt() {
      if (!this.config.loading.save) {}
    },
    "formData.id_funcao": function formDataId_funcao() {
      if (!this.config.loading.save) {}
      this.getGHE();
    }
  },
  data: function data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: []
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false
        },
        tipo: [59]
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd: 0,

        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_4__form_funcionario_editar__["a" /* default */];
  },


  methods: {
    getFuncao: function getFuncao(_search) {
      var _this = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        id_fdt: this.formData.id_fdt
      };

      this.get("funcao", {
        search: _search,
        filter: filter,
        pagination: 1000
      }).then(function (result) {
        result = result[0];

        _this.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this.config.list.id_funcao = result.data.data;

          if (_this.formData.id_funcao) {
            if (!_this.arrFindByField(_this.config.list.id_funcao, "id", _this.formData.id_funcao)) {
              _this.formData.id_funcao = null;
              _this.formData.id_ghe = null;
              _this.config.list.id_ghe = [];
            }
          }
        }

        _this.config.loading.save = false;
      });
    },
    getFDT: function getFDT() {
      var _this2 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];
      var filter = {
        ativo: 1
      };
      this.get("pcmso/fdt", {
        filter: filter
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {

          _this2.config.list.id_fdt = result.data.data;
          _this2.getFuncao();
        }
      });
    },
    getGHE: function getGHE() {
      var _this3 = this;

      if (!this.formData.id_funcao) return;

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.get("pcmso/ghe", {
        filter: filter,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_ghe = false;

        if (result.status == 200) {
          _this3.config.list.id_ghe = result.data;

          var encontrado = false;
          result.data.forEach(function (revisao, index) {
            if (_this3.$utilidade.arrFindByField(revisao.options, "id", _this3.formData.id_ghe)) {
              encontrado = true;
            }
          });

          if (_this3.formData.id_ghe && !encontrado) {
            _this3.formData.id_ghe = null;
          }
        }
      });
    },
    getFuncionario: function getFuncionario() {
      var _this4 = this;

      this.config.loading.save = true;

      this.get("funcionario/0/" + this.$route.params.id).then(function (result) {
        result = result[0];

        _this4.response = result;

        if (result.status == 200) {
          var _this4$formData;

          var data = result.data;

          if (data.funcao) {}

          _this4.formData = (_this4$formData = {
            id: data.id,
            id_estado: data.id_estado == "0" ? null : data.id_estado,
            id_cidade: data.id_cidade == "0" ? null : data.id_cidade,
            id_funcao: data.id_funcao,
            id_fdt: data.id_pcmso ? data.id_pcmso : null,
            id_ghe: data.id_ghe ? data.id_ghe : null,
            _id_ghe: data._id_ghe ? data._id_ghe : null,
            nome: data.nome,
            cpf: data.cpf,
            rg: data.rg,
            dt_nas: data.dt_nas ? _this4.toDate(data.dt_nas, true) : null
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "dt_nas", data.dt_nas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "email", data.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "tel_res", data.tel_res), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "tel_cel", data.tel_cel), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "cep", data.cep), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "end", data.end), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "num", data.num), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "bairro", data.bairro), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "comp", data.comp), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "obs", data.obs), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_num", data.ct_num), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_serie", data.ct_serie), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "pcd", data.pcd), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "ct_uf", data.ct_uf), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "sexo", data.sexo), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "mat", data.mat), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "pis", data.pis), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "user_edit", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "created_at", data.created_at), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this4$formData, "updated_at", data.updated_at), _this4$formData);
        } else {
          if (result.status == 404) _this4.toRoute({
            name: "empresa.funcionario"
          });
        }

        _this4.config.loading.save = false;
        _this4.getFDT();
      });
    },
    salvar: function salvar() {
      var _this5 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("funcionario/0/editar", this.formData).then(function (result) {
        result = result[0];

        _this5.config.loading.save = false;
        _this5.response = result;

        if (result.status == 200) {
          console.log(result);
          _this5.edMsg("Dados atualizados com sucesso");
          _this5.getFuncionario();
        }
      });
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_consulta_liberacao_includes_historico_whatsapp__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_consulta_liberacao_includes_historico_whatsapp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsWeb_consulta_liberacao_includes_historico_whatsapp__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, HistoricoWhatsapp: __WEBPACK_IMPORTED_MODULE_2_appsWeb_consulta_liberacao_includes_historico_whatsapp___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingTable: false,
      pagination: {},
      response: {},
      tableData: [],
      showHistoricoWhatsapp: false,
      historicoWhatsappId: null,
      tableHedad: [{
        key: 'id',
        sortable: true,
        label: 'Cód'

      }, {
        key: 'nome',
        sortable: true,
        label: 'Nome'

      }, {
        key: 'cpf',
        sortable: true,
        label: 'CPF'

      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'status',
        sortable: true,
        label: 'Status'
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
  },


  methods: {
    onRegister: function onRegister() {
      this.toRoute({ name: 'empresa.funcionario.cad' });
    },
    onEdit: function onEdit(data) {
      this.toRoute({ name: 'empresa.funcionario.edt', params: { id: data.id } });
    },
    onConsulta: function onConsulta(data) {
      this.toRoute({ name: 'empresa.consulta.cad', params: { funcionario: data.id } }, 'object');
    },
    onHistoricoWhatsapp: function onHistoricoWhatsapp(data) {
      this.historicoWhatsappId = data.id;
      this.showHistoricoWhatsapp = !this.showHistoricoWhatsapp;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        type: 'warning'

      }).then(function () {

        self.response = {};
        self.loadingTable = true;

        self.post('funcionario/0/deletar', { itens: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          self.response = result;

          if (result.status == 200) {
            _this.edMsg('REgistro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    },
    getFuncionario: function getFuncionario(search, page, pagination) {
      var _this2 = this;

      this.loadingTable = true;

      this.get("funcionario/0", { search: search, page: page, pagination: pagination }).then(function (result) {
        result = result[0];

        _this2.loadingTable = false;
        _this2.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              status: data[i].dem == 1 ? 'DEMITIDO' : 'ATIVO',
              _data: data[i],
              options: {
                style: "color:" + (data[i].dem == 1 ? 'red' : '')
              },
              buttons: [{
                color: 'warning',
                icon: 'fa fa-address-card',
                title: 'Inserir Nova Consulta',
                click: _this2.onConsulta

              }, {
                color: 'default',
                icon: 'fa-solid fa-rectangle-list',
                title: 'Ver histórico de notificações WhatsApp enviadas para esse funcionário (ex: aviso de atualização de matrícula ao contador).',
                click: _this2.onHistoricoWhatsapp
              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__ = __webpack_require__(944);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      config: {
        tipo: [46],
        click: {},
        list: {
          id_cre: [],
          id_funcionario: []
        },
        loading: {
          id_cre: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: false,
          id_fdt: true
        }
      },
      formFilter: {
        id_tipo_status: [66],
        id_tipo_aso: [],
        created_at: [],
        deleted: 0
      },
      filterBadge: 0,
      loadingTable: false,
      consulta: null,
      pagination: {},
      response: {},
      tableData: [],
      filterItems: [],
      tableHead: [{
        key: 'id_con',
        sortable: true,
        label: 'Consulta'

      }, {
        key: 'dt_cad',
        sortable: true,
        label: 'Data'

      }, {
        key: 'credenciada',
        sortable: true,
        label: 'Credenciada'

      }, {
        key: 'funcionario',
        sortable: true,
        label: 'Funcionário'
      }, {
        key: 'funcao',
        sortable: true,
        show_tipo_aso: true,
        label: 'Função'
      }, {
        key: 'status',
        show_status: true,
        sortable: true,
        label: 'Status'
      }]
    };
  },
  mounted: function mounted() {
    this.getConsulta();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_consulta_filtro__["a" /* default */];
  },

  methods: {
    onSearchASO: function onSearchASO(data) {
      this.open('consulta/aso/' + this.toMd5(data.id_con));
    },
    getConsulta: function getConsulta(search, page, pagination) {
      var _this = this;

      this.config.loading.table = true;

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      this.filterBadge = (this.formFilter.created_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length;

      this.get("consulta/liberacao", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formFilter
      }).then(function (result) {

        result = result[0];
        _this.config.loading.table = false;
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {
          data = result.data.data;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              id_con: data[i].id_con ? data[i].id_con : '---',
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].info,
              dt_cad: _this.toDate(data[i].dt_cad, true),
              _data: data[i],
              options: {
                disable_edit: true,
                disable_delete: true
              },
              buttons: []
            };

            if (!data[i].deleted_at) {
              item.buttons.push({
                color: 'info',
                icon: 'fa fa-file-pdf-o',
                title: 'Imprimir ASO',
                click: _this.onSearchASO
              });
            }
            tableData.push(item);
          }

          pagination = result.data;
        }
        _this.config.loading.table = false;
        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_login__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_reset__ = __webpack_require__(946);









/* harmony default export */ __webpack_exports__["default"] = ({
		components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a },
		mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
		data: function data() {
				return {
						error: {},
						response: {},
						formData: {
								cpf: null,
								cnpj: null,
								senha: null,
								point_type: 'empresa'
						},
						loginItens: [],
						resetitens: [],
						loadingSave: false,
						loadingRecuperarSenha: false,
						showModal: false,
						loadingContent: true
				};
		},
		created: function created() {

				if (this.logged()) this.toRoute({ name: 'empresa.consulta' });else this.loadingContent = false;
		},
		mounted: function mounted() {
				this.loginItens = __WEBPACK_IMPORTED_MODULE_4__form_login__["a" /* default */];
				this.resetitens = __WEBPACK_IMPORTED_MODULE_5__form_reset__["a" /* default */];
		},


		methods: {
				login: function login() {
						var _this = this;

						this.loadingSave = true;
						this.error = {};
						this.response = {};

						this.post("login", this.formData).then(function (result) {
								result = result[0];

								_this.loadingSave = false;
								_this.response = result;

								if (result.status == 200) {

										var usuario = result.data.usuario,
										    cliente = result.data.cliente;

										_this.setCookie(_this.env.jwt_empresa, result.data.jwt, usuario.sessao);

										_this.usuario = usuario;
										_this.cliente = cliente;

										_this.toRoute({ name: 'empresa.consulta' });
								}
						});
				},
				recuperarSenha: function recuperarSenha() {
						var _this2 = this;

						this.loadingRecuperarSenha = true;
						this.response = {};

						this.post("recuperar-senha", this.formData).then(function (result) {
								result = result[0];
								_this2.response = result;
								_this2.loadingRecuperarSenha = false;

								if (result.status == 200) {
										_this2.showModal = false;
										_this2.edAlert("Sua nova senha foi enviada para o email: " + result.data + ". Aguarde alguns minutos e verifique sua caixa de entrada.");
								}
						});
				}
		}
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_meu_cadastro_email__ = __webpack_require__(947);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "email",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    empresa: {
      type: Object,
      default: null
    }
  },
  watch: {
    empresa: function empresa() {
      this.getEmail();
      this.getFdt();
    }
  },
  data: function data() {
    return {
      formData: {
        id: 0,
        id_emp: null,
        id_usu: null,
        tipo: [],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      },
      pagination: {},
      response: {},
      config: {
        tipo: [32],
        click: {
          fdt: this.getFdt
        },
        loading: {
          save: false,
          fdt: false
        },
        list: {
          fdt: []
        }
      },
      emailItems: [],
      tableHead: [{
        key: 'email',
        sortable: true,
        label: 'Email'
      }, {
        key: 'setor',
        sortable: true,
        label: 'Setor'
      }, {
        key: 'fdt',
        sortable: true,
        label: 'Frente de Trabalho'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Obs'
      }],
      tableData: [],
      loadingTable: false,
      loadingSave: false,
      showFormEdit: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.emailItems = __WEBPACK_IMPORTED_MODULE_5__form_meu_cadastro_email__["a" /* default */];
    this.getEmail();
    this.getFdt();
  },

  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_emp: this.empresa.id,
        id_usu: null,
        tipo: [],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      };
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {

      var fdt = [],
          tipo = [];

      for (var j = 0; j < data.fdt.length; j++) {
        var element = data.fdt[j];
        fdt.push(data.fdt[j].id);
      }

      for (var _j = 0; _j < data.tipo.length; _j++) {
        var _element = data.fdt[_j];
        tipo.push(data.tipo[_j].id);
      }

      this.formData = {
        id: data.id,
        id_usu: data.usuario.id_usu,
        id_emp: this.empresa.id,
        obs: data.obs,
        tipo: tipo,
        fdt: fdt,
        email: data.email,
        usuario: data.usuario,
        updated_at: data.updated_at,
        ativo: data.ativo
      };
      this.showFormEdit = !this.showFormEdit;
    },

    getFdt: function getFdt() {
      var _this = this;

      if (!this.empresa || !this.empresa.id) return;

      this.config.loading.fdt = true;
      this.config.list.fdt = [];

      this.get('pcmso/fdt', { pagination: 100 }).then(function (result) {

        result = result[0];

        _this.config.loading.fdt = false;

        if (result.status == 200) {
          _this.config.list.fdt = result.data.data;
        }
      });
    },


    getEmail: function getEmail(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;

      this.get("/email/0", { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {

            var fdt = [],
                tipo = [];

            for (var j = 0; j < data[i].fdt.length; j++) {
              var element = data[i].fdt[j];
              fdt.push(element.pcmso + ' (' + element.descricao + ')');
            }

            for (var _j2 = 0; _j2 < data[i].tipo.length; _j2++) {
              var _element2 = data[i].tipo[_j2];
              tipo.push(_element2.descricao);
            }

            var item = {
              nome: data[i].nome,
              email: data[i].email.replace(';', '<br>'),
              obs: data[i].obs ? data[i].obs : '---',
              fdt: fdt.length > 0 ? fdt.join('<br>') : '---',
              setor: tipo.length > 0 ? tipo.join('<br>') : '---',
              ativo: data[i].ativo == 1 ? 'Sim' : 'Não',
              _data: data[i],
              options: {
                style: 'color:' + (data[i].ativo == 1 ? 'green' : 'red'),
                title: data[i].ativo == 1 ? '' : 'Email inativo. Clique para atualizar.'
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    },

    salvar: function salvar() {
      var _this3 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/email/0/editar", this.formData).then(function (result) {
        result = result[0];

        _this3.config.loading.save = false;
        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg('Email salvo com sucesso!');
          _this3.showFormEdit = !_this3.showFormEdit;
          _this3.getEmail();
        }
      });
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_index__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__email_index__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, Emails: __WEBPACK_IMPORTED_MODULE_4__email_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    'formData.id_fdt': function formDataId_fdt() {
      this.getFuncao();
    },
    'formData.id_funcao': function formDataId_funcao() {
      this.getGHE();
    }
  },
  data: function data() {
    return {
      tagConfig: 'tab-cadastro',
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        tipo: [],
        readonly: {
          nome: true,
          cnpj: true,
          u_cpf: true,
          u_nome: true
        }
      },
      formData: {
        id: null,
        id_estado: null,
        id_cidade: null,
        nome: null,
        cnpj: null,
        email: null,
        tel_com: null,
        r_nome: null,
        r_email: null,
        r_tel_com: null,
        u_nome: null,
        u_cpf: null,
        u_email: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        log: [],
        obs: null,
        created_at: null,
        updated_at: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_3__form_meu_cadastro__["a" /* default */];
  },


  methods: {
    getEmpresa: function getEmpresa() {
      var _this = this;

      this.loadingContent = true;
      this.response = {};

      this.get("meu-cadastro").then(function (result) {

        result = result[0];

        _this.loadingContent = false;
        _this.response = result;

        if (result.status == 200) {
          var data = result.data;

          _this.formData = {
            id: data.id,
            id_estado: data.id_estado,
            id_cidade: data.id_cidade,
            nome: data.nome,
            cnpj: data.cnpj,
            email: data.email,
            tel_com: data.tel_com,
            r_nome: data.r_nome,
            r_email: data.r_email,
            r_tel_com: data.r_tel_com,
            cep: data.cep,
            end: data.end,
            num: data.num,
            bairro: data.bairro,
            comp: data.comp,
            obs: data.obs,
            created_at: data.created_at,
            updated_at: data.updated_at,

            senha_atual: null,
            senha_nova: null,
            senha_confirma: null,

            u_nome: _this.usuario.logged.nome,
            u_cpf: _this.usuario.logged.usuario,
            u_email: _this.usuario.logged.email
          };
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.loadingSave = true;
      this.response = {};

      this.post('meu-cadastro', this.formData).then(function (result) {
        result = result[0];

        _this2.loadingSave = false;

        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Dados atualizados com sucesso');
          _this2.getEmpresa();
        }
      });
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_5_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, ConsultaLote: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_consulta_includes_lote___default.a, ConsultaHistorico: __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_includes_historico___default.a, Pcmso: __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_consulta_includes_pcmso___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingTable: false,
      componentKey: 0,
      pagination: {},
      response: null,
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_funcionario: this.getFuncionario,
          id_fdt: this.getFdt
        },
        list: {
          id_funcionario: [],
          id_fdt: []
        },
        loading: {
          id_funcionario: false,
          id_fdt: false
        },
        tipo: []
      },
      formData: {
        id_funcionario: [],
        id_fdt: [],
        periodo: [this.toDate(this.addDate(-30, null, 'D'), true), this.toDate(this.addDate(30, null, 'D'), true)]
      },
      formDataConsulta: {
        funcionario: []
      },
      tabPeriodico: 'tab-ok',
      tabExame: 'tab-exames',
      tableData: [],
      tableDataForaPeriodo: [],
      tableDataError: [],
      tableDataExame: [],
      tableDataTabelaPreco: [],
      tableHeadTabelaPreco: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "quantidade",
        sortable: true,
        label: "Quantidade"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Unitário (R$)"
      }, {
        key: "valor_total",
        sortable: true,
        label: "Valor Total (R$)"
      }],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Aproximado (R$)"
      }, {
        key: 'consulta',
        sortable: true,
        width: '215px',
        label: 'Última Consulta Realizada'

      }, {
        key: 'tipo',
        sortable: true,
        label: 'Tipo'

      }, {
        key: 'data',
        sortable: true,
        width: '215px',
        label: 'Data Ideal Para Refazê-lo'
      }, {
        key: 'obs',
        sortable: true,
        label: 'Observações'
      }],
      tableHead: [{
        key: 'nome',
        sortable: true,
        show_cpf: true,
        label: 'Nome'

      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }, {
        key: 'fdt',
        sortable: true,
        label: 'Frente de Trabalho'
      }, {
        key: 'ghe',
        sortable: true,
        label: 'GHE (Setor)'
      }, {
        key: 'obs',
        sortable: true,
        show_html: true,
        label: 'Observações'
      }],
      funcionario: null,
      showModal: false,
      showConsultaLote: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getFuncionario();
    this.getFdt();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__["a" /* default */];
  },


  methods: {
    onConsultaLote: function onConsultaLote(data) {

      if (data.id) {
        data = [data];
      }

      this.componentKey += 1;
      this.formDataConsulta.funcionario = data;
      this.showConsultaLote = !this.showConsultaLote;
    },
    onExcel: function onExcel() {
      this.open('periodico/excel', { filter: this.formData });
    },
    onExames: function onExames(data) {

      var tableDataExame = [];

      for (var i = 0; i < data.exames.length; i++) {

        var item = {
          id: data.exames[i].id,
          exame: data.exames[i].nome,
          consulta: data.exames[i].id_con ? 'Consulta ' + data.exames[i].id_con + ' (' + this.toDate(data.exames[i].dt_cad, true) + ')' + (data.exames[i].validade > 0 ? '<br><span>Exame válido por ' + data.exames[i].validade + ' dias</span>' : '') : '---',
          tipo: data.exames[i].dt_rea ? data.exames[i].tipo : '---',
          data: data.exames[i].dt_rea ? this.toDate(data.exames[i].dt_rea, true) : '---',
          obs: data.exames[i].obs ? data.exames[i].obs : '---',
          valor_venda: data.exames[i].tabela_preco ? this.floatToMoney(data.exames[i].tabela_preco.valor_venda) : "---",
          _data: data.exames[i],
          options: {
            style: 'color:' + data.exames[i].cor
          },
          buttons: [{
            color: 'success',
            icon: 'fa fa-user-md',
            title: 'Visualizar Exames',
            click: this.onExames

          }]
        };
        tableDataExame.push(item);
      }

      this.tabExame = 'tab-exames';
      this.showModal = !this.showModal;
      this.tableDataExame = tableDataExame;
      this.funcionario = data;
    },
    getFdt: function getFdt() {
      var _this = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get('pcmso/fdt').then(function (result) {
        result = result[0];

        _this.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this.config.list.id_fdt = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('funcionario/0', { search: _search, pagination: 100 }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this2.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getPeriodico: function getPeriodico(search, page, pagination) {
      var _this3 = this;

      this.loadingTable = true;
      this.tabPeriodico = 'tab-ok';

      if (this.formData.periodo.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-30, null, 'D'), true),
            amanha = this.toDate(this.addDate(30, null, 'D'), true);

        this.formData.periodo = [ontem, amanha];
      }

      this.get("periodico", { search: search, page: page, pagination: pagination, filter: this.formData }).then(function (result) {
        result = result[0];

        _this3.loadingTable = false;
        _this3.response = result;

        var data = [],
            tableData = [],
            tableDataForaPeriodo = [],
            tableDataError = [],
            tableDataTabelaPreco = [],
            pagination = {};

        if (result.status == 200) {
          result.data.per_tabela_preco.forEach(function (tabela_preco, index) {
            var item = {
              id: index,
              exame: tabela_preco.fdt.nome,
              valor_venda: '---',
              valor_total: '---',
              quantidade: tabela_preco.fdt.quantidade,
              _data: tabela_preco,
              options: {
                style: "color:red;font-weight:bold"
              },
              buttons: []
            };
            tableDataTabelaPreco.push(item);

            tabela_preco.exames.forEach(function (tabela_preco_exame, indexExame) {
              var item = {
                id: index + indexExame,
                exame: tabela_preco_exame.nome,
                valor_venda: tabela_preco_exame.quantidade == 0 ? '---' : _this3.floatToMoney(tabela_preco_exame.valor_venda),
                valor_total: _this3.floatToMoney(Number(tabela_preco_exame.valor_venda) * Number(tabela_preco_exame.quantidade)),
                quantidade: tabela_preco_exame.quantidade,
                _data: tabela_preco_exame,
                buttons: []
              };
              tableDataTabelaPreco.push(item);
            });
          });

          data = result.data.per_dentro_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: [{
                color: 'warning',
                icon: 'fa fa-address-card',
                title: 'Gerar Consulta para esse Trabalhador',
                click: _this3.onConsultaLote

              }, {
                color: 'success',
                icon: 'fa fa-user-md',
                title: 'Visualizar Exames (' + data[i].length + ' no total)',
                click: _this3.onExames

              }]
            };
            tableData.push(item);
          }

          data = result.data.per_fora_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: [{
                color: 'success',
                icon: 'fa fa-user-md',
                title: 'Visualizar Exames (' + data[i].length + ' no total)',
                click: _this3.onExames

              }]
            };
            tableDataForaPeriodo.push(item);
          }

          data = result.data.per_erro;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : '---',
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '---',
              ghe: data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : '---',
              _data: data[i],
              buttons: []
            };
            tableDataError.push(item);
          }
        }

        _this3.tableData = tableData;
        _this3.tableDataForaPeriodo = tableDataForaPeriodo;
        _this3.tableDataError = tableDataError;
        _this3.tableDataTabelaPreco = tableDataTabelaPreco;
      });
    }
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidaTokenEmailStep',
  props: {
    email: {
      type: String,
      default: ''
    },
    values: {
      type: Array,
      default: function _default() {
        return ['', '', '', ''];
      }
    },
    busy: {
      type: Boolean,
      default: false
    },
    canResend: {
      type: Boolean,
      default: false
    },
    resendLabel: {
      type: String,
      default: 'Reenviar Código'
    }
  },
  computed: {
    canConfirm: function canConfirm() {
      return this.values.join('').length === 4;
    }
  }
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidaTokenTelefoneStep',
  props: {
    telefone: {
      type: String,
      default: ''
    },
    values: {
      type: Array,
      default: function _default() {
        return ['', '', '', ''];
      }
    },
    busy: {
      type: Boolean,
      default: false
    },
    canResend: {
      type: Boolean,
      default: false
    },
    resendLabel: {
      type: String,
      default: 'Reenviar Código'
    }
  },
  computed: {
    canConfirm: function canConfirm() {
      return this.values.join('').length === 4;
    }
  }
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidarEmailStep',
  props: {
    email: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canContinue: function canContinue() {
      return !!String(this.email || '').trim();
    }
  }
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidarIdentidadeStep',
  props: {
    cpf: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    },
    cadastroExistente: {
      type: Boolean,
      default: false
    },
    editavel: {
      type: Boolean,
      default: false
    },
    nome: {
      type: String,
      default: ''
    },
    maskedNome: {
      type: String,
      default: ''
    },
    maskedCpf: {
      type: String,
      default: ''
    },
    sexo: {
      type: String,
      default: ''
    },
    dataNascimento: {
      type: String,
      default: ''
    },
    possuiDadosCerebro: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidarSenhaStep',
  props: {
    password: {
      type: String,
      default: ''
    },
    passwordConfirm: {
      type: String,
      default: ''
    },
    passwordError: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AsoValidarTelefoneStep',
  props: {
    telefone: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canContinue: function canContinue() {
      return String(this.telefone || '').replace(/\D+/g, '').length >= 10;
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_img_mockups_doc_front_uploader_png__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_img_mockups_doc_front_uploader_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assets_img_mockups_doc_front_uploader_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_mockups_doc_front_uploader_success_png__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_mockups_doc_front_uploader_success_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_mockups_doc_front_uploader_success_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_mockups_doc_front_uploader_error_png__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_mockups_doc_front_uploader_error_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_img_mockups_doc_front_uploader_error_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_mockups_doc_back_uploader_png__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_mockups_doc_back_uploader_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_mockups_doc_back_uploader_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_mockups_doc_back_uploader_success_png__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_mockups_doc_back_uploader_success_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_img_mockups_doc_back_uploader_success_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_img_mockups_doc_back_uploader_error_png__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_img_mockups_doc_back_uploader_error_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_img_mockups_doc_back_uploader_error_png__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadDocumentCard',
  props: {
    side: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    busy: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    acceptPdf: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    uploaded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMobileOptions: false
    };
  },

  computed: {
    galleryAccept: function galleryAccept() {
      return this.acceptPdf ? 'image/png,image/jpeg,application/pdf' : 'image/png,image/jpeg';
    },
    isMobile: function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    },
    visualImage: function visualImage() {
      var isFront = this.side === 'frente';

      if (this.hasError) {
        return isFront ? __WEBPACK_IMPORTED_MODULE_2_assets_img_mockups_doc_front_uploader_error_png___default.a : __WEBPACK_IMPORTED_MODULE_5_assets_img_mockups_doc_back_uploader_error_png___default.a;
      }

      if (this.uploaded) {
        return isFront ? __WEBPACK_IMPORTED_MODULE_1_assets_img_mockups_doc_front_uploader_success_png___default.a : __WEBPACK_IMPORTED_MODULE_4_assets_img_mockups_doc_back_uploader_success_png___default.a;
      }

      return isFront ? __WEBPACK_IMPORTED_MODULE_0_assets_img_mockups_doc_front_uploader_png___default.a : __WEBPACK_IMPORTED_MODULE_3_assets_img_mockups_doc_back_uploader_png___default.a;
    },
    visualStyle: function visualStyle() {
      return {
        backgroundImage: 'url(' + this.visualImage + ')'
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside, true);
  },

  methods: {
    handlePrimaryAction: function handlePrimaryAction() {
      if (this.disabled || this.busy) {
        return;
      }

      if (this.isMobile) {
        this.showMobileOptions = !this.showMobileOptions;
        if (this.showMobileOptions) {
          document.addEventListener('click', this.handleClickOutside, true);
        } else {
          document.removeEventListener('click', this.handleClickOutside, true);
        }
        return;
      }

      this.openGallery();
    },
    handleClickOutside: function handleClickOutside(event) {
      if (!this.showMobileOptions) {
        return;
      }

      var trigger = this.$refs.triggerRef;
      if (trigger && !trigger.contains(event.target)) {
        this.showMobileOptions = false;
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    },
    openCamera: function openCamera() {
      if (this.disabled || this.busy) {
        return;
      }

      this.showMobileOptions = false;
      document.removeEventListener('click', this.handleClickOutside, true);
      this.$refs.cameraInput.click();
    },
    openGallery: function openGallery() {
      if (this.disabled || this.busy) {
        return;
      }

      this.showMobileOptions = false;
      document.removeEventListener('click', this.handleClickOutside, true);
      this.$refs.galleryInput.click();
    },
    onSelect: function onSelect(event) {
      var file = event && event.target && event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      this.$emit('selected', {
        side: this.side,
        file: file
      });

      event.target.value = '';
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadFaceCard',
  props: {
    label: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    uploaded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isWebcamOpen: false,
      cameraError: '',
      capturedPhoto: null,
      mediaStream: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCamera();
  },

  methods: {
    tryOpenLiveCamera: function tryOpenLiveCamera() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var stream;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.disabled || _this.busy)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.cameraError = '';

                _context.prev = 3;
                _context.next = 6;
                return navigator.mediaDevices.getUserMedia({
                  video: { facingMode: 'user' },
                  audio: false
                });

              case 6:
                stream = _context.sent;


                _this.mediaStream = stream;
                _this.isWebcamOpen = true;

                _this.$nextTick(function () {
                  _this.attachStreamToVideo();
                });
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](3);

                _this.cameraError = 'Não foi possível acessar a câmera. Verifique as permissões do navegador.';
                console.error('Erro ao acessar câmera:', _context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 12]]);
      }))();
    },
    captureFrame: function captureFrame() {
      var video = this.$refs.videoElement;
      if (!video) {
        return;
      }

      var canvas = document.createElement('canvas');
      canvas.width = video.videoWidth || 640;
      canvas.height = video.videoHeight || 480;

      var ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);

      this.capturedPhoto = canvas.toDataURL('image/jpeg', 0.95);
    },
    confirmPhoto: function confirmPhoto() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, blob, file;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.capturedPhoto) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return fetch(_this2.capturedPhoto);

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.blob();

              case 7:
                blob = _context2.sent;
                file = new File([blob], 'selfie.jpg', { type: 'image/jpeg' });


                _this2.$emit('selected', file);
                _this2.closeLiveCamera();

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resetCapture: function resetCapture() {
      var _this3 = this;

      this.capturedPhoto = null;

      this.$nextTick(function () {
        _this3.attachStreamToVideo();
      });
    },
    attachStreamToVideo: function attachStreamToVideo() {
      var video = this.$refs.videoElement;
      if (!video || !this.mediaStream) {
        return;
      }

      if (video.srcObject !== this.mediaStream) {
        video.srcObject = this.mediaStream;
      }

      var playPromise = video.play && video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    },
    closeLiveCamera: function closeLiveCamera() {
      this.stopCamera();
      this.isWebcamOpen = false;
      this.capturedPhoto = null;
      this.cameraError = '';
    },
    stopCamera: function stopCamera() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(function (track) {
          return track.stop();
        });
        this.mediaStream = null;
      }
    }
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailIcon", function() { return EmailIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdIcon", function() { return IdIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneIcon", function() { return PhoneIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PasswordIcon", function() { return PasswordIcon; });

var EmailIcon = {
  name: 'EmailIcon',
  render: function render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [h('path', {
      attrs: {
        fill: '#0575E6',
        d: 'M23.25 5.25v13.5H.75V5.25h22.5zm-1.5 3.544l-7.89 4.507c-1.153.659-2.567.659-3.72 0L2.25 8.795v8.455h19.5V8.794zm0-2.044H2.25v.316l8.634 4.933c.638.364 1.41.392 2.07.084l.162-.084 8.634-4.934V6.75z'
      }
    })]);
  }
};

var IdIcon = {
  name: 'IdIcon',
  render: function render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [h('path', {
      attrs: {
        fill: '#0575E6',
        d: 'M21.6 4.8c1.325 0 2.4 1.075 2.4 2.4V18c0 1.325-1.075 2.4-2.4 2.4H2.4C1.075 20.4 0 19.325 0 18V7.2c0-1.325 1.075-2.4 2.4-2.4h19.2zm0 1.44H2.4c-.49 0-.893.366-.953.84l-.007.12V18c0 .49.366.893.84.953l.12.007h19.2c.49 0 .893-.366.953-.84l.007-.12V7.2c0-.49-.366-.893-.84-.953l-.12-.007zM8.891 14.4c1.054 0 1.909.895 1.909 2v.4h-.89v-.4c0-.663-.386-.8-1.019-.8H4.3c-.627 0-1.005.133-1.005.79v.4H2.4v-.4c0-1.1.85-1.99 1.899-1.99zM6.6 8.4c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 1.2c-.994 0-1.8.806-1.8 1.8s.806 1.8 1.8 1.8 1.8-.806 1.8-1.8-.806-1.8-1.8-1.8zm13.2 1.2c.365 0 .66.295.66.66 0 .328-.24.6-.553.651l-.107.009h-7.2c-.365 0-.66-.295-.66-.66 0-.328.24-.6.553-.651l.107-.009h7.2zm0-2.46c.365 0 .66.295.66.66 0 .328-.24.6-.553.651l-.107.009h-7.2c-.365 0-.66-.295-.66-.66 0-.328.24-.6.553-.651l.107-.009h7.2z'
      }
    })]);
  }
};

var PhoneIcon = {
  name: 'PhoneIcon',
  render: function render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [h('path', {
      attrs: {
        fill: '#0575E6',
        d: 'M16.504.75c1.243 0 2.25 1.007 2.25 2.25v18c0 1.243-1.007 2.25-2.25 2.25H7.508c-1.242 0-2.25-1.007-2.25-2.25V3c0-1.243 1.008-2.25 2.25-2.25h8.996zm.749 19.501H6.757l.001.749c0 .414.336.75.75.75h8.996c.414 0 .75-.336.75-.75l-.001-.749zm0-15.001H6.757v13.501h10.496V5.25zm-.749-3H7.508c-.414 0-.75.336-.75.75l-.001.75h10.496l.001-.75c0-.414-.336-.75-.75-.75z'
      }
    })]);
  }
};

var PasswordIcon = {
  name: 'PasswordIcon',
  render: function render(h) {
    return h('svg', {
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '18',
        height: '18',
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
      }
    }, [h('path', {
      attrs: {
        d: 'M12 2C9.24 2 7 4.24 7 7v3H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-2V7c0-2.76-2.24-5-5-5zm0 1.5c1.93 0 3.5 1.57 3.5 3.5v3h-7V7c0-1.93 1.57-3.5 3.5-3.5zM5 12h14v8H5v-8zm7 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        fill: '#0575E6'
      }
    })]);
  }
};

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wizard_mixin__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadDocumentCard__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadDocumentCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UploadDocumentCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadFaceCard__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadFaceCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UploadFaceCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AsoValidarEmailStep_vue__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AsoValidarEmailStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AsoValidarEmailStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AsoValidaTokenEmailStep_vue__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AsoValidaTokenEmailStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AsoValidaTokenEmailStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AsoValidarIdentidadeStep_vue__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AsoValidarIdentidadeStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AsoValidarIdentidadeStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AsoValidarTelefoneStep_vue__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AsoValidarTelefoneStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AsoValidarTelefoneStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AsoValidaTokenTelefoneStep_vue__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AsoValidaTokenTelefoneStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AsoValidaTokenTelefoneStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AsoValidarSenhaStep_vue__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AsoValidarSenhaStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AsoValidarSenhaStep_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FuncionarioAsoAssinar',
  components: {
    UploadDocumentCard: __WEBPACK_IMPORTED_MODULE_1__UploadDocumentCard___default.a,
    UploadFaceCard: __WEBPACK_IMPORTED_MODULE_2__UploadFaceCard___default.a,
    EmailIcon: __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__["EmailIcon"],
    IdIcon: __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__["IdIcon"],
    PhoneIcon: __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__["PhoneIcon"],
    PasswordIcon: __WEBPACK_IMPORTED_MODULE_3__ValidationIcons_vue__["PasswordIcon"],
    AsoValidarEmailStep: __WEBPACK_IMPORTED_MODULE_4__AsoValidarEmailStep_vue___default.a,
    AsoValidaTokenEmailStep: __WEBPACK_IMPORTED_MODULE_5__AsoValidaTokenEmailStep_vue___default.a,
    AsoValidarIdentidadeStep: __WEBPACK_IMPORTED_MODULE_6__AsoValidarIdentidadeStep_vue___default.a,
    AsoValidarTelefoneStep: __WEBPACK_IMPORTED_MODULE_7__AsoValidarTelefoneStep_vue___default.a,
    AsoValidaTokenTelefoneStep: __WEBPACK_IMPORTED_MODULE_8__AsoValidaTokenTelefoneStep_vue___default.a,
    AsoValidarSenhaStep: __WEBPACK_IMPORTED_MODULE_9__AsoValidarSenhaStep_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__wizard_mixin__["a" /* default */]]
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {}
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  props: {
    erro: {
      type: String,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    $('body').addClass('bg-login');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },
  mounted: function mounted() {
    $(".carregando").hide();
  },


  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PoliticaPrivacidade'
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_template__ = __webpack_require__(33);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: { EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_template__["a" /* EdForm */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_3_template__["b" /* EdInputSelect */] },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
	props: {
		consulta: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		consultaNova: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		ultimaRevisao: {
			type: Object,
			default: function _default() {
				return null;
			}
		}
	},
	watch: {
		consulta: function consulta() {
			this.getFdt();
		},
		'consultaNova.id_fdt': function consultaNovaId_fdt() {
			this.consultaNova.id_ghe = null;
		},
		'consultaNova.id_ghe': function consultaNovaId_ghe() {
			this.consultaNova.id_funcao = null;
		},
		'consultaNova.id_funcao': function consultaNovaId_funcao() {
			this.getCredenciada();
		}
	},
	data: function data() {
		return {
			list: {
				fdt: [],
				ghe: [],
				revisao: [],
				funcao: []
			},
			tabela_preco: null,
			loadingFdt: false,
			loadingGhe: false,
			loadingFuncao: false,
			loadingRevisao: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getFdt();
	},

	methods: {
		getFdt: function getFdt() {
			var _this = this;

			if (!this.consulta) return;

			this.loadingFdt = true;

			this.$root.$request.get("pcmso/fdt/" + this.consulta.empresa.id, {}).then(function (result) {

				console.log('fdt', result);
				if (result.status == 200) {
					_this.list.fdt = result.data.data;

					if (_this.consultaNova.id_fdt) {
						_this.getGhe();
					}
				}

				_this.loadingFdt = false;
			});
		},
		getGhe: function getGhe() {
			var _this2 = this;

			this.loadingGhe = true;
			this.list.ghe = [];

			this.$root.$request.get("pcmso/ghe/" + this.consulta.empresa.id, {
				filter: {
					id_fdt: this.consultaNova.id_fdt
				}
			}).then(function (result) {

				console.log('ghe', result);

				if (result.status == 200) {
					_this2.list.ghe = result.data;
				}

				_this2.loadingGhe = false;
			});
		},
		getFuncao: function getFuncao() {
			var _this3 = this;

			this.loadingFuncao = true;
			this.list.funcao = [];

			this.$root.$request.get("pcmso/ghe/funcao/" + this.consultaNova.id_ghe + "/" + this.consulta.empresa.id, {
				filter: {}
			}).then(function (result) {

				console.log('funcao', result.data.data);

				if (result.status == 200) {
					_this3.list.funcao = result.data.data;

					var self = _this3;
					var funcao = _this3.list.funcao.find(function (c) {
						return c.id == self.consulta.funcao.id;
					});
					console.log('asdsdf', [funcao, _this3.list.funcao, self.consulta.funcao]);

					_this3.consultaNova.id_funcao = null;

					if (funcao) {
						_this3.consultaNova.id_funcao = funcao.id;
					}
				}

				_this3.loadingFuncao = false;
			});
		},
		getCredenciada: function getCredenciada(page, search) {
			var _this4 = this;

			if (!this.consultaNova.id_fdt || !this.consultaNova.id_ghe || !this.consultaNova.id_funcao) {
				return;
			}

			this.$root.$loading.set(true, "Carregando exames");

			var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
				id_fdt: this.consultaNova.id_fdt,
				id_funcao: this.consultaNova.id_funcao,
				id_ghe: this.consultaNova.id_ghe,
				periodicidade: this.consulta.periodicidade,
				id_funcionario: this.consulta.funcionario.id,
				hoje: this.$utilidade.toDate(null, true),
				id_tipo_aso: [this.consulta.tipo_aso.id],
				pcd: 0,
				show_tabela_preco: 1
			}, this.formFilter);

			this.$root.$request.get("tabela-preco/" + this.consulta.empresa.id + "/" + this.consultaNova.id_fdt, {
				search: search,
				page: page,
				filter: filter
			}).then(function (result) {
				_this4.$root.$loading.set(false);

				console.log('tabela preco', result);

				_this4.consultaNova.id_tabela_preco = null;

				if (result.status == 200) {
					_this4.tabela_preco = null;

					for (var index = 0; index < result.data.length; index++) {
						var tabela_preco = result.data[index];

						if (tabela_preco.credenciada && tabela_preco.credenciada.padrao == "1" || index == 0) {
							_this4.consultaNova.id_tabela_preco = tabela_preco.id;
						}
					}

					if (!_this4.consultaNova.id_tabela_preco) {
						_this4.tabela_preco = 'Tabela de preço não encontrado para os dados informados.';
					}
				} else {
					_this4.tabela_preco = result.msg;
				}
			});
		}
	}
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {},
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
	props: {
		consulta: {
			type: Object,
			default: function _default() {
				return null;
			}
		}
	},
	watch: {
		consulta: function consulta() {}
	},
	data: function data() {
		return {
			tabConfig: 'tab-consulta'
		};
	},
	created: function created() {},


	mounted: function mounted() {},

	methods: {}
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_consulta_externa_filtro__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a,
    ConsultaDetalhe: __WEBPACK_IMPORTED_MODULE_6__include_consulta_detalhe___default.a,
    ConsultaAlterarRevisao: __WEBPACK_IMPORTED_MODULE_7__include_consulta_alterar_revisao___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_4_common_alert___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  watch: {
    "formFilter.id_empresa": function formFilterId_empresa() {
      this.getFuncionario();
      this.getFDT();

      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.config.disabled.id_fdt = this.formFilter.id_empresa ? false : true;

      this.formFilter.id_funcionario = null;
      this.formFilter.id_fdt = null;
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_cre: this.getCredenciada,
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_funcao: this.getFuncao,
          id_fdt: this.getFDT
        },
        list: {
          id_cre: [],
          id_empresa: [],
          id_funcionario: [],
          id_funcao: [],
          id_fdt: []
        },
        loading: {
          id_cre: false,
          id_empresa: false,
          id_funcionario: false,
          id_funcao: false,
          id_fdt: false
        },
        disabled: {
          id_funcionario: true,
          id_fdt: true
        }
      },
      formData: {
        consulta: null,
        consultaNova: null,
        ultima_revisao: null
      },
      formFilter: {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      },
      pagination: {},
      response: {},
      filterItems: [],
      tableHead: [{
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "credenciada",
        sortable: true,
        label: "Credenciada"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }, {
        key: "data_agendamento",
        sortable: true,
        label: "Agendamento"
      }, {
        key: "data_cadastro",
        sortable: true,
        label: "Cadastro"
      }],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      loadingConsultaDetail: false,
      showFormFilter: false,
      showConsultaDetail: false,
      showAlterarRevisao: false,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getConsulta();
    this.getEmpresa();
    this.getCredenciada();
    this.getFuncao();

    this.filterItems = __WEBPACK_IMPORTED_MODULE_5__form_consulta_externa_filtro__["a" /* default */];
  },


  computed: {
    checkAlterarPcmso: function checkAlterarPcmso() {
      return this.formData.consultaNova && this.formData.consultaNova.id_fdt && this.formData.consultaNova.id_ghe && this.formData.consultaNova.id_tabela_preco && this.formData.consultaNova.id_funcao ? false : true;
    }
  },
  methods: {
    onClear: function onClear() {
      this.formFilter = {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0
      };
    },
    onEdit: function onEdit(data) {
      var _this = this;

      this.loadingTable = true;

      this.get("empresa/consulta/externa/" + data.id + "/gerar").then(function (result) {
        result = result[0];

        if (result.status == 200) {
          window.open("https://www1.softwareatento.com.br" + "/app/consulta.php?con=" + result.data.id_con + "&force=1", "_top");
        } else {
          _this.getConsulta();

          _this.$alert(result.msg, "Atenção", {
            confirmButtonText: "OK"
          });
        }
      });
    },
    onShowConsulta: function onShowConsulta(data) {
      var _this2 = this;

      this.showConsultaDetail = !this.showConsultaDetail;
      this.loadingConsultaDetail = true;
      this.formData.consulta = null;

      this.get("empresa/consulta/externa/" + data.id).then(function (result) {
        result = result[0];

        _this2.loadingConsultaDetail = false;

        if (result.status == 200) {
          _this2.formData.consulta = result.data;
        }
      });
    },
    onGerarConsulta: function onGerarConsulta(data) {
      var _this3 = this;

      var label = data.funcionario.nome,
          self = this;

      this.$confirm("O sistema vai gerar uma consulta definitiva para o funcionário " + label + ". Deseja continuar?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.get("pcmso/revisao/" + data.empresa.id + "/" + data.fdt.id + "/ultima-revisao").then(function (result) {
          result = result[0];

          self.formData.ultima_revisao = result.data;
          self.formData.consulta = data;
          self.formData.consultaNova = {
            id: 0,
            id_fdt: data.fdt.id,
            id_emp: data.empresa.id,
            id_ghe: null,
            id_funcao: null,
            id_tabela_preco: null,
            id_mf_fdt: null,
            id_mf_ghe: null,
            id_mf_funcao: null,
            data_age: _this3.toDate(null, true),
            id_tipo_aso: data.tipo_aso.id,
            periodicidade: data.periodicidade,
            id_funcionario: data.funcionario.id,
            id_con_ext_original: data.id
          };

          var diff = _this3.$utilidade.diffDays(data.data_age, _this3.$utilidade.toDate(null, true, "YYYY-MM-DD"), "d");

          console.log("validar revisao", [data, result.data]);

          if (diff <= 0 && (!result.data || !data.revisao || data.revisao.id != result.data.id)) {
            self.showAlterarRevisao = !self.showAlterarRevisao;
          } else {
            self.loadingTable = true;

            self.get("empresa/consulta/externa/" + data.id + "/gerar").then(function (result) {
              result = result[0];

              if (result.status == 200) {
                window.open(_this3.env.url_cs + "/app/consulta.php?con=" + result.data.id_con, "_top");
              } else {
                self.getConsulta();

                _this3.$alert(result.msg, "Atenção", {
                  confirmButtonText: "OK"
                });
              }
            });
          }
        });
      });
    },
    onAlterarPcmso: function onAlterarPcmso() {
      var _this4 = this;

      self = this;

      this.$confirm("O sistema vai alterar o PCMSO e exames vinculados nessa consulta e o processo não poderá ser revertido. Deseja continuar?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.$root.$loading.set(true);

        if (_this4.formData.consulta.tipo_aso.id == 50) {
          _this4.formData.consultaNova.id_mf_fdt = _this4.formData.consultaNova.id_fdt;
          _this4.formData.consultaNova.id_mf_ghe = _this4.formData.consultaNova.id_ghe;
          _this4.formData.consultaNova.id_mf_funcao = _this4.formData.consultaNova.id_funcao;
        }

        var filter = {
          id_fdt: _this4.formData.consultaNova.id_fdt,
          id_funcao: _this4.formData.consultaNova.id_funcao,
          id_ghe: _this4.formData.consultaNova.id_ghe,
          periodicidade: _this4.formData.consulta.periodicidade,
          id_funcionario: _this4.formData.consulta.funcionario.id,
          hoje: _this4.$utilidade.toDate(null, true),
          id_tipo_aso: [_this4.formData.consulta.tipo_aso.id],
          pcd: 0,
          show_tabela_preco: 1
        };

        self.post("empresa/consulta/externa/" + _this4.formData.consulta.id + "/alterar", _this4.formData.consultaNova, filter).then(function (result) {
          result = result[0];

          console.log("altear consulta result", result);
          self.$root.$loading.set(false);

          if (result.status == 200) {
            window.open(_this4.env.url_cs + "/app/consulta.php?con=" + result.data.id_con, "_top");
          }
        });
      });
    },
    getFuncao: function getFuncao(_search) {
      var _this5 = this;

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      this.get("/funcao", { search: _search }).then(function (result) {
        result = result[0];

        _this5.config.loading.id_funcao = false;

        if (result.status == 200) {
          _this5.config.list.id_funcao = result.data.data;
        }
      });
    },
    getCredenciada: function getCredenciada(_search) {
      var _this6 = this;

      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get("/credenciada", { search: _search }).then(function (result) {
        result = result[0];

        _this6.config.loading.id_cre = false;

        if (result.status == 200) {
          _this6.config.list.id_cre = result.data.data;
        }
      });
    },
    getEmpresa: function getEmpresa(_search) {
      var _this7 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this7.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this7.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this8 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this8.config.loading.id_funcionario = true;

        if (result.status == 200) {
          _this8.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getFDT: function getFDT() {
      var _this9 = this;

      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, {
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this9.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this9.config.list.id_fdt = result.data.data;
        }
      });
    },
    getConsulta: function getConsulta(_search, _page, _pagination, _loading) {
      var _this10 = this;

      this.loadingTable = true;
      this.response = {};

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-10, null, "D"), true),
            amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcao ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_cre ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + (this.formFilter.agendamento_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta/externa", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this10.response = result;
        _this10.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this10,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var style = "",
                color = "#6fc956",
                title = "Agendamento",
                hoje = _this10.toDate(null, true),
                data_age = _this10.toDate(data[i].data_age, true),
                diff = _this10.diffDays(data_age, hoje);

            if (data[i].id_con) {
              color = "#6fc956";
            } else if (diff > 0) {
              color = "#e07d59";
            } else if (diff == 0) {
              color = "#6fc956";
            } else {
              color = "#7797ef";
            }

            var item = {
              consulta: data[i].id_con ? data[i].id_con : "---",
              credenciada: data[i].credenciada ? data[i].credenciada.nome : null,
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_consulta: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              data_cadastro: _this10.toDate(data[i].created_at, false),
              data_agendamento: data[i].data_age ? _this10.toDate(data[i].data_age, true) : null,
              style: data[i].deleted_at ? 'color:red;"' : "color:" + color,
              _data: data[i],
              options: {
                disable_delete: !_this10.validarPermissao(560),
                disable_edit: !_this10.validarPermissao(559)
              },
              buttons: []
            };

            if (_this10.validarPermissao(559) && data[i].credenciada.padrao == 1 && data[i].tipo_status.id != 194 && data[i].tipo_status.id != 195) {
              if (!data[i].id_con) {
                item.buttons.push({
                  icon: "fa fa-paper-plane",
                  color: "success",
                  title: "Gerar Consulta (Ação necessária para prosseguir com o atendimento)",
                  click: _this10.onGerarConsulta
                });
              } else {
                item.buttons.push({
                  icon: "fa fa-pencil-square-o",
                  color: "primary",
                  title: "Consulta já foi gerada. Clique aqui para abrir a consulta",
                  click: _this10.onEdit
                });
              }
            }

            item.buttons.push({
              icon: "fa fa-info-circle",
              color: "warning",
              title: "Detalhes da consulta",
              click: _this10.onShowConsulta
            });

            tableData.push(item);
          }

          _this10.pagination = pagination;
          _this10.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    funcionario: {
      type: Object,
      default: null
    },
    empresa: {
      type: Object,
      default: null
    },
    id_funcao: {
      type: Number,
      default: null
    }
  },
  watch: {
    funcionario: function funcionario() {
      this.getHistorico();
    },
    empresa: function empresa() {
      this.getHistorico();
    },
    id_funcao: function id_funcao() {
      this.getHistorico();
    }
  },

  data: function data() {
    return {
      formData: {
        historico: null,
        consulta: null,
        exames: []
      },
      pagination: {},
      paginationExame: {},
      response: {},
      tableData: [],
      tableDataExame: [],
      tableHeadExame: [{
        key: 'exame',
        sortable: true,
        show_rea: true,
        show_dem: true,
        show_alt: true,
        label: 'Exame'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }],
      tableHead: [{
        key: 'consulta',
        sortable: true,
        label: 'Consulta',
        width: '90px'
      }, {
        key: 'data',
        sortable: true,
        label: 'Data',
        width: '100px'
      }, {
        key: 'tipo_aso',
        sortable: true,
        label: 'Tipo',
        width: '200px'
      }, {
        key: 'funcao',
        sortable: true,
        label: 'Função'
      }],
      showModal: false,
      loadingTable: false,
      loadingTableExame: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getHistorico();
  },


  methods: {
    onShowExame: function onShowExame(consulta) {
      this.showModal = !this.showModal;
      this.formData.consulta = consulta;
      this.getExame();
    },
    getExame: function getExame(_search, _page, _pagination) {
      var _this = this;

      this.loadingTableExame = true;
      this.formData.exames = [];

      this.get('empresa/consulta/exame/' + this.formData.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        _this.loadingTableExame = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              data: data[i].dt_cad ? _this.toDate(data[i].dt_cad, true) : null,
              valor: data[i].valor,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableDataExame = tableData;
        _this.paginationExame = pagination;
      });
    },
    getHistorico: function getHistorico(_search) {
      var _this2 = this;

      if (!this.funcionario || !this.empresa || !this.funcionario.id) return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var ontem = this.convertDate(this.addDate(-10, null, 'y')),
          amanha = this.convertDate(this.addDate(30, null)),
          filter = {
        id_empresa: this.empresa.id,
        id_funcionario: this.funcionario.id,
        show_con_exa: 1,
        created_at: [ontem, amanha]
      };

      this.get('empresa/consulta', { filter: filter }).then(function (result) {
        result = result[0];

        _this2.response = result;
        _this2.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_aso: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              data: _this2.toDate(data[i].dt_cad, true),
              exames: '',
              _data: data[i],
              buttons: [{
                color: 'primary',
                icon: 'fa fa-search',
                title: 'Ver Exames',
                click: _this2.onShowExame

              }]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this2.tableData = tableData;
        _this2.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmpresaCadastro',
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    id_ghe: {
      type: Number,
      default: null
    }
  },
  watch: {
    id_ghe: function id_ghe() {
      this.getPCMSO();
    }
  },

  data: function data() {
    return {
      formData: {
        pcmso: null
      },
      pagination: {},
      response: {},
      tableData: [],
      tableHead: [{
        key: 'exame',
        sortable: true,
        label: 'Exame'
      }, {
        key: 'adm',
        sortable: true,
        show_html: true,
        label: 'Admissional'
      }, {
        key: 'apos_adm',
        sortable: true,
        show_html: true,
        label: 'Após Admissional'
      }, {
        key: 'dem',
        sortable: true,
        show_html: true,
        label: 'Demissional'
      }, {
        key: 'ret_tra',
        sortable: true,
        show_html: true,
        label: 'Retorno ao Trabalho'
      }, {
        key: 'mud_fun',
        sortable: true,
        show_html: true,
        label: 'Mudança de Função'
      }, {
        key: 'periodicidade',
        sortable: true,
        show_html: true,
        label: 'Periódico'
      }, {
        key: 'validade',
        sortable: true,
        show_html: true,
        label: 'Validade'
      }],
      showModal: false,
      loadingTable: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getPCMSO();
  },


  methods: {
    getPCMSO: function getPCMSO() {
      var _this = this;

      if (!this.id_ghe) return;

      this.loadingTable = true;
      this.formData.pcmso = null;
      this.response = {};

      this.get('pcmso/ghe/exame/' + this.id_ghe).then(function (result) {
        result = result[0];

        _this.response = result;
        _this.loadingTable = false;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {

          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var periodicidade = data[i].periodicidade != '0' ? '<span style="color:green">' + data[i].periodicidade + ' meses</span>' : '<span style="color:red">Não</span>';

            if (data[i].per_id1 != '0') {
              periodicidade += "<span style='color:green'>\nA partir dos " + data[i].per_id1 + " anos</span>";
            }

            if (data[i].per_id2 != '0') {
              periodicidade += "<span style='color:green'>\nAté os  " + data[i].per_id2 + " anos</span>";
            }

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              validade: data[i].validade > 0 ? data[i].validade + ' dias' : '---',
              adm: data[i].adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              apos_adm: data[i].apos_adm != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              dem: data[i].dem != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              ret_tra: data[i].ret_tra != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              mud_fun: data[i].mud_fun != '0' ? '<span style="color:green">Sim</span>' : '<span style="color:red">Não</span>',
              periodicidade: periodicidade,
              _data: data[i],
              buttons: []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        _this.tableData = tableData;
        _this.pagination = pagination;
      });
    }
  }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_fct__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_5_common_fct___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showDownloadASO': function parentShowDownloadASO() {
			this.getConsultaEmail();
		},
		'parent.consulta.id': function parentConsultaId() {
			this.getConsultaEmail();
		}
	},
	data: function data() {
		return {
			pagination: {},
			error: {},
			tableHead: [{
				key: 'data',
				sortable: true,
				width: '120px',
				label: 'Data'
			}, {
				key: 'usuario',
				sortable: true,
				label: 'Usuário'
			}, {
				key: 'lote',
				sortable: true,
				width: '55px',
				label: 'Lote'
			}, {
				key: 'consulta',
				sortable: true,
				show_tipo_aso: true,
				show_consulta_link: true,
				label: 'Consulta'
			}, {
				key: 'remetente',
				sortable: true,
				label: 'Remetente'
			}, {
				key: 'destinatario',
				sortable: true,
				show_html: true,
				label: 'Destinatário'
			}, {
				key: 'obs',
				sortable: true,
				limit: 20,
				label: 'Obs'
			}, {
				key: 'documento',
				sortable: true,
				show_html: true,
				label: 'Documento'
			}, {
				key: 'status',
				sortable: true,
				show_status: true,
				label: 'Status'
			}],
			tableData: [],
			loadingTable: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getConsultaEmail();

		this.$events.on('onClienteEvent', function (eventData) {
			_this.getConsultaEmail();
		});

		this.$on('onTabHistoricoOpened', function () {
			_this.getConsultaEmail();
		});
	},

	methods: {
		delay: function delay(ms) {
			return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
				return setTimeout(resolve, ms);
			});
		},


		getConsultaEmail: function () {
			var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_search, _page, _pagination) {
				var _this2 = this;

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.loadingTable = true;

								_context.next = 3;
								return this.delay(500);

							case 3:

								this.get('empresa/consulta/email/' + (this.parent.consulta ? this.parent.consulta.id_con : 0), { search: _search, page: _page, pagination: _pagination }).then(function (result) {

									result = result[0];

									if (result.status == 200) {
										_this2.formataData(result);
									}
								});

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getConsultaEmail(_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			}

			return getConsultaEmail;
		}(),

		formataData: function formataData(result) {
			var data = result.data.data,
			    tableData = [],
			    self = this,
			    pagination = result.data;

			for (var i = 0; i < data.length; i++) {

				var fdt = data[i].fdt ? data[i].fdt.pcmso + ' (' + data[i].fdt.descricao + ')' : '',
				    select_pages = '';

				var arr = data[i].destinatario.split(';'),
				    destinatario = '',
				    msg = '';

				for (var j = 0; j < arr.length; j++) {
					var title = '';

					if (data[i].abertura && data[i].abertura[arr[j]]) {
						var abertura = data[i].abertura[arr[j]],
						    aux = 'Email visualizado em ' + this.toDate(abertura.data) + '\n' + 'Endereço IP ' + abertura.ip;

						title = '<i class="fa fa-eye" title="' + aux + '"></i> ';
					}
					destinatario += '<span>' + title + arr[j] + '</span><br>';
				}

				if (data[i].abertura && data[i].abertura.data) {
					abertura = '<span style="color:red;font-size:7pt"><br><br>Email Visualizado em: ' + this.toDate(data[i].abertura.data, false);
					abertura += '<br>Endereço IP: ' + data[i].abertura.ip + '</span>';
				}

				if (data[i].msg) {
					msg = '<span style="color:red;font-size:7pt" title="' + data[i].msg + '"><i class="fa fa-exclamation-triangle"></i></span> ';
				}

				if (data[i].select_pages) {
					select_pages = '<br><span style="color:red;font-size:7.5pt">Páginas selecionadas: ' + data[i].select_pages.join(',') + '</span>';
				}

				var item = {
					'data': this.toDate(data[i].created_at, false),
					'usuario': data[i].usuario ? data[i].usuario.usuario : null,
					'lote': data[i].lote,
					'obs': data[i].obs,
					'remetente': data[i].remetente,
					'destinatario': destinatario,
					'documento': data[i].tipo_documento ? data[i].tipo_documento.descricao + select_pages : null,
					'status': data[i].msg,
					'consulta': data[i].id_con,
					_data: data[i],
					options: {},
					buttons: []
				};

				tableData.push(item);
			}

			this.pagination = pagination;
			this.tableData = tableData;
			this.loadingTable = false;
		}
	}
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__download_aso_email__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__download_aso_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__download_aso_email__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a,
    Download: __WEBPACK_IMPORTED_MODULE_6_common_download___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_7_common_modal___default.a,
    DownloadAsoEmail: __WEBPACK_IMPORTED_MODULE_8__download_aso_email___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_5_common_fct___default.a, __WEBPACK_IMPORTED_MODULE_6_common_download___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showDownloadASO": function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.formData.obs = null;
                this.tagConfig = "tab-cadastro";

                _context.next = 4;
                return this.delay(500);

              case 4:

                if (this.parent.consulta) {
                  this.formData = {
                    destinatario: this.parent.consulta.empresa.email,
                    consultas: [this.parent.consulta],
                    id_emp: this.parent.consulta.empresa.id,
                    id_fun: null,
                    obs: null,
                    todos: false,
                    tipo_documento: [82]
                  };
                  this.lstConsulta = [this.parent.consulta];
                  this.lstEmpresa = [this.parent.consulta.empresa];
                  this.empresa = this.parent.consulta.empresa;
                } else {
                  this.inicialize();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parentShowDownloadASO() {
        return _ref.apply(this, arguments);
      }

      return parentShowDownloadASO;
    }(),
    "parent.consulta.id": function parentConsultaId() {
      if (this.parent.consulta) {
        this.formData = {
          destinatario: this.parent.consulta.empresa.email,
          consultas: [this.parent.consulta],
          id_emp: this.parent.consulta.empresa.id,
          id_fun: null,
          obs: null,
          todos: false,
          tipo_documento: [82]
        };
        this.lstConsulta = [this.parent.consulta];
        this.lstEmpresa = [this.parent.consulta.empresa];
        this.empresa = this.parent.consulta.empresa;
      } else {
        this.inicialize();
      }
    }
  },
  data: function data() {
    return {
      formData: {
        destinatario: null,
        todos: false,
        id_emp: null,
        id_fun: null,
        obs: null,
        consultas: [],
        tipo_documento: [82]
      },
      empresa: null,
      pagination: {},
      error: {},
      tableHead: [{
        key: "data",
        sortable: true,
        width: "120px",
        label: "Data"
      }, {
        key: "usuario",
        sortable: true,
        label: "Usuário"
      }, {
        key: "lote",
        sortable: true,
        width: "55px",
        label: "Lote"
      }, {
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "destinatario",
        sortable: true,
        show_html: true,
        label: "Destinatário"
      }, {
        key: "obs",
        sortable: true,
        limit: 20,
        label: "Obs"
      }, {
        key: "documento",
        sortable: true,
        show_html: true,
        label: "Documento"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstConsulta: [],
      lstTipoDocumento: [],
      loadingFuncionario: false,
      loadingConsulta: false,
      loadingEmpresa: false,
      loadingEditAll: false,
      loadingTable: false,
      loadingSave: false,
      novaLiberacao: false,
      tagConfig: "tab-cadastro"
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getEmpresa();
    this.getTipo();
    this.inicialize();
  },

  methods: {
    delay: function delay(ms) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },


    inicialize: function inicialize() {
      this.formData = {
        destinatario: null,
        id_emp: null,
        id_fun: null,
        consultas: [],
        todos: false,
        obs: null,
        tipo_documento: [82]
      };
      this.lstConsulta = [];
      this.empresa = null;
    },

    handleClick: function handleClick(tab, event) {
      this.novaLiberacao = false;
    },


    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.loadingEmpresa = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1
      };

      this.get("/empresa", {
        search: _search,
        filter: filter
      }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this.lstEmpresa = result.data.data;
        } else {
          _this.lstEmpresa = [];
        }

        _this.loadingEmpresa = false;
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      if (!this.formData.id_emp) return;

      this.loadingFuncionario = true;
      this.lstFuncionario = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this2.loadingFuncionario = false;

        if (result.status == 200) {
          _this2.lstFuncionario = result.data.data;
        }
      });
    },

    getConsulta: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_search) {
        var _this3 = this;

        var hoje, ontem, amanha, filter;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.empresa) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:

                this.formData.id_emp = this.empresa.id;
                this.formData.destinatario = this.empresa.email;

                if (this.formData.id_emp) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:

                this.loadingConsulta = true;
                this.lstConsulta = [];

                hoje = this.toDate(null, true), ontem = this.toDate(this.addDate(-365 * 2, null, "D"), true), amanha = this.toDate(this.addDate(1, null, "D"), true);
                filter = {
                  id_empresa: this.formData.id_emp,
                  with_arquivo: 1,
                  created_at: [ontem, amanha]
                };
                _context2.next = 12;
                return this.delay(500);

              case 12:

                this.get("/empresa/consulta", {
                  filter: filter,
                  pagination: 1000
                }).then(function (result) {
                  result = result[0];

                  _this3.loadingConsulta = false;

                  if (result.status == 200) {
                    _this3.lstConsulta = result.data.data;
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getConsulta(_x) {
        return _ref2.apply(this, arguments);
      }

      return getConsulta;
    }(),

    getTipo: function getTipo() {
      var _this4 = this;

      this.post("tipo/parent", {
        codigo: [81],
        exclude: [84, 88]
      }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this4.lstTipoDocumento = result.data["81"];
        }
      });
    },

    salvar: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.loadingSave = true;

                this.post("empresa/consulta/email/" + (this.parent.consulta ? this.parent.consulta.id_con : 0) + "/cadastrar", this.formData).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            result = result[0];

                            _this5.loadingSave = false;

                            if (!(result.status == 200)) {
                              _context3.next = 10;
                              break;
                            }

                            _this5.$message({
                              message: "Email cadastrado com sucesso! O envio pode levar alguns minutos para ser realizado. Por favor aguarde!",
                              type: "success"
                            });

                            _this5.error = {};
                            _this5.novaLiberacao = true;
                            _this5.tagConfig = "tab-historico";

                            _context3.next = 9;
                            return _this5.delay(500);

                          case 9:

                            _this5.$refs.downloadAsoEmailComponent.getConsultaEmail();

                          case 10:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this5);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function salvar() {
        return _ref3.apply(this, arguments);
      }

      return salvar;
    }()

  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "historico-whatsapp",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    endpoint: {
      type: String,
      default: "empresa/consulta/liberacao"
    },
    idAntesDoSufixo: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      showModal: false,
      historico: [],
      idRecurso: null
    };
  },

  computed: {
    titulo: function titulo() {
      return "HISTÓRICO DE NOTIFICAÇÕES WHATSAPP" + (this.idRecurso ? " - " + this.idRecurso : "");
    }
  },
  watch: {
    "parent.showHistoricoWhatsapp": function parentShowHistoricoWhatsapp(val) {
      this.showModal = val;
      if (val) {
        this.buscar();
      }
    },
    showModal: function showModal(val) {
      if (!val) {
        this.parent.showHistoricoWhatsapp = false;
      }
    }
  },
  methods: {
    descricaoTemplate: function descricaoTemplate(template) {
      var mapa = {
        assinar_aso: "Assinatura de ASO",
        lembrete_assinar_aso: "Lembrete de assinatura",
        atualizar_matricula_contador: "Atualizar matrícula (contador)"
      };
      return mapa[template] || template;
    },
    corStatus: function corStatus(status) {
      var mapa = {
        agendado: "warning",
        enviado: "success",
        cancelado: "info",
        falhou: "danger"
      };
      return mapa[status] || "info";
    },
    buscar: function buscar() {
      var _this = this;

      this.idRecurso = this.parent.historicoWhatsappId;

      if (!this.idRecurso) return;

      this.loading = true;

      var url = this.idAntesDoSufixo ? this.endpoint + "/" + this.idRecurso + "/historico-whatsapp" : this.endpoint + "/" + this.idRecurso;

      this.get(url).then(function (result) {
        result = result[0];
        _this.loading = false;

        if (result.status == 200 && result.data) {
          _this.historico = result.data;
        } else {
          _this.historico = [];
        }
      }).catch(function (e) {
        console.log(e);
        _this.loading = false;
        _this.historico = [];
      });
    }
  }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "lembrete-assinatura",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      loadingSave: false,
      showModal: false
    };
  },

  watch: {
    "parent.showLembreteAssinatura": function parentShowLembreteAssinatura(val) {
      this.showModal = val;
    },
    showModal: function showModal(val) {
      if (!val) {
        this.parent.showLembreteAssinatura = false;
      }
    }
  },
  computed: {
    descricao: function descricao() {
      if (!this.parent.consulta) return "";
      var funcionario = this.parent.consulta.funcionario ? this.parent.consulta.funcionario.nome : "o funcionário";
      return "Deseja reenviar o lembrete de assinatura digital do ASO da consulta " + this.parent.consulta.id_con + " para " + funcionario + "?";
    }
  },
  methods: {
    enviar: function enviar() {
      var _this = this;

      var consulta = this.parent.consulta;
      var telefone = consulta.funcionario ? consulta.funcionario.tel_cel : null;
      var nome = consulta.funcionario ? consulta.funcionario.nome : null;

      if (!telefone) {
        this.$notify({
          title: "Erro",
          message: "Funcionário não possui celular cadastrado.",
          type: "error"
        });
        return;
      }

      var url = "/" + this.cliente.logged.url + "/funcionario/aso/assinar/" + consulta.id_con;

      this.loadingSave = true;

      this.post("/" + this.cliente.logged.url + "/funcionario/aso/disparar-whatsapp-lembrete-assinar", {
        telefone: telefone,
        nome: nome,
        url: url,
        id_con: consulta.id_con
      }).then(function (result) {
        result = result[0];
        _this.loadingSave = false;

        if (result.status == 200 && result.data && result.data.success) {
          _this.$notify({
            title: "Sucesso",
            message: "Lembrete de assinatura reenviado com sucesso!",
            type: "success"
          });
        } else {
          _this.$notify({
            title: "Erro",
            message: "Não foi possível reenviar o lembrete. Tente novamente. Se o erro persistir contate o suporte.",
            type: "error"
          });
        }

        _this.showModal = false;
      }).catch(function (e) {
        console.log(e);
        _this.loadingSave = false;
        _this.$notify({
          title: "Erro",
          message: "Não foi possível reenviar o lembrete. Tente novamente.",
          type: "error"
        });
        _this.showModal = false;
      });
    }
  }
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_liberacao_aso__ = __webpack_require__(952);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.consulta.id": function parentConsultaId() {
      this.carregarDados();
    },
    "parent.showLiberacao": function parentShowLiberacao() {
      this.carregarDados();
    },
    "formData.aptidao": function formDataAptidao() {
      this.handleAptidao();
    }
  },
  data: function data() {
    return {
      trabalhosEspeciais: [],
      config: {
        tipo: [53, 185, 189],
        click: {
          exames: _.debounce(this.getExame, 1000)
        },
        list: {
          exames: []
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false
        },
        disabled: {
          id_tipo_status: false,
          obs: false
        }
      },
      formData: {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        obs: null,
        arquivo: null,
        exames: []
      },
      pagination: {},
      response: {},
      tableHead: [],
      tableData: [],
      formItems: [],
      novaLiberacao: false,
      tagConfig: "tab-cadastro",
      title: ""
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.montarTableHead();
  },

  computed: {
    asoLiberada: function asoLiberada() {
      return this.parent && this.parent.consulta && this.parent.consulta.tipo_status && this.parent.consulta.tipo_status.id === 66;
    },
    asoNaoAssinada: function asoNaoAssinada() {
      return this.parent && this.parent.consulta && !this.parent.consulta.pgr_docs_aso;
    },
    asoSemUploadOuConfig: function asoSemUploadOuConfig() {
      if (!this.parent || !this.parent.consulta) return false;
      var consulta = this.parent.consulta;
      var temUpload = !!consulta.arquivo_aso;
      var empresaConfigurada = consulta.empresa && consulta.empresa.aso_sign == 1 && consulta.empresa.aso_assinatura == 1;
      return !temUpload && !empresaConfigurada;
    }
  },

  methods: {
    handleClick: function handleClick(tab, event) {
      this.novaLiberacao = false;
    },


    carregarDados: function carregarDados() {
      var _this = this;

      if (!this.parent.consulta) return;

      var id_emp = this.parent.consulta.empresa ? this.parent.consulta.empresa.id : null;

      if (!id_emp) {
        this.getConsulta();
        this.getConsultaLiberacao();
        return;
      }

      this.config.loading.content = true;

      this.get("empresa/" + id_emp + "/trabalho-especial").then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this.trabalhosEspeciais = result.data || [];
        } else {
          _this.trabalhosEspeciais = [];
        }

        _this.montarFormItems();
        _this.montarFormData();
        _this.montarDisabled();
        _this.montarTableHead();
        _this.getConsulta();
        _this.getConsultaLiberacao();
      });
    },

    montarFormItems: function montarFormItems() {
      var baseItems = __WEBPACK_IMPORTED_MODULE_5__form_liberacao_aso__["a" /* default */].slice();
      var teItems = [];

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        var te = this.trabalhosEspeciais[i];
        teItems.push({
          class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
          type: 'select-tipo',
          field: te.field,
          label: te.label,
          valor: 'valor',
          tipo: te.tipo,
          rules: ['required']
        });
      }

      this.formItems = [baseItems[0]].concat(teItems, baseItems.slice(1));
    },

    montarFormData: function montarFormData() {
      var formData = {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        obs: null,
        arquivo: null,
        exames: []
      };

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        formData[this.trabalhosEspeciais[i].field] = null;
      }

      this.formData = formData;
    },

    montarDisabled: function montarDisabled() {
      var disabled = {
        id_tipo_status: false,
        obs: false
      };

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        disabled[this.trabalhosEspeciais[i].field] = false;
      }

      this.$set(this.config, 'disabled', disabled);
    },

    montarTableHead: function montarTableHead() {
      var head = [{ key: "data", sortable: true, width: "120px", label: "Data" }, { key: "usuario", sortable: true, label: "Usuário" }, { key: "status", sortable: true, label: "Status" }, { key: "aptidao", sortable: true, show_html: true, label: "Aptidão" }];

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        var te = this.trabalhosEspeciais[i];
        head.push({
          key: "te_" + te.field,
          sortable: true,
          show_html: true,
          label: te.label
        });
      }

      head.push({ key: "exames", sortable: true, label: "Exames Alterados" });
      head.push({ key: "obs", sortable: true, label: "Obs" });

      this.tableHead = head;
    },

    handleAptidao: function handleAptidao() {
      this.config.disabled.id_tipo_status = this.formData.aptidao == "2" || this.formData.aptidao == "5";

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        this.$set(this.config.disabled, this.trabalhosEspeciais[i].field, this.formData.aptidao == "5");
      }

      if (this.formData.aptidao == "1") {
        this.formData.id_tipo_status = 66;
      } else if (this.formData.aptidao == "2") {
        this.formData.id_tipo_status = 67;
      } else if (this.formData.aptidao == "5") {
        this.formData.id_tipo_status = 70;
      }
    },
    getExame: function getExame() {},


    getConsulta: function getConsulta() {
      var _this2 = this;

      if (!this.parent.consulta) return;

      this.config.loading.content = true;
      this.config.list.exames = [];

      this.get("empresa/consulta/" + this.parent.consulta.id_con).then(function (result) {
        result = result[0];
        _this2.config.loading.content = false;

        if (result.status == 200) {
          var formData = {
            id_tipo_status: result.data.tipo_status ? result.data.tipo_status.id : null,
            aptidao: _this2.toString(result.data.aptidao) == "0" ? null : _this2.toString(result.data.aptidao),
            obs: result.data.obs,
            exames: []
          };

          for (var i = 0; i < _this2.trabalhosEspeciais.length; i++) {
            var field = _this2.trabalhosEspeciais[i].field;
            formData[field] = _this2.toString(result.data[field]) == "0" ? null : _this2.toString(result.data[field]);
          }

          _this2.formData = formData;

          for (var i = 0; i < result.data.exames.length; i++) {
            var element = result.data.exames[i];

            if (element.dem == 0) {
              _this2.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },

    getConsultaLiberacao: function getConsultaLiberacao(_search, _page, _pagination) {
      var _this3 = this;

      if (!this.parent.consulta) return;

      this.config.loading.table = true;
      this.tagConfig = "tab-cadastro";
      this.title = " Nº " + this.parent.consulta.id_con + " - " + this.parent.consulta.empresa.nome + " - " + this.parent.consulta.funcionario.nome;

      this.get("empresa/consulta/liberacao/" + this.parent.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this3.formataData(result);
        }
      });
    },

    formatarTeIcon: function formatarTeIcon(valor) {
      if (valor == "1") return '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
      if (valor == "2") return '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
      if (valor == "3") return '<i title="N/A">-</i>';
      return "";
    },

    formataData: function formataData(result) {
      var data = result.data.data,
          tableData = [],
          self = this,
          pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var aptidao = "";

        if (data[i].aptidao == "1") aptidao = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO PARA A FUNÇÃO"/>';else if (data[i].aptidao == "2") aptidao = '<i class="fa fa-exclamation-triangle fa-2x" style="color:orange" title="APTO COM RESTRIÇÕES"/>';else if (data[i].aptidao == "5" || data[i].aptidao == "6") aptidao = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO PARA A FUNÇÃO"/>';

        var item = {
          data: this.toDate(data[i].created, false),
          usuario: data[i].usuario ? data[i].usuario.usuario : null,
          status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
          aptidao: aptidao,
          exames: data[i].exame_alt ? data[i].exame_alt.join(", ") : "",
          obs: data[i].obs,
          _data: data[i],
          options: {},
          buttons: []
        };

        for (var j = 0; j < this.trabalhosEspeciais.length; j++) {
          var te = this.trabalhosEspeciais[j];
          item["te_" + te.field] = this.formatarTeIcon(data[i][te.field]);
        }

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.config.loading.table = false;
    },

    salvar: function salvar() {
      var _this4 = this;

      this.$confirm("Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this4.config.loading.save = true;
        _this4.response = {};

        _this4.post("empresa/consulta/liberacao/" + _this4.parent.consulta.id_con + "/cadastrar", _this4.formData).then(function (result) {
          result = result[0];
          _this4.response = result;

          _this4.config.loading.save = false;

          if (result.status == 200) {
            _this4.edMsg("Liberação cadastrado com sucesso!");

            _this4.novaLiberacao = true;
            _this4.tagConfig = "tab-historico";

            _this4.formataData(result);
            _this4.getConsulta();
            _this4.parent.getConsulta();
          }
        });
      });
    }

  }
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_upload__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Upload: __WEBPACK_IMPORTED_MODULE_4_common_upload___default.a, UploadPagina: __WEBPACK_IMPORTED_MODULE_5__upload_pagina_aso___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_4_common_upload___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showUploadASO': function parentShowUploadASO() {
			this.getConsultaUpload();
			this.tagConfig = 'tab-cadastro';

			this.formData = {
				tipo: 86,
				documento: 82,
				juntar: 1,
				id_emp: null,
				id_fun: null,
				id_con: null,
				arquivo: null
			};
		}
	},
	data: function data() {
		return {
			formData: {
				tipo: 86,
				documento: 82,
				juntar: 1,
				id_emp: null,
				id_fun: null,
				id_con: null,
				arquivo: null
			},
			pagination: {},
			error: {},
			upload_pagina: null,
			tableHead: [{
				key: 'data',
				sortable: true,
				width: '120px',
				label: 'Data'
			}, {
				key: 'usuario',
				sortable: true,
				label: 'Usuário'
			}, {
				key: 'lote',
				sortable: true,
				width: '55px',
				label: 'Lote'
			}, {
				key: 'arquivo',
				sortable: true,
				show_arquivo: true,
				label: 'Arquivo'
			}, {
				key: 'tipo',
				sortable: true,
				label: 'Tipo'
			}, {
				key: 'status',
				sortable: true,
				show_status: true,
				label: 'Status'
			}],
			tableData: [],
			lstTipoStatus: [],
			lstTipoDocumento: [],
			lstTipoUpload: [],
			lstEmpresa: [],
			lstFuncionario: [],
			lstConsulta: [],
			loadingFuncionario: false,
			loadingConsulta: false,
			loadingEmpresa: false,
			loadingEditAll: false,
			loadingTable: false,
			loadingSave: false,
			showUploadPagina: false,
			novaLiberacao: false,
			tagConfig: 'tab-cadastro',
			title: ''

		};
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getEmpresa();
		this.getTipo();
		this.getConsultaUpload();

		this.$events.on('onClienteEvent', function (eventData) {
			_this.getConsultaUpload();
		});
	},

	methods: {
		handleClick: function handleClick(tab, event) {
			this.novaLiberacao = false;
		},
		handleAptidao: function handleAptidao() {
			if (this.formData.aptidao == 2) {
				this.formData.id_tipo_status = 67;
			}

			if (this.formData.aptidao == 5) {
				this.formData.te_alt = 0;
				this.formData.te_esp = 0;
				this.formData.te_ele = 0;
				this.formData.te_ali = 0;
				this.formData.te_rad_ion = 0;
				this.formData.id_tipo_status = 70;
			}
		},
		handleArquivo: function handleArquivo(e) {
			e.preventDefault();
			this.formData.arquivo = e.target.files[0];
		},


		onUploadPagina: function onUploadPagina(data) {
			this.upload_pagina = data;
			this.showUploadPagina = !this.showUploadPagina;
		},

		onUploadEditar: function onUploadEditar(data) {

			var self = this;

			this.$confirm('Tem certeza que deseja processar o lote ' + data.lote + ' novamente?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				self.get('/empresa/consulta/upload/editar/' + data.id).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getConsultaUpload();
						self.edMsg('Arquivo processado com sucesso. Verifique o status do processamento abaixo.');
					} else {
						self.edAlert(result.msg, 'error');
					}
				});
			});
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;
				self.loadingTable = true;

				_this2.post('/empresa/consulta/upload/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;
					self.loadingTable = false;

					if (result.status == 200) {

						_this2.formataData(result);

						_this2.$message({
							message: 'Registo excluido com sucesso',
							type: 'success'
						});
					} else {
						if (result.status == 403) {
							_this2.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
								confirmButtonText: 'OK'
							});
						} else {
							_this2.$message({
								message: result.msg,
								type: 'error'
							});
						}
					}
				});
			});
		},

		getTipo: function getTipo() {
			var _this3 = this;

			this.post('tipo/parent', { codigo: [81, 85], exclude: [84, 88] }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this3.lstTipoDocumento = result.data['81'];
					_this3.lstTipoUpload = result.data['85'];
				}
			});
		},

		getEmpresa: function getEmpresa(_search) {
			var _this4 = this;

			this.loadingEmpresa = true;

			this.get('/empresa', { search: _search }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this4.lstEmpresa = result.data.data;
				} else {
					_this4.lstEmpresa = [];
				}

				_this4.loadingEmpresa = false;
			});
		},

		getFuncionario: function getFuncionario(_search) {
			var _this5 = this;

			if (!this.formData.id_emp) return;

			this.loadingFuncionario = true;
			this.lstFuncionario = [];

			this.get('/empresa/funcionario/' + this.formData.id_emp, { search: _search }).then(function (result) {

				result = result[0];

				_this5.loadingFuncionario = false;

				if (result.status == 200) {
					_this5.lstFuncionario = result.data.data;
				}
			});
		},

		getConsulta: function getConsulta(_search) {
			var _this6 = this;

			if (!this.formData.id_fun || !this.formData.id_emp) return;

			this.loadingConsulta = true;
			this.lstConsulta = [];

			var hoje = this.toDate(null, true),
			    ontem = this.toDate(this.addDate(-365 * 2, null, 'D'), true),
			    amanha = this.toDate(this.addDate(1, null, 'D'), true);

			var filter = {
				id_funcionario: this.formData.id_fun,
				id_empresa: this.formData.id_emp,
				created_at: [ontem, amanha]
			};

			this.get('/empresa/consulta', { filter: filter }).then(function (result) {

				result = result[0];

				_this6.loadingConsulta = false;

				if (result.status == 200) {
					_this6.lstConsulta = result.data.data;
				}
			});
		},

		getConsultaUpload: function getConsultaUpload(_search, _page, _pagination) {
			var _this7 = this;

			this.loadingTable = true;

			this.get('empresa/consulta/upload', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];

				if (result.status == 200) {
					_this7.formataData(result);
				} else {
					_this7.$alert(result.msg, 'Atenção', {
						type: 'error',
						confirmButtonText: 'OK'
					});
				}
			});
		},

		formataData: function formataData(result) {

			var data = result.data.data,
			    tableData = [],
			    self = this,
			    pagination = result.data;

			for (var i = 0; i < data.length; i++) {

				var item = {
					'data': this.toDate(data[i].created_at, false),
					'usuario': data[i].usuario ? data[i].usuario.usuario : null,
					'tipo': data[i].tipo_upload ? data[i].tipo_upload.descricao.toUpperCase() : null,
					'lote': data[i].lote,
					'arquivo': data[i].arquivo,
					'status': data[i].obs,
					_data: data[i],
					options: {},
					buttons: []
				};

				item.buttons.push({
					icon: 'fa fa-files-o',
					color: 'success',
					title: 'Visualizar detalhes das páginas do arquivo',
					click: this.onUploadPagina
				});

				if (data[i].tipo_status && data[i].tipo_status.id == '80') {
					item.buttons.push({
						icon: 'fa fa-cloud-upload',
						color: 'warning',
						title: 'Processar Arquivo Novamente',
						click: this.onUploadEditar
					});
				}

				tableData.push(item);
			}

			this.pagination = pagination;
			this.tableData = tableData;
			this.loadingTable = false;
		},

		salvar: function salvar() {
			var _this8 = this;

			this.loadingSave = true;
			this.error = {};

			this.post('empresa/consulta/upload/cadastrar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this8.loadingSave = false;

				if (result.status == 200) {

					_this8.edMsg('Documento cadastrado com sucesso!');

					_this8.error = {};
					_this8.novaLiberacao = true;
					_this8.tagConfig = 'tab-historico';

					_this8.formataData(result);
					_this8.parent.getConsulta();
				}
			});
		}

	}
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_upload_pagina_editar__ = __webpack_require__(954);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_3_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_7_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_5_common_button___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_6_common_alert___default.a, Download: __WEBPACK_IMPORTED_MODULE_2_common_download___default.a, DownloadAsoEmail: __WEBPACK_IMPORTED_MODULE_8_apps_web_consulta_liberacao_includes_download_aso_email___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showUploadPagina": function parentShowUploadPagina() {
      this.getConsultaUploadPagina();
    },
    "parent.upload_pagina.id": function parentUpload_paginaId() {
      this.getConsultaUploadPagina();
    },
    "formDataEdit.id_emp": function formDataEditId_emp() {
      this.getFuncionario();
      this.config.disabled.id_fun = this.formDataEdit.id_emp ? false : true;
    },
    "formDataEdit.id_fun": function formDataEditId_fun() {
      this.getConsulta();
      this.config.disabled.id_con = this.formDataEdit.id_fun ? false : true;
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      formDataEdit: {
        id: 0,
        id_emp: null,
        id_fun: null,
        id_con: null,
        usuario: null,
        updated_at: null
      },
      config: {
        click: {
          id_emp: _.debounce(this.getEmpresa, 1000),
          id_fun: _.debounce(this.getFuncionario, 1000),
          id_con: _.debounce(this.getConsulta, 1000)
        },
        loading: {
          id_emp: false,
          id_fun: false,
          id_con: false,
          save: false
        },
        list: {
          id_emp: [],
          id_fun: [],
          id_con: []
        },
        disabled: {
          id_fun: true,
          id_con: true,
          page: true
        }
      },
      consulta: null,
      tagConfig: "tab-detalhe",
      tableHead: [{
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_link_consulta: true,
        label: "Consulta"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_link_empresa: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcionario_link: true,
        show_funcao: true,
        label: "Funcionário"
      }, {
        key: "pagina",
        sortable: true,
        width: "90px",
        label: "Página"
      }, {
        key: "arquivo",
        sortable: true,
        show_arquivo: true,
        label: "Arquivo"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }],
      tableData: [],
      tableDataEmail: [],
      formItemsEdit: [],
      loadingTable: false,
      showEnviarEmail: false,
      showFormEdit: false,
      showDownloadASO: false,
      loadingEmailSave: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItemsEdit = __WEBPACK_IMPORTED_MODULE_9__form_upload_pagina_editar__["a" /* default */];
    this.getEmpresa();
  },

  methods: {
    onArquivoEmail: function onArquivoEmail(item) {
      var data = [],
          tableDataEmail = {},
          formData = {};

      if (item && item.id) {
        data.push(item);
      } else {
        data = item;

        try {
          data = data.sort(function (a, b) {
            return a.empresa.nome > b.empresa.nome ? 1 : b.empresa.nome > a.empresa.nome ? -1 : 0;
          });
        } catch (error) {
          data = item;
        }
      }

      this.showEnviarEmail = !this.showEnviarEmail;

      for (var i = 0; i < data.length; i++) {
        var element = data[i];

        if (!element.id_con) continue;

        if (!tableDataEmail[element.empresa.nome]) {
          tableDataEmail[element.empresa.nome] = [];
          formData[element.empresa.id] = {
            destinatario: element.empresa.email,
            consultas: [],
            obs: null,
            error: null
          };
        }

        if (element.tipo_documento && element.tipo_documento.id == "82") {
          formData[element.empresa.id].consultas.push(element.id_con);
        }

        tableDataEmail[element.empresa.nome].push(element);
      }

      this.tableDataEmail = tableDataEmail;
      this.formData = formData;
    },
    onEdit: function onEdit(data) {
      this.formDataEdit = {
        id: data.id,
        page: data.page,
        id_emp: data.empresa ? data.empresa.id : null,
        id_fun: data.funcionario ? data.funcionario.id : null,
        id_con: data.id_con,
        usuario: data.usuario,
        updated_at: this.toDate(data.updated_at)
      };

      if (data.empresa) {
        this.config.list.id_emp = [data.empresa];
      }

      if (data.funcionario) {
        this.getFuncionario(data.funcionario.nome);
      }

      if (data.id_con) {
        this.getConsulta();
      }

      this.showFormEdit = !this.showFormEdit;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_emp = false;

        if (result.status == 200) {
          _this.config.list.id_emp = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      if (!this.formDataEdit.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formDataEdit.id_emp, { search: _search, pagination: 500 }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fun = false;

        if (result.status == 200) {
          _this2.config.list.id_fun = result.data.data;
        }
      });
    },
    getConsulta: function getConsulta(_search) {
      var _this3 = this;

      if (!this.formDataEdit.id_emp || !this.formDataEdit.id_fun) return;

      this.config.loading.id_con = true;
      this.config.list.id_con = [];

      var filter = {
        id_empresa: this.formDataEdit.id_emp,
        id_funcionario: this.formDataEdit.id_fun
      };

      this.get("empresa/consulta", { search: _search, filter: filter, pagination: 500 }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_con = false;

        if (result.status == 200) {
          _this3.config.list.id_con = result.data.data;
        }
      });
    },
    getConsultaUploadPagina: function getConsultaUploadPagina(_search, _page, _pagination) {
      var _this4 = this;

      if (!this.parent.upload_pagina) return;

      this.loadingTable = true;

      var filter = {
        id_tipo_email: [197],
        show_emp_email: 1
      };

      this.get("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id, { search: _search, page: _page, pagination: _pagination, filter: filter }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this4.formataData(result);
        } else {
          _this4.$alert(result.msg, "Atenção", {
            type: "error",
            confirmButtonText: "OK"
          });
        }
      });
    },


    formataData: function formataData(result) {
      var data = result.data.data,
          tableData = [],
          self = this,
          pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var send_email = "";

        if (data[i].send_email_at) {
          send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + this.toDate(data[i].send_email_at) + '"/>';
        }

        var item = {
          consulta: (data[i].id_con ? data[i].id_con : "---") + (send_email ? send_email : ""),
          empresa: data[i].empresa ? data[i].empresa.nome : "---",
          funcionario: data[i].funcionario ? data[i].funcionario.nome : "---",
          arquivo: data[i].arquivo ? data[i].arquivo : "---",
          pagina: data[i].page + " de " + data[i].pages,
          status: data[i].obs ? data[i].obs : "",
          _data: data[i],
          options: {},
          buttons: []
        };

        if (data[i].arquivo && data[i].tipo_status && (data[i].tipo_status.id == "79" || data[i].tipo_status.id == "193") && data[i].tipo_documento && data[i].tipo_documento.id == "82") {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Enviar Arquivo por email",
            click: this.onArquivoEmail
          });
        }

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.loadingTable = false;
    },

    salvar: function salvar() {
      var _this5 = this;

      this.config.loading.save = true;

      this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/editar", this.formDataEdit).then(function (result) {
        result = result[0];

        _this5.config.loading.save = false;

        if (result.status == 200) {
          _this5.getConsultaUploadPagina();
          _this5.parent.getConsultaUpload();
          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.edMsg("Dados atualizados com sucesso");
        }
      });
    },
    enviar: function enviar() {
      var _this6 = this;

      var error = false;

      for (var item in this.formData) {
        var element = this.formData[item];

        if (!element.destinatario && element.consultas.length > 0) {
          element.error = "Campo Destinatário é Obrigatório";
          error = true;
        } else if (element.consultas.length > 0) {
          var emails = element.destinatario.split(";");

          for (var j = 0; j < emails.length; j++) {
            if (!this.validateEmail(emails[j])) {
              element.error = "Email `" + emails[j] + "` não é válido";
              error = true;
            }
          }
        }
      }

      if (error) {
        this.edAlert("Não foi possível completar o envio. Você deve corrigir os erros apontados acima.", "error");
      } else {
        this.loadingEmailSave = true;

        this.post("empresa/consulta/upload/pagina/" + this.parent.upload_pagina.id + "/enviar", { empresa: this.formData }).then(function (result) {
          result = result[0];

          _this6.loadingEmailSave = false;

          if (result.status == 200) {
            _this6.edMsg("Emails enviado com sucesso. Você pode acompanhar o status do email atravês do `Histórico de Emails` na página anterior.");
            _this6.formataData(result);

            _this6.showEnviarEmail = !_this6.showEnviarEmail;
            _this6.formData = {};
            _this6.tableDataEmail = [];
          }
        });
      }
    }
  }
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_liberar_aso__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_liberar_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__includes_liberar_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_upload_aso__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_upload_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_upload_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_download_aso__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_download_aso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_download_aso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_lembrete_assinatura__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_lembrete_assinatura___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__includes_lembrete_assinatura__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__includes_historico_whatsapp__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__includes_historico_whatsapp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__includes_historico_whatsapp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_liberacao_filtro__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_css__);















function getCookieValue(prefix) {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.startsWith(prefix)) {
      var cookieValue = cookie.substring(cookie.indexOf('=') + 1);
      return cookieValue;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, LiberarASO: __WEBPACK_IMPORTED_MODULE_5__includes_liberar_aso___default.a, UploadASO: __WEBPACK_IMPORTED_MODULE_6__includes_upload_aso___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_common_form___default.a, DownloadASO: __WEBPACK_IMPORTED_MODULE_7__includes_download_aso___default.a, LembreteAssinatura: __WEBPACK_IMPORTED_MODULE_8__includes_lembrete_assinatura___default.a, HistoricoWhatsapp: __WEBPACK_IMPORTED_MODULE_9__includes_historico_whatsapp___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  watch: {
    "formFilter.id_empresa": function formFilterId_empresa() {
      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.getFuncionario();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_empresa: _.debounce(this.getEmpresa, 1000),
          id_fdt: _.debounce(this.getFDT, 1000),
          id_funcionario: _.debounce(this.getFuncionario, 1000)
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          table: false
        },
        disabled: {
          id_funcionario: true
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: []
        }
      },
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null
      },
      formFilter: {
        id_funcao: null,
        id_empresa: null,
        id_arquivo_aso: 0,
        inativo: 0,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_aso: [],
        id_tipo_status: [68, 69],
        created_at: []
      },
      pagination: {},
      response: {},
      consulta: null,
      historicoWhatsappId: null,
      tableHead: [{
        key: "data",
        sortable: true,
        label: "Data Consulta"
      }, {
        key: "consulta",
        sortable: true,
        show_tipo_aso: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "credenciada",
        sortable: true,
        label: "Credenciada"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "status",
        sortable: true,
        label: "Status"
      }],
      tableData: [],
      formItems: [],
      showFormFilter: false,
      showLiberacao: false,
      showUploadASO: false,
      showDownloadASO: false,
      showLembreteAssinatura: false,
      showHistoricoWhatsapp: false,
      loadingDownloadASO: false,
      filterBadge: "0"
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_10__form_liberacao_filtro__["a" /* default */];

    this.getConsulta();
    this.getEmpresa();
  },

  methods: {
    onLiberarASO: function onLiberarASO(data) {
      this.consulta = data;
      this.showLiberacao = !this.showLiberacao;
    },

    onDownloadASO: function onDownloadASO(data) {
      var _this = this;

      this.showDownloadASO = !this.showDownloadASO;
      this.loadingDownloadASO = true;

      if (!data) {
        this.loadingDownloadASO = false;
        this.consulta = data;
        return;
      }

      var filter = {
        id_tipo_email: [197]
      };

      this.get("/empresa/email/" + data.empresa.id, { filter: filter }).then(function (result) {
        result = result[0];

        _this.loadingDownloadASO = false;

        if (result.status == 200) {
          var emails = [];

          for (var i = 0; i < result.data.data.length; i++) {
            emails.push(result.data.data[i].email);
          }
          data.empresa.email = emails.join(";");
        }

        _this.consulta = data;
      });
    },

    onRegister: function onRegister() {
      this.showUploadASO = !this.showUploadASO;
    },

    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, { search: _search }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getFDT: function getFDT() {
      var _this4 = this;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, { pagination: 100 }).then(function (result) {
        result = result[0];

        _this4.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this4.config.loading.id_fdt = result.data.data;
        }
      });
    },

    getConsulta: function getConsulta(_search, _page, _pagination, _loading) {
      var _this5 = this;

      this.config.loading.table = true;
      this.response = {};

      if (this.formFilter.created_at.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-60, null, "D"), true),
            amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcao ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta", { search: _search, page: _page, pagination: _pagination, filter: this.formFilter }).then(function (result) {
        result = result[0];
        _this5.response = result;
        _this5.config.loading.table = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this5,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var send_email = "";
            var isExcluida = data[i].status == 0;

            if (data[i].send_email_at) {
              send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + _this5.toDate(data[i].send_email_at) + '"/>';
            }

            var item = {
              data: _this5.toDate(data[i].dt_cad, true),
              consulta: data[i].id_con + (data[i].rapido == "1" ? ' <img src="' + _this5.env.url_cs + "app/1.img/img_sof/ar.png" + '" title="Consulta gerada pelo ASO Rápido"/>' : "") + send_email,
              credenciada: data[i].credenciada ? data[i].credenciada.nome : "---",
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              TIPO: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              _data: data[i],
              options: {
                disable_edit: !_this5.validarPermissao(553),
                style: 'color:' + (data[i].status == 0 ? 'red !important' : '')
              },
              buttons: []
            };

            if (data[i].cliente_id == 1001 || data[i].cliente_id == 1914) {
              if (data[i].pgr_docs_aso) {
                item.buttons.push({
                  icon: "fa-solid fa-file-signature fs16",
                  color: isExcluida ? "danger" : "cyan",
                  title: isExcluida ? "Consulta excluída" : "Documento assinado digitalmente",
                  click: isExcluida ? null : _this5.onAssinadoDigitalmente,
                  disabled: isExcluida
                });
              } else {
                item.buttons.push({
                  icon: "fa-solid fa-file-signature fs16",
                  color: isExcluida ? "danger" : "info",
                  title: isExcluida ? "Consulta excluída" : "ASO ainda não assinado, click para enviar um lembrete de assinatura ao funcionario.",
                  click: isExcluida ? null : _this5.onLembreteAssinatura,
                  disabled: isExcluida
                });
              }

              item.buttons.push({
                icon: "fa-solid fa-rectangle-list fs16",
                color: "default",
                title: "Ver histórico de notificações WhatsApp enviadas para essa consulta.",
                click: _this5.onHistoricoWhatsapp
              });
            }

            if (isExcluida) {
              item.buttons.push({
                icon: "fa fa-lock",
                color: "danger",
                title: "Consulta excluída - não é possível liberar",
                disabled: true
              });
            } else if (!data[i].id_cre && data[i].tipo_status && data[i].tipo_status.id == 66) {
              item.buttons.push({
                icon: "fa fa-unlock",
                color: "warning",
                title: "ASO Liberado. Clique para ver mais detalhes",
                click: _this5.onLiberarASO
              });
            } else {
              if (!data[i].id_cre) {
                var assinado = !!data[i].pgr_docs_aso;
                var temUpload = !!data[i].arquivo_aso;
                var empresaConfigurada = data[i].empresa && data[i].empresa.aso_sign == 1 && data[i].empresa.aso_assinatura == 1;
                var podeLiberar = assinado && (temUpload || empresaConfigurada);

                if (podeLiberar) {
                  item.buttons.push({
                    icon: "fa fa-lock",
                    color: "warning",
                    title: "Liberar esse ASO",
                    click: _this5.onLiberarASO
                  });
                } else {
                  var motivos = [];
                  if (!assinado) motivos.push("o funcionário ainda não assinou o ASO");
                  if (!temUpload && !empresaConfigurada) motivos.push("é necessário upload prévio do ASO ou habilitar 'Assinar ASO com Certificado' e 'Incluir Assinatura no ASO' na empresa");

                  item.buttons.push({
                    icon: "fa fa-lock",
                    color: "default",
                    title: "Não é possível liberar: " + motivos.join("; "),
                    disabled: true
                  });
                }
              }
            }

            if (_this5.validarPermissao(561)) {
              item.buttons.push({
                icon: data[i].send_email_at ? "fa-solid fa-envelope-circle-check" : "fa-solid fa-paper-plane",
                color: isExcluida ? "danger" : data[i].send_email_at ? "success" : "warning",
                title: isExcluida ? "Consulta excluída - não é possível enviar email" : data[i].send_email_at ? "ASO enviado por email" : "Enviar ASO por email",
                click: isExcluida ? null : _this5.onDownloadASO,
                disabled: isExcluida
              });
            }

            tableData.push(item);
          }

          _this5.pagination = pagination;
          _this5.tableData = tableData;
        }
      });
    },

    generateMD5: function generateMD5() {
      var hash = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash('md5').update(this.inputValue.toString()).digest('hex');
      this.md5Hash = hash;
    },
    onAssinadoDigitalmente: function onAssinadoDigitalmente(data) {
      var asoNumber = data.id_con.toString();
      var md5Hash = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash('md5').update(asoNumber).digest('hex');
      var token = getCookieValue('web');
      if (token) {
        var url = "../commtrol/api/empresa/consulta/aso/" + md5Hash + "?token=" + token + "&btASO=pdf";
        window.open(url, '_blank');
      } else {
        console.error('Token not found in cookies');
      }
    },


    onLembreteAssinatura: function onLembreteAssinatura(data) {
      this.consulta = data;
      this.showLembreteAssinatura = !this.showLembreteAssinatura;
    },

    onHistoricoWhatsapp: function onHistoricoWhatsapp(data) {
      this.historicoWhatsappId = data.id_con;
      this.showHistoricoWhatsapp = !this.showHistoricoWhatsapp;
    },

    onFuncionarioCadastrado: function onFuncionarioCadastrado(data) {
      console.log("Funcionário cadastrado no sistema ASO", data);
    }
  }
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_email_cadastrar__ = __webpack_require__(955);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'exame-editar',
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm: function showForm(val) {
      this.showFormEdit = val;
      if (val) this.init();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [240, 32, 241],
        tipo_exclude: [33, 34, 35, 36, 37, 196],
        hidden: { padrao: true },
        click: {},
        loading: {
          save: false,
          content: false,
          oauth: false,
          status: false
        },
        list: {}
      },
      formData: {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: 'tls',
        senha: null,
        porta: 0,
        tempo_espera: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null,
        tipo: [],
        tipo_auth: 'senha'
      },
      response: {},
      showFormEdit: false,
      gruposForm: [],
      oauthStatus: null,
      showTermoModal: false
    };
  },
  mounted: function mounted() {
    this.gruposForm = __WEBPACK_IMPORTED_MODULE_5__form_email_cadastrar__["a" /* default */];
  },

  methods: {
    abrirTermoModal: function abrirTermoModal() {
      var _this = this;

      if (this.showTermoModal) {
        this.showTermoModal = false;
        this.$nextTick(function () {
          _this.showTermoModal = true;
        });
      } else {
        this.showTermoModal = true;
      }
    },
    fecharTermoModal: function fecharTermoModal() {
      this.showTermoModal = false;
    },
    init: function init() {
      this.response = {};
      this.oauthStatus = null;

      if (!this.parent || !this.parent.formData) return;

      var tipo = Array.isArray(this.parent.formData.tipo) ? this.parent.formData.tipo.map(function (element) {
        return element.id;
      }) : [];

      this.formData = {
        id: this.parent.formData.id || 0,
        nome: this.parent.formData.nome || null,
        usuario: this.parent.formData.usuario || null,
        email: this.parent.formData.email || null,
        servidor_smtp: this.parent.formData.servidor_smtp || null,
        autenticacao: this.parent.formData.autenticacao || 1,
        conexao_seg: this.parent.formData.conexao_seg || 'tls',
        porta: this.parent.formData.porta || 0,
        senha: null,
        tempo_espera: this.parent.formData.tempo_espera || 0,
        n_msg_pct: this.parent.formData.n_msg_pct || 50,
        t_esp_pct: this.parent.formData.t_esp_pct || 600,
        updated_at: this.parent.formData.updated_at || null,
        tipo: tipo,
        tipo_auth: this.parent.formData.tipo_auth || 'senha'
      };

      if (this.formData.tipo_auth === 'oauth2' && this.formData.id) {
        this.verificarStatusOAuth2();
      }
    },
    salvar: function salvar() {
      var _this2 = this;

      this.response = {};
      this.config.loading.save = true;

      if (!this.validarFormulario()) {
        this.config.loading.save = false;
        return;
      }

      this.post('conta-email/editar', this.formData).then(function (result) {
        result = result[0];
        _this2.config.loading.save = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg('Registro salvo com sucesso!');

          if (_this2.formData.id === 0 && result.data && result.data.id) {
            _this2.formData.id = result.data.id;
          }

          if (_this2.formData.tipo_auth === 'oauth2' && _this2.formData.id) {
            setTimeout(function () {
              _this2.verificarStatusOAuth2();
            }, 500);
          }

          _this2.showFormEdit = false;

          if (_this2.parent && _this2.parent.getContaEmail) {
            _this2.parent.getContaEmail();
          }
        }
      }).catch(function () {
        _this2.config.loading.save = false;
      });
    },
    validarFormulario: function validarFormulario() {
      if (!this.formData.nome) {
        this.edMsg('Nome é obrigatório', 'error');
        return false;
      }

      if (!this.formData.email) {
        this.edMsg('Email é obrigatório', 'error');
        return false;
      }

      if (!this.formData.usuario) {
        this.edMsg('Usuário é obrigatório', 'error');
        return false;
      }

      if (!this.formData.tipo_auth) {
        this.edMsg('Método de Autenticação é obrigatório', 'error');
        return false;
      }

      if (this.formData.tipo_auth === 'senha') {
        if (!this.formData.senha && this.formData.id === 0) {
          this.edMsg('Senha é obrigatória para contas SMTP', 'error');
          return false;
        }

        if (!this.formData.servidor_smtp) {
          this.edMsg('Servidor SMTP é obrigatório para contas SMTP', 'error');
          return false;
        }

        if (!this.formData.porta) {
          this.edMsg('Porta é obrigatória para contas SMTP', 'error');
          return false;
        }

        if (!this.formData.conexao_seg) {
          this.edMsg('Conexão de Segurança é obrigatória para contas SMTP', 'error');
          return false;
        }
      }

      if (this.formData.tipo_auth === 'oauth2') {
        console.log('Validação OAuth2: apenas campos básicos necessários');
      }

      return true;
    },
    conectarOAuth2: function conectarOAuth2() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, popup, checkClosed;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.formData.id) {
                  _context.next = 3;
                  break;
                }

                _this3.edMsg('Salve a conta primeiro antes de conectar OAuth2', 'warning');
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;

                _this3.config.loading.oauth = true;

                _context.next = 7;
                return _this3.get('conta-email/' + _this3.formData.id + '/oauth2/iniciar');

              case 7:
                response = _context.sent;


                if (response && response[0] && response[0].data && response[0].data.auth_url) {
                  popup = window.open(response[0].data.auth_url, 'oauth2', 'width=500,height=600,scrollbars=yes,resizable=yes');
                  checkClosed = setInterval(function () {
                    if (popup.closed) {
                      clearInterval(checkClosed);
                      setTimeout(function () {
                        _this3.verificarStatusOAuth2();
                      }, 1000);
                    }
                  }, 1000);
                } else {
                  _this3.edMsg('Erro ao obter URL de autorização', 'error');
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                console.error('Erro ao conectar OAuth2:', _context.t0);
                _this3.edMsg('Erro ao iniciar conexão OAuth2', 'error');

              case 15:
                _context.prev = 15;

                _this3.config.loading.oauth = false;
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 11, 15, 18]]);
      }))();
    },
    verificarStatusOAuth2: function verificarStatusOAuth2() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this4.formData.id || _this4.formData.tipo_auth !== 'oauth2')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.prev = 2;

                _this4.config.loading.status = true;

                _context2.next = 6;
                return _this4.get('conta-email/' + _this4.formData.id + '/oauth2/status');

              case 6:
                response = _context2.sent;


                if (response && response[0] && response[0].data) {
                  _this4.oauthStatus = response[0].data;

                  if (_this4.oauthStatus.is_fully_configured) {
                    _this4.edMsg('OAuth2 configurado com sucesso!', 'success');
                  }
                }

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                console.error('Erro ao verificar status OAuth2:', _context2.t0);
                _this4.oauthStatus = null;

              case 14:
                _context2.prev = 14;

                _this4.config.loading.status = false;
                return _context2.finish(14);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[2, 10, 14, 17]]);
      }))();
    },
    revogarOAuth2: function revogarOAuth2() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (confirm('Tem certeza que deseja desconectar a conta Gmail?')) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return _this5.post('conta-email/' + _this5.formData.id + '/oauth2/revogar', {});

              case 5:
                _this5.oauthStatus = null;
                _this5.edMsg('Conta Gmail desconectada com sucesso!', 'success');

                setTimeout(function () {
                  _this5.verificarStatusOAuth2();
                }, 500);

                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](2);

                console.error('Erro ao revogar OAuth2:', _context3.t0);
                _this5.edMsg('Erro ao desconectar conta Gmail', 'error');

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[2, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teste__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EmailEditar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a, EmailTeste: __WEBPACK_IMPORTED_MODULE_3__teste___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        tempo_espera: 0,
        porta: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "email",
        sortable: true,
        label: "Email"
      }, {
        key: "usuario",
        sortable: true,
        label: "Usuário"
      }, {
        key: "tipo",
        sortable: true,
        label: "Serviços Vinculados"
      }],
      tableData: [],
      loadingTable: false,
      loadingTest: false,
      showFormEdit: false,
      showFormTeste: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getContaEmail();
  },

  methods: {
    onRegister: function onRegister() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        porta: 0,
        tempo_espera: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null,
        tipo: []
      };
    },

    onEdit: function onEdit(data) {
      this.showFormEdit = !this.showFormEdit;

      this.formData = {
        id: data.id,
        nome: data.nome,
        usuario: data.usuario,
        email: data.email,
        servidor_smtp: data.servidor_smtp,
        autenticacao: data.autenticacao,
        conexao_seg: data.conexao_seg,
        porta: data.porta,
        senha: null,
        tempo_espera: data.tempo_espera,
        n_msg_pct: data.n_msg_pct,
        t_esp_pct: data.t_esp_pct,
        updated_at: data.updated_at,
        tipo: data.tipo
      };
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingTable = true;

        _this.post("/conta-email/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaEmail();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    onTest: function onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        email: data.email
      };
    },


    getContaEmail: function getContaEmail(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("conta-email", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var tipo = [];

            for (var j = 0; j < data[i].tipo.length; j++) {
              var element = data[i].tipo[j];
              tipo.push(element.descricao);
            }

            var item = {
              id: data[i].id,
              nome: data[i].nome,
              email: data[i].email,
              usuario: data[i].usuario,
              servidor_smtp: data[i].servidor_smtp,
              tipo: tipo.length > 0 ? tipo.join("<br>") : "---",
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(3),
                disable_edit: !_this2.validarPermissao(3)
              },
              buttons: [{
                icon: "fa fa-check",
                color: "success",
                title: "Enviar Email Teste",
                click: _this2.onTest
              }]
            };

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_EdRequest_vue__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_EdRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__root_EdRequest_vue__);





function b64UrlDecode(str) {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }return atob(str);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OAuth2Callback',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__root_EdRequest_vue___default.a],

  data: function data() {
    return { loading: true, error: null, success: false };
  },


  methods: {
    processCallback: function processCallback() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _$route$query, code, state, cbResp, success, conta_email_id, oauth_access_token, error;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _$route$query = _this.$route.query, code = _$route$query.code, state = _$route$query.state;

                if (code) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Código de autorização não encontrado na URL.');

              case 4:
                if (state) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Parâmetro "state" ausente na URL.');

              case 6:
                try {
                  JSON.parse(b64UrlDecode(state));
                } catch (_) {}

                _context.next = 9;
                return _this.get('oauth2/callback', { code: code, state: state }, null, true);

              case 9:
                cbResp = _context.sent;
                success = cbResp.success, conta_email_id = cbResp.conta_email_id, oauth_access_token = cbResp.oauth_access_token, error = cbResp.error;

                if (success) {
                  _context.next = 13;
                  break;
                }

                throw new Error(error || 'Erro no callback OAuth2.');

              case 13:
                _context.next = 15;
                return _this.post('conta-email/' + conta_email_id + '/oauth2/salvar', { oauth_access_token: oauth_access_token }, null, true);

              case 15:
                _this.success = true;
                setTimeout(function () {
                  return _this.$router.push('/conta-email');
                }, 3000);

                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                console.error('OAuth2 callback erro:', _context.t0);
                _this.error = _context.t0 && _context.t0.response && _context.t0.response.data && _context.t0.response.data.error || _context.t0.message || 'Erro ao processar o callback.';

              case 23:
                _context.prev = 23;

                _this.loading = false;
                return _context.finish(23);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 19, 23, 26]]);
      }))();
    }
  },

  mounted: function mounted() {
    this.processCallback();
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_email_teste__ = __webpack_require__(956);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'parent.formData.id': function parentFormDataId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
		}
	},
	data: function data() {
		return {
			config: {
				hidden: {},
				click: {},
				loading: {
					save: false,
					content: false
				},
				list: {}
			},
			formData: {
				id: 0,
				email: null
			},
			response: {},
			exameItems: [],
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_email_teste__["a" /* default */];
	},


	methods: {
		init: function init() {},
		salvar: function salvar() {
			var _this = this;

			this.response = {};
			this.config.loading.save = true;

			this.formData.id = this.parent.formData.id;

			this.post('/conta-email/testar', this.formData).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;

				if (result.status == 200) {
					_this.showFormEdit = !_this.showFormEdit;
					_this.edAlert('Email enviado com sucesso');
				}
			});
		}
	}
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conta-whatsapp-editar',
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm: function showForm(val) {
      this.showFormEdit = val;
      if (val) this.init();
    }
  },
  data: function data() {
    return {
      config: {
        loading: {
          save: false,
          content: false
        }
      },
      formData: {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      },
      response: {},
      showFormEdit: false,
      showAccessToken: false
    };
  },

  methods: {
    init: function init() {
      this.response = {};
      this.showAccessToken = false;

      if (!this.parent || !this.parent.formData) return;

      this.formData = {
        id: this.parent.formData.id || 0,
        nome: this.parent.formData.nome || null,
        phone_number_id: this.parent.formData.phone_number_id || null,
        business_account_id: this.parent.formData.business_account_id || null,
        access_token: null
      };
    },
    salvar: function salvar() {
      var _this = this;

      this.response = {};
      this.config.loading.save = true;

      if (!this.validarFormulario()) {
        this.config.loading.save = false;
        return;
      }

      this.post('conta-whatsapp/editar', this.formData).then(function (result) {
        result = result[0];
        _this.config.loading.save = false;
        _this.response = result;

        if (result.status == 200) {
          _this.edMsg('Registro salvo com sucesso!');
          _this.showFormEdit = false;

          if (_this.parent && _this.parent.getContaWhatsapp) {
            _this.parent.getContaWhatsapp();
          }
        }
      }).catch(function () {
        _this.config.loading.save = false;
      });
    },
    validarFormulario: function validarFormulario() {
      if (!this.formData.nome) {
        this.edMsg('Nome é obrigatório', 'error');
        return false;
      }
      if (!this.formData.phone_number_id) {
        this.edMsg('Phone Number ID é obrigatório', 'error');
        return false;
      }
      if (!this.formData.business_account_id) {
        this.edMsg('Business Account ID é obrigatório', 'error');
        return false;
      }
      if (!this.formData.access_token && this.formData.id === 0) {
        this.edMsg('Access Token é obrigatório', 'error');
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__teste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__templates__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "conta-whatsapp",
  components: { EdPaginate: __WEBPACK_IMPORTED_MODULE_1_common_paginate___default.a, WhatsappEditar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a, WhatsappTeste: __WEBPACK_IMPORTED_MODULE_3__teste___default.a, WhatsappTemplates: __WEBPACK_IMPORTED_MODULE_4__templates___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      },
      search: null,
      pagination: {},
      response: {},
      tableData: [],
      loadingTable: false,
      showFormEdit: false,
      showFormTeste: false,
      showFormTemplates: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {
    var clienteId = this.cliente && this.cliente.logged ? this.cliente.logged.id : null;
    if (clienteId !== 1 && clienteId !== 914) {
      this.$router.replace('/');
      return;
    }
  },


  mounted: function mounted() {
    this.getContaWhatsapp();
  },

  methods: {
    onRegister: function onRegister() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      };
    },

    onEdit: function onEdit(data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        nome: data.nome,
        phone_number_id: data.phone_number_id,
        business_account_id: data.business_account_id,
        access_token: null
      };
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingTable = true;

        _this.post("/conta-whatsapp/deletar", { ids: data }).then(function (result) {
          result = result[0];
          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaWhatsapp();
            self.edMsg("Registro excluído com sucesso");
          }
        });
      });
    },

    onTest: function onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        nome: data.nome
      };
    },
    onTemplates: function onTemplates(data) {
      this.formData = {
        id: data.id,
        nome: data.nome
      };
      this.showFormTemplates = true;
    },
    handleSearch: function handleSearch() {
      this.getContaWhatsapp(this.search, 1, this.pagination.per_page);
    },
    handleClearSearch: function handleClearSearch() {
      this.search = null;
      this.getContaWhatsapp();
    },
    handleNavigate: function handleNavigate(page) {
      this.getContaWhatsapp(this.search, page, this.pagination.per_page);
    },


    getContaWhatsapp: function getContaWhatsapp(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("conta-whatsapp", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            tableData.push({
              id: data[i].id,
              nome: data[i].nome,
              phone_number_id: data[i].phone_number_id,
              business_account_id: data[i].business_account_id
            });
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    }
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);




var TEMPLATE_VAZIO = function TEMPLATE_VAZIO() {
  return {
    name: null,
    category: 'UTILITY',
    language: 'pt_BR',
    header: null,
    body: null,
    footer: null
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conta-whatsapp-templates',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm: function showForm(val) {
      this.showDialog = val;
      if (val) this.init();
    }
  },
  data: function data() {
    return {
      showDialog: false,
      activeTab: 'lista',
      loadingList: false,
      loadingSave: false,
      listError: null,
      saveError: null,
      templates: [],
      templateSelecionado: null,
      novoTemplate: TEMPLATE_VAZIO()
    };
  },

  methods: {
    init: function init() {
      this.activeTab = 'lista';
      this.templateSelecionado = null;
      this.listError = null;
      this.saveError = null;
      this.novoTemplate = TEMPLATE_VAZIO();
      this.carregarTemplates();
    },
    onClose: function onClose() {
      this.$emit('update:showForm', false);
    },
    carregarTemplates: function carregarTemplates() {
      var _this = this;

      if (!this.parent || !this.parent.formData) return;

      this.loadingList = true;
      this.listError = null;

      this.get('conta-whatsapp/templates/' + this.parent.formData.id).then(function (result) {
        result = result[0];
        _this.loadingList = false;

        if (result.status == 200) {
          _this.templates = result.data || [];
        } else {
          _this.templates = [];
          _this.listError = result.msg || 'Não foi possível carregar os templates desta conta.';
        }
      }).catch(function () {
        _this.loadingList = false;
        _this.listError = 'Não foi possível carregar os templates desta conta.';
      });
    },
    visualizarTemplate: function visualizarTemplate(row) {
      this.templateSelecionado = row;
      this.activeTab = 'visualizar';
    },
    abrirNovo: function abrirNovo() {
      this.novoTemplate = TEMPLATE_VAZIO();
      this.saveError = null;
      this.activeTab = 'novo';
    },
    limparNovo: function limparNovo() {
      this.novoTemplate = TEMPLATE_VAZIO();
      this.saveError = null;
    },
    normalizarNome: function normalizarNome(val) {
      this.novoTemplate.name = (val || '').toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    },
    categoriaLabel: function categoriaLabel(cat) {
      var map = { MARKETING: 'Marketing', UTILITY: 'Utilidade', AUTHENTICATION: 'Autenticação' };
      return map[cat] || cat;
    },
    categoriaIcone: function categoriaIcone(cat) {
      var map = {
        MARKETING: 'fa fa-bullhorn',
        UTILITY: 'fa fa-info-circle',
        AUTHENTICATION: 'fa fa-key'
      };
      return map[cat] || 'fa fa-file-text-o';
    },
    idiomaLabel: function idiomaLabel(lang) {
      var map = { pt_BR: 'Português (BR)', en_US: 'Inglês (US)', es: 'Espanhol' };
      return map[lang] || lang;
    },
    statusLabel: function statusLabel(status) {
      var map = {
        APPROVED: 'Aprovado',
        PENDING: 'Em análise',
        REJECTED: 'Rejeitado',
        PAUSED: 'Pausado',
        DISABLED: 'Desativado'
      };
      return map[status] || status;
    },
    statusIcone: function statusIcone(status) {
      var map = {
        APPROVED: 'fa fa-check-circle',
        PENDING: 'fa fa-clock-o',
        REJECTED: 'fa fa-times-circle',
        PAUSED: 'fa fa-pause-circle',
        DISABLED: 'fa fa-ban'
      };
      return map[status] || 'fa fa-question-circle';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        APPROVED: 'success',
        PENDING: 'warning',
        REJECTED: 'danger',
        PAUSED: 'info',
        DISABLED: 'info'
      };
      return map[status] || 'info';
    },
    validarNovoTemplate: function validarNovoTemplate() {
      if (!this.novoTemplate.name) {
        this.saveError = 'Informe o nome do template.';
        return false;
      }
      if (!this.novoTemplate.category) {
        this.saveError = 'Selecione a categoria do template.';
        return false;
      }
      if (!this.novoTemplate.body) {
        this.saveError = 'Informe o corpo da mensagem.';
        return false;
      }
      return true;
    },
    converterVariaveis: function converterVariaveis(texto) {
      return (texto || '').replace(/\{(\d+)\}/g, '{{$1}}');
    },
    montarComponents: function montarComponents() {
      var components = [];

      if (this.novoTemplate.header) {
        components.push({ type: 'HEADER', format: 'TEXT', text: this.novoTemplate.header });
      }

      components.push({ type: 'BODY', text: this.converterVariaveis(this.novoTemplate.body) });

      if (this.novoTemplate.footer) {
        components.push({ type: 'FOOTER', text: this.novoTemplate.footer });
      }

      return components;
    },
    enviarTemplate: function enviarTemplate() {
      var _this2 = this;

      this.saveError = null;

      if (!this.validarNovoTemplate()) return;

      this.loadingSave = true;

      var payload = {
        id: this.parent.formData.id,
        name: this.novoTemplate.name,
        category: this.novoTemplate.category,
        language: this.novoTemplate.language,
        components: this.montarComponents()
      };

      this.post('conta-whatsapp/templates/criar', payload).then(function (result) {
        result = result[0];
        _this2.loadingSave = false;

        if (result.status == 200) {
          _this2.edMsg('Template enviado para aprovação da Meta com sucesso!');
          _this2.activeTab = 'lista';
          _this2.carregarTemplates();
        } else {
          _this2.saveError = result.msg || 'Não foi possível enviar o template para aprovação.';
        }
      }).catch(function () {
        _this2.loadingSave = false;
        _this2.saveError = 'Não foi possível enviar o template para aprovação.';
      });
    }
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_whatsapp_teste__ = __webpack_require__(957);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conta-whatsapp-teste',
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    showForm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showForm: function showForm() {
      this.showFormEdit = !this.showFormEdit;
      this.init();
    }
  },
  data: function data() {
    return {
      config: {
        hidden: {},
        click: {},
        loading: {
          save: false,
          content: false
        },
        list: {}
      },
      formData: {
        id: 0,
        telefone: null
      },
      response: {},
      formItems: [],
      showFormEdit: false
    };
  },
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_whatsapp_teste__["a" /* default */];
  },

  methods: {
    init: function init() {},
    salvar: function salvar() {
      var _this = this;

      this.response = {};
      this.config.loading.save = true;

      this.formData.id = this.parent.formData.id;

      this.post('/conta-whatsapp/testar', this.formData).then(function (result) {
        result = result[0];
        _this.config.loading.save = false;

        if (result.status == 200) {
          _this.showFormEdit = !_this.showFormEdit;
          _this.edAlert('Mensagem de teste enviada com sucesso!');
        }
      });
    }
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vincular__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vincular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vincular__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-certificado",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, Upload: __WEBPACK_IMPORTED_MODULE_2_common_upload___default.a, Vincular: __WEBPACK_IMPORTED_MODULE_4__vincular___default.a },
  data: function data() {
    return {
      formData: {
        id: 0,
        tipo_certificado_id: null,
        empresa: null,
        arquivo: null,
        representante: null,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: 0,
        inserir_vinculo: 1
      },
      loadingTable: false,
      loadingSave: false,
      showFormEdit: false,
      showFormVincular: false,
      loadingEmpresa: false,
      pagination: {},
      error: {},
      response: {},
      arquivo: null,
      tableHead: [{
        key: 'tipo',
        sortable: true,
        label: 'Tipo'
      }, {
        key: 'nome',
        sortable: true,
        label: 'Nome'
      }, {
        key: 'validade',
        sortable: true,
        label: 'Validade'
      }, {
        key: 'vincular',
        sortable: true,
        label: 'Vincular Automaticamente'
      }, {
        key: 'data_cadastro',
        sortable: true,
        label: 'Data Cadastro'
      }],
      tableData: [],
      lstTipoCertificado: [],
      lstEmpresa: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getParametros();
    this.getEsocialCertificado();
  },


  methods: {

    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        tipo_certificado_id: null,
        arquivo: null,
        representante: null,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: 0,
        deletar_vinculo: 0,
        inserir_vinculo: 0
      };
      this.arquivo = null;
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {

      this.formData = {
        id: data.id,
        tipo_certificado_id: data.tipo_certificado_id,
        empresa: data.empresa_id,
        arquivo_name: data.arquivo_name,
        arquivo_size: data.arquivo_size,
        arquivo: null,
        representante: data.representante,
        senha: null,
        confirmar_senha: null,
        validade: null,
        vincular: parseInt(data.vincular),
        deletar_vinculo: 0,
        inserir_vinculo: 0
      };

      this.arquivo = null;

      if (this.formData.arquivo_id) {
        this.arquivo = { name: this.formData.arquivo_name, size: this.formData.arquivo_size };
      }

      this.lstEmpresa = [{
        id: data.empresa_id,
        cnpj: data.empresa_cnpj,
        nome: data.empresa_nome_fantasia
      }];

      this.showFormEdit = !this.showFormEdit;
    },
    onVincularCertificado: function onVincularCertificado(data) {

      this.formData = data;
      this.showFormVincular = !this.showFormVincular;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning'

      }).then(function () {

        self.loadingTable = true;

        _this.post('esocial/certificados/deletar', { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {

            _this.$message({
              message: 'Registo excluido com sucesso',
              type: 'success'
            });

            _this.formataLista(result);
          }
        });
      });
    },
    onChangeArquivo: function onChangeArquivo(e) {
      e.preventDefault();
      this.formData.arquivo = e.target.files[0];
      this.arquivo = { name: this.formData.arquivo.name, size: this.formData.arquivo.size };
    },
    getEmpresa: function getEmpresa(_search) {
      var _this2 = this;

      this.loadingEmpresa = true;
      this.lstEmpresa = [];

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        _this2.loadingEmpresa = false;

        if (result.status == 200) {
          _this2.lstEmpresa = result.data.data;
        }
      });
    },
    getParametros: function getParametros() {
      var _this3 = this;

      this.post('/tipo/parent', { codigo: [200] }).then(function (result) {

        result = result[0];
        var data = result.data;

        if (result.status == 200) {
          _this3.lstTipoCertificado = data[200];
        }
      });
    },
    getEsocialCertificado: function getEsocialCertificado(_search, _page) {
      var _this4 = this;

      this.loadingTable = true;
      this.lstTabelaConteudo = [];
      this.hideAdvancedFilter = !this.hideAdvancedFilter;
      this.response = {};

      this.get('esocial/certificados', { page: _page, search: _search }).then(function (result) {

        result = result[0];

        _this4.loadingTable = false;
        _this4.response = result;

        if (result.status == 200) {
          _this4.formataLista(result);
        }
      });
    },
    formataLista: function formataLista(result) {

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {

        var styleDefault = '',
            styleCertificado = ' Vence em ' + arrData[i].validade_diff + ' dia(s)',
            titleRiscoDinamico = '',
            tipo_certificado = arrData[i].tipo_certificado_nome,
            representante = arrData[i].empresa_nome_fantasia,
            validade = arrData[i].validade,
            vincular = arrData[i].vincular,
            created_at = arrData[i].created_at;

        if (arrData[i].parent_id) {
          tipo_certificado = arrData[i].parent_tipo_certificado_nome;
          representante = arrData[i].empresa_nome_fantasia + '<br><b style="font-size:9pt">Usando certificado de ' + arrData[i].parent_empresa_nome_fantasia + '</b>';
          validade = arrData[i].parent_validade;
          vincular = arrData[i].parent_vincular;
          created_at = arrData[i].parent_created_at;
        }

        if (arrData[i].validade_diff && arrData[i].validade_diff > 0 && arrData[i].validade_diff < 10) {
          styleDefault = 'color:#dbb734';
          titleRiscoDinamico = 'O certificado vence em  ' + arrData[i].validade_diff + ' dia(s)';
        } else if (arrData[i].validade_diff && arrData[i].validade_diff == 0) {
          styleDefault = 'color:#dbb734';
          titleRiscoDinamico = 'O certificado vence hoje';
          styleCertificado = ' Vence em hoje';
        } else if (arrData[i].validade_diff && arrData[i].validade_diff < 0) {
          styleDefault = 'color:red';
          titleRiscoDinamico = 'O certificado venceu a ' + arrData[i].validade_diff + ' dia(s)';
          styleCertificado = ' Venceu a ' + arrData[i].validade_diff + ' dia(s)';
        } else if (arrData[i].parent_id) {
          styleDefault = 'color:#3287bc';
          titleRiscoDinamico = 'Esse certificado foi compartilhado por ' + representante;
        } else {}

        var item = {
          'tipo': tipo_certificado,
          'nome': arrData[i].id + ' - ' + representante,
          'validade': this.toDate(validade, true),
          'vincular': vincular == '1' ? 'Sim' : 'Não',
          'data_cadastro': this.toDate(created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        if (this.cliente.logged.cnpj == arrData[i].empresa_cnpj) {
          item.buttons.push({
            icon: 'fa fa-users',
            color: 'success',
            title: 'Vincular clientes',
            click: this.onVincularCertificado
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },


    salvar: function salvar(formName) {
      var _this5 = this;

      this.loadingSave = true;
      this.error = {};
      this.response = {};

      var data = new FormData();

      data.append('id', this.formData.id);
      data.append('tipo_certificado_id', this.formData.tipo_certificado_id);
      data.append('empresa', this.formData.empresa);
      data.append('representante', this.formData.representante);
      data.append('senha', this.formData.senha);
      data.append('confirmar_senha', this.formData.confirmar_senha);
      data.append('vincular', this.formData.vincular);
      data.append('deletar_vinculo', this.formData.deletar_vinculo);
      data.append('inserir_vinculo', this.formData.inserir_vinculo);

      if (this.formData.arquivo) {
        data.append('arquivo', this.formData.arquivo);
      }

      this.post('esocial/certificados/salvar', data, false).then(function (result) {

        result = result[0];

        _this5.loadingSave = false;

        if (result.status == 200) {

          _this5.edMsg('Dados atualizados com sucesso');

          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.formataLista(result);
        }
      });
    }

  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-certificado",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },

  props: {

    certificado: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }

  },

  watch: {
    certificado: function certificado() {},
    showForm: function showForm() {
      this.showFormEdit = !this.showFormEdit;
      this.getEsocialCertificado();
    }
  },

  data: function data() {
    return {
      formData: {
        id_esocial_certificado: null,
        empresa: null
      },
      loadingTable: false,
      loadingSave: false,
      loadingEmpresa: false,
      showFormEdit: false,
      pagination: {},
      error: {},
      response: {},
      arquivo: null,
      tableHead: [{
        key: 'empresa',
        sortable: true,
        label: 'Empresa'
      }],
      tableData: [],
      lstEmpresa: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEsocialCertificado();
  },


  methods: {

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning'

      }).then(function () {

        self.loadingTable = true;

        _this.post('/esocial/certificados/' + _this.certificado.id + '/deletar/vinculo', { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {

            _this.$message({
              message: 'Registo excluido com sucesso',
              type: 'success'
            });

            _this.formataLista(result);
          } else {
            if (result.status == 403) {
              _this.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
                confirmButtonText: 'OK'
              });
            } else {
              _this.$message({
                message: result.msg,
                type: 'error'
              });
            }
          }
        });
      });
    },

    getEmpresa: function getEmpresa(_search, _id) {
      var _this2 = this;

      this.loadingEmpresa = true;

      var url = '';

      this.get('/empresa', { search: _search }).then(function (result) {

        result = result[0];

        if (result.status == 200) {
          _this2.lstEmpresa = result.data.data;
        }

        _this2.loadingEmpresa = false;
      });
    },

    getEsocialCertificado: function getEsocialCertificado(_search, _page) {
      var _this3 = this;

      this.loadingTable = true;
      this.lstTabelaConteudo = [];
      this.hideAdvancedFilter = !this.hideAdvancedFilter;
      this.formData.certificado = this.certificado;
      this.response = {};
      this.pagination = {};

      this.get('/esocial/certificados/' + this.certificado.id, { page: _page, search: _search, pagination: 20 }).then(function (result) {

        result = result[0];

        _this3.loadingTable = false;
        _this3.response = result;
        _this3.pagination = result;

        if (result.status == 200) {
          _this3.formataLista(result);
        }
      });
    },


    formataLista: function formataLista(result) {

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {

        var item = {
          'empresa': arrData[i].empresa_cnpj + ' - ' + arrData[i].empresa_nome_fantasia,
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },

    salvar: function salvar(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {

        if (valid) {

          _this4.loadingTable = true;
          _this4.error = {};

          _this4.post('/esocial/certificados/' + _this4.certificado.id + '/vincular', _this4.formData).then(function (result) {

            _this4.loadingTable = false;

            result = result[0];

            if (result.status == 200) {

              _this4.$message({
                message: 'Dados atualizados com sucesso',
                type: 'success'
              });

              _this4.lstEmpresa = [];
              _this4.formData.empresa = null;

              _this4.formataLista(result);
            }
          });
        } else {
          _this4.$alert('Antes de processeguir, por favor preencher todos os campos obrigatórios', 'Atenção', {
            confirmButtonText: 'OK'
          });
        }
      });
    }

  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_configuracao__ = __webpack_require__(959);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-configuracao",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
  watch: {
    'formData.ativo': function formDataAtivo() {
      this.config.disabled.empresas = this.formData.ativo == 0;
      this.config.disabled.data_inicio = this.formData.ativo == 0;
      this.config.disabled.empresas_processar = this.formData.ativo == 0;
    }
  },
  data: function data() {
    return {
      response: {},
      config: {
        click: {
          empresas: this.getEmpresa,
          empresas_processar: this.getEmpresa,
          save: this.salvar
        },
        list: {
          empresas: [],
          empresas_processar: []
        },
        loading: {
          empresas: false,
          empresas_processar: false,
          save: false
        },
        disabled: {
          empresas: true,
          empresas_processar: true,
          data_inicio: true
        }
      },
      formData: {
        id: 0,
        ativo: 0,
        empresas: [],
        data_inicio: this.toDate(),
        usuario: null,
        updated_at: null
      },
      formItems: [],
      loadingContent: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEsocialConfiguracao();


    this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_configuracao__["a" /* default */];
  },


  methods: {

    getEmpresa: function getEmpresa(_search, _empresas) {
      var _this = this;

      this.config.loading.empresas = true;
      this.config.loading.empresas_processar = true;
      this.config.list.empresas = [];
      this.config.list.empresas_processar = [];

      this.get('/empresa', { search: _search, pagination: 10, filter: { empresas: _empresas } }).then(function (result) {

        result = result[0];
        _this.config.loading.empresas = false;
        _this.config.loading.empresas_processar = false;

        if (result.status == 200) {
          _this.config.list.empresas = result.data.data;
          _this.config.list.empresas_processar = result.data.data;
        }
      });
    },

    getEsocialConfiguracao: function getEsocialConfiguracao() {
      var _this2 = this;

      this.get('/esocial/configuracao').then(function (result) {

        result = result[0];

        _this2.loadingContent = false;
        _this2.config.list.empresas = [];
        _this2.config.list.empresas_processar = [];

        if (result.status == 200 && result.data) {
          _this2.formData = {
            id: result.data.id,
            ativo: result.data.ativo,
            empresas: [],
            empresas_processar: [],
            data_inicio: result.data.data_inicio ? _this2.toDate(result.data.data_inicio, true) : null,
            usuario: result.data.usuario,
            updated_at: _this2.toDate(result.updated_at)
          };

          for (var i = 0; i < result.data.empresas.length; i++) {
            var element = result.data.empresas[i];

            _this2.formData.empresas.push(element.id);
            _this2.config.list.empresas.push(element);
          }

          for (var _i = 0; _i < result.data.empresas_processar.length; _i++) {
            var _element = result.data.empresas_processar[_i];

            _this2.formData.empresas_processar.push(_element.id);
            _this2.config.list.empresas_processar.push(_element);
          }
        }
      });
    },
    salvar: function salvar(formName) {
      var _this3 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post('esocial/configuracao/editar', this.formData, false).then(function (result) {

        _this3.config.loading.save = false;

        result = result[0];

        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg('Dados atualizados com sucesso');
          _this3.getEsocialConfiguracao();
        }
      });
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







var ICONES_ROTINA = {
  "command:esocial.gerarLote": "fa fa-folder-open-o",
  "command:esocial.processarLote": "fa fa-paper-plane",
  "command:esocial.consultarLote": "fa fa-search",
  "command:esocial.gerarS2240Admissional": "fa fa-user-plus",
  "command:esocial.reenviarS2240Erros": "fa fa-repeat"
};

var DESCRICOES_ROTINA = {
  "command:esocial.gerarLote": "Agrupa os eventos do eSocial que ainda não foram enviados em lotes, por empresa e layout. Só organiza os eventos em lote, não envia nada ao governo.",
  "command:esocial.processarLote": "Envia ao webservice do eSocial os lotes que ainda não foram processados. É aqui que o envio de verdade acontece.",
  "command:esocial.consultarLote": "Consulta no eSocial o resultado do processamento dos lotes já enviados e atualiza o status de cada evento (confirmado ou com erro).",
  "command:esocial.gerarS2240Admissional": "Cria automaticamente o evento S-2240 (exposição a agentes de risco) 48h depois da confirmação do S-2220 admissional do trabalhador.",
  "command:esocial.reenviarS2240Erros": "Reenvia sozinho o lote de S-2240 quando detecta que o cadastro do funcionário foi corrigido depois de um erro do webservice (ex: categoria ou matrícula faltando)."
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-agendamento",
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],

  props: {
    showForm: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    showForm: function showForm() {
      this.showModal = !this.showModal;

      if (this.showModal) {
        this.getAgendamento();
      } else {
        this.historico = null;
      }
    }
  },

  data: function data() {
    return {
      showModal: false,
      loading: false,
      rotinas: [],
      historico: null,
      loadingHistorico: false,
      historicoItens: [],
      detalheItem: null
    };
  },


  methods: {
    close: function close() {
      this.showModal = false;
      this.historico = null;
      this.detalheItem = null;
    },
    openDetalhe: function openDetalhe(item) {
      this.detalheItem = item;
    },
    closeDetalhe: function closeDetalhe() {
      this.detalheItem = null;
    },
    resumoColunas: function resumoColunas(itens) {
      var _this = this;

      var colunas = [];

      itens.forEach(function (item) {
        _this.resumoDe(item).forEach(function (r) {
          if (!colunas.includes(r.label)) colunas.push(r.label);
        });
      });

      return colunas;
    },
    resumoValor: function resumoValor(item, label) {
      var item_resumo = this.resumoDe(item).find(function (r) {
        return r.label == label;
      });
      return item_resumo ? item_resumo.valor : "-";
    },
    getAgendamento: function getAgendamento() {
      var _this2 = this;

      this.loading = true;

      this.get("esocial/agendamento").then(function (result) {
        result = result[0];
        _this2.rotinas = result.status == 200 ? result.data : [];
        _this2.loading = false;
      });
    },
    toggleHistorico: function toggleHistorico(signature) {
      var _this3 = this;

      if (this.historico == signature) {
        this.historico = null;
        return;
      }

      this.historico = signature;
      this.loadingHistorico = true;
      this.historicoItens = [];

      this.get("log/tarefa", { filter: { tarefa: signature }, pagination: 10 }).then(function (result) {
        result = result[0];
        _this3.historicoItens = result.status == 200 ? result.data.data : [];
        _this3.loadingHistorico = false;
      });
    },
    rotinaIcon: function rotinaIcon(signature) {
      return ICONES_ROTINA[signature] || "fa fa-cog";
    },
    rotinaDescricao: function rotinaDescricao(signature) {
      return DESCRICOES_ROTINA[signature] || "Sem descrição cadastrada para esta rotina.";
    },
    resumoDe: function resumoDe(item) {
      return item.conteudo && item.conteudo.resumo ? item.conteudo.resumo : [];
    },
    errosDe: function errosDe(item) {
      return item.conteudo && item.conteudo.erros ? item.conteudo.erros : [];
    },
    formatErro: function formatErro(erro) {
      if (typeof erro == "string") return erro;
      if (erro && erro.error) return "Lote " + erro.lote + " (empresa " + erro.empresa + "): " + erro.error;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(erro);
    },
    fromNow: function fromNow(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).fromNow();
    },
    statusModifier: function statusModifier(rotina) {
      if (rotina.processando) return "processando";
      if (!rotina.ultima_execucao) return "inedita";
      if (rotina.executado == 0) return "erro";

      return "ok";
    },
    statusIcon: function statusIcon(rotina) {
      var icones = {
        processando: "fa fa-refresh fa-spin",
        inedita: "fa fa-minus-circle",
        erro: "fa fa-times-circle",
        ok: "fa fa-check-circle"
      };

      return icones[this.statusModifier(rotina)];
    },
    statusLabel: function statusLabel(rotina) {
      var labels = {
        processando: "Processando",
        inedita: "Nunca executado",
        erro: "Falhou",
        ok: "OK"
      };

      return labels[this.statusModifier(rotina)];
    }
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "conflitos-detalhe",
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasContent: function hasContent() {
      return !!(this.item && (this.item.log_erro && this.item.log_erro.length || this.item.log_warning && this.item.log_warning.length));
    }
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_filtrar__ = __webpack_require__(958);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-gerar-lote",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formFilter.id_empresa": function parentFormFilterId_empresa() {
      this.config.disabled.id_fdt = this.parent.formFilter.id_empresa ? false : true;
      this.config.disabled.id_funcionario = this.parent.formFilter.id_empresa ? false : true;

      this.parent.formFilter.id_fdt = null;
      this.parent.formFilter.id_funcionario = null;

      this.getFdt();
      this.getFuncionario();
    },
    "parent.formData.layout": function parentFormDataLayout() {
      this.config.hidden.tp_exa = ["S-2220", "S-2240"].indexOf(this.parent.formData.layout) == -1;

      if (this.config.hidden.tp_exa) {
        this.parent.formFilter.tp_exa = [];
      }
    },
    "parent.formFilter.empresa_envio_automatico": function parentFormFilterEmpresa_envio_automatico() {
      this.config.disabled.id_empresa = this.parent.formFilter.empresa_envio_automatico;
      this.parent.formFilter.id_tipo_status = [];

      if (this.parent.formFilter.empresa_envio_automatico) {
        this.parent.formFilter.id_empresa = null;
        this.parent.formFilter.id_fdt = null;
        this.parent.formFilter.id_funcionario = null;
        this.parent.formFilter.id_tipo_status = [328, 331, 336, 335, 330];
      }
    }
  },

  data: function data() {
    return {
      config: {
        tipo: [327],
        click: {
          id_empresa: this.getEmpresa,
          id_fdt: this.getFdt,
          id_funcionario: this.getFuncionario,
          mostrar: this.getMostrar,
          tp_exa: this.getTipoConsulta,
          empresa_envio_automatico: null
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          mostrar: false,
          tp_exa: false,
          empresa_envio_automatico: false
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: [],
          mostrar: [],
          tp_exa: [],
          empresa_envio_automatico: []
        },
        disabled: {
          id_fdt: true,
          id_funcionario: true,
          empresa_envio_automatico: false
        },
        hidden: {
          tp_exa: ["S-2220", "S-2240"].indexOf(this.parent.formData.layout) == -1
        },
        title: {
          model: 'empresa_envio_automatico',
          empresa_envio_automatico: 'Selecionar empresas com processamento automático dos lotes'
        },
        description: {
          empresa_envio_automatico: 'Essa campo permite selecionar automaticamente as empresas que estão definidas para processamento automático dos lotes em Esocial > Configurações >  Processar Lote'
        }
      },
      response: {},
      filterItems: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.filterItems = __WEBPACK_IMPORTED_MODULE_3__form_filtrar__["a" /* default */];

    this.getEmpresa();
    this.getMostrar();
    this.getTipoConsulta();
  },


  methods: {
    getTipoConsulta: function getTipoConsulta() {
      this.config.list.tp_exa = [{ codigo: "adm", nome: "Admissional" }, { codigo: "apos_adm,3", nome: "Após 3 meses do Admissional" }, { codigo: "apos_adm,6", nome: "Após 6 meses do Admissional" }, { codigo: "apos_adm,12", nome: "Após 12 meses do Admissional" }, { codigo: "ret_tra", nome: "Retorno ao Trabalho" }, { codigo: "mud_fun", nome: "Mudança de Risco Ocupacional" }, { codigo: "periodicidade,0", nome: "Periódico (Sem PCMSO)" }, { codigo: "periodicidade,3", nome: "Periódico a cada 3 meses" }, { codigo: "periodicidade,6", nome: "Periódico a cada 6 meses" }, { codigo: "periodicidade,12", nome: "Periódico a cada 12 meses" }, { codigo: "periodicidade,24", nome: "Periódico a cada 24 meses" }, { codigo: "periodicidade,36", nome: "Periódico a cada 36 meses" }, { codigo: "dem", nome: "Demissional" }];
    },
    getMostrar: function getMostrar() {
      this.config.list.mostrar = [{ id: 1, nome: "Apenas arquivos SEM XML gerado" }, { id: 2, nome: "Apenas arquivos COM XML gerado" }, { id: 3, nome: "Apenas arquivos SEM conflitos" }, { id: 4, nome: "Apenas arquivos COM conflitos" }];
    },
    getEmpresa: function getEmpresa(search) {
      var _this = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFdt: function getFdt(search) {
      var _this2 = this;

      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.parent.formFilter.id_empresa, {
        search: search
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },


    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.parent.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-logs",
  mixins: [],
  components: { EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a },

  props: {

    showForm: {
      type: Boolean,
      default: false
    },

    formData: {
      type: Object,
      default: {}
    }

  },

  watch: {
    showForm: function showForm() {
      this.showLogs = !this.showLogs;
      this.initialize();
    },
    formData: function formData() {}
  },

  data: function data() {
    return {
      showLogs: false,
      tabSelected: 'error'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.initialize();
  },


  methods: {
    initialize: function initialize() {
      if (this.formData.item && this.formData.item && this.formData.item.log_erro.length) {
        this.tabSelected = 'error';
      } else if (this.formData.item && this.formData.item && this.formData.item.log_warning.length) {
        this.tabSelected = 'warning';
      } else {
        this.tabSelected = 'file';
      }
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_paginate__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conflitos_detalhe__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conflitos_detalhe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__conflitos_detalhe__);









var STATUS_EMAIL = { PENDENTE: 72, ENVIANDO: 73, ENVIADO: 74, ERRO: 75 };

var STATUS_EMAIL_TIMELINE = [{ id: STATUS_EMAIL.PENDENTE, ordem: 1, descricao: "Pendente" }, { id: STATUS_EMAIL.ENVIANDO, ordem: 2, descricao: "Enviando" }, { id: STATUS_EMAIL.ENVIADO, ordem: 3, descricao: "Enviado" }, { id: STATUS_EMAIL.ERRO, ordem: 3, descricao: "Erro", erro: true }];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-tabela",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_2_common_fct___default.a],
  components: { EdPaginate: __WEBPACK_IMPORTED_MODULE_3_common_paginate___default.a, Download: __WEBPACK_IMPORTED_MODULE_4_common_download___default.a, ConflitosDetalhe: __WEBPACK_IMPORTED_MODULE_5__conflitos_detalhe___default.a },
  props: {
    tableHead: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    response: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loadingTable: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: null
    },
    onSearch: {
      type: Function,
      default: null
    },
    onDelete: {
      type: Function,
      default: null
    },
    onBulkGerarXml: {
      type: Function,
      default: null
    },
    onEditAll: {
      type: Function,
      default: null
    },
    disableCheckAll: {
      type: Boolean,
      default: false
    },
    editableRows: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: "Nenhum registro encontrado para os filtros atuais."
    }
  },
  data: function data() {
    return {
      checkAll: false,
      checkItem: [],
      sortKey: null,
      sortDesc: false,
      ppage: 50,
      lstPages: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500],
      popover: { open: false, type: null, payload: null, pos: {} },
      tooltip: { visible: false, text: "", top: 0, left: 0, below: false }
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.closePopover, true);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.closePopover, true);
  },

  watch: {
    tableData: function tableData() {
      this.checkAll = false;
      this.checkItem = [];
      this.closePopover();
    },
    pagination: function pagination() {
      this.ppage = this.pagination && this.pagination.per_page ? parseInt(this.pagination.per_page) : 50;
    }
  },
  computed: {
    colspan: function colspan() {
      return this.tableHead.length + (this.disableCheckAll ? 1 : 2);
    },
    selectedEligibleForXml: function selectedEligibleForXml() {
      var _this = this;

      return this.tableData.filter(function (row) {
        return _this.checkItem.indexOf(row._data.id) != -1 && row.buttons && row.buttons.some(function (btn) {
          return btn.title == "Gerar arquivo XML";
        });
      });
    },
    emptyMessage: function emptyMessage() {
      if (this.response && this.response.status && this.response.status != 200) {
        return this.response.status + (this.response.msg ? " - " + this.response.msg : "");
      }
      return this.emptyText;
    },
    sortedData: function sortedData() {
      if (!this.sortKey) return this.tableData;

      var key = this.sortKey;
      var desc = this.sortDesc;

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tableData)).sort(function (a, b) {
        var valA = (a[key] == null ? "" : a[key]).toString();
        var valB = (b[key] == null ? "" : b[key]).toString();
        var result = valA.localeCompare(valB, "pt-BR", { numeric: true });
        return desc ? -result : result;
      });
    }
  },
  methods: {
    toggleSort: function toggleSort(key) {
      if (this.sortKey != key) {
        this.sortKey = key;
        this.sortDesc = false;
      } else if (!this.sortDesc) {
        this.sortDesc = true;
      } else {
        this.sortKey = null;
        this.sortDesc = false;
      }
    },
    hasConflito: function hasConflito(data) {
      return !!(data && (data.log_erro && data.log_erro.length || data.log_warning && data.log_warning.length));
    },
    handleStatusClick: function handleStatusClick(col, data, event) {
      if (col.show_status_timeline) {
        this.togglePopover("timeline", data, data.id, event);
      } else if (this.hasConflito(data)) {
        this.toggleConflito(data, event);
      }
    },
    timelinePassos: function timelinePassos(data) {
      var erro = data.tipo_status && data.tipo_status.id == STATUS_EMAIL.ERRO;
      return STATUS_EMAIL_TIMELINE.filter(function (step) {
        return !step.erro || erro;
      });
    },
    timelineAtual: function timelineAtual(data) {
      var atualId = data.tipo_status ? data.tipo_status.id : null;
      return STATUS_EMAIL_TIMELINE.find(function (step) {
        return step.id == atualId;
      }) || STATUS_EMAIL_TIMELINE[0];
    },
    timelineStepIcon: function timelineStepIcon(step, data) {
      var atual = this.timelineAtual(data);

      if (step.ordem < atual.ordem) return "fa-check-circle";
      if (step.ordem == atual.ordem) return step.erro ? "fa-times-circle" : "fa-dot-circle-o";
      return "fa-circle-o";
    },
    conflitoCount: function conflitoCount(data) {
      return (data.log_erro ? data.log_erro.length : 0) + (data.log_warning ? data.log_warning.length : 0);
    },
    toggleConflito: function toggleConflito(data, event) {
      this.togglePopover("conflito", data, data.id, event);
    },
    toggleEventos: function toggleEventos(data, event) {
      this.togglePopover("eventos", data, event.currentTarget, event);
    },
    toggleReciboManual: function toggleReciboManual(data, event) {
      this.togglePopover("recibo_manual", data, data.id, event);
    },
    togglePopover: function togglePopover(type, payload, identity, event) {
      if (this.popover.open && this.popover.type == type && this.popover._identity == identity) {
        this.closePopover();
        return;
      }

      var rect = event.currentTarget.getBoundingClientRect();
      var estimatedHeight = 300;
      var left = Math.max(8, Math.min(rect.left, window.innerWidth - 340));
      var pos;

      if (window.innerHeight - rect.bottom < estimatedHeight) {
        pos = { left: left + "px", bottom: window.innerHeight - rect.top + 6 + "px", top: "auto" };
      } else {
        pos = { left: left + "px", top: rect.bottom + 6 + "px", bottom: "auto" };
      }

      this.popover = { open: true, type: type, payload: payload, pos: pos, _identity: identity };
    },
    closePopover: function closePopover() {
      if (this.popover.open) this.popover = { open: false, type: null, payload: null, pos: {} };
      this.hideTooltip();
    },
    showTooltip: function showTooltip(text, event) {
      if (!text) return;

      var rect = event.currentTarget.getBoundingClientRect();
      var below = rect.top < 60;

      this.tooltip = {
        visible: true,
        text: text,
        below: below,
        top: below ? rect.bottom + 8 : rect.top - 8,
        left: Math.max(70, Math.min(rect.left + rect.width / 2, window.innerWidth - 70))
      };
    },
    hideTooltip: function hideTooltip() {
      this.tooltip.visible = false;
    },
    clearSelection: function clearSelection() {
      this.checkAll = false;
      this.checkItem = [];
    },
    handleSelectAll: function handleSelectAll() {
      this.checkItem = this.checkAll ? this.tableData.filter(function (row) {
        return !(row.options && row.options.disable_select);
      }).map(function (row) {
        return row._data.id;
      }) : [];
    },
    handleSelectItem: function handleSelectItem() {
      this.checkAll = this.checkItem.length > 0 && this.checkItem.length == this.tableData.length;
    },
    handleBulkDelete: function handleBulkDelete() {
      if (this.checkItem.length && this.onDelete) {
        this.onDelete(this.checkItem);
        this.clearSelection();
      }
    },
    handleBulkGerarXml: function handleBulkGerarXml() {
      var ids = this.selectedEligibleForXml.map(function (row) {
        return row._data.id;
      });

      if (ids.length && this.onBulkGerarXml) {
        this.onBulkGerarXml(ids);
        this.clearSelection();
      }
    },
    handleBulkEditAll: function handleBulkEditAll() {
      var _this2 = this;

      var data = this.tableData.filter(function (row) {
        return _this2.checkItem.indexOf(row._data.id) != -1;
      }).map(function (row) {
        return row._data;
      });

      if (data.length && this.onEditAll) {
        this.onEditAll(data);
        this.clearSelection();
      }
    },
    handleNavigate: function handleNavigate(page) {
      if (this.onSearch) this.onSearch(this.search, page, this.ppage);
    },
    handlePerPage: function handlePerPage() {
      if (this.onSearch) this.onSearch(this.search, 1, this.ppage);
    },
    getUrlFuncionario: function getUrlFuncionario(_data) {
      if (this.$root.$session.sub_domain == "empresa") {
        return "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/funcionarios/editar/" + (_data.funcionario ? _data.funcionario.id : _data.id);
      }
      return this.env.url_cs + "/app/funcionarios_info.php?abre=" + (_data.funcionario ? _data.funcionario.id : _data.id);
    },
    getUrlEmpresa: function getUrlEmpresa(_data) {
      if (this.$root.$session.sub_domain == "empresa") {
        return "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/meu-cadastro?";
      }
      return this.env.url_cs + "/app/empresas_info.php?abre=" + (_data.empresa ? _data.empresa.id : _data.empresa_id);
    },
    getUrlConsulta: function getUrlConsulta(_data) {
      if (this.$root.$session.sub_domain == "empresa") return "#";
      return this.env.url_cs + "/app/consulta.php?con=" + _data.id_con;
    },
    btnStyle: function btnStyle(btn) {
      if (btn.style) return btn.style;

      var colors = { warning: "#a8791f", success: "#34c142", primary: "#09f", danger: "#c0392b", info: "#568cdd" };

      return btn.color && colors[btn.color] ? "color:" + colors[btn.color] : "";
    },
    hexToRgba: function hexToRgba(hex, alpha) {
      if (!hex) return "transparent";

      var h = hex.replace("#", "");
      if (h.length == 3) h = h.split("").map(function (c) {
        return c + c;
      }).join("");

      var r = parseInt(h.substring(0, 2), 16);
      var g = parseInt(h.substring(2, 4), 16);
      var b = parseInt(h.substring(4, 6), 16);

      return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    },
    getUrlLote: function getUrlLote(_data) {
      if (this.$root.$session.sub_domain == "empresa") {
        return "https://" + "empresa1.softwareatento.com.br" + "/" + this.$root.$session.cliente.tenant + "/esocial/gerar-lote" + (_data.lote ? "/" + _data.lote : "");
      }
      return "https://" + "web1.softwareatento.com.br" + "/esocial/lotes" + (_data.lote ? "/" + _data.lote : "");
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_xml_viewer__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_template__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_logs__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_filter__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__includes_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__includes_tabela__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__includes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__includes_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__includes_agendamento__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__includes_agendamento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__includes_agendamento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__s0000__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__s0000___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__s0000__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__s2210__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__s2210___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__s2210__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__s2220__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__s2220___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__s2220__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__s2240__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__s2240___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__s2240__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__s3000__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__s3000___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__s3000__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial",
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a, __WEBPACK_IMPORTED_MODULE_4_common_fct___default.a],
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_2_common_table___default.a,
    EsocialTabela: __WEBPACK_IMPORTED_MODULE_9__includes_tabela___default.a,
    Filters: __WEBPACK_IMPORTED_MODULE_8__includes_filter___default.a,
    Logs: __WEBPACK_IMPORTED_MODULE_7__includes_logs___default.a,
    Agendamento: __WEBPACK_IMPORTED_MODULE_10__includes_agendamento___default.a,
    s0000: __WEBPACK_IMPORTED_MODULE_11__s0000___default.a,
    s2220: __WEBPACK_IMPORTED_MODULE_13__s2220___default.a,
    s2210: __WEBPACK_IMPORTED_MODULE_12__s2210___default.a,
    s2240: __WEBPACK_IMPORTED_MODULE_14__s2240___default.a,
    s3000: __WEBPACK_IMPORTED_MODULE_15__s3000___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_6_template__["c" /* EdAlert */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_6_template__["e" /* EdInputText */],
    XmlViewer: __WEBPACK_IMPORTED_MODULE_5_vue_xml_viewer___default.a
  },
  watch: {
    "formData.layout": function formDataLayout(codigo) {
      this.formData.esocial_tabela = (this.config.list.esocial_tabela || []).find(function (tabela) {
        return tabela.codigo == codigo;
      }) || null;

      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        tp_exa: []
      };
      this.getEsocial(null, null, null);
    },
    "layout": function layout() {
      this.formData.layout = this.layout;
    },
    "lote": function lote() {
      this.getEsocial(null, null, null);
    }
  },
  props: {
    layout: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    lote: {
      type: [String, Number],
      default: function _default() {
        return null;
      }
    },
    avulso: {
      type: [Number],
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      config: {
        loading: {
          esocial_tabela: false,
          content: false,
          table: false,
          tableAntigo: false
        },
        list: {
          esocial_tabela: []
        }
      },
      formData: {
        layout: null,
        esocial_tabela: null,
        item: null,
        search: null,
        page: null,
        pagination: null,
        filter: null,
        empresa: null,
        arquivoConfig: {},
        result: {}
      },
      formDataXml: {},
      formFilter: {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: 1,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        tp_exa: []
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      showFilterModal: false,
      showAgendamento: false,
      showLogAntigo: false,
      showNovoXml: false,
      paginationAntigo: {},
      responseAntigo: {},
      filterBadgeAntigo: 0,
      tableHead: [],
      tableData: [],
      tableHeadAntigo: [],
      tableDataAntigo: [],
      showLogs: false,
      showModalUid: false,
      novoUid: null,
      novoRecibo: null,
      olduid: null,
      reciboManualInfo: null,
      showModalDownloadXML: false,
      xmlViewMode: "arvore",
      xmlPreview: {
        content: null,
        filename: null,
        blob: null,
        campos: []
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEsocialTabela();
  },


  methods: {
    onClear: function onClear() {
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico: 0,
        avulso: this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        tp_exa: []
      }, this.getEsocial(null, null, null);
    },
    onRegister: function onRegister() {
      this.formDataXml = {};
      this.showNovoXml = !this.showNovoXml;
    },
    onEditXml: function onEditXml(data) {
      this.showNovoXml = !this.showNovoXml;
      this.formDataXml = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, {});
    },
    onEdit: function onEdit(data) {
      this.onGerarArquivoXML([data.id], data.layout);
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var arrayExcluir = [];
      var avulso = false;

      if (data && data.id) {
        arrayExcluir.push(data.id);

        if (data.avulso == '1' && [328].indexOf(data.tipo_status.id) != -1) {
          avulso = true;
        }
      }

      if (!arrayExcluir.length) {
        this.edAlert("Arquivo indispoível para exclusão.", "error");
        return;
      }

      var msg = "O sistema vai excluir " + arrayExcluir.length + " arquivo(s) diretamente no eSocial e o processo não poderá ser desfeito. Deseja prosseguir?";

      if (!data.recibo) {
        msg = "O sistema vai excluir " + arrayExcluir.length + " arquivo(s) e o processo não poderá ser desfeito. Deseja prosseguir?";
      }

      this.$confirm(msg, "Atenção", {
        type: "warning"
      }).then(function () {
        _this.$root.$loading.set(true);
        _this.config.loading.content = true;

        var filter = {
          ids: [data.id]
        };

        var empresa_id = null;

        _this.post("esocial/" + _this.formData.layout + "/deletar", { ids: arrayExcluir }).then(function (result) {
          result = result[0];
          _this.config.loading.content = false;
          _this.$root.$loading.set(false);

          _this.getEsocial();

          if (result.status == 200) {

            if (avulso) {
              _this.edAlert("Evento excluído com sucesso.");
            } else {
              _this.edAlert("Evento de exclusão enviado para o eSocial.");
            }
          }
        });
      });
    },
    onGerarLote: function onGerarLote(data) {
      var _this2 = this;

      this.$confirm("O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this2.config.loading.content = true;
        _this2.$root.$loading.set(true);

        var filter = {
          ids: [data.id],
          avulso: _this2.avulso
        };

        var empresa_id = null;

        if (data.empresa) {
          empresa_id = data.empresa.id;
        } else if (data.ghe && data.ghe.ltcat) {
          empresa_id = data.ghe.ltcat.empresa.id;
        }

        _this2.get("esocial/lotes/gerar/" + data.layout + "/" + empresa_id, { filter: filter }).then(function (result) {
          result = result[0];
          _this2.config.loading.content = false;
          _this2.$root.$loading.set(false);

          _this2.getEsocial();

          if (result.status == 200) {
            _this2.edAlert("Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo.");
          } else {
            _this2.edAlert(result.msg, "error");
          }
        });
      });
    },
    onBulkGerarXml: function onBulkGerarXml(ids) {
      this.onGerarArquivoXML(ids, this.formData.layout);
    },
    onGerarArquivoXML: function onGerarArquivoXML(ids) {
      var _this3 = this;

      var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$confirm("Tem certeza que deseja gerar o xml dos registro(s) selecionados?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this3.config.loading.content = true;
        _this3.$root.$loading.set(true);

        var filter = {
          ids: ids,
          avulso: _this3.avulso
        };

        _this3.get("esocial/" + (layout ? layout : _this3.formData.layout) + "/gerar-arquivo-xml", {
          filter: filter
        }).then(function (result) {
          result = result[0];

          _this3.config.loading.content = false;
          _this3.$root.$loading.set(false);

          _this3.getEsocial();

          if (result.status == 200) {
            _this3.edMsg("Operação realizada com sucesso");
          } else {
            _this3.edAlert(result.msg, "error");
          }
        });
      });
    },
    onDownloadXML: function onDownloadXML(data) {
      if (!data.xml) return;

      var filename = data.uid + ".xml";
      var content = atob(data.xml);

      this.xmlViewMode = "arvore";
      this.xmlPreview = {
        content: content,
        filename: filename,
        blob: this.b64toBlob(data.xml, "application/xml"),
        campos: this.xmlToCampos(content)
      };

      this.showModalDownloadXML = true;
    },
    xmlToCampos: function xmlToCampos(xml) {
      var campos = [];

      try {
        var doc = new DOMParser().parseFromString(xml, "text/xml");

        var percorrer = function percorrer(node, caminho) {
          var filhosElemento = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(node.childNodes).filter(function (n) {
            return n.nodeType === 1;
          });

          if (!filhosElemento.length) {
            var valor = (node.textContent || "").trim();

            if (valor) {
              campos.push({ caminho: caminho, valor: valor });
            }

            return;
          }

          filhosElemento.forEach(function (filho) {
            percorrer(filho, caminho ? caminho + " > " + filho.nodeName : filho.nodeName);
          });
        };

        if (doc.documentElement) {
          percorrer(doc.documentElement, doc.documentElement.nodeName);
        }
      } catch (e) {
        campos = [];
      }

      return campos;
    },
    downloadXMLPreview: function downloadXMLPreview() {
      if (!this.xmlPreview.blob) return;

      this.download(this.xmlPreview.blob, this.xmlPreview.filename);
    },
    onDispararWhatsappAtualizarMatriculaContador: function onDispararWhatsappAtualizarMatriculaContador(data) {
      var self = this;
      var idFuncionario = data.funcionario ? data.funcionario.id : data.id_fun;

      this.$confirm("Enviar WhatsApp ao contador solicitando a correção da matrícula/categoria do funcionário?", "Atenção", { type: "warning" }).then(function () {
        self.post("esocial/funcionario/" + idFuncionario + "/disparar-whatsapp-atualizar-matricula-contador", {}).then(function (result) {
          result = result[0];

          if (result.status == 200 && result.data.success) {
            self.edMsg("WhatsApp enviado ao contador com sucesso.");
          } else {
            self.edMsg(result.data && result.data.message || "Não foi possível enviar o WhatsApp.", "error");
          }
        });
      });
    },
    onUpdateUid: function onUpdateUid(data) {
      this.olduid = data.uid;
      this.novoUid = data.uid;
      this.novoRecibo = data.recibo;
      this.reciboManualInfo = data.usuario_recibo_manual ? {
        usuario: data.usuario_recibo_manual.usuario,
        data: this.toDate(data.recibo_manual_at)
      } : null;
      this.showModalUid = !this.showModalUid;
    },
    saveUid: function saveUid() {
      var _this4 = this;

      this.$root.$loading.set(true);
      this.config.loading.content = true;

      this.post("esocial/update-uid", {
        novoUid: this.novoUid,
        antigoUid: this.olduid,
        novoRecibo: this.novoRecibo
      }).then(function (result) {
        result = result[0];

        _this4.config.loading.content = false;
        _this4.$root.$loading.set(false);

        if (result.status == 200) {
          _this4.showModalUid = !_this4.showModalUid;
          _this4.edMsg("Operação realizada com sucesso");

          _this4.getEsocial();
        }
      });
    },
    onLogs: function onLogs(data) {
      this.formData.item = data;
      this.showLogs = !this.showLogs;
    },
    getEsocialTabela: function getEsocialTabela(_search, _page, _pagination) {
      var _this5 = this;

      this.config.loading.esocial_tabela = true;
      this.config.list.esocial_tabela = [];

      this.get("esocial/tabelas/conteudo/9", {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];

        _this5.config.loading.esocial_tabela = false;

        if (result.status == 200) {
          _this5.config.list.esocial_tabela = result.data.data;

          if (_this5.config.list.esocial_tabela.length && !_this5.formData.esocial_tabela) {
            _this5.formData.esocial_tabela = _this5.config.list.esocial_tabela[0];
            _this5.formData.layout = _this5.config.list.esocial_tabela[0].codigo;
          }
        }
      });
    },
    getEsocial: function getEsocial() {
      var _search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formData.search;

      var _this6 = this;

      var _page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.formData.page;

      var _pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.formData.pagination;

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.empresa_envio_automatico ? 1 : 0) + (this.formFilter.data_cadastro && this.formFilter.data_cadastro[0] && this.formFilter.data_cadastro[1] ? 1 : 0) + (this.formFilter.mostrar && this.formFilter.mostrar.length > 0 ? 1 : 0) + (this.formFilter.id_tipo_status && this.formFilter.id_tipo_status.length > 0 ? 1 : 0) + (this.formFilter.tp_exa && this.formFilter.tp_exa.length > 0 ? 1 : 0);

      if (this.lote) {
        this.formFilter['lote'] = this.lote;
      }

      this.formData.search = _search;
      this.formData.page = _page;
      this.formData.pagination = _pagination;

      this.config.loading.table = true;
      this.response = {};
      this.pagination = {};

      this.config.loading.tableAntigo = true;
      this.responseAntigo = {};
      this.paginationAntigo = {};

      if (this.layout) {
        this.formData.layout = this.layout;
      }

      var url = "esocial/" + this.formData.layout;
      if (this.avulso) {
        url = "esocial/avulso";
      }

      this.get(url, {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this6.response = result;
        _this6.config.loading.table = false;

        if (result.status == 200) {
          _this6.pagination = result;
        }
      });
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "esocial-lotes",
    mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
    components: {},
    data: function data() {
        return {
            loadingContent: true,
            loadingDownload: false,
            error: null,
            formData: {}
        };
    },
    created: function created() {
        $('.carregando').hide();
    },
    mounted: function mounted() {
        this.getEsocialLote();
    },


    methods: {

        toDate: function toDate(data, disableHours) {
            return __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.toDate(data, disableHours);
        },

        getEsocialLote: function getEsocialLote() {
            var _this = this;

            this.loadingContent = true;
            this.loadingDownload = true;
            this.error = null;

            var _email = this.$route.params.email ? this.$route.params.email : null;

            this.get('/util/esocial/arquivo/' + this.$route.params.link, { email: _email }).then(function (result) {

                result = result[0];

                _this.loadingContent = false;

                if (result.status == 200) {
                    _this.formData = result.data;
                    _this.onDownloadArquivo();
                } else {
                    _this.error = result.msg;
                }
            });
        },

        onDownloadArquivo: function onDownloadArquivo() {

            this.loadingDownload = false;

            if (this.formData.contents) {

                var contents = this.formData.contents;
                var filename = this.formData.filename;
                var contentType = this.formData.contentType;

                var blob = __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.b64toBlob(contents, contentType);

                __WEBPACK_IMPORTED_MODULE_1_common_fct___default.a.download(blob, filename);

                this.getEsocialLotes();
            } else {

                this.$alert('Não foi possível baixar o arquivo', 'Atenção', {
                    confirmButtonText: 'OK',
                    type: 'info'
                });
            }
        }

    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_tabela__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__includes_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_lote_email_cadastro__ = __webpack_require__(960);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-email",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_0_common_form___default.a, EsocialTabela: __WEBPACK_IMPORTED_MODULE_2__includes_tabela___default.a },
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },

  watch: {
    showForm: function showForm() {
      this.showFormList = !this.showFormList;

      if (this.showFormList) {
        this.getLog();
      }
    }
  },

  computed: {
    emailsValidos: function emailsValidos() {
      var regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return (this.formData.destinatario || "").split(";").map(function (email) {
        return email.trim();
      }).filter(function (email) {
        return email.length && regexEmail.test(email);
      });
    }
  },

  data: function data() {
    return {
      config: {
        click: {},
        loading: {
          save: false,
          content: false
        },
        list: {}
      },
      response: {},
      pagination: {},
      search: null,
      tableHead: [{
        key: "destinatario",
        sortable: true,
        label: "Destinatário"
      }, {
        key: "tipo_status",
        label: "Status",
        show_status_timeline: true
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      formData: {
        destinatario: null
      },
      tableData: [],
      formItems: [],
      loadingTable: false,
      showFormList: false,
      showFormRegister: false,
      showPreview: false,
      loadingPreview: false,
      previewHtml: null
    };
  },
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_lote_email_cadastro__["a" /* default */];
  },


  methods: {
    closeList: function closeList() {
      this.showFormList = false;
    },
    closeRegister: function closeRegister() {
      this.showFormRegister = false;
    },
    onRegister: function onRegister() {
      this.showFormRegister = true;
    },
    abrirPreviewEmail: function abrirPreviewEmail() {
      var _this = this;

      this.showPreview = true;
      this.loadingPreview = true;
      this.previewHtml = null;

      this.get("esocial/lotes/" + this.parent.formData.id + "/email/preview").then(function (result) {
        _this.previewHtml = result[0];
        _this.loadingPreview = false;
      });
    },
    closePreview: function closePreview() {
      this.showPreview = false;
    },
    getLog: function getLog(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("log/email/esocial-lote/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {
          data = result.data.data;
          pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            tableData.push({
              destinatario: data[i].destinatario ? data[i].destinatario.split(";").join("<br>") : "---",
              updated_at: _this2.toDate(data[i].created_at),
              _data: data[i],
              buttons: []
            });
          }
        }

        _this2.pagination = pagination;
        _this2.tableData = tableData;
        _this2.loadingTable = false;
      });
    },
    validarEmails: function validarEmails() {
      var destinatario = (this.formData.destinatario || "").trim();

      if (!destinatario) {
        return { destinatario: ["Campo Obrigatório"] };
      }

      var regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var emails = destinatario.split(";").map(function (email) {
        return email.trim();
      }).filter(function (email) {
        return email.length;
      });
      var invalidos = emails.filter(function (email) {
        return !regexEmail.test(email);
      });

      if (invalidos.length) {
        return { destinatario: ["Email inválido: " + invalidos.join(", ")] };
      }

      if (!this.emailsValidos.length) {
        return { destinatario: ["Informe ao menos um email válido"] };
      }

      return null;
    },
    salvar: function salvar() {
      var _this3 = this;

      var erros = this.validarEmails();

      if (erros) {
        this.response = { status: 400, options: { data: erros } };
        return;
      }

      this.config.loading.save = true;
      this.response = {};

      this.post("esocial/lotes/" + this.parent.formData.id + "/email", this.formData).then(function (result) {
        _this3.config.loading.save = false;

        result = result[0];
        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg("Email cadastrado com sucesso");
          _this3.closeRegister();
          _this3.getLog();
        }
      });
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(33);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-gerar",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdForm */],
    EdAlert: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdAlert */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_1_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdInputSelect */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputDate */]
  },
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    showForm: function showForm() {
      this.showFormEdit = this.showForm;

      if (this.showFormEdit) {
        this.resultado = null;
      }
    },
    "formData.id_emp": function formDataId_emp() {
      this.getFdt();
      this.getFuncionario();
    }
  },

  computed: {
    totalFiltrosAtivos: function totalFiltrosAtivos() {
      var f = this.formData;
      var total = 0;

      if (f.fdts && f.fdts.length) total++;
      if (f.funcionarios && f.funcionarios.length) total++;
      if (f.funcionarios_delete && f.funcionarios_delete.length) total++;
      if (f.created_at && f.created_at.length) total++;
      if (f.avulso) total++;

      return total;
    }
  },

  data: function data() {
    return {
      config: {
        loading: {
          save: false,
          content: false,
          id_emp: false,
          layout: false,
          id_fdt: false,
          id_fun: false
        },
        list: {
          id_emp: [],
          layout: [],
          id_fdt: [],
          id_fun: []
        }
      },
      resultado: null,
      showFiltros: false,
      formData: {
        id_emp: null,
        layout: null,
        avulso: 0,
        created_at: [],
        fdts: [],
        funcionarios: [],
        funcionarios_delete: []
      },
      showFormEdit: false
    };
  },
  mounted: function mounted() {
    this.getLayout();
    this.getEmpresa();
  },


  methods: {
    close: function close() {
      this.showFormEdit = false;

      if (this.parent.showFormEdit) {
        this.parent.showFormEdit = false;
      }
    },


    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];
        _this.config.loading.id_emp = false;

        if (result.status == 200) {
          _this.config.list.id_emp = result.data.data;
        }
      });
    },

    getFdt: function getFdt(_search) {
      var _this2 = this;

      if (!this.formData.id_emp) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formData.id_emp, { search: _search }).then(function (result) {
        result = result[0];
        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formData.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_fun = false;

        if (result.status == 200) {
          _this3.config.list.id_fun = result.data.data;
        }
      });
    },
    getLayout: function getLayout(_search) {
      var _this4 = this;

      this.config.loading.layout = true;
      this.config.list.layout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(function (result) {
        result = result[0];

        _this4.config.loading.layout = false;

        if (result.status == 200) {
          _this4.config.list.layout = result.data.data;
        }
      });
    },

    salvar: function salvar() {
      var _this5 = this;

      if (!this.formData.id_emp || !this.formData.layout) {
        this.edAlert("Selecione a empresa e o layout", "error");
        return;
      }

      this.$confirm("O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this5.config.loading.save = true;
        _this5.resultado = null;

        var filter = {
          id_empresa: _this5.formData.id_emp,
          created_at: _this5.formData.created_at,
          fdts: _this5.formData.fdts,
          funcionarios: _this5.formData.funcionarios,
          funcionarios_delete: _this5.formData.funcionarios_delete,
          avulso: _this5.formData.avulso
        };

        _this5.get("esocial/lotes/gerar/" + _this5.formData.layout.codigo, {
          filter: filter
        }).then(function (result) {
          _this5.config.loading.save = false;

          result = result[0];

          if (result.status == 200) {
            _this5.resultado = result.data || { total_lotes: 0, total_eventos: 0 };

            if (_this5.parent.getEsocialLotes) _this5.parent.getEsocialLotes(_this5.parent.search);

            if (_this5.resultado.total_lotes) {
              _this5.edAlert("Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo.");
            }
          } else {
            _this5.edAlert(result.msg, "error");
          }
        });
      });
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: {
    XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdButton */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdInputSelect */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_1_template__["f" /* EdInputDate */]
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    },
    loadingFuncionario: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {},
    loadingFuncionario: function loadingFuncionario() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      loading: false,
      erro: null,
      consultadoEm: {},
      lstLayout: [{ codigo: "S-1000", nome: "S-1000" }, { codigo: "S-1005", nome: "S-1005" }, { codigo: "S-1010", nome: "S-1010" }, { codigo: "S-1020", nome: "S-1020" }, { codigo: "S-1030", nome: "S-1030" }, { codigo: "S-1035", nome: "S-1035" }, { codigo: "S-1040", nome: "S-1040" }, { codigo: "S-1050", nome: "S-1050" }, { codigo: "S-1060", nome: "S-1060" }, { codigo: "S-1065", nome: "S-1065" }, { codigo: "S-1070", nome: "S-1070" }, { codigo: "S-1080", nome: "S-1080" }, { codigo: "S-1200", nome: "S-1200" }, { codigo: "S-1202", nome: "S-1202" }, { codigo: "S-1207", nome: "S-1207" }, { codigo: "S-1210", nome: "S-1210" }, { codigo: "S-1250", nome: "S-1250" }, { codigo: "S-1260", nome: "S-1260" }, { codigo: "S-1270", nome: "S-1270" }, { codigo: "S-1280", nome: "S-1280" }, { codigo: "S-1295", nome: "S-1295" }, { codigo: "S-1298", nome: "S-1298" }, { codigo: "S-1299", nome: "S-1299" }, { codigo: "S-1300", nome: "S-1300" }, { codigo: "S-2190", nome: "S-2190" }, { codigo: "S-2200", nome: "S-2200" }, { codigo: "S-2205", nome: "S-2205" }, { codigo: "S-2206", nome: "S-2206" }, { codigo: "S-2210", nome: "S-2210" }, { codigo: "S-2220", nome: "S-2220" }, { codigo: "S-2230", nome: "S-2230" }, { codigo: "S-2240", nome: "S-2240" }, { codigo: "S-2241", nome: "S-2241" }, { codigo: "S-2245", nome: "S-2245" }, { codigo: "S-2250", nome: "S-2250" }, { codigo: "S-2298", nome: "S-2298" }, { codigo: "S-2299", nome: "S-2299" }, { codigo: "S-2300", nome: "S-2300" }, { codigo: "S-2306", nome: "S-2306" }, { codigo: "S-2399", nome: "S-2399" }, { codigo: "S-2400", nome: "S-2400" }, { codigo: "S-3000", nome: "S-3000" }, { codigo: "S-5001", nome: "S-5001" }, { codigo: "S-5002", nome: "S-5002" }, { codigo: "S-5011", nome: "S-5011" }, { codigo: "S-5012", nome: "S-5012" }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/evento-empresa", this.formData).then(function (result) {
        _this.loading = false;

        if (result.status == 200) {
          _this.formData.strXml = result.data;
          _this.consultadoEm = {
            layout: _this.formData.layout,
            periodo: _this.formData.periodo,
            empresa: _this.empresaSelecionada(),
            data: _this.toDate(new Date())
          };
        } else {
          _this.erro = result.msg || "Não foi possível consultar os eventos do empregador no eSocial.";
        }
      });
    },
    empresaSelecionada: function empresaSelecionada() {
      var _this2 = this;

      var empresa = (this.lstEmpresa || []).find(function (e) {
        return e.id == _this2.formData.id_emp;
      });
      return empresa ? empresa.nome : this.formData.id_emp;
    },
    toDate: function toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: {
    XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdButton */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputDate */]
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      lstFuncionario: [],
      loadingFuncionario: false,
      loading: false,
      erro: null,
      consultadoEm: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    getFuncionario: function getFuncionario(_search) {
      var _this = this;

      if (!this.formData.id_emp) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search
      }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this.lstFuncionario = result.data.data;
        }
        _this.loadingFuncionario = false;
      });
    },
    consultar: function consultar() {
      var _this2 = this;

      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/" + this.formData.id_fun + "/evento-funcionario", this.formData).then(function (result) {
        _this2.loading = false;

        if (result.status == 200) {
          _this2.formData.strXml = result.data;
          _this2.consultadoEm = {
            funcionario: _this2.funcionarioSelecionado(),
            periodo: _this2.formData.data_inicio + " a " + _this2.formData.data_fim,
            empresa: _this2.empresaSelecionada(),
            data: _this2.toDate(new Date())
          };
        } else {
          _this2.erro = result.msg || "Não foi possível consultar os eventos do trabalhador no eSocial.";
        }
      });
    },
    empresaSelecionada: function empresaSelecionada() {
      var _this3 = this;

      var empresa = (this.lstEmpresa || []).find(function (e) {
        return e.id == _this3.formData.id_emp;
      });
      return empresa ? empresa.nome : this.formData.id_emp;
    },
    funcionarioSelecionado: function funcionarioSelecionado() {
      var _this4 = this;

      var funcionario = (this.lstFuncionario || []).find(function (f) {
        return f.id == _this4.formData.id_fun;
      });
      return funcionario ? funcionario.nome : this.formData.id_fun;
    },
    toDate: function toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    }
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdForm */], EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdButton */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdInputSelect */], EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["e" /* EdInputText */] },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      loading: false,
      erro: null,
      consultadoEm: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/protocolo", this.formData).then(function (result) {
        _this.loading = false;

        if (result.status == 200) {
          _this.formData.strXml = result.data;
          _this.consultadoEm = {
            busca: _this.formData.busca,
            empresa: _this.empresaSelecionada(),
            data: _this.toDate(new Date())
          };
        } else {
          _this.erro = result.msg || "Não foi possível consultar o protocolo no eSocial.";
        }
      });
    },
    empresaSelecionada: function empresaSelecionada() {
      var _this2 = this;

      var empresa = (this.lstEmpresa || []).find(function (e) {
        return e.id == _this2.formData.id_emp;
      });
      return empresa ? empresa.nome : this.formData.id_emp;
    },
    toDate: function toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer: __WEBPACK_IMPORTED_MODULE_0_vue_xml_viewer___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_template__["a" /* EdForm */], EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdButton */], EdInputSelect: __WEBPACK_IMPORTED_MODULE_1_template__["b" /* EdInputSelect */], EdInputText: __WEBPACK_IMPORTED_MODULE_1_template__["e" /* EdInputText */] },

  props: {
    lstEmpresa: {
      type: [Array],
      default: []
    },
    loadingEmpresa: {
      type: Boolean,
      default: false
    }
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function handler(newVal) {},
      deep: true
    },
    loadingEmpresa: function loadingEmpresa() {}
  },

  data: function data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null
      },
      loading: false,
      erro: null,
      consultadoEm: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},


  methods: {
    consultar: function consultar() {
      var _this = this;

      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request.post("esocial/lotes/consultar/" + this.formData.id_emp + "/recibo", this.formData).then(function (result) {
        _this.loading = false;

        if (result.status == 200) {
          _this.formData.strXml = result.data;
          _this.consultadoEm = {
            busca: _this.formData.busca,
            empresa: _this.empresaSelecionada(),
            data: _this.toDate(new Date())
          };
        } else {
          _this.erro = result.msg || "Não foi possível consultar o recibo no eSocial.";
        }
      });
    },
    empresaSelecionada: function empresaSelecionada() {
      var _this2 = this;

      var empresa = (this.lstEmpresa || []).find(function (e) {
        return e.id == _this2.formData.id_emp;
      });
      return empresa ? empresa.nome : this.formData.id_emp;
    },
    toDate: function toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    }
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_consulta_protocolo_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_consulta_protocolo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__includes_consulta_protocolo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_consulta_recibo_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_consulta_recibo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_consulta_recibo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_consulta_evento_trabalhador_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_consulta_evento_trabalhador_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__includes_consulta_evento_trabalhador_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_empresa_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_empresa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_empresa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_tabela__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gerar__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gerar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gerar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__email_index__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__email_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__processar_index__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__processar_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__processar_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__item_index__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__item_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__item_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__includes_agendamento__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__includes_agendamento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__includes_agendamento__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  components: {
    EsocialTabela: __WEBPACK_IMPORTED_MODULE_7__includes_tabela___default.a,
    GerarLote: __WEBPACK_IMPORTED_MODULE_8__gerar___default.a,
    EmailLote: __WEBPACK_IMPORTED_MODULE_9__email_index___default.a,
    Processar: __WEBPACK_IMPORTED_MODULE_10__processar_index___default.a,
    Item: __WEBPACK_IMPORTED_MODULE_11__item_index___default.a,
    Agendamento: __WEBPACK_IMPORTED_MODULE_12__includes_agendamento___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdForm */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdAlert: __WEBPACK_IMPORTED_MODULE_2_template__["c" /* EdAlert */],
    ConsultaProtocolo: __WEBPACK_IMPORTED_MODULE_3__includes_consulta_protocolo_vue___default.a,
    ConsultaRecibo: __WEBPACK_IMPORTED_MODULE_4__includes_consulta_recibo_vue___default.a,
    ConsultaEventoTrabalhador: __WEBPACK_IMPORTED_MODULE_5__includes_consulta_evento_trabalhador_vue___default.a,
    ConsultaEventoEmpresa: __WEBPACK_IMPORTED_MODULE_6__includes_consulta_evento_empresa_vue___default.a
  },
  provide: function provide() {
    return {
      formData: this.formData,
      getEmpresa: this.getEmpresa,
      getFuncionario: this.getFuncionario,
      getLayout: this.getLayout,
      parent: this
    };
  },
  data: function data() {
    return {
      response: {},
      pagination: {},
      formData: {},
      search: null,
      showFilterModal: false,
      tableHead: [{
        key: "lote",
        sortable: true,
        width: "150px",
        bold: true,
        label: "Lote"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "layout",
        sortable: true,
        label: "Layout"
      }, {
        key: "eventos",
        show_eventos: true,
        label: "Eventos"
      }, {
        key: "arquivo",
        show_arquivo: true,
        label: "Arquivo"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização",
        info: "Data da última alteração deste lote: eventos adicionados/removidos, geração do arquivo XML ou atualização do status de processamento."
      }],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstLayout: [],
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        layout: null
      },
      showFormEdit: false,
      showAgendamento: false,
      showFormEmail: false,
      showFormProcessar: false,
      loadingTable: false,
      loadingEmpresa: false,
      loadingFuncionario: false,
      boolExibirConsultaProtocolo: false,
      showFormItem: false,
      filterBadge: 0,
      tabSelected: "tab-consulta-protocolo"
    };
  },
  created: function created() {
    this.getEsocialLotes(this.$route.params.lote);
  },
  mounted: function mounted() {
    this.getEmpresa();
    this.getLayout();
  },


  methods: {
    onRegister: function onRegister(init) {
      this.showFormEdit = !this.showFormEdit;
    },
    onEmail: function onEmail(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout
      };
      this.showFormEmail = !this.showFormEmail;
    },
    onItem: function onItem(data) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        id: data.id,
        lote: data.lote,
        layout: data.layout,
        avulso: data.avulso
      }, {});
      this.showFormItem = !this.showFormItem;
    },
    onProcessar: function onProcessar(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout
      };
      this.showFormProcessar = !this.showFormProcessar;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingTable = true;

        _this.post("esocial/lotes/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getEsocialLotes();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },
    onClearFilter: function onClearFilter() {
      this.formFilter.id_empresa = null;
      this.formFilter.id_funcionario = null;

      this.getEsocialLotes(this.search, 1);
    },
    onLayoutTab: function onLayoutTab(codigo) {
      this.formFilter.layout = codigo;
      this.getEsocialLotes(this.search, 1);
    },
    getLayout: function getLayout(_search) {
      var _this2 = this;

      this.lstLayout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(function (result) {
        result = result[0];

        if (result.status == 200) {
          _this2.lstLayout = result.data.data;
        }
      });
    },
    getEmpresa: function getEmpresa(_search) {
      var _this3 = this;

      this.lstEmpresa = [];
      this.loadingEmpresa = true;

      this.get("/empresa", { search: _search }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this3.lstEmpresa = result.data.data;
        }
        _this3.loadingEmpresa = false;
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this4 = this;

      if (!this.formFilter.id_empresa) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search
      }).then(function (result) {
        result = result[0];
        if (result.status == 200) {
          _this4.lstFuncionario = result.data.data;
        }
        _this4.loadingFuncionario = false;
      });
    },
    getEsocialLotes: function getEsocialLotes() {
      var _this5 = this;

      var _search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.search;

      var _page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.pagination.current_page;

      this.loadingTable = true;
      this.response = {};
      this.search = _search;

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0);

      this.get("esocial/lotes", {
        page: _page,
        search: _search,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this5.response = result;

        _this5.loadingTable = false;

        if (result.status == 200) {
          _this5.formataLista(result);
        }
      });
    },
    formataLista: function formataLista(result) {
      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].fdt = arrData[i].empresa.fdt && arrData[i].empresa.fdt.length ? arrData[i].empresa.fdt[0] : null;

        var item = {
          lote: arrData[i].lote,
          empresa: arrData[i].empresa.nome,
          layout: arrData[i].layout,
          eventos: {
            total: arrData[i].total_evento,
            enviado: arrData[i].total_evento_enviado,
            erro: arrData[i].total_evento_erro
          },
          arquivo: arrData[i].arquivo,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          updated_at: this.toDate(arrData[i].updated_at, false),
          _data: arrData[i],
          buttons: [{
            icon: "fa fa-envelope",
            color: "warning",
            title: "Enviar Lote por Email",
            click: this.onEmail
          }],
          options: {}
        };

        if (this.$root.$session.validarPacote(30)) {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Processar Lote",
            click: this.onProcessar
          });
        }

        if (true) {
          item.buttons.push({
            icon: "fa fa-th-list",
            color: "primary",
            title: "Visualizar items no arquivo",
            click: this.onItem
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    }
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_esocial_index__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_esocial_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_appsWeb_esocial_index__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-item",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  components: { eSocial: __WEBPACK_IMPORTED_MODULE_1_appsWeb_esocial_index___default.a },
  props: {
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  inject: ["formData", "parent"],
  watch: {
    showForm: function showForm() {
      this.showFormList = !this.showFormList;
    }
  },
  data: function data() {
    return {
      showFormList: false
    };
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__includes_tabela__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__includes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__includes_tabela__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-lotes-processar",
  mixins: [],
  components: { EsocialTabela: __WEBPACK_IMPORTED_MODULE_0__includes_tabela___default.a },
  inject: ["parent"],
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },

  watch: {
    formData: function formData() {
      this.getEsocialLotesProcessar();
    },
    showForm: function showForm() {
      this.showFormList = !this.showFormList;
    }
  },

  data: function data() {
    return {
      loadingContent: false,
      showFormList: false,
      showLogs: false,
      showModo: false,
      titleLogsReq: null,
      showLogsReq: false,
      messageLogsReq: null,
      pagination: {},
      formDataLogs: {},
      tableHead: [{
        key: "id",
        sortable: true,
        width: "150px",
        bold: true,
        label: "ID"
      }, {
        key: "modo",
        label: "Modo"
      }, {
        key: "status",
        label: "Status"
      }, {
        key: "mensagem",
        label: "Mensagem"
      }, {
        key: "protocolo",
        label: "Protocolo"
      }, {
        key: "data_recepcao",
        label: "Data Recepção"
      }, {
        key: "data_envio",
        label: "Data Envio"
      }],
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getEsocialLotesProcessar();
  },


  methods: {
    toDate: function toDate(date, disabledHours) {
      return this.$utilidade.toDate(date, disabledHours);
    },

    formatXml: function formatXml(xml) {
      if (!xml) return "";

      var formatted = "";
      var pad = 0;

      xml.replace(/(>)(<)(\/*)/g, "$1\r\n$2$3").split("\r\n").forEach(function (node) {
        var indent = 0;

        if (node.match(/.+<\/\w[^>]*>$/)) {
          indent = 0;
        } else if (node.match(/^<\/\w/)) {
          if (pad !== 0) pad -= 1;
        } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
          indent = 1;
        }

        formatted += "  ".repeat(Math.max(0, pad)) + node + "\r\n";
        pad += indent;
      });

      return formatted.trim();
    },
    getEsocialLotesProcessar: function getEsocialLotesProcessar() {
      var _this = this;

      if (!this.formData.id) return;

      this.loadingContent = true;

      this.$root.$request.get("esocial/lotes/processar/" + this.formData.id).then(function (result) {
        _this.loadingContent = false;

        if (result.status == 200) {
          _this.formataLista(result);
        }
      });
    },
    onRegister: function onRegister(data, modo) {
      if (!modo) {
        this.showModo = !this.showModo;
        return;
      }

      var self = this;
      this.$root.$dialog.confirm("Tem certeza que deseja enviar esse lote para o eSocial?").then(function () {
        self.$root.$loading.set(true);

        self.$root.$request.get("esocial/lotes/processar/" + self.formData.id + "/enviar-lote/" + modo).then(function (result) {
          self.$root.$loading.set(false);

          if (result.status == 200) {
            self.formataLista(result);
            self.showModo = false;
          } else if (result.msg) {
            self.$root.$dialog.alert(result.msg, "error");
          }
        });
      });
    },
    onAtualizarProtocolo: function onAtualizarProtocolo(data) {
      var _this2 = this;

      this.loadingContent = true;

      this.$root.$request.get("esocial/lotes/processar/" + this.formData.id + "/" + data.id + "/consultar-lote").then(function (result) {
        _this2.loadingContent = false;

        if (result.status == 200) {
          _this2.formataLista(result);
          _this2.parent.getEsocialLotes();
        } else if (result.msg) {
          _this2.$alert(result.msg, "Atenção", {
            confirmButtonText: "OK"
          });
        }
      });
    },
    onLogs: function onLogs(data) {
      this.formDataLogs = data;
      this.showLogs = !this.showLogs;
    },
    onLogsReqSend: function onLogsReqSend(data) {
      this.titleLogsReq = "Dados enviados";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_request;
    },
    onLogsReqReceiv: function onLogsReqReceiv(data) {
      this.titleLogsReq = "Dados recebidos";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_response;
    },


    parseModo: function parseModo(modo) {
      if (!modo) return;

      return modo.replace("INC", "Inclusão").replace("ALT", "Alteração").replace("EXC", "Exclusão");
    },

    formataLista: function formataLista(result) {
      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].loading = false;
        arrData[i].log_retorno = arrData[i].log_retorno ? this.$utilidade.stringToArray(arrData[i].log_retorno) : null;

        var item = {
          id: arrData[i].id,
          modo: this.parseModo(arrData[i].modo),
          status: arrData[i].status,
          mensagem: arrData[i].msg,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          request: arrData[i].request,
          response: arrData[i].response,
          data_recepcao: this.$utilidade.toDate(arrData[i].data_recepcao, false),
          data_envio: this.$utilidade.toDate(arrData[i].created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {}
        };

        item.buttons.push({
          icon: "fa fa-refresh",
          color: "primary",
          title: "Consultar Protocolo",
          click: this.onAtualizarProtocolo
        });

        if (arrData[i].log_retorno && arrData[i].log_retorno.length > 0) {
          item.buttons.push({
            icon: "fa fa-search",
            color: "warning",
            title: "Detalhes do Envio",
            click: this.onLogs
          });

          if (arrData[i].log_request) {
            item.buttons.push({
              icon: "fa fa-cloud-upload",
              color: "warning",
              title: "Visualizar dados enviados",
              click: this.onLogsReqSend
            });
          }

          if (arrData[i].log_response) {
            item.buttons.push({
              icon: "fa fa-cloud-download",
              color: "warning",
              title: "Visualizar dados recebidos",
              click: this.onLogsReqReceiv
            });
          }
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__s2220__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__s2220___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__s2220__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__s2240__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__s2240___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__s2240__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_template__ = __webpack_require__(33);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {
    EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_4_template__["a" /* EdForm */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_4_template__["e" /* EdInputText */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_4_template__["b" /* EdInputSelect */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_4_template__["g" /* EdInputAutoComplete */],
    s2220: __WEBPACK_IMPORTED_MODULE_2__s2220___default.a,
    s2240: __WEBPACK_IMPORTED_MODULE_3__s2240___default.a
  },

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  conputed: {},

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    },
    "formData.id_emp": function formDataId_emp() {},
    "parent.showNovoXml": function parentShowNovoXml() {
      this.initialize();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "layout",
        sortable: true,
        label: "Layout"
      }, {
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização"
      }],
      bind: {
        loadingEmpresa: false,
        loadingFuncionario: false,
        loadingCategoria: false,
        loadingFdt: false,
        funcionarios: [],
        empresas: [],
        estados: [],
        fdt: [],
        categorias: null
      },
      response: null,
      formData: {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true)
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel: {},
          ambiente: {
            dtIniCondicao: null,
            dscAtivDes: null
          },
          exames: [],
          riscos: []
        }
      }
    };
  },
  mounted: function mounted() {
    this.formataLista();
    this.getEstados();
    this.getCategoria();
    this.getEmpresa();
    this.initialize();
  },


  methods: {
    initialize: function initialize() {
      this.formData = {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true)
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel: {},
          ambiente: {
            dtIniCondicao: null,
            dscAtivDes: null
          },
          exames: [],
          riscos: []
        }
      };
      if (this.parent.formDataXml && this.parent.formDataXml.id) {
        this.bind.funcionarios = [this.parent.formDataXml.funcionario];
        this.bind.empresas = [this.parent.formDataXml.empresa];

        this.formData = {
          id: this.parent.formDataXml.id,
          id_emp: this.parent.formDataXml.empresa.id,
          id_fun: this.parent.formDataXml.funcionario.id,
          funcionario: this.parent.formDataXml.funcionario,
          empresa: this.parent.formDataXml.empresa,
          layout: this.parent.formDataXml.layout,
          valor: this.parent.formDataXml.esocial_avulso.valor
        };

        if (!this.formData.valor.responsavel_pcmso || !this.formData.valor.responsavel_pcmso.nome) {
          this.formData.valor.responsavel_pcmso = {
            nome: null,
            crm: null,
            crm_uf: null
          };
        }

        this.formData.id_fun = this.parent.formDataXml.funcionario.id;
      }
    },
    setFuncionario: function setFuncionario(obj) {

      console.log('objobjobj', obj);
      if (obj) {
        this.formData.id_fun = obj.id;
        this.formData.matricula = obj.mat;
        this.formData.id_esocial_categoria = obj.id_esocial_categoria;

        if (obj.funcao) {
          this.formData.valor.ambiente.dscAtivDes = obj.funcao.descricao;
        }
      }
    },
    setEmpresa: function setEmpresa(obj) {
      if (obj) {
        this.formData.id_emp = obj.id;
        this.getFuncionario();
        this.getFdt();
      }
    },
    getEstados: function getEstados() {
      var _this = this;

      this.bind.estados = [];

      this.$root.$request.get("common/estado", null, true).then(function (result) {
        console.log("resultresultresult", result);
        if (result.status == 200) {
          result.data.forEach(function (element) {
            _this.bind.estados.push({ id: element.uf, nome: element.uf });
          });
        }
      });
    },
    getCategoria: function getCategoria(_search) {
      var _this2 = this;

      this.bind.categorias = [];
      this.bind.loadingCategoria = false;

      this.$root.$request.get("esocial/tabelas/conteudo/1", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingCategoria = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.categorias.push(item);
          });
        }
      });
    },
    getTabelas: function getTabelas() {
      var tabelas = [];

      this.parent.config.list.esocial_tabela.forEach(function (element) {
        if (["S-2220", "S-2240"].indexOf(element.codigo) != -1) {
          tabelas.push({
            id: element.codigo,
            nome: element.codigo + " - " + element.nome
          });
        }
      });

      return tabelas;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this3 = this;

      this.bind.empresas = [];
      this.bind.loadingEmpresa = false;

      this.$root.$request.get("empresa", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this3.bind.loadingFuncionario = false;

        if (result.status == 200) {
          _this3.bind.empresas = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this4 = this;

      this.bind.funcionarios = [];
      this.bind.loadingFuncionario = false;

      this.$root.$request.get("empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this4.bind.loadingFuncionario = false;

        if (result.status == 200) {
          _this4.bind.funcionarios = result.data.data;
        }
      });
    },
    getFdt: function getFdt() {
      var _this5 = this;

      if (!this.formData.id_emp) return;

      this.bind.loadingFdt = true;
      this.bind.fdt = [];

      this.$root.$request.get("pcmso/fdt/" + this.formData.id_emp, { pagination: 100 }).then(function (result) {

        _this5.bind.loadingFdt = false;
        console.log('fdt', result);

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            _this5.bind.fdt.push({ id: element.id, nome: element.pcmso + ' (' + element.descricao + ')' });
          });
        }
      });
    },


    formataLista: function formataLista() {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }
        var item = {
          layout: arrData[i].layout + "<br><b>Avulso</b>",
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }
        }

        if (arrData[i].avulso == "1" && [328].indexOf(arrData[i].tipo_status.id) != -1 || arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
          item.buttons.push({
            icon: "fa fa-times-circle",
            color: "default",
            title: "Excluir arquivo XML",
            style: "color:#d82d2d",
            click: this.parent.onDelete
          });
        }

        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title: item._data.log_erro.length + item._data.log_warning.length + " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },

    salvar: function salvar() {
      var _this6 = this;

      this.$root.$loading.set(true);
      this.$root.$request.post("esocial/avulso/editar", this.formData).then(function (result) {
        _this6.$root.$loading.set(false);

        if (result.status == 200) {
          _this6.parent.showNovoXml = !_this6.parent.showNovoXml;
          _this6.parent.getEsocial();
        }
      });
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {},

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "cat",
        sortable: true,
        label: "CAT"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização",
        info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote."
      }]
    };
  },
  mounted: function mounted() {
    this.formataLista();
  },


  methods: {
    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        var lote = '';

        if (arrData[i].lote) {
          lote = '<span>';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + '</span>';
          lote += '</span>';
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + '</span>';
          lote += '</a>';
        }
        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          cat: arrData[i].cat ? arrData[i].cat.id : '---',
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : '----',
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + '</span>',
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].updated_at, false) + '</span>',
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].created_at, false) + '</span>',
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2220",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  components: {
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputSelectTipo */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_template__["i" /* EdModal */]
  },

  props: {
    avulso: {
      type: Number,
      default: 0
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false
      },
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "consulta",
        sortable: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo",
        show_recibo_manual: true
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Data Atualização",
        info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote."
      }],
      showProcedimento: false
    };
  },
  mounted: function mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getProcedimento();
    }
  },


  methods: {
    inserirProcedimento: function inserirProcedimento() {
      var _this = this;

      if (this.bind.procedimento) {
        var encontrado = false;

        this.formData.exames.forEach(function (element) {
          if (element.codigo == _this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.exames.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          data: this.$utilidade.toDate(null, true),
          resultado: 1
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },
    removerProcedimento: function removerProcedimento(index) {
      this.formData.exames.splice(index, 1);
    },
    getProcedimento: function getProcedimento(_search) {
      var _this2 = this;

      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request.get("esocial/tabelas/conteudo/27", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingProcedimento = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              codigo: element.codigo,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.procedimentos.push(item);
          });
        }
      });
    },


    formataLista: function formataLista() {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        var _item;

        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote += '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }

        var item = (_item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>"
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "tipo_status", '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null) + "</span>"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "_data", arrData[i]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "buttons", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "options", {
          disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
        }), _item);

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-pen",
            color: "default",
            title: "Atualizar dados do evento",
            style: "color:#34c142",
            click: this.parent.onUpdateUid
          });


          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo && arrData[i].tipo_status.id != 380) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s2240",
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_fct___default.a],
  components: {
    EdButton: __WEBPACK_IMPORTED_MODULE_2_template__["d" /* EdButton */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_2_template__["f" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_2_template__["b" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_2_template__["h" /* EdInputSelectTipo */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_template__["i" /* EdModal */]
  },

  props: {
    avulso: {
      type: Number,
      default: 0
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false
      },
      showProcedimento: false,
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "consulta",
        sortable: true,
        show_consulta_link: true,
        label: "Consulta"
      }, {
        key: "pgr",
        sortable: true,
        label: "PPRA/PGR"
      }, {
        key: "ghe",
        sortable: true,
        label: "GHE (SETOR)"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo",
        show_recibo_manual: true
      }, {
        key: "lote",
        sortable: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização",
        info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote."
      }]
    };
  },
  mounted: function mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getRisco();
    }
  },


  methods: {
    inserirProcedimento: function inserirProcedimento() {
      var _this = this;

      if (this.bind.procedimento) {
        var encontrado = false;

        this.formData.riscos.forEach(function (element) {
          if (element.codigo == _this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.riscos.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          dscAgNoc: null,
          tpAval: 1,
          intConc: null,
          limTol: null,
          unMed: null,
          tecMedicao: null
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },
    removerProcedimento: function removerProcedimento(index) {
      this.formData.riscos.splice(index, 1);
      this.$forceUpdate();
    },
    getRisco: function getRisco(_search) {
      var _this2 = this;

      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request.get("esocial/tabelas/conteudo/24", {
        search: _search,
        pagination: 100
      }).then(function (result) {
        _this2.bind.loadingProcedimento = false;

        if (result.status == 200) {
          result.data.data.forEach(function (element) {
            var item = {
              id: element.id,
              codigo: element.codigo,
              nome: element.codigo + " - " + element.nome
            };

            if (item.nome.length > 50) {
              item.nome = item.nome.substring(0, 100);
            }

            _this2.bind.procedimentos.push(item);
          });
        }
      });
    },


    errosMatricula: function errosMatricula(data) {
      var termos = ["matrícula", "matricula", "categoria"];

      return (data.log_erro || []).filter(function (msg) {
        var msgLower = (msg || "").toLowerCase();
        return termos.some(function (termo) {
          return msgLower.indexOf(termo) != -1;
        });
      });
    },

    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        var _item;

        console.log('i ' + i);

        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].ghe = arrData[i].ghe ? arrData[i].ghe : null;

        var pgr = "";
        var lote = "";

        if (arrData[i].ghe && arrData[i].ghe.revisao) {
          pgr = arrData[i].ghe.revisao.rev + " (" + arrData[i].ghe.revisao.descricao + ")";

          if (arrData[i].ghe.revisao.parent) {
            pgr += " / " + arrData[i].ghe.revisao.parent.rev + " (" + arrData[i].ghe.revisao.parent.descricao + ")";
          }

          pgr = '<a target="_blank" href="' + this.$root.$session.env.url_cs + "/app/ppra.php?emp=" + arrData[i].empresa.id + "&pcmso=" + (arrData[i].funcionario && arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt.id : '') + "&rev=" + (arrData[i].ghe && arrData[i].ghe.revisao ? arrData[i].ghe.revisao.id : '') + "&ghe=" + (arrData[i].ghe ? arrData[i].ghe.id : '') + '" arget="_blank">' + pgr + "</a>";
        }

        if (arrData[i].lote) {
          lote = '<a target="_blank" href="/esocial/lotes/' + arrData[i].lote + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + "</span>";
          lote += "</a>";
        }

        if (arrData[i].lote_exclusao) {
          lote += '<br><a target="_blank" href="/esocial/lotes/' + arrData[i].lote_exclusao + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '"><i class="fa fa-times"></i> Lote exclusão ' + arrData[i].lote_exclusao + "</span>";
          lote += "</a>";
        }

        var item = (_item = {
          consulta: arrData[i].id_con ? arrData[i].id_con : "---",
          pgr: pgr,
          empresa: arrData[i].empresa.nome,
          ghe: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].ghe ? arrData[i].ghe.ghe + " (" + arrData[i].ghe.descricao.trim() + ")" : "---") + "</span>",
          funcionario: arrData[i].funcionario.nome,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          id: arrData[i].id,
          lote: lote ? lote : "---",
          recibo: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + this.toDate(arrData[i].created_at, false) + "</span>",
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "tipo_status", '<span style="color:' + (arrData[i].tipo_status && arrData[i].tipo_status.id === 380 ? "orange" : arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") + '">' + (arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null) + "</span>"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "fdt", arrData[i].fdt), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "_data", arrData[i]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "buttons", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_item, "options", {
          disable_delete: arrData[i].tipo_status && [332, 330].indexOf(arrData[i].tipo_status.id) != -1 && arrData[i].recibo && this.$root.$session.validarPermissao(586) ? false : true
        }), _item);

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit
          });
        } else {

          item.buttons.push({
            icon: "fa fa-pen",
            color: "default",
            title: "Atualizar dados do evento",
            style: "color:#34c142",
            click: this.parent.onUpdateUid
          });

          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo && arrData[i].tipo_status.id != 380) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }

          if (arrData[i].recibo && arrData[i].tipo_status && [332, 335].indexOf(arrData[i].tipo_status.id) != -1) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete
            });
          }

          if (arrData[i].tipo_status && arrData[i].tipo_status.id == 336 && this.errosMatricula(arrData[i]).length && (arrData[i].id_fun || arrData[i].funcionario && arrData[i].funcionario.id)) {
            item.buttons.push({
              icon: "fa fa-whatsapp",
              color: "info",
              title: "Erro do eSocial relacionado à matrícula/categoria do funcionário — enviar WhatsApp ao contador solicitando a correção.",
              click: this.parent.onDispararWhatsappAtualizarMatriculaContador
            });
          }
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_fct__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "esocial-s3000",
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_fct___default.a],
  components: {},

  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    "parent.response": function parentResponse() {
      this.formataLista();
    }
  },

  data: function data() {
    return {
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        show_empresa_link: true,
        label: "Empresa"
      }, {
        key: "funcionario",
        sortable: true,
        show_funcao: true,
        show_funcionario_link: true,
        label: "Funcionário"
      }, {
        key: "layout",
        sortable: true,
        label: "Layout Excluído"
      }, {
        key: "recibo",
        sortable: true,
        label: "Recibo"
      }, {
        key: "lote",
        sortable: true,
        show_lote_link: true,
        label: "Lote"
      }, {
        key: "tipo_status",
        sortable: true,
        label: "Status"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização",
        info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote."
      }]
    };
  },
  mounted: function mounted() {
    this.formataLista();
  },


  methods: {
    formataLista: function formataLista() {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
          arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao : null;
        arrData[i].fdt = arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var lote = '';

        if (arrData[i].lote) {
          lote = '<a target="_blank" href="/esocial/lotes/' + arrData[i].lote + '">';
          lote += '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '"><i class="fa fa-plus"></i> Lote inclusão ' + arrData[i].lote + '</span>';
          lote += '</a>';
        }

        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          layout: arrData[i].parent ? arrData[i].parent.layout + '<br>' + arrData[i].parent.recibo : '---',
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : '---',
          recibo: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + (arrData[i].recibo ? arrData[i].recibo : "---") + "</span>",
          updated_at: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].updated_at, false) + "</span>",
          dt_cad: '<span style="color:' + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : '') + '">' + this.toDate(arrData[i].created_at, true) + "</span>",
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null,
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete: true
          }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit
          });
        } else {
          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit
            });
          }
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_laboratorio_cadastrar__ = __webpack_require__(289);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [],
        hidden: {},
        click: {
          laboratorio: this.getLaboratorio
        },
        loading: {
          laboratorio: false
        },
        list: {
          laboratorio: []
        }
      },
      formData: {
        laboratorio: null
      },
      response: {},
      formItems: [],
      showForm: false,
      tableData: [],
      tableHedad: [{
        key: "laboratorio",
        sortable: true,
        label: "Laboratório"
      }, {
        key: "valor_custo",
        show_money: true,
        label: "Valor Custo (R$)",
        width: "130px"
      }, {
        key: "valor_venda",
        show_money: true,
        label: "Valor Venda (R$)",
        width: "130px"
      }, {
        key: "id_lab",
        show_radio: true,
        label: "Padrao",
        width: "90px"
      }, {
        key: "buttons",
        label: "",
        width: "50px"
      }]
    };
  },


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_laboratorio_cadastrar__["a" /* default */];
    this.getLaboratorio();
    this.inicialize();
  },

  methods: {
    inicialize: function inicialize() {
      var tableData = [];

      for (var i = 0; i < this.parent.formData.laboratorios.length; i++) {
        var element = this.parent.formData.laboratorios[i];

        var item = {
          id_lab: element.laboratorio.id,
          laboratorio: element.laboratorio.nome,
          valor_custo: element.valor_custo,
          valor_venda: element.valor_venda,
          _data: element
        };

        tableData.push(item);
      }

      this.tableData = tableData;
    },
    onRegister: function onRegister() {
      if (!this.formData.laboratorio) {
        this.edAlert("Por favor selecione um laboratório", "error");
        return;
      }

      if (this.arrFindByField(this.tableData, "id_lab", this.formData.laboratorio.id)) {
        this.edAlert("O laboratório selecionado já está cadastrado", "error");
        return;
      }

      var data = {
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio,
        valor_custo: "0,00",
        valor_venda: "0,00"
      };

      this.tableData.push({
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio.nome,
        valor_custo: "0,00",
        valor_venda: "0,00",
        _data: data
      });

      this.showForm = !this.showForm;
      this.formData.laboratorio = null;
      this.formatData();
    },
    onDelete: function onDelete(item) {
      this.tableData.splice(item.index, 1);
      this.formatData();
    },
    formatData: function formatData() {
      this.parent.formData.laboratorios = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];
        this.parent.formData.laboratorios.push(element._data);
      }
    },


    getLaboratorio: function getLaboratorio(_search) {
      var _this = this;

      this.config.loading.laboratorio = true;
      this.config.list.laboratorio = [];

      this.get("laboratorio", { search: _search }).then(function (result) {
        result = result[0];
        _this.config.loading.laboratorio = false;

        if (result.status == 200) {
          _this.config.list.laboratorio = result.data.data;
        }
      });
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__includes_laboratorio__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, Laboratorios: __WEBPACK_IMPORTED_MODULE_3__includes_laboratorio___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	watch: {},
	data: function data() {
		return {
			config: {
				tipo: [269, 290],
				hidden: {},
				click: {
					save: this.salvar,
					id_tab: this.getTabelaDinamica,
					esocial_atividade_per: this.getEscocialTabela28
				},
				loading: {
					save: false,
					id_tab: false,
					esocial_atividade_per: false
				},
				list: {
					id_tab: [],
					esocial_atividade_per: []
				}
			},
			formData: {
				id: 0,
				nome: null,
				nome_comercial: null,
				cod_cas: null,
				cod_esocial: '00.00.000',
				cod_metodologia: null,
				desc_metodologia: null,
				id_tipo_unidade_medida: null,
				id_tab: null,
				un_medida: null,
				amostra: null,
				vazao: null,
				volume: null,
				cod_amostrador: null,
				desc_amostrador: null,
				usuario: null,
				laboratorio: null,
				id_lab: null,
				laboratorios: [],
				esocial_atividade_per: [],
				ativo: 1
			},
			response: {},
			exameItems: []
		};
	},


	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__["a" /* default */];
		this.getTabelaDinamica();
		this.getEscocialTabela28();
	},

	methods: {

		onChangeProprio: function onChangeProprio() {},

		getEscocialTabela28: function getEscocialTabela28(_search) {
			var _this = this;

			this.config.loading.esocial_atividade_per = true;
			this.config.list.esocial_atividade_per = [];

			this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(function (result) {
				result = result[0];

				_this.config.loading.esocial_atividade_per = false;

				if (result.status == 200) {
					_this.config.list.esocial_atividade_per = result.data.data;
				}
			});
		},

		getTabelaDinamica: function getTabelaDinamica(_search) {
			var _this2 = this;

			this.config.loading.id_tab = true;
			this.config.list.id_tab = [];

			this.get('/ltcat/tabela-dinamica', { search: _search }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_tab = false;

				if (result.status == 200) {
					_this2.config.list.id_tab = result.data.data;
				}
			});
		},


		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('fator-risco/editar', this.formData).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {

					_this3.$message({
						message: 'Registro salvo com sucesso!',
						type: 'success'
					});

					_this3.toRoute({ name: 'ltcat.risco.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_laboratorio_cadastrar__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_laboratorio__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, Laboratorios: __WEBPACK_IMPORTED_MODULE_4__includes_laboratorio___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {},
  data: function data() {
    return {
      config: {
        tipo: [269, 290],
        hidden: {},
        click: {
          save: this.salvar,
          id_tab: this.getTabelaDinamica,
          esocial_atividade_per: this.getEscocialTabela28
        },
        loading: {
          save: false,
          content: false,
          id_tab: false,
          esocial_atividade_per: false
        },
        list: {
          id_tab: [],
          esocial_atividade_per: []
        }
      },
      formData: {
        id: 0,
        nome: null,
        nome_comercial: null,
        cod_cas: null,
        cod_esocial: null,
        cod_metodologia: null,
        desc_metodologia: null,
        id_tipo_unidade_medida: null,
        id_tab: null,
        un_medida: null,
        amostra: null,
        vazao: null,
        volume: null,
        cod_amostrador: null,
        desc_amostrador: null,
        usuario: null,
        laboratorio: null,
        id_lab: null,
        laboratorios: [],
        esocial_atividade_per: [],
        ativo: 1
      },
      response: {},
      fatorRiscoItems: []
    };
  },


  mounted: function mounted() {
    this.fatorRiscoItems = __WEBPACK_IMPORTED_MODULE_2__form_risco_cadastrar__["a" /* default */];
    this.laboratorioItems = __WEBPACK_IMPORTED_MODULE_3__form_laboratorio_cadastrar__["a" /* default */];
    this.getFatorRisco();
    this.getTabelaDinamica();
    this.getEscocialTabela28();
  },

  methods: {
    getEscocialTabela28: function getEscocialTabela28(_search) {
      var _this = this;

      this.config.loading.esocial_atividade_per = true;
      this.config.list.esocial_atividade_per = [];

      this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.esocial_atividade_per = false;

        if (result.status == 200) {
          _this.config.list.esocial_atividade_per = result.data.data;
        }
      });
    },

    getTabelaDinamica: function getTabelaDinamica(_search) {
      var _this2 = this;

      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_tab = false;

        if (result.status == 200) {
          _this2.config.list.id_tab = result.data.data;
        }
      });
    },
    getFatorRisco: function getFatorRisco() {
      var _this3 = this;

      this.config.loading.content = true;

      this.get("fator-risco/" + this.$route.params.id).then(function (result) {
        result = result[0];

        _this3.config.loading.content = false;

        if (result.status == 200) {
          _this3.formatData(result);
        }
      });
    },
    formatData: function formatData(result) {
      this.formData = result.data;
    },
    salvar: function salvar() {
      var _this4 = this;

      this.response = {};
      this.config.loading.save = true;

      this.post("fator-risco/editar", this.formData).then(function (result) {
        result = result[0];

        _this4.config.loading.save = false;
        _this4.response = result;

        if (result.status == 200) {
          _this4.formatData(result);
          _this4.$message({
            message: "Registro salvo com sucesso!",
            type: "success"
          });
        }
      });
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_template__ = __webpack_require__(33);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_4_template__["a" /* EdForm */], EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_4_template__["h" /* EdInputSelectTipo */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        tuss: null,
        interpr: null,
        ordem: null,
        ex_id_min: null,
        ex_id_max: null,
        tipo: null,
        proprio: null
      },
      formFilter: {
        cat_esocial: []
      },
      pagination: {},
      response: {},
      filterBadge: 0,
      tableHead: [{
        key: "id",
        sortable: true,
        label: "CÓD"
      }, {
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "cat_esocial",
        sortable: true,
        label: "CATEGORIA"
      }, {
        key: "cod_metodologia",
        sortable: true,
        label: "CÓD METODOLOGIA"
      }, {
        key: "cod_esocial",
        sortable: true,
        label: "CÓD ESOCIAL"
      }, {
        key: "cas",
        sortable: true,
        label: "CÓD CAS"
      }, {
        key: "ativo",
        sortable: true,
        label: "Ativo"
      }],
      tableData: [],
      loadingTable: false,
      showFormEdit: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},


  mounted: function mounted() {
    this.getFatorRisco();
  },

  methods: {
    onExcel: function onExcel() {
      this.open("fator-risco/excel", { filter: {} });
    },


    onRegister: function onRegister() {
      this.toRoute({ name: "ltcat.risco.cadastrar" });
    },

    onEdit: function onEdit(data) {
      this.toRoute({ name: "ltcat.risco.editar", params: { id: data.id } });
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;

        _this.post("/fator-risco/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getFatorRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getFatorRisco: function getFatorRisco(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.filterBadge = this.formFilter.cat_esocial.length;

      this.get("fator-risco", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this2.response = result;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cas: data[i].cod_cas,
              cat_esocial: data[i].cat_esocial,
              cod_metodologia: data[i].cod_metodologia,
              cod_esocial: data[i].cod_esocial,
              ativo: data[i].ativo == 1 ? "Sim" : "Não",
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(568),
                disable_edit: !_this2.validarPermissao(568)
              },
              buttons: []
            };

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
          _this2.loadingTable = false;
        }
      });
    }
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_filters__ = __webpack_require__(961);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a],
  props: {
    point_id: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    point_type: {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    filter: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    onRegister: {
      type: [Function],
      default: null
    }
  },
  watch: {
    point_id: function point_id() {
      this.getLog();
    },
    point_type: function point_type() {
      this.formatarCabecalho();
      this.getLog();
    },
    '$root.$session.event': function $root$sessionEvent() {

      switch (this.$root.$session.event) {
        case 'DisparoNotifyEvent':
        case 'LogEmailNotifyEvent':
          this.getLog();
          this.$root.$session.event = null;
          break;

        default:
          break;
      }
    }
  },

  data: function data() {
    return {
      config: {
        click: {},
        list: {},
        loading: {}
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        mensagem: null
      },
      formFilter: {
        created_at: [],
        tabela: this.tabela,
        registro: this.registro
      },
      tableHead: [{
        key: "id",
        sortable: true,
        label: " Nº Envio"
      }, {
        key: "point",
        sortable: true,
        label: "Identificação"
      }, {
        key: "remetente",
        sortable: true,
        label: "Remetente"
      }, {
        key: "destinatario",
        sortable: true,
        label: "Destinatário"
      }, {
        key: "status",
        sortable: true,
        show_status: true,
        label: "Status"
      }, {
        key: "created_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      filterItems: [],
      loadingTable: false,
      showFormMsg: false,
      disabledConfigCell: true,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {
    this.formatarCabecalho();
  },


  mounted: function mounted() {
    this.getLog();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_5__form_filters__["a" /* default */];
  },

  methods: {
    formatarCabecalho: function formatarCabecalho() {
      switch (this.point_type) {
        case "consulta":
          this.tableHead[1].label = "Consulta";
          break;

        case "empresa":
          this.tableHead[1].label = "Empresa";
          break;

        case "funcionario":
          this.tableHead[1].label = "Funcionário";
          break;

        case "esocial-lote":
          this.tableHead[1].label = "Lote";
          break;
      }
    },
    formatarPoint: function formatarPoint(data) {
      switch (this.point_type) {

        case "consulta":
          return data.id_con;
          break;

        case "funcionario":
          return "<span>" + data.nome + "</span>" + (data.empresa ? "<br><span>" + data.empresa.nome + "</span>" : "");
          break;

        case "esocial-lote":
          return data.lote;
          break;

        default:
          return data.nome;
          break;
      }
    },
    onMensagem: function onMensagem(data) {
      this.formData = {
        id: data.id,
        mensagem: data.mensagem
      };

      this.open("log/email/html/" + this.formData.id);
    },
    onError: function onError(data) {
      this.formData = {
        id: data.id,
        mensagem: data.obs
      };
      this.showFormMsg = !this.showFormMsg;
    },
    getLog: function getLog(_search, _page, _pagination) {
      var _this = this;

      if (!this.point_type) return;

      this.loadingTable = true;
      this.disabledConfigCell = true;
      this.response = {};

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      if (this.formFilter.created_at.length < 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-1, null, "y"), true),
            amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at.push(ontem, amanha);
      }

      this.filterBadge = this.formFilter.created_at.length > 0 ? 1 : 0;
      var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.filter, this.formFilter);

      this.get("log/email/" + this.point_type + (this.point_id ? "/" + this.point_id : ""), {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: filters
      }).then(function (result) {
        result = result[0];
        _this.response = result;

        var data = [],
            tableData = [],
            pagination = {};

        if (result.status == 200) {
          data = result.data.data, tableData = [], pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              remetente: data[i].remetente,
              destinatario: data[i].destinatario ? data[i].destinatario.split(";").join("<br>") : "---",
              point: data[i].point ? _this.formatarPoint(data[i].point) : "---",
              status: data[i].obs ? data[i].obs : "",
              created_at: _this.toDate(data[i].created_at),
              _data: data[i],
              options: {},
              buttons: []
            };

            if (data[i].mensagem) {
              _this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-file-text-o",
                color: "success",
                title: "Visualizar Mensagem",
                click: _this.onMensagem
              });
            }

            if (data[i].obs) {
              _this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-window-close",
                color: "danger",
                title: "Visualizar Erro",
                click: _this.onError
              });
            }
            tableData.push(item);
          }
        }

        _this.pagination = pagination;
        _this.tableData = tableData;
        _this.loadingTable = false;
      });
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_equipamento_cadastrar__ = __webpack_require__(965);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		anexo: {
			type: Object,
			default: function _default() {
				return {
					id: 0,
					descricao: null,
					arquivo: null,
					updated_at: null,
					usuario: null,
					ativo: 1
				};
			}
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'anexo.id': function anexoId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
			if (this.anexo.id != 0) {
				this.getAnexo();
			}
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [],
				loading: {
					save: false,
					content: false
				},
				list: {}
			},
			formData: {
				id: 0,
				descricao: null,
				arquivo: null,
				updated_at: null,
				usuario: null
			},
			response: {},
			exameItems: [],
			loadingSave: false,
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.exameItems = __WEBPACK_IMPORTED_MODULE_4__form_equipamento_cadastrar__["a" /* default */];

		this.$events.on('upload-arquivo', function (eventData) {
			_this.formData.arquivo = eventData;
		});

		this.$events.on('upload-arquivo-delete', function (eventData) {
			_this.getAnexo();
		});

		this.$events.on('onClienteEvent', function (eventData) {
			_this.parent.getLtcatAnexo();
		});
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				descricao: null,
				arquivo: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			};
		},
		getAnexo: function getAnexo() {
			var _this2 = this;

			this.config.loading.content = true;
			this.formData = {};

			this.get('ltcat/anexo/' + this.parent.ltcat.id + '/' + this.anexo.id).then(function (result) {

				result = result[0];

				_this2.config.loading.content = false;

				if (result.status == 200) {
					_this2.formataData(result);
				}
			});
		},
		formataData: function formataData(result) {
			this.formData = {
				id: result.data.id,
				descricao: result.data.descricao,
				arquivo: result.data.arquivo,
				usuario: result.data.usuario,
				updated_at: result.data.updated_at
			};
		},
		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.loadingSave = true;

			this.post('/ltcat/anexo/' + this.parent.ltcat.id + '/editar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this3.loadingSave = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Registro salvo com sucesso!');
					_this3.formataData(result);
					_this3.showFormEdit = !_this3.showFormEdit;

					if (_this3.parent.getLtcatAnexo) _this3.parent.getLtcatAnexo();
				}
			});
		}
	}
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'$store.state.ltcat.data': function $storeStateLtcatData() {
			this.getLtcatAnexo();
		}
	},
	data: function data() {
		return {
			formData: {},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'Cód'
			}, {
				key: 'descricao',
				sortable: true,
				label: 'Descrição'
			}, {
				key: 'imagem',
				show_arquivo: true,
				label: 'Anexo'
			}, {
				key: 'status',
				show_status: true,
				label: 'Status'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getLtcatAnexo();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: 0
			};
		},

		onEdit: function onEdit(data) {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: data.id,
				nome: data.nome,
				usuario: data.usuario,
				updated_at: data.updated_at
			};
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this.post('/ltcat/anexo/' + _this.$store.state.ltcat.data.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getLtcatAnexo();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getLtcatAnexo: function getLtcatAnexo(_search, _page, _pagination) {
			var _this2 = this;

			if (!this.$store.state.ltcat.data) return;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/anexo/' + this.$store.state.ltcat.data.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						data[i].collapse = null;

						var item = {
							'id': data[i].id,
							'descricao': data[i].descricao,
							'link': data[i].arquivo ? data[i].arquivo.url : '',
							'updated_at': _this2.toDate(data[i].updated_at),
							'imagem': data[i].arquivo,
							'status': data[i].obs ? data[i].obs : '',
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(576) || data[i].tipo_status && data[i].tipo_status.id != 79,
								disable_edit: !_this2.validarPermissao(576) || data[i].tipo_status && data[i].tipo_status.id != 79
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
					_this2.loadingTable = false;
				}
			});
		}

	}
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_ltcat_cadastrar__ = __webpack_require__(962);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_2_common_alert___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	watch: {
		'formData.id_emp': function formDataId_emp() {
			this.config.disabled.id_fdt = this.formData.id_emp ? false : true;
			this.formData.id_fdt = null;
			this.formData.id_rev = null;
			this.ultima_revisao = null;
			this.getFdt();
		},
		'formData.id_fdt': function formDataId_fdt() {
			this.config.disabled.id_rev = this.formData.id_fdt ? false : true;
			this.config.disabled.id_tipo_ltcat = this.formData.id_fdt ? false : true;
			this.config.disabled.id_tipo_revisao = this.formData.id_fdt ? false : true;
			this.config.disabled.data = this.formData.id_fdt ? false : true;
			this.config.disabled.obs = this.formData.id_fdt ? false : true;
			this.formData.id_rev = null;
			this.ultima_revisao = null;
			this.getUltimaRevisao();
			this.getRevisaoPpra();
		},
		'formData.id_tipo_ltcat': function formDataId_tipo_ltcat() {
			this.config.hidden.id_rev = this.formData.id_tipo_ltcat == 205 ? false : true;
			this.config.hidden.id_ltcat = this.formData.id_tipo_ltcat == 206 ? false : true;
			this.formData.id_rev = null;
			this.formData.id_ltcat = null;
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [1, 203],
				tipo_exclude: [],
				hidden: {
					id_rev: true,
					id_ltcat: true
				},
				title: {
					ppra: 'Empresa sem PPRA'
				},
				disabled: {
					id_fdt: true,
					data: true,
					obs: true,
					id_rev: true,
					id_tipo_ltcat: true,
					id_tipo_revisao: true
				},
				click: {
					save: this.salvar,
					id_emp: this.getEmpresa,
					id_fdt: this.getFdt,
					id_rev: this.getRevisaoPpra,
					id_ltcat: this.getLtcat
				},
				list: {
					id_emp: [],
					id_fdt: [],
					id_rev: [],
					id_ltcat: []
				},
				loading: {
					save: false,
					data: false,
					id_emp: false,
					id_fdt: false,
					id_rev: false,
					id_ltcat: false
				},
				options: {
					data: {
						disabledDate: this.handlerDisableYesterdayDate
					}
				}
			},
			formData: {
				id: 0,
				id_tipo_ltcat: 228,
				id_tipo_revisao: 2,
				id_emp: null,
				id_fdt: null,
				id_rev: null,
				id_ltcat: null,
				obs: null,
				data: this.toDate(null, true),
				ppra: 0
			},
			ultima_revisao: null,
			response: {},
			exameItems: []
		};
	},


	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_ltcat_cadastrar__["a" /* default */];
		this.getEmpresa();
		this.getLtcat();
	},

	methods: {

		onChangeProprio: function onChangeProprio() {},

		getEmpresa: function getEmpresa(search) {
			var _this = this;

			this.config.loading.id_emp = true;
			this.config.list.id_emp = [];

			this.get('empresa', { search: search }).then(function (result) {
				result = result[0];

				_this.config.loading.id_emp = false;

				if (result.status == 200) {
					_this.config.list.id_emp = result.data.data;
				}
			});
		},
		getFdt: function getFdt(search) {
			var _this2 = this;

			if (!this.formData.id_emp) return;

			this.config.loading.id_fdt = true;
			this.config.list.id_fdt = [];

			this.get('/pcmso/fdt/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_fdt = false;

				if (result.status == 200) {
					_this2.config.list.id_fdt = result.data.data;
				}
			});
		},
		getRevisaoPpra: function getRevisaoPpra(search) {
			var _this3 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt) return;

			this.config.loading.id_rev = true;
			this.config.list.id_rev = [];

			this.get('/pcmso/revisao/' + this.formData.id_emp + '/' + this.formData.id_fdt, { search: search }).then(function (result) {
				result = result[0];

				_this3.config.loading.id_rev = false;

				if (result.status == 200) {
					_this3.config.list.id_rev = _this3.formataRevisao(result.data.data);
				}
			});
		},
		getLtcat: function getLtcat(search) {
			var _this4 = this;

			this.config.loading.id_ltcat = true;
			this.config.list.id_ltcat = [];

			this.get('/ltcat', { search: search }).then(function (result) {
				result = result[0];

				_this4.config.loading.id_ltcat = false;

				if (result.status == 200) {
					_this4.config.list.id_ltcat = _this4.formataRevisao(result.data.data);
				}
			});
		},
		getUltimaRevisao: function getUltimaRevisao() {
			var _this5 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt) return;

			this.config.loading.data = true;
			this.ultima_revisao = null;

			this.get('/ltcat/ultima-revisao/' + this.formData.id_fdt).then(function (result) {
				result = result[0];

				_this5.config.loading.data = false;

				if (result.status == 200 && result.data) {
					_this5.ultima_revisao = result.data;
				}
				_this5.handlerValidarTipoRevisao();
			});
		},
		handlerValidarTipoRevisao: function handlerValidarTipoRevisao() {

			if (this.ultima_revisao) {
				var diff = this.diffDays(this.toDate(null, true, 'YYYY-MM-DD'), this.ultima_revisao.data, 'y');

				this.config.tipo_exclude = [2];
				this.formData.id_tipo_revisao = diff > 1 ? 4 : 3;
			} else {
				this.config.tipo_exclude = [3, 4];
				this.formData.id_tipo_revisao = 2;
			}
		},
		handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {

			if (!this.ultima_revisao) return false;

			var hoje = this.ultima_revisao.parent ? this.ultima_revisao.parent.data : this.ultima_revisao.data;
			date = this.toDate(date, true, 'YYYY-MM-DD');

			return date < hoje;
		},
		salvar: function salvar() {
			var _this6 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/cadastrar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Registro salvo com sucesso!');
					_this6.toRoute({ name: 'ltcat.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_conclusao_cadastrar__ = __webpack_require__(966);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		conclusao_tecnica: {
			type: Object,
			default: null
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'conclusao_tecnica.id': function conclusao_tecnicaId() {},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
			if (this.conclusao_tecnica.id != 0) {
				this.getConclusaoTecnica();
			}
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [92, 96, 100],
				hidden: {
					padrao: true
				},
				click: {
					id_esocial_procedimento: this.getEscocialTabela
				},
				loading: {
					save: false,
					content: false,
					id_esocial_procedimento: false
				},
				list: {
					id_esocial_procedimento: []
				}
			},
			formData: {
				id: 0,
				nome: null,
				descricao: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			},
			response: {},
			exameItems: [],
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_conclusao_cadastrar__["a" /* default */];
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				nome: null,
				descricao: null,
				updated_at: null,
				usuario: null,
				ativo: 1
			};
		},
		getConclusaoTecnica: function getConclusaoTecnica() {
			var _this = this;

			this.config.loading.content = true;
			this.formData = {};
			this.response = {};

			this.get('conclusao-tecnica/' + this.conclusao_tecnica.id).then(function (result) {

				result = result[0];

				_this.response = result;
				_this.config.loading.content = false;

				if (result.status == 200) {
					_this.formataData(result);
				}
			});
		},
		formataData: function formataData(result) {
			this.formData = {
				id: result.data.id,
				nome: result.data.nome,
				descricao: result.data.descricao,
				usuario: result.data.usuario,
				updated_at: result.data.updated_at,
				ativo: result.data.ativo
			};
		},
		salvar: function salvar() {
			var _this2 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('conclusao-tecnica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Registro salvo com sucesso!');
					_this2.formataData(result);
					_this2.showFormEdit = !_this2.showFormEdit;

					if (_this2.parent.getConclusaoTecnica) _this2.parent.getConclusaoTecnica();
				}
			});
		}
	}
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			formData: {},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'CÓD'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'descricao',
				show_colapse: true,
				label: 'Descrição'
			}, {
				key: 'ativo',
				label: 'Ativo'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getConclusaoTecnica();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: 0,
				nome: null,
				descricao: null,
				usuario: null,
				updated_at: null
			};
		},

		onEdit: function onEdit(data) {
			this.showFormEdit = !this.showFormEdit;
			this.formData = {
				id: data.id,
				nome: data.nome,
				descricao: data.descricao,
				usuario: data.usuario,
				updated_at: data.updated_at
			};
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this.post('/conclusao-tecnica/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getConclusaoTecnica();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getConclusaoTecnica: function getConclusaoTecnica(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('conclusao-tecnica', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'nome': data[i].nome,
							'descricao': data[i].descricao,
							'ativo': data[i].ativo == 1 ? 'Sim' : 'Não',
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(573),
								disable_edit: !_this2.validarPermissao(573)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
					_this2.loadingTable = false;
				}
			});
		}

	}
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modelo_index__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modelo_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modelo_index__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdAlert: __WEBPACK_IMPORTED_MODULE_0_common_alert___default.a, Conclusao: __WEBPACK_IMPORTED_MODULE_1__conclusao_tecnica_index___default.a, Modelo: __WEBPACK_IMPORTED_MODULE_2__modelo_index___default.a },
	mixins: [],
	props: {},
	watch: {},
	data: function data() {
		return {
			tagConfig: 'tab-conclusao'

		};
	},
	created: function created() {},


	mounted: function mounted() {},
	methods: {}
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_conteudo_editar__ = __webpack_require__(967);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		modelo: {
			type: Object,
			default: null
		}
	},
	watch: {
		'modelo.id': function modeloId() {
			this.getModeloConteudo();
		},
		'formData.ocultar': function formDataOcultar() {
			this.config.disabled.fator_riscos = this.formData.ocultar == 0;
			this.config.disabled.ocultar_texto = this.formData.ocultar == 0;
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [],
				click: {
					fator_riscos: this.getFatorRisco
				},
				loading: {
					save: false,
					content: false,
					fator_riscos: false
				},
				disabled: {
					fator_riscos: true,
					ocultar_texto: true
				},
				list: {
					fator_riscos: []
				}
			},
			formData: {
				id: 0,
				titulo: null,
				ocultar: 0,
				ocultar_texto: null,
				updated_at: null,
				usuario: null,
				fator_riscos: []
			},
			response: {},
			pagination: {},
			tableHead: [{
				key: 'titulo',
				sortable: true,
				label: 'Título'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			conteudoItems: [],
			showFormEdit: false,
			tagConfig: 'tab-editar'
		};
	},
	mounted: function mounted() {
		this.getModeloConteudo();
		this.getFatorRisco();
		this.conteudoItems = __WEBPACK_IMPORTED_MODULE_4__form_conteudo_editar__["a" /* default */];
	},


	methods: {
		onEdit: function onEdit(data) {
			this.config.list.fator_riscos = [];
			this.tagConfig = 'tab-editar';

			this.formData = {
				id: data.id,
				titulo: data.titulo,
				ocultar: data.ocultar,
				ocultar_texto: data.ocultar_texto,
				updated_at: data.updated_at,
				usuario: data.usuario,
				fator_riscos: []
			};

			this.showFormEdit = !this.showFormEdit;

			for (var i = 0; i < data.fator_riscos.length; i++) {
				var element = data.fator_riscos[i];
				this.config.list.fator_riscos.push(element);
				this.formData.fator_riscos.push(element.id);
			}
		},
		getFatorRisco: function getFatorRisco(_search) {
			var _this = this;

			this.config.loading.fator_riscos = true;
			this.config.list.fator_riscos = [];

			this.get('fator-risco', { search: _search }).then(function (result) {

				result = result[0];

				_this.config.loading.fator_riscos = false;

				if (result.status == 200) {
					_this.config.list.fator_riscos = result.data.data;
				}
			});
		},


		getModeloConteudo: function getModeloConteudo(_search, _page, _pagination) {
			var _this2 = this;

			if (!this.modelo) return;

			_pagination = !_pagination ? 100 : _pagination;

			this.config.loading.content = true;
			this.response = {};

			this.get('ltcat/modelo/conteudo/' + this.modelo.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;

				_this2.config.loading.content = false;

				if (result.status == 200) {

					if (result.status == 200) {
						var data = result.data.data,
						    tableData = [],
						    pagination = result.data;

						for (var i = 0; i < data.length; i++) {

							var item = {
								'id': data[i].id,
								'titulo': data[i].tipo == 0 ? '***' : data[i].titulo,
								'updated_at': _this2.toDate(data[i].updated_at),
								_data: data[i],
								options: {
									disable_delete: !_this2.validarPermissao(569),
									disable_edit: !_this2.validarPermissao(569) || data[i].tipo != 0,
									style: 'color:' + (data[i].ocultar == 1 ? 'red' : '')
								},
								buttons: []
							};

							tableData.push(item);
						}

						console.log(pagination);
						_this2.pagination = pagination;
						_this2.tableData = tableData;
					}
				}
			});
		},

		salvar: function salvar() {
			var _this3 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/modelo/conteudo/' + this.modelo.id + '/editar', this.toFormUpload(this.formData)).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Registro salvo com sucesso!');
					_this3.getModeloConteudo();
					_this3.showFormEdit = !_this3.showFormEdit;
				}
			});
		}
	}
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conteudo__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conteudo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__conteudo__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Conteudo: __WEBPACK_IMPORTED_MODULE_2__conteudo___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			tableData: [],
			tagConfig: '0',
			loadingContent: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getModelo();
	},

	methods: {

		getModelo: function getModelo(_search, _page, _pagination) {
			var _this = this;

			this.loadingContent = true;

			this.get('ltcat/modelo', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this.loadingContent = false;

				if (result.status == 200) {
					_this.tableData = result.data.data;
				}
			});
		}
	}
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_editar__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ghe_index__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ghe_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ghe_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anexo_index__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__anexo_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__anexo_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orcamento_index__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orcamento_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__orcamento_index__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat-risco-cadastrar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a, LtcatGhe: __WEBPACK_IMPORTED_MODULE_5__ghe_index___default.a, LtcatAnexo: __WEBPACK_IMPORTED_MODULE_6__anexo_index___default.a, LtcatOrcamento: __WEBPACK_IMPORTED_MODULE_7__orcamento_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	watch: {
		'formData.id_emp': function formDataId_emp() {},
		'formData.id_fdt': function formDataId_fdt() {},
		'formData.id_rev': function formDataId_rev() {},
		'formData.id': function formDataId() {
			this.handlerDisableYesterdayDate();
			this.config.disabled.id_tipo_revisao = this.formData.id_tipo_revisao == 2;
		}
	},
	data: function data() {
		var _config, _formData;

		return {
			config: (_config = {
				tipo: [1, 203],
				tipo_exclude: [],
				hidden: {
					ppra: false,
					id_rev: true
				},
				title: {
					ppra: ''
				},
				disabled: {
					id_emp: true,
					id_fdt: true,
					id_tipo_ltcat: true,
					id_tipo_revisao: false,
					id_rev: true
				},
				click: {
					save: this.salvar,
					id_emp: this.getEmpresa,
					id_fdt: this.getFdt,
					id_rev: this.getRevisaoLtcat,
					id_res: this.getProfissionais,
					id_mod: this.getModelo
				},
				list: {
					id_emp: [],
					id_fdt: [],
					id_rev: [],
					id_res: [],
					id_mod: []
				},
				change: {
					id_rev: this.getLtcat
				},
				loading: {
					save: false,
					id_emp: false,
					id_fdt: false,
					id_rev: false,
					id_res: false,
					id_mod: false
				}
			}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'title', {
				id_emp: 'Editar Cadastro'
			}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'options', {
				data: {
					disabledDate: this.handlerDisableYesterdayDate
				}
			}), _config),
			formData: (_formData = {
				id: 0,
				id_tipo_revisao: null,
				id_emp: null,
				id_rev: null,
				id_fdt: null
			}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'id_rev', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'id_res', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'obs', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'data', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'usuario', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'empresa', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_formData, 'ppra', 0), _formData),
			response: {},
			exameItems: [],
			tagConfig: 'tab-ghe'
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_editar__["a" /* default */];
		this.getLtcat();
		this.getModelo();
	},


	methods: {
		gerarDocumento: function gerarDocumento() {
			if (this.formData.id == 0) return;

			if (!this.formData.id_mod) {
				this.edAlert('Selecione um modelo e o responsável pelo LTCAT', 'error');
				return;
			}

			window.open(this.env.url_cs + '/app/ltcat_gera.php?p=' + this.base64Encode(this.formData.id), 'blank');
		},
		getLtcat: function getLtcat(id) {
			var _this = this;

			this.config.loading.content = true;

			id = id ? id : this.$route.params.id;

			this.get('ltcat/' + id).then(function (result) {
				result = result[0];

				_this.config.loading.content = false;

				var revisao = '555';

				if (result.data.revisao) {
					revisao = (result.data.revisao.parent ? result.data.revisao.parent.rev + ' (' + result.data.revisao.parent.descricao + ' em ' + result.data.revisao.parent.descricao + ') / ' : '') + result.data.revisao.rev + ' (' + result.data.revisao.descricao + ' em ' + result.data.revisao.descricao + ')';
				}
				if (result.status == 200) {
					var _this$formData;

					_this.formData = (_this$formData = {
						id: result.data.id,
						id_rev: result.data.id,
						id_tipo_revisao: result.data.id_tipo_revisao,
						id_emp: result.data.empresa.id,
						id_fdt: result.data.fdt.id,
						id_res: result.data.responsavel ? result.data.responsavel.id : null,
						id_mod: result.data.modelo ? result.data.modelo.id : null,
						rev: result.data.rev,
						obs: result.data.obs,
						empresa: result.data.empresa,
						id_tipo_ltcat: result.data.id_tipo_ltcat
					}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'id_rev', revisao), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'revisao', result.data), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_this$formData, 'data', _this.toDate(result.data.data, true)), _this$formData);

					_this.config.list.id_emp = [result.data.empresa];
					_this.$store.dispatch("ltcat/setLtcat", _this.formData);

					if (result.data.id_tipo_ltcat == 205) {
						_this.config.hidden.id_rev = false;
					}

					_this.getFdt();
					_this.getRevisaoLtcat();
					_this.getProfissionais();
				} else {
					_this.$router.push({ name: 'ltcat' });
				}
			});
		},
		getEmpresa: function getEmpresa() {

			if (!this.formData.id_emp) return;

			window.open(this.env.url_cs + 'app/empresas_info.php?abre=' + this.formData.id_emp, 'blank');
		},
		getModelo: function getModelo(search) {
			var _this2 = this;

			this.config.loading.id_mod = true;
			this.config.list.id_mod = [];

			this.get('/ltcat/modelo', { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_mod = false;

				if (result.status == 200) {
					_this2.config.list.id_mod = result.data.data;
				}
			});
		},
		getProfissionais: function getProfissionais(search) {
			var _this3 = this;

			this.config.loading.id_res = true;
			this.config.list.id_res = [];

			this.formData.empresa.id_eng.push(0);
			this.formData.empresa.id_tec.push(0);

			var filter = {
				ids: [],
				profissionais: [0, 1, 2]
			};

			for (var index = 0; index < this.formData.empresa.id_eng.length; index++) {
				var element = this.formData.empresa.id_eng[index];
				filter.ids.push(element);
			}

			for (var _index = 0; _index < this.formData.empresa.id_med.length; _index++) {
				var _element = this.formData.empresa.id_med[_index];
				filter.ids.push(_element);
			}

			for (var _index2 = 0; _index2 < this.formData.empresa.id_tec.length; _index2++) {
				var _element2 = this.formData.empresa.id_tec[_index2];
				filter.ids.push(_element2);
			}

			console.log('asdf', filter);
			this.get('/profissionais/-1', { search: search, filter: filter }).then(function (result) {
				result = result[0];

				_this3.config.loading.id_res = false;

				if (result.status == 200) {
					_this3.config.list.id_res = result.data.data;
				}
			});
		},
		getFdt: function getFdt(search) {
			var _this4 = this;

			if (!this.formData.id_emp || this.config.list.id_fdt.length > 0) return;

			this.config.loading.id_fdt = true;
			this.config.list.id_fdt = [];

			this.get('/pcmso/fdt/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this4.config.loading.id_fdt = false;

				if (result.status == 200) {
					_this4.config.list.id_fdt = result.data.data;
				}
			});
		},
		getRevisaoLtcat: function getRevisaoLtcat() {
			var _this5 = this;

			if (!this.formData.id_emp || !this.formData.id_fdt || this.config.list.id_rev.length > 0) return;

			this.config.loading.id_rev = true;
			this.config.list.id_rev = [];

			var filter = {
				id_empresa: this.formData.id_emp
			};

			this.get('/ltcat', { filter: filter }).then(function (result) {
				result = result[0];

				_this5.config.loading.id_rev = false;

				if (result.status == 200) {
					_this5.config.list.id_rev = _this5.formataRevisao(result.data.data);
				}
			});
		},
		handlerDisableYesterdayDate: function handlerDisableYesterdayDate(date) {

			if (this.config.list.id_rev.length == 0) return false;

			var primeira_revisao = this.config.list.id_rev[0];

			var hoje = primeira_revisao.parent ? primeira_revisao.parent.data : primeira_revisao.data;
			date = this.toDate(date, true, 'YYYY-MM-DD');

			return date < hoje;
		},
		salvar: function salvar() {
			var _this6 = this;

			this.response = {};
			this.config.loading.save = true;

			this.post('ltcat/editar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Registro salvo com sucesso!');
				}
			});
		}
	}
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_cadastrar__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcao__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__funcao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, Funcao: __WEBPACK_IMPORTED_MODULE_6__funcao___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Medicao: __WEBPACK_IMPORTED_MODULE_7__medicao___default.a, ConclusaoTecnica: __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showFormCadastro": function parentShowFormCadastro() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          copiar: this.getGhe
        },
        loading: {
          save: false,
          config: false,
          copiar: false,
          content: false
        },
        list: {
          copiar: []
        }
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        copiar: null,
        ghes: []
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false,
      tableHead: [{
        key: "ordem",
        show_numeric: true,
        sortable: true,
        width: "200px",
        label: "Ordem"
      }, {
        key: "ghe",
        show_text: true,
        sortable: true,
        width: "200px",
        label: "GHE"
      }, {
        key: "descricao",
        show_text: true,
        sortable: true,
        label: "Descrição"
      }, {
        key: "buttons",
        label: "",
        width: "50px"
      }],
      tableData: []
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_cadastrar__["a" /* default */];
  },
  methods: {
    inicialize: function inicialize(formData) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, formData ? formData : this.parent.formData);

      this.tagConfig = "tab-cadastro";
      this.tableData = [];
      this.getGhe();
    },
    onRegister: function onRegister() {
      var ordem = this.tableData.length + 1,
          ghe = this.tableData.length + 1;

      if (this.tableData.length == 0 && this.config.list.copiar.length > 0) {
        var _data = this.config.list.copiar[this.config.list.copiar.length - 1];

        ordem = _data.ordem + 1;
        ghe = _data.ordem + 1;
      } else {
        var _data = this.tableData[this.tableData.length - 1];

        if (_data) {
          ordem = _data.ordem + 1;
          ghe = _data.ordem + 1;
        } else {
          ordem = 1;
          ghe = 1;
        }
      }

      var data = {
        id: 0,
        ordem: ordem,
        ghe: ghe,
        descricao: null
      };

      this.tableData.push({
        id: 0,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: null,
        _data: data
      });
    },
    onDelete: function onDelete(item) {
      this.tableData.splice(item.index, 1);
    },
    onClose: function onClose() {
      this.parent.getLtcat();
    },
    getGhe: function getGhe(_search) {
      var _this = this;

      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this.config.loading.copiar = false;

        if (result.status == 200) {
          _this.config.list.copiar = result.data.data;
        }

        if (_this.tableData.length == 0) _this.onRegister();
      });
    },
    formatData: function formatData() {
      this.formData.ghes = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var element = this.tableData[i];
        this.formData.ghes.push(element._data);
      }
    },
    salvar: function salvar() {
      var _this2 = this;

      this.formatData();

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/cadastrar", this.formData).then(function (result) {
        result = result[0];

        _this2.config.loading.save = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg("Dados atualizados");
          _this2.showFormEdit = !_this2.showFormEdit;
          _this2.parent.getLtcat();
        }
      });
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_conclusao_cadastrar__ = __webpack_require__(969);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "ltcat.ghe.funcao",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.formData.id': function parentFormDataId() {
			this.getLtcatConclusaoTecnica();
			this.getGhe();
		},
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {
			this.getGhe();
		},
		'formData.id_fun': function formDataId_fun() {
			this.config.disabled.cbo = this.formData.id_fun ? false : true;
			this.config.disabled.descricao = this.formData.id_fun ? false : true;

			var funcao = this.arrFindByField(this.config.list.id_fun, 'id', this.formData.id_fun);

			if (funcao) {
				this.formData.cbo = funcao.cbo;
				this.formData.descricao = funcao.descricao;
			}
		},
		'formData.id_con_tec': function formDataId_con_tec() {
			if (this.formData.id_con_tec) {
				this.formData.nome = this.formData.id_con_tec.nome;
				this.formData.descricao = this.formData.id_con_tec.descricao;
			}
		}
	},
	data: function data() {
		return {
			config: {
				click: {
					id_con_tec: this.getConclusaoTecnica,
					replicar: this.getGhe
				},
				loading: {
					save: false,
					content: false,
					id_con_tec: false,
					replicar: false
				},
				list: {
					id_con_tec: [],
					replicar: []
				},
				disabled: {
					id_con_tec: false
				},
				hidden: {
					id_con_tec: false,
					inserir: false
				},
				title: {
					equipamentos_insert: 'Inserir Equipamento',
					replicar_subs: 'Sobrescrever medição caso existir'
				},
				description: {
					replicar_subs: 'Se habilitar esse campo, o sistema vai excluir as medições existentes nos GHE selecionados e inserir novamente baseado nessa medição.'
				}
			},
			pagination: {},
			response: {},
			formData: {
				id: 0,
				id_ghe: this.parent.formData.id,
				id_con_tec: null,
				nome: null,
				descricao: null,
				usuario: null,
				updated_at: null,
				replicar: [],
				replicar_subs: 0
			},
			formItems: [],
			tableHead: [{
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'descricao',
				sortable: true,
				show_colapse: true,
				label: 'Descrição'
			}, {
				key: 'updated_at',
				width: '180px',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			showFormEdit: false
		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},
	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_conclusao_cadastrar__["a" /* default */];
		this.getLtcatConclusaoTecnica();
		this.getConclusaoTecnica();
		this.getGhe();
	},


	methods: {

		onRegister: function onRegister() {
			this.formData = {
				id: 0,
				id_ghe: this.parent.formData.id,
				id_con_tec: null,
				nome: null,
				descricao: null,
				usuario: null,
				inserir: 1,
				updated_at: null,
				replicar: [],
				replicar_subs: 0
			};
			this.config.hidden.id_con_tec = false;
			this.config.hidden.inserir = false;
			this.showFormEdit = !this.showFormEdit;
		},

		onEdit: function onEdit(data) {
			var _this = this;

			this.showFormEdit = !this.showFormEdit;
			this.config.loading.content = true;
			this.config.hidden.id_con_tec = true;
			this.config.hidden.inserir = true;

			this.get('ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id + '/' + data.id).then(function (result) {

				result = result[0];
				_this.response = result;
				_this.config.loading.content = false;

				if (result.status == 200) {
					_this.formData = {
						id: data.id,
						id_ghe: _this.parent.formData.id,
						id_con_tec: null,
						nome: data.nome,
						descricao: data.descricao,
						usuario: data.usuario,
						updated_at: data.updated_at,
						inserir: 0,
						replicar: [],
						replicar_subs: 0
					};
				}
			});
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;
				self.loadingTable = true;

				_this2.post('/ltcat/ghe/conclusao-tecnica/' + _this2.parent.formData.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getLtcatConclusaoTecnica();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getGhe: function getGhe(_search) {
			var _this3 = this;

			if (!this.$store.state.ltcat.data) return;

			this.config.loading.replicar = true;
			this.config.list.replicar = [];

			this.get('ltcat/ghe/' + this.$store.state.ltcat.data.id, { search: _search }).then(function (result) {

				result = result[0];
				_this3.config.loading.replicar = false;

				if (result.status == 200) {

					var data = result.data.data;

					for (var i = 0; i < data.length; i++) {
						var element = data[i];
						if (element.id != _this3.parent.formData.id) {
							_this3.config.list.replicar.push(element);
						}
					}
				}
			});
		},

		getConclusaoTecnica: function getConclusaoTecnica(_search) {
			var _this4 = this;

			this.config.loading.id_con_tec = true;
			this.config.list.id_con_tec = [];

			this.get('conclusao-tecnica', { search: _search }).then(function (result) {

				result = result[0];

				_this4.config.loading.id_con_tec = false;

				if (result.status == 200) {
					_this4.config.list.id_con_tec = result.data.data;
				}
			});
		},

		getLtcatConclusaoTecnica: function getLtcatConclusaoTecnica(_search, _page, _pagination) {
			var _this5 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this5.response = result;
				_this5.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this5,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'nome': data[i].nome,
							'descricao': data[i].descricao,
							'updated_at': _this5.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this5.validarPermissao(567),
								disable_edit: !_this5.validarPermissao(567)
							},
							buttons: []
						};
						tableData.push(item);
					}

					_this5.pagination = pagination;
					_this5.tableData = tableData;
				}
			});
		},

		salvar: function salvar() {
			var _this6 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/ghe/conclusao-tecnica/' + this.parent.formData.id + '/editar', this.formData).then(function (result) {

				result = result[0];

				_this6.config.loading.save = false;
				_this6.response = result;

				if (result.status == 200) {
					_this6.edMsg('Dados atualizados');
					_this6.showFormEdit = !_this6.showFormEdit;
					_this6.getLtcatConclusaoTecnica();
					_this6.getConclusaoTecnica();
				}
			});
		}
	}
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_ghe_editar__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funcao__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funcao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__funcao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcionario__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcionario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__funcionario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: {
    EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a,
    Funcao: __WEBPACK_IMPORTED_MODULE_5__funcao___default.a,
    Funcionario: __WEBPACK_IMPORTED_MODULE_6__funcionario___default.a,
    Medicao: __WEBPACK_IMPORTED_MODULE_7__medicao___default.a,
    ConclusaoTecnica: __WEBPACK_IMPORTED_MODULE_8__conclusao_tecnica___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.showFormEdit": function parentShowFormEdit() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.inicialize();
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          copiar: this.getGhe
        },
        loading: {
          save: false,
          config: false,
          copiar: false
        },
        list: {
          copiar: []
        }
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        ordem: 1,
        ghe: null,
        descricao: null,
        obs: null,
        descricao_ambiente_trabalho: null,
        copiar: null,
        updated_at: null,
        usuario: null,
        ordenar: 0,
        funcoes: [],
        medicoes: [],
        conclusoes: [],
        funcionarios: []
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_ghe_editar__["a" /* default */];
  },

  methods: {
    inicialize: function inicialize(formData) {
      this.formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, formData ? formData : this.parent.formData);
      this.tagConfig = "tab-cadastro";
      this.getGhe();
    },
    onClose: function onClose() {
      this.parent.getLtcat();
    },
    getGhe: function getGhe(_search) {
      var _this = this;

      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this.config.loading.copiar = false;

        if (result.status == 200) {
          _this.config.list.copiar = result.data.data;
        }
      });
    },
    salvar: function salvar() {
      var _this2 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this2.config.loading.save = false;
        _this2.response = result;

        if (result.status == 200) {
          _this2.edMsg("Dados atualizados");
          _this2.inicialize(result.data);
          _this2.parent.getLtcat();
        }
      });
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_funcao_cadastrar__ = __webpack_require__(971);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.funcao",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  computed: {
    event: {
      cache: false,
      get: function get() {
        return this.$store.state.common.event;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEvent", value);
      }
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatFuncao();
      this.getGhe();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getGhe();
    },
    "formData.id_fun": function formDataId_fun() {
      this.config.disabled.cbo = this.formData.id_fun ? false : true;
      this.config.disabled.descricao = this.formData.id_fun ? false : true;

      var funcao = this.arrFindByField(this.config.list.id_fun, "id", this.formData.id_fun);

      if (funcao) {
        this.formData.cbo = funcao.cbo;
        this.formData.descricao = funcao.descricao;
      }
    }
  },
  data: function data() {
    return {
      config: {
        click: {
          id_fun: this.getFuncao,
          replicar: this.getGhe
        },
        loading: {
          save: false,
          content: false,
          id_fun: false,
          replicar: false
        },
        list: {
          id_fun: [],
          replicar: []
        },
        disabled: {
          cbo: true,
          descricao: true,
          id_fun: false
        },
        title: {
          equipamentos_insert: "Inserir Equipamento",
          replicar_subs: "Sobrescrever medição caso existir"
        },
        description: {
          replicar_subs: "Se habilitar esse campo, o sistema vai excluir as medições existentes nos GHE selecionados e inserir novamente baseado nessa medição."
        }
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0
      },
      formItems: [],
      tableHead: [{
        key: "cbo",
        sortable: true,
        width: "80px",
        label: "CBO"
      }, {
        key: "funcao",
        sortable: true,
        label: "Função"
      }, {
        key: "descricao",
        sortable: true,
        show_colapse: true,
        label: "Descrição"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_ltcat_ghe_funcao_cadastrar__["a" /* default */];
    this.getLtcatFuncao();
    this.getGhe();
  },


  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_fun: null,
        cbo: null,
        descricao: null,
        usuario: null,
        updated_at: null,
        replicar: [],
        replicar_subs: 0
      };
      this.config.disabled.id_fun = false;
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function onEdit(data) {
      var _this = this;

      this.showFormEdit = !this.showFormEdit;
      this.config.loading.content = true;
      this.config.disabled.id_fun = true;
      this.config.list.id_fun = [];

      this.get("ltcat/ghe/funcao/" + this.parent.formData.id + "/" + data.id).then(function (result) {
        result = result[0];
        _this.response = result;
        _this.config.loading.content = false;

        if (result.status == 200) {
          _this.formData = {
            id: data.id,
            id_ghe: _this.parent.formData.id,
            id_fun: data.funcao.id,
            cbo: data.cbo,
            descricao: data.descricao,
            usuario: data.usuario,
            updated_at: data.updated_at,
            replicar: [],
            replicar_subs: 0
          };
          _this.config.list.id_fun.push(data.funcao);
        }
      });
    },

    onDelete: function onDelete(data) {
      var _this2 = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this2.post("/ltcat/ghe/funcao/" + _this2.parent.formData.id + "/deletar", {
          ids: data
        }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatFuncao();
            self.edMsg("Registo excluido com sucesso");
            self.event = new Date().getTime() + "-funcoes-save";
          }
        });
      });
    },

    getGhe: function getGhe(_search) {
      var _this3 = this;

      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this3.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var i = 0; i < data.length; i++) {
            var element = data[i];
            if (element.id != _this3.parent.formData.id) {
              _this3.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getFuncao: function getFuncao(_search) {
      var _this4 = this;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("funcao", { search: _search }).then(function (result) {
        result = result[0];

        _this4.config.loading.id_fun = false;

        if (result.status == 200) {
          _this4.config.list.id_fun = result.data.data;
        }
      });
    },

    getLtcatFuncao: function getLtcatFuncao(_search, _page, _pagination) {
      var _this5 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/funcao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this5.response = result;
        _this5.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this5,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              funcao: data[i].funcao.nome,
              cbo: data[i].cbo,
              descricao: data[i].descricao,
              updated_at: _this5.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this5.validarPermissao(567),
                disable_edit: !_this5.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this5.pagination = pagination;
          _this5.tableData = tableData;
        }
      });
    },
    salvar: function salvar() {
      var _this6 = this;

      this.config.loading.save = true;
      this.response = {};

      this.post("/ltcat/ghe/funcao/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this6.config.loading.save = false;
        _this6.response = result;

        if (result.status == 200) {
          _this6.edMsg("Dados atualizados");
          _this6.showFormEdit = !_this6.showFormEdit;
          _this6.getLtcatFuncao();
          _this6.event = new Date().getTime() + "-funcoes-save";
        }
      });
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_template__ = __webpack_require__(33);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.funcao",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_2_template__["a" /* EdForm */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_2_template__["g" /* EdInputAutoComplete */],
    EdInputText: __WEBPACK_IMPORTED_MODULE_2_template__["e" /* EdInputText */],
    EdInputTextArea: __WEBPACK_IMPORTED_MODULE_2_template__["j" /* EdInputTextArea */]
  },
  mixins: [],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatFuncionario();
      this.getFuncionario();
      this.getLtcatFuncao();
    },
    "parent.formData.funcoes": function parentFormDataFuncoes() {},
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {},
    "$store.state.common.event": function $storeStateCommonEvent() {
      this.getLtcatFuncao();
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null
      },
      tableHead: [{
        key: "cpf",
        sortable: true,
        width: "80px",
        label: "CPF"
      }, {
        key: "nome",
        sortable: true,
        label: "Nome"
      }, {
        key: "funcao",
        sortable: true,
        label: "Função"
      }, {
        key: "descricao",
        sortable: true,
        show_colapse: true,
        label: "Descrição Atividades"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      funcionario: null,
      lstFuncionario: [],
      lstFuncoes: [],
      loadingFuncionario: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcatFuncionario();
    this.getLtcatFuncao();
    this.getFuncionario();
  },


  methods: {
    setFuncionario: function setFuncionario() {
      if (this.lstFuncoes) {
        var self = this;
        var funcionario = this.lstFuncionario.find(function (c) {
          return c.id == self.formData.id_funcionario;
        });
        var funcao = this.lstFuncoes.find(function (c) {
          return c.funcao && funcionario && c.funcao.id == funcionario.id_funcao;
        });

        if (funcao && funcao.descricao) {
          this.formData.descricao = funcao.descricao;
        } else if (funcionario && funcionario.funcao) {
          this.formData.descricao = funcionario.funcao.descricao;
        } else {
          this.formData.descricao = null;
        }
      }
    },
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_funcionario: null,
        descricao: null,
        usuario: null,
        updated_at: null
      };
      this.showFormEdit = !this.showFormEdit;
    },
    onEdit: function onEdit(data) {
      this.formData = {
        id: data.id,
        id_ghe: this.parent.formData.id,
        id_funcionario: data.funcionario.id,
        funcionario: data.funcionario,
        descricao: data.descricao,
        usuario: data.usuario,
        updated_at: data.updated_at
      };

      console.log("formData", this.formData);
      this.showFormEdit = !this.showFormEdit;
    },


    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.$root.$request.post("/ltcat/ghe/funcionario/" + _this.parent.formData.id + "/deletar", {
          ids: data
        }).then(function (result) {
          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatFuncionario();
            self.$root.$dialog.alert("Registo excluido com sucesso");
          }
        });
      });
    },

    getFuncionario: function getFuncionario(_search) {
      var _this2 = this;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.$root.$request.get("/empresa/funcionario/" + this.ltcat.id_emp, { search: _search }).then(function (result) {
        _this2.loadingFuncionario = false;
        if (result.status == 200) {
          _this2.lstFuncionario = result.data.data;
        }
      });
    },
    getLtcatFuncionario: function getLtcatFuncionario(_search, _page, _pagination) {
      var _this3 = this;

      this.loadingTable = true;
      this.response = {};

      this.$root.$request.get("ltcat/ghe/funcionario/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this3,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              cpf: data[i].funcionario.cpf,
              nome: data[i].funcionario.nome,
              funcao: data[i].funcionario.funcao ? data[i].funcionario.funcao.nome : "",
              descricao: data[i].descricao,
              updated_at: _this3.$utilidade.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this3.$root.$session.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this3.pagination = pagination;
          _this3.tableData = tableData;
        }
      });
    },
    getLtcatFuncao: function getLtcatFuncao() {
      var _this4 = this;

      this.lstFuncoes = [];
      this.$root.$request.get("ltcat/ghe/funcao/" + this.parent.formData.id).then(function (result) {
        if (result.status == 200) {
          _this4.lstFuncoes = result.data.data;
        }
      });
    },
    salvar: function salvar() {
      var _this5 = this;

      this.$root.$loading.set(true);
      this.response = {};

      this.$root.$request.post("/ltcat/ghe/funcionario/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {
        _this5.$root.$loading.set(false);
        _this5.response = result;

        if (result.status == 200) {
          _this5.$root.$dialog.alert("Dados atualizados");
          _this5.showFormEdit = !_this5.showFormEdit;
          _this5.getLtcatFuncionario();
        }
      });
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editar__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastrar__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cadastrar__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Editar: __WEBPACK_IMPORTED_MODULE_3__editar___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_4__cadastrar___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
  props: {
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getLtcat();
    },
    "$store.state.common.event": function $storeStateCommonEvent() {
      this.getLtcat();
    }
  },
  data: function data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      tableHead: [{
        key: "ordem",
        width: "50px",
        sortable: true,
        show_fdt: true,
        label: "Ordem"
      }, {
        key: "ghe",
        sortable: true,
        show_fdt: true,
        label: "GHE (Setor)"
      }, {
        key: "medicoes",
        sortable: true,
        show_colapse: true,
        label: "Medições"
      }, {
        key: "funcoes",
        sortable: true,
        show_colapse: true,
        label: "Funções"
      }, {
        key: "funcionarios",
        sortable: true,
        show_colapse: true,
        label: "Funcionários"
      }, {
        key: "conclusoes",
        sortable: true,
        show_colapse: true,
        label: "Conclusão Técnica"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormCadastro: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
    this.formData = {};
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcat();
  },


  methods: {
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        copiar: null,
        ghes: []
      };
      this.showFormCadastro = !this.showFormCadastro;
    },
    onEdit: function onEdit(data) {
      this.formData = {
        id: data.id,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: data.descricao,
        copiar: null,
        updated_at: data.updated_at,
        usuario: data.usuario,
        funcoes: data.funcoes,
        medicoes: data.medicoes,
        conclusoes: data.conclusoes,
        funcionarios: data.funcionarios,
        obs: data.obs,
        ordenar: 0
      };
      this.showFormEdit = !this.showFormEdit;
    },
    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.post("/ltcat/ghe/" + _this.$store.state.ltcat.data.id + "/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },
    getLtcat: function getLtcat(_search, _page, _pagination) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this2.response = result;
        _this2.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this2,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var funcoes = "",
                funcionarios = "",
                medicoes = "",
                conclusoes = "";

            for (var j = 0; j < data[i].funcoes.length; j++) {
              var element = data[i].funcoes[j];
              funcoes += "<li>" + element.funcao.nome + "</li><br>";
            }

            for (var _j = 0; _j < data[i].funcionarios.length; _j++) {
              var _element = data[i].funcionarios[_j];
              funcionarios += "<li>" + _element.funcionario.nome + "</li><br>";
            }

            for (var _j2 = 0; _j2 < data[i].medicoes.length; _j2++) {
              var _element2 = data[i].medicoes[_j2];
              medicoes += "<li>" + (_element2.data_medicao ? _this2.toDate(_element2.data_medicao, true) + ": " : "") + _element2.fator_risco.nome + "</li><br>";
            }

            for (var _j3 = 0; _j3 < data[i].conclusoes.length; _j3++) {
              var _element3 = data[i].conclusoes[_j3];
              conclusoes += "<li>" + _element3.nome + "<br>" + _element3.descricao + "</li><br>";
            }

            var item = {
              ordem: data[i].ordem,
              ghe: data[i].ghe + " (" + data[i].descricao + ")",
              funcoes: funcoes,
              funcionarios: funcionarios,
              conclusoes: conclusoes,
              medicoes: medicoes,
              obs: data[i].obs ? data[i].obs.replace(/(?:\r\n|\r|\n)/g, "<br>") : "",
              updated_at: _this2.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this2.validarPermissao(567),
                disable_edit: !_this2.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_template__ = __webpack_require__(33);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat.ghe.medicao",
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_5_template__["c" /* EdAlert */],
    EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_5_template__["a" /* EdForm */],
    EdButton: __WEBPACK_IMPORTED_MODULE_3_common_button___default.a,
    EdInputText: __WEBPACK_IMPORTED_MODULE_5_template__["e" /* EdInputText */],
    EdInputDate: __WEBPACK_IMPORTED_MODULE_5_template__["f" /* EdInputDate */],
    EdInputAutoComplete: __WEBPACK_IMPORTED_MODULE_5_template__["g" /* EdInputAutoComplete */],
    EdInputSelect: __WEBPACK_IMPORTED_MODULE_5_template__["b" /* EdInputSelect */],
    EdInputSelectTipo: __WEBPACK_IMPORTED_MODULE_5_template__["h" /* EdInputSelectTipo */],
    EdInputSwitch: __WEBPACK_IMPORTED_MODULE_5_template__["l" /* EdInputSwitch */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_rest___default.a],
  props: {
    parent: {
      type: Object,
      default: null
    },
    ltcat: {
      type: Object,
      default: null
    }
  },
  watch: {
    "parent.formData.id": function parentFormDataId() {
      this.getLtcatRisco();
      this.getGhe();
    },
    "$store.state.ltcat.data.id": function $storeStateLtcatDataId() {
      this.getGhe();
    },
    "formData.id_age": function formDataId_age() {
      if (this.formData.id_age && this.formData.id_age.tabela) {
        this.formData.id_tab = this.formData.id_age.tabela;
      } else if (this.formData.id == 0) {
        this.getTabelaDinamicaColuna();
      }
    },
    "formData.id_tab": function formDataId_tab() {
      this.getTabelaDinamicaColuna();
    }
  },
  data: function data() {
    return {
      config: {
        loading: {
          save: false,
          content: false,
          id_age: false,
          id_tab: false,
          lancamentos: false,
          equipamentos: false,
          replicar: false,
          aposentadoria_especial: false,
          periculosidade: false,
          insalubridade: false,
          epi: false
        },
        list: {
          id_age: [],
          id_tab: [],
          lancamentos: [],
          equipamentos: [],
          replicar: [],
          aposentadoria_especial: [],
          periculosidade: [],
          insalubridade: [],
          epi: [],
          utilizEPC: [{ id: 0, nome: 'Não se aplica' }, { id: 1, nome: 'Não implementa' }, { id: 2, nome: 'Implementa' }]
        }
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: null,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi: null,
        aposentadoria_especial: 0,
        periculosidade: 0,
        insalubridade: 0,
        obs: null,
        data_medicao: null,
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        fator_riscos: [],
        equipamentos: []
      },
      formItems: [],
      tableHead: [{
        key: "risco",
        sortable: true,
        label: "Fator de Risco"
      }, {
        key: "amostragem",
        sortable: true,
        label: "Nº Amostragem"
      }, {
        key: "data_medicao",
        sortable: true,
        label: "Data Medição"
      }, {
        key: "obs",
        sortable: true,
        label: "Observações"
      }, {
        key: "updated_at",
        width: "180px",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormEquipamento: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcatRisco();
    this.getFatorRisco();
    this.getTabelaDinamica();
    this.getEquipamento();
    this.getGhe();
    this.getAposentadoriaEspecial();
    this.getPericulosidade();
    this.getInsalubridade();
  },


  methods: {
    getAposentadoriaEspecial: function getAposentadoriaEspecial() {
      this.config.list.aposentadoria_especial = [{ id: '0', nome: 'Não' }, { id: '1', nome: 'Sim' }];
    },
    getPericulosidade: function getPericulosidade() {
      this.config.list.periculosidade = [{ id: 0, nome: 'Não' }, { id: 1, nome: 'Sim' }];
    },
    getInsalubridade: function getInsalubridade() {
      this.config.list.insalubridade = [{ id: 0, nome: 'Não' }, { id: 1, nome: 'Sim' }];
    },
    onRegister: function onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi: null,
        aposentadoria_especial: 0,
        periculosidade: 0,
        insalubridade: 0,
        obs: null,
        data_medicao: this.toDate(),
        lancamentos: [],
        equipamentos: [],
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        utilizEPC: 0,
        utilizEPI: 0,
        eficEpi: 1,
        eficEpc: 1
      };
      this.showFormEdit = !this.showFormEdit;
    },
    removeEPI: function removeEPI(index) {
      this.formData.equipamentos.splice(index, 1);
    },
    addEPI: function addEPI() {
      var _this = this;

      if (!this.formData.equipamentos) {
        this.formData.equipamentos = [];
      }

      if (this.formData.epi && this.formData.equipamentos.findIndex(function (x) {
        return x.id_epi == _this.formData.epi.id;
      }) == -1) {

        var equipamento = {
          id_ghe_med: this.formData.id,
          id_epi: this.formData.epi.id,
          epi: this.formData.epi,
          medProtecao: 1,
          condFuncto: 1,
          usoInint: 1,
          przValid: 1,
          periodicTroca: 1,
          higienizacao: 1
        };

        this.formData.equipamentos.push(equipamento);
      }

      this.formData.epi = null;

      console.log('formData', this.formData);
    },
    onEdit: function onEdit(data) {
      var _this2 = this;

      this.$root.$loading.set(true, "Carregando medição");

      this.config.loading.lancamentos = true;
      this.showFormEdit = !this.showFormEdit;
      this.config.list.id_age = [];
      this.config.list.equipamentos = [];
      this.response = {};

      this.get("/ltcat/ghe/medicao/" + this.parent.formData.id + "/" + data.id).then(function (result) {
        result = result[0];

        _this2.response = result;

        if (result.status == 200) {
          _this2.formData = {
            id: result.data.id,
            id_ghe: _this2.parent.formData.id,
            id_age: result.data.fator_risco,
            id_tab: result.data.tabela,
            usuario: result.data.usuario,
            tabela: result.data.tabela,
            updated_at: result.data.updated_at,
            obs: result.data.obs,
            data_medicao: result.data.data_medicao,
            lancamentos: result.data.lancamentos,
            amostragem: result.data.amostragem,
            epi: null,
            aposentadoria_especial: !result.data.aposentadoria_especial ? 0 : parseInt(result.data.aposentadoria_especial),
            periculosidade: !result.data.periculosidade ? 0 : parseInt(result.data.periculosidade),
            insalubridade: !result.data.insalubridade ? 0 : parseInt(result.data.insalubridade),
            utilizEPC: !result.data.utilizEPC ? 0 : parseInt(result.data.utilizEPC),
            utilizEPI: !result.data.utilizEPI ? 0 : parseInt(result.data.utilizEPI),
            eficEpi: !result.data.eficEpi ? 0 : parseInt(result.data.eficEpi),
            eficEpc: !result.data.eficEpc ? 0 : parseInt(result.data.eficEpc),
            equipamentos: result.data.equipamentos,
            replicar: [],
            replicar_subs: 0
          };

          _this2.config.list.id_age.push(data.fator_risco);
        }

        _this2.config.loading.lancamentos = false;
        _this2.$root.$loading.set(false);
      });
    },
    onInserirLinha: function onInserirLinha(coluna, i) {
      for (var _i = 0; _i < coluna.tabela_valores.length; _i++) {
        var element = coluna.tabela_valores[_i];

        element.linhas.push({
          id: element.id,
          id_tab_col: element.id_tab_col,
          id_tipo_campo: element.id_tipo_campo,
          tipo_campo: element.tipo_campo,
          nome: null,
          ordem: element.linhas.length + 1,
          unidade: element.unidade,
          padrao: element.padrao,
          ativo: element.ativo
        });
      }
    },
    onDeleteLinha: function onDeleteLinha(coluna, index) {
      if (index == 0) return;

      for (var i = 0; i < coluna.tabela_valores.length; i++) {
        var element = coluna.tabela_valores[i];

        if (element.linhas.length > 1) {
          element.linhas.splice(index, 1);
        }
      }
    },
    onInserirEquipamento: function onInserirEquipamento() {
      this.showFormEquipamento = !this.showFormEquipamento;
    },
    onDelete: function onDelete(data) {
      var _this3 = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this3.post("/ltcat/ghe/medicao/" + _this3.parent.formData.id + "/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },


    getGhe: function getGhe(_search) {
      var _this4 = this;

      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this4.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (var i = 0; i < data.length; i++) {
            var element = data[i];
            if (element.id != _this4.parent.formData.id) {
              element.nome = element.ghe + ' (' + element.descricao + ')';
              _this4.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getEquipamento: function getEquipamento(_search) {
      var _this5 = this;

      this.config.loading.epi = true;
      this.config.list.epi = [];

      this.get("epi", { search: _search }).then(function (result) {
        result = result[0];
        _this5.config.loading.epi = false;

        if (result.status == 200) {
          _this5.config.list.epi = result.data.data;
        }
      });
    },

    getFatorRisco: function getFatorRisco(_search) {
      var _this6 = this;

      console.log('asdf', _search);
      this.config.loading.id_age = true;
      this.config.list.id_age = [];

      this.get("fator-risco", { search: _search }).then(function (result) {
        result = result[0];

        _this6.config.loading.id_age = false;

        if (result.status == 200) {
          _this6.config.list.id_age = result.data.data;
        }
      });
    },
    getTabelaDinamica: function getTabelaDinamica(_search) {
      var _this7 = this;

      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then(function (result) {
        result = result[0];

        _this7.config.loading.id_tab = false;

        if (result.status == 200) {
          _this7.config.list.id_tab = result.data.data;
        }
      });
    },
    getTabelaDinamicaColuna: function getTabelaDinamicaColuna() {
      var _this8 = this;

      if (!this.formData.id_tab) return;

      this.config.loading.lancamentos = true;
      this.config.list.lancamentos = [];
      this.response = {};
      var filter = {
        id_ghe_med: this.formData.id
      };

      this.get("/ltcat/tabela-dinamica/coluna/" + this.formData.id_tab.id, {
        filter: filter
      }).then(function (result) {
        result = result[0];
        _this8.response = result;

        _this8.config.loading.lancamentos = false;

        if (result.status == 200) {
          var data = result.data.data,
              coluna = null,
              tabela_valor = null,
              lancamento = null,
              item = null;

          for (var i = 0; i < data.length; i++) {
            coluna = data[i];

            if (!coluna.valor && _this8.formData.id_age && coluna.tipo_vinculo) {
              coluna.valor = _this8.formData.id_age[coluna.tipo_vinculo.valor];
            }

            for (var j = 0; j < coluna.tabela_valores.length; j++) {
              tabela_valor = coluna.tabela_valores[j];
            }

            _this8.config.list.lancamentos.push(coluna);
          }

          data = null;
          coluna = null;
          tabela_valor = null;
          lancamento = null;
          item = null;
        }
      });
    },
    getLtcatRisco: function getLtcatRisco(_search, _page, _pagination) {
      var _this9 = this;

      this.loadingTable = true;
      this.response = {};

      this.get("/ltcat/ghe/medicao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        result = result[0];
        _this9.response = result;
        _this9.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this9,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              data_medicao: data[i].data_medicao ? _this9.toDate(data[i].data_medicao, true) : "---",
              obs: data[i].obs ? data[i].obs : "---",
              risco: data[i].fator_risco.nome,
              amostragem: data[i].amostragem,
              updated_at: _this9.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this9.validarPermissao(567),
                disable_edit: !_this9.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this9.pagination = pagination;
          _this9.tableData = tableData;
        }
      });
    },
    showCategoria: function showCategoria(coluna, i) {
      var tabela_categoria = coluna.tabela_categoria,
          coluna_anterior = this.config.list.lancamentos[i - 1];

      if (!tabela_categoria || !coluna_anterior) return true;else if (coluna_anterior && !coluna_anterior.tabela_categoria) return true;else if (coluna.tabela_categoria.id != coluna_anterior.tabela_categoria.id) return true;else return false;
    },
    salvar: function salvar() {
      var _this10 = this;

      this.config.loading.save = true;
      this.response = {};

      this.formData.lancamentos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.config.list.lancamentos);

      this.$root.$request.post("/ltcat/ghe/medicao/" + this.parent.formData.id + "/editar", this.formData).then(function (result) {

        _this10.config.loading.save = false;
        _this10.response = result;

        if (result.status == 200) {
          _this10.edMsg("Dados atualizados");
          _this10.showFormEdit = !_this10.showFormEdit;
          _this10.getLtcatRisco();
        }
      });
    }
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_ltcat_filter__ = __webpack_require__(964);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ltcat",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  data: function data() {
    return {
      config: {
        click: {
          id_empresa: this.getEmpresa
        },
        list: {
          id_empresa: []
        },
        loading: {
          id_empresa: false
        }
      },
      formFilter: {
        id_empresa: null,
        vencimento: []
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "empresa",
        sortable: true,
        show_fdt: true,
        label: "Empresa"
      }, {
        key: "revisao",
        sortable: true,
        label: "Tipo de Revisão"
      }, {
        key: "vencimento",
        sortable: true,
        label: "Vencimento"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      filterItems: [],
      loadingTable: true,
      loadingEditAll: false,
      filterBadge: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getLtcat();
    this.getEmpresa();
    this.filterItems = __WEBPACK_IMPORTED_MODULE_4__form_ltcat_filter__["a" /* default */];
  },


  methods: {
    onRegister: function onRegister() {
      this.$router.push({ name: "ltcat.cadastrar" });
    },

    onEdit: function onEdit(data) {
      this.$router.push({ name: "ltcat.editar", params: { id: data.id } });
    },

    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?", "Atenção", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(function () {
        self.loadingEditAll = true;
        self.loadingTable = true;

        _this.post("/ltcat/deletar", { ids: data }).then(function (result) {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getEmpresa: function getEmpresa(search) {
      var _this2 = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this2.config.list.id_empresa = result.data.data;
        }
      });
    },


    getLtcat: function getLtcat(_search, _page, _pagination, _loading) {
      var _this3 = this;

      this.loadingTable = true;
      this.response = {};

      this.filterBadge = (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.vencimento && this.formFilter.vencimento.length == 2 ? 1 : 0);

      this.get("ltcat", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(function (result) {
        result = result[0];
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this3,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var revisao = data[i].rev + " (" + data[i].descricao + " em " + _this3.toDate(data[i].data, true) + ")";

            if (data[i].parent) {
              revisao = data[i].parent.rev + " (" + data[i].parent.descricao + " em " + _this3.toDate(data[i].parent.data, true) + ") / " + revisao;
            }

            var item = {
              empresa: data[i].empresa.nome,
              vencimento: data[i].vencimento ? _this3.toDate(data[i].vencimento, true) : "---",
              revisao: revisao,
              updated_at: _this3.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                style: !data[i].parent ? "font-weight:bold" : "",
                disable_delete: !_this3.validarPermissao(567),
                disable_edit: !_this3.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          _this3.pagination = pagination;
          _this3.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__ = __webpack_require__(291);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				estado: true,
				cnae: true,
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				}
			},
			response: {},
			credenciadaItems: [],
			formData: {
				id: 0,
				nome: null,
				cnpj: null,
				ie: null,
				cnae: null,
				cep: null,
				id_estado: null,
				id_cidade: null,
				end: null,
				num: null,
				comp: null,
				bairro: null,
				tel_com: null,
				tel_cel: null,
				email: null,
				site: null,
				obs: null,
				resp: null
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.credenciadaItems = __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__["a" /* default */];
	},
	methods: {

		salvar: function salvar() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/laboratorio/editar', this.formData).then(function (result) {

				result = result[0];

				_this.config.loading.save = false;
				_this.response = result;

				if (result.status == 200) {
					_this.edMsg('Dados atualizados');
					_this.$router.push({ name: 'ltcat.laboratorio.editar', params: { id: result.data.id } });
				}
			});
		}

	}
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fator_risco_index__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fator_risco_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fator_risco_index__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, FatorRisco: __WEBPACK_IMPORTED_MODULE_3__fator_risco_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				estado: true,
				cnae: true,
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				}
			},
			response: {},
			parceiroItems: [],
			formData: {
				id: this.$route.params.id
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.parceiroItems = __WEBPACK_IMPORTED_MODULE_2__form_parceiro_cadastrar__["a" /* default */];
		this.getLaboratorio();
	},
	methods: {

		onDelete: function onDelete(data) {

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.config.loading.save = true;

				self.delete('/laboratorio/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.config.loading.save = false;

					if (result.status == 200) {
						self.edMsg('Registo excluido com sucesso');
						self.getLaboratorio();
					}
				});
			});
		},

		getLaboratorio: function getLaboratorio() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.get('laboratorio/' + this.$route.params.id).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;
				_this.response = {};

				if (result.status == 200) {
					_this.formData = {
						id: result.data.id,
						nome: result.data.nome,
						cnpj: result.data.cnpj,
						cei: result.data.cei,
						ie: result.data.ei,
						cnae: { cnae: result.data.cnae },
						cep: result.data.cep,
						id_estado: result.data.id_estado,
						id_cidade: result.data.id_cidade,
						end: result.data.end,
						num: result.data.num,
						comp: result.data.comp,
						bairro: result.data.bairro,
						tel_com: result.data.tel_com,
						tel_cel: result.data.tel_cel,
						email: result.data.email,
						site: result.data.site,
						obs: result.data.obs,
						resp: result.data.resp
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/laboratorio/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.getLaboratorio();
				}
			});
		}

	}
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_parceiro_form_parceiro_exame_cadastrar__ = __webpack_require__(698);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "parceiro.exame",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_3_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		laboratorio: {
			type: Object,
			default: null
		}
	},
	watch: {
		laboratorio: function laboratorio() {},
		'formData.id_lab': function formDataId_lab() {
			this.config.disabled.id_exa = this.formData.id_par ? true : false;
			this.config.disabled.padrao = this.formData.id_par ? false : true;
			this.config.disabled.atualizar_tb_empresa = this.formData.id_par ? false : true;
		}
	},
	data: function data() {
		return {
			config: {
				click: {
					id_lab: this.getLaboratorio
				},
				list: {
					id_lab: []
				},
				disabled: {
					valor_custo: true,
					valor_venda: true,
					padrao: true,
					parceiro_padrao: true,
					atualizar_tb_empresa: true
				},
				hidden: {
					id_lab: true,
					parceiro_padrao: false
				},
				loading: {
					id_lab: false,
					save: false,
					table: false
				}
			},
			formData: {
				id: 0,
				id_exa: null,
				valor_custo: 0,
				valor_venda: 0,
				padrao: 0,
				atualizar_tb_empresa: 0
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'Cód'
			}, {
				key: 'risco',
				sortable: true,
				label: 'Fator de Risco'
			}, {
				key: 'id_lab',
				sortable: true,
				edit: 'select-custom',
				info: 'Esse é o laboratório padrão para esse Fator de Risco',
				label: 'Laboratório Padrão'
			}, {
				key: 'valor_custo',
				sortable: true,
				edit: 'money',
				label: 'Valor de Custo'
			}, {
				key: 'valor_venda',
				sortable: true,
				edit: 'money',
				label: 'Valor de Venda'
			}],
			tableData: [],
			formItems: [],
			loadingTable: false,
			loadingSave: false,
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_4_appsWeb_parceiro_form_parceiro_exame_cadastrar__["a" /* default */];
		this.getRiscoLaboratorio();
	},

	methods: {
		onEditAll: function onEditAll(data) {
			var _this = this;

			this.config.loading.table = true;

			this.post('/laboratorio/fator-risco/' + this.laboratorio.id + '/editar-todos', { items: data }).then(function (result) {

				result = result[0];

				_this.config.loading.table = false;

				if (result.status == 200) {
					_this.getRiscoLaboratorio();
				}
			});
		},
		getLaboratorio: function getLaboratorio(_search) {
			var _this2 = this;

			this.config.loading.id_lab = true;
			this.config.list.id_lab = [];

			this.get('laboratorio', { search: _search }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_lab = false;

				if (result.status == 200) {
					_this2.config.list.id_lab = result.data.data;
				}
			});
		},


		getRiscoLaboratorio: function getRiscoLaboratorio(_search, _page, _pagination) {
			var _this3 = this;

			this.config.loading.table = true;
			this.config.list.id_lab = [];
			this.response = {};

			this.get('/laboratorio/fator-risco/' + this.laboratorio.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this3.response = result;
				_this3.config.loading.table = false;

				var data = [],
				    tableData = [],
				    pagination = {};

				if (result.status == 200) {

					data = result.data.data;

					for (var i = 0; i < data.length; i++) {

						if (data[i].laboratorio && !_this3.arrFindByField(_this3.config.list.id_lab, 'id', data[i].id_lab)) {
							_this3.config.list.id_lab.push({
								id: data[i].id_lab,
								nome: data[i].laboratorio.nome
							});
						}

						var item = {
							'id': data[i].id,
							'risco': data[i].nome,
							'id_lab': data[i].laboratorio ? data[i].laboratorio.nome : '---',
							'valor_custo': data[i].valor_custo,
							'valor_venda': data[i].valor_venda,
							_data: data[i],
							options: {
								disable_delete: !_this3.validarPermissao(303),
								disable_edit: !_this3.validarPermissao(303),
								style: 'color:' + (data[i].laboratorio && data[i].laboratorio.id == _this3.laboratorio.id ? 'green' : 'red')
							},
							buttons: []
						};

						tableData.push(item);
					}

					pagination = result.data;
				}

				_this3.tableData = tableData;
				_this3.pagination = pagination;
			});
		},

		salvar: function salvar() {
			var _this4 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/parceiro/exames/' + this.parceiro.id + '/editar', this.formData).then(function (result) {

				result = result[0];
				_this4.response = result;

				_this4.config.loading.save = false;

				if (result.status == 200) {
					_this4.edMsg('Dados a com sucesso!');
					_this4.showFormEdit = !_this4.showFormEdit;
					_this4.getRiscoLaboratorio();
				}
			});
		}
	}
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { TableView: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			formData: {
				id: 0,
				nome: null,
				cbo: null,
				descricao: null
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'cnpj',
				sortable: true,
				width: '150px',
				label: 'CNPJ'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'telefone',
				sortable: true,
				label: 'Telefone'
			}, {
				key: 'responsavel',
				sortable: true,
				label: 'Responsável'
			}, {
				key: 'email',
				sortable: true,
				label: 'Email'
			}],
			tableData: [],
			loadingTable: true,
			loadingEditAll: false,
			showFormEdit: false,
			showFormVinculo: false,
			lstTipoPagamento: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getLaboratorio();
	},

	methods: {

		onRegister: function onRegister() {
			this.$router.push({ name: 'ltcat.laboratorio.cadastrar' });
		},

		onEdit: function onEdit(data) {
			this.$router.push({ name: 'ltcat.laboratorio.editar', params: { id: data.id } });
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/laboratorio/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getLaboratorio();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getLaboratorio: function getLaboratorio(_search, _page, _pagination, _loading) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('laboratorio', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'cnpj': data[i].cnpj,
							'nome': data[i].nome,
							'telefone': data[i].tel_com,
							'email': data[i].email,
							'responsavel': data[i].resp,
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(570),
								disable_edit: !_this2.validarPermissao(570)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_orcamento_cadastrar__ = __webpack_require__(972);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame-editar",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		anexo: {
			type: Object,
			default: function _default() {
				return {
					id: 0,
					descricao: null,
					arquivo: null,
					updated_at: null,
					usuario: null,
					ativo: 1
				};
			}
		},
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {},
		'formData.id_tipo_orcamento': function formDataId_tipo_orcamento() {
			this.config.hidden.id_orc_cp = this.formData.id_tipo_orcamento != 236;
		},
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.init();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [234],
				click: {
					id_orc_cp: this.getOrcamento
				},
				list: {
					id_orc_cp: []
				},
				loading: {
					save: false,
					content: false,
					id_orc_cp: false
				},
				hidden: {
					id_orc_cp: true
				}
			},
			formData: {
				id: 0,
				id_tipo_orcamento: 235,
				descricao: null,
				updated_at: null,
				usuario: null,
				id_orc_cp: null
			},
			response: {},
			exameItems: [],
			loadingSave: false,
			showFormEdit: false
		};
	},
	mounted: function mounted() {
		this.exameItems = __WEBPACK_IMPORTED_MODULE_3__form_orcamento_cadastrar__["a" /* default */];
	},


	methods: {
		init: function init() {
			this.formData = {
				id: 0,
				id_tipo_orcamento: 235,
				descricao: null,
				updated_at: null,
				usuario: null,
				id_orc_cp: null
			};
			this.getOrcamento();
		},


		getOrcamento: function getOrcamento(_search) {
			var _this = this;

			this.config.loading.id_orc_cp = true;
			this.config.list.id_orc_cp = [];

			this.get('ltcat/orcamento/' + this.$store.state.ltcat.data.id, { search: _search }).then(function (result) {

				result = result[0];
				_this.config.loading.id_orc_cp = false;

				if (result.status == 200) {
					_this.config.list.id_orc_cp = result.data.data;
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.response = {};
			this.loadingSave = true;

			this.post('/ltcat/orcamento/' + this.$store.state.ltcat.data.id + '/cadastrar', this.formData).then(function (result) {

				result = result[0];

				_this2.loadingSave = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Registro salvo com sucesso!');
					_this2.showFormEdit = !_this2.showFormEdit;

					if (_this2.parent.getLtcatOrcamento) _this2.parent.getLtcatOrcamento();
				}
			});
		}
	}
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_orcamento_editar__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicao__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__medicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servico__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__servico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame-editar",
  components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a, Medicao: __WEBPACK_IMPORTED_MODULE_4__medicao___default.a, Servico: __WEBPACK_IMPORTED_MODULE_5__servico___default.a, LogEmail: __WEBPACK_IMPORTED_MODULE_6_appsWeb_log_email_index___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  props: {
    parent: {
      type: [Object, Window],
      default: null
    },
    orcamento: {
      type: Object,
      default: null
    },
    showForm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    },
    showForm: function showForm() {
      alert("asdf");
      this.showFormEdit = !this.showFormEdit;
      this.init();

      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    }
  },
  data: function data() {
    return {
      config: {
        tipo: [234, 229],
        click: {
          save: this.salvar
        },
        loading: {
          save: false,
          content: false
        },
        list: {},
        disabled: {
          codigo: true
        }
      },
      formData: {
        id: 0,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      },
      response: {},
      formItems: [],
      loadingSave: false,
      showFormEdit: false,
      tagConfig: "tab-cadastro",
      tagConfigResumo: "tab-res-med"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_orcamento_editar__["a" /* default */];
    this.getOrcamento();

    this.$events.on('orcamentoProposta', function (eventData) {
      _this.getOrcamento();
    });
  },


  methods: {
    init: function init() {
      this.formData = {
        id: 0,
        codigo: null,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      };
    },
    getOrcamento: function getOrcamento() {
      var _this2 = this;

      if (!this.orcamento || this.orcamento.id == 0) return;

      this.config.loading.content = true;
      this.tagConfig = "tab-cadastro";
      this.formData = {};

      this.get("ltcat/orcamento/" + this.$store.state.ltcat.data.id + "/" + this.orcamento.id).then(function (result) {
        result = result[0];

        _this2.config.loading.content = false;

        if (result.status == 200) {
          _this2.formataData(result);
        }
      });
    },
    formataData: function formataData(result) {
      this.formData = {
        id: result.data.id,
        id_tipo_status: result.data.tipo_status.id,
        codigo: result.data.codigo,
        descricao: result.data.descricao,
        usuario: result.data.usuario,
        updated_at: result.data.updated_at
      };
    },
    salvar: function salvar() {
      var _this3 = this;

      this.response = {};
      this.loadingSave = true;

      this.post("/ltcat/orcamento/" + this.$store.state.ltcat.data.id + "/editar", this.formData).then(function (result) {
        result = result[0];

        _this3.loadingSave = false;
        _this3.response = result;

        if (result.status == 200) {
          _this3.edMsg("Registro salvo com sucesso!");
          _this3.formataData(result);
          _this3.showFormEdit = !_this3.showFormEdit;

          if (_this3.parent.getLtcatOrcamento) _this3.parent.getLtcatOrcamento();
        }
      });
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastrar__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "exame",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_3__cadastrar___default.a, Editar: __WEBPACK_IMPORTED_MODULE_2__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		ltcat: {
			type: Object,
			default: null
		}
	},
	watch: {
		'$store.state.ltcat.data.id': function $storeStateLtcatDataId() {
			this.getLtcatOrcamento();
		}
	},
	data: function data() {
		return {
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				label: 'CÓDIGO'
			}, {
				key: 'descricao',
				sortable: true,
				label: 'Descrição'
			}, {
				key: 'tipo_status',
				sortable: true,
				label: 'Status'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: false,
			showFormEdit: false,
			showFormCadastro: false,
			tagConfig: 'tab-listar',
			orcamentos: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		var _this = this;

		this.getLtcatOrcamento();

		this.$events.on('ckeditor-pdf', function (eventData) {
			_this.formData.pdf = eventData;
		});

		this.$events.on('orcamentoProposta', function (eventData) {
			_this.getLtcatOrcamento();
		});
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormCadastro = !this.showFormCadastro;
			this.orcamentos = [];
		},

		onEdit: function onEdit(data) {

			var index = this.orcamentos.length - 1;

			if (!this.arrFindByField(this.orcamentos, 'id', data.id)) {
				this.orcamentos.push(data);
			}

			for (var i = 0; i < this.orcamentos.length; i++) {
				var element = this.orcamentos[i];
				if (data.id == element.id) {
					index = i;
				}
			}
			this.tagConfig = 'tab-editar-' + index;
		},

		onDelete: function onDelete(data) {
			var _this2 = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingTable = true;

				_this2.post('/ltcat/orcamento/' + _this2.$store.state.ltcat.data.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingTable = false;

					if (result.status == 200) {
						self.getLtcatOrcamento();
						self.handleTabsDelete();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		handleTabsDelete: function handleTabsDelete(targetName, action) {
			this.tagConfig = 'tab-listar';

			var index = this.onlyNumber(targetName);

			for (var i = 0; i < this.orcamentos.length; i++) {
				var element = this.orcamentos[i];

				if (i == index) {
					this.orcamentos.splice(i, 1);
				}
			}
		},


		getLtcatOrcamento: function getLtcatOrcamento(_search, _page, _pagination) {
			var _this3 = this;

			if (!this.$store.state.ltcat.data) return;

			this.loadingTable = true;
			this.response = {};

			this.get('ltcat/orcamento/' + this.$store.state.ltcat.data.id, { search: _search, page: _page, pagination: _pagination, filter: { show_emp_email: 1 } }).then(function (result) {

				result = result[0];
				_this3.response = result;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						data[i].collapse = null;

						var item = {
							'id': data[i].codigo,
							'descricao': data[i].descricao ? data[i].descricao : '---',
							'tipo_status': data[i].tipo_status ? data[i].tipo_status.descricao : '---',
							'updated_at': _this3.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this3.validarPermissao(577) || data[i].tipo_status.bloqueado == 1,
								disable_edit: !_this3.validarPermissao(577)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this3.pagination = pagination;
					_this3.tableData = tableData;
				}

				_this3.loadingTable = false;
			});
		}

	}
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_rest__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_common_rest___default.a],
  props: {
    orcamento: {
      type: Object,
      default: null
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      this.inicialize();
    },
    "formData.point_type": function formDataPoint_type() {
      this.getLtcatOrcamentoMedicao();
    },
    tableData: function tableData() {
      this.formataDados();
    }
  },
  data: function data() {
    return {
      formData: {
        point_type: "ghe"
      },
      pagination: {},
      response: {},
      tableData: [],
      tableMedicaoChecked: [],
      tablePointChecked: [],
      loadingTable: false,
      showFormEdit: false,
      showFormCadastro: false,
      showPopover: false
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.getLtcatOrcamentoMedicao();
    this.inicialize();
  },

  methods: {
    inicialize: function inicialize() {
      if (this.orcamento) {
        this.formData.point_type = this.orcamento.agrupar;
      }
    },


    onRegister: function onRegister() {
      this.showFormCadastro = !this.showFormCadastro;
      this.formData = {
        id: 0
      };
    },

    onEdit: function onEdit(data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        descricao: data.descricao,
        tipo_status: data.tipo_status,
        usuario: data.usuario,
        updated_at: data.updated_at
      };
    },

    formataDados: function formataDados() {
      for (var i = 0; i < this.tableData.length; i++) {
        var data = this.tableData[i];

        for (var j = 0; j < data.orcamento_medicoes.length; j++) {
          var medicao = data.orcamento_medicoes[j];

          var valor_venda = this.moneyToFloat(medicao.valor_venda),
              amostragem = parseInt(medicao.amostragem);

          medicao.valor_venda = this.floatToMoney(valor_venda);
          medicao.valor_total = this.floatToMoney(valor_venda * amostragem);
        }
      }
    },


    getLtcatOrcamentoMedicao: function getLtcatOrcamentoMedicao(_search, _page, _pagination) {
      var _this = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.tableData = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formData
      }).then(function (result) {
        result = result[0];
        _this.response = result;

        if (result.status == 200) {
          _this.tableData = result.data;
        }

        _this.loadingTable = false;
      });
    },

    restaurar: function restaurar() {
      var _this2 = this;

      var self = this;

      this.$confirm("O sistema vai restaurar o orçamento de acordo com o cadastro inicial. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this2.loadingTable = true;
        _this2.response = {};

        _this2.get("ltcat/orcamento/medicao/" + _this2.orcamento.id + "/restaurar").then(function (result) {
          result = result[0];
          _this2.response = result;

          _this2.loadingTable = false;

          if (result.status == 200) {
            _this2.getLtcatOrcamentoMedicao();
            _this2.edMsg("Dados atualizados com sucesso");
            _this2.$events.fire("orcamentoMedicao." + _this2.orcamento.id, []);
          }
        });
      });
    },
    agrupar: function agrupar() {
      var _this3 = this;

      var self = this;

      this.$confirm("O sistema vai agrupar " + this.tablePointChecked.length + " " + this.formData.point_type.toUpperCase() + ". Esse processo NÃO poderá ser desfeito. Deseja prosseguir?", "Atenção", {
        type: "warning"
      }).then(function () {
        _this3.loadingTable = true;
        _this3.response = {};

        _this3.post("ltcat/orcamento/medicao/" + _this3.orcamento.id + "/agrupar", {
          arrayPoint: _this3.tablePointChecked,
          filter: _this3.formData
        }).then(function (result) {
          result = result[0];
          _this3.response = result;

          _this3.loadingTable = false;

          if (result.status == 200) {
            _this3.getLtcatOrcamentoMedicao();
            _this3.edMsg("Dados atualizados com sucesso");
            _this3.$events.fire("orcamentoMedicao." + _this3.orcamento.id, []);
            _this3.tablePointChecked = [];
          }
        });
      });
    },
    salvar: function salvar() {
      var _this4 = this;

      this.loadingTable = true;
      this.response = {};

      this.post("ltcat/orcamento/medicao/" + this.orcamento.id + "/editar", {
        arrayMedicao: this.tableData
      }).then(function (result) {
        result = result[0];
        _this4.response = result;

        _this4.loadingTable = false;

        if (result.status == 200) {
          _this4.getLtcatOrcamentoMedicao();
          _this4.edMsg("Dados atualizados com sucesso");
          _this4.$events.fire("orcamentoMedicao." + _this4.orcamento.id, []);

          _this4.tableMedicaoChecked = [];
        }
      });
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_orcamento_email__ = __webpack_require__(974);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "exame",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_0_common_button___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_1_common_modal___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_common_rest___default.a],
  props: {
    orcamento: {
      type: Object,
      default: null
    }
  },
  watch: {
    "orcamento.id": function orcamentoId() {
      this.inicialize();
    }
  },
  computed: {},
  data: function data() {
    return {
      config: {
        click: {
          id_conta_email: this.getContaEmail
        },
        list: {
          id_conta_email: []
        },
        loading: {
          id_conta_email: false
        }
      },
      pagination: {},
      response: {},
      formData: {
        id_conta_email: null,
        destinatario: null,
        mensagem: null,
        pdf: null,
        forma_pagamento: null,
        qtde_medicao: 0,
        valor_medicao: 0,
        qtde_servico: 0,
        valor_servico: 0,
        valor_desconto: "0,00",
        valor_total: "0,00",
        valor_lucro: "0,00",
        percent_lucro: "0,00",
        servicos: []
      },
      loadingTable: false,
      showFormEmail: false,
      formItems: []
    };
  },
  created: function created() {
    this.formItems = __WEBPACK_IMPORTED_MODULE_4__form_orcamento_email__["a" /* default */];
  },


  mounted: function mounted() {
    var _this = this;

    this.getLtcatOrcamentoServico();
    this.getLtcatOrcamentoMedicaoResumo();
    this.getContaEmail();
    this.inicialize();

    this.$events.on("orcamentoMedicao." + this.orcamento.id, function (eventData) {
      _this.getLtcatOrcamentoMedicaoResumo();
    });

    this.$events.on("ckeditor-mensagem", function (eventData) {
      _this.formData.mensagem = eventData;
    });

    this.$events.on("ckeditor-pdf", function (eventData) {
      _this.formData.pdf = eventData;
    });
  },

  methods: {
    inicialize: function inicialize() {
      if (this.orcamento) {
        this.formData.mensagem = this.orcamento.mensagem;
        this.formData.destinatario = this.orcamento.empresa ? this.orcamento.empresa.email : null;
        this.formData.valor_desconto = this.orcamento.valor_desconto;
        this.formData.pdf = this.orcamento.pdf;
      }
    },
    onRegister: function onRegister() {
      this.formData.servicos.push({
        id: 0,
        descricao: null,
        qtde: 1,
        padrao: 0,
        valor: "0,00",
        usuario: null
      });
      this.formataCustoServicos();
    },
    onDelete: function onDelete(index) {
      this.formData.servicos.splice(index, 1);
      this.formataCustoServicos();
    },


    getContaEmail: function getContaEmail(_search) {
      var _this2 = this;

      this.config.list.id_conta_email = [];
      this.config.loading.id_conta_email = true;

      this.get("conta-email", {
        search: _search
      }).then(function (result) {
        result = result[0];
        _this2.config.loading.id_conta_email = false;

        if (result.status == 200) {
          _this2.config.list.id_conta_email = result.data.data;
        }
      });
    },

    getLtcatOrcamentoServico: function getLtcatOrcamentoServico(_search, _page, _pagination) {
      var _this3 = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicos = [];

      this.get("ltcat/orcamento/servico/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: 100
      }).then(function (result) {
        result = result[0];
        _this3.response = result;
        _this3.loadingTable = false;

        if (result.status == 200) {
          _this3.formData.servicos = result.data.data;
          _this3.formataCustoServicos();
        }
      });
    },
    getLtcatOrcamentoMedicaoResumo: function getLtcatOrcamentoMedicaoResumo() {
      var _this4 = this;

      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.formData.servicosMedicao = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id + "/resumo").then(function (result) {
        result = result[0];
        _this4.response = result;
        _this4.loadingTable = false;
        if (result.status == 200) {
          _this4.formData.servicosMedicao = result.data;
          _this4.formataCustoMedicoes();
        }
      });
    },
    formataCustoMedicoes: function formataCustoMedicoes() {
      var qtde = 0,
          valor = 0,
          self = this;

      this.formData.servicosMedicao.forEach(function (objMedicao) {
        qtde += parseInt(objMedicao.total);
        valor += self.moneyToFloat(objMedicao.valor_venda);
      });

      this.formData.qtde_medicao = qtde;
      this.formData.valor_medicao = this.floatToMoney(valor);

      this.formataCustoTotal();
    },
    formataCustoServicos: function formataCustoServicos() {
      var qtde = 0,
          valor = 0,
          self = this;

      this.formData.servicos.forEach(function (objServico) {
        qtde += parseInt(objServico.qtde);
        valor += self.moneyToFloat(objServico.valor);
      });

      this.formData.qtde_servico = qtde;
      this.formData.valor_servico = this.floatToMoney(valor);

      this.formataCustoTotal();
    },
    formataCustoTotal: function formataCustoTotal() {
      var valor_medicao = this.moneyToFloat(this.formData.valor_medicao),
          valor_servico = this.moneyToFloat(this.formData.valor_servico),
          valor_desconto = this.moneyToFloat(this.formData.valor_desconto),
          valor_total = valor_medicao + valor_servico - valor_desconto,
          valor_lucro = valor_medicao - valor_servico - valor_desconto,
          percent_lucro = valor_lucro / valor_total * 100;

      if (valor_desconto && valor_desconto > valor_lucro) {
        this.edAlert("O valor de desconto não pode ser maior que o lucro líquido", "warning");
        this.formData.valor_desconto = "0,00";
        return;
      }

      this.formData.valor_total = this.floatToMoney(valor_total);
      this.formData.valor_lucro = this.floatToMoney(valor_lucro);
      this.formData.percent_lucro = this.floatToMoney(percent_lucro);
    },
    validar_formulario: function validar_formulario() {
      var erro = "";
      this.formData.servicos.forEach(function (objServico) {
        if (!objServico.descricao) {
          erro = "Favor preencher a descrição de todos os campos";
        }
      });

      if (erro) {
        this.edAlert(erro, "danger");
        return false;
      }

      return true;
    },
    salvar: function salvar() {
      var _this5 = this;

      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post("ltcat/orcamento/servico/" + this.orcamento.id + "/editar", this.formData).then(function (result) {
          result = result[0];
          _this5.response = result;
          _this5.loadingTable = false;

          if (result.status == 200) {
            _this5.edMsg("Dados atualizados com sucesso");
            _this5.getLtcatOrcamentoServico();
          }
        });
      }
    },
    proposta: function proposta() {
      var _this6 = this;

      if (this.validar_formulario()) {
        this.loadingTable = true;
        this.response = {};

        this.post("ltcat/orcamento/servico/" + this.orcamento.id + "/enviar-proposta", this.formData).then(function (result) {
          result = result[0];
          _this6.response = result;
          _this6.loadingTable = false;

          if (result.status == 200) {
            _this6.showFormEmail = !_this6.showFormEmail;
            _this6.edMsg("Dados atualizados com sucesso");
            _this6.getLtcatOrcamentoServico();

            _this6.$events.fire("orcamentoProposta", []);
          }
        });
      }
    },
    previa: function previa(method) {
      this.open("ltcat/orcamento/servico/" + this.orcamento.id + "/previa");
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__ = __webpack_require__(292);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				click: {
					save: this.salvar,
					copiar: this.getTabaleDinamica
				},
				loading: {
					save: false,
					copiar: false
				},
				list: {
					copiar: []
				}
			},
			response: {},
			formItems: [],
			formData: {
				id: 0,
				nome: null,
				cor: null,
				ativo: 1,
				obs: null
			},
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__["a" /* default */];
		this.getTabaleDinamica();
	},
	methods: {
		getTabaleDinamica: function getTabaleDinamica(search) {
			var _this = this;

			this.config.loading.copiar = true;
			this.config.list.copiar = [];

			var filter = { ativo: 1 };

			this.get('/ltcat/tabela-dinamica', { search: search, filter: filter }).then(function (result) {

				result = result[0];

				_this.config.loading.copiar = false;

				if (result.status == 200) {
					_this.config.list.copiar = result.data.data;
				}
			});
		},
		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.$router.push({ name: 'ltcat.tabela.editar', params: { id: result.data.id } });
				}
			});
		}
	}
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_tabela_categoria_cadastrar__ = __webpack_require__(975);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		},
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaCategoria();
		},
		'parent.formData.id': function parentFormDataId() {
			this.getTabelaDinamicaCategoria();
		},
		'parent.showFormVersao': function parentShowFormVersao() {
			this.showFormEdit = !this.showFormEdit;
		}
	},
	data: function data() {
		return {
			config: {
				click: {},
				loading: {
					content: false,
					save: false
				},
				disabled: {
					versao: true
				}
			},
			response: {},
			formItems: [],
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_3__form_tabela_categoria_cadastrar__["a" /* default */];
		this.getTabelaDinamicaCategoria();
	},
	methods: {

		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria() {
			var _this = this;

			if (this.parent.formData.id == 0) return;

			this.config.loading.content = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id + '/' + this.parent.formData.id).then(function (result) {
				result = result[0];

				_this.config.loading.content = false;
				_this.response = {};

				if (result.status == 200) {
					_this.parent.formData = {
						id: result.data.id,
						nome: result.data.nome,
						updated_at: result.data.updated_at,
						usuario: result.data.usuario,
						ativo: result.data.ativo
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/categoria/' + this.tabela.id + '/editar', this.parent.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.parent.getTabelaDinamicaCategoria();
					_this2.showFormEdit = !_this2.showFormEdit;
				}
			});
		}

	}
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editar__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__editar__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a, CategoriaEdit: __WEBPACK_IMPORTED_MODULE_4__editar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaCategoria();
		}
	},
	data: function data() {
		return {
			formData: {
				id: 0,
				nome: null,
				ativo: 1
			},
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'ativo',
				sortable: true,
				label: 'Ativo'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			loadingEditAll: false,
			showFormVersao: false,
			lstTipoPagamento: []

		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.getTabelaDinamicaCategoria();
	},

	methods: {

		onRegister: function onRegister() {

			this.formData = {
				id: 0,
				nome: null,
				usuario: null,
				updated_at: null,
				ativo: 1
			};
			this.showFormVersao = !this.showFormVersao;
		},

		onEdit: function onEdit(data) {

			this.formData = {
				id: data.id,
				nome: data.nome,
				usuario: data.usuario,
				updated_at: data.updated_at,
				ativo: data.ativo
			};
			this.showFormVersao = !this.showFormVersao;
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/ltcat/tabela-dinamica/categoria/' + _this.tabela.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {
						self.getTabelaDinamicaCategoria();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'nome': data[i].nome,
							'ativo': data[i].ativo == 1 ? 'Sim' : 'Não',
							'updated_at': _this2.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								style: 'color:' + (data[i].ativo == 0 ? 'red' : ''),
								disable_delete: !_this2.validarPermissao(571),
								disable_edit: !_this2.validarPermissao(571)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_tabela_coluna_cadastrar__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__valores__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__valores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__valores__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_1_common_table___default.a, EdForm: __WEBPACK_IMPORTED_MODULE_2_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_3_common_modal___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_4_common_button___default.a, Valores: __WEBPACK_IMPORTED_MODULE_6__valores___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		tabela: {
			type: Object,
			default: null
		}
	},
	watch: {
		'tabela.id': function tabelaId() {
			this.getTabelaDinamicaColuna();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [207, 218],
				click: {
					id_cat: this.getTabelaDinamicaCategoria
				},
				loading: {
					content: false,
					id_cat: false,
					save: false
				},
				list: {
					id_cat: []
				}
			},
			response: {},
			pagination: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'ordem',
				sortable: true,
				width: '60px',
				label: 'Ordem'
			}, {
				key: 'nome',
				sortable: true,
				label: 'Nome'
			}, {
				key: 'id_tipo_campo',
				sortable: true,
				label: 'Tipo Conteúdo'
			}, {
				key: 'unidade',
				sortable: true,
				label: 'Unidade Medida'
			}, {
				key: 'valor_ref',
				sortable: true,
				label: 'Valor de Referência'
			}, {
				key: 'id_cat',
				sortable: true,
				label: 'Categoria'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			formData: {},
			formItems: [],
			showFormEdit: false,
			showForm: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_5__form_tabela_coluna_cadastrar__["a" /* default */];
		this.getTabelaDinamicaColuna();
		this.getTabelaDinamicaCategoria();
	},
	methods: {
		onRegister: function onRegister() {

			this.formData = {
				id: 0,
				id_tab: this.tabela.id,
				id_cat: null,
				id_tipo_campo: 208,
				id_tipo_vinculo: null,
				nome: null,
				ordem: this.tableData.length + 1,
				unidade: null,
				mascara: null,
				valor_ref_min: null,
				valor_ref_max: null,
				ativo: 1,
				obrigatorio: 0,
				ordenar: 0,
				tabela_valores: []
			};
			this.showForm = !this.showForm;
		},
		onEdit: function onEdit(data) {
			this.formData = {
				id: data.id,
				id_tab: this.tabela.id,
				id_cat: data.tabela_categoria ? data.tabela_categoria.id : null,
				id_tipo_campo: data.tipo_campo.id,
				id_tipo_vinculo: data.tipo_vinculo ? data.tipo_vinculo.id : null,
				nome: data.nome,
				ordem: data.ordem,
				unidade: data.unidade,
				mascara: data.mascara,
				valor_ref_min: data.valor_ref_min,
				valor_ref_max: data.valor_ref_min,
				ativo: data.ativo,
				obrigatorio: data.obrigatorio,
				updated_at: data.updated_at,
				usuario: data.usuario,
				tabela_valores: data.tabela_valores,
				ordenar: 0
			};
			this.showForm = !this.showForm;
		},
		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;
			this.response = {};

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				type: 'warning'

			}).then(function () {

				self.config.loading.content = true;

				_this.post('/ltcat/tabela-dinamica/coluna/' + _this.tabela.id + '/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.response = result;
					self.config.loading.content = false;

					if (result.status == 200) {
						self.getTabelaDinamicaColuna();
						self.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},


		getTabelaDinamicaCategoria: function getTabelaDinamicaCategoria(_search) {
			var _this2 = this;

			this.config.loading.id_cat = true;
			this.config.list.id_cat = [];

			var filter = {
				ativo: 1
			};
			this.get('/ltcat/tabela-dinamica/categoria/' + this.tabela.id, { search: _search, filter: filter }).then(function (result) {

				result = result[0];

				_this2.config.loading.id_cat = false;

				if (result.status == 200) {
					_this2.config.list.id_cat = result.data.data;
				}
			});
		},

		getTabelaDinamicaColuna: function getTabelaDinamicaColuna(_search, _page, _pagination) {
			var _this3 = this;

			if (this.tabela.id == 0) return;

			this.config.loading.content = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/coluna/' + this.tabela.id, { search: _search, page: _page, pagination: _pagination }).then(function (result) {
				result = result[0];

				_this3.config.loading.content = false;
				_this3.response = result;
				_this3.tableData = [];

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this3,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {
						var valor_ref = '';

						if (data[i].valor_ref_min) {
							valor_ref = data[i].valor_ref_min;
						}

						if (data[i].valor_ref_max) {
							valor_ref += valor_ref ? ' a ' + data[i].valor_ref_max : data[i].valor_ref_max;
						}

						var item = {
							'id': data[i].id,
							'ordem': data[i].ordem,
							'nome': data[i].nome,
							'id_tipo_campo': data[i].tipo_campo.descricao,
							'unidade': data[i].unidade,
							'id_cat': data[i].tabela_categoria ? data[i].tabela_categoria.nome : '---',
							'valor_ref': valor_ref ? valor_ref : '---',
							'updated_at': _this3.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								style: 'color:' + (data[i].ativo == 0 ? 'red' : ''),
								disable_delete: !_this3.validarPermissao(571),
								disable_edit: !_this3.validarPermissao(571)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this3.pagination = pagination;
					_this3.tableData = tableData;
				}
			});
		},


		salvar: function salvar() {
			var _this4 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/coluna/' + this.tabela.id + '/editar', this.formData).then(function (result) {

				result = result[0];

				_this4.config.loading.save = false;
				_this4.response = result;

				if (result.status == 200) {
					_this4.edMsg('Dados atualizados');
					_this4.getTabelaDinamicaColuna();
					_this4.showForm = !_this4.showForm;
				}
			});
		}

	}
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdButton: __WEBPACK_IMPORTED_MODULE_0_common_button___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		}
	},
	watch: {
		'parent.showForm': function parentShowForm() {
			this.inicialize();
		},
		'parent.formData.id': function parentFormDataId() {
			this.inicialize();
		},
		'parent.formData.id_tipo_campo': function parentFormDataId_tipo_campo() {}
	},
	data: function data() {
		return {
			tableHead: [{
				key: 'ordem',
				show_numeric: true,
				sortable: true,
				width: '200px',
				label: 'Ordem'
			}, {
				key: 'nome',
				show_text: true,
				sortable: true,
				label: 'Nome'
			}, {
				key: 'unidade',
				show_text: true,
				sortable: true,
				label: 'Unidade'
			}, {
				key: 'id_tipo_campo',
				show_select: true,
				sortable: true,
				label: 'Tipo de Campo'
			}, {
				key: 'ativo',
				show_boolean: true,
				sortable: true,
				width: '200px',
				label: 'Item Ativo?'
			}, {
				key: 'buttons',
				label: '',
				width: '50px'
			}],
			tableData: [],
			tipo_campos: []
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.inicialize();
		this.handleParametros();
	},

	methods: {
		inicialize: function inicialize() {

			var tableData = [];

			for (var i = 0; i < this.parent.formData.tabela_valores.length; i++) {
				var element = this.parent.formData.tabela_valores[i];

				var item = {
					id: element.id,
					id_tab_ver_col: this.parent.formData.id,
					id_tipo_campo: element.tipo_campo ? element.tipo_campo.id : null,
					ordem: element.ordem,
					nome: element.nome,
					unidade: element.unidade,
					padrao: element.padrao,
					ativo: element.ativo,
					_data: element
				};

				tableData.push(item);
			}

			this.tableData = tableData;
		},
		onRegister: function onRegister() {

			var data = {
				id: 0,
				id_tab_ver_col: this.parent.formData.id,
				id_tipo_campo: null,
				unidade: null,
				ordem: this.parent.formData.tabela_valores.length + 1,
				nome: 'ITEM ' + (this.parent.formData.tabela_valores.length + 1),
				ativo: 1,
				padrao: 0
			};

			this.tableData.push({
				id: 0,
				id_tab_ver_col: this.parent.formData.id,
				id_tipo_campo: null,
				ordem: this.parent.formData.tabela_valores.length + 1,
				nome: null,
				unidade: null,
				ativo: 1,
				padrao: 0,
				_data: data
			});
			this.formatData();
		},
		onDelete: function onDelete(item) {
			this.tableData.splice(item.index, 1);
			this.formatData();
		},
		formatData: function formatData() {

			this.parent.formData.tabela_valores = [];

			for (var i = 0; i < this.tableData.length; i++) {
				var element = this.tableData[i];
				this.parent.formData.tabela_valores.push(element._data);
			}
		},
		handleParametros: function handleParametros() {
			var _this = this;

			this.post('tipo/parent', { codigo: [207], exclude: [210, 211, 212, 213, 214] }).then(function (result) {

				result = result[0];

				_this.tipo_campos = [];

				if (result.status == 200) {
					_this.tipo_campos = result.data['207'];
				}
			});
		}
	}
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coluna_index__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coluna_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__coluna_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categoria_index__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categoria_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__categoria_index__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, TabelaDinamicaColuna: __WEBPACK_IMPORTED_MODULE_3__coluna_index___default.a, TabelaDinamicaCategoria: __WEBPACK_IMPORTED_MODULE_4__categoria_index___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	data: function data() {
		return {
			config: {
				click: {
					save: this.salvar
				},
				loading: {
					save: false
				},
				hidden: {
					copiar: true
				}
			},
			response: {},
			formItems: [],
			formData: {
				id: this.$route.params.id
			},
			boolExibir: false,
			tagConfig: 'tab-cadastro'
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.formItems = __WEBPACK_IMPORTED_MODULE_2__form_tabela_cadastrar__["a" /* default */];
		this.boolExibir = [1, 914].indexOf(this.$root.$session.cliente.logged.id) != -1 || this.$root.$session.usuario.logged.usuario == 'SuporteSA';
		this.getTabelaDinamica();
	},

	methods: {

		onDelete: function onDelete(data) {

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.config.loading.save = true;

				self.delete('/ltcat/tabela-dinamica/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.config.loading.save = false;

					if (result.status == 200) {
						self.edMsg('Registo excluido com sucesso');
						self.getTabelaDinamica();
					}
				});
			});
		},

		getTabelaDinamica: function getTabelaDinamica() {
			var _this = this;

			this.config.loading.save = true;
			this.response = {};

			this.get('/ltcat/tabela-dinamica/' + this.$route.params.id).then(function (result) {
				result = result[0];

				_this.config.loading.save = false;
				_this.response = {};

				if (result.status == 200) {
					_this.formData = {
						id: result.data.id,
						nome: result.data.nome,
						cor: result.data.cor,
						obs: result.data.obs,
						ativo: result.data.ativo,
						updated_at: result.data.updated_at,
						usuario: result.data.usuario
					};
				}
			});
		},

		salvar: function salvar() {
			var _this2 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/ltcat/tabela-dinamica/editar', this.formData).then(function (result) {

				result = result[0];

				_this2.config.loading.save = false;
				_this2.response = result;

				if (result.status == 200) {
					_this2.edMsg('Dados atualizados');
					_this2.getTabelaDinamica();
				}
			});
		}

	}
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_template__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "empresa",
  components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, EdButton: __WEBPACK_IMPORTED_MODULE_1_template__["d" /* EdButton */], EdAlert: __WEBPACK_IMPORTED_MODULE_1_template__["c" /* EdAlert */], EdModal: __WEBPACK_IMPORTED_MODULE_1_template__["i" /* EdModal */] },
  mixins: [],
  data: function data() {
    return {
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null
      },
      pagination: {},
      response: {},
      tableHead: [{
        key: "id",
        sortable: true,
        width: "60px",
        label: "Cód"
      }, {
        key: "nome",
        sortable: true,
        show_html: true,
        label: "Nome"
      }, {
        key: "updated_at",
        sortable: true,
        show_user: true,
        label: "Atualização"
      }],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      showFormEdit: false,
      showHtml: false,
      showFormVinculo: false,
      lstTipoPagamento: []
    };
  },
  created: function created() {},


  mounted: function mounted() {
    this.getTabelaDinamica();
  },

  methods: {
    onExportar: function onExportar() {
      this.$root.$request.open("ltcat/tabela-dinamica/exportar");
    },
    onRegister: function onRegister() {
      this.$router.push({ name: "ltcat.tabela.cadastrar" });
    },
    onEdit: function onEdit(data) {
      this.$router.push({
        name: "ltcat.tabela.editar",
        params: { id: data.id }
      });
    },
    onHtml: function onHtml(data) {
      this.showHtml = !this.showHtml;
      this.formData = data;
    },


    onDelete: function onDelete(data) {
      var _this = this;

      var self = this;

      this.$root.$dialog.confirm("O sistema vai excluir " + data.length + " registro(s). Deseja prosseguir?").then(function () {
        self.loadingEditAll = true;

        _this.$root.$request.post("/ltcat/tabela-dinamica/deletar", { ids: data }).then(function (result) {
          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getTabelaDinamica();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getTabelaDinamica: function getTabelaDinamica(_search, _page, _pagination, _loading) {
      var _this2 = this;

      this.loadingTable = true;
      this.response = {};

      this.$root.$request.get("/ltcat/tabela-dinamica", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(function (result) {
        _this2.response = result;
        _this2.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
              tableData = [],
              self = _this2,
              pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: '<div style="width:30px;float:left;margin-right:5px;background:' + data[i].cor + '">&nbsp;</div> ' + data[i].nome,
              updated_at: _this2.$utilidade.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !_this2.$root.$session.validarPermissao(571),
                disable_edit: !_this2.$root.$session.validarPermissao(571)
              },
              buttons: []
            };

            if (data[i].html || true) {
              item.buttons.push({
                icon: 'fa fa-eye',
                color: 'warning',
                title: 'Visualizar tabela',
                click: _this2.onHtml
              });
            }

            tableData.push(item);
          }

          _this2.pagination = pagination;
          _this2.tableData = tableData;
        }
      });
    }
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_periodico_desativado_cadastrar_js__ = __webpack_require__(978);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "empresa",
	components: { EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a, EdModal: __WEBPACK_IMPORTED_MODULE_2_common_modal___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
	props: {
		parent: {
			type: Object,
			default: null
		},
		showForm: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		showForm: function showForm() {
			this.showFormEdit = !this.showFormEdit;
			this.inicialize();
		},
		'formData.id_emp': function formDataId_emp() {
			this.config.disabled.id_fun = !this.formData.id_emp ? true : false;
			this.getFuncionario();
		}
	},
	data: function data() {
		return {
			config: {
				tipo: [244, 250],
				click: {
					id_emp: this.getEmpresa,
					id_fun: this.getFuncionario
				},
				loading: {
					save: false,
					id_emp: false,
					id_fun: false
				},
				list: {
					id_emp: [],
					id_fun: []
				},
				disabled: {
					id_fun: true,
					funcionario_todos: true
				},
				hidden: {
					ativo: true
				}
			},
			response: {},
			disparoItems: [],
			formData: {
				id: 0,
				empresa_todos: 1,
				funcionario_todos: 0,
				id_emp: null,
				id_fun: []
			},
			showFormEdit: false
		};
	},
	created: function created() {},


	mounted: function mounted() {
		this.disparoItems = __WEBPACK_IMPORTED_MODULE_3__form_periodico_desativado_cadastrar_js__["a" /* default */];
		this.getEmpresa();
	},
	methods: {
		inicialize: function inicialize() {
			this.formData = {
				id: 0,
				empresa_todos: 1,
				funcionario_todos: 0,
				id_emp: null,
				id_fun: []
			};
		},
		getEmpresa: function getEmpresa(search) {
			var _this = this;

			this.config.loading.id_emp = true;
			this.config.list.id_emp = [];

			this.get('empresa', { search: search }).then(function (result) {
				result = result[0];

				_this.config.loading.id_emp = false;

				if (result.status == 200) {
					_this.config.list.id_emp = result.data.data;
				}
			});
		},
		getFuncionario: function getFuncionario(search) {
			var _this2 = this;

			if (!this.formData.id_emp) return;

			this.config.loading.id_fun = true;
			this.config.list.id_fun = [];

			this.get('empresa/funcionario/' + this.formData.id_emp, { search: search }).then(function (result) {
				result = result[0];

				_this2.config.loading.id_fun = false;

				if (result.status == 200) {
					_this2.config.list.id_fun = result.data.data;
				}
			});
		},


		salvar: function salvar() {
			var _this3 = this;

			this.config.loading.save = true;
			this.response = {};

			this.post('/periodico/desativado/editar', this.formData).then(function (result) {

				result = result[0];

				_this3.config.loading.save = false;
				_this3.response = result;

				if (result.status == 200) {
					_this3.edMsg('Dados atualizados');
					_this3.showFormEdit = !_this3.showFormEdit;
					if (_this3.parent) _this3.parent.getDesativado();
				}
			});
		}

	}
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_fct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_fct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cadastrar__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "periodicos-disparo",
	components: { EdTable: __WEBPACK_IMPORTED_MODULE_0_common_table___default.a, Cadastrar: __WEBPACK_IMPORTED_MODULE_3__cadastrar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_1_common_rest___default.a],
	data: function data() {
		return {
			pagination: {},
			response: {},
			tableHead: [{
				key: 'id',
				sortable: true,
				width: '60px',
				label: 'Cód'
			}, {
				key: 'empresa',
				sortable: true,
				label: 'Empresa'
			}, {
				key: 'funcionario',
				sortable: true,
				label: 'Funcionário'
			}, {
				key: 'updated_at',
				sortable: true,
				show_user: true,
				label: 'Atualização'
			}],
			tableData: [],
			loadingTable: true,
			showFormCadastro: false

		};
	},
	beforeDestroy: function beforeDestroy() {
		this.tableData = [];
	},
	created: function created() {},


	mounted: function mounted() {
		this.getDesativado();
	},

	methods: {

		onRegister: function onRegister() {
			this.showFormCadastro = !this.showFormCadastro;
		},

		onDelete: function onDelete(data) {
			var _this = this;

			var self = this;

			this.$confirm('O sistema vai excluir ' + data.length + ' registro(s). Deseja prosseguir?', 'Atenção', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning'

			}).then(function () {

				self.loadingEditAll = true;

				_this.post('/periodico/desativado/deletar', { ids: data }).then(function (result) {
					result = result[0];

					self.loadingEditAll = false;

					if (result.status == 200) {

						_this.getDesativado();
						_this.edMsg('Registo excluido com sucesso');
					}
				});
			});
		},

		getDesativado: function getDesativado(_search, _page, _pagination) {
			var _this2 = this;

			this.loadingTable = true;
			this.response = {};

			this.get('periodico/desativado', { search: _search, page: _page, pagination: _pagination }).then(function (result) {

				result = result[0];
				_this2.response = result;
				_this2.loadingTable = false;

				if (result.status == 200) {

					var data = result.data.data,
					    tableData = [],
					    self = _this2,
					    pagination = result.data;

					for (var i = 0; i < data.length; i++) {

						var item = {
							'id': data[i].id,
							'empresa': data[i].empresa.nome,
							'funcionario': data[i].funcionario ? data[i].funcionario.nome : '---',
							'updated_at': _this2.toDate(data[i].updated_at),
							_data: data[i],
							options: {
								disable_delete: !_this2.validarPermissao(310)
							},
							buttons: []
						};

						tableData.push(item);
					}

					_this2.pagination = pagination;
					_this2.tableData = tableData;
				}
			});
		}

	}
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_common_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EdTable: __WEBPACK_IMPORTED_MODULE_5_common_table___default.a,
    EdForm: __WEBPACK_IMPORTED_MODULE_1_common_form___default.a,
    EdButton: __WEBPACK_IMPORTED_MODULE_2_common_button___default.a,
    EdModal: __WEBPACK_IMPORTED_MODULE_4_common_modal___default.a,
    EdAlert: __WEBPACK_IMPORTED_MODULE_3_common_alert___default.a,
    ConsultaHistorico: __WEBPACK_IMPORTED_MODULE_7_appsWeb_consulta_includes_historico___default.a,
    Pcmso: __WEBPACK_IMPORTED_MODULE_8_appsWeb_consulta_includes_pcmso___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  watch: {
    "formData.id_empresa": function formDataId_empresa() {
      this.config.disabled.id_funcionario = this.formData.id_empresa ? false : true;
      this.config.disabled.id_fdt = this.formData.id_empresa ? false : true;

      this.formData.id_funcionario = [];
      this.formData.id_fdt = [];

      this.getFdt();
      this.getFuncionario();
      this.getPeriodico();
    },
    "formData.periodo": function formDataPeriodo() {
      this.config.disabled.id_empresa = this.formData.periodo.length == 2 ? false : true;
    }
  },
  data: function data() {
    return {
      loadingTable: false,
      pagination: {},
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_fdt: this.getFdt
        },
        list: {
          id_empresa: [],
          id_funcionario: [],
          id_fdt: []
        },
        loading: {
          id_empresa: false,
          id_funcionario: false,
          id_fdt: false
        },
        disabled: {
          id_empresa: true,
          id_funcionario: true,
          id_fdt: true
        }
      },
      formData: {
        id_empresa: null,
        id_fdt: [],
        id_funcionario: [],
        periodo: []
      },
      formDataConsulta: {
        funcionario: []
      },
      tabPeriodico: "tab-ok",
      tabExame: "tab-exames",
      tableData: [],
      tableDataForaPeriodo: [],
      tableDataError: [],
      tableDataExame: [],
      tableFooterExame: [],
      tableDataTabelaPreco: [],
      tableHeadTabelaPreco: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "quantidade",
        sortable: true,
        label: "Quantidade"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Unitário (R$)"
      }, {
        key: "valor_total",
        sortable: true,
        label: "Valor Total (R$)"
      }],
      tableHeadExame: [{
        key: "exame",
        sortable: true,
        label: "Exame"
      }, {
        key: "valor_venda",
        sortable: true,
        label: "Valor Aproximado (R$)"
      }, {
        key: "consulta",
        sortable: true,
        width: "215px",
        label: "Última Consulta Realizada"
      }, {
        key: "tipo",
        sortable: true,
        label: "Tipo"
      }, {
        key: "data",
        sortable: true,
        width: "215px",
        label: "Data Ideal Para Refazê-lo"
      }, {
        key: "obs",
        sortable: true,
        label: "Observações"
      }],
      tableHead: [{
        key: "nome",
        sortable: true,
        show_funcionario_link: true,
        show_funcao: true,
        label: "Nome"
      }, {
        key: "fdt",
        sortable: true,
        label: "Frente de Trabalho"
      }, {
        key: "ghe",
        sortable: true,
        label: "GHE (Setor)"
      }, {
        key: "dt_per_rea",
        sortable: true,
        label: "DATA SUGERIDA PARA O PERIÓDICO"
      }, {
        key: "obs",
        sortable: true,
        show_html: true,
        label: "Observações"
      }],
      funcionario: null,
      showModal: false,
      showConsultaLote: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.tableData = [];
    this.tableDataError = [];
    this.tableDataExame = [];
    this.tableDataForaPeriodo = [];
  },
  created: function created() {},
  mounted: function mounted() {
    this.getEmpresa();
    this.formDataItems = __WEBPACK_IMPORTED_MODULE_6__form_periodico_pesquisar__["a" /* default */];
  },


  methods: {
    onConsultaLote: function onConsultaLote(data) {
      if (data.id) {
        data = [data];
      }

      this.formDataConsulta.funcionario = data;
      this.showConsultaLote = !this.showConsultaLote;
    },
    onExcel: function onExcel() {
      this.open("periodico/excel", { filter: this.formData });
    },
    onExames: function onExames(data) {
      var tableDataExame = [];
      var tableFooterExame = [];
      var valor_total = 0;
      var item = null;

      for (var i = 0; i < data.exames.length; i++) {
        item = {
          id: data.exames[i].id,
          exame: data.exames[i].nome,
          consulta: data.exames[i].id_con ? "Consulta " + data.exames[i].id_con + " (" + this.toDate(data.exames[i].dt_cad, true) + ")" + (data.exames[i].validade > 0 ? '<br><span>Exame válido por ' + data.exames[i].validade + ' dias</span>' : '') : "---",
          tipo: data.exames[i].dt_rea ? data.exames[i].tipo : "---",
          data: data.exames[i].dt_rea ? this.toDate(data.exames[i].dt_rea, true) : "---",
          obs: data.exames[i].obs ? data.exames[i].obs : "---",
          valor_venda: data.exames[i].tabela_preco ? this.floatToMoney(data.exames[i].tabela_preco.valor_venda) : "---",
          _data: data.exames[i],
          options: {
            style: "color:" + data.exames[i].cor
          },
          buttons: [{
            color: "success",
            icon: "fa fa-user-md",
            title: "Visualizar Exames",
            click: this.onExames
          }]
        };
        tableDataExame.push(item);

        if (data.exames[i].tabela_preco) {
          valor_total += Number(data.exames[i].tabela_preco.valor_venda);
        }
      }

      item = {
        id: 0,
        exame: "TOTAL",
        consulta: "---",
        tipo: "---",
        data: "---",
        obs: "---",
        valor_venda: this.floatToMoney(valor_total),
        _data: {},
        options: {
          style: "color:#000;font-weight:bold"
        },
        buttons: []
      };
      tableDataExame.push(item);

      this.tabExame = "tab-exames";
      this.showModal = !this.showModal;
      this.tableDataExame = tableDataExame;
      this.tableFooterExame = tableFooterExame;
      this.funcionario = data;
    },
    getEmpresa: function getEmpresa(_search) {
      var _this = this;

      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: _search }).then(function (result) {
        result = result[0];

        _this.config.loading.id_empresa = false;

        if (result.status == 200) {
          _this.config.list.id_empresa = result.data.data;
        }
      });
    },
    getFdt: function getFdt(search) {
      var _this2 = this;

      if (!this.formData.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("/pcmso/fdt/" + this.formData.id_empresa, {
        search: search
      }).then(function (result) {
        result = result[0];

        _this2.config.loading.id_fdt = false;

        if (result.status == 200) {
          _this2.config.list.id_fdt = result.data.data;
        }
      });
    },
    getFuncionario: function getFuncionario(_search) {
      var _this3 = this;

      if (!this.formData.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("empresa/funcionario/" + this.formData.id_empresa, {
        search: _search,
        pagination: 100
      }).then(function (result) {
        result = result[0];

        _this3.config.loading.id_funcionario = false;

        if (result.status == 200) {
          _this3.config.list.id_funcionario = result.data.data;
        }
      });
    },
    getPeriodico: function getPeriodico(search, page, pagination) {
      var _this4 = this;

      if (!this.formData.id_empresa) return;

      this.loadingTable = true;
      this.tabPeriodico = "tab-ok";

      if (this.formData.periodo.length != 2) {
        var hoje = this.toDate(null, true),
            ontem = this.toDate(this.addDate(-30, null, "D"), true),
            amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formData.periodo = [ontem, amanha];
      }

      this.get("periodico", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formData
      }).then(function (result) {
        result = result[0];

        _this4.loadingTable = false;
        _this4.response = result;

        var data = [],
            tableData = [],
            tableDataForaPeriodo = [],
            tableDataTabelaPreco = [],
            tableDataError = [],
            pagination = {};

        if (result.status == 200) {
          result.data.per_tabela_preco.forEach(function (tabela_preco, index) {
            var item = {
              id: index,
              exame: tabela_preco.fdt.nome,
              valor_venda: '---',
              valor_total: '---',
              quantidade: tabela_preco.fdt.quantidade,
              _data: tabela_preco,
              options: {
                style: "color:red;font-weight:bold"
              },
              buttons: []
            };
            tableDataTabelaPreco.push(item);

            tabela_preco.exames.forEach(function (tabela_preco_exame, indexExame) {
              var item = {
                id: index + indexExame,
                exame: tabela_preco_exame.nome,
                valor_venda: tabela_preco_exame.quantidade == 0 ? '---' : _this4.floatToMoney(tabela_preco_exame.valor_venda),
                valor_total: _this4.floatToMoney(Number(tabela_preco_exame.valor_venda) * Number(tabela_preco_exame.quantidade)),
                quantidade: tabela_preco_exame.quantidade,
                _data: tabela_preco_exame,
                buttons: []
              };
              tableDataTabelaPreco.push(item);
            });
          });

          data = result.data.per_dentro_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: data[i].dt_per_rea ? _this4.toDate(data[i].dt_per_rea, true) + "<br>" + data[i].tipo_ultima_consulta : "---",
              _data: data[i],
              buttons: [{
                color: "success",
                icon: "fa fa-user-md",
                title: "Visualizar Exames (" + data[i].exames.length + " no total)",
                click: _this4.onExames
              }]
            };
            tableData.push(item);
          }

          data = result.data.per_fora_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: [{
                color: "success",
                icon: "fa fa-user-md",
                title: "Visualizar Exames (" + data[i].exames.length + " no total)",
                click: _this4.onExames
              }]
            };
            tableDataForaPeriodo.push(item);
          }

          data = result.data.per_erro;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")" : "---",
              ghe: data[i].ghe && data[i].ghe.ghe ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")" : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: []
            };
            tableDataError.push(item);
          }
        }

        _this4.tableData = tableData;
        _this4.tableDataForaPeriodo = tableDataForaPeriodo;
        _this4.tableDataError = tableDataError;
        _this4.tableDataTabelaPreco = tableDataTabelaPreco;
      });
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_rest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apps_template_500__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_apps_template_500__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: { EmpresaHeader: __WEBPACK_IMPORTED_MODULE_1_common_menu_header_v2___default.a, EmpresaFooter: __WEBPACK_IMPORTED_MODULE_2_common_menu_footer_v2___default.a, Erro500: __WEBPACK_IMPORTED_MODULE_3_apps_template_500___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_rest___default.a],
  data: function data() {
    return {
      loadingContent: true,
      noTenant: null
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },
  mounted: function mounted() {
    this.getTenant();
  },
  created: function created() {
    this.sub_domain = "credenciada";
    this.validarLogin();
    this.tenant = this.$route.params.tenant;
  },


  methods: {

    getTenant: function getTenant() {
      var _this = this;

      this.noTenant = null;

      this.get("config").then(function (result) {

        result = result[0];

        if (result.status == 200 && result.data) {
          _this.cliente = result.data;
          _this.getUsuario();
        } else {
          _this.noTenant = result.msg;
        }
      });
    },

    getUsuario: function getUsuario() {
      var _this2 = this;

      this.get('usuario/menu').then(function (result) {

        result = result[0];

        if (result.status == 200 && result.data) {
          _this2.usuario = result.data.usuario;
          _this2.jwt = _this2.logged();
        }

        _this2.loadingContent = false;
      });
    },

    validarLogin: function validarLogin(to, from, next) {

      if (!to) to = this.$route;

      $('body').removeClass('bg-login');
      if (to.name == 'credenciada.login') $('body').addClass('bg-login');

      if (to.meta && to.meta.title && to.meta.navigation) {
        this.navigation = to.meta.navigation;
        this.setTitle(to.meta.title);
      }

      if (!to.matched.some(function (record) {
        return record.meta.requiresAuth;
      })) {
        if (next) next();
      } else {
        if (!this.logged()) {} else {
          if (next) next();
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apps_template_500__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_apps_template_500__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: { EmpresaHeader: __WEBPACK_IMPORTED_MODULE_0_common_menu_header_v2___default.a, EmpresaFooter: __WEBPACK_IMPORTED_MODULE_1_common_menu_footer_v2___default.a, Erro500: __WEBPACK_IMPORTED_MODULE_2_apps_template_500___default.a },
  mixins: [],
  data: function data() {
    return {
      loadingContent: true,
      noTenant: null
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },
  mounted: function mounted() {
    this.getTenant();
  },
  created: function created() {
    this.$root.$session.sub_domain = "empresa";
    this.$root.$loading.set(true, 'Carregando');
    this.validarLogin();
    this.$root.$session.tenant = this.$route.params.tenant;
  },


  methods: {
    getTenant: function getTenant() {
      var _this = this;

      this.noTenant = null;

      this.$root.$request.get("config").then(function (result) {

        if (result.status == 200 && result.data) {
          _this.$root.$session.cliente = result.data;

          _this.getUsuario();
        } else {
          _this.noTenant = result.msg;
        }
      });
    },
    getEmpresa: function getEmpresa() {
      var _this2 = this;

      this.$root.$request.get("meu-cadastro").then(function (result) {

        if (result.status == 200) {
          _this2.$root.$session.empresa = result.data;
        }

        _this2.loadingContent = false;
        _this2.$root.$loading.set(false);
      });
    },
    getUsuario: function getUsuario() {
      var _this3 = this;

      this.$root.$request.get('usuario/menu').then(function (result) {

        if (result.status == 200 && result.data) {
          _this3.$root.$session.usuario = result.data.usuario;
          _this3.$root.$session.jwt = _this3.$root.$session.logged();
          _this3.validarSenha();
        }

        _this3.getEmpresa();
      });
    },
    validarSenha: function validarSenha() {},
    validarLogin: function validarLogin(to, from, next) {

      if (!to) to = this.$route;

      $('body').removeClass('bg-login');
      if (to.name == 'empresa.login') $('body').addClass('bg-login');

      if (to.meta && to.meta.title && to.meta.navigation) {
        this.$root.$session.navigation = to.meta.navigation;
        this.$root.$session.setTitle(to.meta.title);
      }

      if (!to.matched.some(function (record) {
        return record.meta.requiresAuth;
      })) {
        if (next) next();
      } else {
        if (!this.$root.$session.logged()) {
          this.$router.push({ name: 'empresa.login' });
        } else {
          if (next) next();
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_root__ = __webpack_require__(979);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    EdSocket: __WEBPACK_IMPORTED_MODULE_0_root__["a" /* EdSocket */],
    EdSession: __WEBPACK_IMPORTED_MODULE_0_root__["b" /* EdSession */],
    EdRequest: __WEBPACK_IMPORTED_MODULE_0_root__["c" /* EdRequest */],
    EdNotify: __WEBPACK_IMPORTED_MODULE_0_root__["d" /* EdNotify */],
    EdDialog: __WEBPACK_IMPORTED_MODULE_0_root__["e" /* EdDialog */],
    EdLoading: __WEBPACK_IMPORTED_MODULE_0_root__["f" /* EdLoading */]
  },
  data: function data() {
    return {
      loadingContent: true
    };
  },
  mounted: function mounted() {

    this.$root.$session = this.$refs.session;
    this.$root.$socket = this.$refs.socket;
    this.$root.$request = this.$refs.request;
    this.$root.$notify = this.$refs.notify;
    this.$root.$dialog = this.$refs.dialog;
    this.$root.$loading = this.$refs.loading;

    this.$root.$session.sub_domain = "web";

    $(".carregando").html("Carregando ambiente...");
    this.getEnv();
    this.getWindow();
  },
  created: function created() {},


  methods: {
    getWindow: function getWindow() {
      var self = this;

      this.$root.$session.window = {
        height: window.innerHeight,
        width: window.innerWidth
      };

      window.addEventListener("resize", function (e) {
        self.$root.$session.window = {
          height: window.innerHeight,
          width: window.innerWidth
        };
      });
    },
    getEnv: function getEnv() {
      var _this = this;

      this.loadingContent = true;

      this.$root.$request.get("common/env").then(function (result) {

        $(".carregando").hide();

        if (result.status == 200 && result.data) {
          _this.$root.$session.deleteCookie("version");
          _this.$root.$session.setCookie("version", result.data.app_version);

          _this.$root.$session.env = result.data;
          _this.loadingContent = false;
        } else {
          $(".carregando").html(result.msg);
          $(".carregando").css({ color: "red" });
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdDialog",
  components: {},
  data: function data() {
    return {
      dialog: false,
      message: null,
      title: null,
      promise: null,
      isAlert: false,
      promiseResolve: function promiseResolve() {},
      promiseReject: function promiseReject() {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$utilidade.console("::EdConfirmDialog module loaded::");
  },

  methods: {
    confirm: function confirm() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "warning";
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Atenção";


      var self = this;
      this.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.$confirm(message, title, {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: type
        }).then(function () {
          resolve();
        }).catch(function () {
          reject();
        });
      });

      return this.promise;
    },
    alert: function alert() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Atenção";

      this.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$alert(message, title, {
          confirmButtonText: "OK",
          type: type
        }).then(function () {
          resolve();
        }).catch(function () {
          reject();
        });
      });
      return this.promise;
    },
    reset: function reset() {
      this.promise = null;
      this.promiseResolve = null;
      this.promiseReject = null;
      this.message = null;
      this.title = null;
      this.dialog = false;
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(675);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EdLoading',
  data: function data() {
    return {
      loading: false,
      text: null
    };
  },
  mounted: function mounted() {
    this.$utilidade.console('::EdLoading module loaded::');
  },

  methods: {
    set: function set(loading, text) {
      this.loading = loading;
      this.text = text;
    }
  },
  computed: {},
  watch: {
    loading: function loading() {},
    text: function text() {}
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdNotify",
  components: {},
  data: function data() {
    return {
      visible: false,
      snackbar: {
        enabled: false,
        color: "success",
        mode: "multi-line",
        timeout: 4000,
        message: "Success!",
        callback: null,
        location: "bottom",
        close: {
          text: "Close",
          color: ""
        }
      }
    };
  },
  mounted: function mounted() {
    this.$utilidade.console("::EdNotification module loaded::");
  },

  methods: {
    error: function error(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "error";
      this.setOptions(options);
    },
    success: function success(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "success";
      this.setOptions(options);
    },
    warning: function warning(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "warning";
      this.setOptions(options);
    },
    info: function info(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.snackbar.message = message;
      this.snackbar.color = "primary";
      this.setOptions(options);
    },
    hide: function hide() {
      this.visible = false;
      if (this.snackbar.callback) {
        this.snackbar.callback();
      }
    },
    setOptions: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$message({
        message: this.snackbar.message,
        type: this.snackbar.color
      });
    },
    reset: function reset() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_stringify_safe__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_json_stringify_safe__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "rest",
  components: {},
  mixins: [],

  data: function data() {
    return {
      requestParam: {
        force_web: false,
        url: "web1.softwareatento.com.br",
        xToken: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).X_TOKEN,
        appVersion: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).APP_VERSION,
        service: null,
        method: null,
        encryptData: null,
        jwt: null,
        headers: null,
        loginRedirect: true,
        uploadProgress: null
      }
    };
  },
  mounted: function mounted() {},


  computed: {
    dados: {
      cache: false,
      get: function get() {
        return this.$store.state.common.request;
      },
      set: function set(value) {
        this.$store.dispatch("common/setRequest", value);
      }
    }
  },
  methods: {
    getUrl: function getUrl(method) {
      this.setUrl();
      return this.requestParam.url + method + "?token=" + this.$root.$session.logged();
    },

    get: function get(_service, _params, _force_web) {
      _params = !_params ? "" : "?" + $.param(_params);

      this.requestParam.service = _service + _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "GET";

      return this.request();
    },
    post: function post(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "POST";

      return this.request();
    },

    put: function put(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "PUT";

      return this.request();
    },

    delete: function _delete(_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "DELETE";

      return this.request();
    },

    open: function open(_service, _params) {
      this.setUrl();

      _params = !_params ? "" : "&" + $.param(_params);

      var token = this.$root.$session.logged();

      if (token) _service += "?token=" + token + _params;

      window.open(this.requestParam.url + _service, "_blank");
    },

    cs: function cs(_service, _params) {
      var _target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_top';

      _params = !_params ? "" : "?" + $.param(_params);
      window.open(this.$root.$session.env.url_cs + _service + _params, _target);
    },

    removeStyle: function removeStyle() {
      $("body").removeAttr("style");
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
    },

    getReq: function getReq() {
      var req = {
        date: null,
        hash: null
      };

      req.date = this.$utilidade.addDate(1, null, "m");
      req.date = this.$utilidade.toDate(req.date, false, "YYYY-MM-DD HH:mm:ss");

      req.hash = this.$utilidade.toMd5(req.date + "6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E");

      return this.$utilidade.base64Encode(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(req));
    },


    getHeaders: function getHeaders(onlyeJWT) {
      var jwt = this.$root.$session.logged(),
          version = this.$root.$session.getCookie("version"),
          req = {
        date: null,
        hash: null
      };

      if (onlyeJWT) {
        return {
          authorization: jwt ? "Bearer " + jwt : null
        };
      }

      var headers = {
        Authorization: jwt ? "Bearer " + jwt : null,
        Version: version ? version : "null",
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type"
      };

      headers["xToken"] = this.getReq();

      return headers;
    },

    setHeaders: function setHeaders() {
      this.requestParam.headers = this.getHeaders();

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common = this.requestParam.headers;
    },

    setUrl: function setUrl() {
      var sub_domain = this.requestParam.force_web == true ? "web" : this.$root.$session.sub_domain,
          url = "https://" + __webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"})[sub_domain];

      if (true) {
        url += "/commtrol/api/";
      } else {
        url += "/api/";
      }

      if (sub_domain != "web") url += this.$root.$session.tenant + "/";


      if (sub_domain != "web") console.log(this.$root.$session.tenant);

      this.requestParam.url = url;

      return url;
    },

    request: function request() {
      var _this = this;

      this.setUrl();
      this.setHeaders();
      console.log('URL API Chamada: ' + this.requestParam.url + this.requestParam.service);

      var response = {};
      this.dados = null;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        response = { msg: "OK", status: 200, data: null };
        var promisses = [],
            self = _this;

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: _this.requestParam.method,
          url: _this.requestParam.service,
          data: _this.requestParam.param,
          baseURL: _this.requestParam.url,

          onUploadProgress: function onUploadProgress(progressEvent) {
            var uploadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);

            if (uploadProgress == 100) {
              uploadProgress = 99;
            }

            self.requestParam.uploadProgress = uploadProgress;
          },
          onDownloadProgress: function onDownloadProgress(progressEvent) {}
        }).then(function (result) {
          response = result.data;
          promisses.push(response);

          _this.removeStyle();
          _this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
            resolve(success[0]);
          }, function (err) {});
        }).catch(function (err) {
          var error = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, err).response;
          _this.requestParam.uploadProgress = _this.requestParam.uploadProgress != null ? 100 : null;

          if (!error) {
            error = {
              status: 500,
              msg: "Não foi possível completar a requisição. Precione as teclas CTRL+F5 para recarregar a página e tente novamente.",
              data: null
            };

            error.data = error;
          }

          if (error) {
            response = error.data;

            switch (response.status) {

              case 401:
                if (_this.$route.meta.requiresAuth) {
                  _this.$root.$session.logout();
                }
                break;

              case 413:
                response.msg = "A requisição excedeu o tamanho limite.";
                response.data = "A requisição excedeu o tamanho limite.";
                break;

              case 426:
                window.location.reload(true);
                break;

              case 429:
                _this.$root.$dialog.alert("Servico indisponível. Aguarde 5 minutos e tente novamente.", "error");
                break;
            }
          }

          promisses.push(response);

          if (_this.requestParam.method != "GET" && response.status != 200 && response.status != 426 && response.status != 403 && response.status != 401 && response.status != 404) {
            _this.$root.$dialog.alert(response.msg, "error");
            _this.dados = response;
          }

          _this.removeStyle();

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promisses).then(function (success) {
            resolve(success[0]);
          }, function (err) {});
        });
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "session",
  components: {},
  mixins: [],
  computed: {
    cliente: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setCliente", value);
      }
    },
    production: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    usuario: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario;
      },
      set: function set(value) {
        this.inicialize();
        this.$store.dispatch("usuario/setUsuario", value);
      }
    },
    empresa: {
      cache: false,
      get: function get() {
        return this.$store.state.empresa.logged;
      },
      set: function set(value) {
        this.inicialize();
        this.$store.dispatch("empresa/setEmpresa", value);
      }
    },
    jwt: {
      cache: false,
      get: function get() {
        return this.$store.state.usuario.jwt;
      },
      set: function set(jwt) {
        this.$store.dispatch("usuario/setJwt", jwt);
      }
    },
    sub_domain: {
      cache: false,
      get: function get() {
        return this.$store.state.common.sub_domain;
      },
      set: function set(value) {
        this.$store.dispatch("common/setSubDomain", value);
      }
    },
    tenant: {
      cache: false,
      get: function get() {
        return this.$store.state.cliente.tenant;
      },
      set: function set(value) {
        this.$store.dispatch("cliente/setTenant", value);
      }
    },
    env: {
      cache: false,
      get: function get() {
        return this.$store.state.common.env;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEnv", value);
      }
    },
    event: {
      cache: false,
      get: function get() {
        return this.$store.state.common.event;
      },
      set: function set(value) {
        this.$store.dispatch("common/setEvent", value);
      }
    },
    navigation: {
      cache: false,
      get: function get() {
        return this.$store.state.common.navigation;
      },
      set: function set(value) {
        this.$store.dispatch("common/setNavigation", value);
      }
    },
    window: {
      cache: false,
      get: function get() {
        return this.$store.state.common.window;
      },
      set: function set(value) {
        this.$store.dispatch("common/setWindow", value);
      }
    },
    device: {
      cache: false,
      get: function get() {
        return this.$store.state.common.device;
      }
    },
    pcmso: {
      cache: false,
      get: function get() {
        return this.$store.state.common.pcmso;
      },
      set: function set(value) {
        this.$store.dispatch("common/setPcmso", value);
      }
    }
  },
  watch: {
    sub_domain: function sub_domain() {},
    navigation: function navigation() {},
    window: function window() {},
    "cliente.logged": function clienteLogged() {
      this.setTitle();
    },
    "usuario.logged": function usuarioLogged() {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {
    inicialize: function inicialize() {
      var self = this;

      this.$root.$socket.publicChannel("AuthChannel").listen(".DisparoNotifyEvent", function (obj) {
        console.log(obj);
        if (obj.data.error) {
          self.$root.$notify.warning(obj.data.error);
        } else {
          self.$root.$notify.success(obj.data);
        }

        self.event = 'DisparoNotifyEvent';
      });

      this.$root.$socket.publicChannel("AuthChannel").listen(".LogEmailNotifyEvent", function (obj) {
        console.log(obj);
        self.event = 'LogEmailNotifyEvent';
      });
    },
    logout: function logout(reload) {
      $("body").removeClass("el-loading-parent--relative el-loading-parent--hidden");
      this.clearSession(true);

      this.$router.push({ name: this.sub_domain + ".login" });
    },
    clearSession: function clearSession() {
      this.deleteCookie(this.getJwt());
    },
    validarAcesso: function validarAcesso(modulo) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_modulo.indexOf(modulo) != -1;
    },
    validarPermissao: function validarPermissao(permissao) {
      return this.usuario.logged && (this.usuario.logged.is_adm == 1 || this.usuario.logged.is_sadm == 1) || this.usuario.acesso_permissao.indexOf(permissao) != -1;
    },
    validarPacote: function validarPacote(pacote) {
      return (this.cliente.logged && this.cliente.logged.pacotes.indexOf(pacote)) != -1;
    },
    toRoute: function toRoute(route, type) {
      type = type ? type : "name";

      var query = this.$route.query;

      switch (type) {
        case "location":
          window.open(route, "_top");
          break;

        default:
          if ((typeof route === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(route)) == "object") {
            route.query = query;
          }

          this.$router.push(route);
          break;
      }
    },
    logged: function logged() {
      var jwt = this.getJwt(),
          cookie = null;

      if (!jwt) return null;

      cookie = __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(jwt);

      return cookie;
    },
    getJwt: function getJwt(parse) {
      var jwt = null;

      try {
        jwt = this.env["jwt_" + this.sub_domain];

        if (!jwt) return null;

        if (parse) return __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(jwt);

        return jwt;
      } catch (error) {
        this.edAlert(error, "error");
      }
    },
    setTitle: function setTitle(title) {
      if (!title) {
        var to = this.$route;
        if (to.meta && to.meta.title && to.meta.navigation) {
          title = to.meta.title;
        }
      }

      title = title.toUpperCase();

      switch (this.sub_domain) {
        case "web":
          document.title = title + " :: " + (this.cliente.logged ? this.cliente.logged.nome : "");
          break;

        case "empresa":
          document.title = "Area da Empresa" + (title ? " :: " + title : "");
          break;

        case "credenciada":
          document.title = "Area da Credenciada" + (title ? " :: " + title : "");
          break;

        case "parceiro":
          document.title = "Area do Parceiro" + (title ? " :: " + title : "");
          break;
      }
    },
    setCookie: function setCookie(key, value, _expires, toJSONString) {
      if (this.getCookie(key)) return;

      _expires = _expires ? _expires : 8;

      if (toJSONString) {
        value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      }

      if (_expires == -1) {
        _expires = 720;
      }

      var date = this.$utilidade.addDate(_expires, null, "h");

      var test = __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(key, value, {
        expires: date,

        secure: false,
        path: "/"
      });
    },
    getCookie: function getCookie(key, toJSON) {
      if (toJSON) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key));
      }
      return __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key);
    },
    deleteCookie: function deleteCookie(key) {
      if (__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(key)) {
        __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.delete(key);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_laravel_echo__ = __webpack_require__(490);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdSocket",
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    inicialize: function inicialize() {
      if (!window.Echo) {
        var host = __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).URL_SOCKET;

        if (!__webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).PRODUCTION) {
          host = "https://" + window.location.hostname;
        }

        window.io = __webpack_require__(1287);
        window.Echo = new __WEBPACK_IMPORTED_MODULE_0_laravel_echo__["a" /* default */]({
          broadcaster: "socket.io",
          encrypted: true,
          key: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).SOCKET_KEY,
          host: host,
          transports: ['websocket', 'polling', 'flashsocket']
        });
      }
    },
    publicChannel: function publicChannel(_channel) {
      this.inicialize();
      return window.Echo.channel(this.$root.$session.env.app_name + '.' + this.$root.$session.cliente.logged.id + '.' + _channel);
    },
    privateChannel: function privateChannel(_channel) {
      this.inicialize();
      return window.Echo.private(this.$root.$session.env.app_name + '.' + this.$root.$session.cliente.logged.id + '.' + _channel);
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdAlert",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    type: {
      type: String,
      required: false,
      default: "success"
    },
    description: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdButton",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  props: {
    text: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: [Boolean, String],
      required: false,
      default: null
    },
    type: {
      type: String,
      default: function _default() {
        return "primary";
      }
    },
    size: {
      type: String,
      default: function _default() {
        return "medium";
      }
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdButton__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdAlert__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdAlert__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdForm",
  mixins: [],
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_0__EdButton___default.a, EdAlert: __WEBPACK_IMPORTED_MODULE_1__EdAlert___default.a },
  props: {
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    reset: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    blockMessage: {
      type: String,
      required: false,
      default: 'Você não tem permissão para acessar essa funcionalidade'
    },
    handlerSave: {
      type: Function,
      required: false,
      default: null
    },
    labelButton: {
      type: String,
      required: false,
      default: "Salvar"
    },
    colorButton: {
      type: String,
      required: false,
      default: "primary"
    },
    iconButton: {
      type: String,
      required: false,
      default: "fa fa-floppy-o"
    },
    classFooter: {
      type: String,
      default: "text-right"
    },
    recaptcha: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: "form-" + this.$utilidade.randomString(),
      recaptchaKey: __webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).GOOGLE_RECAPTCHA,
      recaptchaId: 1
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    validar: function validar() {

      if (this.handlerSave) {
        this.handlerSave();
      }
    },
    resetValidation: function resetValidation() {
      this.$refs[this.ref].resetValidation();
    },
    onRecaptchaVerify: function onRecaptchaVerify(ev) {
      this.$emit("recaptcha", ev);
    },
    onRecaptchaError: function onRecaptchaError(ev) {
      this.$emit("recaptcha", null);
    },
    onRecaptchaRender: function onRecaptchaRender(id) {}
  },
  watch: {
    block: function block() {},
    loading: function loading() {},
    blockMessage: function blockMessage() {},
    recaptchaResponse: function recaptchaResponse() {},
    reset: function reset() {
      this.resetValidation();
    },
    "formData.recaptcha": function formDataRecaptcha() {},
    "$root.$request.getResponse": function $root$requestGetResponse() {
      var response = this.$root.$request.getResponse;

      if (response && response.status == 503) {
        this.recaptchaId++;
      }
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputAutoComplete",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id"
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome"
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      search: null,
      timerId: null
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },

  computed: {},
  methods: {
    remoteMethod: function remoteMethod(val) {
      this.$emit("search", val);
    },
    getLabel: function getLabel(item) {
      var retorno = item[this.itemText];

      switch (this.itemText) {
        case "fdt":
          retorno = item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          retorno = item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          retorno = item.ghe + " (" + item.descricao + ")";
          break;

        case "funcionario":
          retorno = item.nome;
          break;

        case "esocial":
          retorno = item.codigo + " - " + item.nome;
          break;
      }

      return retorno;
    },
    getValue: function getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },
    getHtml: function getHtml(item) {
      switch (this.itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo + " - " + item.nome;
          break;

        case "funcionario":
          return item.nome + (item.funcao ? '<br><span style="font-size:8pt"><b>' + item.funcao.nome + "</b></span>" : "");
          break;

        case "epi":
          return (this.maxLenght ? '<span title="' + item.nome + '">' + this.$utilidade.textLimit(item.nome, this.maxLenght) + "</span>" : item.nome) + (item.ca ? " | <b>CA:</b> " + item.ca : "") + (item.categoria ? " | <b>Categoria:</b> " + item.categoria.nome : "");
          break;

        default:
          return this.maxLenght ? '<span title="' + item[this.itemText] + '">' + this.$utilidade.textLimit(item[this.itemText], this.maxLenght) + '</span>' : item[this.itemText];
          break;
      }
    }
  },
  watch: {
    items: function items() {}
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputDate",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    maxDaysTomorrow: {
      type: [String, Number],
      required: false,
      default: null
    },
    tomorrowDisabled: {
      type: [Boolean],
      required: false,
      default: false
    },
    yesterdayDisabled: {
      type: [Boolean],
      required: false,
      default: false
    },
    type: {
      type: [String],
      required: false,
      default: "date"
    },
    format: {
      type: [String],
      required: false,
      default: "dd/MM/yyyy"
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    handleDateOptions: function handleDateOptions() {
      var options = {};

      if (this.yesterdayDisabled || this.tomorrowDisabled) {
        options.disabledDate = this.handlerDisable;
      }

      return options;
    }
  },
  methods: {
    handlerDisable: function handlerDisable(date) {
      var hoje = this.$utilidade.toDate(null, true, "YYYY-MM-DD");
      date = this.$utilidade.toDate(date, true, "YYYY-MM-DD");

      if (this.tomorrowDisabled && this.maxDaysTomorrow) {
        var amanha = this.$utilidade.toDate(this.$utilidade.addDate(this.maxDaysTomorrow, hoje, "d"), true, "YYYY-MM-DD");

        if (date > amanha) {
          return true;
        }
      }

      return date < hoje;
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputEditor",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    }
  },
  data: function data() {
    return {
      id: "ckeditor-" + this.$utilidade.randomString(),
      editorUrl: "https://www1.softwareatento.com.br" + "/0.recursos/ckeditor_447_full/ckeditor.js?v=" + this.$root.$session.getCookie("version"),
      editorConfig: {
        language: "pt-br"
      }
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.inicialize();
  },

  computed: {},
  methods: {
    inicialize: function inicialize() {}
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputItem",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    getError: function getError() {
      if (this.$root.$request.dados && this.$root.$request.dados.status == 400 && this.$root.$request.dados.options && this.$root.$request.dados.options.data && this.name) {
        return this.$root.$request.dados.options.data[this.name];
      }
    }
  },
  methods: {}
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputAutoComplete",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id"
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome"
    },
    itemGroup: {
      type: [Boolean],
      required: false,
      default: null
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      search: null,
      timerId: null
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },

  computed: {},
  methods: {
    remoteMethod: function remoteMethod(val) {
      this.$emit("search", val);
    },
    getLabel: function getLabel(item) {

      var itemText = item.itemText ? item.itemText : this.itemText;

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM " + this.$utilidade.toDate(item.vencimento, true) + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo;
          break;

        case "tabela_dinamica":
          return item.nome;
          break;

        default:
          return item[this.itemText];
          break;
      }
    },
    getValue: function getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },
    getHtml: function getHtml(item) {

      var itemText = item.itemText ? item.itemText : this.itemText;

      switch (itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + " EM " + this.$utilidade.toDate(item.vencimento, true) + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo;
          break;

        case "tabela_dinamica":
          return '<span style="width:40px;margin-bottom:1px;margin-rigth:5px;float:left;background:' + item.cor + '">&nbsp;</span>' + item.nome;
          break;
        case "fator_risco":

          return "<b>" + item.nome + "</b>" + (item.cod_esocial ? '<br><span style="font-size:9pt">' + item.cod_esocial + "</span>" : "") + (item.cod_metodologia && item.cod_metodologia != "***" ? (!item.cod_esocial ? "<br>" : "") + '<span style="font-size:9pt"> (' + item.cod_metodologia + ")</span>" : "");
          break;

        default:
          return item[this.itemText];
          break;
      }
    }
  },
  watch: {
    items: function items() {}
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputSelectTipo",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    tipo: {
      type: [String, Number],
      required: true
    },
    exclude: {
      type: [Array],
      required: false,
      default: function _default() {
        return [];
      }
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false
    },
    isRadio: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      items: [],
      loadingTipo: false
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {
    this.getTipo();
  },

  computed: {},
  methods: {
    getTipo: function getTipo() {
      var _this = this;

      if (!this.tipo) return;

      this.items = [];
      this.loadingTipo = true;

      this.$root.$request.post("tipo/parent", {
        codigo: [this.tipo],
        exclude: this.exclude
      }).then(function (result) {
        _this.loadingTipo = false;
        if (result.status == 200) {
          _this.items = result.data[_this.tipo];
        }
      });
    }
  },
  watch: {
    tipo: function tipo() {
      this.getTipo();
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputSwitch",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {},
  data: function data() {
    return {
      items: [{
        id: 1,
        descricao: "Sim"
      }, {
        id: 0,
        descricao: "Não"
      }]
    };
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {},
  watch: {}
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdInputItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputText",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { EdInputItem: __WEBPACK_IMPORTED_MODULE_1__EdInputItem___default.a },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixins_formControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_download__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdInputItem__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdInputItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdInputItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EdInputUpload",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formControl___default.a],
  components: { Download: __WEBPACK_IMPORTED_MODULE_1_common_download___default.a, EdInputItem: __WEBPACK_IMPORTED_MODULE_2__EdInputItem___default.a },
  props: {
    extensoes: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    isBase: {
      type: Boolean,
      required: false,
      default: false
    },
    accept: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    currentFile: {
      type: [Object, Array, File],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  beforeDestroy: function beforeDestroy() {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    getAccept: function getAccept() {
      var arrayExtensoes = [];

      var extensoes = {
        doc: ["application/msword"],
        jpg: ["image/jpeg"],
        text: ["text/plain"],
        svg: ["image/svg+xml"],
        xls: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
        pfx: ["application/x-pkcs12"],
        crt: ["application/pkix-cert"]
      };

      this.extensoes.forEach(function (value) {
        if (extensoes[value]) {
          arrayExtensoes.push(extensoes[value].join(","));
        }
      });

      return arrayExtensoes.join(",");
    }
  },
  methods: {
    onChangeFile: function onChangeFile(e) {

      e.preventDefault();
      var file = e.target.files[0];

      this.$emit("input", file);
      this.$emit("change", file);
    },
    clearFiles: function clearFiles() {
      this.$refs["file-input-" + this.input].reset();
    },
    handleChange: function handleChange(e) {
      if (this.onChangeFile) this.onChangeFile(e);

      e.preventDefault();

      this.$events.fire("upload-" + this.input, e.target.files[0]);
    }
  },

  watch: {
    accept: function accept() {},
    extensoes: function extensoes() {}
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_common_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-modal",
  components: { EdButton: __WEBPACK_IMPORTED_MODULE_1_common_button___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_common_session___default.a],
  props: {
    title: {
      type: String,
      default: 'Modal'
    },
    modal: {
      type: Boolean,
      default: false
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '95%'
    },
    saveIcon: {
      type: String,
      default: 'fa fa-save'
    },
    closeESC: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: true
    },
    closeCLICK: {
      type: Boolean,
      default: false
    },
    lodingSave: {
      type: Boolean,
      default: false
    },
    saveName: {
      type: String,
      default: 'Salvar'
    },
    onSave: {
      type: Function,
      default: null
    },
    onClose: {
      type: Function,
      default: null
    }

  },
  watch: {
    title: function title() {},
    modal: function modal() {
      this.showModal = !this.showModal;
    },
    loading: function loading() {},
    loadingSave: function loadingSave() {},
    width: function width() {},
    saveIcon: function saveIcon() {},
    closeESC: function closeESC() {},
    isModal: function isModal() {},
    closeCLICK: function closeCLICK() {},
    lodingSave: function lodingSave() {},
    saveName: function saveName() {},
    onSave: function onSave() {}
  },

  data: function data() {
    return {
      showModal: false
    };
  },
  mounted: function mounted() {},


  methods: {
    handlerClose: function handlerClose() {
      if (this.onClose) {
        this.onClose();
      } else {
        this.showModal = false;
      }
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _props;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ed-form-mixin",
  components: {},
  props: (_props = {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: [Boolean, Number],
      required: false,
      default: false
    },
    disabledItem: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: [String],
      required: false,
      default: null
    },
    color: {
      type: [String],
      required: false,
      default: null
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto"
    },
    info: {
      type: [Number, String],
      required: false,
      default: null
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: null
    },
    maxLenght: {
      type: [Number, String],
      required: false,
      default: null
    },
    label: {
      type: [Number, String, Boolean],
      required: false,
      default: ''
    },
    title: {
      type: [Number, String],
      required: false,
      default: null
    },
    value: {
      type: [Number, String, Boolean, Array, Object, Date, File, Event],
      required: false,
      default: null
    },
    valueKey: {
      type: [String],
      required: false,
      default: 'id'
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "color", {
    type: [String],
    required: false,
    default: "primary"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "iconRight", {
    type: String,
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "iconLeft", {
    type: String,
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "classe", {
    type: [String],
    required: false,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "filterable", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "multiple", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "remote", {
    type: Boolean,
    required: false,
    default: false
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "placeholder", {
    type: String,
    default: null
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, "rules", {
    type: [String],
    required: false,
    default: function _default() {
      return null;
    }
  }), _props),
  data: function data() {
    return {
      intUniqId: Date.now(),
      validateClass: "",
      labelHtml: "",
      errors: {}
    };
  },

  methods: {
    setEvent: function setEvent(event, data) {
      this.$emit(event, data);
      this.$root.$session.event = {
        event: event,
        data: data
      };
    },
    focus: function focus() {
      if (this.$refs.field) {
        this.$refs.field.focus();
      }
    },
    validate: function validate($event) {}
  },
  mounted: function mounted() {},

  computed: {
    getError: function getError() {

      if (this.errors[this.name]) {
        return this.errors[this.name];
      }
      return false;
    },
    getErrorContents: function getErrorContents() {
      var response = this.$root.$request.getResponse;

      if (response && response.status == 400) {
        for (var field in response.data.error.options) {
          if (field == this.name) {
            return response.data.error.options[field];
          }
        }
      }

      return [];
    },
    getRules: function getRules() {
      var _this = this;

      var rules = [];
      var arrayAux = [];

      if (this.rules) {
        arrayAux = this.rules.split("|").concat(arrayAux);

        arrayAux.forEach(function (rule) {
          if (rule.indexOf("required") != -1) {
            rules.push(function (v) {
              return !!v || "Campo obrigatório";
            });
          }

          if (rule.indexOf("email") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isEmail(v) || "Email inválido";
            });
          }

          if (rule.indexOf("numeric") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isNumeric(v) || "Digite um número válido";
            });
          }

          if (rule.indexOf("cpf") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isCpf(v) || "Digite um CPF válido";
            });
          }

          if (rule.indexOf("date") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isDate(v) || "Digite uma data válida no formato dd/mm/aaaa";
            });
          }

          if (rule.indexOf("cnpj") != -1) {
            rules.push(function (v) {
              return v && _this.$utilidade.isCnpj(v) || "Digite um CNPJ válido";
            });
          }

          if (rule.indexOf("min:") != -1) {
            var min = parseInt(rule.split(":")[1]);

            rules.push(function (v) {
              return v && v.length >= min || "Campo deve conter ao menos " + min + " caracteres";
            });
          }

          if (rule.indexOf("max:") != -1) {
            var max = parseInt(rule.split(":")[1]);

            rules.push(function (v) {
              return v && v.length <= max || "Campo deve conter até " + max + " caracteres";
            });
          }
        });
      }

      return rules;
    }
  },
  watch: {
    name: function name() {},
    label: function label() {},
    value: function value() {},
    multiple: function multiple() {},
    clearable: function clearable() {},
    required: function required() {},
    loading: function loading() {},
    disabled: function disabled() {},
    readonly: function readonly() {},
    valueKey: function valueKey() {},
    maxLenght: function maxLenght() {}
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua senha para continuar',
    placeholder: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Informe abaixo o motivo do cancelamento da consulta',
    placeholder: '',
    maxlength: 1000,
    rows: 5,
    rules: ['required']
}]);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'grau_estudo',
    label: 'Grau de Estudo',
    clearable: true,
    tipo: 122,
    valor: 'valor',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'pa1',
    maxlength: 3,
    label: 'Pressão Arterial Baixa (mmHg)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'pa2',
    maxlength: 3,
    label: 'Pressão Arterial Alta (mmHg)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'peso',
    label: 'Peso (Kg)',
    mask: 'money',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'altura',
    label: 'Altura (metros)',
    mask: 'money',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'ESTILO DE VIDA E ANTECEDENTES'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q18',
    label: 'Bebida Alcoólica',
    valor: 'valor',
    tipo: 134,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q132',
    label: 'Tem boa Visão',
    valor: 'id',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q164',
    label: 'Usa Óculos ou Lente de Contato',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Diabetes',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Pressão Alta',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q1128',
    label: 'Câncer',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q14',
    label: 'Fuma',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd14',
    label: 'Quantos cigarros ao dia/tempo',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q116',
    label: 'Pratica Esporte',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd116',
    label: 'Qual esporte e quantas vezes na semana',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q11024',
    label: 'Cirurgia ou Operação',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd11024',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q12048',
    label: 'Toma Algum Medicamento',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd12048',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q14096',
    label: 'Alergia',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd14096',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q18192',
    label: 'Já Esteve Internado',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd18192',
    label: 'Porquê',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q116384',
    label: 'Já Recebeu Sangue de Alguém',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd116384',
    label: 'Quando',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q132768',
    label: 'Tem Alguma Doença',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd132768',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q165536',
    label: 'Algum Acidente de Trabalho',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd165536',
    label: 'Quando',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'q22',
    label: 'Tem Alguma Queixa',
    tipo: 131,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'text',
    field: 'qd22',
    label: 'Quais',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'PELE E MUCOSAS'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q34',
    label: '',
    tipo: 139,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'CABEÇA E PESCOÇO'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q44',
    label: '',
    tipo: 144,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'TÓRAX'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q54',
    label: '',
    tipo: 152,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'ABDOME'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q64',
    label: '',
    tipo: 158,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'MÃOS/PUNHOS/OMBROS/COTOVELOS'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q74',
    label: '',
    tipo: 164,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'MEMBROS INFERIORES'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q84',
    label: '',
    tipo: 167,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'COLUNA'
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo-checkbox',
    field: 'q94',
    label: '',
    tipo: 171,
    valor: 'valor',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'CONCLUSÃO MÉDICA'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'conclusao',
    label: 'Conclusão',
    valor: 'valor',
    tipo: 180,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'observacoes',
    label: 'Observações Gerais',
    rules: ['']
}]);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'aptidao',
    label: 'Aptidão',
    valor: 'valor',
    tipo: 185,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_alt',
    label: 'Trabalho em Altura',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_esp',
    label: 'Trabalho em Espaço Confinado',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_ele',
    label: 'Trabalho com Eletricidade',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_rad_ion',
    label: 'Trabalho com Radiação Ionizante',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_ali',
    label: 'Manuseio de Alimentos',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'exames',
    label: 'Informe os Exames Alterados (caso existir algum)',
    clearable: true,
    multiple: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_aso',
    label: 'Selecionar ASO (em PDF)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_femo',
    label: 'Selecionar Ficha Clínica (em PDF)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'upload',
    field: 'arquivo_exame',
    label: 'Selecionar Exames Complementares (em PDF)',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 53,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua Senha',
    placeholder: 'Para continuar você deve inserir sua senha',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    placeholder: 'Digite algo sobre a liberação',
    rules: ['required']
}]);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações da Consulta'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7',
    type: 'text',
    field: 'funcionario',
    label: 'Trabalhador (a)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_funcao',
    label: 'Função',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'text',
    field: 'data_age',
    label: 'Data do Agendamento da Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    tipo: 46,
    field: 'id_tipo_aso',
    label: 'Tipo de Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Selecione uma Ação'
}]);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'SENHA',
    prefix: 'fa fa-key',
    rules: ['required']
}]);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}]);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações de Cadastro'
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
    type: 'text',
    field: 'nome',
    maxlength: 255,
    label: 'Nome',
    rules: ['required']
}, {
    id: 3,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'email',
    field: 'email',
    maxlength: 100,
    label: 'Email',
    rules: ['required', 'email']
}, {
    id: 4,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['required']
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['required']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['required']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['required']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Representante Legal da Empresa'
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_nome',
    label: 'Nome',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_email',
    label: 'Email',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_tel_com',
    label: 'Telefone',
    mask: 'celular',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Alterar Minha Senha'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_cpf',
    label: 'Login',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_email',
    label: 'Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_atual',
    label: 'Senha Atual',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_nova',
    label: 'Nova Senha (Mínimo 6 caracteres)',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_confirma',
    label: 'Confirmar Nova Senha',
    rules: []
}]);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações da Consulta'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7',
    type: 'text',
    field: 'funcionario',
    label: 'Trabalhador (a)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
    type: 'text',
    field: 'id_funcao',
    label: 'Função',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'id_ghe',
    label: 'GHE (Setor)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
    type: 'date',
    field: 'data_age',
    info: 'A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.',
    yesterdayDisabledDate: true,
    label: 'Data do Agendamento da Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    tipo: 46,
    field: 'id_tipo_aso',
    label: 'Tipo de Consulta',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['required']
}]);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_cre',
    label: 'Credenciada',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}]);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'SENHA',
    prefix: 'fa fa-key',
    rules: ['required']
}]);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cpf',
    label: 'CPF',
    mask: 'cpf',
    prefix: 'fa fa-credit-card',
    rules: ['required']
}]);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'email',
    label: 'Email',
    maxlength: 500,
    info: 'Digite apenas um ou mais emails separados por ; (ponto e vírgula)',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'tipo',
    tipo: 32,
    label: 'Setor (Tipo de Email)',
    multiple: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Ativo',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    info: '',
    rules: ['']
}]);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações de Cadastro'
}, {
    id: 1,
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'text',
    field: 'cnpj',
    label: 'CNPJ',
    mask: 'cnpj',
    rules: ['required']
}, {
    id: 2,
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'text',
    field: 'nome',
    maxlength: 255,
    label: 'Nome',
    rules: ['required']
}, {
    id: 4,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'tel_com',
    label: 'Telefone',
    mask: 'telefone',
    rules: ['required']
}, {
    id: 5,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'cep',
    maxlength: 10,
    field: 'cep',
    label: 'CEP',
    mask: 'cep',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 500,
    field: 'end',
    label: 'Endereço',
    rules: ['required']
}, {
    id: 6,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 50,
    field: 'num',
    label: 'Número',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    type: 'text',
    maxlength: 100,
    field: 'bairro',
    label: 'Bairro',
    rules: ['required']
}, {
    id: 7,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    maxlength: 50,
    field: 'comp',
    label: 'Complemento',
    rules: ['required']
}, {
    id: 8,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-uf',
    field: 'id_estado',
    label: 'Estado',
    rules: ['required']
}, {
    id: 9,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'select-cidade',
    field: 'id_cidade',
    label: 'Cidade',
    rules: ['required']
}, {
    id: 14,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Representante Legal da Empresa'
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_nome',
    label: 'Nome',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_email',
    label: 'Email',
    rules: ['required']
}, {
    id: 10,
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'r_tel_com',
    label: 'Telefone',
    mask: 'celular',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Alterar Minha Senha'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_cpf',
    label: 'Login',
    mask: 'cpf',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'text',
    field: 'u_email',
    label: 'Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_atual',
    label: 'Senha Atual',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_nova',
    label: 'Nova Senha (Mínimo 6 caracteres)',
    rules: []
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
    type: 'password',
    field: 'senha_confirma',
    label: 'Confirmar Nova Senha',
    rules: []
}]);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Filtrar Periódico'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'periodo',
    label: 'Período',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    label: 'Frente de Trabalho',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    label: 'Funcionário',
    multiple: true,
    rules: ['']
}]);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_rest__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_rest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_common_rest__);








var TOKEN_TTL_SECONDS = 120;
var SUPPORT_ERROR_MESSAGE = 'Nao foi possivel concluir o envio dos documentos. Tente novamente em alguns instantes ou contate o suporte.';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6_common_rest___default.a],
  data: function data() {
    return {
      loading: true,
      errorMessage: '',
      alreadySigned: false,
      justSigned: false,
      codigoAssinatura: null,
      currentStep: 1,
      wizardComplete: false,
      busy: false,
      cpf: '',
      nome: '',
      telefone: '',
      email: '',
      password: '',
      passwordConfirm: '',
      passwordConfirmTouched: false,
      passwordConfirmError: '',
      cadastroExistente: false,
      possuiAssinaturaAnterior: false,
      cadastroEditavel: false,
      cadastroEdicaoAtivada: false,
      cadastroMaskedNome: '',
      cadastroMaskedTelefone: '',
      cadastroMaskedEmail: '',
      cadastroMaskedCpf: '',
      cadastroUsuarioId: 0,
      dataNascimento: '',
      sexo: '',
      token: '',
      tokenChannel: '',
      tokenExpiresAt: 0,
      emailValidationView: 'email',
      emailTokenValues: ['', '', '', ''],
      phoneValidationView: 'phone',
      phoneTokenValues: ['', '', '', ''],
      timerNow: Date.now(),
      tokenTimer: null,
      frenteDocumento: '',
      frenteIsPdf: false,
      versoDocumento: '',
      frenteDocumentoName: '',
      versoDocumentoName: '',
      uploadLoadingFrente: false,
      uploadLoadingVerso: false,
      uploadErrorFrente: false,
      uploadErrorVerso: false,
      uploadLoadingRosto: false,
      uploadErrorRosto: false,
      fotoRosto: '',
      fotoRostoName: '',
      trabalhadorId: 0,
      stepMessage: '',
      stepError: false,
      dadosFuncionarioCerebro: null,
      funcionarioCerebroEditavel: false,
      funcionarioCerebroEdicaoAtivada: false
    };
  },

  computed: {
    tenant: function tenant() {
      return this.$route.params.tenant;
    },
    tenantTitleCase: function tenantTitleCase() {
      var value = String(this.tenant || '').trim();
      if (!value) {
        return '';
      }

      return value.toLowerCase().split(/([\s_-]+)/).map(function (part) {
        if (/^[\s_-]+$/.test(part)) {
          return part;
        }

        return part.charAt(0).toUpperCase() + part.slice(1);
      }).join('');
    },
    idConsulta: function idConsulta() {
      return this.$route.params.idConsulta;
    },
    tokenRemainingSeconds: function tokenRemainingSeconds() {
      if (!this.tokenExpiresAt) {
        return 0;
      }

      var diff = Math.floor((this.tokenExpiresAt - this.timerNow) / 1000);
      return diff > 0 ? diff : 0;
    },
    tokenExpired: function tokenExpired() {
      return !!this.tokenExpiresAt && this.tokenRemainingSeconds === 0;
    },
    tokenCountdown: function tokenCountdown() {
      if (!this.tokenExpiresAt) {
        return '';
      }

      var minutes = String(Math.floor(this.tokenRemainingSeconds / 60)).padStart(2, '0');
      var seconds = String(this.tokenRemainingSeconds % 60).padStart(2, '0');
      return minutes + ':' + seconds;
    },
    tokenResendLabel: function tokenResendLabel() {
      return this.tokenExpired ? 'Reenviar Código' : 'Reenviar Código ' + this.tokenCountdown;
    },
    canSaveDocumentos: function canSaveDocumentos() {
      var hasDocumentos = this.frenteIsPdf ? !!this.frenteDocumento : !!this.frenteDocumento && !!this.versoDocumento;

      return hasDocumentos && !this.uploadLoadingFrente && !this.uploadLoadingVerso && !this.uploadErrorFrente && !this.uploadErrorVerso;
    },
    emailValidated: function emailValidated() {
      return this.currentStep > 1;
    },
    identidadeValidated: function identidadeValidated() {
      return this.currentStep > 2;
    },
    telefoneValidated: function telefoneValidated() {
      if (this.cadastroExistente) {
        return true;
      }

      return this.currentStep > 3;
    },
    senhaValidated: function senhaValidated() {
      if (this.cadastroExistente && this.currentStep >= 4) {
        return true;
      }

      if (this.currentStep <= 4) {
        return false;
      }

      return !!this.password && !this.validatePasswordConfirmation();
    },
    emailStatusLabel: function emailStatusLabel() {
      return this.email ? this.email : 'Confirme seu e-mail';
    },
    identidadeStatusLabel: function identidadeStatusLabel() {
      return this.identidadeValidated ? 'Identidade validada' : 'Confirme sua identidade';
    },
    telefoneStatusLabel: function telefoneStatusLabel() {
      return this.telefone ? this.telefone : 'Confirme seu telefone';
    },
    senhaStatusLabel: function senhaStatusLabel() {
      if (this.cadastroExistente && this.senhaValidated) {
        return 'Cadastro existente validado';
      }

      return this.senhaValidated ? 'Senha criada com sucesso' : 'Crie sua senha';
    },
    canAdvanceValidationBoard: function canAdvanceValidationBoard() {
      return this.emailValidated && this.identidadeValidated && this.telefoneValidated && this.senhaValidated;
    },
    routeStep: function routeStep() {
      return String(this.$route && this.$route.params && this.$route.params.step || '').toLowerCase();
    },
    isStepRoute: function isStepRoute() {
      return ['email', 'identidade', 'telefone', 'senha'].includes(this.routeStep);
    },
    showValidationBoard: function showValidationBoard() {
      return !this.isStepRoute && this.currentStep <= 4;
    },
    possuiDadosCerebro: function possuiDadosCerebro() {
      return !!(this.dadosFuncionarioCerebro && this.dadosFuncionarioCerebro.existe);
    }
  },
  mounted: function mounted() {
    this.restoreWizardState();
    this.syncStepFromRoute();
    this.loadAssinaturaStatus();
    this.ensureTokenTimer();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopTokenTimer();
  },

  methods: {
    assinarRouteName: function assinarRouteName() {
      if (String(this.$route.name || '').indexOf('empresa.') === 0) {
        return 'empresa.funcionario.aso.assinar';
      }

      return 'web.funcionario.aso.assinar';
    },
    assinarStepRouteName: function assinarStepRouteName() {
      if (String(this.$route.name || '').indexOf('empresa.') === 0) {
        return 'empresa.funcionario.aso.assinar.step';
      }

      return 'web.funcionario.aso.assinar.step';
    },
    goToValidationRoute: function goToValidationRoute(step) {
      var tenant = this.tenant;
      var idConsulta = this.idConsulta;
      this.$router.push({
        name: this.assinarStepRouteName(),
        params: {
          tenant: tenant,
          idConsulta: idConsulta,
          step: step
        }
      });
    },
    goToBoardRoute: function goToBoardRoute() {
      var tenant = this.tenant;
      var idConsulta = this.idConsulta;
      this.$router.push({
        name: this.assinarRouteName(),
        params: {
          tenant: tenant,
          idConsulta: idConsulta
        }
      });
    },
    syncStepFromRoute: function syncStepFromRoute() {
      if (this.routeStep === 'email') {
        this.goToEmailForm();
        return;
      }

      if (this.routeStep === 'identidade') {
        this.currentStep = 2;
        return;
      }

      if (this.routeStep === 'telefone') {
        this.currentStep = 3;
        this.phoneValidationView = 'phone';
        return;
      }

      if (this.routeStep === 'senha') {
        this.currentStep = 4;
      }
    },
    validationClass: function validationClass(key) {
      return {
        'aso-public-entry__validation-item--active': this.isValidationStepActive(key),
        'aso-public-entry__validation-item--done': this.isValidationStepDone(key)
      };
    },
    isValidationStepDone: function isValidationStepDone(key) {
      if (key === 'email') {
        return this.emailValidated;
      }

      if (key === 'identidade') {
        return this.identidadeValidated;
      }

      if (key === 'telefone') {
        return this.telefoneValidated;
      }

      if (key === 'senha') {
        return this.senhaValidated;
      }

      return false;
    },
    isValidationStepActive: function isValidationStepActive(key) {
      if (key === 'email') {
        return this.currentStep === 1;
      }

      if (key === 'identidade') {
        return this.currentStep === 2;
      }

      if (key === 'telefone') {
        return this.currentStep === 3;
      }

      if (key === 'senha') {
        return this.currentStep === 4;
      }

      return false;
    },
    isValidationActionVisible: function isValidationActionVisible(key) {
      var _this = this;

      if (this.currentStep > 4) {
        return false;
      }

      var steps = ['email', 'identidade', 'telefone', 'senha'];
      var nextPending = steps.find(function (stepKey) {
        return !_this.isValidationStepDone(stepKey);
      });
      return key === nextPending;
    },
    goToValidationStep: function goToValidationStep(key) {
      if (key === 'email') {
        this.goToValidationRoute('email');
        return;
      }

      if (key === 'identidade') {
        if (!this.emailValidated) {
          this.goToValidationRoute('email');
          this.setStepMessage('Valide o e-mail antes de seguir para identidade.', true);
          return;
        }

        this.goToValidationRoute('identidade');
        return;
      }

      if (key === 'telefone' || key === 'senha') {
        if (key === 'telefone' && !this.identidadeValidated) {
          this.goToValidationRoute('identidade');
          this.setStepMessage('Conclua a validação de identidade antes de telefone.', true);
          return;
        }

        if (key === 'senha' && !this.telefoneValidated) {
          this.goToValidationRoute('telefone');
          this.setStepMessage('Conclua a validação de telefone antes de senha.', true);
          return;
        }

        this.goToValidationRoute(key);
        return;
      }
    },
    resetValidationBoard: function resetValidationBoard() {
      this.currentStep = 1;
      this.emailValidationView = 'email';
      this.emailTokenValues = ['', '', '', ''];
      this.phoneValidationView = 'phone';
      this.phoneTokenValues = ['', '', '', ''];
      this.token = '';
      this.tokenChannel = '';
      this.tokenExpiresAt = 0;
      this.stopTokenTimer();
      this.cpf = '';
      this.nome = '';
      this.telefone = '';
      this.email = '';
      this.password = '';
      this.passwordConfirm = '';
      this.passwordConfirmTouched = false;
      this.passwordConfirmError = '';
      this.cadastroExistente = false;
      this.possuiAssinaturaAnterior = false;
      this.cadastroEditavel = false;
      this.cadastroEdicaoAtivada = false;
      this.cadastroMaskedNome = '';
      this.cadastroMaskedTelefone = '';
      this.cadastroMaskedEmail = '';
      this.cadastroMaskedCpf = '';
      this.cadastroUsuarioId = 0;
      this.dataNascimento = '';
      this.sexo = '';
      this.trabalhadorId = 0;
      this.dadosFuncionarioCerebro = null;
      this.funcionarioCerebroEditavel = false;
      this.funcionarioCerebroEdicaoAtivada = false;
      this.setStepMessage('', false);
    },
    advanceValidationBoard: function advanceValidationBoard() {
      if (!this.canAdvanceValidationBoard) {
        this.setStepMessage('Conclua as quatro validações para continuar.', true);
        return;
      }

      this.currentStep = 5;
      this.setStepMessage('Validações concluídas. Continue com o upload dos documentos.', false);
    },
    stepClass: function stepClass(step) {
      return {
        'aso-public-entry__steps-item': true,
        'aso-public-entry__steps-item--active': this.currentStep === step,
        'aso-public-entry__steps-item--done': this.currentStep > step
      };
    },
    responsePayload: function responsePayload(result) {
      var response = Array.isArray(result) && result.length ? result[0] : null;
      return response && response.data && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(response.data) === 'object' ? response.data : {};
    },
    responseStatus: function responseStatus(result) {
      var response = Array.isArray(result) && result.length ? result[0] : null;
      return response && typeof response.status === 'number' ? response.status : 0;
    },
    apiServicePath: function apiServicePath(service) {
      var clean = String(service || '').replace(/^\/+/, '');
      return this.tenant ? this.tenant + '/' + clean : clean;
    },
    apiGet: function apiGet(service, params) {
      return this.get(this.apiServicePath(service), params, true);
    },
    apiPost: function apiPost(service, params, filters) {
      return this.post(this.apiServicePath(service), params, filters, true);
    },
    responseMessage: function responseMessage(result, fallback) {
      var response = Array.isArray(result) && result.length ? result[0] : null;
      if (response && response.msg) {
        return response.msg;
      }

      var payload = this.responsePayload(result);
      if (payload && payload.message) {
        return payload.message;
      }

      return fallback;
    },
    setStepMessage: function setStepMessage(message, isError) {
      this.stepMessage = message;
      this.stepError = !!isError;
    },
    logRequestError: function logRequestError(context, details) {
      console.error('[ASO Upload Error][' + context + ']', details);
    },
    getStorageKey: function getStorageKey() {
      return 'asoPublicWizard:' + this.tenant + ':' + this.idConsulta;
    },
    persistWizardState: function persistWizardState() {
      if (typeof window === 'undefined' || this.alreadySigned) {
        return;
      }

      var data = {
        currentStep: this.currentStep,
        emailValidationView: this.emailValidationView,
        emailTokenValues: this.emailTokenValues,
        phoneValidationView: this.phoneValidationView,
        phoneTokenValues: this.phoneTokenValues,
        cpf: this.cpf,
        nome: this.nome,
        telefone: this.telefone,
        email: this.email,
        cadastroExistente: this.cadastroExistente,
        possuiAssinaturaAnterior: this.possuiAssinaturaAnterior,
        cadastroEditavel: this.cadastroEditavel,
        cadastroEdicaoAtivada: this.cadastroEdicaoAtivada,
        cadastroMaskedNome: this.cadastroMaskedNome,
        cadastroMaskedTelefone: this.cadastroMaskedTelefone,
        cadastroMaskedEmail: this.cadastroMaskedEmail,
        cadastroMaskedCpf: this.cadastroMaskedCpf,
        cadastroUsuarioId: this.cadastroUsuarioId,
        dataNascimento: this.dataNascimento,
        sexo: this.sexo,
        tokenChannel: this.tokenChannel,
        tokenExpiresAt: this.tokenExpiresAt,
        trabalhadorId: this.trabalhadorId,
        dadosFuncionarioCerebro: this.dadosFuncionarioCerebro,
        funcionarioCerebroEditavel: this.funcionarioCerebroEditavel,
        funcionarioCerebroEdicaoAtivada: this.funcionarioCerebroEdicaoAtivada
      };

      window.localStorage.setItem(this.getStorageKey(), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data));
    },
    restoreWizardState: function restoreWizardState() {
      var _this2 = this;

      if (typeof window === 'undefined') {
        return;
      }

      var saved = window.localStorage.getItem(this.getStorageKey());
      if (!saved) {
        return;
      }

      try {
        var parsed = JSON.parse(saved);
        var restoredStep = Number(parsed.currentStep || 1);
        this.currentStep = restoredStep === 7 ? 2 : restoredStep;
        this.emailValidationView = parsed.emailValidationView === 'token' ? 'token' : 'email';
        this.emailTokenValues = Array.isArray(parsed.emailTokenValues) && parsed.emailTokenValues.length === 4 ? parsed.emailTokenValues.map(function (value) {
          return _this2.onlyDigits(value).slice(0, 1);
        }) : ['', '', '', ''];
        this.phoneValidationView = parsed.phoneValidationView === 'token' ? 'token' : 'phone';
        this.phoneTokenValues = Array.isArray(parsed.phoneTokenValues) && parsed.phoneTokenValues.length === 4 ? parsed.phoneTokenValues.map(function (value) {
          return _this2.onlyDigits(value).slice(0, 1);
        }) : ['', '', '', ''];
        this.cpf = parsed.cpf || '';
        this.nome = parsed.nome || '';
        this.telefone = parsed.telefone || '';
        this.email = parsed.email || '';
        this.cadastroExistente = !!parsed.cadastroExistente;
        this.possuiAssinaturaAnterior = !!parsed.possuiAssinaturaAnterior;
        this.cadastroEditavel = !!parsed.cadastroEditavel;
        this.cadastroEdicaoAtivada = !!parsed.cadastroEdicaoAtivada;
        this.cadastroMaskedNome = parsed.cadastroMaskedNome || '';
        this.cadastroMaskedTelefone = parsed.cadastroMaskedTelefone || '';
        this.cadastroMaskedEmail = parsed.cadastroMaskedEmail || '';
        this.cadastroMaskedCpf = parsed.cadastroMaskedCpf || '';
        this.cadastroUsuarioId = Number(parsed.cadastroUsuarioId || 0);
        this.dataNascimento = parsed.dataNascimento || '';
        this.sexo = parsed.sexo || '';
        this.tokenChannel = parsed.tokenChannel || '';
        this.tokenExpiresAt = Number(parsed.tokenExpiresAt || 0);
        this.trabalhadorId = Number(parsed.trabalhadorId || 0);
        this.dadosFuncionarioCerebro = parsed.dadosFuncionarioCerebro || null;
        this.funcionarioCerebroEditavel = !!parsed.funcionarioCerebroEditavel;
        this.funcionarioCerebroEdicaoAtivada = !!parsed.funcionarioCerebroEdicaoAtivada;
      } catch (error) {
        this.clearWizardState();
      }
    },
    clearWizardState: function clearWizardState() {
      if (typeof window === 'undefined') {
        return;
      }

      window.localStorage.removeItem(this.getStorageKey());
    },
    setTokenExpiry: function setTokenExpiry() {
      this.timerNow = Date.now();
      this.tokenExpiresAt = this.timerNow + TOKEN_TTL_SECONDS * 1000;
      this.ensureTokenTimer();
    },
    getTokenDigitInput: function getTokenDigitInput(index, type) {
      if (typeof document === 'undefined') {
        return null;
      }

      return document.querySelector('[data-token-index="' + index + '"][data-token-type="' + type + '"]');
    },
    focusTokenDigit: function focusTokenDigit(index, type) {
      var input = this.getTokenDigitInput(index, type);
      if (input && typeof input.focus === 'function') {
        input.focus();
      }
    },
    goToEmailForm: function goToEmailForm() {
      this.currentStep = 1;
      this.emailValidationView = 'email';
      this.token = '';
      this.emailTokenValues = ['', '', '', ''];
    },
    goToEmailTokenForm: function goToEmailTokenForm() {
      var _this3 = this;

      this.currentStep = 1;
      this.emailValidationView = 'token';
      this.emailTokenValues = ['', '', '', ''];
      this.$nextTick(function () {
        return _this3.focusTokenDigit(0, 'email');
      });
    },
    onEmailTokenDigitInput: function onEmailTokenDigitInput(payload) {
      var _this4 = this;

      if (!payload || typeof payload.index !== 'number') {
        return;
      }

      var value = this.onlyDigits(payload.value).slice(-1);
      this.$set(this.emailTokenValues, payload.index, value);

      if (value && payload.index < this.emailTokenValues.length - 1) {
        this.$nextTick(function () {
          return _this4.focusTokenDigit(payload.index + 1, 'email');
        });
      }
    },
    onEmailTokenDigitKeydown: function onEmailTokenDigitKeydown(payload) {
      var _this5 = this;

      if (!payload || typeof payload.index !== 'number') {
        return;
      }

      if (payload.key === 'Backspace' && !this.emailTokenValues[payload.index] && payload.index > 0) {
        this.$nextTick(function () {
          return _this5.focusTokenDigit(payload.index - 1, 'email');
        });
      }
    },
    onEmailTokenPaste: function onEmailTokenPaste(event) {
      var _this6 = this;

      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      var text = event && event.clipboardData ? event.clipboardData.getData('text') : '';
      var digits = this.onlyDigits(text).slice(0, 4);
      if (digits.length !== 4) {
        return;
      }

      this.emailTokenValues = digits.split('');
      this.$nextTick(function () {
        return _this6.focusTokenDigit(3, 'email');
      });
    },
    goToPhoneForm: function goToPhoneForm() {
      this.currentStep = 3;
      this.phoneValidationView = 'phone';
      this.phoneTokenValues = ['', '', '', ''];
    },
    goToPhoneTokenForm: function goToPhoneTokenForm() {
      var _this7 = this;

      this.currentStep = 3;
      this.phoneValidationView = 'token';
      this.phoneTokenValues = ['', '', '', ''];
      this.$nextTick(function () {
        return _this7.focusTokenDigit(0, 'phone');
      });
    },
    onPhoneTokenDigitInput: function onPhoneTokenDigitInput(payload) {
      var _this8 = this;

      if (!payload || typeof payload.index !== 'number') {
        return;
      }

      var value = this.onlyDigits(payload.value).slice(-1);
      this.$set(this.phoneTokenValues, payload.index, value);

      if (value && payload.index < this.phoneTokenValues.length - 1) {
        this.$nextTick(function () {
          return _this8.focusTokenDigit(payload.index + 1, 'phone');
        });
      }
    },
    onPhoneTokenDigitKeydown: function onPhoneTokenDigitKeydown(payload) {
      var _this9 = this;

      if (!payload || typeof payload.index !== 'number') {
        return;
      }

      if (payload.key === 'Backspace' && !this.phoneTokenValues[payload.index] && payload.index > 0) {
        this.$nextTick(function () {
          return _this9.focusTokenDigit(payload.index - 1, 'phone');
        });
      }
    },
    onPhoneTokenPaste: function onPhoneTokenPaste(event) {
      var _this10 = this;

      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      var text = event && event.clipboardData ? event.clipboardData.getData('text') : '';
      var digits = this.onlyDigits(text).slice(0, 4);
      if (digits.length !== 4) {
        return;
      }

      this.phoneTokenValues = digits.split('');
      this.$nextTick(function () {
        return _this10.focusTokenDigit(3, 'phone');
      });
    },
    ensureTokenTimer: function ensureTokenTimer() {
      var _this11 = this;

      if (!this.tokenExpiresAt || this.tokenExpired) {
        this.stopTokenTimer();
        return;
      }

      if (this.tokenTimer) {
        return;
      }

      this.tokenTimer = setInterval(function () {
        _this11.timerNow = Date.now();
        if (_this11.tokenExpired) {
          _this11.stopTokenTimer();
        }
      }, 1000);
    },
    stopTokenTimer: function stopTokenTimer() {
      if (!this.tokenTimer) {
        return;
      }

      clearInterval(this.tokenTimer);
      this.tokenTimer = null;
    },
    loadAssinaturaStatus: function loadAssinaturaStatus() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var idConsulta, result, status, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this12.loading = true;
                _this12.errorMessage = '';
                _this12.alreadySigned = false;
                _this12.codigoAssinatura = null;
                _this12.wizardComplete = false;

                idConsulta = Number(_this12.idConsulta);

                if (!(!idConsulta || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(idConsulta))) {
                  _context.next = 10;
                  break;
                }

                _this12.loading = false;
                _this12.errorMessage = 'Consulta inválida.';
                return _context.abrupt('return');

              case 10:
                _context.prev = 10;
                _context.next = 13;
                return _this12.apiGet('funcionario/aso/verificar-documento/' + idConsulta);

              case 13:
                result = _context.sent;
                status = _this12.responseStatus(result);

                if (!(status && status !== 200)) {
                  _context.next = 18;
                  break;
                }

                _this12.errorMessage = _this12.responseMessage(result, 'Não foi possível consultar a assinatura para esta consulta.');
                return _context.abrupt('return');

              case 18:
                payload = _this12.responsePayload(result);

                if (!(payload && payload.consultaExiste === false)) {
                  _context.next = 22;
                  break;
                }

                _this12.errorMessage = payload.message || 'Consulta não encontrada.';
                return _context.abrupt('return');

              case 22:

                _this12.alreadySigned = !!payload.assinado;
                _this12.codigoAssinatura = payload.codigo || null;

                if (!_this12.alreadySigned) {
                  _context.next = 30;
                  break;
                }

                _this12.wizardComplete = true;
                _this12.clearWizardState();
                _this12.stopTokenTimer();
                _context.next = 32;
                break;

              case 30:
                _context.next = 32;
                return _this12.carregarDadosFuncionarioConsulta();

              case 32:
                _context.next = 37;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context['catch'](10);

                _this12.errorMessage = 'Não foi possível consultar o status da assinatura.';

              case 37:
                _context.prev = 37;

                _this12.loading = false;
                return _context.finish(37);

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this12, [[10, 34, 37, 40]]);
      }))();
    },
    carregarDadosFuncionarioConsulta: function carregarDadosFuncionarioConsulta() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var idConsulta, result, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idConsulta = Number(_this13.idConsulta);

                if (!(!idConsulta || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(idConsulta))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return _this13.apiGet('funcionario/aso/dados-funcionario-consulta/' + idConsulta);

              case 6:
                result = _context2.sent;
                payload = _this13.responsePayload(result);


                if (payload && payload.existe) {
                  _this13.dadosFuncionarioCerebro = {
                    existe: true,
                    idFuncionario: Number(payload.idFuncionario || 0),
                    nomeMascarado: payload.nomeMascarado || '',
                    cpfMascarado: payload.cpfMascarado || '',
                    sexo: payload.sexo || '',
                    data_nascimento: payload.data_nascimento || '',
                    celular: payload.celular || ''
                  };

                  if (payload.sexo && !_this13.sexo) {
                    _this13.sexo = payload.sexo;
                  }
                  if (payload.data_nascimento && !_this13.dataNascimento) {
                    _this13.dataNascimento = payload.data_nascimento;
                  }

                  if (!_this13.cadastroExistente) {
                    _this13.cadastroMaskedNome = payload.nomeMascarado || '';
                    _this13.cadastroMaskedCpf = payload.cpfMascarado || '';
                  }

                  if (!_this13.telefone && payload.celular) {
                    _this13.telefone = _this13.maskPhone(payload.celular);
                  }
                }
                _context2.next = 13;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](3);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this13, [[3, 11]]);
      }))();
    },
    onlyDigits: function onlyDigits(value) {
      return String(value || '').replace(/\D+/g, '');
    },
    maskCpf: function maskCpf(value) {
      var digits = this.onlyDigits(value).slice(0, 11);
      var parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9), digits.slice(9, 11)];
      return [parts[0], parts[1], parts[2]].filter(Boolean).join('.') + (parts[3] ? '-' + parts[3] : '');
    },
    maskPhone: function maskPhone(value) {
      var digits = this.onlyDigits(value).slice(0, 11);
      if (digits.length <= 10) {
        return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
      }

      return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
    },
    setDocumentUploadState: function setDocumentUploadState(side, loading, hasError) {
      if (side === 'frente') {
        this.uploadLoadingFrente = !!loading;
        this.uploadErrorFrente = !!hasError;
        return;
      }

      this.uploadLoadingVerso = !!loading;
      this.uploadErrorVerso = !!hasError;
    },
    onDocumentSelected: function onDocumentSelected(payload) {
      if (!payload || !payload.file || !payload.side) {
        return;
      }

      this.onSelectFile(payload.file, payload.side);
    },
    isSupportedImage: function isSupportedImage(file) {
      if (!file || !file.type) {
        return false;
      }

      return file.type === 'image/png' || file.type === 'image/jpeg';
    },
    isSupportedDocument: function isSupportedDocument(file) {
      if (!file || !file.type) {
        return false;
      }

      return file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'application/pdf';
    },
    fileToDataUrl: function fileToDataUrl(file) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var reader = new FileReader();
                  reader.onload = function () {
                    return resolve(String(reader.result || ''));
                  };
                  reader.onerror = function () {
                    return reject(new Error('Falha ao ler arquivo.'));
                  };
                  reader.readAsDataURL(file);
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this14);
      }))();
    },
    onSelectFile: function onSelectFile(input, side) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var file, dataUrl, isPdf;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                file = input && input.target && input.target.files && input.target.files[0] ? input.target.files[0] : input;

                if (file) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return');

              case 3:
                if (!(side === 'verso' && !_this15.frenteDocumento)) {
                  _context4.next = 6;
                  break;
                }

                _this15.setStepMessage('Envie primeiro a frente do documento.', true);
                return _context4.abrupt('return');

              case 6:

                _this15.setDocumentUploadState(side, true, false);

                if (_this15.isSupportedDocument(file)) {
                  _context4.next = 11;
                  break;
                }

                _this15.setStepMessage('Formato inválido. Envie imagem PNG, JPEG ou PDF.', true);
                _this15.setDocumentUploadState(side, false, true);
                return _context4.abrupt('return');

              case 11:
                _context4.prev = 11;
                _context4.next = 14;
                return _this15.fileToDataUrl(file);

              case 14:
                dataUrl = _context4.sent;
                isPdf = file.type === 'application/pdf';

                if (!(side === 'frente')) {
                  _context4.next = 23;
                  break;
                }

                _this15.frenteDocumento = dataUrl;
                _this15.frenteDocumentoName = file.name;
                _this15.frenteIsPdf = isPdf;

                if (isPdf) {
                  _this15.versoDocumento = '';
                  _this15.versoDocumentoName = '';
                  _this15.uploadLoadingVerso = false;
                  _this15.uploadErrorVerso = false;
                }

                _this15.setDocumentUploadState(side, false, false);
                return _context4.abrupt('return');

              case 23:

                _this15.versoDocumento = dataUrl;
                _this15.versoDocumentoName = file.name;
                _this15.setDocumentUploadState(side, false, false);
                _context4.next = 32;
                break;

              case 28:
                _context4.prev = 28;
                _context4.t0 = _context4['catch'](11);

                _this15.setStepMessage('Não foi possível ler o arquivo selecionado.', true);
                _this15.setDocumentUploadState(side, false, true);

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this15, [[11, 28]]);
      }))();
    },
    onSelectFace: function onSelectFace(file) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (file) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:

                _this16.setFaceUploadState(true, false);

                if (_this16.isSupportedImage(file)) {
                  _context5.next = 7;
                  break;
                }

                _this16.setStepMessage('Formato invalido. Envie apenas imagem PNG ou JPEG.', true);
                _this16.setFaceUploadState(false, true);
                return _context5.abrupt('return');

              case 7:
                _context5.prev = 7;
                _context5.next = 10;
                return _this16.fileToDataUrl(file);

              case 10:
                _this16.fotoRosto = _context5.sent;

                _this16.fotoRostoName = file.name;
                _this16.setFaceUploadState(false, false);
                _context5.next = 19;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](7);

                _this16.setStepMessage('Não foi possível carregar a foto do rosto.', true);
                _this16.setFaceUploadState(false, true);

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this16, [[7, 15]]);
      }))();
    },
    setFaceUploadState: function setFaceUploadState(loading, hasError) {
      this.uploadLoadingRosto = !!loading;
      this.uploadErrorRosto = !!hasError;
    },
    validatePasswordConfirmation: function validatePasswordConfirmation() {
      if (!this.passwordConfirm) {
        return 'Confirme a senha.';
      }

      if (this.password !== this.passwordConfirm) {
        return 'As senhas não conferem.';
      }

      return '';
    },
    onPasswordConfirmBlur: function onPasswordConfirmBlur() {
      this.passwordConfirmTouched = true;
      this.passwordConfirmError = this.validatePasswordConfirmation();
    },
    onPasswordConfirmInput: function onPasswordConfirmInput() {
      if (!this.passwordConfirmTouched) {
        return;
      }

      this.passwordConfirmError = this.validatePasswordConfirmation();
    },
    validarCpf: function validarCpf() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var idConsulta, usarDadosFuncionario, cpf, requestPayload, cpfDigits, result, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                idConsulta = Number(_this17.idConsulta);
                usarDadosFuncionario = _this17.possuiDadosCerebro && !_this17.funcionarioCerebroEditavel;


                _this17.setStepMessage('', false);

                if (usarDadosFuncionario) {
                  _context6.next = 17;
                  break;
                }

                cpf = _this17.onlyDigits(_this17.cpf);

                if (!(!_this17.nome || _this17.nome.trim().length < 3)) {
                  _context6.next = 8;
                  break;
                }

                _this17.setStepMessage('Informe o nome completo.', true);
                return _context6.abrupt('return');

              case 8:
                if (!(cpf.length !== 11)) {
                  _context6.next = 11;
                  break;
                }

                _this17.setStepMessage('Informe um CPF válido com 11 dígitos.', true);
                return _context6.abrupt('return');

              case 11:
                if (_this17.sexo) {
                  _context6.next = 14;
                  break;
                }

                _this17.setStepMessage('Selecione o sexo.', true);
                return _context6.abrupt('return');

              case 14:
                if (_this17.dataNascimento) {
                  _context6.next = 17;
                  break;
                }

                _this17.setStepMessage('Informe a data de nascimento.', true);
                return _context6.abrupt('return');

              case 17:
                if (!(!idConsulta || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(idConsulta))) {
                  _context6.next = 20;
                  break;
                }

                _this17.setStepMessage('Consulta inválida.', true);
                return _context6.abrupt('return');

              case 20:

                _this17.busy = true;

                _context6.prev = 21;
                requestPayload = { idConsulta: idConsulta };


                if (usarDadosFuncionario) {
                  requestPayload.usarDadosFuncionario = true;
                  requestPayload.idFuncionario = _this17.dadosFuncionarioCerebro.idFuncionario;
                } else {
                  cpfDigits = _this17.onlyDigits(_this17.cpf);

                  _this17.cpf = _this17.maskCpf(cpfDigits);
                  requestPayload.cpf = cpfDigits;
                }

                _context6.next = 26;
                return _this17.apiPost('funcionario/aso/validar-info', requestPayload);

              case 26:
                result = _context6.sent;
                payload = _this17.responsePayload(result);

                if (!payload.valido) {
                  _context6.next = 33;
                  break;
                }

                _this17.currentStep = 3;
                _this17.setStepMessage('Identidade validada. Continue com a assinatura.', false);
                _this17.goToBoardRoute();
                return _context6.abrupt('return');

              case 33:

                _this17.setStepMessage(payload.message || 'CPF não confere com a consulta informada.', true);
                _context6.next = 39;
                break;

              case 36:
                _context6.prev = 36;
                _context6.t0 = _context6['catch'](21);

                _this17.setStepMessage('Não foi possível validar o CPF agora. Tente novamente.', true);

              case 39:
                _context6.prev = 39;

                _this17.busy = false;
                return _context6.finish(39);

              case 42:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this17, [[21, 36, 39, 42]]);
      }))();
    },
    confirmarCadastro: function confirmarCadastro() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var cpf, telefone, email, updatePayload, updateResult, _updatePayload, cadastroResult, cadastroPayload;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                cpf = _this18.onlyDigits(_this18.cpf);
                telefone = _this18.onlyDigits(_this18.telefone);
                email = String(_this18.email || '').trim().toLowerCase();


                _this18.setStepMessage('', false);

                if (!_this18.cadastroExistente) {
                  _context7.next = 49;
                  break;
                }

                if (_this18.cadastroEditavel) {
                  _context7.next = 9;
                  break;
                }

                _this18.currentStep = 4;
                _this18.setStepMessage('Dados mantidos com sucesso. Envie os documentos para avançar.', false);
                return _context7.abrupt('return');

              case 9:
                if (!(!_this18.nome || _this18.nome.trim().length < 3)) {
                  _context7.next = 12;
                  break;
                }

                _this18.setStepMessage('Informe o nome completo.', true);
                return _context7.abrupt('return');

              case 12:
                if (!(telefone.length < 10)) {
                  _context7.next = 15;
                  break;
                }

                _this18.setStepMessage('Informe um celular válido.', true);
                return _context7.abrupt('return');

              case 15:
                if (!(!email || email.indexOf('@') === -1)) {
                  _context7.next = 18;
                  break;
                }

                _this18.setStepMessage('Informe um e-mail válido.', true);
                return _context7.abrupt('return');

              case 18:

                _this18.busy = true;
                _context7.prev = 19;

                if (!_this18.cadastroUsuarioId) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 23;
                return _this18.atualizarCadastroUsuarioTrabalhador();

              case 23:
                updatePayload = _context7.sent;

                if (!(updatePayload && updatePayload.success === false)) {
                  _context7.next = 27;
                  break;
                }

                _this18.setStepMessage(updatePayload.message || 'Não foi possível atualizar os dados.', true);
                return _context7.abrupt('return');

              case 27:
                _context7.next = 36;
                break;

              case 29:
                _context7.next = 31;
                return _this18.apiPost('funcionario/aso/atualizar-cadastro-existente', {
                  cpf: cpf,
                  nome: _this18.nome.trim(),
                  celular: telefone,
                  email: email
                });

              case 31:
                updateResult = _context7.sent;
                _updatePayload = _this18.responsePayload(updateResult);

                if (!(_updatePayload && _updatePayload.success === false)) {
                  _context7.next = 36;
                  break;
                }

                _this18.setStepMessage(_updatePayload.message || 'Não foi possível atualizar os dados.', true);
                return _context7.abrupt('return');

              case 36:
                _context7.next = 38;
                return _this18.carregarCadastroPorCpf(cpf);

              case 38:
                _this18.currentStep = 4;
                _this18.setStepMessage('Dados atualizados com sucesso. Envie os documentos para avançar.', false);
                _context7.next = 45;
                break;

              case 42:
                _context7.prev = 42;
                _context7.t0 = _context7['catch'](19);

                _this18.setStepMessage('Não foi possível atualizar os dados. Tente novamente.', true);

              case 45:
                _context7.prev = 45;

                _this18.busy = false;
                return _context7.finish(45);

              case 48:
                return _context7.abrupt('return');

              case 49:
                if (!(!_this18.nome || _this18.nome.trim().length < 3)) {
                  _context7.next = 52;
                  break;
                }

                _this18.setStepMessage('Informe o nome completo.', true);
                return _context7.abrupt('return');

              case 52:
                if (!(telefone.length < 10)) {
                  _context7.next = 55;
                  break;
                }

                _this18.setStepMessage('Informe um celular válido.', true);
                return _context7.abrupt('return');

              case 55:
                if (!(!_this18.password || _this18.password.length < 4)) {
                  _context7.next = 58;
                  break;
                }

                _this18.setStepMessage('Informe uma senha com ao menos 4 caracteres.', true);
                return _context7.abrupt('return');

              case 58:

                _this18.passwordConfirmTouched = true;
                _this18.passwordConfirmError = _this18.validatePasswordConfirmation();

                if (!_this18.passwordConfirmError) {
                  _context7.next = 63;
                  break;
                }

                _this18.setStepMessage(_this18.passwordConfirmError + ' Verifique e tente novamente.', true);
                return _context7.abrupt('return');

              case 63:
                if (!(!email || email.indexOf('@') === -1)) {
                  _context7.next = 66;
                  break;
                }

                _this18.setStepMessage('O e-mail precisa ser validado no passo 1.', true);
                return _context7.abrupt('return');

              case 66:

                _this18.busy = true;

                _context7.prev = 67;

                _this18.telefone = _this18.maskPhone(telefone);
                _this18.email = email;

                _context7.next = 72;
                return _this18.apiPost('funcionario/aso/criar-usuario', {
                  email: email,
                  password: _this18.password,
                  cpf: cpf,
                  nome: _this18.nome.trim(),
                  telefone: telefone
                });

              case 72:
                cadastroResult = _context7.sent;
                cadastroPayload = _this18.responsePayload(cadastroResult);

                if (cadastroPayload && cadastroPayload.trabalhador_id) {
                  _this18.trabalhadorId = Number(cadastroPayload.trabalhador_id);
                }

                _context7.next = 77;
                return _this18.apiPost('funcionario/aso/validar-info-trabalhador', {
                  cpf: cpf,
                  nome: _this18.nome.trim(),
                  celular: telefone
                });

              case 77:

                _this18.currentStep = 4;
                _this18.setStepMessage('Cadastro confirmado. Envie os documentos para avançar.', false);
                _context7.next = 84;
                break;

              case 81:
                _context7.prev = 81;
                _context7.t1 = _context7['catch'](67);

                _this18.setStepMessage('Não foi possível confirmar o cadastro. Revise os dados e tente novamente.', true);

              case 84:
                _context7.prev = 84;

                _this18.busy = false;
                return _context7.finish(84);

              case 87:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this18, [[19, 42, 45, 48], [67, 81, 84, 87]]);
      }))();
    },
    carregarCadastroPorCpf: function carregarCadastroPorCpf(cpf) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var idResult, idPayload, cadastroResult, cadastroPayload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this19.apiGet('funcionario/aso/id-por-cpf/' + cpf);

              case 2:
                idResult = _context8.sent;
                idPayload = _this19.responsePayload(idResult);

                if (idPayload && idPayload.id) {
                  _this19.trabalhadorId = Number(idPayload.id);
                }

                _context8.next = 7;
                return _this19.apiGet('funcionario/aso/cadastro-por-cpf/' + cpf);

              case 7:
                cadastroResult = _context8.sent;
                cadastroPayload = _this19.responsePayload(cadastroResult);

                _this19.hidratarCadastroExistente(cadastroPayload);

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this19);
      }))();
    },
    carregarDadosMascaradosPorEmail: function carregarDadosMascaradosPorEmail(email) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var encoded, result, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                encoded = encodeURIComponent(String(email || '').trim().toLowerCase());
                _context9.next = 3;
                return _this20.apiGet('funcionario/aso/dados-mascarado-trabalhador/' + encoded);

              case 3:
                result = _context9.sent;
                payload = _this20.responsePayload(result);


                if (payload && payload.existe) {
                  _this20.cadastroUsuarioId = Number(payload.id_usuario || 0);
                  _this20.cadastroMaskedNome = payload.nomeMascarado || '';
                  _this20.cadastroMaskedCpf = payload.cpfMascarado || '';
                  _this20.cadastroMaskedTelefone = payload.celularMascarado || '';
                  _this20.cadastroMaskedEmail = payload.emailMascarado || '';
                  _this20.dataNascimento = payload.data_nascimento || _this20.dadosFuncionarioCerebro && _this20.dadosFuncionarioCerebro.data_nascimento || '';
                  _this20.sexo = payload.sexo || _this20.dadosFuncionarioCerebro && _this20.dadosFuncionarioCerebro.sexo || '';
                  if (payload.id_trabalhador) {
                    _this20.trabalhadorId = Number(payload.id_trabalhador);
                  }
                }

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this20);
      }))();
    },
    atualizarCadastroUsuarioTrabalhador: function atualizarCadastroUsuarioTrabalhador() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var payload, cpfDigits, email, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = { id_usuario: _this21.cadastroUsuarioId };


                if (_this21.nome && _this21.nome.trim()) {
                  payload.nome = _this21.nome.trim();
                }

                cpfDigits = _this21.onlyDigits(_this21.cpf);

                if (cpfDigits && cpfDigits.length === 11) {
                  payload.cpf = cpfDigits;
                }

                if (_this21.sexo) {
                  payload.sexo = _this21.sexo;
                }

                if (_this21.dataNascimento) {
                  payload.data_nascimento = _this21.dataNascimento;
                }

                email = String(_this21.email || '').trim().toLowerCase();

                if (email && email.indexOf('@') !== -1) {
                  payload.email = email;
                }

                _context10.next = 10;
                return _this21.apiPost('funcionario/aso/atualizar-cadastro-usuario-trabalhador', payload);

              case 10:
                result = _context10.sent;
                return _context10.abrupt('return', _this21.responsePayload(result));

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this21);
      }))();
    },
    hidratarCadastroExistente: function hidratarCadastroExistente(payload) {
      this.cadastroExistente = !!(payload && payload.usuarioExiste);
      if (!this.cadastroEdicaoAtivada) {
        this.cadastroEditavel = false;
      }

      if (!payload || !payload.existe) {
        this.cadastroMaskedNome = '';
        this.cadastroMaskedTelefone = '';
        this.cadastroMaskedEmail = '';
        return;
      }

      this.cadastroMaskedNome = payload.nomeMascarado || '';
      this.cadastroMaskedTelefone = payload.celularMascarado || '';
      this.cadastroMaskedEmail = payload.emailMascarado || '';

      if (this.cadastroExistente) {
        if (!this.cadastroEdicaoAtivada) {
          this.nome = this.cadastroMaskedNome;
          this.telefone = this.cadastroMaskedTelefone;
          this.email = this.cadastroMaskedEmail;
        }
        return;
      }
    },
    onFuncionarioCerebroEditavelToggle: function onFuncionarioCerebroEditavelToggle() {
      if (!this.possuiDadosCerebro) {
        return;
      }

      if (this.funcionarioCerebroEditavel) {
        this.funcionarioCerebroEdicaoAtivada = true;
        this.nome = '';
        this.cpf = '';
        this.sexo = '';
        this.dataNascimento = '';
      } else {
        this.cadastroMaskedNome = this.dadosFuncionarioCerebro.nomeMascarado || '';
        this.cadastroMaskedCpf = this.dadosFuncionarioCerebro.cpfMascarado || '';
        this.sexo = this.dadosFuncionarioCerebro.sexo || '';
        this.dataNascimento = this.dadosFuncionarioCerebro.data_nascimento || '';
      }

      this.setStepMessage('', false);
    },
    onCadastroEditavelToggle: function onCadastroEditavelToggle() {
      if (!this.cadastroExistente) {
        return;
      }

      if (this.cadastroEditavel) {
        this.cadastroEdicaoAtivada = true;
      }

      this.setStepMessage('', false);
    },
    confirmarDadosExistente: function confirmarDadosExistente() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this22.setStepMessage('', false);

                if (!_this22.cadastroEditavel) {
                  _context11.next = 20;
                  break;
                }

                _this22.busy = true;
                _context11.prev = 3;

                if (!_this22.cadastroUsuarioId) {
                  _context11.next = 11;
                  break;
                }

                _context11.next = 7;
                return _this22.atualizarCadastroUsuarioTrabalhador();

              case 7:
                result = _context11.sent;

                if (!(result && result.success === false)) {
                  _context11.next = 11;
                  break;
                }

                _this22.setStepMessage(result.message || 'Não foi possível atualizar os dados.', true);
                return _context11.abrupt('return');

              case 11:
                _context11.next = 17;
                break;

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11['catch'](3);

                _this22.setStepMessage('Não foi possível atualizar os dados.', true);
                return _context11.abrupt('return');

              case 17:
                _context11.prev = 17;

                _this22.busy = false;
                return _context11.finish(17);

              case 20:
                if (!_this22.cadastroExistente) {
                  _context11.next = 32;
                  break;
                }

                if (!_this22.possuiAssinaturaAnterior) {
                  _context11.next = 27;
                  break;
                }

                _this22.currentStep = 7;
                _this22.persistWizardState();
                _this22.goToBoardRoute();
                _this22.salvarAssinatura();
                return _context11.abrupt('return');

              case 27:

                _this22.currentStep = 5;
                _this22.persistWizardState();
                _this22.setStepMessage('Dados confirmados. Continue com o upload dos documentos.', false);
                _this22.goToBoardRoute();
                return _context11.abrupt('return');

              case 32:

                _this22.currentStep = 5;
                _this22.persistWizardState();
                _this22.setStepMessage('Dados confirmados. Continue com o upload dos documentos.', false);
                _this22.goToBoardRoute();

              case 36:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this22, [[3, 13, 17, 20]]);
      }))();
    },
    enviarTokenEmail: function enviarTokenEmail() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var email, checkResult, checkPayload, sent;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                email = String(_this23.email || '').trim().toLowerCase();

                if (!(!email || email.indexOf('@') === -1)) {
                  _context12.next = 4;
                  break;
                }

                _this23.setStepMessage('Informe um e-mail válido.', true);
                return _context12.abrupt('return');

              case 4:

                _this23.busy = true;
                _context12.prev = 5;
                _context12.next = 8;
                return _this23.apiGet('funcionario/aso/verificar-email/' + encodeURIComponent(email));

              case 8:
                checkResult = _context12.sent;
                checkPayload = _this23.responsePayload(checkResult);

                if (!(checkPayload && checkPayload.emailEncontrado === false)) {
                  _context12.next = 13;
                  break;
                }

                _this23.setStepMessage(checkPayload.message || 'Esse e-mail não pode ser utilizado.', true);
                return _context12.abrupt('return');

              case 13:
                if (!(checkPayload && checkPayload.emailCadastrado)) {
                  _context12.next = 22;
                  break;
                }

                _this23.cadastroExistente = true;
                _this23.possuiAssinaturaAnterior = !!checkPayload.possuiAssinaturaAnterior;
                _context12.next = 18;
                return _this23.carregarDadosMascaradosPorEmail(email);

              case 18:
                _this23.currentStep = 2;
                _this23.setStepMessage('E-mail já cadastrado. Confira seus dados.', false);
                _this23.goToValidationRoute('identidade');
                return _context12.abrupt('return');

              case 22:

                _this23.busy = false;
                _context12.next = 25;
                return _this23.enviarToken('email');

              case 25:
                sent = _context12.sent;

                if (sent) {
                  _this23.goToEmailTokenForm();
                }
                _context12.next = 32;
                break;

              case 29:
                _context12.prev = 29;
                _context12.t0 = _context12['catch'](5);

                _this23.setStepMessage('Não foi possível verificar o e-mail.', true);

              case 32:
                _context12.prev = 32;

                _this23.busy = false;
                return _context12.finish(32);

              case 35:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this23, [[5, 29, 32, 35]]);
      }))();
    },
    reenviarTokenEmail: function reenviarTokenEmail() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (_this24.tokenExpired) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt('return');

              case 2:
                _context13.next = 4;
                return _this24.enviarToken('email');

              case 4:
                _this24.emailTokenValues = ['', '', '', ''];
                _this24.$nextTick(function () {
                  return _this24.focusTokenDigit(0, 'email');
                });

              case 6:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this24);
      }))();
    },
    enviarTokenTelefone: function enviarTokenTelefone() {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var sent;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this25.enviarToken('sms');

              case 2:
                sent = _context14.sent;

                if (sent) {
                  _this25.goToPhoneTokenForm();
                }

              case 4:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this25);
      }))();
    },
    reenviarTokenTelefone: function reenviarTokenTelefone() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (_this26.tokenExpired) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt('return');

              case 2:
                _context15.next = 4;
                return _this26.enviarToken('sms');

              case 4:
                _this26.phoneTokenValues = ['', '', '', ''];
                _this26.$nextTick(function () {
                  return _this26.focusTokenDigit(0, 'phone');
                });

              case 6:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this26);
      }))();
    },
    enviarToken: function enviarToken(channel) {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var email, telefone, emailCheckResult, emailCheckPayload, emailResult, smsResult;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                email = String(_this27.email || '').trim().toLowerCase();
                telefone = _this27.onlyDigits(_this27.telefone);


                _this27.setStepMessage('', false);

                if (!(channel === 'email')) {
                  _context16.next = 9;
                  break;
                }

                if (!(!email || email.indexOf('@') === -1)) {
                  _context16.next = 7;
                  break;
                }

                _this27.setStepMessage('Informe um e-mail válido para receber o token.', true);
                return _context16.abrupt('return', false);

              case 7:
                _context16.next = 12;
                break;

              case 9:
                if (!(telefone.length < 10)) {
                  _context16.next = 12;
                  break;
                }

                _this27.setStepMessage('Informe um celular válido para receber o token.', true);
                return _context16.abrupt('return', false);

              case 12:

                _this27.busy = true;

                _context16.prev = 13;

                if (!(channel === 'email')) {
                  _context16.next = 22;
                  break;
                }

                _context16.next = 17;
                return _this27.apiGet('funcionario/aso/verificar-email/' + encodeURIComponent(email));

              case 17:
                emailCheckResult = _context16.sent;
                emailCheckPayload = _this27.responsePayload(emailCheckResult);

                if (!(emailCheckPayload && emailCheckPayload.emailEncontrado === false)) {
                  _context16.next = 22;
                  break;
                }

                _this27.setStepMessage(emailCheckPayload.message || 'Esse e-mail não pode ser utilizado.', true);
                return _context16.abrupt('return', false);

              case 22:
                if (!(channel === 'email')) {
                  _context16.next = 30;
                  break;
                }

                _context16.next = 25;
                return _this27.apiPost('funcionario/aso/disparar-email', { email: email });

              case 25:
                emailResult = _context16.sent;

                _this27.tokenChannel = 'email';
                _this27.setTokenExpiry();
                _this27.setStepMessage(_this27.responseMessage(emailResult, 'Token enviado por e-mail.'), false);
                return _context16.abrupt('return', true);

              case 30:
                _context16.next = 32;
                return _this27.apiPost('funcionario/aso/disparar-sms', { telefoneInput: telefone });

              case 32:
                smsResult = _context16.sent;

                _this27.tokenChannel = 'sms';
                _this27.setTokenExpiry();
                _this27.setStepMessage(_this27.responseMessage(smsResult, 'Token enviado por SMS.'), false);
                return _context16.abrupt('return', true);

              case 39:
                _context16.prev = 39;
                _context16.t0 = _context16['catch'](13);

                _this27.setStepMessage('Não foi possível disparar o token agora.', true);
                return _context16.abrupt('return', false);

              case 43:
                _context16.prev = 43;

                _this27.busy = false;
                return _context16.finish(43);

              case 46:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this27, [[13, 39, 43, 46]]);
      }))();
    },
    validarToken: function validarToken() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var token, telefone, email, result, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                token = _this28.onlyDigits(_this28.emailTokenValues.join(''));
                telefone = _this28.onlyDigits(_this28.telefone);
                email = String(_this28.email || '').trim().toLowerCase();


                _this28.setStepMessage('', false);

                if (!(token.length !== 4)) {
                  _context17.next = 7;
                  break;
                }

                _this28.setStepMessage('Informe os 4 dígitos do token recebido.', true);
                return _context17.abrupt('return');

              case 7:
                if (!(_this28.tokenExpiresAt && _this28.tokenExpired)) {
                  _context17.next = 10;
                  break;
                }

                _this28.setStepMessage('Token expirado. Solicite um novo token.', true);
                return _context17.abrupt('return');

              case 10:

                _this28.busy = true;

                _context17.prev = 11;
                _context17.next = 14;
                return _this28.apiPost('funcionario/aso/validar-token', {
                  token: token,
                  email: email,
                  telefoneInput: telefone
                });

              case 14:
                result = _context17.sent;
                payload = _this28.responsePayload(result);

                if (!(payload && payload.valido)) {
                  _context17.next = 25;
                  break;
                }

                _this28.currentStep = 2;
                _this28.emailValidationView = 'email';
                _this28.emailTokenValues = ['', '', '', ''];
                _this28.tokenExpiresAt = 0;
                _this28.stopTokenTimer();
                _this28.setStepMessage('E-mail validado com sucesso. Agora confirme sua identidade.', false);
                _this28.goToBoardRoute();
                return _context17.abrupt('return');

              case 25:

                _this28.setStepMessage(payload.message || 'Token inválido ou expirado.', true);
                _context17.next = 31;
                break;

              case 28:
                _context17.prev = 28;
                _context17.t0 = _context17['catch'](11);

                _this28.setStepMessage('Não foi possível validar o token.', true);

              case 31:
                _context17.prev = 31;

                _this28.busy = false;
                return _context17.finish(31);

              case 34:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this28, [[11, 28, 31, 34]]);
      }))();
    },
    validarTokenTelefone: function validarTokenTelefone() {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var token, telefone, email, result, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                token = _this29.onlyDigits(_this29.phoneTokenValues.join(''));
                telefone = _this29.onlyDigits(_this29.telefone);
                email = String(_this29.email || '').trim().toLowerCase();


                _this29.setStepMessage('', false);

                if (!(token.length !== 4)) {
                  _context18.next = 7;
                  break;
                }

                _this29.setStepMessage('Informe os 4 dígitos do token recebido.', true);
                return _context18.abrupt('return');

              case 7:
                if (!(_this29.tokenExpiresAt && _this29.tokenExpired)) {
                  _context18.next = 10;
                  break;
                }

                _this29.setStepMessage('Token expirado. Solicite um novo token.', true);
                return _context18.abrupt('return');

              case 10:

                _this29.busy = true;

                _context18.prev = 11;
                _context18.next = 14;
                return _this29.apiPost('funcionario/aso/validar-token', {
                  token: token,
                  email: email,
                  telefoneInput: telefone
                });

              case 14:
                result = _context18.sent;
                payload = _this29.responsePayload(result);

                if (!(payload && payload.valido)) {
                  _context18.next = 25;
                  break;
                }

                _this29.currentStep = 4;
                _this29.phoneValidationView = 'phone';
                _this29.phoneTokenValues = ['', '', '', ''];
                _this29.tokenExpiresAt = 0;
                _this29.stopTokenTimer();
                _this29.setStepMessage('Telefone validado com sucesso. Agora crie sua senha.', false);
                _this29.goToBoardRoute();
                return _context18.abrupt('return');

              case 25:

                _this29.setStepMessage(payload.message || 'Token inválido ou expirado.', true);
                _context18.next = 31;
                break;

              case 28:
                _context18.prev = 28;
                _context18.t0 = _context18['catch'](11);

                _this29.setStepMessage('Não foi possível validar o token de telefone.', true);

              case 31:
                _context18.prev = 31;

                _this29.busy = false;
                return _context18.finish(31);

              case 34:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this29, [[11, 28, 31, 34]]);
      }))();
    },
    validarSenha: function validarSenha() {
      this.passwordConfirmTouched = true;
      this.passwordConfirmError = this.validatePasswordConfirmation();

      var hasUpper = /[A-Z]/.test(this.password);
      var hasLower = /[a-z]/.test(this.password);
      var hasNumber = /\d/.test(this.password);
      var hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password);
      var strongEnough = this.password && this.password.length >= 8 && hasUpper && hasLower && hasNumber && hasSpecial;

      if (!strongEnough) {
        this.setStepMessage('A senha é muito fraca. Use 8+ caracteres com maiúscula, minúscula, número e símbolo.', true);
        return;
      }

      if (this.passwordConfirmError) {
        this.setStepMessage(this.passwordConfirmError + ' Verifique e tente novamente.', true);
        return;
      }

      this.registrarNovoCadastro();
    },
    registrarNovoCadastro: function registrarNovoCadastro() {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var cpf, telefone, email, usarDadosFuncionario, criarUsuarioPayload, cadastroResult, cadastroPayload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                cpf = _this30.onlyDigits(_this30.cpf);
                telefone = _this30.onlyDigits(_this30.telefone);
                email = String(_this30.email || '').trim().toLowerCase();
                usarDadosFuncionario = _this30.possuiDadosCerebro && !_this30.funcionarioCerebroEditavel;


                _this30.setStepMessage('', false);

                if (!(!email || email.indexOf('@') === -1)) {
                  _context19.next = 8;
                  break;
                }

                _this30.setStepMessage('O e-mail precisa ser validado no passo 1.', true);
                return _context19.abrupt('return');

              case 8:

                _this30.busy = true;

                _context19.prev = 9;
                criarUsuarioPayload = {
                  email: email,
                  password: _this30.password,
                  telefone: telefone
                };


                if (usarDadosFuncionario) {
                  criarUsuarioPayload.usarDadosFuncionario = true;
                  criarUsuarioPayload.idFuncionario = _this30.dadosFuncionarioCerebro.idFuncionario;
                } else {
                  criarUsuarioPayload.cpf = cpf;
                  criarUsuarioPayload.nome = _this30.nome.trim();
                  criarUsuarioPayload.sexo = _this30.sexo;
                  criarUsuarioPayload.data_nascimento = _this30.dataNascimento;
                }

                _context19.next = 14;
                return _this30.apiPost('funcionario/aso/criar-usuario', criarUsuarioPayload);

              case 14:
                cadastroResult = _context19.sent;
                cadastroPayload = _this30.responsePayload(cadastroResult);

                if (cadastroPayload && cadastroPayload.trabalhador_id) {
                  _this30.trabalhadorId = Number(cadastroPayload.trabalhador_id);
                }

                if (usarDadosFuncionario) {
                  _context19.next = 20;
                  break;
                }

                _context19.next = 20;
                return _this30.apiPost('funcionario/aso/validar-info-trabalhador', {
                  cpf: cpf,
                  nome: _this30.nome.trim(),
                  celular: telefone
                });

              case 20:

                _this30.currentStep = 5;
                _this30.setStepMessage('Cadastro confirmado. Continue com o upload dos documentos.', false);
                _this30.goToBoardRoute();
                _context19.next = 28;
                break;

              case 25:
                _context19.prev = 25;
                _context19.t0 = _context19['catch'](9);

                _this30.setStepMessage('Não foi possível confirmar o cadastro. Tente novamente.', true);

              case 28:
                _context19.prev = 28;

                _this30.busy = false;
                return _context19.finish(28);

              case 31:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this30, [[9, 25, 28, 31]]);
      }))();
    },
    salvarDocumentos: function salvarDocumentos() {
      var _this31 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var email, _payload, result, status;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                email = String(_this31.email || '').trim().toLowerCase();


                _this31.setStepMessage('', false);

                if (!(!_this31.frenteDocumento || !_this31.frenteIsPdf && !_this31.versoDocumento)) {
                  _context20.next = 5;
                  break;
                }

                _this31.setStepMessage(_this31.frenteIsPdf ? 'Selecione o documento PDF.' : 'Selecione frente e verso do documento.', true);
                return _context20.abrupt('return');

              case 5:

                _this31.busy = true;

                _context20.prev = 6;
                _payload = {
                  email: email,
                  idConsulta: Number(_this31.idConsulta),
                  frenteDocumento: _this31.frenteDocumento
                };


                if (!_this31.frenteIsPdf) {
                  _payload.versoDocumento = _this31.versoDocumento;
                }

                _context20.next = 11;
                return _this31.apiPost('funcionario/aso/salvar-documentos', _payload);

              case 11:
                result = _context20.sent;
                status = _this31.responseStatus(result);
                _payload = _this31.responsePayload(result);

                if (!(status && status !== 200)) {
                  _context20.next = 20;
                  break;
                }

                _this31.uploadErrorFrente = true;
                _this31.uploadErrorVerso = true;
                _this31.logRequestError('salvarDocumentos:status', { status: status, payload: _payload, result: result });
                _this31.setStepMessage(SUPPORT_ERROR_MESSAGE, true);
                return _context20.abrupt('return');

              case 20:
                if (!(_payload && _payload.success === false)) {
                  _context20.next = 26;
                  break;
                }

                _this31.uploadErrorFrente = true;
                _this31.uploadErrorVerso = true;
                _this31.logRequestError('salvarDocumentos:payload', { payload: _payload, result: result });
                _this31.setStepMessage(SUPPORT_ERROR_MESSAGE, true);
                return _context20.abrupt('return');

              case 26:

                _this31.uploadErrorFrente = false;
                _this31.uploadErrorVerso = false;

                _this31.currentStep = 6;
                _this31.setStepMessage(_this31.responseMessage(result, 'Documentos enviados com sucesso.'), false);
                _context20.next = 38;
                break;

              case 32:
                _context20.prev = 32;
                _context20.t0 = _context20['catch'](6);

                _this31.uploadErrorFrente = true;
                _this31.uploadErrorVerso = true;
                _this31.logRequestError('salvarDocumentos:exception', _context20.t0);
                _this31.setStepMessage(SUPPORT_ERROR_MESSAGE, true);

              case 38:
                _context20.prev = 38;

                _this31.busy = false;
                return _context20.finish(38);

              case 41:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this31, [[6, 32, 38, 41]]);
      }))();
    },
    salvarAssinatura: function salvarAssinatura() {
      var _this32 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var idConsulta, cpf, trabalhadorId, idResult, idPayload, usarDadosFuncionario, payload, result, responsePayload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                idConsulta = Number(_this32.idConsulta);
                cpf = _this32.onlyDigits(_this32.cpf);


                _this32.setStepMessage('', false);

                if (!(!_this32.fotoRosto && !(_this32.cadastroExistente && _this32.possuiAssinaturaAnterior))) {
                  _context21.next = 6;
                  break;
                }

                _this32.setStepMessage('Selecione uma foto do rosto para finalizar.', true);
                return _context21.abrupt('return');

              case 6:

                _this32.busy = true;

                _context21.prev = 7;
                trabalhadorId = Number(_this32.trabalhadorId || 0);

                if (!(!trabalhadorId && cpf)) {
                  _context21.next = 15;
                  break;
                }

                _context21.next = 12;
                return _this32.apiGet('funcionario/aso/id-por-cpf/' + cpf);

              case 12:
                idResult = _context21.sent;
                idPayload = _this32.responsePayload(idResult);

                trabalhadorId = idPayload && idPayload.id ? Number(idPayload.id) : 0;

              case 15:
                usarDadosFuncionario = _this32.possuiDadosCerebro && !_this32.funcionarioCerebroEditavel;
                payload = {
                  idConsulta: idConsulta,
                  fotoRosto: _this32.fotoRosto,
                  celular: _this32.onlyDigits(_this32.telefone),
                  email: (_this32.email || '').trim().toLowerCase(),
                  password: _this32.password || ''
                };


                if (usarDadosFuncionario) {
                  payload.usarDadosFuncionario = true;
                  payload.idFuncionario = _this32.dadosFuncionarioCerebro.idFuncionario;
                } else {
                  payload.nome = (_this32.nome || '').trim();
                  payload.sexo = _this32.sexo || '';
                  payload.data_nascimento = _this32.dataNascimento || '';
                  payload.cpf = cpf;
                }

                if (trabalhadorId) {
                  payload.id = trabalhadorId;
                }

                _context21.next = 21;
                return _this32.apiPost('funcionario/aso/salvar-assinatura', payload);

              case 21:
                result = _context21.sent;
                responsePayload = _this32.responsePayload(result);

                if (!(responsePayload && responsePayload.success === false)) {
                  _context21.next = 26;
                  break;
                }

                _this32.setStepMessage(responsePayload.message || 'Não foi possível concluir a assinatura.', true);
                return _context21.abrupt('return');

              case 26:

                _this32.justSigned = true;
                _this32.wizardComplete = true;
                _this32.setStepMessage(_this32.responseMessage(result, 'Documento assinado com sucesso.'), false);
                _this32.clearWizardState();
                _context21.next = 32;
                return _this32.loadAssinaturaStatus();

              case 32:
                _context21.next = 37;
                break;

              case 34:
                _context21.prev = 34;
                _context21.t0 = _context21['catch'](7);

                _this32.setStepMessage('Erro ao concluir assinatura. Tente novamente.', true);

              case 37:
                _context21.prev = 37;

                _this32.busy = false;
                return _context21.finish(37);

              case 40:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this32, [[7, 34, 37, 40]]);
      }))();
    }
  },
  watch: {
    '$route.params.step': function $routeParamsStep() {
      this.syncStepFromRoute();
    },
    cpf: function cpf(value) {
      this.cpf = this.maskCpf(value);
    },
    telefone: function telefone(value) {
      if (this.cadastroExistente && !this.cadastroEditavel) {
        return;
      }

      this.telefone = this.maskPhone(value);
    },
    currentStep: function currentStep() {
      this.persistWizardState();
    },
    nome: function nome() {
      this.persistWizardState();
    },
    email: function email() {
      this.persistWizardState();
    },
    tokenChannel: function tokenChannel() {
      this.persistWizardState();
    },
    tokenExpiresAt: function tokenExpiresAt() {
      this.persistWizardState();
      this.ensureTokenTimer();
    },
    trabalhadorId: function trabalhadorId() {
      this.persistWizardState();
    }
  }
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'agendamento_at',
    label: 'Data do Agendamento',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    clearable: true,
    option: {
        label: 'fdt',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcao',
    label: 'Função',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'deleted',
    label: 'Mostrar Consultas Excluídas',
    rules: ['']
}]);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
  class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
  type: 'select-tipo',
  field: 'aptidao',
  label: 'Aptidão',
  valor: 'valor',
  tipo: 185,
  rules: ['required']
}, {
  class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
  type: 'select-custom',
  field: 'exames',
  label: 'Informe os Exames Alterados (caso existir algum)',
  clearable: true,
  multiple: true,
  option: {
    label: 'nome',
    value: 'id'
  },
  rules: ['']
}, {
  class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
  type: 'select-tipo',
  field: 'id_tipo_status',
  label: 'Status',
  tipo: 53,
  rules: ['required']
}, {
  class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
  type: 'textarea',
  field: 'obs',
  label: 'Observações',
  placeholder: 'Digite algo sobre a liberacao',
  rules: []
}]);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadastro',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionário',
    clearable: true,
    option: {
        label: 'nome',
        value: 'id'
    },
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_aso',
    label: 'Tipo de ASO',
    clearable: true,
    multiple: true,
    tipo: 46,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    clearable: true,
    multiple: true,
    tipo: 53,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'boolean',
    field: 'id_arquivo_aso',
    label: 'Mostrar Apenas Consultas com ASO Digitalizado ',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'inativo',
    label: 'Mostrar Apenas Consultas Excluídas ',
    rules: ['']
}]);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'number',
    field: 'page',
    label: 'Página',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        label: 'empresa',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Trabalhador',
    option: {
        label: 'funcionario',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_con',
    label: 'Consulta',
    option: {
        label: 'consulta',
        value: 'id_con'
    },
    rules: ['required']
}]);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  group: 'Geral',
  fields: [{
    class: 'col-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 500,
    rules: ['required']
  }, {
    class: 'col-12',
    type: 'text',
    field: 'email',
    label: 'Email',
    maxlength: 500,
    rules: ['required']
  }, {
    class: 'col-md-6',
    type: 'text',
    field: 'usuario',
    label: 'Usuário',
    maxlength: 500,
    rules: ['required']
  }, {
    class: 'col-md-6',
    type: 'password',
    field: 'senha',
    label: 'Senha',
    maxlength: 500,
    rules: [] }, {
    class: 'col-12',
    type: 'select-tipo',
    field: 'tipo',
    label: 'Serviços Vinculados',
    tipo: 32,
    multiple: true,
    info: 'Selecione os serviços que utilizarão essa conta de email',
    rules: ['']
  }]
}, {
  group: 'Tipo de Autenticação',
  fields: [{
    class: 'col-12',
    type: 'select-tipo',
    field: 'tipo_auth',
    label: 'Método de Autenticação',
    tipo: 241,
    valor: 'valor',
    info: 'OAuth2 oferece maior segurança e melhor entrega de emails',
    rules: ['required']
  }]
}, {
  group: 'Configurações SMTP',
  fields: [{
    class: 'col-md-6',
    type: 'text',
    field: 'servidor_smtp',
    label: 'Servidor SMTP',
    maxlength: 500,
    info: 'Servidor STMP do seu provedor. Exemplo: smtp.gmail.com, stmp.google.com, etc',
    rules: [] }, {
    class: 'col-md-3',
    type: 'text',
    field: 'porta',
    label: 'Porta',
    maxlength: 500,
    info: 'A maioria dos servidores utilizam a porta 587. Na dúvida entre em contato com seu provedor para saber qual a porta de autenticação.',
    rules: [] }, {
    class: 'col-md-3',
    type: 'boolean',
    field: 'autenticacao',
    label: 'Seu servidor requer autenticação?',
    info: 'A maioria dos servidores requerem autenticação. É recomendado que deixe esse campo habilitado.',
    rules: [] }, {
    class: 'col-12',
    type: 'select-tipo',
    field: 'conexao_seg',
    tipo: 240,
    valor: 'valor',
    label: 'Seu Servidor Requer uma Conexão de Segurança?',
    info: 'A maioria dos servidores requerem autenticação TLS.',
    rules: [] }]
}, {
  group: 'Configurações Avançadas',
  fields: [{
    class: 'col-12',
    type: 'number',
    field: 'tempo_espera',
    label: 'Tempo de Espera (Segundos)',
    info: 'Recomenda-se deixar 0 (zero)',
    rules: ['required']
  }, {
    class: 'col-12',
    type: 'number',
    field: 'n_msg_pct',
    label: 'MARKETING - Nº Mensagens por Pacote',
    info: 'Recomenda-se deixar 50',
    rules: ['required']
  }, {
    class: 'col-12',
    type: 'number',
    field: 't_esp_pct',
    label: 'MARKETING - Tempo espera entre Pacote(s)',
    info: 'Recomenda-se deixar 600',
    rules: ['required']
  }]
}]);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-912 col-lg-912 col-xl-12',
    type: 'text',
    field: 'email',
    label: 'Digite um Email',
    rules: ['required']
}]);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
  type: 'text',
  field: 'telefone',
  label: 'Número de Telefone (com DDD)',
  info: 'Exemplo: 11999998888',
  rules: ['required']
}]);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    title: {
        model: 'empresa_envio_automatico',
        description: 'ssss'
    },
    info: '',
    clearable: true,
    placeholder: 'Todas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    clearable: true,
    placeholder: 'Todas',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    label: 'Funcionario',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    clearable: true,
    placeholder: 'Todos',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 327,
    multiple: true,
    placeholder: 'Todos',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'tp_exa',
    label: 'Tipo de Consulta',
    option: {
        key: 'codigo',
        label: 'nome',
        value: 'codigo'
    },
    info: '',
    clearable: true,
    multiple: true,
    disable_remote: true,
    placeholder: 'Todos',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'data_cadastro',
    label: 'Data de Cadastro',
    info: '',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Habilitar envio de Lotes',
    info: 'Ao habilitar essa opção o sistema vai enviar automaticamente (todo dia as 00:00) os lotes para seus clientes.',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
    type: 'date',
    field: 'data_inicio',
    label: 'Iniciar Envio EM',
    info: 'Data de inicio do envio dos Lotes.',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'empresas',
    label: 'Empresa - Gerar Lote',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione as empresas que receberam os emails de Lotes do Esocial. Deixe em branco para enviar a todas as empresas.',
    placeholder: 'Todas',
    clearable: true,
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'empresas_processar',
    label: 'Empresa - Processar Lote',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione as empresas que serão enviados os lotes processados diretamente para o eSocial.',
    clearable: true,
    multiple: true,
    rules: ['']
}]);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'destinatario',
    label: 'Destinatário',
    info: 'Para enviar mais de um destinatário, por favor separe os emails com `;` (ponto e vírgula)',
    rules: ['required']
}]);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'created_at',
    label: 'Data de Cadstro',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_ltcat',
    tipo: 203,
    label: 'Como deseja gerar o LTCAT',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
    type: 'select-tipo',
    field: 'id_tipo_revisao',
    tipo: 1,
    label: 'Tipo da Revisão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'date',
    field: 'data',
    label: 'Data Documento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-revisao',
    field: 'id_rev',
    label: 'Selecione o PPRA para copiar',
    info: '',
    option: {
        key: 'id',
        label: 'revisao',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-revisao',
    field: 'id_ltcat',
    option: {
        key: 'id',
        label: 'revisao',
        value: 'id'
    },
    label: 'Selecione o LTCAT para copiar',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    info: '',
    rules: ['']
}]);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações do Documento'
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    title: {
        link: 'id_emp',
        icon: 'fa fa-pencil-square-o'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-custom',
    field: 'id_fdt',
    label: 'Frente de Trabalho',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
    type: 'select-tipo',
    field: 'id_tipo_revisao',
    tipo: 1,
    label: 'Tipo da Revisão',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'date',
    field: 'data',
    label: 'Data Documento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5',
    type: 'select-custom',
    field: 'id_mod',
    label: 'Modelo do Documento',
    option: {
        key: 'id',
        label: 'modelo',
        value: 'id'
    },
    info: 'Para criar novos modelos acesso o menú LTCAT Modelos',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-custom',
    field: 'id_res',
    label: 'Responsável pelo LTCAT',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_ltcat',
    tipo: 203,
    label: 'Tipo do cadastro do LTCAT',
    info: '',
    disabled: true,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'id_rev',
    label: 'PPRA Copiado',
    info: '',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    maxlength: 500,
    info: '',
    rules: ['']
}]);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    label: 'Empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: '',
    clearable: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'vencimento',
    label: 'Vencimento',
    info: '',
    clearable: true,
    rules: ['']
}]);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    label: 'Descrição',
    maxlength: 300,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'upload',
    field: 'arquivo',
    multiple: false,
    accept: '.jpg, .png, .jpeg, .pdf, .zip',
    label: 'Selecione o Arquivo - Até 50 MB (imagem,pdf,zip)',
    info: 'Caso precisar fazer upload de mais de um arquivo, você pode compactar esses arquivos no formato ZIP e fazer upload do arquivo compactado.',
    rules: ['']
}]);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 255,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['required']
}]);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ocultar',
    label: 'Ocultar Conteúdo',
    info: 'Se esse campo estiver habilitado, esse conteúdo não será exibido no documento final LTCAT',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'ocultar_texto',
    label: 'Substituir o Conteúdo pelo Texto Abaixo',
    placeholder: 'Não se aplica',
    info: 'Ao ocultar o item, você pode definir um teste padrão que será mostrado no item em questão',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'fator_riscos',
    label: 'Mostrar SOMENTE para os seguintes Fatores de Riscos',
    multiple: true,
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Aqui você pode definir uma exceção para o bloqueio do campo. Insira os fatores de riscos que permitirão a visualização do conteúdo no documento LTCAT. Deixe em branco para bloquear totalmente.',
    rules: ['']
}]);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'copiar',
    label: 'Copiar Medições e Funções do seguinte GHE',
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    info: 'Selecione um GHE para copiar as medições e funções já cadastradas.',
    rules: ['']
}]);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'replicar',
    label: 'Replicar Medição para os Seguintes GHE',
    multiple: [],
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    title: {
        model: 'replicar_subs'
    },
    info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_con_tec',
    label: 'Selecionar uma Conclusão Técnica Existente',
    option: {
        key: 'id',
        label: 'nome',
        value: 'object'
    },
    info: 'Para incluir uma conclusão técnica na base de dados, acesse o menú LTCAT > Confgurações > Conclusão Técnica',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    maxlength: 255,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'number',
    field: 'ordem',
    label: 'Ordem',
    info: 'Esse campo é utilizado para ordenar o GHE',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'text',
    field: 'ghe',
    label: 'GHE',
    maxlength: 15,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'text',
    field: 'descricao',
    label: 'Descrição',
    maxlength: 150,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao_ambiente_trabalho',
    label: 'Descrição do Ambiente de Trabalho',
    info: 'Descrição individual do ambiente de trabalho deste setor, usada no evento S-2240 do eSocial.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ordenar',
    label: 'Ordenar as colunas a partir daqui',
    info: 'Habilite essa opção se quiser ordenar as os GHE a partir desse item. Isso funciona caso precisar incluir um GHE entre vários outros.',
    rules: ['']
}]);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'replicar',
    label: 'Replicar Função para os Seguintes GHE',
    multiple: [],
    option: {
        key: 'id',
        label: 'ghe',
        value: 'id'
    },
    title: {
        model: 'replicar_subs'
    },
    info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Função',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'cbo',
    label: 'CBO',
    mask: 'cbo',
    maxlength: 45,
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'descricao',
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_orcamento',
    tipo: 234,
    label: 'Como deseja gerar o Orçamento',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_orc_cp',
    label: 'Selecione o Orçamento para copiar',
    info: '',
    option: {
        key: 'id',
        label: 'ltcat_orcamento',
        value: 'id'
    },
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    maxlength: 255,
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'codigo',
    label: 'Código',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    tipo: 229,
    label: 'Status',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'descricao',
    maxlength: 255,
    label: 'Descrição',
    rules: ['required']
}]);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_conta_email',
    option: {
        key: 'id',
        label: 'email',
        value: 'id'
    },
    label: 'Conta de Email',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'destinatario',
    maxlength: 255,
    label: 'Destinatário',
    info: 'Separe os emails por `;` (ponto e vírgula) para enviar a varios destinatários',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'editor',
    field: 'mensagem',
    label: 'Enviar Email com a Seguinte Mensagem',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'editor',
    field: 'pdf',
    label: 'Modelo da Proposta (em PDF)',
    rules: ['required']
}]);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['']
}]);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Informações Gerais'
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'number',
    field: 'ordem',
    label: 'Ordem',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10',
    type: 'text',
    field: 'nome',
    label: 'Nome',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_campo',
    tipo: 207,
    label: 'Tipo de Campo',
    info: '',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'id_tipo_vinculo',
    clearable: true,
    tipo: 218,
    label: 'Vínculo com Fator de Risco',
    info: 'Aqui você pode relacionar esse campo com os campos dos Fatores de Riscos. Esse vínculo vai automatizar o cadastro dos fatores de riscos no LTCAT.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'unidade',
    label: 'Unidade de Medida',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'mascara',
    label: 'Máscara',
    info: 'Utilize esse campo para formatar o conteúdo do campo. Exemplo: Telefone: (99) 9999-9999 ou CPF: 999.999.999-99',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'valor_ref_min',
    label: 'Valor de Referência (mínimo)',
    mask: 'money',
    info: 'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
    type: 'text',
    field: 'valor_ref_max',
    label: 'Valor de Refrência (máximo)',
    mask: 'money',
    info: 'Utlize esse campo se quiser aplicar um valor de refrência para o campo. Esse valor pode ser utilizado para comparação se o valor de lançamento está dentro dos parâmetros definidos nas normas.',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'ativo',
    label: 'Registro Ativo?',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
    type: 'boolean',
    field: 'obrigatorio',
    label: 'Preenchimento Obrigatório?',
    info: 'Se habilitar esse campo, o mesmo deverá ser preenchido obrigatoriamente no momento do cadastro do LTCAT',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
    type: 'boolean',
    field: 'ordenar',
    label: 'Ordenar as colunas a partir daqui',
    info: 'Habilite essa opção se quiser ordenar as colunas a partir desse item. Isso funciona caso precisar incluir uma coluna entre várias outras.',
    rules: ['']
}]);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'group',
    icon: 'fa fa-arrow-circle-right',
    label: 'Filtrar Periódico'
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'date-range',
    field: 'periodo',
    label: 'Período',
    mask: 'date',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_empresa',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    label: 'Empresa',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fdt',
    option: {
        key: 'id',
        label: 'fdt',
        value: 'id'
    },
    multiple: true,
    label: 'Frente de Trabalho',
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_funcionario',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    label: 'Funcionário',
    multiple: true,
    rules: ['']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'boolean',
    field: 'periodico_data_adm',
    label: 'Calcular periódico somente de funcionários sem consulta cadastrado',
    rules: ['']
}]);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_emp',
    label: 'Selecione a Empresa',
    placeholder: 'Selecione',
    option: {
        key: 'id',
        label: 'nome',
        value: 'id'
    },
    info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
    rules: ['required']
}, {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'id_fun',
    label: 'Funcionário',
    placeholder: 'Todos',
    option: {
        key: 'id',
        label: 'funcionario',
        value: 'id'
    },
    multiple: true,
    info: 'Selecione a empresa que deseja desativar o envio dos periódicos.',
    rules: ['']
}]);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdSession__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdSession___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EdSession__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__EdSession___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdSocket__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdSocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EdSocket__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EdSocket___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdRequest__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EdRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EdRequest__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__EdRequest___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdDialog__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EdDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EdDialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__EdDialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdNotify__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EdNotify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EdNotify__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__EdNotify___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdLoading__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EdLoading__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__EdLoading___default.a; });







/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('mask', __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_min_css__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_events__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_theme_index_css__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_pt_br__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_froala_wysiwyg__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_froala_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_froala_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_composition_api__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directive__ = __webpack_require__(678);


__webpack_require__(267);
__webpack_require__(266);
__webpack_require__(690);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(691);
window._ = __webpack_require__(692);


















var isAsoSignatureFlow = /\/funcionario\/aso\/assinar\//.test(window.location.pathname);
var vuetify = null;

if (isAsoSignatureFlow) {
  var vuetifyModule = __webpack_require__(679);
  vuetify = vuetifyModule.default || vuetifyModule;
}

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_froala_wysiwyg___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12__vue_composition_api__["default"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale_lang_pt_br___default.a });
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);





$('.carregando').show();

new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  vuetify: vuetify,
  localStorage: __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a,
  element: __WEBPACK_IMPORTED_MODULE_7_element_ui___default.a,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__app___default.a);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_apps_template_500__);
















var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'credenciada.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'credenciada.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'credenciada.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'credenciada.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'credenciada.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'credenciada.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'credenciada.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'credenciada.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_empresa__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_empresa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_empresa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_apps_funcionario_aso_assinar_index_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_apps_funcionario_aso_assinar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_apps_funcionario_aso_assinar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_periodico_index__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_periodico_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_appsEmpresa_periodico_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsEmpresa_liberacao_index__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsEmpresa_liberacao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_appsEmpresa_liberacao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apps_template_404__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apps_template_511__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apps_template_200__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apps_template_500__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_apps_template_500__);


























var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_14_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_15_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_empresa___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'empresa.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsEmpresa_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'funcionario/aso/assinar/:idConsulta',
      name: 'empresa.funcionario.aso.assinar',
      component: __WEBPACK_IMPORTED_MODULE_11__components_apps_funcionario_aso_assinar_index_vue___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Assinatura de ASO',
        navigation: [{ text: 'Assinatura de ASO', active: true }]
      }
    }, {
      path: 'funcionario/aso/assinar/:idConsulta/validacao/:step',
      name: 'empresa.funcionario.aso.assinar.step',
      component: __WEBPACK_IMPORTED_MODULE_11__components_apps_funcionario_aso_assinar_index_vue___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Assinatura de ASO',
        navigation: [{ text: 'Assinatura de ASO', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'empresa.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'empresa.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsEmpresa_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'empresa.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'empresa.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsEmpresa_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'empresa.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsEmpresa_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'empresa.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'consultas/cadastrar/:funcionario?',
      name: 'empresa.consulta.cad',
      component: __WEBPACK_IMPORTED_MODULE_7_appsEmpresa_consulta_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'empresa.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Cadastrar', to: { name: 'empresa.consulta.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'liberacao',
      name: 'empresa.liberacao',
      component: __WEBPACK_IMPORTED_MODULE_13_appsEmpresa_liberacao_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Liberação de ASO',
        navigation: [{ text: 'Liberação', to: { name: 'empresa.liberacao' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'funcionarios',
      name: 'empresa.funcionario',
      component: __WEBPACK_IMPORTED_MODULE_8_appsEmpresa_funcionario_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Funcionários',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, active: true }]
      }
    }, {
      path: 'funcionarios/editar/:id',
      name: 'empresa.funcionario.edt',
      component: __WEBPACK_IMPORTED_MODULE_9_appsEmpresa_funcionario_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Funcionário',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon: 'fa fa-users', active: false }, { text: 'Editar', to: { name: 'empresa.funcionario.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'funcionarios/cadastrar',
      name: 'empresa.funcionario.cad',
      component: __WEBPACK_IMPORTED_MODULE_10_appsEmpresa_funcionario_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Funcionário',
        navigation: [{ text: 'Funcionários', to: { name: 'empresa.funcionario' }, icon: 'fa fa-users', active: false }, { text: 'Cadastrar', to: { name: 'empresa.funcionario.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'periodicos',
      name: 'empresa.periodico',
      component: __WEBPACK_IMPORTED_MODULE_12_appsEmpresa_periodico_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Periódicos',
        navigation: [{ text: 'Periódicos', to: { name: 'empresa.periodico' }, active: true }]
      }
    }, {
      path: 'consulta/aproveitamento',
      name: 'empresa.aproveitamento',
      component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1615));
      },
      meta: {
        requiresAuth: true,
        title: 'Aproveitamento de ASO',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, active: true }]
      }
    }, {
      path: 'consulta/aproveitamento/editar/:consulta',
      name: 'empresa.aproveitamento.edt',
      component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1614));
      },
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Aproveitamento',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'consultas/aproveitamento/cadastrar/:funcionario?',
      name: 'empresa.aproveitamento.cad',
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1613));
      },
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Cadastrar Aproveitamento',
        navigation: [{ text: 'Aproveitamento de ASO', to: { name: 'empresa.aproveitamento' }, icon: 'fa fa-address-card', active: false }, { text: 'Cadastrar', to: { name: 'empresa.aproveitamento.cad' }, icon: 'fa fa-plus-circle', active: true }]
      }
    }, {
      path: 'esocial/gerar-xml',
      name: 'esocial.gerarXML',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 163));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', active: false, cs: false, to: '' }, { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/gerar-xml-avulso',
      name: 'esocial.gerarXMLAvulso',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 699));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social Avulso',
        navigation: [{ text: 'E-Social Avulso', active: false, cs: false, to: '' }, { text: 'Gerar XML', to: { name: 'empresa.aproveitamento.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/gerar-lote/:lote?',
      name: 'empresa',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 664));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false }, { text: 'Gerar Lote', to: null, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }, {
      path: 'esocial/certificado',
      name: 'esocial.certificado',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 662));
      },
      meta: {
        requiresAuth: true,
        title: 'E-Social',
        navigation: [{ text: 'E-Social', to: { name: 'esocial.gerarXML' }, icon: 'fa fa-pencil-square-o', active: false }, { text: 'Certificado', to: null, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_layouts_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_layouts_credenciada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_apps_template_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_apps_template_511__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apps_template_200___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_apps_template_200__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apps_template_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_apps_template_500__);
















var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_7_apps_template_404___default.a
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: __WEBPACK_IMPORTED_MODULE_0_layouts_index___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_8_apps_template_511___default.a,
    meta: {
      requiresAuth: false,
      disablePageHeader: true,
      title: 'Cliente não Encontardo',
      navigation: [{ text: 'Cliente não Encontardo', active: true }]
    }
  }, {
    path: '/:tenant',
    meta: { requiresAuth: false },
    component: __WEBPACK_IMPORTED_MODULE_1_layouts_credenciada___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'login',
      name: 'parceiro.login',
      component: __WEBPACK_IMPORTED_MODULE_2_appsCredenciada_login_index___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Login',
        navigation: [{ text: 'Login', active: true }]
      }
    }, {
      path: 'logout',
      name: 'logout',
      component: __WEBPACK_IMPORTED_MODULE_3_common_logout___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'parceiro.home',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'meu-cadastro',
      name: 'parceiro.cadastro',
      component: __WEBPACK_IMPORTED_MODULE_4_appsCredenciada_meu_cadastro_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Meu Cadastro',
        navigation: [{ text: 'Meu Cadastro', to: { name: 'parceiro.cadastro' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas',
      name: 'parceiro.consulta',
      component: __WEBPACK_IMPORTED_MODULE_5_appsCredenciada_consulta_index___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: true }]
      }
    }, {
      path: 'consultas/editar/:consulta',
      name: 'parceiro.consulta.edt',
      component: __WEBPACK_IMPORTED_MODULE_6_appsCredenciada_consulta_editar___default.a,
      meta: {
        requiresAuth: true,
        disablePageHeader: false,
        title: 'Editar Consulta',
        navigation: [{ text: 'Consultas', to: { name: 'parceiro.consulta' }, icon: 'fa fa-address-card', active: false }, { text: 'Editar', to: { name: 'parceiro.consulta.edt' }, icon: 'fa fa-pencil-square-o', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_conta_whatsapp_index__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_appsWeb_conta_whatsapp_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_appsWeb_conta_whatsapp_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_index__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_appsWeb_periodico_desativado_index__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_appsWeb_periodico_desativado_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_appsWeb_periodico_desativado_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_index__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_cadastrar__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_ltcat_editar__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_appsWeb_ltcat_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_appsWeb_ltcat_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_index__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_cadastrar__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsWeb_fator_risco_editar__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_appsWeb_fator_risco_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_appsWeb_fator_risco_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_index__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_editar__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_laboratorio_cadastrar__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_laboratorio_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_laboratorio_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_index__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_editar__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_tabela_dinamica_cadastrar__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_tabela_dinamica_cadastrar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_tabela_dinamica_cadastrar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_appsWeb_ltcat_configuracao_index__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_appsWeb_ltcat_configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_appsWeb_ltcat_configuracao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_liberacao_index__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_liberacao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_liberacao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_appsWeb_consulta_externa_index__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_appsWeb_consulta_externa_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_appsWeb_consulta_externa_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_apps_funcionario_aso_assinar_index_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_apps_funcionario_aso_assinar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_apps_funcionario_aso_assinar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_index__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_certificado_index__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_certificado_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_certificado_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_index__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_appsWeb_esocial_configuracao_index__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_appsWeb_esocial_configuracao_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_appsWeb_esocial_configuracao_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_appsWeb_esocial_lotes_download__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_appsWeb_esocial_lotes_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_appsWeb_esocial_lotes_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_apps_web_conta_email_oAuth2Callback_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_apps_web_conta_email_oAuth2Callback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_apps_web_conta_email_oAuth2Callback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_apps_web_Privacy_Policy_index_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_apps_web_Privacy_Policy_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_apps_web_Privacy_Policy_index_vue__);







































var routes = [{
  name: '404',
  path: '*',
  meta: { requiresAuth: false },
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 157));
  }
}, {
  path: '/',
  meta: { requiresAuth: false },
  component: function component() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 159));
  },
  children: [{
    path: '/',
    meta: { requiresAuth: false },
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1648));
    },
    children: [{
      path: '',
      meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 700));
      }
    }, {
      path: 'login',
      name: 'web.login',
      meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
      component: function component() {
        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 700));
      }
    }, {
      path: ':tenant/funcionario/aso/assinar/:idConsulta',
      name: 'web.funcionario.aso.assinar',
      component: __WEBPACK_IMPORTED_MODULE_19__components_apps_funcionario_aso_assinar_index_vue___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Assinatura de ASO',
        navigation: []
      }
    }, {
      path: ':tenant/funcionario/aso/assinar/:idConsulta/validacao/:step',
      name: 'web.funcionario.aso.assinar.step',
      component: __WEBPACK_IMPORTED_MODULE_19__components_apps_funcionario_aso_assinar_index_vue___default.a,
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Assinatura de ASO',
        navigation: []
      }
    }, {
      path: 'logout',
      name: 'logout',
      omponent: function omponent() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
      },
      meta: {
        requiresAuth: false,
        disablePageHeader: true,
        title: 'Sair do Sistema',
        navigation: [{ text: 'Sair do Sistema', active: true }]
      }
    }, {
      path: '',
      name: 'web.home',
      component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1631));
      },
      meta: {
        requiresAuth: true,
        navigation: [{ text: 'Home', active: false }]
      }
    }, {
      path: 'politica-de-privacidade',
      name: 'web.politica',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 658));
      },
      meta: {
        requiresAuth: false,
        title: ''
      }
    }, {
      path: 'conta-email/oauth2/iniciar',
      name: 'web.conta-email.oauth2.iniciar',
      beforeEnter: function beforeEnter(to, from, next) {
        fetch('https://www1.softwareatento.com.br/commtrol/api/conta-email/oauth2/iniciar');

        fetch('http://localhost:8070/api/conta-email/oauth2/iniciar').then(function (res) {
          return res.json();
        }).then(function (data) {
          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            console.error('redirect_url não encontrada na resposta da API.');
            next(false);
          }
        }).catch(function (err) {
          console.error('Erro ao iniciar OAuth:', err);
          next(false);
        });
      },

      meta: {
        requiresAuth: true,
        title: 'Conectar Conta de Email'
      }

    }, {

      path: '/oauth2/callback',
      name: 'oAuth2Callback',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 661));
      },

      meta: {
        title: 'OAuth2 Callback',
        requiresAuth: true
      }

    }, {
      path: '/contador/:emp/:token',
      name: 'contador',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1616));
      },
      meta: {
        requiresAuth: false,
        title: '',
        navigation: []
      }
    }, {
      path: 'empresas',
      name: 'empresa',
      component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1625));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, cs: true, to: '/app/empresas.php' }]
      }
    }, {
      path: 'empresas/cadastrar',
      name: 'empresa.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1623));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'empresas/editar/:id',
      name: 'empresa.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1624));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'empresa/tabela-balcao',
      name: 'empresa.tabelabalcao',
      component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1626));
      },
      meta: {
        requiresAuth: true,
        title: 'Empresas',
        navigation: [{ text: 'Empresas', active: false, to: '/empresas' }, { text: 'Tabela Preço Balcão', active: true }]
      }
    }, {
      path: 'consultas/liberacao',
      name: 'consultas.liberacao',
      component: __WEBPACK_IMPORTED_MODULE_17_appsWeb_consulta_liberacao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Consultas',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Liberação', active: true }]
      }
    }, {
      path: 'consultas/externas',
      name: 'consultas.externa',
      component: __WEBPACK_IMPORTED_MODULE_18_appsWeb_consulta_externa_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Consultas Externas',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Consulta Externa', active: true }]
      }
    }, {
      path: 'consultas/aproveitamento',
      name: 'consultas.aproveitamento',
      component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1619));
      },
      meta: {
        requiresAuth: true,
        title: 'Aproveitamento de ASO',
        navigation: [{ text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' }, { text: 'Aproveitamento de ASO', active: true }]
      }
    }, {
      path: 'credenciadas',
      name: 'credenciada',
      component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1622));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: true }]
      }
    }, {
      path: 'credenciadas/cadastrar',
      name: 'credenciada.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1620));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: false, to: '/credenciadas' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'credenciadas/editar/:id',
      name: 'credenciada.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1621));
      },
      meta: {
        requiresAuth: true,
        title: 'Credenciadas',
        navigation: [{ text: 'Credenciadas', active: false, to: '/credenciadas' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'financeiro/boleto/bradesco',
      name: 'financeiro.boleto.bradesco',
      component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1628));
      },
      meta: {
        requiresAuth: true,
        title: 'Financeiro',
        navigation: [{ text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' }, { text: 'Boletos', active: true }]
      }
    }, {
      path: 'financeiro/boleto/inter',
      name: 'financeiro.boleto.inter',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1629));
      },
      meta: {
        requiresAuth: true,
        title: 'Financeiro',
        navigation: [{ text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' }, { text: 'Boletos', active: true }]
      }
    }, {
      path: 'cat',
      name: 'cat',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1617));
      },
      meta: {
        requiresAuth: true,
        title: 'Comunicação de Acidente de Trabalho',
        navigation: [{ text: 'Comunicação de Acidente de Trabalho', active: true }]
      }
    }, {
      path: 'cat/modelo',
      name: 'cat.modelo',
      component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1618));
      },
      meta: {
        requiresAuth: true,
        title: 'Comunicação de Acidente de Trabalho',
        navigation: [{ text: 'Comunicação de Acidente de Trabalho', active: false, to: '/cat' }, { text: 'Modelo', active: true }]
      }
    }, {
      path: 'pcmso/vencido',
      name: 'pcmso.vencido',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 703));
      },
      meta: {
        requiresAuth: true,
        title: 'PCMSO Vencido',
        navigation: [{ text: 'PCMSO Vencido', active: true }]
      }
    }, {
      path: 'pcmso/disparador',
      name: 'pcmso.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1639));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'pcmso/disparador/cadastrar',
      name: 'pcmso.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 702));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: false, to: '/pcmso/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'pcmso/disparador/editar/:id',
      name: 'pcmso.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 702));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' }, { text: 'Disparador', active: false, to: '/pcmso/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'pcmso/config',
      name: 'pcmso.config',
      component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 701));
      },
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'PCMSO', active: false, cs: true, to: '/app/pcmso.php' }, { text: 'Configuração', active: true }]
      }
    }, {
      path: 'ppra/vencido',
      name: 'ppra.vencido',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 703));
      },
      meta: {
        requiresAuth: true,
        title: 'PPRA Vencido',
        navigation: [{ text: 'PPRA Vencido', active: true }]
      }
    }, {
      path: 'ppra/disparador',
      name: 'ppra.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1644));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'ppra/disparador/cadastrar',
      name: 'ppra.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 705));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: false, to: '/ppra/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ppra/disparador/editar/:id',
      name: 'ppra.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 705));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' }, { text: 'Disparador', active: false, to: '/ppra/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ppra/config',
      name: 'ppra.config',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 701));
      },
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'PPRA', active: false, cs: true, to: '/app/ppra.php' }, { text: 'Configuração', active: true }]
      }
    }, {
      path: 'config/funcoes',
      name: 'funcao',
      component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1630));
      },
      meta: {
        requiresAuth: true,
        title: 'Funções',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Funções', active: true }]
      }
    }, {
      path: 'config/exames',
      name: 'exame',
      component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1627));
      },
      meta: {
        requiresAuth: true,
        title: 'Exames',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Exames', active: true }]
      }
    }, {
      path: 'config/riscos',
      name: 'risco',
      component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1647));
      },
      meta: {
        requiresAuth: true,
        title: 'Riscos',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Riscos', active: true }]
      }
    }, {
      path: 'config/conta-email',
      name: 'contaemail',
      component: __WEBPACK_IMPORTED_MODULE_0_appsWeb_conta_email_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Contas de Emails',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Contas de Emails', active: true }]
      }
    }, {
      path: 'config/conta-whatsapp',
      name: 'contawhatsapp',
      component: __WEBPACK_IMPORTED_MODULE_1_appsWeb_conta_whatsapp_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Contas de WhatsApp',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Contas de WhatsApp', active: true }]
      }
    }, {
      path: 'periodicos',
      name: 'periodico',
      component: __WEBPACK_IMPORTED_MODULE_2_appsWeb_periodico_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Periódicos',
        navigation: [{ text: 'Periódicos', active: true }]
      }
    }, {
      path: 'periodicos/disparador',
      name: 'periodico.disparo',
      component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1640));
      },
      meta: {
        requiresAuth: true,
        title: 'Disparador',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: true }]
      }
    }, {
      path: 'periodicos/disparador/cadastrar',
      name: 'periodico.disparo.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 704));
      },
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: false, to: '/periodicos/disparador' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'periodicos/disparador/editar/:id',
      name: 'periodico.disparo.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 704));
      },
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Disparador', active: false, to: '/periodicos/disparador' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'periodicos/desativados',
      name: 'periodico.desativado',
      component: __WEBPACK_IMPORTED_MODULE_3_appsWeb_periodico_desativado_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Desativados',
        navigation: [{ text: 'Periódicos', active: false, to: '/periodicos' }, { text: 'Desativados', active: true }]
      }
    }, {
      path: 'ltcat',
      name: 'ltcat',
      component: __WEBPACK_IMPORTED_MODULE_4_appsWeb_ltcat_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'LTCAT',
        navigation: [{ text: 'LTCAT', active: true }]
      }
    }, {
      path: 'ltcat/cadastrar',
      name: 'ltcat.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_5_appsWeb_ltcat_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/editar/:id',
      name: 'ltcat.editar',
      component: __WEBPACK_IMPORTED_MODULE_6_appsWeb_ltcat_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco',
      name: 'ltcat.risco',
      component: __WEBPACK_IMPORTED_MODULE_7_appsWeb_fator_risco_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Fator de Risco',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Fator de Risco', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco/cadastrar',
      name: 'ltcat.risco.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_8_appsWeb_fator_risco_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/fator-risco/editar/:id',
      name: 'ltcat.risco.editar',
      component: __WEBPACK_IMPORTED_MODULE_9_appsWeb_fator_risco_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/modelo',
      name: 'ltcat.modelo',
      meta: {
        requiresAuth: true,
        title: 'Modelos',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Modelos', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio',
      name: 'ltcat.laboratorio',
      component: __WEBPACK_IMPORTED_MODULE_10_appsWeb_ltcat_laboratorio_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Laboratórios',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio/cadastrar',
      name: 'ltcat.laboratorio.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_12_appsWeb_ltcat_laboratorio_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/laboratorio/editar/:id',
      name: 'ltcat.laboratorio.editar',
      component: __WEBPACK_IMPORTED_MODULE_11_appsWeb_ltcat_laboratorio_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica',
      name: 'ltcat.tabela',
      component: __WEBPACK_IMPORTED_MODULE_13_appsWeb_ltcat_tabela_dinamica_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Tabela Dinâmica',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica/cadastrar',
      name: 'ltcat.tabela.cadastrar',
      component: __WEBPACK_IMPORTED_MODULE_15_appsWeb_ltcat_tabela_dinamica_cadastrar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Cadastrar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'ltcat/tabela-dinamica/editar/:id',
      name: 'ltcat.tabela.editar',
      component: __WEBPACK_IMPORTED_MODULE_14_appsWeb_ltcat_tabela_dinamica_editar___default.a,
      meta: {
        requiresAuth: true,
        title: 'Editar',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'ltcat/configuracao',
      name: 'ltcat.configuracao',
      component: __WEBPACK_IMPORTED_MODULE_16_appsWeb_ltcat_configuracao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Configurações',
        navigation: [{ text: 'LTCAT', active: false, to: '/ltcat' }, { text: 'Configurações', active: false }]
      }
    }, {
      path: 'pgr',
      name: 'pgr',
      component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1643));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: true }]
      }
    }, {
      path: 'pgr/cadastrar',
      name: 'pgr.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1641));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: false, to: '/pgr' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'pgr/editar/:id',
      name: 'pgr.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1642));
      },
      meta: {
        requiresAuth: true,
        title: 'PGR',
        navigation: [{ text: 'PGR', active: false, to: '/pgr' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'relatorio/anual',
      name: 'relatorio.anual',
      component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1646));
      },
      meta: {
        requiresAuth: true,
        title: 'Relatório Analítico',
        navigation: [{ text: 'Relatório Analítico', active: true, to: '/relatorio/anual' }]
      }
    }, {
      path: 'config/profissionais',
      name: 'profissionais',
      component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1645));
      },
      meta: {
        requiresAuth: true,
        title: 'Profissionais Responsáveis',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Profissionais Responsáveis', active: true }]
      }
    }, {
      path: 'config/parceiros',
      name: 'parceiro',
      component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1638));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true }]
      }
    }, {
      path: 'config/parceiros/cadastrar',
      name: 'parceiro.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1636));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true, to: '/config/parceiros' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'config/parceiros/editar/:id',
      name: 'parceiro.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1637));
      },
      meta: {
        requiresAuth: true,
        title: 'Parceiros',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Parceiros', active: true, to: '/config/parceiros' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'config/medicos',
      name: 'medico',
      component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1635));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true }]
      }
    }, {
      path: 'config/medicos/cadastrar',
      name: 'medico.cadastrar',
      component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1633));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true, to: '/config/medicos' }, { text: 'Cadastrar', active: true }]
      }
    }, {
      path: 'config/medicos/editar/:id',
      name: 'medico.editar',
      component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1634));
      },
      meta: {
        requiresAuth: true,
        title: 'Medicos Examinadores',
        navigation: [{ text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' }, { text: 'Medicos Examinadores', active: true, to: '/config/medicos' }, { text: 'Editar', active: true }]
      }
    }, {
      path: 'log/tarefa',
      name: 'log.tarefa',
      component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1612));
      },
      meta: {
        requiresAuth: true,
        title: 'Tarefa',
        navigation: [{ text: 'Log', active: false }, { text: 'Tarefa', active: true }]
      }
    }, {
      path: 'log/aplicacao',
      name: 'log.aplicacao',
      component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1632));
      },
      meta: {
        requiresAuth: true,
        title: 'Logs da Aplicação',
        navigation: [{ text: 'Log', active: false }, { text: 'Logs da Aplicação', active: true }]
      }
    }, {
      path: 'esocial',
      name: 'esocial',
      component: __WEBPACK_IMPORTED_MODULE_20_appsWeb_esocial_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Esocial',
        navigation: [{ text: 'Esocial', active: false }]
      }
    }, {
      path: 'esocial/avulso',
      name: 'esocial.avulso',
      component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 699));
      },
      meta: {
        requiresAuth: true,
        title: 'Esocial Avulso',
        navigation: [{ text: 'Esocial Avulso', active: false }]
      }
    }, {
      path: 'esocial/lotes/:lote?',
      name: 'esocial.lotes',
      component: __WEBPACK_IMPORTED_MODULE_22_appsWeb_esocial_lotes_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Lotes',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Lotes', active: true }]
      }
    }, {
      path: 'esocial/certificados',
      name: 'esocial.certificado',
      component: __WEBPACK_IMPORTED_MODULE_21_appsWeb_esocial_certificado_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Certificados',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Certificados', active: true }]
      }
    }, {
      path: 'esocial/configuracao',
      name: 'esocial.configuracao',
      component: __WEBPACK_IMPORTED_MODULE_23_appsWeb_esocial_configuracao_index___default.a,
      meta: {
        requiresAuth: true,
        title: 'Configuração',
        navigation: [{ text: 'Esocial', active: false, to: '/esocial' }, { text: 'Configuração', active: true }]
      }
    }]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_md5__);







var Cookie = __webpack_require__(643);

var VueCookie = {
  install: function install(Vue) {
    Vue.prototype.$cookie = this;
    Vue.cookie = this;
  },
  set: function set(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    var opts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
      expires: '24h',
      secure: false,
      path: '/'
    }, options);

    return Cookie.set(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value), opts);
  },
  get: function get(key) {

    if (!key) return null;

    var cookie = Cookie.get(key);

    if (!cookie) return null;

    try {
      return JSON.parse(cookie);
    } catch (error) {
      return cookie;
    }
  },
  delete: function _delete(key) {
    Cookie.remove(key);
  }
};

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(VueCookie);

/* unused harmony default export */ var _unused_webpack_default_export = (VueCookie);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_base_64__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_md5__);










var VueUtilidade = {
  install: function install(Vue) {
    Vue.prototype.$utilidade = this;
    Vue.utilidade = this;
  },
  getLocation: function getLocation(type) {
    var hostname = window.location;

    type = type ? type : 'hostname';

    return hostname[type];
  },
  stringToArray: function stringToArray(string) {
    if (!string) return [];

    return JSON.parse(string);
  },
  getIcone: function getIcone(icone) {
    var _icones;

    var icones = (_icones = {
      'cadastrar': 'fa fa-plus-circle',
      'buscar': 'fa fa-search',
      'filtrar': 'fa fa-filter',
      'editar': 'fa fa-pencil-square',
      'deletar': 'fa fa-trash-o',
      'link': 'fa fa-external-link-square',
      'salvar': 'fa fa-floppy-o',
      'fechar': 'fa fa-times',
      'info': 'fa fa-info-circle',
      'pdf': 'fa fa-file-pdf-o',
      'texto': 'fa fa-file-text-o',
      'empresa': 'fa fa-building'
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, "empresa", 'fa fa-building'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'usuarios', 'fa fa fa-users'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'usuario', 'fa fa-user'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'medico', 'fa fa-user-md'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'download', 'fa fa-cloud-download'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'upload', 'fa-cloud-upload'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'email', 'fa fa-envelope'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_icones, 'historico', 'fa fa-history'), _icones);

    if (icones[icone]) {
      return icones[icone];
    }

    return null;
  },
  randomMumber: function randomMumber(min, max) {
    min = !min ? 1 : min;
    max = !max ? 10 : max;
    return Math.random() * (max - min) + min;
  },
  randomString: function randomString() {
    var math = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return this.toMd5(math + new Date().getTime());
  },
  arrFindByField: function arrFindByField(arr, field, value, index) {
    if (!field || !arr || !arr.length > 0) return null;

    var arr = arr.filter(function (x) {
      return x[field] == value;
    });
    var arrIndex = arr.findIndex(function (x) {
      return x[field] == value;
    });

    if (index) return arrIndex;
    if (arr.length == 1) return arr[0];

    return null;
  },
  onlyNumber: function onlyNumber(value) {
    if (!value) return "";

    value = value.toString();

    return value.replace(/[\. ,:-]+/g, "-").replace(/[^0-9\.]+/g, "");
  },
  onlyText: function onlyText(value) {
    if (!value) return "";

    value = this.toString(value);
    return value.replace(/(<([^>]+)>)/gi, "");
  },
  isEmail: function isEmail(value) {
    var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return value && pattern.test(value);
  },
  isDate: function isDate(value) {
    if (!value) return false;

    var arrayValue = value.toString().split('/');

    if (arrayValue.length != 3) return false;

    var dia = arrayValue[0];
    var mes = arrayValue[1];
    var ano = arrayValue[2];
    var data = ano + '-' + mes + '-' + dia;

    if (parseInt(mes) > 12 || parseInt(mes) < 1 || parseInt(dia) < 1 || parseInt(dia) > 31 || parseInt(ano) < 1900) return false;

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(data).isValid();
  },
  isCpf: function isCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return false;

    if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;

    var add = 0;
    for (var i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }var rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) return false;

    add = 0;
    for (i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }rev = 11 - add % 11;
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) return false;
    return true;
  },
  mascara: function mascara(val, mask) {

    if (!val) return val;

    var limpo = this.limparCnpj(val);

    if (this.isCnpj(limpo)) {
      mask = 'cnpj';
      val = limpo;
    } else {
      val = this.onlyNumber(val);
      var num = val;

      if (this.isCpf(num)) {
        mask = 'cpf';
      } else if (num.toString().length == 10) {
        mask = 'telefone';
      } else if (num.toString().length == 1) {
        mask = 'celular';
      }
    }

    switch (mask) {

      case 'cnpj':
        mask = '##.###.###/####-##';
        break;

      case 'cpf':
        mask = '###.###.###-##';
        break;

      case 'telefone':
        mask = '(##) ####-####';
        break;

      case 'celular':
        mask = '(##) #####-#####';
        break;

      default:
        mask = '';
        break;
    }

    var maskared = '';
    var k = 0;

    for (var i = 0; i <= mask.length - 1; i++) {

      if (mask[i] == '#') {
        if (val[k]) maskared += val[k++];
      } else {
        if (mask[i]) maskared += mask[i];
      }
    }

    return maskared;
  },
  limparCnpj: function limparCnpj(value) {
    if (!value) return '';
    return value.toString().replace(/[\.\-\/\s]/g, '').toUpperCase();
  },
  cnpjCharValue: function cnpjCharValue(char) {
    return char.toUpperCase().charCodeAt(0) - 48;
  },
  isCnpj: function isCnpj(value) {

    if (!value) return false;

    var cnpj = this.limparCnpj(value);

    if (cnpj.length !== 14) return false;

    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

    if (/^(.)\1+$/.test(cnpj)) return false;

    var self = this;

    var t = cnpj.length - 2,
        d = cnpj.substring(t),
        d1 = parseInt(d.charAt(0)),
        d2 = parseInt(d.charAt(1)),
        calc = function calc(x) {
      var n = cnpj.substring(0, x),
          y = x - 7,
          s = 0,
          r = 0;

      for (var i = x; i >= 1; i--) {
        s += self.cnpjCharValue(n.charAt(x - i)) * y--;
        if (y < 2) y = 9;
      }

      r = 11 - s % 11;
      return r > 9 ? 0 : r;
    };

    return calc(t) === d1 && calc(t + 1) === d2;
  },
  isNumeric: function isNumeric(value) {
    var pattern = /[0-9]/;

    return value && pattern.test(value);
  },
  buildFormData: function buildFormData(formData, data, parentKey) {
    var _this = this;

    if (data && (typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {

        console.log('key', [key, data[key]]);
        _this.buildFormData(formData, data[key], parentKey ? parentKey + "[" + key + "]" : key);
      });
    } else {

      console.log('parentKey', value);
      var value = data == null ? '' : data;

      formData.append(parentKey, value);
    }
  },
  toFormUpload: function toFormUpload(data) {
    var formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  },
  booleanToInteger: function booleanToInteger(form) {
    for (var key in form) {
      if (form[key] === true) form[key] = 1;

      if (form[key] === false) form[key] = 0;
    }

    return form;
  },
  base64Decode: function base64Decode(value) {
    try {
      return __WEBPACK_IMPORTED_MODULE_7_base_64___default.a.decode(value);
    } catch (err) {
      return null;
    }
  },
  base64Encode: function base64Encode(value) {
    try {
      return __WEBPACK_IMPORTED_MODULE_7_base_64___default.a.encode(value);
    } catch (err) {
      return null;
    }
  },
  fileToBase64: function fileToBase64(file) {

    var reader = new FileReader();
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      reader.onerror = function () {
        reader.abort();reject(new Error("Error parsing file"));
      };
      reader.onload = function () {
        var bytes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(new Uint8Array(this.result));

        var base64StringFile = btoa(bytes.map(function (item) {
          return String.fromCharCode(item);
        }).join(""));

        resolve({
          size: file.size,
          content: base64StringFile,
          name: file.name,
          type: file.type
        });
      };
      reader.readAsArrayBuffer(file);
    });
  },
  utf8Decode: function utf8Decode(t) {
    if (!t) return t;

    try {
      return decodeURIComponent(escape(t));
    } catch (err) {
      return t;
    }
  },
  toDate: function toDate(date, disableHours, format) {
    if (!date) {
      date = new Date();
    }

    if (!format) {
      format = "DD/MM/YYYY HH:mm:ss";

      if (disableHours) {
        format = "DD/MM/YYYY";
      }
    }

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
  },
  convertDate: function convertDate(date, format) {
    if (!date) {
      return new Date();
    }

    format = format ? format : 'DD/MM/YYYY';

    return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
  },
  addDate: function addDate(value, date) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'D';
    var format = arguments[3];


    if (!date) {
      date = new Date();
    } else {
      date = new Date(date);
    }

    switch (type) {
      case "y":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'years').toDate();
        break;
      case "M":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'months').toDate();
        break;
      case "D":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'days').toDate();
        break;
      case "h":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'hours').toDate();
        break;
      case "m":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'minutes').toDate();
        break;
      case "s":
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'secounds').toDate();
        break;
      default:
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(value, 'days').toDate();
    }

    if (format) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(format);
    }
    return date;
  },
  diffDays: function diffDays(date1, date2, type) {
    type = !type ? "d" : type;
    date1 = !date1 ? __WEBPACK_IMPORTED_MODULE_6_moment___default()() : __WEBPACK_IMPORTED_MODULE_6_moment___default()(date1);
    date2 = !date2 ? __WEBPACK_IMPORTED_MODULE_6_moment___default()() : __WEBPACK_IMPORTED_MODULE_6_moment___default()(date2);

    switch (type) {
      case "y":
        return date1.diff(date2, "years", true);
        break;
      case "d":
        return date1.diff(date2, "days", true);
        break;
      case "h":
        return date1.diff(date2, "hours", true);
        break;
      case "m":
        return date1.diff(date2, "minutes", true);
        break;
      case "s":
        return date1.diff(date2, "seconds", true);
        break;
      default:
        return date1.diff(date2, "days", true);
        break;
    }
  },
  moneyToFloat: function moneyToFloat(value) {
    if (!value || value == "") {
      return 0;
    }

    value = this.toString(value);

    return parseFloat(value.replace(".", "").replace(",", "."));
  },
  floatToMoney: function floatToMoney(value) {
    if (!value) {
      return "0,00";
    }

    var formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

    value = formatter.format(value).replace("R$", "").trim();

    return value;
  },
  formataCampo: function formataCampo(text, left, format) {

    format = !format ? '0' : format;
    left = !left ? 0 : left;

    if (!text) return text;

    return text.toString().padStart(left, format);
  },


  toMb: function toMb(bytes) {

    if (!bytes) return '0 MB';

    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  },

  toString: function toString(value) {
    if (value == null || value == undefined) return '';

    return value.toString();
  },
  toMd5: function toMd5(text) {

    try {
      text = this.toString(text);
      text = __WEBPACK_IMPORTED_MODULE_8_js_md5___default()(text);
      return text;
    } catch (e) {
      return text;
    }
  },
  validateEmail: function validateEmail(email) {

    email = email ? email.trim() : null;

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  },
  textLimit: function textLimit(value, limit) {

    limit = limit ? limit : 100;

    if (value && value.length > limit) {
      return value.substring(0, limit) + "...";
    }

    return value;
  },
  console: function (_console) {
    function console(_x2) {
      return _console.apply(this, arguments);
    }

    console.toString = function () {
      return _console.toString();
    };

    return console;
  }(function (data) {
    if (__webpack_require__.i({"NODE_ENV":"production","APP_NAME":"softwareatento","PROTOCOL":"https://","URL_CS":"https://www1.softwareatento.com.br","URL_API":__webpack_require__.i({"web":"web1.softwareatento.com.br","empresa":"empresa1.softwareatento.com.br","credenciada":"credenciada1.softwareatento.com.br","parceiro":"parceiro1.softwareatento.com.br"}),"REQ_KEY":"6D374B328CCE803FC770D92BEBCD689477FA9A4CAC74753BC87980168BCA674E","REQ_NAME":"xToken","FROALA_KEY":"mA4B1E2A1vA1E1F1C4B8D7A6E1D5E4iexC-16mmznxC-7keovlF4fijD3kx==","PUSHER_KEY":"048c8ee8504af5687c17","PUSHER_CLUSTER":"us2","PUSHER_LOG":true,"CONFIG_DEV_TOOLS":false,"CONFIG_PRODTIP":false,"CONFIG_DEBUG":false}).LOG) {
      console.log(data);
    }
  }),
  removerAcentos: function removerAcentos() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!source) {
      return '';
    }

    var accent = [/[\300-\306]/g, /[\340-\346]/g, /[\310-\313]/g, /[\350-\353]/g, /[\314-\317]/g, /[\354-\357]/g, /[\322-\330]/g, /[\362-\370]/g, /[\331-\334]/g, /[\371-\374]/g, /[\321]/g, /[\361]/g, /[\307]/g, /[\347]/g],
        noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

    for (var i = 0; i < accent.length; i++) {
      source = source.replace(accent[i], noaccent[i]);
    }

    return source;
  },
  getEstado: function getEstado() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var arrayEstados = [{
      "uf": "AC",
      "estado": "Acre"
    }, {
      "uf": "AL",
      "estado": "Alagoas"
    }, {
      "uf": "AP",
      "estado": "Amapá"
    }, {
      "uf": "AM",
      "estado": "Amazonas"
    }, {
      "uf": "BA",
      "estado": "Bahia"
    }, {
      "uf": "CE",
      "estado": "Ceará"
    }, {
      "uf": "DF",
      "estado": "Distrito Federal"
    }, {
      "uf": "ES",
      "estado": "Espírito Santo"
    }, {
      "uf": "GO",
      "estado": "Goiás"
    }, {
      "uf": "MA",
      "estado": "Maranhão"
    }, {
      "uf": "MT",
      "estado": "Mato Grosso"
    }, {
      "uf": "MS",
      "estado": "Mato Grosso do Sul"
    }, {
      "uf": "MG",
      "estado": "Minas Gerais"
    }, {
      "uf": "PA",
      "estado": "Pará"
    }, {
      "uf": "PB",
      "estado": "Paraíba"
    }, {
      "uf": "PR",
      "estado": "Paraná"
    }, {
      "uf": "PE",
      "estado": "Pernambuco"
    }, {
      "uf": "PI",
      "estado": "Piauí"
    }, {
      "uf": "RJ",
      "estado": "Rio de Janeiro"
    }, {
      "uf": "RN",
      "estado": "Rio Grande do Norte"
    }, {
      "uf": "RS",
      "estado": "Rio Grande do Sul"
    }, {
      "uf": "RO",
      "estado": "Rondônia"
    }, {
      "uf": "RR",
      "estado": "Roraima"
    }, {
      "uf": "SP",
      "estado": "São Paulo"
    }, {
      "uf": "SC",
      "estado": "Santa Catarina"
    }, {
      "uf": "SE",
      "estado": "Sergipe"
    }, {
      "uf": "TO",
      "estado": "Tocantins"
    }];

    return arrayEstados.filter(function (objEstado) {
      objEstado.estado = objEstado.estado.toUpperCase();

      return !search || objEstado.uf.indexOf(search) !== -1;
    });
  },
  pluck: function pluck(array, key) {
    return array.map(function (o) {
      return o[key];
    });
  }
};

__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(VueUtilidade);

/* unused harmony default export */ var _unused_webpack_default_export = (VueUtilidade);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCliente", function() { return setCliente; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTenant", function() { return setTenant; });

var setCliente = function setCliente(context, cliente) {
	context.commit('SET_CLIENTE', cliente);
};

var setTenant = function setTenant(context, tenant) {
	context.commit('SET_TENANT', tenant);
};



/***/ }),
/* 989 */
/***/ (function(module, exports) {



/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(988);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CLIENTE", function() { return SET_CLIENTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TENANT", function() { return SET_TENANT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);



var SET_CLIENTE = function SET_CLIENTE(state, cliente) {
	state.logged = cliente;

	if (cliente && cliente.google_analytics_key) {
		__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
			id: cliente.google_analytics_key,
			linkers: [cliente.url_web, cliente.url_empresa, cliente.url_credenciada, cliente.url_parceiro],
			checkDuplicatedScript: true
		});
	}
};

var SET_TENANT = function SET_TENANT(state, tenant) {
	state.tenant = tenant;
};



/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	tenant: null
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubDomain", function() { return setSubDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLog", function() { return setLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocation", function() { return setLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRequest", function() { return setRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNavigation", function() { return setNavigation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEnv", function() { return setEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWindow", function() { return setWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEvent", function() { return setEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPcmso", function() { return setPcmso; });

var setSubDomain = function setSubDomain(context, sub_domain) {
	context.commit('SET_SUB_DOMAIN', sub_domain);
};

var setEvent = function setEvent(context, event) {
	context.commit('SET_EVENT', event);
};

var setLog = function setLog(context, log) {
	context.commit('SET_LOG', log);
};

var setLocation = function setLocation(context, location) {
	context.commit('SET_LOCATION', location);
};

var setRequest = function setRequest(context, request) {
	context.commit('SET_REQUEST', request);
};

var setNavigation = function setNavigation(context, navigation) {
	context.commit('SET_NAVIGATION', navigation);
};

var setEnv = function setEnv(context, env) {
	context.commit('SET_ENV', env);
};

var setUrlApi = function setUrlApi(context, url_api) {
	context.commit('SET_URL_API', url_api);
};

var setPcmso = function setPcmso(context, pcmso) {
	context.commit('SET_PCMSO', pcmso);
};

var setWindow = function setWindow(context, window) {
	context.commit('SET_WINDOW', window);

	var device = 'lg';

	if (window.width >= 1200) {
		device = 'lg';
	} else if (window.width >= 992) {
		device = 'md';
	} else if (window.width >= 785) {
		device = 'sm';
	} else {
		device = 'xs';
	}

	context.commit('SET_DEVICE', device);
};



/***/ }),
/* 994 */
/***/ (function(module, exports) {



/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(993);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUB_DOMAIN", function() { return SET_SUB_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOG", function() { return SET_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NAVIGATION", function() { return SET_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ENV", function() { return SET_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_URL_API", function() { return SET_URL_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_WINDOW", function() { return SET_WINDOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICE", function() { return SET_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUEST", function() { return SET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_EVENT", function() { return SET_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PCMSO", function() { return SET_PCMSO; });

var SET_SUB_DOMAIN = function SET_SUB_DOMAIN(state, sub_domain) {
	state.sub_domain = sub_domain;
};

var SET_EVENT = function SET_EVENT(state, event) {
	state.event = event;
};

var SET_LOG = function SET_LOG(state, log) {
	state.log = log;
};

var SET_PCMSO = function SET_PCMSO(state, pcmso) {
	state.pcmso = pcmso;
};

var SET_LOCATION = function SET_LOCATION(state, location) {
	state.location = location;
};

var SET_NAVIGATION = function SET_NAVIGATION(state, navigation) {
	state.navigation = navigation;
};

var SET_ENV = function SET_ENV(state, env) {
	state.env = env;
};

var SET_URL_API = function SET_URL_API(state, url_api) {
	state.url_api = url_api;
};

var SET_WINDOW = function SET_WINDOW(state, window) {
	state.window = window;
};

var SET_DEVICE = function SET_DEVICE(state, device) {
	state.device = device;
};

var SET_REQUEST = function SET_REQUEST(state, request) {
	state.request = request;
};



/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  device: 'lg',
  log: {
    request: false,
    request_error: false
  },
  window: {
    width: 0,
    height: 0
  },
  request: null,
  event: null,
  url_api: null,
  pcmso: null,
  navigation: [],
  env: {},
  sub_domain: null
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotalContato", function() { return setTotalContato; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTotalProcedimento", function() { return setTotalProcedimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCredenciada", function() { return setCredenciada; });

var setTotalContato = function setTotalContato(context, total) {
	context.commit('SET_TOTAL_CONTATO', total);
};

var setTotalProcedimento = function setTotalProcedimento(context, total) {
	context.commit('SET_TOTAL_PROCEDIMENTO', total);
};

var setCredenciada = function setCredenciada(context, credenciada) {
	context.commit('SET_CREDENCIADA', credenciada);
};



/***/ }),
/* 999 */
/***/ (function(module, exports) {



/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(998);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL_CONTATO", function() { return SET_TOTAL_CONTATO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOTAL_PROCEDIMENTO", function() { return SET_TOTAL_PROCEDIMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CREDENCIADA", function() { return SET_CREDENCIADA; });


var SET_TOTAL_CONTATO = function SET_TOTAL_CONTATO(state, total_contato) {
	state.total_contato = total_contato;
};

var SET_TOTAL_PROCEDIMENTO = function SET_TOTAL_PROCEDIMENTO(state, total_procedimento) {
	state.total_procedimento = total_procedimento;
};

var SET_CREDENCIADA = function SET_CREDENCIADA(state, credenciada) {
	state.logged = credenciada;
};



/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	total_contato: 0,
	total_procedimento: 0,
	logged: null
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmpresa", function() { return setEmpresa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPeriodico", function() { return setPeriodico; });

var setEmpresa = function setEmpresa(context, empresa) {
	context.commit('SET_EMPRESA', empresa);
};

var setPeriodico = function setPeriodico(context, periodico) {
	context.commit('SET_PERIODICO', periodico);
};



/***/ }),
/* 1004 */
/***/ (function(module, exports) {



/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1003);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_EMPRESA", function() { return SET_EMPRESA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PERIODICO", function() { return SET_PERIODICO; });


var SET_EMPRESA = function SET_EMPRESA(state, empresa) {
	state.logged = empresa;
};

var SET_PERIODICO = function SET_PERIODICO(state, periodico) {
	state.periodico = periodico;
};



/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	periodoco: null
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLtcat", function() { return setLtcat; });

var setLtcat = function setLtcat(context, ltcat) {
	context.commit('SET_LTCAT', ltcat);
};



/***/ }),
/* 1009 */
/***/ (function(module, exports) {



/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1008);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LTCAT", function() { return SET_LTCAT; });


var SET_LTCAT = function SET_LTCAT(state, ltcat) {
	state.data = ltcat;

	var title = '';

	if (ltcat && ltcat.empresa) {
		title += ltcat.empresa.nome;
	}

	if (ltcat.revisao) {
		title += ' :: ';

		if (ltcat.revisao.parent) {
			title += ltcat.revisao.parent.rev + ' (' + ltcat.revisao.parent.descricao + ') / ';
		}
		title += ltcat.revisao.rev + ' (' + ltcat.revisao.descricao + ')';
	}

	if (title) {
		title += ' :: ';
	}

	state.title = title;
};



/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	data: null,
	title: null
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUsuario", function() { return setUsuario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMenu", function() { return setMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setJwt", function() { return setJwt; });

var setUsuario = function setUsuario(context, usuario) {

	var menu = usuario && usuario.menu ? usuario.menu : [],
	    acesso_permissao = usuario && usuario.acesso_permissao ? usuario.acesso_permissao : [],
	    acesso_modulo = usuario && usuario.acesso_modulo ? usuario.acesso_modulo : [];

	context.commit('SET_USUARIO', usuario);
	context.commit('SET_MENU', menu);
	context.commit('SET_ACESSO_PERMISSAO', acesso_permissao);
	context.commit('SET_ACESSO_MODULO', acesso_modulo);
};

var setMenu = function setMenu(context, menu) {
	context.commit('SET_MENU', menu);
};

var setJwt = function setJwt(context, jwt) {
	context.commit('SET_JWT', jwt);
};



/***/ }),
/* 1014 */
/***/ (function(module, exports) {



/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1013);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USUARIO", function() { return SET_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MENU", function() { return SET_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACESSO_MODULO", function() { return SET_ACESSO_MODULO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACESSO_PERMISSAO", function() { return SET_ACESSO_PERMISSAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_JWT", function() { return SET_JWT; });
var SET_USUARIO = function SET_USUARIO(state, logged) {
	state.logged = logged;
};

var SET_MENU = function SET_MENU(state, menu) {
	state.menu = menu;
};

var SET_JWT = function SET_JWT(state, jwt) {
	state.jwt = jwt;
};

var SET_ACESSO_MODULO = function SET_ACESSO_MODULO(state, acesso_modulo) {
	state.acesso_modulo = acesso_modulo;
};

var SET_ACESSO_PERMISSAO = function SET_ACESSO_PERMISSAO(state, acesso_permissao) {
	state.acesso_permissao = acesso_permissao;
};



/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	logged: null,
	jwt: null,
	acesso_permissao: [],
	acesso_modulo: [],
	menu: []
});

/***/ }),
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.6.1.tgz","_integrity":"sha512-RaddvvMatK2LJHqFJ+YA4WysVN5Ita9E35botqIYspQ4TkRAlCicdzKOjlyv/1Za5RyTNn7di//eEV0uTAfe3g==","_from":"elliptic@6.6.1"}

/***/ }),
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 493,
	"./af.js": 493,
	"./ar": 500,
	"./ar-dz": 494,
	"./ar-dz.js": 494,
	"./ar-kw": 495,
	"./ar-kw.js": 495,
	"./ar-ly": 496,
	"./ar-ly.js": 496,
	"./ar-ma": 497,
	"./ar-ma.js": 497,
	"./ar-sa": 498,
	"./ar-sa.js": 498,
	"./ar-tn": 499,
	"./ar-tn.js": 499,
	"./ar.js": 500,
	"./az": 501,
	"./az.js": 501,
	"./be": 502,
	"./be.js": 502,
	"./bg": 503,
	"./bg.js": 503,
	"./bm": 504,
	"./bm.js": 504,
	"./bn": 505,
	"./bn.js": 505,
	"./bo": 506,
	"./bo.js": 506,
	"./br": 507,
	"./br.js": 507,
	"./bs": 508,
	"./bs.js": 508,
	"./ca": 509,
	"./ca.js": 509,
	"./cs": 510,
	"./cs.js": 510,
	"./cv": 511,
	"./cv.js": 511,
	"./cy": 512,
	"./cy.js": 512,
	"./da": 513,
	"./da.js": 513,
	"./de": 516,
	"./de-at": 514,
	"./de-at.js": 514,
	"./de-ch": 515,
	"./de-ch.js": 515,
	"./de.js": 516,
	"./dv": 517,
	"./dv.js": 517,
	"./el": 518,
	"./el.js": 518,
	"./en-SG": 519,
	"./en-SG.js": 519,
	"./en-au": 520,
	"./en-au.js": 520,
	"./en-ca": 521,
	"./en-ca.js": 521,
	"./en-gb": 522,
	"./en-gb.js": 522,
	"./en-ie": 523,
	"./en-ie.js": 523,
	"./en-il": 524,
	"./en-il.js": 524,
	"./en-nz": 525,
	"./en-nz.js": 525,
	"./eo": 526,
	"./eo.js": 526,
	"./es": 529,
	"./es-do": 527,
	"./es-do.js": 527,
	"./es-us": 528,
	"./es-us.js": 528,
	"./es.js": 529,
	"./et": 530,
	"./et.js": 530,
	"./eu": 531,
	"./eu.js": 531,
	"./fa": 532,
	"./fa.js": 532,
	"./fi": 533,
	"./fi.js": 533,
	"./fo": 534,
	"./fo.js": 534,
	"./fr": 537,
	"./fr-ca": 535,
	"./fr-ca.js": 535,
	"./fr-ch": 536,
	"./fr-ch.js": 536,
	"./fr.js": 537,
	"./fy": 538,
	"./fy.js": 538,
	"./ga": 539,
	"./ga.js": 539,
	"./gd": 540,
	"./gd.js": 540,
	"./gl": 541,
	"./gl.js": 541,
	"./gom-latn": 542,
	"./gom-latn.js": 542,
	"./gu": 543,
	"./gu.js": 543,
	"./he": 544,
	"./he.js": 544,
	"./hi": 545,
	"./hi.js": 545,
	"./hr": 546,
	"./hr.js": 546,
	"./hu": 547,
	"./hu.js": 547,
	"./hy-am": 548,
	"./hy-am.js": 548,
	"./id": 549,
	"./id.js": 549,
	"./is": 550,
	"./is.js": 550,
	"./it": 552,
	"./it-ch": 551,
	"./it-ch.js": 551,
	"./it.js": 552,
	"./ja": 553,
	"./ja.js": 553,
	"./jv": 554,
	"./jv.js": 554,
	"./ka": 555,
	"./ka.js": 555,
	"./kk": 556,
	"./kk.js": 556,
	"./km": 557,
	"./km.js": 557,
	"./kn": 558,
	"./kn.js": 558,
	"./ko": 559,
	"./ko.js": 559,
	"./ku": 560,
	"./ku.js": 560,
	"./ky": 561,
	"./ky.js": 561,
	"./lb": 562,
	"./lb.js": 562,
	"./lo": 563,
	"./lo.js": 563,
	"./lt": 564,
	"./lt.js": 564,
	"./lv": 565,
	"./lv.js": 565,
	"./me": 566,
	"./me.js": 566,
	"./mi": 567,
	"./mi.js": 567,
	"./mk": 568,
	"./mk.js": 568,
	"./ml": 569,
	"./ml.js": 569,
	"./mn": 570,
	"./mn.js": 570,
	"./mr": 571,
	"./mr.js": 571,
	"./ms": 573,
	"./ms-my": 572,
	"./ms-my.js": 572,
	"./ms.js": 573,
	"./mt": 574,
	"./mt.js": 574,
	"./my": 575,
	"./my.js": 575,
	"./nb": 576,
	"./nb.js": 576,
	"./ne": 577,
	"./ne.js": 577,
	"./nl": 579,
	"./nl-be": 578,
	"./nl-be.js": 578,
	"./nl.js": 579,
	"./nn": 580,
	"./nn.js": 580,
	"./pa-in": 581,
	"./pa-in.js": 581,
	"./pl": 582,
	"./pl.js": 582,
	"./pt": 584,
	"./pt-br": 583,
	"./pt-br.js": 583,
	"./pt.js": 584,
	"./ro": 585,
	"./ro.js": 585,
	"./ru": 586,
	"./ru.js": 586,
	"./sd": 587,
	"./sd.js": 587,
	"./se": 588,
	"./se.js": 588,
	"./si": 589,
	"./si.js": 589,
	"./sk": 590,
	"./sk.js": 590,
	"./sl": 591,
	"./sl.js": 591,
	"./sq": 592,
	"./sq.js": 592,
	"./sr": 594,
	"./sr-cyrl": 593,
	"./sr-cyrl.js": 593,
	"./sr.js": 594,
	"./ss": 595,
	"./ss.js": 595,
	"./sv": 596,
	"./sv.js": 596,
	"./sw": 597,
	"./sw.js": 597,
	"./ta": 598,
	"./ta.js": 598,
	"./te": 599,
	"./te.js": 599,
	"./tet": 600,
	"./tet.js": 600,
	"./tg": 601,
	"./tg.js": 601,
	"./th": 602,
	"./th.js": 602,
	"./tl-ph": 603,
	"./tl-ph.js": 603,
	"./tlh": 604,
	"./tlh.js": 604,
	"./tr": 605,
	"./tr.js": 605,
	"./tzl": 606,
	"./tzl.js": 606,
	"./tzm": 608,
	"./tzm-latn": 607,
	"./tzm-latn.js": 607,
	"./tzm.js": 608,
	"./ug-cn": 609,
	"./ug-cn.js": 609,
	"./uk": 610,
	"./uk.js": 610,
	"./ur": 611,
	"./ur.js": 611,
	"./uz": 613,
	"./uz-latn": 612,
	"./uz-latn.js": 612,
	"./uz.js": 613,
	"./vi": 614,
	"./vi.js": 614,
	"./x-pseudo": 615,
	"./x-pseudo.js": 615,
	"./yo": 616,
	"./yo.js": 616,
	"./zh-cn": 617,
	"./zh-cn.js": 617,
	"./zh-hk": 618,
	"./zh-hk.js": 618,
	"./zh-tw": 619,
	"./zh-tw.js": 619
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1255;

/***/ }),
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1501),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1582),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1491),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1492),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1484),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1493),
  /* scopeId */
  "data-v-45bc2e84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1452),
  /* scopeId */
  "data-v-21b13180",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1476),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1494),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1527),
  /* scopeId */
  "data-v-65d72154",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1473),
  /* scopeId */
  "data-v-34e79c0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1584),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1468),
  /* scopeId */
  "data-v-2e7b2c7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1212)
__webpack_require__(1211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1543),
  /* scopeId */
  "data-v-7a110ca9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1544),
  /* scopeId */
  "data-v-7aed02ed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1583),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1572),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1432),
  /* scopeId */
  "data-v-0568b513",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1435),
  /* scopeId */
  "data-v-0b3d88f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1586),
  /* scopeId */
  "data-v-dffd3cbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1479),
  /* scopeId */
  "data-v-3c34d7fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(1425),
  /* scopeId */
  "data-v-010fe137",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1555),
  /* scopeId */
  "data-v-8fe28994",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1430),
  /* scopeId */
  "data-v-03e57592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1522),
  /* scopeId */
  "data-v-60106157",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1496),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1570),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1458),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1579),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1489),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1429),
  /* scopeId */
  "data-v-01fc01fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1440),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1456),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(1442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('ed-modal', {
    attrs: {
      "title": 'FILTRAR RESULTADO' + ' (' + _vm.filterBadge + ')',
      "modal": _vm.showFilter,
      "onSave": _vm.handleFilter,
      "onClear": _vm.handleClear,
      "isModal": false,
      "width": "80%",
      "saveName": "Filtrar",
      "saveIcon": "fa fa-filter"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_vm._t("table-filter-content")], 2)]), _vm._v(" "), (_vm.onRegister || !_vm.disableInputSearch || !_vm.disableInputButtons) ? _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row d-flex align-items-baseline"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "table-button d-flex flex-row"
  }, [(_vm.onRegister) ? _c('ed-button', {
    staticClass: "mb-1 mr-1",
    attrs: {
      "type": "primary",
      "icon": _vm.registerIcon,
      "loading": _vm.loadingRegister,
      "value": _vm.registerName
    },
    on: {
      "click": _vm.onRegister
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("table-button")], 2)]), _vm._v(" "), (!_vm.disableInputSearch) ? _c('div', {
    class: _vm.onRegister ?
      'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' :
      'col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12'
  }, [_c('b-input-group', {
    staticClass: "mt-3"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite aqui sua pesquisa e pressione ENTER..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.formData.search),
      callback: function($$v) {
        _vm.$set(_vm.formData, "search", $$v)
      },
      expression: "formData.search"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": "Clique para relizar sua busca..."
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Buscar")])]), _vm._v(" "), (_vm.onFilter) ? _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "title": _vm.filterBadge + ' filtro(s) ativados, clique para saber mais...'
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    class: 'fa fa-filter' +
      (_vm.filterBadge > 0 ? ' faa-flash animated' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("Filtrar")])]) : _vm._e()], 1)], 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-popover', {
    ref: "deleteAll",
    attrs: {
      "placement": "top",
      "trigger": "manual"
    },
    model: {
      value: (_vm.showPopoverCheckAll),
      callback: function($$v) {
        _vm.showPopoverCheckAll = $$v
      },
      expression: "showPopoverCheckAll"
    }
  }, [_c('div', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3"
  }, [_c('b', [_vm._v("O que deseja fazer com os registro(s) selecionado(s)?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-1"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-window-close-o",
      "type": "info",
      "size": "mini",
      "title": "Calcelar",
      "value": "Cancelar"
    },
    on: {
      "click": _vm.handleSearch
    }
  }), _vm._v(" "), (_vm.onDelete && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-trash",
      "type": "danger",
      "size": "mini",
      "title": _vm.onDeleteName,
      "value": _vm.onDeleteName
    },
    on: {
      "click": _vm.handleDelete
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onEditAll && _vm.checkItem.length > 0) ? _c('ed-button', {
    attrs: {
      "icon": _vm.editAllIcon,
      "type": "warning",
      "size": "mini",
      "title": _vm.editAllTitle,
      "loading": _vm.loadingEditAll,
      "value": _vm.editAllName
    },
    on: {
      "click": _vm.handleEditAll
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), (_vm.onSearch) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "10px"
    }
  }, [_c('el-select', {
    style: ('width: ' + (this.device == 'xs' ? '100%' : '220px') + ' !important'),
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.formData.ppage),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ppage", $$v)
      },
      expression: "formData.ppage"
    }
  }, _vm._l((_vm.lstPages), function(page) {
    return _c('el-option', {
      key: page,
      attrs: {
        "label": 'Exibir ' + page + ' itens por página',
        "value": page
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.disableTableContent && _vm.loadingTable),
      expression: "disableTableContent && loadingTable"
    }],
    staticClass: "col-md-12"
  }, [(_vm.tableData.length > 0) ? _vm._t("table-export") : _vm._e(), _vm._v(" "), _vm._t("table-content"), _vm._v(" "), (!_vm.disableTableContent) ? _c('b-table', {
    ref: "selectableTable",
    staticClass: "table-v2",
    attrs: {
      "id": "table-v2",
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": _vm.response && _vm.response.status && _vm.response.status != 200 ?
        _vm.response.status + (_vm.response.msg ? ' - ' + _vm.response.msg : '') :
        _vm.emptyTable,
      "busy": _vm.loadingTable,
      "items": _vm.items,
      "fields": _vm.fields,
      "stacked": this.device == 'xs',
      "sort-by": _vm.formData.sortBy,
      "sort-desc": _vm.formData.sortDesc,
      "foot-clone": _vm.tableFooter.length > 0
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.formData, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.formData, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_vm._v("\n        " + _vm._s(data.label) + "\n        "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == true
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-desc"
        }) : _vm._e(), _vm._v(" "), (
          _vm.formData.sortBy == data.field.key && _vm.formData.sortDesc == false
        ) ? _c('i', {
          staticClass: "fa fa-sort-alpha-asc"
        }) : _vm._e(), _vm._v(" "), (data.field.info) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": data.field.info,
            "placement": "top"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-question-circle",
          attrs: {
            "aria-hidden": "true"
          }
        })])]) : _vm._e()]
      }
    }, {
      key: "foot()",
      fn: function(data) {
        return [(data.field && data.field.value != undefined) ? _c('span', [_vm._v("\n          " + _vm._s(data.field.value) + "\n        ")]) : _vm._e()]
      }
    }, {
      key: "table-busy",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center my-2",
          staticStyle: {
            "color": "var(--primary)"
          }
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _vm._v(" "), _c('strong', [_vm._v("Carregando...")])], 1)]
      },
      proxy: true
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "head(selected)",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "popover",
            rawName: "v-popover:deleteAll",
            arg: "deleteAll"
          }],
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          on: {
            "change": _vm.handleSelectAll
          },
          model: {
            value: (_vm.checkAll),
            callback: function($$v) {
              _vm.checkAll = $$v
            },
            expression: "checkAll"
          }
        })], 1)]
      }
    }, {
      key: "cell(selected)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          attrs: {
            "label": data.item._data.id
          },
          on: {
            "change": _vm.handleSelectItem
          },
          model: {
            value: (_vm.checkItem),
            callback: function($$v) {
              _vm.checkItem = $$v
            },
            expression: "checkItem"
          }
        })], 1)]
      }
    }, {
      key: "cell(tipo_status)",
      fn: function(data) {
        return [(data.item._data.tipo_status) ? _c('div', {
          style: ('color:' + data.item._data.tipo_status.cor)
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(
          data.field && data.field.show_tipo_aso && data.item._data.tipo_aso
        ) ? _c('div', [(
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              CÓD: "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), _c('span', {
          style: ('font-size: 7pt; color: #666;' + (data.item.options && data.item.options.style ? data.item.options.style : ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + "\n            ")])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_vm._v("\n              " + _vm._s(data.item._data.tipo_aso.descricao) + " " + _vm._s((data.item._data.periodicidade ? data.item._data.periodicidade + ' MESES' : '')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (
          (data.field.show_consulta_link ||
            data.field.show_link_consulta) &&
          data.item._data.id_con && data.item._data.consulta
        ) ? _c('a', {
          attrs: {
            "href": _vm.getUrlConsulta(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-calendar",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$utilidade.toDate(data.item._data.consulta.dt_cad, true)))]), _c('br')])]) : (data.field && data.field.show_empresa_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlEmpresa(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')]), _vm._v(" "), (data.field.show_fdt && data.item._data.fdt && data.item._data.fdt.pcmso) ? _c('span', {
          style: ('font-size:7pt;color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              ''))
        }, [_vm._v("\n              " + _vm._s(data.item._data.fdt.pcmso) + " (" + _vm._s(data.item._data.fdt.descricao) + ")\n            ")]) : _vm._e()])]) : (data.field && data.field.show_revisao_link && data.item._data.revisao_tipo) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/' + (data.item._data.revisao_tipo) + '.php?emp=' +
              (data.item._data.empresa ? data.item._data.empresa.id : data.item._data.empresa_id) +
              '&pcmso=' + (data.item._data.fdt ? data.item._data.fdt.id : data.item._data.fdt_id) +
              '&rev=' + (data.item._data.revisao ? data.item._data.revisao.id : data.item._data.revisao_id),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: (data.item.options && data.item.options.style ?
            ';' + data.item.options.style :
            ''),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _c('br')])])]) : (
          data.field && data.field.show_funcao && data.item._data.funcao
        ) ? _c('div', [(data.field.show_funcionario_link) ? _c('a', {
          attrs: {
            "href": _vm.getUrlFuncionario(data.item._data),
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          style: ((data.item.options && data.item.options.style ? data.item.options.style : '')),
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])]) : _c('span', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n                " + _vm._s(data.item._data.funcao.nome) + "\n              ")])])])]) : (data.field && data.field.show_financeiro_link) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.env.url_cs +
              '/app/financeiro_rel.php?cod_tp=0&cod_n=' +
              data.value,
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])])]) : (
          data.field && data.field.show_lote_link && data.item._data
        ) ? _c('div', [_c('a', {
          attrs: {
            "href": _vm.getUrlLote(data.item._data),
            "target": "_blank"
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })])])]) : (
          data.field && data.field.show_user && data.item._data.usuario
        ) ? _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            '')
        }, [_vm._v("\n          " + _vm._s(data.value)), _c('br'), _vm._v(" "), _c('span', {
          style: ('font-size:7pt' +
            (data.item.options && data.item.options.style ?
              data.item.options.style :
              ''))
        }, [_vm._v("\n            " + _vm._s(data.item._data.usuario.usuario) + "\n          ")])]) : (data.field && data.field.show_arquivo) ? _c('div', [(data.value && data.value.id) ? _c('Download', {
          attrs: {
            "arquivo": data.value
          }
        }) : _c('span', [_vm._v("---")])], 1) : (data.field && data.field.show_input) ? _c('div', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'number') ? _c('el-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()], 1) : (data.field && data.field.show_point) ? _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n          "), (
          data.item._data.log_acesso.usuario &&
          data.item._data.log_acesso.usuario.point
        ) ? _c('span', {
          staticStyle: {
            "font-size": "7pt",
            "color": "#666"
          }
        }, [_c('br'), _vm._v(_vm._s(data.item._data.log_acesso.usuario.point.nome) + "\n          ")]) : _vm._e()]) : (
          data.field &&
          data.field.show_status &&
          data.item._data.tipo_status
        ) ? _c('div', [_c('span', {
          style: ('color:' + data.item._data.tipo_status.cor),
          attrs: {
            "title": data.value
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : data.value
          }
        }, [(data.item._data.tipo_status.icon) ? _c('i', {
          class: data.item._data.tipo_status.icon
        }) : _vm._e(), _vm._v("\n              " + _vm._s(data.item._data.tipo_status.descricao) + "\n            ")])])]) : (
          data.field && data.field.show_rea && data.item._data.id_con_rea
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-rea",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" da consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_rea))]), _vm._v(" "), (data.item._data.con_rea_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_rea_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_dem && data.item._data.id_con_dem
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticClass: "tp-exame-dem",
          staticStyle: {
            "font-size": "9pt"
          },
          attrs: {
            "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
          }
        }, [_vm._v("\n            Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta\n            "), _c('label', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(data.item._data.id_con_dem))]), _vm._v(" "), (data.item._data.con_dem_dt) ? _c('span', [_vm._v("\n              em " + _vm._s(_vm.toDate(data.item._data.con_dem_dt, true)) + "\n            ")]) : _vm._e()])]) : (
          data.field && data.field.show_alt && data.item._data.alt == '1'
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          staticStyle: {
            "color": "#c64747"
          },
          attrs: {
            "title": "Esse exame teve resultado alterado e deverá ser refeito no próximo periódico."
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n            " + _vm._s(data.value) + "\n          ")])]) : (
          data.field && data.field.show_parceiro && data.item._data.parceiro
        ) ? _c('div', [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [_vm._v("\n            " + _vm._s(data.value)), _c('br')]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "9pt",
            "color": "#c4c4c4"
          },
          attrs: {
            "title": "Parceiro que o exame será efetuado"
          }
        }, [_vm._v("\n            " + _vm._s(data.item._data.parceiro.nome) + "\n          ")])]) : (data.field && data.field.show_json) ? _c('div', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 text-center mt-2"
        }, [_c('b', [_vm._v("Detalhes")])]), _vm._v(" "), _vm._l((data.value), function(value, field, i) {
          return _c('div', {
            key: i,
            staticClass: "col-md-12"
          }, [_c('b', [_vm._v(_vm._s(field) + ": ")]), _vm._v(" "), (field == 'exame' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'parceiro' && value && value.nome) ? _c('span', [_vm._v("\n                  " + _vm._s(value.nome) + "\n                ")]) : (field == 'created_at' || field == 'updated_at') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.toDate(value)) + "\n                ")]) : (field == 'bl_his' || field == 'bl_his') ? _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.base64Decode(value))
            }
          })]) : _c('span', [_vm._v("\n                  " + _vm._s(value) + "\n                ")])])
        })], 2), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                Ver mais...\n              ")])], 1)])], 1) : (data.field && data.field.show_html) ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })]) : (data.field && data.field.show_colapse) ? _c('div', [(!data.value) ? _c('span', [_vm._v("---")]) : _c('el-collapse', {
          attrs: {
            "title": "Clique para mostrar mais informações"
          },
          model: {
            value: (data.item._data[data.field.key].collapse),
            callback: function($$v) {
              _vm.$set(data.item._data[data.field.key], "collapse", $$v)
            },
            expression: "data.item._data[data.field.key].collapse"
          }
        }, [_c('el-collapse-item', {
          attrs: {
            "name": data.item._data.id.toString() + data.field.key
          }
        }, [_c('template', {
          slot: "title"
        }, [(
          data.item._data[data.field.key].collapse &&
          data.item._data[data.field.key].collapse[0]
        ) ? _c('i', {
          staticClass: "fa fa-minus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        }) : _c('i', {
          staticClass: "fa fa-plus-circle fa-1x",
          staticStyle: {
            "color": "#28a745"
          }
        })]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "7pt"
          },
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })], 2)], 1)], 1) : _c('div', {
          style: (data.item.options && data.item.options.style ?
            data.item.options.style :
            ''),
          attrs: {
            "title": data.item.options && data.item.options.title ?
              data.item.options.title :
              null
          }
        }, [_c('span', {
          class: data.item._data.deleted_at ? 'deleted' : '',
          attrs: {
            "title": data.item._data.deleted_at ? 'Registro excluído' : ''
          }
        }, [(
          data.field.limit &&
          data.field.limit < _vm.toString(data.value).length
        ) ? _c('span', [_c('el-popover', {
          attrs: {
            "placement": "top",
            "trigger": "click"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 p-5"
        }, [_vm._v("\n                    " + _vm._s(data.value) + "\n                  ")])]), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('b-link', [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v("\n                    Ver mais...\n                  ")])], 1)])], 1) : _c('span', [(
          data.item &&
          data.item._data &&
          ((_vm.onEditAll &&
              _vm.checkItem.indexOf(data.item._data.id) != -1) ||
            _vm.editableRows)
        ) ? _c('span', [(data.field.edit == 'money') ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field.edit == 'text') ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (
          data.field.edit == 'select-custom' &&
          _vm.config.click &&
          _vm.config.click[data.field.key] &&
          _vm.config.list &&
          _vm.config.list[data.field.key]
        ) ? _c('el-select', {
          attrs: {
            "loading": _vm.config.loading[data.field.key],
            "placeholder": 'Pesquisar...',
            "filterable": "",
            "remote": "",
            "remote-method": _vm.config.click[data.field.key],
            "value-key": "id"
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.config.list[data.field.key]), function(val, j) {
          return _c('el-option', {
            key: j,
            attrs: {
              "label": val.nome,
              "value": val.id
            }
          })
        }), 1) : _c('span', [_vm._v("\n                  " + _vm._s(data.value) + "\n                ")])], 1) : _c('span', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        }), _vm._v(" "), (
          data.field && data.field.show_cnpj && data.item._data.cnpj
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CNPJ"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-credit-card-alt",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cnpj) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field && data.field.show_cpf && data.item._data.cpf
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "CPF"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-address-card",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.cpf) + "\n                ")]) : _vm._e(), _vm._v(" "), (
          data.field &&
          data.field.show_telefone &&
          _vm.onlyNumber(data.item._data.telefone)
        ) ? _c('span', {
          style: ('color:#666' +
            (data.item.options && data.item.options.style ?
              ';' + data.item.options.style :
              '')),
          attrs: {
            "title": "Telefone"
          }
        }, [_c('br'), _vm._v(" "), _c('i', {
          staticClass: "fa fa-phone-square",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                  " + _vm._s(data.item._data.telefone) + "\n                ")]) : _vm._e()])])])])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-center tbutton"
        }, [(
          _vm.onEdit &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_edit))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-pencil-square-o",
            "type": "primary",
            "size": "mini",
            "title": "Editar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(data.item._data)
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm._l((data.value), function(button, i) {
          return _c('ed-button', {
            key: i,
            staticStyle: {
              "margin": "2px"
            },
            style: (button.style),
            attrs: {
              "icon": button.icon,
              "type": button.color,
              "size": "mini",
              "title": button.title,
              "disabled": !!button.disabled
            },
            on: {
              "click": function($event) {
                button.click ? button.click(data.item._data) : null
              }
            }
          })
        }), _vm._v(" "), (
          _vm.onDelete &&
          (!data.item.options ||
            (data.item.options && !data.item.options.disable_delete))
        ) ? _c('ed-button', {
          staticStyle: {
            "margin": "2px"
          },
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": _vm.onDeleteName
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(data.item._data)
            }
          }
        }) : _vm._e()], 2)]
      }
    }], null, false, 274876559)
  }) : _vm._e(), _vm._v(" "), (_vm.pagination && _vm.pagination.total && _vm.pagination.total > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Número do Protocolo",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.busca),
      callback: function($$v) {
        _vm.$set(_vm.formData, "busca", $$v)
      },
      expression: "formData.busca"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "loading": _vm.loading,
      "disabled": !_vm.formData.id_emp || !_vm.formData.busca ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.erro) ? _c('div', {
    staticClass: "consulta-esocial-erro"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.erro))])]) : _vm._e(), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.busca))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.empresa))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Consultado em")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.data))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": "900px",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(!_vm.loading && _vm.historico.length === 0) ? _c('el-alert', {
    attrs: {
      "title": "Nenhuma notificação de WhatsApp foi enviada.",
      "type": "info",
      "show-icon": "",
      "closable": false
    }
  }) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historico,
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.descricaoTemplate(scope.row.template)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Telefone",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.telefone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.corStatus(scope.row.status),
            "size": "mini"
          }
        }, [_vm._v(_vm._s(scope.row.status.toUpperCase()))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Agendado para"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.agendado_para ? _vm.toDate(scope.row.agendado_para) : "---"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Enviado em"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.enviado_em ? _vm.toDate(scope.row.enviado_em) : "---"))]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": this.$store.state.ltcat.title + 'Gerar Novo Orçamento',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.parent.formData.id == 0 ? 'Nova Categoria' : 'Editar Categoria ' + _vm.parent.formData.nome + ' :: ' + _vm.tabela.nome,
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.parent.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(_vm.noTenant) ? _c('Erro500', {
    attrs: {
      "erro": _vm.noTenant
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.$route.meta.disablePageHeader && !_vm.loadingContent && _vm.$root.$session.usuario.logged && _vm.$root.$session.usuario.logged.point) ? _c('div', [_c('EmpresaHeader')], 1) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [(!_vm.$route.meta.disablePageHeader) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.meta.title.toUpperCase()))]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": this.$root.$session.navigation
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent && _vm.$root.$session.cliente.logged) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('EmpresaFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormList) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFormList = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Lote " + _vm._s(_vm.parent.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFormList = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [(_vm.parent.formData.lote) ? _c('eSocial', {
    key: _vm.formData.id + '-' + (_vm.showForm ? 1 : 0),
    attrs: {
      "layout": _vm.parent.formData.layout,
      "lote": _vm.parent.formData.lote,
      "avulso": _vm.parent.formData.avulso ? _vm.parent.formData.avulso : 0
    }
  }) : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ?
        'Novo GHE' :
        this.$store.state.ltcat.title +
        _vm.formData.ghe +
        ' (' +
        _vm.formData.descricao +
        ')',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": _vm.tagConfig == 'tab-cadastro' ? this.salvar : null,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Medições (" + _vm._s(_vm.formData.medicoes.length) + ")\n          ")]), _vm._v(" "), _c('Medicao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica (" + _vm._s(_vm.formData.conclusoes.length) + ")\n          ")]), _vm._v(" "), _c('ConclusaoTecnica', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Funções (" + _vm._s(_vm.formData.funcoes.length) + ")\n          ")]), _vm._v(" "), _c('Funcao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcionarios"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Funcionário (" + _vm._s(_vm.formData.funcionarios.length) + ")\n          ")]), _vm._v(" "), _c('Funcionario', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormRegister) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeRegister($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Enviar Novo Email Lote " + _vm._s(_vm.parent.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.closeRegister
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "esocial-modal__form-no-info"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__hint"
  }, [_vm._v(_vm._s(_vm.formItems[0] && _vm.formItems[0].info))]), _vm._v(" "), (_vm.emailsValidos.length) ? _c('div', {
    staticClass: "esocial-modal__preview"
  }, [_c('span', {
    staticClass: "esocial-modal__preview-label"
  }, [_vm._v(_vm._s(_vm.emailsValidos.length) + " destinatário(s) válido(s)")]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__preview-chips"
  }, _vm._l((_vm.emailsValidos), function(email, i) {
    return _c('span', {
      key: i,
      staticClass: "esocial-modal__chip"
    }, [_vm._v(_vm._s(email))])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-modal__btn esocial-modal__btn--secondary",
    on: {
      "click": _vm.abrirPreviewEmail
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Ver preview do email\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__btn esocial-modal__btn--primary",
    attrs: {
      "disabled": _vm.config.loading.save
    },
    on: {
      "click": _vm.salvar
    }
  }, [(_vm.config.loading.save) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n            Enviar\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showPreview) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePreview($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Preview do Email Lote " + _vm._s(_vm.parent.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.closePreview
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingPreview),
      expression: "loadingPreview"
    }],
    staticClass: "esocial-modal__body esocial-modal__body--preview"
  }, [(_vm.previewHtml) ? _c('iframe', {
    staticClass: "esocial-modal__preview-frame",
    attrs: {
      "srcdoc": _vm.previewHtml
    }
  }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormList) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeList($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Emails Lote " + _vm._s(_vm.parent.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.closeList
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "esocial-modal__actions"
  }, [_c('button', {
    staticClass: "esocial-modal__btn esocial-modal__btn--primary",
    on: {
      "click": _vm.onRegister
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo Email\n            ")])]), _vm._v(" "), _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "search": _vm.search,
      "onSearch": _vm.getLog,
      "disableCheckAll": "",
      "emptyText": "Nenhum email enviado para este lote ainda."
    }
  })], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.boolExibirConsultaProtocolo) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.boolExibirConsultaProtocolo = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Consultar Informações no eSocial")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.boolExibirConsultaProtocolo = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('ed-alert', {
    staticClass: "mb-3"
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n              Escolha abaixo o que gostaria de consultar diretamente no webservice do eSocial. Essas consultas usam o\n              certificado digital da empresa e podem demorar alguns segundos.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs esocial-tabs--consulta"
  }, [_c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.tabSelected == 'tab-consulta-protocolo'
    },
    on: {
      "click": function($event) {
        _vm.tabSelected = 'tab-consulta-protocolo'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  }), _vm._v(" "), _c('span', [_vm._v("Situação do Protocolo")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.tabSelected == 'tab-consulta-recibo'
    },
    on: {
      "click": function($event) {
        _vm.tabSelected = 'tab-consulta-recibo'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Informações do Recibo")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.tabSelected == 'tab-consulta-evento-empresa'
    },
    on: {
      "click": function($event) {
        _vm.tabSelected = 'tab-consulta-evento-empresa'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v(" "), _c('span', [_vm._v("Eventos do Empregador")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.tabSelected == 'tab-consulta-evento-trabalhador'
    },
    on: {
      "click": function($event) {
        _vm.tabSelected = 'tab-consulta-evento-trabalhador'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o"
  }), _vm._v(" "), _c('span', [_vm._v("Eventos do Trabalhador")])])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs-panel"
  }, [_c('consulta-protocolo', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSelected == 'tab-consulta-protocolo'),
      expression: "tabSelected == 'tab-consulta-protocolo'"
    }],
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  }), _vm._v(" "), _c('consulta-recibo', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSelected == 'tab-consulta-recibo'),
      expression: "tabSelected == 'tab-consulta-recibo'"
    }],
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  }), _vm._v(" "), _c('consulta-evento-empresa', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSelected == 'tab-consulta-evento-empresa'),
      expression: "tabSelected == 'tab-consulta-evento-empresa'"
    }],
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  }), _vm._v(" "), _c('consulta-evento-trabalhador', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSelected == 'tab-consulta-evento-trabalhador'),
      expression: "tabSelected == 'tab-consulta-evento-trabalhador'"
    }],
    attrs: {
      "lstEmpresa": _vm.lstEmpresa,
      "loadingEmpresa": _vm.loadingEmpresa,
      "loadingFuncionario": _vm.loadingFuncionario
    }
  })], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('GerarLote', {
    attrs: {
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('Agendamento', {
    attrs: {
      "showForm": _vm.showAgendamento
    }
  }), _vm._v(" "), _c('EmailLote', {
    attrs: {
      "parent": this,
      "showForm": _vm.showFormEmail
    }
  }), _vm._v(" "), _c('Item', {
    attrs: {
      "showForm": _vm.showFormItem
    }
  }), _vm._v(" "), _c('Processar', {
    attrs: {
      "formData": _vm.formData,
      "showForm": _vm.showFormProcessar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "esocial-toolbar"
  }, [_c('div', {
    staticClass: "esocial-toolbar__actions"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--primary",
    on: {
      "click": _vm.onRegister
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Gerar Novo Lote\n      ")]), _vm._v(" "), (_vm.$root.$session.validarPacote(30)) ? _c('button', {
    staticClass: "esocial-search__btn",
    on: {
      "click": function($event) {
        _vm.boolExibirConsultaProtocolo = !_vm.boolExibirConsultaProtocolo
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Consultar Informações\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs"
  }, [_c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': !_vm.formFilter.layout
    },
    on: {
      "click": function($event) {
        return _vm.onLayoutTab(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', [_vm._v("Todos")])]), _vm._v(" "), _vm._l((_vm.lstLayout), function(tabela) {
    return _c('div', {
      key: tabela.id,
      staticClass: "esocial-tabs__item",
      class: {
        'is-active': _vm.formFilter.layout == tabela.codigo
      },
      on: {
        "click": function($event) {
          return _vm.onLayoutTab(tabela.codigo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-code-o"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(tabela.codigo))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "esocial-search"
  }, [_c('div', {
    staticClass: "esocial-search__group"
  }, [_c('div', {
    staticClass: "esocial-search__input"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar por Lote, Empresa..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getEsocialLotes(_vm.search, 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--attached",
    on: {
      "click": function($event) {
        return _vm.getEsocialLotes(_vm.search, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.showFilterModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n        "), (_vm.filterBadge > 0) ? _c('span', {
    staticClass: "esocial-search__badge"
  }, [_vm._v(_vm._s(_vm.filterBadge))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn",
    attrs: {
      "title": "Rotinas Automáticas"
    },
    on: {
      "click": function($event) {
        _vm.showAgendamento = !_vm.showAgendamento
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])]), _vm._v(" "), _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "search": _vm.search,
      "onSearch": _vm.getEsocialLotes,
      "onDelete": _vm.onDelete
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFilterModal) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFilterModal = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Filtrar Resultado")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formFilter
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formFilter.id_empresa),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "id_empresa", $$v)
      },
      expression: "formFilter.id_empresa"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Trabalhador",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formFilter.id_funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "id_funcionario", $$v)
      },
      expression: "formFilter.id_funcionario"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn",
    on: {
      "click": function($event) {
        _vm.onClearFilter();
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Limpar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.getEsocialLotes(_vm.search, 1);
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n          ")])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.text
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormEdit) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Gerar Novo Lote")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "esocial-modal__body"
  }, [_c('ed-alert', {
    staticClass: "mb-3"
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n            O sistema já faz esta verificação diariamente e cria os lotes necessários. Use esse formulário só se\n            quiser forçar a geração agora, para uma empresa/layout específico.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-section"
  }, [_c('div', {
    staticClass: "gerar-lote-section__title"
  }, [_vm._v("Obrigatório")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Empresa",
      "placeholder": "Pesquisar empresa",
      "items": _vm.config.list.id_emp,
      "loading": _vm.config.loading.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Layout",
      "placeholder": "Pesquisar layout",
      "items": _vm.config.list.layout,
      "loading": _vm.config.loading.layout,
      "itemText": "esocial",
      "is-object": "",
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getLayout
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-section"
  }, [_c('button', {
    staticClass: "gerar-lote-section__toggle",
    on: {
      "click": function($event) {
        _vm.showFiltros = !_vm.showFiltros
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.showFiltros ? 'fa-chevron-up' : 'fa-chevron-down'
  }), _vm._v("\n            Filtros opcionais\n            "), (_vm.totalFiltrosAtivos) ? _c('span', {
    staticClass: "gerar-lote-section__badge"
  }, [_vm._v(_vm._s(_vm.totalFiltrosAtivos))]) : _vm._e()]), _vm._v(" "), (_vm.showFiltros) ? _c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.config.list.id_fdt,
      "loading": _vm.config.loading.id_fdt,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "itemText": "fdt",
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.fdts),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fdts", $$v)
      },
      expression: "formData.fdts"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Funcionário",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios", $$v)
      },
      expression: "formData.funcionarios"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de cadastro do arquivo",
      "type": "daterange",
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout
    },
    model: {
      value: (_vm.formData.created_at),
      callback: function($$v) {
        _vm.$set(_vm.formData, "created_at", $$v)
      },
      expression: "formData.created_at"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Não incluir os seguintes funcionários",
      "items": _vm.config.list.id_fun,
      "loading": _vm.config.loading.id_fun,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": "",
      "multiple": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.funcionarios_delete),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionarios_delete", $$v)
      },
      expression: "formData.funcionarios_delete"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0",
    attrs: {
      "label": "Somente eventos avulsos",
      "items": [{
        id: 1,
        nome: 'Sim'
      }, {
        id: 0,
        nome: 'Não'
      }],
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout,
      "clearable": ""
    },
    model: {
      value: (_vm.formData.avulso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "avulso", $$v)
      },
      expression: "formData.avulso"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.resultado) ? _c('div', {
    staticClass: "gerar-lote-resultado"
  }, [_c('div', {
    staticClass: "gerar-lote-resultado__icon",
    class: _vm.resultado.total_lotes ? 'is-success' : 'is-empty'
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.resultado.total_lotes ? 'fa-check-circle' : 'fa-info-circle'
  })]), _vm._v(" "), _c('div', {
    staticClass: "gerar-lote-resultado__content"
  }, [(_vm.resultado.total_lotes) ? _c('b', [_vm._v("\n              " + _vm._s(_vm.resultado.total_lotes) + " lote(s) gerado(s) com " + _vm._s(_vm.resultado.total_eventos) + " evento(s).\n            ")]) : _c('b', [_vm._v("Nenhum lote gerado.")]), _vm._v(" "), (_vm.resultado.msg) ? _c('span', [_vm._v(_vm._s(_vm.resultado.msg))]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-modal__btn esocial-modal__btn--primary",
    attrs: {
      "disabled": _vm.config.loading.save
    },
    on: {
      "click": _vm.salvar
    }
  }, [(_vm.config.loading.save) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n          Gerar Lote\n        ")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-token-step"
  }, [_c('h2', {
    staticClass: "aso-token-step__title"
  }, [_vm._v("Digite o código que enviamos por e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-token-step__text"
  }, [_vm._v("\n    Ele foi enviado para "), _c('strong', [_vm._v(_vm._s(_vm.email))]), _vm._v(". Se não o encontrar, confira sua caixa de spam ou\n    "), _c('button', {
    staticClass: "aso-token-step__link",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('change-email')
      }
    }
  }, [_vm._v("\n      altere seu e-mail\n    ")]), _vm._v(".\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-token-step__grid"
  }, _vm._l((_vm.values), function(value, index) {
    return _c('input', {
      key: index,
      ref: 'tokenDigit' + index,
      refInFor: true,
      staticClass: "aso-token-step__digit",
      attrs: {
        "data-token-index": index,
        "data-token-type": "email",
        "type": "text",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "maxlength": "1",
        "disabled": _vm.busy
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function($event) {
          return _vm.$emit('digit-input', {
            index: index,
            value: $event.target.value
          })
        },
        "keydown": [function($event) {
          return _vm.$emit('digit-keydown', {
            index: index,
            key: $event.key
          })
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.canConfirm && _vm.$emit('confirm')
        }],
        "paste": function($event) {
          index === 0 ? _vm.$emit('paste', $event) : null
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__confirm aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canConfirm
    },
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Validando...' : 'Confirmar Código') + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__resend aso-flow-button aso-flow-button--quiet aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canResend
    },
    on: {
      "click": function($event) {
        return _vm.$emit('resend')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.resendLabel) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "isModal": false,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "pagination": _vm.paginationExame,
      "response": _vm.response,
      "loadingTable": _vm.loadingTableExame,
      "onSearch": _vm.getExame,
      "disableCheckAll": "",
      "disableInputSearch": "",
      "disabledConfigCell": ""
    }
  })], 1)]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 10 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadingContent) ? _c('div', {
    staticClass: "row d-flex justify-content-center",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-md-offset-4"
  }, [_c('b-card', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tAcesso Restrito\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ed-modal', {
    attrs: {
      "title": "Recuperar Senha",
      "modal": _vm.showModal,
      "width": "50%",
      "onSave": _vm.recuperarSenha,
      "loadingSave": _vm.loadingRecuperarSenha,
      "saveName": "Recuperar Senha"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.resetitens
    }
  })], 1)]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.loginItens
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-sign-in",
      "type": "primary",
      "loading": _vm.loadingSave,
      "value": "Entrar"
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }, [_vm._v("Esqueci Minha Senha")])])], 1)])])], 1)])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": Number(item.id)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": (_vm.device == 'xs' ? '97%' : _vm.width),
      "close-on-press-escape": _vm.closeESC,
      "close-on-click-modal": _vm.closeCLICK,
      "modal": _vm.isModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": _vm.handlerClose
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.toUpperCase()) + "\n    ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.onSave && !_vm.isCurrentTabHistorico) ? _c('ed-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave,
      "disabled": _vm.disabledSave,
      "icon": _vm.saveIcon,
      "value": _vm.saveName
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onClear) ? _c('ed-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-refresh",
      "value": "Limpar"
    },
    on: {
      "click": _vm.onClear
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-window-close",
      "value": "Fechar"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('div', {}, [_c('div', {}, [_c('b-form-file', {
    ref: 'file-input-' + this.name,
    attrs: {
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "placeholder": "Escolher arquivo...",
      "drop-placeholder": "Apagar arquivo...",
      "browse-text": "Procurar..."
    },
    on: {
      "change": _vm.onChangeFile
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function(ref) {
        var names = ref.names;

        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))]), _vm._v(" "), (names.length > 1) ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("\n           + " + _vm._s(names.length - 1) + " More files\n         ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), (_vm.currentFile != null) ? _c('div', {
    staticClass: "arquivo-info"
  }, [_c('Download', {
    attrs: {
      "arquivo": _vm.currentFile
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabConfig),
      callback: function($$v) {
        _vm.tabConfig = $$v
      },
      expression: "tabConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v("\n\t\t\t\tInformações da Consulta\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row p-1"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0 border-right-0"
  }, [_c('b', [_vm._v("Cód")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.id) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Funcionário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("CPF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.cpf) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Função")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border  border-right-0"
  }, [_c('b', [_vm._v("Tipo da Consulta")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.tipo_aso.descricao) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-exame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v("\n\t\t\t\tInformações dos Exames\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    }
  }, [_vm._v("Exame")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _vm._l((_vm.consulta.exames), function(exame) {
    return _c('tr', {
      key: exame.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(exame.exame.nome) + "\n\t\t\t\t\t\t"), (exame.id_con_rea) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame reaproveitado na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_rea))]), _vm._v(" em " + _vm._s(_vm.toDate(exame.data, true)) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (exame.id_con_dem) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame demonstrativo na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_dem))])]) : _vm._e(), _vm._v(" "), (!exame.pcmso_exame) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v("Exame não encontrado no PCMSO")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : _vm.toDate(exame.data, true))) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : exame.valor)) + "\n\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n\t\t\t\tInformações dos Riscos\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Risco")])]), _vm._v(" "), _vm._l((_vm.consulta.riscos), function(risco) {
    return _c('tr', {
      key: risco.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : (risco.categoria) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.nome) + "\n\t\t\t\t\t\t")]) : (risco.nome) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.nome) + "\n\t\t\t\t\t\t")]) : _vm._e()])])
  })], 2)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [(_vm.formData.consulta) ? _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    }
  }, [_vm._v("Exame")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _vm._l((_vm.formData.consulta.exames), function(exame) {
    return _c('tr', {
      key: exame.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n          " + _vm._s(exame.exame.nome) + "\n          "), (exame.consulta_rea) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n            Exame reaproveitado na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.consulta_rea.id_con))]), _vm._v(" em " + _vm._s(_vm.toDate(exame.consulta_rea.dt_cad, true)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n          " + _vm._s((exame.consulta_rea ? '---' : _vm.toDate(exame.dt_cad, true))) + "\n        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s((exame.consulta_rea ? '---' : exame.valor)))])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 5 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onEditAll": _vm.onEditAll,
      "onSearch": _vm.getRiscoLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "config": _vm.config,
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Medição' : 'Editar Medição',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "ltcat-medicao",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações Gerais\n        ")]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Replicar Medição para os Seguintes GHE",
      "items": _vm.config.list.replicar,
      "multiple": ""
    },
    model: {
      value: (_vm.formData.replicar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "replicar", $$v)
      },
      expression: "formData.replicar"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Fator de Risco",
      "name": "id_tab.id",
      "items": _vm.config.list.id_age,
      "remote": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFatorRisco
    },
    model: {
      value: (_vm.formData.id_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_age", $$v)
      },
      expression: "formData.id_age"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Tabela Dinâmica",
      "name": "id_age.id",
      "items": _vm.config.list.id_tab,
      "itemText": "tabela_dinamica",
      "is-object": ""
    },
    model: {
      value: (_vm.formData.id_tab),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_tab", $$v)
      },
      expression: "formData.id_tab"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Nº de Amostragens Necessárias por Ponto",
      "type": "number"
    },
    model: {
      value: (_vm.formData.amostragem),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amostragem", $$v)
      },
      expression: "formData.amostragem"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Data Medição"
    },
    model: {
      value: (_vm.formData.data_medicao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_medicao", $$v)
      },
      expression: "formData.data_medicao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Equipamentos\n        ")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('ed-alert', [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('a', {
    attrs: {
      "href": "http://caepi.mte.gov.br/internet/ConsultaCAInternet.aspx",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Clique aqui para consultar a lista de CA\n                      ")])])])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0 text-left ",
    attrs: {
      "label": "Pesquisar Equipamento",
      "placeholder": "Digite o nome do EPI",
      "items": _vm.config.list.epi,
      "loading": _vm.config.loading.epi,
      "itemText": "epi",
      "maxLenght": "10",
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEquipamento,
      "input": _vm.addEPI
    },
    model: {
      value: (_vm.formData.epi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "epi", $$v)
      },
      expression: "formData.epi"
    }
  })], 1)])]), _vm._v(" "), (_vm.formData.equipamentos && _vm.formData.equipamentos.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("EPI")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Med. Protecao \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi tentada a implementação de medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo EPI por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Cond. Funcionamento \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foram observadas as condições de funcionamento do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Uso Ininterrupto \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o uso ininterrupto do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Validade \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o prazo de validade do CA no momento da compra do EPI?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Troca \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais, comprovada mediante recibo assinado pelo usuário em época própria?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("\n                  Higienização\n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a higienização conforme orientação do fabricante nacional ou importador?"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.formData.equipamentos), function(equipamento, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_vm._v("\n                " + _vm._s(equipamento.epi.nome) + "\n                \n                "), (equipamento.epi.ca) ? _c('span', [_c('br'), _c('b', [_vm._v("CA:")]), _vm._v(" " + _vm._s(equipamento.epi.ca) + "\n                ")]) : _vm._e(), _vm._v(" "), (equipamento.epi.categoria) ? _c('span', [_c('br'), _c('b', [_vm._v("Categoria:")]), _vm._v(" " + _vm._s(equipamento.epi.categoria.nome) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "medProtecao"
      },
      model: {
        value: (equipamento.medProtecao),
        callback: function($$v) {
          _vm.$set(equipamento, "medProtecao", $$v)
        },
        expression: "equipamento.medProtecao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "condFuncto"
      },
      model: {
        value: (equipamento.condFuncto),
        callback: function($$v) {
          _vm.$set(equipamento, "condFuncto", $$v)
        },
        expression: "equipamento.condFuncto"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "usoInint"
      },
      model: {
        value: (equipamento.usoInint),
        callback: function($$v) {
          _vm.$set(equipamento, "usoInint", $$v)
        },
        expression: "equipamento.usoInint"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "przValid"
      },
      model: {
        value: (equipamento.przValid),
        callback: function($$v) {
          _vm.$set(equipamento, "przValid", $$v)
        },
        expression: "equipamento.przValid"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "periodicTroca"
      },
      model: {
        value: (equipamento.periodicTroca),
        callback: function($$v) {
          _vm.$set(equipamento, "periodicTroca", $$v)
        },
        expression: "equipamento.periodicTroca"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "higienizacao"
      },
      model: {
        value: (equipamento.higienizacao),
        callback: function($$v) {
          _vm.$set(equipamento, "higienizacao", $$v)
        },
        expression: "equipamento.higienizacao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-times",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEPI(index)
        }
      }
    })], 1)])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          INFORMAÇÕES DA MEDIÇÃO\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.lancamentos),
      expression: "config.loading.lancamentos"
    }],
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.formData.id_tab) ? _c('div', {}, _vm._l((_vm.config.list.lancamentos), function(coluna, i) {
    return _c('div', {
      key: i,
      staticClass: "col-12 text-left p-0 mb-2"
    }, [(_vm.showCategoria(coluna, i)) ? _c('div', {
      style: ('font-weight: bold;')
    }, [(coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.tabela_categoria.nome) + "\n                ")]) : (!coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 217) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-plus-circle",
        "type": "text",
        "value": "Inserir Nova Linha"
      },
      on: {
        "click": function($event) {
          return _vm.onInserirLinha(coluna, i)
        }
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: 'col-12 p-0 mt-1 mb-1'
    }, [(
      coluna.tipo_campo.id == 208 || coluna.tipo_campo.id == 216
    ) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (coluna.mascara ? coluna.mascara : ''),
        expression: "coluna.mascara ? coluna.mascara : ''"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 215) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 209) ? _c('el-input-number', {
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('el-select', {
      attrs: {
        "clearable": true,
        "placeholder": "Selecione"
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, _vm._l((coluna.tabela_valores), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1) : _vm._e()], 1), _vm._v(" "), (
      coluna.tabela_valores.length > 0 &&
      coluna.tipo_campo.id != 210
    ) ? _c('div', {
      staticClass: "row"
    }, _vm._l((coluna.tabela_valores), function(coluna_val, j) {
      return _c('div', {
        key: i + j,
        class: 'col-' +
          12 / coluna.tabela_valores.length +
          ' text-left mb-2'
      }, [_vm._v("\n                  " + _vm._s(coluna_val.nome) + "\n                  "), (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        (coluna_val.tipo_campo.id == 208 ||
          coluna_val.tipo_campo.id == 216)
      ) ? _c('el-input', {
        attrs: {
          "type": coluna_val.tipo_campo ?
            coluna_val.tipo_campo.valor :
            'text'
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 215
      ) ? _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 209
      ) ? _c('el-input-number', {
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((coluna_val.linhas), function(coluna_val_lin, k) {
        return _c('div', {
          key: i + j + k,
          class: 'col-12 text-left p-0 mt-2'
        }, [(j == 0 && k > 0) ? _c('span', [_c('el-link', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.onDeleteLinha(coluna, k)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v("\n                        Remover Linha\n                      ")])], 1) : (k > 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (
          coluna_val_lin.tipo_campo &&
          (coluna_val_lin.tipo_campo.id == 208 ||
            coluna_val_lin.tipo_campo.id == 216)
        ) ? _c('el-input', {
          attrs: {
            "type": coluna_val_lin.tipo_campo ?
              coluna_val_lin.tipo_campo.valor :
              'text'
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 215
        ) ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 209
        ) ? _c('el-input-number', {
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }) : _vm._e()], 1)
      })], 2)
    }), 0) : _vm._e(), _vm._v(" "), (
      _vm.response.status == 400 &&
      _vm.response.options.data[0] &&
      _vm.response.options.data[0][coluna.id]
    ) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.response.options.data[0][coluna.id]) + "\n              ")]) : _vm._e()])
  }), 0) : _vm._e()])], 1), _vm._v(" "), (
    !_vm.config.loading.content &&
    !_vm.config.loading.lancamentos &&
    (!_vm.formData.id_age || !_vm.formData.id_tab)
  ) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "title": "Selecione todos os campos obrigatórios"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Medição",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [(_vm.isRadio) ? [_c('div', {
    staticClass: "el-input"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "form-check col-12 text-left pl-0"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '_' + item.id,
        "disabled": _vm.disabled || _vm.disabledItem(item)
      },
      domProps: {
        "checked": _vm.value == item.id ? 'checked' : '',
        "value": _vm.value
      },
      on: {
        "change": function($event) {
          return _vm.setEvent('input', this.isObject ? item : item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": _vm.name + '_' + item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.descricao) + "\n        ")]), _vm._v(" "), (!!_vm.$slots[_vm.name + '_' + item.id]) ? _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "background": "#ffdbdb"
      }
    }, [_vm._t(_vm.name + '_' + item.id)], 2) : _vm._e()])
  }), 0)] : [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.valueKey,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": this.isObject ? item : item[_vm.valueKey]
      }
    })
  }), 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), _c('Aso', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Imprimir Ficha Clínica",
      "name": "tab-femo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Ficha Clínica")]), _vm._v(" "), _c('Femo', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": " Liberar ASO",
      "name": "tab-liberar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), _c('Liberar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1), _vm._v(" "), (!_vm.consulta || (_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id != 66 && _vm.consulta.tipo_status.id != 57 && _vm.consulta.tipo_status.id != 58)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Cancelar Consulta",
      "name": "tab-cancelar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-window-close"
  }), _vm._v(" Cancelar Consulta")]), _vm._v(" "), _c('Cancelar', {
    attrs: {
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Inserir 	Novo Email' : 'Editar Email'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.emailItems
    }
  }), _vm._v(" "), (_vm.formData.usuario) ? _c('EdAlert', {
    attrs: {
      "title": "Última Atualização"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Usuário:")]), _vm._v(" " + _vm._s(_vm.formData.usuario.usuario)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Data:")]), _vm._v(" " + _vm._s(_vm.toDate(_vm.formData.updated_at)) + "\n          ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('EdAlert', {
    attrs: {
      "title": "Atenção",
      "description": "Aqui você pode cadastrar múltiplos emails para essa empresa especificando cada email por setores",
      "type": "warning"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Novo Email",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onSearch": _vm.getEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aso-upload-face-card",
    class: {
      'aso-upload-face-card--disabled': _vm.disabled
    }
  }, [(_vm.label) ? _c('p', {
    staticClass: "aso-upload-face-card__label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "triggerRef",
    staticClass: "aso-upload-face-card__trigger"
  }, [_c('button', {
    staticClass: "aso-upload-face-card__visual",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.tryOpenLiveCamera
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "aso-upload-face-card__loader"
  }, [_vm._v("Falta pouco...")]) : (_vm.uploaded) ? _c('span', {
    staticClass: "aso-upload-face-card__status aso-upload-face-card__status--success"
  }, [_vm._v("✓ Foto validada")]) : (_vm.hasError) ? _c('span', {
    staticClass: "aso-upload-face-card__status aso-upload-face-card__status--error"
  }, [_vm._v("⚠ Falha no upload")]) : _c('span', {
    staticClass: "aso-upload-face-card__status"
  }, [_vm._v("Toque para tirar foto")])])]), _vm._v(" "), (_vm.cameraError && !_vm.isWebcamOpen) ? _c('p', {
    staticClass: "aso-upload-face-card__camera-error aso-upload-face-card__camera-error--inline"
  }, [_vm._v("\n    " + _vm._s(_vm.cameraError) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isWebcamOpen) ? _c('div', {
    staticClass: "aso-upload-face-card__modal",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal--preview' : 'aso-upload-face-card__modal--camera'
  }, [_c('div', {
    staticClass: "aso-upload-face-card__modal-content",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal-content--preview' : 'aso-upload-face-card__modal-content--camera'
  }, [_c('h3', {
    staticClass: "aso-upload-face-card__modal-title"
  }, [_vm._v(_vm._s(_vm.capturedPhoto ? 'Confirme sua foto' : 'Tire sua foto'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.capturedPhoto),
      expression: "capturedPhoto"
    }],
    staticClass: "aso-upload-face-card__preview-container"
  }, [_c('img', {
    staticClass: "aso-upload-face-card__preview-full",
    attrs: {
      "src": _vm.capturedPhoto
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.capturedPhoto),
      expression: "!capturedPhoto"
    }],
    staticClass: "aso-upload-face-card__media-container"
  }, [_c('video', {
    ref: "videoElement",
    staticClass: "aso-upload-face-card__video",
    attrs: {
      "autoplay": "",
      "playsinline": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-upload-face-card__modal-actions",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal-actions--preview' : 'aso-upload-face-card__modal-actions--camera'
  }, [(_vm.capturedPhoto) ? _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.confirmPhoto
    }
  }, [_vm._v("\n          Confirmar e enviar\n        ")]) : _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.captureFrame
    }
  }, [_vm._v("\n          Tirar foto\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--danger",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        _vm.capturedPhoto ? _vm.resetCapture() : _vm.closeLiveCamera()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.capturedPhoto ? 'Tirar outra foto' : 'Cancelar') + "\n        ")])]), _vm._v(" "), (_vm.cameraError && !_vm.capturedPhoto) ? _c('p', {
    staticClass: "aso-upload-face-card__camera-error"
  }, [_vm._v(_vm._s(_vm.cameraError))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('h1', [_vm._v("eSocial - Download de Arquivo")]), _vm._v(" "), _c('div', {
    staticClass: "widget-container fluid-height clearfix widget-content padded"
  }, [(_vm.error) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.error,
      "show-icon": "",
      "closable": false
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.error && _vm.formData.id) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Arquivo Carregado com Sucesso",
      "type": "success",
      "description": "Confira abaixo as informações do lote",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.lote))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.empresa_nome_fantasia) + " - " + _vm._s(_vm.formData.empresa_cnpj))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.layout))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [_vm._v(_vm._s(_vm.formData.filename))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.toDate(_vm.formData.updated_at, false)))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingDownload
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [(!_vm.loadingDownload) ? _c('i', {
    staticClass: "fa fa-download"
  }) : _vm._e(), _vm._v("\n                    Baixar Arquivo\n                ")]), _vm._v(" "), _vm._m(6)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Lote:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Empresa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Layout:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Nome do Arquivo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Última Atualização:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "30px",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                    O arquivo foi baixado automaticamente. Clique no botão acima para baixar novamente.\n                ")])
}]}

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "isModal": false,
      "title": 'EXAMES' + (_vm.funcionario ? ' - ' + _vm.funcionario.nome : '') + (_vm.formData.consulta ? ' - CONSULTA ' + _vm.formData.consulta.id_con : ''),
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "pagination": _vm.paginationExame,
      "response": _vm.response,
      "loadingTable": _vm.loadingTableExame,
      "onSearch": _vm.getExame,
      "disableCheckAll": "",
      "disableInputSearch": "",
      "disabledConfigCell": ""
    }
  })], 1)]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Exibindo o histórico de consultas dos últimos 10 anos",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Certificado',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['empresa'] ? 'is-error' : '',
    attrs: {
      "label": "Empresa",
      "prop": "empresa",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                                  " + _vm._s(item.cnpj) + "\n                            ")])])
  }), 1), _vm._v(" "), (_vm.error['empresa']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['empresa'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['tipo_certificado_id'] ? 'is-error' : '',
    attrs: {
      "label": "Tipo de Certificado",
      "prop": "tipo_certificado_id",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.formData.tipo_certificado_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo_certificado_id", $$v)
      },
      expression: "formData.tipo_certificado_id"
    }
  }, _vm._l((_vm.lstTipoCertificado), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1), _vm._v(" "), (_vm.error['tipo_certificado_id']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['tipo_certificado_id'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['arquivo'] ? 'is-error' : '',
    attrs: {
      "label": "Certificado",
      "prop": "arquivo",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('Upload', {
    attrs: {
      "onChangeFile": _vm.onChangeArquivo,
      "currentFile": _vm.arquivo,
      "ordem": "1"
    }
  }), _vm._v(" "), (_vm.error['arquivo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['arquivo'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('el-form-item', {
    class: _vm.error['senha'] ? 'is-error' : '',
    attrs: {
      "label": "Senha do Certificado",
      "prop": "senha",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formData.senha),
      callback: function($$v) {
        _vm.$set(_vm.formData, "senha", $$v)
      },
      expression: "formData.senha"
    }
  }), _vm._v(" "), (_vm.error['senha']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['senha'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('el-form-item', {
    class: _vm.error['confirmar_senha'] ? 'is-error' : '',
    attrs: {
      "label": "Confirmar Senha do Certificado",
      "prop": "confirmar_senha",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formData.confirmar_senha),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmar_senha", $$v)
      },
      expression: "formData.confirmar_senha"
    }
  }), _vm._v(" "), (_vm.error['confirmar_senha']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['confirmar_senha'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['vincular'] ? 'is-error' : '',
    attrs: {
      "label": "Vincular Automaticamente",
      "prop": "vincular",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Vincular Automaticamente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai vincular esse certificado para todos seus clientes automaticamente.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.vincular),
      callback: function($$v) {
        _vm.$set(_vm.formData, "vincular", $$v)
      },
      expression: "formData.vincular"
    }
  }), _vm._v(" "), (_vm.error['vincular']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['vincular'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formData.id > 0 && _vm.formData.vincular == 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['deletar_vinculo'] ? 'is-error' : '',
    attrs: {
      "label": "Deletar Vínculo",
      "prop": "deletar_vinculo",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Deletar Vínculo Existente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai deletar esse certificado da base de seus clientes.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.deletar_vinculo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "deletar_vinculo", $$v)
      },
      expression: "formData.deletar_vinculo"
    }
  }), _vm._v(" "), (_vm.error['deletar_vinculo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['deletar_vinculo'][0]))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    class: _vm.error['inserir_vinculo'] ? 'is-error' : '',
    attrs: {
      "label": "Inserir Vínculo Não Existente",
      "prop": "inserir_vinculo",
      "rules": []
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                        Inserir Vínculo Não Existente\n                        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Ao habilitar essa opção o sistema vai inserir esse certificado da base de seus clientes que já estão cadastrados no sistema.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.inserir_vinculo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inserir_vinculo", $$v)
      },
      expression: "formData.inserir_vinculo"
    }
  }), _vm._v(" "), (_vm.error['inserir_vinculo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['inserir_vinculo'][0]))]) : _vm._e()], 1)], 1) : _vm._e()])])], 1)]), _vm._v(" "), _c('Vincular', {
    attrs: {
      "showForm": _vm.showFormVincular,
      "certificado": _vm.formData
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Certificado",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getEsocialCertificado,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99:99'),
      expression: "'99:99'"
    }],
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "rules": _vm.rules,
      "placeholder": "hh:mm"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "mt-2"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, _vm._l((_vm.tableData), function(modelo, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": i.toString(),
        "name": modelo.id.toString()
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-list-ol"
    }), _vm._v(" " + _vm._s(modelo.id) + " (" + _vm._s(modelo.nome) + ")\n\t\t\t")]), _vm._v(" "), _c('Conteudo', {
      attrs: {
        "modelo": modelo
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Aguarde enquanto o upload é processado...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('UploadPagina', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "UPLOAD DE ASO",
      "modal": _vm.parent.showUploadASO,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "98%",
      "saveName": "Salvar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Fazer Novo Upload")]), _vm._v(" "), (_vm.formData.tipo == 86) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Automática o sistema reconhece automaticamente a quem pertence o ASO. Para isso funcionar verifique se o ASO está em PDF e possui no rodapé o código de identificação.",
      "show-icon": ""
    }
  }) : (_vm.formData.tipo == 87) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Na Identificação Manual o sistema exige que você informe a quem pertence o ASO: empresa, funcionário e a consulta.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Upload",
      "prop": "tipo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.formData.tipo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo", $$v)
      },
      expression: "formData.tipo"
    }
  }, _vm._l((_vm.lstTipoUpload), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['arquivo'] ? 'is-error' : '',
    attrs: {
      "label": "Selecione o ASO (no formato PDF e no máximo 25MB de tamanho)",
      "prop": "arquivo",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('Upload', {
    attrs: {
      "onChangeFile": _vm.handleArquivo,
      "currentFile": _vm.formData.arquivo,
      "ordem": "1"
    }
  }), _vm._v(" "), (_vm.error['arquivo']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['arquivo'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Escolha o Tipo do Documento",
      "prop": "documento",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tEscolha o Tipo do Documento\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Certifique-se que a primeira página do Prontuário Médico esteja anexado a FEMO da consulta ( Ficha de Exame Médico Ocupacional)",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.formData.tipo == 86
    },
    model: {
      value: (_vm.formData.documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "documento", $$v)
      },
      expression: "formData.documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.descricao
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: (_vm.formData.tipo == 87),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.formData.tipo == 86
    },
    on: {
      "change": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Funcionario",
      "prop": "id_fun",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome do funcionário",
      "remote-method": _vm.getFuncionario,
      "loading": _vm.loadingFuncionario,
      "disabled": !_vm.formData.id_emp
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formData.id_fun),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fun", $$v)
      },
      expression: "formData.id_fun"
    }
  }, _vm._l((_vm.lstFuncionario), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cnpj) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: (_vm.formData.tipo == '87'),
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": !_vm.formData.id_fun
    },
    model: {
      value: (_vm.formData.id_con),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_con", $$v)
      },
      expression: "formData.id_con"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item.id_con,
        "label": item.id_con + ((item.dt_cad ? ' | ' + _vm.toDate(item.dt_cad, true) : '') + (item.tipo_aso ? ' | ' + item.tipo_aso.descricao : ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.id_con) + " | " + _vm._s((item.dt_cad ? _vm.toDate(item.dt_cad, true) : '')) + " | " + _vm._s((item.tipo_aso ? item.tipo_aso.descricao : '')) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.documento == 83) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Juntar Arquivo",
      "prop": "juntar",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tJuntar Arquivo\n\t\t\t\t\t\t\t\t\t\t"), (_vm.formData.documento == 83) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Se essa opção estiver marcado, o sistema vai adicionar esse upload nos os arquivos enviados anteriormente.",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.formData.juntar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "juntar", $$v)
      },
      expression: "formData.juntar"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n\t\t\t\t\t\tHistórico de Uploads\n\t\t\t\t\t")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaUpload,
      "onDelete": _vm.onDelete,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Parâmetros Gerais\n            ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: _vm.ref,
    attrs: {
      "model": _vm.formData,
      "disabled": _vm.block || _vm.loading
    }
  }, [_c('div', {
    staticClass: "col-md-12 pa-2 justify-center text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.block && _vm.blockMessage) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "message": _vm.blockMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'col-md-12 pa-0 pt-3 justify-center ' + _vm.classFooter
  }, [(_vm.handlerSave) ? _c('ed-button', {
    attrs: {
      "color": _vm.colorButton,
      "label": _vm.labelButton,
      "disabled": _vm.block,
      "icon": "salvar",
      "size": "100%"
    },
    on: {
      "click": _vm.validar
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("form-footer")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-public-entry"
  }, [_c('div', {
    staticClass: "aso-public-entry__body"
  }, [_c('div', {
    staticClass: "aso-public-entry__card"
  }, [_c('h1', [_vm._v("Assinatura de ASO")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__context"
  }, [_c('strong', [_vm._v(_vm._s(_vm.tenantTitleCase))]), _vm._v("\n      | Consulta\n      "), _c('strong', [_vm._v(_vm._s(_vm.idConsulta))])]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "aso-public-entry__status"
  }, [_vm._v("\n      Consultando status da assinatura...\n    ")]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--error"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : (_vm.alreadySigned) ? _c('div', {
    staticClass: "aso-public-entry__signed-card"
  }, [_c('svg', {
    staticClass: "aso-public-entry__signed-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 6.41-6.29 6.3a1 1 0 0 1-1.42 0L7 12.41a1 1 0 1 1 1.41-1.41L10 12.59l5.59-5.59A1 1 0 0 1 17 8.41z",
      "fill": "#127902"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "aso-public-entry__signed-title"
  }, [_vm._v(_vm._s(_vm.justSigned ? 'ASO assinado com sucesso!' : 'O ASO referente a esta consulta já está assinado!'))])]) : _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--pending"
  }, [_c('p', {
    staticClass: "aso-public-entry__subtitle"
  }, [_vm._v("\n        Documento ainda não assinado. Siga as etapas para finalizar o processo.\n      ")]), _vm._v(" "), (_vm.showValidationBoard) ? _c('section', {
    staticClass: "aso-public-entry__validation-board",
    attrs: {
      "aria-label": "Validação de Informações"
    }
  }, [_c('h2', {
    staticClass: "aso-public-entry__validation-title"
  }, [_vm._v("Validação de Informações")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__validation-subtitle"
  }, [_vm._v("\n          Valide as informações necessárias para finalizar o cadastro\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-list"
  }, [_c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('email')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('email-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de e-mail")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emailStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('email')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('email')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]), _vm._v(" "), _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('identidade')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('id-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de identidade")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.identidadeStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('identidade')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('identidade')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]), _vm._v(" "), (!_vm.cadastroExistente) ? _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('telefone')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('phone-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de telefone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.telefoneStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('telefone')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('telefone')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.cadastroExistente) ? _c('article', {
    staticClass: "aso-public-entry__validation-item",
    class: _vm.validationClass('senha')
  }, [_c('div', {
    staticClass: "aso-public-entry__validation-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('password-icon')], 1), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-copy"
  }, [_c('h3', [_vm._v("Validação de senha")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.senhaStatusLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-action aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.isValidationActionVisible('senha')
    },
    on: {
      "click": function($event) {
        return _vm.goToValidationStep('senha')
      }
    }
  }, [_vm._v("\n              Validar\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__validation-footer"
  }, [_c('button', {
    staticClass: "aso-public-entry__validation-secondary aso-flow-button aso-flow-button--quiet aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.resetValidationBoard
    }
  }, [_vm._v("\n            Limpar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__validation-primary aso-flow-button aso-flow-button--loud aso-flow-button--compact",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canAdvanceValidationBoard
    },
    on: {
      "click": _vm.advanceValidationBoard
    }
  }, [_vm._v("\n            Finalizar\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepMessage) ? _c('p', {
    class: ['aso-public-entry__hint', _vm.stepError ? 'aso-public-entry__hint--error' : 'aso-public-entry__hint--ok']
  }, [_vm._v("\n        " + _vm._s(_vm.stepMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.wizardComplete) ? _c('div', {
    staticClass: "aso-public-entry__status aso-public-entry__status--ok aso-public-entry__status--compact"
  }, [_vm._v("\n        Processo concluído com sucesso. Recarregando status da assinatura...\n      ")]) : (!_vm.showValidationBoard) ? _c('div', [(_vm.currentStep === 1) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [(_vm.emailValidationView === 'email') ? _c('aso-validar-email-step', {
    attrs: {
      "email": _vm.email,
      "busy": _vm.busy
    },
    on: {
      "update:email": function($event) {
        _vm.email = $event
      },
      "continue": _vm.enviarTokenEmail
    }
  }) : _c('aso-valida-token-email-step', {
    attrs: {
      "email": _vm.email,
      "values": _vm.emailTokenValues,
      "busy": _vm.busy,
      "can-resend": _vm.tokenExpired,
      "resend-label": _vm.tokenResendLabel
    },
    on: {
      "digit-input": _vm.onEmailTokenDigitInput,
      "digit-keydown": _vm.onEmailTokenDigitKeydown,
      "paste": _vm.onEmailTokenPaste,
      "change-email": _vm.goToEmailForm,
      "confirm": _vm.validarToken,
      "resend": _vm.reenviarTokenEmail
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("2. Confirmação de identidade")]), _vm._v(" "), _c('aso-validar-identidade-step', {
    attrs: {
      "cpf": _vm.cpf,
      "busy": _vm.busy,
      "cadastro-existente": _vm.cadastroExistente,
      "editavel": _vm.cadastroExistente ? _vm.cadastroEditavel : _vm.funcionarioCerebroEditavel,
      "nome": _vm.nome,
      "masked-nome": _vm.cadastroMaskedNome,
      "masked-cpf": _vm.cadastroMaskedCpf,
      "sexo": _vm.sexo,
      "data-nascimento": _vm.dataNascimento,
      "possui-dados-cerebro": _vm.possuiDadosCerebro
    },
    on: {
      "update:cpf": function($event) {
        _vm.cpf = $event
      },
      "update:nome": function($event) {
        _vm.nome = $event
      },
      "update:sexo": function($event) {
        _vm.sexo = $event
      },
      "update:dataNascimento": function($event) {
        _vm.dataNascimento = $event
      },
      "toggle-edit": function($event) {
        _vm.cadastroExistente ? (_vm.cadastroEditavel = $event, _vm.onCadastroEditavelToggle()) : (_vm.funcionarioCerebroEditavel = $event, _vm.onFuncionarioCerebroEditavelToggle())
      },
      "validate": function($event) {
        _vm.cadastroExistente ? _vm.confirmarDadosExistente() : _vm.validarCpf()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("3. Validação de telefone")]), _vm._v(" "), (_vm.phoneValidationView === 'phone') ? _c('aso-validar-telefone-step', {
    attrs: {
      "telefone": _vm.telefone,
      "busy": _vm.busy
    },
    on: {
      "update:telefone": function($event) {
        _vm.telefone = $event
      },
      "continue": _vm.enviarTokenTelefone
    }
  }) : _c('aso-valida-token-telefone-step', {
    attrs: {
      "telefone": _vm.telefone,
      "values": _vm.phoneTokenValues,
      "busy": _vm.busy,
      "can-resend": _vm.tokenExpired,
      "resend-label": _vm.tokenResendLabel
    },
    on: {
      "digit-input": _vm.onPhoneTokenDigitInput,
      "digit-keydown": _vm.onPhoneTokenDigitKeydown,
      "paste": _vm.onPhoneTokenPaste,
      "confirm": _vm.validarTokenTelefone,
      "resend": _vm.reenviarTokenTelefone
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("4. Validação de senha")]), _vm._v(" "), _c('aso-validar-senha-step', {
    attrs: {
      "password": _vm.password,
      "password-confirm": _vm.passwordConfirm,
      "password-error": _vm.passwordConfirmError,
      "busy": _vm.busy
    },
    on: {
      "update:password": function($event) {
        _vm.password = $event
      },
      "update:passwordConfirm": function($event) {
        _vm.passwordConfirm = $event
      },
      "confirm-blur": _vm.onPasswordConfirmBlur,
      "continue": _vm.validarSenha
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 5) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("5. Upload dos documentos")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__form"
  }, [_c('upload-document-card', {
    attrs: {
      "side": "frente",
      "label": _vm.frenteIsPdf ? 'Documento' : 'Frente',
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingFrente,
      "has-error": _vm.uploadErrorFrente,
      "uploaded": !!_vm.frenteDocumento,
      "disabled": false,
      "accept-pdf": true
    },
    on: {
      "selected": _vm.onDocumentSelected
    }
  }), _vm._v(" "), (!_vm.frenteIsPdf) ? _c('upload-document-card', {
    attrs: {
      "side": "verso",
      "label": "Verso",
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingVerso,
      "has-error": _vm.uploadErrorVerso,
      "uploaded": !!_vm.versoDocumento,
      "disabled": !_vm.frenteDocumento
    },
    on: {
      "selected": _vm.onDocumentSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canSaveDocumentos
    },
    on: {
      "click": _vm.salvarDocumentos
    }
  }, [_vm._v("\n              " + _vm._s(_vm.busy ? 'Enviando...' : 'Salvar documentos') + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 7) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('p', {
    staticClass: "aso-public-entry__status"
  }, [_vm._v("\n            Finalizando assinatura do ASO...\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6) ? _c('div', {
    staticClass: "aso-public-entry__step"
  }, [_c('h2', [_vm._v("6. Assinatura")]), _vm._v(" "), _c('p', {
    staticClass: "aso-public-entry__hint"
  }, [_vm._v("\n            Envie uma foto nítida do seu rosto para concluir a assinatura do ASO.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-public-entry__form"
  }, [_c('upload-face-card', {
    attrs: {
      "busy": _vm.busy,
      "loading": _vm.uploadLoadingRosto,
      "has-error": _vm.uploadErrorRosto,
      "uploaded": !!_vm.fotoRosto,
      "disabled": false
    },
    on: {
      "selected": _vm.onSelectFace
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "aso-public-entry__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.salvarAssinatura
    }
  }, [_vm._v("\n              " + _vm._s(_vm.busy ? 'Finalizando...' : 'Concluir assinatura') + "\n            ")])], 1)]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "registerName": "Liberação",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableCheckAll": true,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-session', {
    ref: "session"
  }), _vm._v(" "), _c('ed-socket', {
    ref: "socket"
  }), _vm._v(" "), _c('ed-notify', {
    ref: "notify"
  }), _vm._v(" "), _c('ed-dialog', {
    ref: "dialog"
  }), _vm._v(" "), _c('ed-loading', {
    ref: "loading"
  }), _vm._v(" "), _c('ed-request', {
    ref: "request"
  }), _vm._v(" "), (!_vm.loadingContent) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-tabela"
  }, [(!_vm.disableCheckAll && _vm.checkItem.length > 0) ? _c('div', {
    staticClass: "ed-tabela__bulkbar"
  }, [_c('span', {
    staticClass: "ed-tabela__bulkbar-count"
  }, [_vm._v(_vm._s(_vm.checkItem.length) + " selecionado(s)")]), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-info"
  }, [_vm._v(_vm._s(_vm.selectedEligibleForXml.length) + " pode(m) gerar XML")]), _vm._v(" "), (_vm.onBulkGerarXml) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    attrs: {
      "disabled": !_vm.selectedEligibleForXml.length
    },
    on: {
      "click": _vm.handleBulkGerarXml
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-file-circle-plus"
  }), _vm._v(" Gerar XML\n      ")])] : _vm._e(), _vm._v(" "), (_vm.onEditAll) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    on: {
      "click": _vm.handleBulkEditAll
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Editar selecionados\n      ")])] : _vm._e(), _vm._v(" "), (_vm.onDelete) ? [_c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action ed-tabela__bulkbar-action--danger",
    on: {
      "click": _vm.handleBulkDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Excluir selecionados\n      ")])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ed-tabela__bulkbar-divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-tabela__bulkbar-action",
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("Cancelar")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__scroll"
  }, [_c('table', {
    staticClass: "ed-tabela__table"
  }, [_c('thead', [_c('tr', [(!_vm.disableCheckAll) ? _c('th', {
    staticClass: "ed-tabela__th-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }, _vm.handleSelectAll]
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHead), function(col) {
    return _c('th', {
      key: col.key,
      class: {
        'is-sortable': col.sortable
      },
      style: ({
        width: col.width
      }),
      on: {
        "click": function($event) {
          col.sortable && _vm.toggleSort(col.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(col.label) + "\n            "), (col.sortable && _vm.sortKey == col.key && !_vm.sortDesc) ? _c('i', {
      staticClass: "fa fa-sort-asc"
    }) : _vm._e(), _vm._v(" "), (col.sortable && _vm.sortKey == col.key && _vm.sortDesc) ? _c('i', {
      staticClass: "fa fa-sort-desc"
    }) : _vm._e(), _vm._v(" "), (col.sortable && _vm.sortKey != col.key) ? _c('i', {
      staticClass: "fa fa-sort ed-tabela__sort-idle"
    }) : _vm._e(), _vm._v(" "), (col.info) ? _c('i', {
      staticClass: "fa fa-question-circle ed-tabela__th-info",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "mouseenter": function($event) {
          return _vm.showTooltip(col.info, $event)
        },
        "mouseleave": _vm.hideTooltip
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    staticClass: "ed-tabela__th-actions"
  }, [_vm._v(" ")])], 2)]), _vm._v(" "), (_vm.loadingTable) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ed-tabela__state",
    attrs: {
      "colspan": _vm.colspan
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Carregando...\n          ")])])]) : (!_vm.sortedData.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "ed-tabela__state",
    attrs: {
      "colspan": _vm.colspan
    }
  }, [_vm._v(_vm._s(_vm.emptyMessage))])])]) : _c('tbody', _vm._l((_vm.sortedData), function(row) {
    return _c('tr', {
      key: row._data.id,
      class: {
        'is-deleted': row._data.deleted_at
      }
    }, [(!_vm.disableCheckAll) ? _c('td', {
      staticClass: "ed-tabela__th-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkItem),
        expression: "checkItem"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": row.options && row.options.disable_select,
        "title": row.options && row.options.disable_select ? 'Este registro não pode ser selecionado' : null
      },
      domProps: {
        "value": row._data.id,
        "checked": Array.isArray(_vm.checkItem) ? _vm._i(_vm.checkItem, row._data.id) > -1 : (_vm.checkItem)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row._data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkItem = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkItem = $$c
          }
        }, _vm.handleSelectItem]
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHead), function(col) {
      return _c('td', {
        key: col.key
      }, [(col.show_empresa_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlEmpresa(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]), _vm._v(" "), (col.show_fdt && row._data.fdt && row._data.fdt.pcmso) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v("\n                " + _vm._s(row._data.fdt.pcmso) + " (" + _vm._s(row._data.fdt.descricao) + ")\n              ")]) : _vm._e()] : (col.show_funcionario_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlFuncionario(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]), _vm._v(" "), (col.show_funcao && row._data.funcao) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v("\n                " + _vm._s(row._data.funcao.nome) + "\n              ")]) : _vm._e()] : (col.show_consulta_link && row._data.id_con) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlConsulta(row._data),
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })])] : (col.show_lote_link) ? [_c('a', {
        staticClass: "ed-tabela__link",
        attrs: {
          "href": _vm.getUrlLote(row._data),
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })])] : (col.key == 'tipo_status' && row._data.tipo_status) ? [_c('button', {
        staticClass: "ed-tabela__badge",
        class: {
          'ed-tabela__badge--conflito': _vm.hasConflito(row._data),
          'ed-tabela__badge--timeline': col.show_status_timeline
        },
        style: ({
          color: row._data.tipo_status.cor,
          background: _vm.hexToRgba(row._data.tipo_status.cor, 0.12),
        }),
        attrs: {
          "disabled": !_vm.hasConflito(row._data) && !col.show_status_timeline,
          "title": _vm.hasConflito(row._data) ? _vm.conflitoCount(row._data) + ' conflito(s) encontrado(s)' : null
        },
        on: {
          "click": function($event) {
            return _vm.handleStatusClick(col, row._data, $event)
          }
        }
      }, [(row._data.tipo_status.icon) ? _c('i', {
        class: [row._data.tipo_status.icon, {
          'ed-tabela__badge-pulse': _vm.hasConflito(row._data)
        }]
      }) : _vm._e(), _vm._v("\n                " + _vm._s(row._data.tipo_status.descricao) + "\n                "), (col.show_status_timeline) ? _c('i', {
        staticClass: "fa fa-chevron-down ed-tabela__badge-caret"
      }) : _vm._e()])] : (col.show_user) ? [_c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      }), _vm._v(" "), (row._data.usuario) ? _c('div', {
        staticClass: "ed-tabela__sub"
      }, [_vm._v(_vm._s(row._data.usuario.usuario))]) : _vm._e()] : (col.show_recibo_manual) ? [(row._data.usuario_recibo_manual) ? _c('button', {
        staticClass: "ed-tabela__recibo-manual-icon",
        on: {
          "click": function($event) {
            return _vm.toggleReciboManual(row._data, $event)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-user"
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })] : (col.show_arquivo) ? [(row[col.key] && row[col.key].id) ? _c('Download', {
        attrs: {
          "arquivo": row[col.key]
        }
      }) : _c('span', [_vm._v("---")])] : (col.show_eventos && row[col.key]) ? [_c('button', {
        staticClass: "ed-tabela__eventos-btn",
        on: {
          "click": function($event) {
            return _vm.toggleEventos(row[col.key], $event)
          }
        }
      }, [_c('span', {
        staticClass: "ed-tabela__eventos-total"
      }, [_vm._v(_vm._s(row[col.key].total))]), _vm._v(" evento(s)\n                "), _c('span', {
        staticClass: "ed-tabela__eventos-count ed-tabela__eventos-count--success"
      }, [_vm._v("\n                  " + _vm._s(row[col.key].enviado || 0) + "\n                ")]), _vm._v(" "), _c('span', {
        staticClass: "ed-tabela__eventos-sep"
      }, [_vm._v("/")]), _vm._v(" "), _c('span', {
        staticClass: "ed-tabela__eventos-count ed-tabela__eventos-count--danger"
      }, [_vm._v("\n                  " + _vm._s(row[col.key].erro || 0) + "\n                ")])])] : (col.edit && _vm.editableRows) ? [(col.edit == 'text') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : (col.edit == 'money') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }, {
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : (col.edit == 'number') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row._data[col.key]),
          expression: "row._data[col.key]"
        }],
        staticClass: "ed-tabela__input",
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (row._data[col.key])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row._data, col.key, $event.target.value)
          }
        }
      }) : _vm._e()] : [_c('span', {
        class: {
          'ed-tabela__value--bold': col.bold
        },
        domProps: {
          "innerHTML": _vm._s(row[col.key])
        }
      })]], 2)
    }), _vm._v(" "), _c('td', {
      staticClass: "ed-tabela__actions"
    }, _vm._l((row.buttons), function(btn, i) {
      return _c('button', {
        key: i,
        staticClass: "ed-tabela__icon-btn",
        style: (_vm.btnStyle(btn)),
        attrs: {
          "aria-label": btn.title,
          "disabled": !!btn.disabled
        },
        on: {
          "click": function($event) {
            btn.click && btn.click(row._data)
          },
          "mouseenter": function($event) {
            return _vm.showTooltip(btn.title, $event)
          },
          "mouseleave": _vm.hideTooltip
        }
      }, [_c('i', {
        class: btn.icon
      })])
    }), 0)], 2)
  }), 0)])]), _vm._v(" "), (_vm.pagination && _vm.pagination.total) ? _c('div', {
    staticClass: "ed-tabela__footer"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ppage),
      expression: "ppage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "ed-tabela__pp",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.ppage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handlePerPage]
    }
  }, _vm._l((_vm.lstPages), function(p) {
    return _c('option', {
      key: p,
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p) + " por página")])
  }), 0), _vm._v(" "), _c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.popover.open) ? _c('div', {
    staticClass: "ed-tabela__conflito-overlay",
    on: {
      "click": _vm.closePopover
    }
  }) : _vm._e(), _vm._v(" "), (_vm.popover.open) ? _c('div', {
    staticClass: "ed-tabela__conflito-popover",
    style: (_vm.popover.pos),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.popover.type == 'conflito') ? _c('conflitos-detalhe', {
    attrs: {
      "item": _vm.popover.payload
    }
  }) : (_vm.popover.type == 'eventos') ? _c('div', {
    staticClass: "ed-tabela__eventos-detalhe"
  }, [_c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.total))])]), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row ed-tabela__eventos-detalhe-row--success"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" "), _c('span', [_vm._v("Com sucesso")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.enviado || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "ed-tabela__eventos-detalhe-row ed-tabela__eventos-detalhe-row--danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v("Com erro")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.erro || 0))])])]) : (_vm.popover.type == 'timeline') ? _c('div', {
    staticClass: "ed-tabela__timeline"
  }, _vm._l((_vm.timelinePassos(_vm.popover.payload)), function(step) {
    return _c('div', {
      key: step.id,
      staticClass: "ed-tabela__timeline-step",
      class: {
        'ed-tabela__timeline-step--done': step.ordem < _vm.timelineAtual(_vm.popover.payload).ordem,
        'ed-tabela__timeline-step--atual': step.ordem == _vm.timelineAtual(_vm.popover.payload).ordem,
        'ed-tabela__timeline-step--erro': step.erro && step.ordem == _vm.timelineAtual(_vm.popover.payload).ordem,
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.timelineStepIcon(step, _vm.popover.payload)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.descricao))])])
  }), 0) : (_vm.popover.type == 'recibo_manual') ? _c('div', {
    staticClass: "ed-tabela__recibo-manual-detalhe"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('div', [_vm._v("\n        Recibo editado manualmente por "), _c('b', [_vm._v(_vm._s(_vm.popover.payload.usuario_recibo_manual.usuario))]), _vm._v(" em\n        " + _vm._s(_vm.toDate(_vm.popover.payload.recibo_manual_at, false)) + "\n      ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tooltip.visible) ? _c('div', {
    staticClass: "ed-tabela__tooltip",
    class: {
      'ed-tabela__tooltip--below': _vm.tooltip.below
    },
    style: ({
      top: _vm.tooltip.top + 'px',
      left: _vm.tooltip.left + 'px'
    })
  }, [_vm._v("\n    " + _vm._s(_vm.tooltip.text) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cw-page"
  }, [_c('WhatsappEditar', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormEdit,
      "parent": this
    }
  }), _vm._v(" "), _c('WhatsappTeste', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormTeste,
      "parent": this
    }
  }), _vm._v(" "), _c('WhatsappTemplates', {
    attrs: {
      "showForm": _vm.showFormTemplates,
      "parent": this
    },
    on: {
      "update:showForm": function($event) {
        _vm.showFormTemplates = $event
      },
      "update:show-form": function($event) {
        _vm.showFormTemplates = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cw-toolbar"
  }, [_c('button', {
    staticClass: "cw-btn cw-btn-primary",
    on: {
      "click": _vm.onRegister
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Nova Conta\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cw-search"
  }, [_c('i', {
    staticClass: "fa fa-search cw-search-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nome ou phone number ID..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.search) ? _c('button', {
    staticClass: "cw-search-clear",
    attrs: {
      "title": "Limpar busca"
    },
    on: {
      "click": _vm.handleClearSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.loadingTable) ? _c('div', {
    staticClass: "cw-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Carregando contas...\n  ")]) : (_vm.tableData.length === 0) ? _c('div', {
    staticClass: "cw-empty"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "cw-empty-title"
  }, [_vm._v(_vm._s(_vm.search ? 'Nenhuma conta encontrada' : 'Nenhuma conta WhatsApp cadastrada'))]), _vm._v(" "), (!_vm.search) ? _c('p', {
    staticClass: "cw-empty-subtitle"
  }, [_vm._v("Cadastre uma conta para começar a enviar mensagens via WhatsApp Business")]) : _vm._e(), _vm._v(" "), (!_vm.search) ? _c('button', {
    staticClass: "cw-btn cw-btn-primary",
    on: {
      "click": _vm.onRegister
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Nova Conta\n    ")]) : _vm._e()]) : _c('div', {
    staticClass: "cw-list"
  }, _vm._l((_vm.tableData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "cw-card"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "cw-card-main"
    }, [_c('div', {
      staticClass: "cw-card-name"
    }, [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('div', {
      staticClass: "cw-card-ids"
    }, [_c('span', {
      staticClass: "cw-card-id"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone_number_id) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "cw-card-id"
    }, [_c('i', {
      staticClass: "fa fa-building"
    }), _vm._v(" " + _vm._s(item.business_account_id) + "\n          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "cw-card-actions"
    }, [_c('button', {
      staticClass: "cw-icon-btn",
      attrs: {
        "title": "Templates de Mensagem"
      },
      on: {
        "click": function($event) {
          return _vm.onTemplates(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-comments"
    })]), _vm._v(" "), _c('button', {
      staticClass: "cw-icon-btn",
      attrs: {
        "title": "Enviar WhatsApp Teste"
      },
      on: {
        "click": function($event) {
          return _vm.onTest(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane"
    })]), _vm._v(" "), _c('button', {
      staticClass: "cw-icon-btn",
      attrs: {
        "title": "Editar Conta",
        "disabled": !_vm.validarPermissao(592)
      },
      on: {
        "click": function($event) {
          return _vm.onEdit(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "cw-icon-btn cw-icon-btn-danger",
      attrs: {
        "title": "Excluir Conta",
        "disabled": !_vm.validarPermissao(592)
      },
      on: {
        "click": function($event) {
          return _vm.onDelete([item.id])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0), _vm._v(" "), (_vm.pagination && _vm.pagination.last_page && _vm.pagination.last_page > 1) ? _c('div', {
    staticClass: "cw-pagination"
  }, [_c('ed-paginate', {
    attrs: {
      "pagination": _vm.pagination,
      "navigation": _vm.handleNavigate
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cw-empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cw-card-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])
}]}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n        ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.loadingSave,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.formData && _vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-emails"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Emails\n        ")]), _vm._v(" "), _c('Emails', {
    attrs: {
      "empresa": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.consulta.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "hover": "",
      "small": "",
      "responsive": "",
      "stacked": (this.device == 'xs')
    }
  }, [_c('b-thead', {
    attrs: {
      "head-variant": ""
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA")])], 1)], 1), _vm._v(" "), (_vm.formData) ? _c('b-tbody', _vm._l((_vm.formData.exames), function(consulta_exame, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', [_vm._v("\r\n            " + _vm._s(consulta_exame.exame.nome) + "\r\n            "), (consulta_exame.id_con_dem != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("demonstrativo")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_dem))])]) : (consulta_exame.id_con_rea != '0') ? _c('span', {
      staticClass: "tp-exame-dem",
      staticStyle: {
        "font-size": "9pt"
      },
      attrs: {
        "title": "Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
      }
    }, [_c('br'), _vm._v("Exame "), _c('b', [_vm._v("reaproveitado")]), _vm._v(" na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(consulta_exame.id_con_rea))])]) : _vm._e()]), _vm._v(" "), _c('b-td', [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "yyyy-MM-dd",
        "format": "dd/MM/yyyy",
        "disabled": _vm.formOption.empty == 1 || consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0,
        "title": (consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0 ? 'A data deste exame não pode ser alterado' : '')
      },
      model: {
        value: (consulta_exame.data),
        callback: function($$v) {
          _vm.$set(consulta_exame, "data", $$v)
        },
        expression: "consulta_exame.data"
      }
    })], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center mt-3 mb-2"
  }, [_c('el-checkbox', {
    attrs: {
      "checked": _vm.formOption.empty == 1
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.formOption.empty),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "empty", $$v)
      },
      expression: "formOption.empty"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Imprimir ASO com a data dos exames em branco")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Salvar Alterações e Imprimir ASO"
    },
    on: {
      "click": _vm.imprimirASO
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Saindo do sistema..."
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Logs', {
    attrs: {
      "showForm": _vm.showLogs,
      "formData": _vm.formData
    }
  }), _vm._v(" "), _c('Agendamento', {
    attrs: {
      "showForm": _vm.showAgendamento
    }
  }), _vm._v(" "), _c('div', [(!_vm.avulso) ? _c('div', {
    staticClass: "esocial-toolbar"
  }, [(!_vm.lote) ? _c('div', {
    staticClass: "esocial-tabs"
  }, _vm._l((_vm.config.list.esocial_tabela), function(tabela) {
    return _c('div', {
      key: tabela.id,
      staticClass: "esocial-tabs__item",
      class: {
        'is-active': _vm.formData.layout == tabela.codigo
      },
      on: {
        "click": function($event) {
          _vm.formData.layout = tabela.codigo
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-code-o"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(tabela.codigo))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "esocial-search"
  }, [_c('div', {
    staticClass: "esocial-search__group"
  }, [_c('div', {
    staticClass: "esocial-search__input"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.search),
      expression: "formData.search"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.lote ?
        'Pesquisar por Empresa, Funcionário...' :
        'Pesquisar por Consulta, Recibo, Lote, Funcionário, Empresa...'
    },
    domProps: {
      "value": (_vm.formData.search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getEsocial(_vm.formData.search)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--attached",
    on: {
      "click": function($event) {
        return _vm.getEsocial(_vm.formData.search)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n          ")])]), _vm._v(" "), (!_vm.lote) ? _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.showFilterModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n          "), (_vm.filterBadge > 0) ? _c('span', {
    staticClass: "esocial-search__badge"
  }, [_vm._v(_vm._s(_vm.filterBadge))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn",
    attrs: {
      "title": "Rotinas Automáticas"
    },
    on: {
      "click": function($event) {
        _vm.showAgendamento = !_vm.showAgendamento
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.avulso) ? _c('ed-table', {
    attrs: {
      "onSearch": _vm.getEsocial,
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEditXml,
      "onClear": _vm.onClear,
      "onFilter": _vm.getEsocial,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "disableInputSearch": false,
      "registerName": "Inserir novo XML"
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('Filters', {
    attrs: {
      "parent": this
    }
  })], 1)]) : _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "search": _vm.formData.search,
      "onSearch": _vm.getEsocial,
      "onBulkGerarXml": _vm.lote ? null : _vm.onBulkGerarXml,
      "disableCheckAll": !!_vm.lote
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFilterModal) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFilterModal = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Filtrar Resultado")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [(_vm.showFilterModal) ? _c('Filters', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn",
    on: {
      "click": function($event) {
        _vm.onClear();
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Limpar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.getEsocial(_vm.formData.search);
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n            ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.avulso) ? _c('s0000', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2210'
  ) ? _c('s2210', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2220'
  ) ? _c('s2220', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2240'
  ) ? _c('s2240', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-3000'
  ) ? _c('s3000', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModalUid) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModalUid = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Atualizar dados do evento")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModalUid = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": {
        novoUid: _vm.novoUid
      }
    }
  }, [_c('ed-alert', {
    staticClass: "px-3 mt-2",
    attrs: {
      "title": "Atenção",
      "type": "warning"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                Se o campo recibo for preenchido ou atualizado, o sistema alterará o status para \"Processado com sucesso\". Caso fique vazio, ele não altera o status atual do evento. A edição manual do recibo fica registrada (usuário e data).\n              ")])]), _vm._v(" "), (_vm.reciboManualInfo) ? _c('ed-alert', {
    staticClass: "px-3 mt-2",
    attrs: {
      "title": "Já editado manualmente",
      "type": "info"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                O recibo deste evento já foi alterado manualmente por "), _c('b', [_vm._v(_vm._s(_vm.reciboManualInfo.usuario))]), _vm._v(" em " + _vm._s(_vm.reciboManualInfo.data) + ".\n              ")])]) : _vm._e(), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Atualizar UID",
      "name": "novoUid",
      "required": ""
    },
    model: {
      value: (_vm.novoUid),
      callback: function($$v) {
        _vm.novoUid = $$v
      },
      expression: "novoUid"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Adicionar/atualizar recibo",
      "name": "novoRecibo",
      "required": ""
    },
    model: {
      value: (_vm.novoRecibo),
      callback: function($$v) {
        _vm.novoRecibo = $$v
      },
      expression: "novoRecibo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": _vm.saveUid
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Salvar\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModalDownloadXML) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModalDownloadXML = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--xml"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Arquivo XML " + _vm._s(_vm.xmlPreview.filename))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModalDownloadXML = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body esocial-modal__body--xml"
  }, [_c('div', {
    staticClass: "esocial-tabs esocial-tabs--xml"
  }, [_c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.xmlViewMode == 'arvore'
    },
    on: {
      "click": function($event) {
        _vm.xmlViewMode = 'arvore'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-code"
  }), _vm._v(" "), _c('span', [_vm._v("Árvore")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.xmlViewMode == 'tabela'
    },
    on: {
      "click": function($event) {
        _vm.xmlViewMode = 'tabela'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', [_vm._v("Tabela")])])]), _vm._v(" "), (_vm.xmlViewMode == 'arvore') ? _c('div', {
    staticClass: "xml-preview"
  }, [(_vm.xmlPreview.content) ? _c('XmlViewer', {
    attrs: {
      "xml": _vm.xmlPreview.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.xmlViewMode == 'tabela') ? _c('div', {
    staticClass: "xml-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Campo")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.xmlPreview.campos), function(campo, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "xml-table__campo"
    }, [_vm._v(_vm._s(campo.caminho))]), _vm._v(" "), _c('td', {
      staticClass: "xml-table__valor"
    }, [_vm._v(_vm._s(campo.valor))])])
  }), 0)]), _vm._v(" "), (!_vm.xmlPreview.campos.length) ? _c('div', {
    staticClass: "xml-table__empty"
  }, [_vm._v("Nenhum campo encontrado no XML.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-modal__btn-download",
    on: {
      "click": _vm.downloadXMLPreview
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Baixar arquivo XML\n          ")])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Email' : 'Editar Email',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, _vm._l((_vm.gruposForm), function(grupo, index) {
    return _c('details', {
      key: index,
      staticClass: "mb-4 border rounded p-3",
      attrs: {
        "open": grupo.group === 'Geral'
      }
    }, [_c('summary', {
      staticClass: "cursor-pointer font-weight-bold text-lg mb-2"
    }, [_vm._v("\n          " + _vm._s(grupo.group) + "\n        ")]), _vm._v(" "), (grupo.group === 'Tipo de Autenticação') ? [_c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    }), _vm._v(" "), (_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "alert alert-info"
    }, [_c('h6', [_c('i', {
      staticClass: "fas fa-info-circle"
    }), _vm._v(" Gmail OAuth2")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                Para usar Gmail OAuth2, você precisa apenas autorizar sua conta. \n                As credenciais OAuth2 já estão configuradas no sistema.\n              ")])]), _vm._v(" "), (_vm.formData.id) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('button', {
      staticClass: "btn btn-primary mr-2",
      attrs: {
        "disabled": _vm.config.loading.oauth
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.conectarOAuth2($event)
        }
      }
    }, [(_vm.config.loading.oauth) ? _c('span', {
      staticClass: "spinner-border spinner-border-sm mr-2"
    }) : _vm._e(), _vm._v("\n                🔗 Autorizar Conta Gmail\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm ml-2",
      attrs: {
        "disabled": _vm.config.loading.status
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.verificarStatusOAuth2($event)
        }
      }
    }, [(_vm.config.loading.status) ? _c('span', {
      staticClass: "spinner-border spinner-border-sm mr-2"
    }) : _vm._e(), _vm._v("\n                📊 Verificar Status\n              ")])]) : _c('div', {
      staticClass: "alert alert-warning mt-3"
    }, [_c('small', [_c('i', {
      staticClass: "fas fa-save"
    }), _vm._v(" Salve a conta primeiro para poder autorizar o Gmail OAuth2")])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 text-muted small"
    }, [_c('p', [_vm._v("\n                Ao autorizar, você concorda com o envio automatizado de e-mails relacionados à medicina do trabalho. \n                "), _c('a', {
      staticStyle: {
        "text-decoration": "underline",
        "cursor": "pointer"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.abrirTermoModal($event)
        }
      }
    }, [_vm._v("\n                  Leia o termo de consentimento completo.\n                ")])])]), _vm._v(" "), (_vm.oauthStatus) ? _c('div', {
      staticClass: "mt-3"
    }, [(_vm.oauthStatus.is_fully_configured) ? _c('div', {
      staticClass: "alert alert-success"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_c('strong', [_vm._v("✅ Gmail conectado com sucesso!")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Sua conta está autorizada e funcionando")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.revogarOAuth2
      }
    }, [_vm._v("\n                    Desconectar\n                  ")])])]) : (!_vm.oauthStatus.has_tokens) ? _c('div', {
      staticClass: "alert alert-warning"
    }, [_c('strong', [_vm._v("⚠️ Autorização pendente")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Clique em \"Autorizar Conta Gmail\" para conectar")])]) : _c('div', {
      staticClass: "alert alert-danger"
    }, [_c('strong', [_vm._v("❌ Erro na autorização")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Tente autorizar novamente")])])]) : _vm._e()]) : _vm._e()] : (grupo.group === 'Configurações SMTP') ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.formData.tipo_auth || _vm.formData.tipo_auth === 'senha'),
        expression: "!formData.tipo_auth || formData.tipo_auth === 'senha'"
      }]
    }, [(_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "alert alert-info mb-3"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    }), _vm._v(" \n              Configurações SMTP não são necessárias para Gmail OAuth2\n            ")]) : _vm._e(), _vm._v(" "), _c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    })], 1), _vm._v(" "), (_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "alert alert-secondary"
    }, [_c('i', {
      staticClass: "fas fa-shield-alt"
    }), _vm._v(" "), _c('strong', [_vm._v("Gmail OAuth2 selecionado")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("As configurações SMTP não são necessárias. A autenticação será feita diretamente com o Google.")])]) : _vm._e()] : [_c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    })]], 2)
  }), 0)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "Termo de Consentimento",
      "modal": _vm.showTermoModal,
      "width": "600px"
    },
    on: {
      "close": _vm.fecharTermoModal
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto",
      "white-space": "pre-wrap",
      "padding": "1rem",
      "font-size": "0.95rem",
      "line-height": "1.5"
    },
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', [_vm._v("\n        Ao conectar sua conta Gmail via OAuth2, você concorda expressamente que este sistema poderá enviar automaticamente mensagens de e-mail relacionadas às atividades profissionais, \n        incluindo comunicações sobre exames médicos, agendamentos e outras informações pertinentes à medicina do trabalho.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        O envio desses e-mails tem como objetivo otimizar a comunicação entre a clínica de medicina do trabalho e os colaboradores, garantindo o cumprimento das normas legais e a segurança dos processos internos.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Todos os dados são tratados com rigorosa confidencialidade, em conformidade com a legislação aplicável de proteção de dados pessoais.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Caso não concorde com este termo, recomendamos que não prossiga com a autorização da conta Gmail via OAuth2.\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": "textarea",
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules,
      "rows": 4
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'DETALHAMENTO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showConsultaDetail,
      "loading": _vm.loadingConsultaDetail,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaDetalhe', {
    attrs: {
      "consulta": _vm.formData.consulta
    }
  })], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'ALTERAR PCMSO DA CONSULTA EXTERNA ' +
        (this.formData.consulta ?
          ' - ' + this.formData.consulta.funcionario.nome :
          ''),
      "modal": _vm.showAlterarRevisao,
      "onSave": _vm.onAlterarPcmso,
      "disabledSave": _vm.checkAlterarPcmso,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ConsultaAlterarRevisao', {
    attrs: {
      "consulta": _vm.formData.consulta,
      "consultaNova": _vm.formData.consultaNova,
      "ultimaRevisao": _vm.formData.ultima_revisao
    }
  })], 1)]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "onFilter": _vm.getConsulta,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems,
      "onClear": _vm.onClear
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-table-simple', {
    staticClass: "table-v2",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    staticStyle: {
      "font-size": "7pt !important"
    }
  }, [_vm._v(_vm._s(_vm.formData.point_type == "ghe" ? "GHE (SETOR)" : "FUNÇÃO"))]), _vm._v(" "), _c('b-th', [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "80%"
    }
  }, [_vm._v("\n                AGENTE AVALIADO\n              ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "7pt !important",
      "border": "none",
      "background": "transparent",
      "color": "#fff"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("\n                METODOLOGIA\n              ")])])])])], 1)], 1), _vm._v(" "), _c('b-tbody', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }]
  }, _vm._l((_vm.tableData), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, _vm._l((data.points), function(point, j) {
      return _c('p', {
        key: i + j
      }, [_c('el-checkbox', {
        attrs: {
          "label": point.id,
          "disabled": _vm.tableMedicaoChecked.length > 0 || data.points.length > 1,
          "title": data.points.length > 1 ?
            'Não é possível agrupar um GHE que já foi agrupado anteriormente' :
            ''
        },
        model: {
          value: (_vm.tablePointChecked),
          callback: function($$v) {
            _vm.tablePointChecked = $$v
          },
          expression: "tablePointChecked"
        }
      }), _vm._v(" "), (_vm.formData.point_type == 'ghe') ? _c('span', [_vm._v("\n              " + _vm._s(point.ghe) + " (" + _vm._s(point.descricao) + ")\n            ")]) : (_vm.formData.point_type == 'funcao') ? _c('span', [_vm._v("\n              " + _vm._s(point.nome) + "\n            ")]) : _vm._e()], 1)
    }), 0), _vm._v(" "), _c('b-td', {
      style: ('background:' + (i % 2 == 0 ? '#E6E6E6' : ''))
    }, _vm._l((data.orcamento_medicoes), function(orcamento_medicao, j) {
      return _c('table', {
        key: j,
        attrs: {
          "width": "100%"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "80%"
        }
      }, [(false) ? _c('el-checkbox', {
        attrs: {
          "label": orcamento_medicao.id,
          "disabled": _vm.tablePointChecked.length > 0
        },
        model: {
          value: (_vm.tableMedicaoChecked),
          callback: function($$v) {
            _vm.tableMedicaoChecked = $$v
          },
          expression: "tableMedicaoChecked"
        }
      }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("\n                  " + _vm._s(orcamento_medicao.fator_risco.nome) + "\n                ")])], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "background": "#f9f6db"
        },
        attrs: {
          "width": "20%"
        }
      }, [_c('b', [_vm._v(_vm._s(orcamento_medicao.fator_risco.cod_metodologia))])])]), _vm._v(" "), _c('tr', [_c('td', {
        staticStyle: {
          "font-size": "7pt !important",
          "border": "none"
        },
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    Nº DE AMOSTRAGENS\n                    "), _c('el-input', {
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.amostragem),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "amostragem", $$v)
          },
          expression: "orcamento_medicao.amostragem"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR UNITÁRIO\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        on: {
          "change": function($event) {
            return _vm.formataDados()
          }
        },
        model: {
          value: (orcamento_medicao.valor_venda),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_venda", $$v)
          },
          expression: "orcamento_medicao.valor_venda"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-md-4"
      }, [_vm._v("\n                    VALOR TOTAL\n                    "), _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text",
          "readonly": ""
        },
        model: {
          value: (orcamento_medicao.valor_total),
          callback: function($$v) {
            _vm.$set(orcamento_medicao, "valor_total", $$v)
          },
          expression: "orcamento_medicao.valor_total"
        }
      })], 1)])])])])
    }), 0)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-save",
      "type": "success",
      "value": "Salvar Medições"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-history",
      "type": "primary",
      "title": "Clique aqui para restaurar e inicializar o orçamento",
      "value": "Restaurar Medições"
    },
    on: {
      "click": _vm.restaurar
    }
  }), _vm._v(" "), (_vm.tablePointChecked.length > 1) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-object-group",
      "type": "warning",
      "title": "Clique aqui para agrupar as medições selecionadas",
      "value": 'Agrupar ' + this.formData.point_type.toUpperCase()
    },
    on: {
      "click": _vm.agrupar
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.tabela_preco ? _vm.tabela_preco.credenciada_nome + ' - VALOR TOTAL DOS EXAMES: R$ ' + _vm.tabela_preco.valor_total : ''),
      "width": "90%"
    }
  }, [(_vm.tabela_preco) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.parent.loadingExame),
      expression: "parent.loadingExame"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Disponibilizamos abaixo a lista dos exames obrigatórios no PCMSO. Você pode escolher em qual Parceiro o exame deve ser feito.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "tableFooter": _vm.tableFooter,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "input": _vm.getFuncionario,
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Trabalhador",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getFuncionario
    },
    model: {
      value: (_vm.formData.id_fun),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fun", $$v)
      },
      expression: "formData.id_fun"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de Início do Periodo"
    },
    model: {
      value: (_vm.formData.data_inicio),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_inicio", $$v)
      },
      expression: "formData.data_inicio"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
    attrs: {
      "label": "Data de Final do Periodo"
    },
    model: {
      value: (_vm.formData.data_fim),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_fim", $$v)
      },
      expression: "formData.data_fim"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "loading": _vm.loading,
      "disabled": !_vm.formData.id_emp || !_vm.formData.id_fun || !_vm.formData.data_inicio || !_vm.formData.data_fim ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.erro) ? _c('div', {
    staticClass: "consulta-esocial-erro"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.erro))])]) : _vm._e(), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Trabalhador")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.funcionario))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Período")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.periodo))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.empresa))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Consultado em")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.data))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loadingContent) ? _c('div', [_c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.froalaConfig
    },
    model: {
      value: (_vm.mensagem),
      callback: function($$v) {
        _vm.mensagem = $$v
      },
      expression: "mensagem"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('Editar', {
    attrs: {
      "conclusao_tecnica": _vm.formData,
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Conclusão Técnica",
      "onRegister": (this.validarPermissao(573) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getConclusaoTecnica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "As tabelas listadas abaixo fazem referência as tabelas de riscos químicos, físicos e biológicos nos documentos do LTCAT. Aqui você pode cadastrar os modelos customizados dessas tabelas."
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "modal": _vm.showHtml,
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.html)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Tabela Dinâmica",
      "onRegister": this.$root.$session.validarPermissao(571) ? _vm.onRegister : null,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [(_vm.tableData.length) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "label": "Exportar Tabelas",
      "title": "Clique aqui para exportar as tabelas e visualizar a extrutura das colunas"
    },
    on: {
      "click": _vm.onExportar
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-email-step"
  }, [_c('h2', {
    staticClass: "aso-email-step__title"
  }, [_vm._v("Digite seu e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__text"
  }, [_vm._v("Certifique-se de ter acesso ao seu e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__text"
  }, [_vm._v("Vamos enviar um código para validá-lo.")]), _vm._v(" "), _c('input', {
    staticClass: "aso-email-step__input",
    attrs: {
      "type": "email",
      "placeholder": "nome@example.com",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:email', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__helper"
  }, [_vm._v("Use o formato nome@example.com")]), _vm._v(" "), _c('button', {
    staticClass: "aso-email-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full aso-flow-button--uppercase",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canContinue
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Enviando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaExame,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container py-5",
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v("Política de Privacidade")]), _vm._v(" "), _c('p', [_vm._v("\n      A "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("ATENTO")]), _vm._v(", responsável pela operação do sistema hospedado em\n      "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "https://www1.softwareatento.com.br",
      "target": "_blank"
    }
  }, [_vm._v("https://www1.softwareatento.com.br")]), _vm._v(",\n      reconhece a importância da privacidade e da proteção de dados pessoais. Esta Política de Privacidade estabelece de forma clara e transparente como tratamos os dados coletados,\n      em especial os dados oriundos de integrações com serviços do Google via OAuth 2.0, em conformidade com a "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("LGPD")]), _vm._v(",\n      as Políticas de Privacidade da Google e demais legislações aplicáveis.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("1. Finalidade do Sistema")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    O Software Atento é uma plataforma de gestão voltada para clínicas e profissionais da área de "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("Medicina do Trabalho")]), _vm._v(", com funcionalidades como:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Agendamento de consultas e exames")]), _vm._v(" "), _c('li', [_vm._v("Emissão de laudos médicos")]), _vm._v(" "), _c('li', [_vm._v("Envio automatizado de comunicados, boletos e documentos")]), _vm._v(" "), _c('li', [_vm._v("Gestão de prontuários ocupacionais")]), _vm._v(" "), _c('li', [_vm._v("Integração com sistemas do eSocial")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2. Dados Coletados")]), _vm._v(" "), _c('h3', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2.1 Dados fornecidos pelo usuário:")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Nome completo")]), _vm._v(" "), _c('li', [_vm._v("Endereço de e-mail")]), _vm._v(" "), _c('li', [_vm._v("Cargo ou função")]), _vm._v(" "), _c('li', [_vm._v("Nome da clínica ou empresa")]), _vm._v(" "), _c('li', [_vm._v("Dados de login")])]), _vm._v(" "), _c('h3', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2.2 Dados de autenticação via Google (OAuth2):")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Ao autorizar o uso de funcionalidades do Google, coletamos os seguintes dados:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Token de acesso temporário (OAuth2)")]), _vm._v(" "), _c('li', [_vm._v("Endereço de e-mail autenticado")]), _vm._v(" "), _c('li', [_vm._v("Permissão para envio de e-mails via Gmail ("), _c('code', [_vm._v("https://www.googleapis.com/auth/gmail.send")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("3. Uso dos Dados")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados são utilizados exclusivamente para autenticação, envio de laudos e comunicação clínica. Não são usados para publicidade ou fins analíticos externos.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("4. Compartilhamento e Divulgação")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados não são vendidos, alugados ou compartilhados com terceiros, exceto em casos exigidos por lei ou mediante ordem judicial.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("5. Retenção e Exclusão de Dados")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados são mantidos apenas enquanto forem necessários para os fins descritos. O usuário pode solicitar exclusão total a qualquer momento pelo e-mail:\n    "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "mailto:suporte@softwareatento.com.br"
    }
  }, [_vm._v("suporte@softwareatento.com.br")]), _vm._v(".\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("6. Segurança da Informação")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Conexões criptografadas (HTTPS/TLS)")]), _vm._v(" "), _c('li', [_vm._v("Armazenamento seguro de tokens")]), _vm._v(" "), _c('li', [_vm._v("Autenticação baseada em permissões")]), _vm._v(" "), _c('li', [_vm._v("Auditorias de segurança regulares")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("7. Direitos do Usuário (LGPD)")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("Os usuários têm direito a:")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Acesso, correção e exclusão de dados")]), _vm._v(" "), _c('li', [_vm._v("Informações sobre o tratamento e compartilhamento")]), _vm._v(" "), _c('li', [_vm._v("Portabilidade e revogação de consentimento")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("8. Uso de Cookies")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Utilizamos cookies para autenticação de sessão e estatísticas internas. O usuário pode desativar cookies pelo navegador.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("9. Alterações nesta Política")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Podemos atualizar esta política a qualquer momento. Alterações significativas serão destacadas na plataforma.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("10. Contato")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Dúvidas ou solicitações podem ser enviadas para:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("E-mail: "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "mailto:suporte@softwareatento.com.br"
    }
  }, [_vm._v("suporte@softwareatento.com.br")])])])])
}]}

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('b-form-file', {
    ref: 'file-input-' + this.input,
    attrs: {
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "placeholder": "Escolher arquivo...",
      "drop-placeholder": "Apagar arquivo...",
      "browse-text": "Procurar..."
    },
    on: {
      "change": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function(ref) {
        var names = ref.names;

        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))]), _vm._v(" "), (names.length > 1) ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("\n              + " + _vm._s(names.length - 1) + " More files\n            ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), (_vm.currentFile != null) ? _c('div', {
    staticClass: "arquivo-info"
  }, [_c('Download', {
    attrs: {
      "arquivo": _vm.currentFile
    },
    on: {
      "deleted": _vm.handleDeleted
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card",
      "editable": _vm.orcamentos.length > 0
    },
    on: {
      "tab-remove": _vm.handleTabsDelete
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-listar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Orçamentos Cadastrados\n\t\t\t")]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Gerar Novo Orçamento",
      "onRegister": (this.validarPermissao(577) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatOrcamento,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _vm._l((_vm.orcamentos), function(orcamento, i) {
    return _c('el-tab-pane', {
      key: i,
      attrs: {
        "label": "Config",
        "name": 'tab-editar-' + i
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v(" Editar Orçamento " + _vm._s(orcamento.codigo) + "\n\t\t\t")]), _vm._v(" "), _c('Editar', {
      attrs: {
        "showForm": _vm.showFormEdit,
        "parent": this,
        "orcamento": orcamento
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Atenção",
      "description": "Aqui você visualizar o histórico de atendimento dessa consulta"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaAcompanhamento,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ConsultaLote', {
    attrs: {
      "showLote": _vm.showConsultaLote,
      "funcionario": _vm.formDataConsulta.funcionario,
      "tipoAso": 52
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' + (_vm.funcionario ? ' :: ' + _vm.funcionario.nome : '') + ' :: ' + _vm.formData.periodo[0] + ' a ' + _vm.formData.periodo[1],
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabExame),
      callback: function($$v) {
        _vm.tabExame = $$v
      },
      expression: "tabExame"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#4ac467",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Dentro do Período Selecionado "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#dd4040",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Fora do Período Selecionado "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#d8a027",
      "float": "left"
    }
  }, [_vm._v("   ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Exame não Realizado - Fora dos requisitos do PCMSO"), _c('br')])])]), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1), _vm._v(" "), (_vm.funcionario) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('ConsultaHistorico', {
    attrs: {
      "funcionario": _vm.funcionario
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.funcionario) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.funcionario.id_ghe
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-search",
      "type": "success",
      "loading": _vm.config.loading.save || _vm.loadingTable,
      "disabled": _vm.config.loading.save || _vm.loadingTable,
      "value": "Pesquisar"
    },
    on: {
      "click": _vm.getPeriodico
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "col-12"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabPeriodico),
      callback: function($$v) {
        _vm.tabPeriodico = $$v
      },
      expression: "tabPeriodico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-ok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Dentro do Período Selecionado (" + _vm._s(_vm.tableData.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "success",
      "description": "Os trabalhadores mostrados abaixo estão com a data dos exames DENTRO PERÍODO SELECIONADO.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "onEditAll": _vm.onConsultaLote,
      "editAllIcon": "fa fa-address-card",
      "editAllName": "Gerar Consulta",
      "editAllTitle": "Gerar Consulta para os trabalhadores selecionados",
      "disableInputSearch": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar Resultado para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1)])], 1), _vm._v(" "), (_vm.tableDataTabelaPreco.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Orçamento Aproximado",
      "name": "tab-preco"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamento Aproximado")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Orçamento aproximado para os periódidocos dentro do período selecionado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataTabelaPreco,
      "tableHead": _vm.tableHeadTabelaPreco,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableDataForaPeriodo.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-nok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Fora do Período Selecionado (" + _vm._s(_vm.tableDataForaPeriodo.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Os trabalhadores mostrados abaixo estão com o periódico atrasado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataForaPeriodo,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableDataError.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-error"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Erro de Cadastro(" + _vm._s(_vm.tableDataError.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "error",
      "description": "Os trabalhadores mostrados abaixo estão com erros no cadastro.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataError,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aso-upload-card",
    class: {
      'aso-upload-card--disabled': _vm.disabled
    }
  }, [_c('p', {
    staticClass: "aso-upload-card__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    ref: "triggerRef",
    staticClass: "aso-upload-card__trigger"
  }, [_c('button', {
    staticClass: "aso-upload-card__visual",
    style: (_vm.visualStyle),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.handlePrimaryAction
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "aso-upload-card__loader"
  }, [_vm._v("Falta pouco...")]) : (_vm.uploaded) ? _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Arquivo validado")]) : (_vm.hasError) ? _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Falha no upload")]) : _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Toque para selecionar")])]), _vm._v(" "), (_vm.showMobileOptions) ? _c('div', {
    staticClass: "aso-upload-card__tooltip"
  }, [_c('button', {
    staticClass: "aso-upload-card__tooltip-btn aso-upload-card__tooltip-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.openCamera
    }
  }, [_vm._v("\n        Abrir camera\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-upload-card__tooltip-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.openGallery
    }
  }, [_vm._v("\n        Selecionar arquivo\n      ")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "cameraInput",
    staticClass: "aso-upload-card__hidden-input",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg",
      "capture": "environment",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "change": _vm.onSelect
    }
  }), _vm._v(" "), _c('input', {
    ref: "galleryInput",
    staticClass: "aso-upload-card__hidden-input",
    attrs: {
      "type": "file",
      "accept": _vm.galleryAccept,
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "change": _vm.onSelect
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": "500px",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("REENVIAR LEMBRETE DE ASSINATURA")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Confirmação",
      "type": "warning",
      "description": _vm.descricao,
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave
    },
    on: {
      "click": _vm.enviar
    }
  }, [_vm._v("Enviar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Editar Conteúdo',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "tab-editar",
      "name": "tab-editar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Editar\n\t\t\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.conteudoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "tab-editar",
      "name": "tab-conteudo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v(" Visualizar Conteúdo\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.titulo)
    }
  })])], 1)], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onEdit": _vm.onEdit,
      "onSearch": _vm.getModeloConteudo,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.content,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Editar', {
    attrs: {
      "anexo": _vm.formData,
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Anexo",
      "onRegister": (this.validarPermissao(576) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatAnexo,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.env && _vm.env.mode && _vm.env.mode != 'production') ? _c('div', {
    staticClass: "aviso2"
  }, [_vm._v("\r\n    Ambiente de Teste\r\n  ")]) : _vm._e(), _vm._v(" "), _c('b-navbar', {
    staticClass: "header1",
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "light",
      "align": "center",
      "fixed": "top"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#",
      "title": ':: ' + _vm.usuario.logged.point.nome + '\n:: ' + _vm.usuario.logged.nome
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo,
      "alt": "Kitten",
      "width": "120"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "align-content-center flex-wrap",
    staticStyle: {
      "font-size": "7pt"
    }
  }, [(_vm.sub_domain == 'empresa') ? _c('span', [_vm._v("Area da Empresa")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'credenciada') ? _c('span', [_vm._v("Area da Credenciada")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'parceiro') ? _c('span', [_vm._v("Area do Parceiro")]) : _vm._e()])]), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav-collapse",
      "type": "dark"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "nav-collapse",
      "is-nav": ""
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "transparent",
      "text-color": "#fff",
      "unique-opened": "",
      "active-text-color": "#fff"
    }
  }, [_vm._l((_vm.usuario.menu), function(menu, i) {
    return [(menu.sub_menu.length == 0) ? _c('el-menu-item', {
      key: i,
      class: menu.class + (menu.rota == _vm.$route.path ? ' is-active' : ''),
      attrs: {
        "index": i.toString(),
        "default-active": +(menu.rota == _vm.$route.path ? menu.rota : ''),
        "exact": ""
      },
      on: {
        "click": function($event) {
          return _vm.toRoute({
            path: menu.rota
          })
        }
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\r\n            " + _vm._s(menu.descricao) + " \r\n            "), (menu.badge && menu.badge > 0) ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(menu.badge))]) : _vm._e()], 1) : _c('el-submenu', {
      key: i,
      class: menu.class,
      attrs: {
        "index": i.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\r\n               " + _vm._s(menu.descricao) + "\r\n            ")]), _vm._v(" "), _vm._l((menu.sub_menu), function(sub_menu, j) {
      return (_vm.isSubMenuVisible(sub_menu)) ? _c('el-menu-item', {
        key: i + j,
        staticClass: "sub_menu",
        attrs: {
          "index": i.toString() + '-' + j.toString()
        },
        on: {
          "click": function($event) {
            return _vm.toRoute({
              path: sub_menu.rota
            })
          }
        }
      }, [_c('i', {
        class: sub_menu.icon
      }), _vm._v("\r\n              " + _vm._s(sub_menu.descricao) + "\r\n            ")]) : _vm._e()
    })], 2)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Anexo' : 'Editar Anexo',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.formData.id == 0) ? _c('ed-alert', {
    attrs: {
      "title": "Instruções",
      "type": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('ul', [_c('li', [_vm._v("O arquivo não deve exceder 50MB de tamanho")]), _vm._v(" "), _c('li', [_vm._v("Os formatos dos arquivos devem estar em PDF, ZIP, JPG, PNG ou JPEG")]), _vm._v(" "), _c('li', [_vm._v("Todos o arquivos enviados que não corresponderem a uma IMAGEM, serão convertidos em IMAGEM automaticamente.")]), _vm._v(" "), _c('li', [_vm._v("Só é possível enviar 1 arquivo por vez. Se precisar enviar vários arquivos, você deve compactar os mesmo no formato ZIP e envia-los. Assim o sistema consegue desconpactar e salvar corretamente no servidor.")])])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-senha-step"
  }, [_c('h2', {
    staticClass: "aso-senha-step__title"
  }, [_vm._v("Crie sua Senha.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "aso-senha-step__input",
    attrs: {
      "type": "password",
      "placeholder": "Digite a senha",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:password', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "aso-senha-step__input",
    attrs: {
      "type": "password",
      "placeholder": "Repita a senha",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:passwordConfirm', $event.target.value)
      },
      "blur": function($event) {
        return _vm.$emit('confirm-blur')
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('p', {
    staticClass: "aso-senha-step__error"
  }, [_vm._v(_vm._s(_vm.passwordError))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "aso-senha-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Salvando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aso-senha-step__text"
  }, [_c('strong', [_vm._v("Seu e-mail será utilizado como login de acesso.")]), _vm._v(" Crie uma senha segura com ao menos 8 caracteres, incluindo letra maiúscula, minúscula, número e caractere especial.")])
}]}

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "trigger",
    staticClass: "ed-select-tipo",
    class: {
      'is-disabled': _vm.disabled,
      'is-focus': _vm.open
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "ed-select-tipo__trigger"
  }, [(_vm.multiple && _vm.selectedItems.length) ? [_vm._l((_vm.visibleTags), function(tag, i) {
    return _c('span', {
      key: i,
      staticClass: "ed-select-tipo__tag"
    }, [_vm._v("\n        " + _vm._s(tag.descricao) + "\n        "), (!_vm.disabled) ? _c('i', {
      staticClass: "fa fa-times ed-select-tipo__tag-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeTag(tag)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.hiddenCount > 0) ? _c('span', {
    staticClass: "ed-select-tipo__tag ed-select-tipo__tag--count"
  }, [_vm._v("\n        +" + _vm._s(_vm.hiddenCount) + "\n      ")]) : _vm._e()] : (!_vm.multiple && _vm.selectedLabel) ? _c('span', {
    staticClass: "ed-select-tipo__value"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedLabel) + "\n    ")]) : _c('span', {
    staticClass: "ed-select-tipo__placeholder"
  }, [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]), _vm._v(" "), (_vm.clearable && _vm.hasValue && !_vm.disabled) ? _c('i', {
    staticClass: "fa fa-times ed-select-tipo__clear",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clear($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down ed-select-tipo__arrow",
    class: {
      'is-reverse': _vm.open
    }
  })], 2), _vm._v(" "), _c('teleport-dropdown', {
    attrs: {
      "visible": _vm.open,
      "trigger-el": _vm.$refs.trigger
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.filteredItems.length > 7 || _vm.search) ? _c('div', {
    staticClass: "ed-select-tipo__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "ed-select-tipo__search-input",
    attrs: {
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "optionsList",
    staticClass: "ed-select-tipo__options"
  }, [_vm._l((_vm.filteredItems), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "ed-select-tipo__option",
      class: {
        'is-selected': _vm.isSelected(item),
        'is-hover': _vm.hoverIndex === item.id
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(item)
        },
        "mouseenter": function($event) {
          _vm.hoverIndex = item.id
        }
      }
    }, [(_vm.multiple) ? _c('span', {
      staticClass: "ed-select-tipo__option-check"
    }, [_c('i', {
      class: _vm.isSelected(item) ? 'fa fa-check-square' : 'fa fa-square-o'
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ed-select-tipo__option-content"
    }, [_c('div', [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), (item.obs) ? _c('div', {
      staticClass: "ed-select-tipo__option-obs"
    }, [_vm._v(_vm._s(item.obs))]) : _vm._e()])])
  }), _vm._v(" "), (_vm.filteredItems.length === 0) ? _c('div', {
    staticClass: "ed-select-tipo__empty"
  }, [_vm._v("\n        Nenhum resultado\n      ")]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.consulta && _vm.ultimaRevisao) ? _c('div', [_c('ed-form', [_c('div', {
    staticClass: "row text-left"
  }, [_c('ed-alert', {
    staticClass: "col-12 mb-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\tEssa consulta está com o PCMSO desatualizado. Para continuar você deve selecionar o último PCMSO válido dessa Frente de Trabalho.\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#c1d19c"
    }
  }, [_c('b', [_vm._v("Último PCMSO válido: ")]), _vm._v(" "), (_vm.ultimaRevisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.parent.rev) + " (" + _vm._s(_vm.ultimaRevisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultimaRevisao.rev) + " (" + _vm._s(_vm.ultimaRevisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.ultimaRevisao.data_hora, true)) + ")\n\t\t\t\t\t")])]), _vm._v(" "), (_vm.consulta.fdt) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Frente de Trabalho: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.fdt.pcmso) + " (" + _vm._s(_vm.consulta.fdt.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.revisao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Revisão: ")]), _vm._v(" "), (_vm.consulta.revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.parent.rev) + " (" + _vm._s(_vm.consulta.revisao.parent.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.parent.data_hora, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.revisao.rev) + " (" + _vm._s(_vm.consulta.revisao.descricao) + " em " + _vm._s(_vm.$utilidade.toDate(_vm.consulta.revisao.data_hora, true)) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.ghe) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("GHE (Setor): ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.ghe.ghe) + " (" + _vm._s(_vm.consulta.ghe.descricao) + ")\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.consulta.funcao) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "background": "#eeeeee"
    }
  }, [_c('b', [_vm._v("Função: ")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('h4', [_vm._v("Selecione o novo PCMSO")])]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getGhe
    },
    model: {
      value: (_vm.consultaNova.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_fdt", $$v)
      },
      expression: "consultaNova.id_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
    attrs: {
      "label": "GHE (Setor)",
      "items": _vm.list.ghe,
      "loading": _vm.loadingGhe,
      "itemText": "ghe",
      "item-group": "",
      "required": "",
      "disabled": !_vm.consultaNova.id_fdt
    },
    on: {
      "input": _vm.getFuncao
    },
    model: {
      value: (_vm.consultaNova.id_ghe),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_ghe", $$v)
      },
      expression: "consultaNova.id_ghe"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Função",
      "items": _vm.list.funcao,
      "loading": _vm.loadingFuncao,
      "itemText": "nome",
      "required": "",
      "disabled": !_vm.consultaNova.id_ghe
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.consultaNova.id_funcao),
      callback: function($$v) {
        _vm.$set(_vm.consultaNova, "id_funcao", $$v)
      },
      expression: "consultaNova.id_funcao"
    }
  }), _vm._v(" "), (_vm.tabela_preco !== null) ? _c('ed-alert', {
    staticClass: "col-12 mt-3",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.tabela_preco) + "\n\t\t\t\t")]) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.consulta.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Imprimir",
      "value": "Imprimir Ficha Clínica"
    },
    on: {
      "click": _vm.imprimir
    }
  })], 1)], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center mt-3 mb-2"
  }, [_c('el-checkbox', {
    attrs: {
      "checked": _vm.formData.empty == 1
    },
    model: {
      value: (_vm.formData.empty),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empty", $$v)
      },
      expression: "formData.empty"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Gostaria de preencher tudo a mão")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Salvar Alterações e Imprimir Ficha Clínica"
    },
    on: {
      "click": _vm.imprimir
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Informações do Orçamento\n      ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Informações das Medições\n      ")]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfigResumo),
      callback: function($$v) {
        _vm.tagConfigResumo = $$v
      },
      expression: "tagConfigResumo"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-res-med"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Medições\n          ")]), _vm._v(" "), _c('Medicao', {
    attrs: {
      "orcamento": _vm.orcamento
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-res-cus"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Custos\n          ")]), _vm._v(" "), _c('Servico', {
    attrs: {
      "orcamento": _vm.orcamento
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-email"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Propostas Enviadas")]), _vm._v(" "), _c('LogEmail', {
    attrs: {
      "point_type": "ltcat_orcamento",
      "point_id": _vm.orcamento.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaRisco,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-identidade-step"
  }, [(!_vm.cadastroExistente && !_vm.possuiDadosCerebro) ? [_c('h2', {
    staticClass: "aso-identidade-step__title"
  }, [_vm._v("Confirme sua identidade.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__text"
  }, [_vm._v("Informe seus dados para confirmar na consulta.")]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Nome completo")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "placeholder": "Nome completo",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.nome
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:nome', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "14",
      "placeholder": "000.000.000-00",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.cpf
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:cpf', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.sexo
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:sexo', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Feminino")])])]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "date",
      "placeholder": "dd/mm/aaaa",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.dataNascimento
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:dataNascimento', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Validando...' : 'Continuar') + "\n    ")])] : [_c('h2', {
    staticClass: "aso-identidade-step__title"
  }, [_vm._v(_vm._s(_vm.cadastroExistente ? 'Bem vindo de volta!' : 'Identificamos seus dados!'))]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__text"
  }, [_vm._v("Confira seus dados cadastrados. Caso necessário, habilite a edição para atualizá-los.")]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__toggle-row"
  }, [_c('label', {
    staticClass: "aso-identidade-step__switch-label"
  }, [_c('span', {
    staticClass: "aso-identidade-step__switch-text"
  }, [_vm._v("Deseja editar suas informações? "), _c('strong', [_vm._v(_vm._s(_vm.editavel ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('span', {
    staticClass: "aso-identidade-step__switch",
    class: {
      'aso-identidade-step__switch--on': _vm.editavel
    },
    attrs: {
      "role": "switch",
      "aria-checked": String(_vm.editavel),
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      }]
    }
  }, [_c('span', {
    staticClass: "aso-identidade-step__switch-thumb"
  })])])]), _vm._v(" "), (_vm.editavel) ? _c('div', {
    staticClass: "aso-identidade-step__warning-card"
  }, [_c('div', {
    staticClass: "aso-identidade-step__warning-header"
  }, [_c('svg', {
    staticClass: "aso-identidade-step__warning-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2L1 21h22L12 2z",
      "fill": "#ffc107",
      "stroke": "#e6ac00",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "12",
      "y": "18",
      "text-anchor": "middle",
      "font-size": "14",
      "font-weight": "bold",
      "fill": "#5a4000"
    }
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__warning-text"
  }, [_vm._v("Para atualizar o cadastro, todos os campos precisam ser editados:")])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Nome completo")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editavel || _vm.busy,
      "placeholder": "Nome completo"
    },
    domProps: {
      "value": _vm.editavel ? _vm.nome : _vm.maskedNome
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:nome', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "14",
      "disabled": !_vm.editavel || _vm.busy,
      "placeholder": "000.000.000-00"
    },
    domProps: {
      "value": _vm.editavel ? _vm.cpf : _vm.maskedCpf
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:cpf', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "disabled": !_vm.editavel || _vm.busy
    },
    domProps: {
      "value": _vm.sexo
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:sexo', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Feminino")])])]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "date",
      "disabled": !_vm.editavel || _vm.busy
    },
    domProps: {
      "value": _vm.dataNascimento
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:dataNascimento', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Salvando...' : (_vm.editavel ? 'Salvar e continuar' : 'Continuar')) + "\n    ")])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "aso-identidade-step__warning-list"
  }, [_c('li', [_vm._v("Nome")]), _vm._v(" "), _c('li', [_vm._v("CPF")]), _vm._v(" "), _c('li', [_vm._v("Sexo")]), _vm._v(" "), _c('li', [_vm._v("Data de Nascimento")])])
}]}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66) || (_vm.formData.tipo_status && _vm.formData.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.formData.updated_at,
      "title": "Atenção"
    }
  })], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para salvar as alterações efetuadas",
      "value": "Salvar Alterações"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-times",
      "type": "danger",
      "value": "Prosseguir com o Calcelamento"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Função' : 'Editar Função',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Função",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatFuncao,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.format,
      "value-format": _vm.format,
      "format": _vm.format,
      "picker-options": _vm.handleDateOptions,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Enviando mensagem de teste..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'Enviar WhatsApp de Teste :: Conta ' + (this.parent ? this.parent.formData.nome : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-categoria"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Gerenciar Categoria\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaCategoria', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.boolExibir) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-colunas"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-columns"
  }), _vm._v(" Gerenciar Colunas\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaColuna', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Enviar Orçamento por Email",
      "modal": _vm.showFormEmail,
      "loadingSave": _vm.loadingTable,
      "onSave": _vm.proposta,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("QUANTIDADE")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("VALOR (R$)")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("ATUALIZAÇÃO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [_c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTO DAS MEDIÇÕES\n        ")], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicosMedicao), function(data, i) {
    return _c('b-tr', {
      key: i + 1000
    }, [_c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.nome) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.total) + "\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          " + _vm._s(data.valor_venda) + "\n          "), (
      _vm.response.options &&
      _vm.response.options.data &&
      _vm.response.options.data[data.id]
    ) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v(_vm._s(_vm.response.options.data[data.id][0]) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7.5pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_vm._v("\n          ---\n        ")])], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL MEDIÇÕES\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_medicao) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold",
      "height": "40px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-usd",
      "type": "text"
    }
  }), _vm._v("\n          CUSTOS DOS SERVIÇOS\n        ")], 1), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#f9f6db",
      "font-weight": "bold"
    }
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "title": "Inserir Novo Serviço",
      "value": "Inserir Novo Serviço"
    },
    on: {
      "click": function($event) {
        return _vm.onRegister()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.servicos), function(data, i) {
    return _c('b-tr', {
      key: i
    }, [_c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (data.descricao),
        callback: function($$v) {
          _vm.$set(data, "descricao", $$v)
        },
        expression: "data.descricao"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.qtde),
        callback: function($$v) {
          _vm.$set(data, "qtde", $$v)
        },
        expression: "data.qtde"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [_c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "change": _vm.formataCustoServicos
      },
      model: {
        value: (data.valor),
        callback: function($$v) {
          _vm.$set(data, "valor", $$v)
        },
        expression: "data.valor"
      }
    })], 1), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.usuario) ? _c('div', [_vm._v("\n            " + _vm._s(data.usuario.usuario)), _c('br'), _vm._v("\n            " + _vm._s(_vm.toDate(data.updated_at)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      style: ('font-size:7pt !important;background:' +
        (i % 2 == 0 ? '#E6E6E6' : '')),
      attrs: {
        "valign": "middle"
      }
    }, [(data.padrao == 0) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini",
        "title": "Deletar Registro"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(i)
        }
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold",
      "height": "40px"
    }
  }, [_vm._v("\n          TOTAL SERVIÇOS\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.qtde_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.valor_servico) + "\n        ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "background": "#deeef9",
      "font-weight": "bold"
    }
  })], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-right d-flex flex-row-reverse bd-highlight",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-center col-sm-12 col-md-6 col-lg-5 col-xl-4",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [_c('b-table-simple', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticClass: "table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CUSTO TOTAL")])], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n            DESCONTOS\n          ")]), _vm._v(" "), _c('b-td', {
    staticStyle: {
      "color": "#dd5a5a",
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_c('el-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "change": _vm.formataCustoTotal
    },
    model: {
      value: (_vm.formData.valor_desconto),
      callback: function($$v) {
        _vm.$set(_vm.formData, "valor_desconto", $$v)
      },
      expression: "formData.valor_desconto"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Custo Total\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_total))])])], 1), _vm._v(" "), _c('b-tr', [_c('b-td', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "right",
      "font-size": "18px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            Lucro Líquido\n            "), _c('span', {
    staticStyle: {
      "color": "#699e62"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.formData.valor_lucro))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#699e62",
      "font-size": "15px !important"
    }
  }, [_vm._v("(" + _vm._s(_vm.formData.percent_lucro) + "%)")])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "primary",
      "value": "Salvar Orçamento"
    },
    on: {
      "click": _vm.salvar
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-search-plus",
      "type": "warning",
      "value": "Prévia do Orçamento"
    },
    on: {
      "click": _vm.previa
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "success",
      "value": "Enviar Orçamento"
    },
    on: {
      "click": function($event) {
        _vm.showFormEmail = !_vm.showFormEmail
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (this.config.loading.content),
      expression: "this.config.loading.content"
    }],
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-end"
    },
    slot: "form-end"
  }, [_c('ed-button', {
    attrs: {
      "type": "warning",
      "value": "Gerar Documento",
      "icon": "fa fa-file-word-o",
      "title": "Clique aqui para gerar o LTCAT no formato .DOC"
    },
    on: {
      "click": _vm.gerarDocumento
    }
  }), _vm._v(" "), (_vm.formData.id > 0) ? _c('div', {
    staticClass: "col-12 text-left mt-3"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-ghe"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Setores\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatGhe', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1), _vm._v(" "), (this.validarPermissao(576)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-docs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Documentos e Anexos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatAnexo', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.validarPermissao(577)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-orcamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamentos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatOrcamento', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.parceiroItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Fator de Risco desse Laboratório",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Fator de Risco desse Laboratório")]), _vm._v(" "), _c('FatorRisco', {
    attrs: {
      "laboratorio": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": "Formulário de Cadasto de Consulta em Lote",
      "width": "99%",
      "onSave": _vm.salvar,
      "onClose": _vm.fechar
    }
  }, [(_vm.formData.data_age) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Selecione o(s) Trabalhador(es)\n        ")]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Trabalhadores",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.list.funcionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": function($event) {
        return _vm.formatarFuncionario(_vm.formData.funcionario)
      }
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Data do Agendamento da Consulta",
      "info": "A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.",
      "disabled": !_vm.formData.funcionarios.length,
      "yesterdayDisabled": "",
      "tomorrowDisabled": ""
    },
    model: {
      value: (_vm.formData.data_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_age", $$v)
      },
      expression: "formData.data_age"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Observações",
      "type": "textarea",
      "disabled": !_vm.formData.funcionarios.length
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  }), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações da Consulta\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('b-table-simple', {
    attrs: {
      "hover": "",
      "small": "",
      "caption-top": "",
      "responsive": ""
    }
  }, [_c('b-thead', {
    staticClass: "table-v2",
    attrs: {
      "head-variant": "light"
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("Trabalhador")]), _vm._v(" "), _c('b-th', [_vm._v("Função")]), _vm._v(" "), _c('b-th', [_vm._v("Frente de Trabalho")]), _vm._v(" "), _c('b-th', [_vm._v("GHE (Setor)")]), _vm._v(" "), _c('b-th', [_vm._v("Tipo de Consulta")]), _vm._v(" "), _c('b-th', [_vm._v("Remover")])], 1)], 1), _vm._v(" "), _c('b-tbody', _vm._l((_vm.formData.funcionarios), function(funcionario, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.nome) + "\n                "), (_vm.getError(funcionario)) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "7pt"
      }
    }, [_c('br'), _vm._v("\n                  " + _vm._s(_vm.getError(funcionario)) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.funcao ? funcionario.funcao.nome : "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.fdt && funcionario.fdt.pcmso ?
      funcionario.fdt.pcmso +
      " (" +
      funcionario.fdt.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.ghe && funcionario.ghe.ghe ?
      funcionario.ghe.ghe +
      " (" +
      funcionario.ghe.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('el-collapse', {
      attrs: {
        "title": "Clique para mostrar mais informações"
      },
      model: {
        value: (funcionario.collapse),
        callback: function($$v) {
          _vm.$set(funcionario, "collapse", $$v)
        },
        expression: "funcionario.collapse"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [(
      funcionario.collapse && funcionario.collapse[0]
    ) ? _c('i', {
      staticClass: "fa fa-minus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }) : _c('i', {
      staticClass: "fa fa-plus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }), _vm._v("\n                        " + _vm._s(_vm.formatarTipoConsulta(funcionario)) + "\n                      ")]), _vm._v(" "), _c('ed-input-select-tipo', {
      key: index,
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "name": 'id_tipo_aso_' + index,
        "tipo": "46",
        "isRadio": "",
        "required": ""
      },
      model: {
        value: (funcionario.id_tipo_aso),
        callback: function($$v) {
          _vm.$set(funcionario, "id_tipo_aso", $$v)
        },
        expression: "funcionario.id_tipo_aso"
      }
    }, [(funcionario.id_tipo_aso == 50) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' + index + '_50'
      },
      slot: 'id_tipo_aso_' + index + '_50'
    }, [_c('div', {
      staticClass: "row ml-0 mr-0 mb-0"
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Frente de Trabalho",
        "items": _vm.list.fdt,
        "loading": _vm.loadingFdt,
        "itemText": "fdt",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getGhe(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_fdt),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_fdt", $$v)
        },
        expression: "funcionario.id_mf_fdt"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Novo GHE (Setor)",
        "items": _vm.list.ghe,
        "loading": _vm.loadingGhe,
        "disabled": !funcionario.id_mf_fdt,
        "itemGroup": "",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getFuncao(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_ghe),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_ghe", $$v)
        },
        expression: "funcionario.id_mf_ghe"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Função",
        "items": _vm.list.funcao,
        "loading": _vm.loadingFuncao,
        "disabled": !funcionario.id_mf_fdt ||
          !funcionario.id_mf_ghe,
        "required": ""
      },
      model: {
        value: (funcionario.id_mf_funcao),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_funcao", $$v)
        },
        expression: "funcionario.id_mf_funcao"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (
      funcionario.id_tipo_aso == 52 ||
      funcionario.id_tipo_aso == 48
    ) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' +
          index +
          '_' +
          funcionario.id_tipo_aso
      },
      slot: 'id_tipo_aso_' +
        index +
        '_' +
        funcionario.id_tipo_aso
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Periodicidade",
        "items": _vm.listaPeriodicidade(funcionario),
        "required": ""
      },
      model: {
        value: (funcionario.periodicidade),
        callback: function($$v) {
          _vm.$set(funcionario, "periodicidade", $$v)
        },
        expression: "funcionario.periodicidade"
      }
    })], 1) : _vm._e()])], 2)], 1)], 1), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(funcionario)
        }
      }
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Mensagem Email :: ' + _vm.formData.id,
      "modal": _vm.showFormMsg,
      "width": "95%",
      "isModal": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.mensagem)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getLog,
      "onFilter": _vm.getLog,
      "onRegister": _vm.onRegister ? _vm.onRegister : null,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disabledConfigCell": _vm.disabledConfigCell,
      "filterBadge": _vm.filterBadge,
      "disableCheckAll": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Desativar Nova Empresa",
      "onRegister": (this.validarPermissao(310) ? _vm.onRegister : null),
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getDesativado,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFormList) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFormList = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Processar Lote " + _vm._s(_vm.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFormList = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "processar-actions"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--primary",
    on: {
      "click": function($event) {
        return _vm.onRegister(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Processar Lote\n            ")])]), _vm._v(" "), _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingContent,
      "pagination": _vm.pagination,
      "onSearch": _vm.getEsocialLotesProcessar,
      "disableCheckAll": true
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModo) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModo = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Selecione o modo de transmissão do arquivo")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModo = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "modo-info"
  }, [_c('div', {
    staticClass: "modo-info__row"
  }, [_c('b', [_vm._v("Inclusão")]), _vm._v(" "), _c('span', [_vm._v("Selecione esta opção na primeira vez que enviar o lote ou quando a tentativa de inclusão foi rejeitada.")])]), _vm._v(" "), _c('div', {
    staticClass: "modo-info__row"
  }, [_c('b', [_vm._v("Alteração")]), _vm._v(" "), _c('span', [_vm._v("Selecione esta opção para alterar o evento. Nesse ponto deve existir um lote de inclusão enviado.")])])]), _vm._v(" "), (_vm.tableData && _vm.tableData.length > 0) ? _c('div', {
    staticClass: "modo-ultimo",
    class: {
      'modo-ultimo--erro': _vm.tableData[0]._data.status != '201'
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.tableData[0]._data.status == '201' ? 'fa-check-circle' : 'fa-exclamation-triangle'
  }), _vm._v(" "), _c('div', [_c('b', [_vm._v("Último lote enviado:")]), _vm._v("\n              " + _vm._s(_vm.parseModo(_vm.tableData[0]._data.modo)) + " em " + _vm._s(_vm.toDate(_vm.tableData[0]._data.created_at, false)) + "\n              "), (_vm.tableData[0]._data.status != '201') ? _c('div', {
    staticClass: "modo-ultimo__aviso"
  }, [_vm._v("\n                Lote não processado. Verifique o detalhamento do processamento.\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modo-options"
  }, [_c('button', {
    staticClass: "modo-option modo-option--inclusao",
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'inc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "modo-option__title"
  }, [_vm._v("Inclusão")]), _vm._v(" "), _c('span', {
    staticClass: "modo-option__desc"
  }, [_vm._v("Primeiro envio do lote, ou reenvio após rejeição.")])]), _vm._v(" "), (_vm.formData && _vm.formData.layout != 'S-3000') ? _c('button', {
    staticClass: "modo-option modo-option--alteracao",
    on: {
      "click": function($event) {
        return _vm.onRegister(null, 'alt')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('span', {
    staticClass: "modo-option__title"
  }, [_vm._v("Alteração")]), _vm._v(" "), _c('span', {
    staticClass: "modo-option__desc"
  }, [_vm._v("Altera um evento já incluído anteriormente.")])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showLogs) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showLogs = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("\n            Status processamento " + _vm._s(_vm.formDataLogs.protocolo ? _vm.formDataLogs.protocolo : "") + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showLogs = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "processar-log"
  }, [_vm._l((_vm.formDataLogs.log_retorno), function(retorno, i) {
    return _c('div', {
      key: i,
      staticClass: "processar-log__item",
      class: retorno.ocorrencias && retorno.ocorrencias.length ?
        'processar-log__item--error' :
        'processar-log__item--success'
    }, [_c('div', {
      staticClass: "processar-log__status",
      class: {
        'processar-log__status--error': retorno.ocorrencias && retorno.ocorrencias.length
      }
    }, [_c('i', {
      staticClass: "fa",
      class: retorno.ocorrencias && retorno.ocorrencias.length ? 'fa-exclamation-triangle' : 'fa-check-circle'
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(retorno.cdResposta))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(retorno.descResposta))])]), _vm._v(" "), (retorno.uid) ? _c('div', {
      staticClass: "processar-log__arquivo"
    }, [_c('div', {
      staticClass: "processar-log__arquivo-row"
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(retorno.uid))])]), _vm._v(" "), (retorno.recibo) ? _c('div', {
      staticClass: "processar-log__arquivo-recibo"
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Recibo: " + _vm._s(retorno.recibo) + "\n                ")]) : _vm._e(), _vm._v(" "), (retorno.funcionario) ? _c('div', {
      staticClass: "processar-log__arquivo-funcionario"
    }, [_vm._v("\n                  " + _vm._s(retorno.funcionario) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (retorno.ocorrencias && retorno.ocorrencias.length) ? _c('div', {
      staticClass: "processar-log__ocorrencias"
    }, _vm._l((retorno.ocorrencias), function(ocorrencia, j) {
      return _c('div', {
        key: j,
        staticClass: "processar-log__ocorrencia"
      }, [_c('b', [_vm._v(_vm._s(ocorrencia.codigo))]), _vm._v(" " + _vm._s(ocorrencia.descricao) + "\n                  "), (ocorrencia.localizacao) ? _c('span', {
        staticClass: "processar-log__ocorrencia-loc"
      }, [_vm._v("\n                    em " + _vm._s(ocorrencia.localizacao) + "\n                  ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), _vm._v(" "), (!_vm.formDataLogs.log_retorno || !_vm.formDataLogs.log_retorno.length) ? _c('div', {
    staticClass: "processar-log__empty"
  }, [_vm._v("\n              Nenhum detalhe de envio disponível.\n            ")]) : _vm._e()], 2)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showLogsReq) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showLogsReq = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v(_vm._s(_vm.titleLogsReq) + " Lote " + _vm._s(_vm.formData.lote))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showLogsReq = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('pre', {
    staticClass: "xml-viewer"
  }, [_vm._v(_vm._s(_vm.formatXml(_vm.messageLogsReq)))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled ? true : false,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "remote": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      },
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Nova Coluna' : 'Editar Coluna') + ' :: ' + _vm.tabela.nome,
      "modal": _vm.showForm,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "99%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [(_vm.formData.id_tipo_campo == 210 || _vm.formData.id_tipo_campo == 211 || _vm.formData.id_tipo_campo == 212 || _vm.formData.id_tipo_campo == 217) ? _c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Valores', {
    attrs: {
      "parent": this
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Coluna",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaColuna,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.content,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Laboratorios', {
    attrs: {
      "parent": this
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.consulta
    }
  }), _vm._v(" "), _c('Lote', {
    attrs: {
      "showLote": _vm.showLote,
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Nova Consulta",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-copy",
      "type": "success",
      "value": "Gerar Consulta em Lote",
      "title": "Clique aqui para gerar várias consultas ao mesmo tempo."
    },
    on: {
      "click": _vm.onLote
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto a liberação é concluída..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'LIBERAR ASO' + _vm.title,
      "modal": _vm.parent.showLiberacao,
      "loadingSave": _vm.config.loading.save,
      "loading": _vm.config.loading.content,
      "onSave": _vm.asoLiberada || _vm.asoNaoAssinada || _vm.asoSemUploadOuConfig ? null : _vm.salvar,
      "currentTab": _vm.tagConfig
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), (_vm.asoLiberada) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "Consulta já liberada",
      "closable": false,
      "description": "A consulta já está liberada e não pode ser liberada novamente.",
      "type": "success",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && _vm.asoNaoAssinada) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "ASO não assinado pelo funcionário",
      "closable": false,
      "description": "O funcionário ainda não assinou o ASO. A assinatura é obrigatória antes da liberação.",
      "type": "warning",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && !_vm.asoNaoAssinada && _vm.asoSemUploadOuConfig) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "Upload do ASO ou configuração da empresa necessários",
      "closable": false,
      "description": "É necessário fazer o upload do ASO previamente, ou habilitar as opções 'Assinar ASO com Certificado' e 'Incluir Assinatura no ASO' no cadastro da empresa.",
      "type": "warning",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && !_vm.asoNaoAssinada && !_vm.asoSemUploadOuConfig) ? _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n            Histórico de Liberação\n          ")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaLiberacao,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'Desativar nova Empresa',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.disparoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "loading": _vm.loading,
      "title": (_vm.title ? _vm.title : _vm.value),
      "size": _vm.size,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO XML",
      "modal": _vm.parent.showNovoXml,
      "onSave": _vm.salvar,
      "isModal": false,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Selecione um Layout",
      "items": _vm.getTabelas(),
      "required": ""
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Empresa",
      "name": "id_emp",
      "items": _vm.bind.empresas,
      "loading": _vm.bind.loadingEmpresa,
      "disabled": !_vm.formData.layout,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEmpresa,
      "input": _vm.setEmpresa
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Trabalhador (a)",
      "name": "id_fun",
      "items": _vm.bind.funcionarios,
      "loading": _vm.bind.loadingFuncionario,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2240') ? _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "name": "valor.id_fdt",
      "items": _vm.bind.fdt,
      "loading": _vm.bind.loadingFdt,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.valor.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_fdt", $$v)
      },
      expression: "formData.valor.id_fdt"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Categoria do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200",
      "items": _vm.bind.categorias,
      "loading": _vm.bind.loadingCategoria,
      "clearable": ""
    },
    on: {
      "search": _vm.getCategoria
    },
    model: {
      value: (_vm.formData.valor.id_esocial_categoria),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_esocial_categoria", $$v)
      },
      expression: "formData.valor.id_esocial_categoria"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Mátricula do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200"
    },
    model: {
      value: (_vm.formData.valor.matricula),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "matricula", $$v)
      },
      expression: "formData.valor.matricula"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2220') ? _c('s2220', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.layout == 'S-2240' && _vm.formData.id_emp && _vm.formData.id_fun && _vm.formData.valor.id_fdt) ? _c('s2240', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo LTCAT",
      "onRegister": (!_vm.validarPacote(27) ? null : _vm.onRegister),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcat,
      "onFilter": _vm.getLtcat,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.ultima_revisao) ? _c('ed-alert', {
    staticClass: "text-left",
    attrs: {
      "title": "Última Revisão desse LTCAT",
      "type": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [(_vm.ultima_revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.parent.rev) + " (" + _vm._s(_vm.ultima_revisao.parent.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.parent.data, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.rev) + " (" + _vm._s(_vm.ultima_revisao.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.data, true)) + ")\n\t\t\t\t\t")])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HistoricoWhatsapp', {
    attrs: {
      "parent": this,
      "endpoint": "empresa/funcionario/historico-whatsapp",
      "id-antes-do-sufixo": false
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getFuncionario,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHedad,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Os Fatores de Riscos listados abaixo devem ser vinculados aos riscos mostrados em Configurações > Riscos"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Fator de Risco",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getFatorRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onFilter": _vm.getFatorRisco,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', [_c('ed-input-select-tipo', {
    staticClass: "col-12",
    attrs: {
      "label": "Filtrar por Categopria",
      "name": "cat_esocial",
      "tipo": "269",
      "valueKey": "descricao",
      "multiple": ""
    },
    model: {
      value: (_vm.formFilter.cat_esocial),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "cat_esocial", $$v)
      },
      expression: "formFilter.cat_esocial"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (this.$store.state.ltcat.title + ' Novo GHE'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": (_vm.tagConfig == 'tab-cadastro' ? this.salvar : null),
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Nova Linha"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.config.loading.content || _vm.config.loading.copiar,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo d-none d-sm-inline d-xl-inline",
    attrs: {
      "src": __webpack_require__(260),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Endereço incompleto...")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.url) ? _c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n    Por exemplo: "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.url) + "/"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("url-da-clinica")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Para acessar essa página você deve fornecer a "), _c('i', [_vm._v("URL")]), _vm._v(" da sua clínica de medicina do Trabalho.\n  ")])
}]}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c('ckeditor', {
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "config": _vm.editorConfig,
      "disabled": _vm.disabled,
      "read-only": _vm.readonly,
      "tag-name": "textarea",
      "editor-url": _vm.editorUrl
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "click": _vm.salvar,
      "loading": _vm.loadingSave,
      "value": "Salvar"
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(260),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Algo deu errado...")]), _vm._v(" "), (_vm.erro) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.erro) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
}]}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n      Informações do Trabalhador(a)\n    ")]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 pa-0",
    attrs: {
      "label": "Trabalhador (a)",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.list.funcionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.formatarFuncionario
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5",
    attrs: {
      "label": "Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "disabled": !_vm.formData.funcionario,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getFuncao
    },
    model: {
      value: (_vm.formData.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_fdt", $$v)
      },
      expression: "formData.id_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5",
    attrs: {
      "label": "Função",
      "items": _vm.list.funcao,
      "loading": _vm.loadingFuncao,
      "disabled": !_vm.formData.funcionario || !_vm.formData.id_fdt,
      "required": ""
    },
    on: {
      "input": _vm.getGHE
    },
    model: {
      value: (_vm.formData.id_funcao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_funcao", $$v)
      },
      expression: "formData.id_funcao"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "GHE (Setor)",
      "items": _vm.list.ghe,
      "loading": _vm.loadingGhe,
      "disabled": !_vm.formData.funcionario || !_vm.formData.id_fdt || !_vm.formData.id_funcao,
      "itemGroup": "",
      "required": ""
    },
    model: {
      value: (_vm.formData.id_ghe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_ghe", $$v)
      },
      expression: "formData.id_ghe"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3",
    attrs: {
      "label": "Data do Agendamento da Consulta",
      "info": "A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe,
      "maxDaysTomorrow": 15
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.data_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_age", $$v)
      },
      expression: "formData.data_age"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Observações",
      "type": "textarea",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n      Informações da Consulta\n    ")]), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Tipo de Consulta",
      "name": "id_tipo_aso",
      "tipo": "46",
      "disabled": !_vm.formData.funcionario ||
        !_vm.formData.id_fdt ||
        !_vm.formData.id_funcao ||
        !_vm.formData.id_ghe ||
        !_vm.formData.data_age,
      "disabledItem": _vm.disabilitarConsulta,
      "isRadio": "",
      "required": ""
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.id_tipo_aso),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_tipo_aso", $$v)
      },
      expression: "formData.id_tipo_aso"
    }
  }, [(_vm.formData.id_tipo_aso == 50) ? _c('div', {
    staticClass: "pb-1",
    attrs: {
      "slot": "id_tipo_aso_50"
    },
    slot: "id_tipo_aso_50"
  }, [_c('div', {
    staticClass: "row ml-0 mr-0 mb-0"
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Nova Frente de Trabalho",
      "items": _vm.list.fdt,
      "loading": _vm.loadingFdt,
      "disabled": !_vm.formData.funcionario,
      "itemText": "fdt",
      "required": ""
    },
    on: {
      "input": _vm.getGheMudancaFuncao
    },
    model: {
      value: (_vm.formData.id_mf_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_fdt", $$v)
      },
      expression: "formData.id_mf_fdt"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-4",
    attrs: {
      "label": "Novo GHE (Setor)",
      "items": _vm.list.mf_ghe,
      "loading": _vm.loadingGhe,
      "disabled": !_vm.formData.id_mf_fdt,
      "itemGroup": "",
      "required": ""
    },
    on: {
      "input": _vm.getFuncaoMudancaFuncao
    },
    model: {
      value: (_vm.formData.id_mf_ghe),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_ghe", $$v)
      },
      expression: "formData.id_mf_ghe"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5",
    attrs: {
      "label": "Nova Função",
      "items": _vm.list.mf_funcao,
      "loading": _vm.loadingFuncao,
      "disabled": !_vm.formData.id_mf_fdt || !_vm.formData.id_mf_ghe,
      "required": ""
    },
    on: {
      "input": _vm.getCredenciada
    },
    model: {
      value: (_vm.formData.id_mf_funcao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_mf_funcao", $$v)
      },
      expression: "formData.id_mf_funcao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.formData.id_tipo_aso == 52 || _vm.formData.id_tipo_aso == 48) ? _c('div', {
    staticClass: "pb-1",
    attrs: {
      "slot": 'id_tipo_aso_' + _vm.formData.id_tipo_aso
    },
    slot: 'id_tipo_aso_' + _vm.formData.id_tipo_aso
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3",
    attrs: {
      "label": "Periodicidade",
      "items": _vm.listaPeriodicidade,
      "loading": !_vm.$root.$session.pcmso,
      "required": ""
    },
    model: {
      value: (_vm.formData.periodicidade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "periodicidade", $$v)
      },
      expression: "formData.periodicidade"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(
    _vm.formData.id_tipo_aso != 50 ||
    (_vm.formData.id_tipo_aso == 50 &&
      _vm.formData.id_mf_fdt &&
      _vm.formData.id_mf_ghe &&
      _vm.formData.id_mf_funcao)
  ) ? _c('div', {
    staticClass: "col-md-12 pa-0"
  }, [_c('ed-credenciada', {
    attrs: {
      "parent": this
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center mt-5",
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "size": "big",
      "icon": "fa fa-floppy-o",
      "label": "Gerar Consulta",
      "disabled": !_vm.formData.id_tipo_aso || !Array.isArray(_vm.tabela_preco),
      "title": !_vm.formData.id_tipo_aso ?
        'Para continuar selecione o tipo da consulta' :
        'Clique aqui para gerar a consulta'
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Aqui você pode inserir uma nova categoria para classificar uma coluna se houver necessidade."
    }
  }), _vm._v(" "), _c('CategoriaEdit', {
    attrs: {
      "tabela": _vm.tabela,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Categoria",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaCategoria,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showDialog,
      "width": "900px",
      "top": "4vh",
      "close-on-click-modal": false,
      "custom-class": "whatsapp-templates-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "wtd-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "wtd-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wtd-header-title"
  }, [_vm._v("Templates de Mensagem")]), _vm._v(" "), _c('div', {
    staticClass: "wtd-header-subtitle"
  }, [_vm._v(_vm._s(_vm.parent && _vm.parent.formData ? _vm.parent.formData.nome : ''))])])]), _vm._v(" "), _c('el-tabs', {
    staticClass: "wtd-tabs",
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Templates Cadastrados",
      "name": "lista"
    }
  }, [_c('div', {
    staticClass: "templates-toolbar"
  }, [(!_vm.loadingList) ? _c('span', {
    staticClass: "templates-count"
  }, [_vm._v("\n          " + _vm._s(_vm.templates.length) + " template" + _vm._s(_vm.templates.length === 1 ? '' : 's') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "templates-toolbar-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "fa fa-refresh",
      "loading": _vm.loadingList
    },
    on: {
      "click": _vm.carregarTemplates
    }
  }, [_vm._v("\n            Atualizar\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "fa fa-plus"
    },
    on: {
      "click": _vm.abrirNovo
    }
  }, [_vm._v("\n            Novo Template\n          ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingList),
      expression: "loadingList"
    }],
    staticClass: "templates-list"
  }, [(!_vm.loadingList && _vm.templates.length === 0 && !_vm.listError) ? _c('div', {
    staticClass: "templates-empty"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('p', [_vm._v("Nenhum template encontrado nesta conta")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.templates), function(row) {
    return _c('div', {
      key: row.id || row.name,
      staticClass: "template-card",
      on: {
        "click": function($event) {
          return _vm.visualizarTemplate(row)
        }
      }
    }, [_c('div', {
      staticClass: "template-card-icon",
      class: 'is-' + (row.category || '').toLowerCase()
    }, [_c('i', {
      class: _vm.categoriaIcone(row.category)
    })]), _vm._v(" "), _c('div', {
      staticClass: "template-card-main"
    }, [_c('div', {
      staticClass: "template-card-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "template-card-meta"
    }, [_vm._v("\n              " + _vm._s(_vm.categoriaLabel(row.category)) + " · " + _vm._s(_vm.idiomaLabel(row.language)) + "\n            ")])]), _vm._v(" "), _c('span', {
      staticClass: "template-status",
      class: 'is-' + (row.status || '').toLowerCase()
    }, [_c('i', {
      class: _vm.statusIcone(row.status)
    }), _vm._v("\n            " + _vm._s(_vm.statusLabel(row.status)) + "\n          ")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right template-card-chevron"
    })])
  })], 2), _vm._v(" "), (_vm.listError) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.listError) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Visualizar",
      "name": "visualizar",
      "disabled": !_vm.templateSelecionado
    }
  }, [(_vm.templateSelecionado) ? _c('div', {
    staticClass: "template-preview"
  }, [_c('div', {
    staticClass: "template-preview-header"
  }, [_c('div', [_c('strong', {
    staticClass: "template-preview-name"
  }, [_vm._v(_vm._s(_vm.templateSelecionado.name))]), _vm._v(" "), _c('span', {
    staticClass: "template-status",
    class: 'is-' + (_vm.templateSelecionado.status || '').toLowerCase(),
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('i', {
    class: _vm.statusIcone(_vm.templateSelecionado.status)
  }), _vm._v("\n              " + _vm._s(_vm.statusLabel(_vm.templateSelecionado.status)) + "\n            ")])]), _vm._v(" "), _c('span', {
    staticClass: "template-preview-meta"
  }, [_vm._v("\n            " + _vm._s(_vm.categoriaLabel(_vm.templateSelecionado.category)) + " · " + _vm._s(_vm.idiomaLabel(_vm.templateSelecionado.language)) + "\n          ")])]), _vm._v(" "), (_vm.templateSelecionado.status === 'REJECTED' && _vm.templateSelecionado.rejected_reason) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Motivo da rejeição: " + _vm._s(_vm.templateSelecionado.rejected_reason) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview-stage"
  }, [_c('div', {
    staticClass: "whatsapp-bubble"
  }, _vm._l((_vm.templateSelecionado.components), function(comp, idx) {
    return _c('div', {
      key: idx,
      staticClass: "whatsapp-bubble-component"
    }, [(comp.type === 'HEADER') ? _c('div', {
      staticClass: "whatsapp-bubble-header"
    }, [(comp.format === 'TEXT') ? [_vm._v(_vm._s(comp.text))] : [_vm._v("[Cabeçalho: " + _vm._s(comp.format) + "]")]], 2) : (comp.type === 'BODY') ? _c('div', {
      staticClass: "whatsapp-bubble-body"
    }, [_vm._v(_vm._s(comp.text))]) : (comp.type === 'FOOTER') ? _c('div', {
      staticClass: "whatsapp-bubble-footer"
    }, [_vm._v(_vm._s(comp.text))]) : (comp.type === 'BUTTONS') ? _c('div', {
      staticClass: "whatsapp-bubble-buttons"
    }, _vm._l((comp.buttons), function(btn, bidx) {
      return _c('div', {
        key: bidx,
        staticClass: "whatsapp-bubble-button"
      }, [_vm._v("\n                  " + _vm._s(btn.text) + "\n                ")])
    }), 0) : _vm._e()])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Novo Template",
      "name": "novo"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSave),
      expression: "loadingSave"
    }],
    attrs: {
      "element-loading-text": "Enviando para aprovação da Meta..."
    }
  }, [_c('div', {
    staticClass: "novo-template-layout"
  }, [_c('div', {
    staticClass: "novo-template-form"
  }, [_c('el-form', {
    ref: "formNovo",
    attrs: {
      "label-position": "top",
      "model": _vm.novoTemplate
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      Nome do Template\n                      "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "Apenas letras minúsculas, números e underscore. Ex: confirmacao_agendamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "ex: confirmacao_agendamento",
      "maxlength": "512"
    },
    on: {
      "input": _vm.normalizarNome
    },
    model: {
      value: (_vm.novoTemplate.name),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "name", $$v)
      },
      expression: "novoTemplate.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Idioma"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.novoTemplate.language),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "language", $$v)
      },
      expression: "novoTemplate.language"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Português (BR)",
      "value": "pt_BR"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Inglês (US)",
      "value": "en_US"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Espanhol",
      "value": "es"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoria"
    }
  }, [_c('el-radio-group', {
    staticClass: "category-radio-group",
    model: {
      value: (_vm.novoTemplate.category),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "category", $$v)
      },
      expression: "novoTemplate.category"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "UTILITY"
    }
  }, [_vm._v("Utilidade")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "MARKETING"
    }
  }, [_vm._v("Marketing")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "AUTHENTICATION"
    }
  }, [_vm._v("Autenticação")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cabeçalho (opcional)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Texto do cabeçalho",
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.header),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "header", $$v)
      },
      expression: "novoTemplate.header"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      Corpo da Mensagem\n                      "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                          Use {1}, {2}, etc. para variáveis dinâmicas."), _c('br'), _vm._v("\n                          Ex: Olá {1}, seu exame está agendado para {2}.\n                        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "Ex: Olá {1}, seu exame está agendado para {2}.",
      "maxlength": "1024",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.body),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "body", $$v)
      },
      expression: "novoTemplate.body"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rodapé (opcional)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Texto do rodapé",
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.footer),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "footer", $$v)
      },
      expression: "novoTemplate.footer"
    }
  })], 1)], 1)])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.saveError) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "novo-template-preview"
  }, [_c('div', {
    staticClass: "template-preview-label"
  }, [_vm._v("Pré-visualização")]), _vm._v(" "), _c('div', {
    staticClass: "preview-stage preview-stage-sticky"
  }, [_c('div', {
    staticClass: "whatsapp-bubble"
  }, [(_vm.novoTemplate.header) ? _c('div', {
    staticClass: "whatsapp-bubble-header"
  }, [_vm._v(_vm._s(_vm.novoTemplate.header))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whatsapp-bubble-body"
  }, [_vm._v(_vm._s(_vm.novoTemplate.body || 'O corpo da mensagem aparecerá aqui...'))]), _vm._v(" "), (_vm.novoTemplate.footer) ? _c('div', {
    staticClass: "whatsapp-bubble-footer"
  }, [_vm._v(_vm._s(_vm.novoTemplate.footer))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "novo-template-actions"
  }, [_c('el-button', {
    on: {
      "click": _vm.limparNovo
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave
    },
    on: {
      "click": _vm.enviarTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar para Aprovação da Meta\n          ")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conflitos-detalhe"
  }, [(_vm.item && _vm.item.log_erro && _vm.item.log_erro.length) ? _c('div', {
    staticClass: "conflitos-detalhe__section"
  }, [_c('div', {
    staticClass: "conflitos-detalhe__title conflitos-detalhe__title--erro"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Erro (" + _vm._s(_vm.item.log_erro.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.item.log_erro), function(err, key) {
    return _c('div', {
      key: 'erro-' + key,
      staticClass: "conflitos-detalhe__item conflitos-detalhe__item--erro"
    }, [(err['risco_vinculo']) ? _c('span', [_vm._m(0, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.")]), _vm._v(" "), _vm._l((err['risco_vinculo']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['exame_vinculo']) ? _c('span', [_vm._m(1, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.")]), _vm._v(" "), _vm._l((err['exame_vinculo']), function(exame, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(exame))])
    })], 2) : (err['cadastro_medico']) ? _c('span', [_vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.")]), _vm._v(" "), _vm._l((err['cadastro_medico']), function(exame, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(exame))])
    })], 2) : (err['cadastro_funcionario']) ? _c('span', [_vm._m(3, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.")]), _vm._v(" "), _vm._l((err['cadastro_funcionario']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_reg_amb']) ? _c('span', [_vm._m(4, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.")]), _vm._v(" "), _vm._l((err['cadastro_reg_amb']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [(posicoes.posicao) ? _c('b', [_vm._v(_vm._s(posicoes.posicao) + ":")]) : _vm._e(), _vm._v(" "), (posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (err['cadastro_ppp_fdt']) ? _c('span', [_vm._m(5, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.")]), _vm._v(" "), _vm._l((err['cadastro_ppp_fdt']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [(posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (err['erro_cadastro_fdt']) ? _c('span', [_vm._m(6, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.")]), _vm._v(" "), _vm._l((err['erro_cadastro_fdt']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_sem_risco']) ? _c('span', [_vm._m(7, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.")]), _vm._v(" "), _vm._l((err['cadastro_sem_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['error_cadastro_epi']) ? _c('span', [_vm._m(8, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.")]), _vm._v(" "), _vm._l((err['error_cadastro_epi']), function(epis, i) {
      return [_c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_c('b', [_vm._v(_vm._s(i))])]), _vm._v(" "), _vm._l((epis), function(epi) {
        return _c('p', {
          key: epi,
          staticClass: "conflitos-detalhe__line"
        }, [_vm._v(_vm._s(epi))])
      })]
    })], 2) : (err['cadastro']) ? _c('span', [_vm._m(9, true), _vm._v(" "), _vm._l((err['cadastro']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_abs']) ? _c('span', [_vm._m(10, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro.")]), _vm._v(" "), _vm._l((err['cadastro_abs']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_setor']) ? _c('span', [_vm._m(11, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão.")]), _vm._v(" "), _vm._l((err['erro_cadastro_setor']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_atividade_funcao']) ? _c('span', [_vm._m(12, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador.")]), _vm._v(" "), _vm._l((err['erro_cadastro_atividade_funcao']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_fator_risco']) ? _c('span', [_vm._m(13, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado.")]), _vm._v(" "), _vm._l((err['erro_cadastro_fator_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v("\n          " + _vm._s(risco.msg ? risco.msg : risco) + "\n        ")])
    })], 2) : (err['erro_cadastro_epi_risco']) ? _c('span', [_vm._m(14, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado.")]), _vm._v(" "), _vm._l((err['erro_cadastro_epi_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v("\n          " + _vm._s(risco.msg ? risco.msg : risco) + "\n        ")])
    })], 2) : (err['erro_cadastro_reg_amb']) ? _c('span', [_vm._m(15, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.")])]) : _c('span', [_c('p', {
      staticClass: "conflitos-detalhe__line"
    }, [_vm._v(_vm._s(err))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.item && _vm.item.log_warning && _vm.item.log_warning.length) ? _c('div', {
    staticClass: "conflitos-detalhe__section"
  }, [_c('div', {
    staticClass: "conflitos-detalhe__title conflitos-detalhe__title--warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Pontos de Atenção (" + _vm._s(_vm.item.log_warning.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.item.log_warning), function(warn, key) {
    return _c('div', {
      key: 'warn-' + key,
      staticClass: "conflitos-detalhe__item conflitos-detalhe__item--warning"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(warn)
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.hasContent) ? _c('div', {
    staticClass: "conflitos-detalhe__empty"
  }, [_vm._v("Nenhum conflito encontrado.")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("RISCO SEM VÍNCULO COM ESOCIAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO TRABALHADOR INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DA FRENTE DE TRABALHO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("NENHUM RISCO FOI ENCONTRADO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EPI CADASTRADO INCORRETAMENTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO ABSENTEÍSMO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO GHE (SETOR) INCORRETO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EPI NÃO CADASTRADO PARA O RISCO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("NENHUMA MEDIÇÃO FOI CADASTRADO PARA ESSE LTCAT")])])
}]}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('LiberarASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('DownloadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('UploadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('LembreteAssinatura', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('HistoricoWhatsapp', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Upload de ASO",
      "registerIcon": "fa fa-upload",
      "registerTitle": "Clique aqui para fazer o upload dos ASO e liberar posteriormente",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "onRegister": _vm.validarPermissao(553) ? _vm.onRegister : null,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response,
      "disableCheckAll": ""
    }
  }, [(_vm.validarPermissao(561)) ? _c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "warning",
      "value": "Enviar ASO por Email"
    },
    on: {
      "click": function($event) {
        return _vm.onDownloadASO(null)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "search-detail"
    },
    slot: "search-detail"
  }, [_vm._v("Busca por código da consulta, nome do funcionário ou empresa")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": 'ENVIAR ARQUIVOS POR EMAIL',
      "modal": _vm.showEnviarEmail,
      "onSave": _vm.enviar,
      "saveName": "Enviar Agora",
      "saveIcon": "fa fa-paper-plane",
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingEmailSave),
      expression: "loadingEmailSave"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "warning",
      "description": "Você pode conferir abaixo os ASO`s que serão enviados por email. Nesse etapa você pode alterar o destinatário e customizar uma mensagem para cada empresa. Clique no nome da empresa para visualizar os arquivos e customizar os dados para envio do email.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, _vm._l((_vm.tableDataEmail), function(item, i) {
    return _c('el-collapse-item', {
      key: i,
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [(item[0] && item[0].empresa) ? _c('span', {
      staticStyle: {
        "color": "#3777a2"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-arrow-circle-right"
    }), _vm._v("\n                  " + _vm._s(item[0].empresa.nome) + "\n                  "), _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#666"
      }
    }, [_vm._v(" " + _vm._s(_vm.formData[item[0].empresa.id].consultas.length) + " aso selecionado(s) ")]), _vm._v(" "), (_vm.formData[item[0].empresa.id].error) ? _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#d16868",
        "text-align": "right"
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle faa-flash animated"
    }), _vm._v("\n                    " + _vm._s(_vm.formData[item[0].empresa.id].error) + "\n                  ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Destinatário",
        "prop": "destinatario",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Digite o destinatário (separado por `;` ponto e vírgula)"
      },
      model: {
        value: (_vm.formData[item[0].empresa.id].destinatario),
        callback: function($$v) {
          _vm.$set(_vm.formData[item[0].empresa.id], "destinatario", $$v)
        },
        expression: "formData[item[0].empresa.id].destinatario"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Observações",
        "prop": "obs",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "O conteúdo deste campo será anexado junto com o email enviado para o destinatário..."
      },
      model: {
        value: (_vm.formData[item[0].empresa.id].obs),
        callback: function($$v) {
          _vm.$set(_vm.formData[item[0].empresa.id], "obs", $$v)
        },
        expression: "formData[item[0].empresa.id].obs"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Consultas (ASO)",
        "prop": "consultas",
        "rules": [{
          required: false,
          message: 'Campo Obrigatorio'
        }]
      }
    }, [_c('table', {
      staticClass: "table table-hover has-gutter",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "120"
      }
    }, [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Funcionário")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "200"
      }
    }, [_vm._v("Arquivo")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "width": "200"
      }
    }, [_vm._v("Enviar por Email")])])]), _vm._v(" "), _c('tbody', _vm._l((item), function(consulta, j) {
      return _c('tr', {
        key: i + j
      }, [_c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(consulta.id_con))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(consulta.funcionario.nome))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('Download', {
        attrs: {
          "arquivo": consulta.arquivo
        }
      })], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('el-checkbox', {
        attrs: {
          "label": consulta.id_con,
          "disabled": consulta.tipo_documento && consulta.tipo_documento.id == '82' ? false : true
        },
        model: {
          value: (_vm.formData[item[0].empresa.id].consultas),
          callback: function($$v) {
            _vm.$set(_vm.formData[item[0].empresa.id], "consultas", $$v)
          },
          expression: "formData[item[0].empresa.id].consultas"
        }
      }, [(_vm.formData[item[0].empresa.id].consultas.indexOf(consulta.id_con) != -1) ? _c('span', [_vm._v(" Sim ")]) : _c('span', [_vm._v("Não")])])], 1)])
    }), 0)])])], 1)])], 2)
  }), 1)], 1)], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'EDITAR PÁGINA' + (_vm.formDataEdit.id ? ' ' + _vm.formDataEdit.page : ''),
      "modal": _vm.showFormEdit,
      "onSave": _vm.salvar,
      "saveName": "Salvar",
      "saveIcon": "fa fa-paper-plane",
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "warning",
      "description": "Aqui você pode vincular a página, do PDF, em alguma consulta. Faça isso caso a página em questão não for identificado pelo sistema ou foi identificado incorretamente.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formDataEdit,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItemsEdit
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.formDataEdit.usuario) ? _c('ed-alert', {
    attrs: {
      "type": "success",
      "description": _vm.formDataEdit.usuario.usuario + ' em ' + _vm.formDataEdit.updated_at,
      "title": "Última Atualização"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'DETALHAMENTO DO ARQUIVO ' + (this.parent.upload_pagina && this.parent.upload_pagina.arquivo ? this.parent.upload_pagina.arquivo.name : ''),
      "modal": _vm.parent.showUploadPagina,
      "width": "90%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-detalhe"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v(" Detalhamento do Arquivo")]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getConsultaUploadPagina,
      "onEdit": _vm.onEdit,
      "onEditAll": _vm.onArquivoEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "editAllName": "Enviar Arquivo(s) por Email",
      "editAllIcon": "fa fa-paper-plane",
      "editAllTitle": "Clique aqui para enviar emails para os registros selecionados"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history'
  }), _vm._v("\n            Histórico de Envio de Emails\n          ")]), _vm._v(" "), _c('DownloadAsoEmail', {
    attrs: {
      "parent": this
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("Página " + _vm._s(_vm.pagination.current_page) + " de " + _vm._s(_vm.pagination.last_page))]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-count": _vm.pagination.last_page,
      "current-page": _vm.pagination.current_page
    },
    on: {
      "current-change": _vm.navigation,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v(_vm._s(_vm.pagination.total) + " registro(s)")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "85%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote": _vm.remote,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      },
      "input": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, [(_vm.itemGroup) ? _vm._l((_vm.items), function(item, indexItem) {
    return _c('el-option-group', {
      key: indexItem,
      attrs: {
        "label": _vm.getLabel(item),
        "disabled": _vm.disabled
      }
    }, _vm._l((item.options), function(subItem, indexSubItem) {
      return _c('el-option', {
        key: indexItem + indexSubItem,
        attrs: {
          "label": _vm.getLabel(subItem),
          "value": _vm.getValue(subItem),
          "disabled": _vm.disabled
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.getHtml(subItem))
        }
      })])
    }), 1)
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("description")], 2)
},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "size": _vm.size,
      "loading": _vm.loading,
      "title": _vm.title ? _vm.title : _vm.label,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [(_vm.icon) ? _c('i', {
    class: _vm.$utilidade.getIcone(_vm.icon)
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('TableView', {
    attrs: {
      "registerName": "Inserir Laboratório",
      "onRegister": (this.validarPermissao(570) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Número do Recibo",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.busca),
      callback: function($$v) {
        _vm.$set(_vm.formData, "busca", $$v)
      },
      expression: "formData.busca"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "loading": _vm.loading,
      "disabled": !_vm.formData.id_emp || !_vm.formData.busca ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.erro) ? _c('div', {
    staticClass: "consulta-esocial-erro"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.erro))])]) : _vm._e(), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Recibo")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.busca))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.empresa))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Consultado em")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.data))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row text-left"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.parent.loadingTabelaPreco),
      expression: "parent.loadingTabelaPreco"
    }],
    staticClass: "col-12"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.parent.tabHistorico),
      callback: function($$v) {
        _vm.$set(_vm.parent, "tabHistorico", $$v)
      },
      expression: "parent.tabHistorico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-credenciada"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Credenciadas")]), _vm._v(" "), (!_vm.parent.formData.id_tipo_aso) ? _c('label', [_vm._v("Selecione o Tipo de Consulta")]) : (!_vm.parent.tabela_preco) ? _c('label', [_vm._v("Aguarde...")]) : (_vm.parent.tabela_preco && _vm.parent.tabela_preco.total == 0) ? _c('span', [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Por favor entre em contato conosco no telefone ' +
        _vm.cliente.logged.tel_com +
        ' para maiores informações',
      "title": "Nenhuma credenciada encontrado"
    }
  })], 1) : (_vm.parent.tabela_preco && !Array.isArray(_vm.parent.tabela_preco)) ? _c('span', {
    staticClass: "col-12"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": _vm.parent.tabela_preco,
      "title": "Falha ao Carregar as Credenciadas"
    }
  })], 1) : _c('span', [_c('div', {
    staticClass: "row"
  }, [(_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Para continuar com o cadastro do ASO você deve selecionar a Credenciada. Você tambem pode utilizar os filtros ao lado para buscar alguma credenciada próximo do seu local.",
      "title": "Atenção"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 q-pa-xs"
  }, [_c('div', {
    staticClass: "col-12 q-mb-md",
    staticStyle: {
      "color": "#21ba45"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.parent.tabela_preco.total) + "\n                  "), (_vm.parent.tabela_preco.total == 1) ? _c('label', [_vm._v("credenciada encontrado")]) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco.total > 1) ? _c('label', [_vm._v("credenciadas encontrado")]) : _vm._e()]), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Organizar Credenciadas")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.parent.formFilter.order),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "order", $$v)
      },
      expression: "parent.formFilter.order"
    }
  }, _vm._l((_vm.lstOrganizar), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione"
    },
    on: {
      "change": _vm.getCidade
    },
    model: {
      value: (_vm.parent.formFilter.id_estado),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "id_estado", $$v)
      },
      expression: "parent.formFilter.id_estado"
    }
  }, _vm._l((_vm.estados), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parent.tabela_preco && _vm.parent.tabela_preco) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('span', {
    staticClass: "credenciada-title"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Selecione",
      "disabled": !_vm.parent.formFilter.id_estado
    },
    model: {
      value: (_vm.parent.formFilter.id_cidade),
      callback: function($$v) {
        _vm.$set(_vm.parent.formFilter, "id_cidade", $$v)
      },
      expression: "parent.formFilter.id_cidade"
    }
  }, _vm._l((_vm.cidades), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.parent.tabela_preco), function(tabela_preco, i) {
    return _c('div', {
      key: i,
      staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-item"
    }, [_c('el-card', {
      class: 'box-card col-md-12 mb-3' +
        (_vm.parent.formData.id_tabela_preco == tabela_preco.id ?
          ' box-card-selected' :
          ''),
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [_c('el-radio', {
      attrs: {
        "val": tabela_preco.id,
        "label": tabela_preco.id,
        "title": tabela_preco.credenciada_nome
      },
      model: {
        value: (_vm.parent.formData.id_tabela_preco),
        callback: function($$v) {
          _vm.$set(_vm.parent.formData, "id_tabela_preco", $$v)
        },
        expression: "parent.formData.id_tabela_preco"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.textLimit(tabela_preco.credenciada_nome, 50)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "fas fa-map-marker-alt"
    }), _vm._v("\n                            " + _vm._s(tabela_preco.credenciada_end.toUpperCase()) + ",\n                            " + _vm._s(tabela_preco.credenciada_num) + "\n                            "), (tabela_preco.credenciada_cidade) ? _c('span', [_vm._v("\n                              -\n                              " + _vm._s(tabela_preco.credenciada_cidade.toUpperCase() +
      "/" +
      tabela_preco.credenciada_uf.toUpperCase()) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text-center item",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "35px"
      }
    }, [_vm._v("\n                              " + _vm._s("R$" +
      _vm.getPreco(tabela_preco.valor_total, "unit")) + "\n                            ")]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-size": "25px"
      }
    }, [_c('sup', [_vm._v("\n                                " + _vm._s(_vm.getPreco(tabela_preco.valor_total, "cents")) + "\n                              ")])]), _vm._v(" "), _c('label', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('br'), _vm._v("Valor por cada ASO"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Esses valores podem sofrer alteração, devido a validade dos exames complementares.")])])])], 1)]), _vm._v(" "), (tabela_preco.exames.mascaramento < 0) ? _c('div', {
      staticClass: "text item q-mb-sm pa-1",
      staticStyle: {
        "font-size": "9pt",
        "background": "#d7eaf4"
      }
    }, [_c('b', [_vm._v("Mascaramento")])]) : _vm._e(), _vm._v(" "), (tabela_preco.exames.mascaramento < 0) ? _c('div', {
      staticClass: "text item",
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "far fa-hand-point-right"
    }), _vm._v("\n                        O mascaramento está habilitado: Os exames serão carregados " + _vm._s(Math.abs(tabela_preco.exames.mascaramento)) + " dia(s) antes do vencimento configurado no PCMSO.\n                        \n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text item q-mb-sm mt-1 pa-1",
      staticStyle: {
        "font-size": "9pt",
        "background": "#d7eaf4"
      }
    }, [_c('b', [_vm._v("Exames")])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('i', {
      staticClass: "far fa-hand-point-right"
    }), _vm._v("\n                        Total: " + _vm._s(tabela_preco.total_exames)), _c('br'), _vm._v("\n                        Total Pendente: " + _vm._s(tabela_preco.total_exames_realizar)), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text item text-center q-mt-lg mt-2"
    }, [_c('ed-button', {
      attrs: {
        "size": "mini",
        "value": " Ver Exames",
        "type": "default",
        "icon": "fa fa-search"
      },
      on: {
        "click": function($event) {
          return _vm.onShowExame(tabela_preco)
        }
      }
    })], 1)])], 1)
  }), 0)])]), _vm._v(" "), _c('Exame', {
    attrs: {
      "parent": this,
      "tabela_preco": _vm.tabela_preco,
      "showExame": _vm.showExame
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Exames no PCMSO",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "description": "Na tabela abaixo você pode conferir os exames cadastrados no PCMSO. Esses exames estão vinculados diretamente com o GHE (Setor) seleciona acima.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.parent.formData.id_ghe
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Histórico de Consultas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('span', [_c('Historico', {
    attrs: {
      "funcionario": _vm.parent.formData.funcionario,
      "id_funcao": _vm.parent.formData.id_funcao
    }
  })], 1)])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-token-step"
  }, [_c('h2', {
    staticClass: "aso-token-step__title"
  }, [_vm._v("Digite o código que enviamos por SMS.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-token-step__text"
  }, [_vm._v("\n    Foi enviado para "), _c('strong', [_vm._v(_vm._s(_vm.telefone))]), _vm._v(".\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "aso-token-step__grid"
  }, _vm._l((_vm.values), function(value, index) {
    return _c('input', {
      key: index,
      staticClass: "aso-token-step__digit",
      attrs: {
        "data-token-index": index,
        "data-token-type": "phone",
        "type": "text",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "maxlength": "1",
        "disabled": _vm.busy
      },
      domProps: {
        "value": value
      },
      on: {
        "input": function($event) {
          return _vm.$emit('digit-input', {
            index: index,
            value: $event.target.value
          })
        },
        "keydown": [function($event) {
          return _vm.$emit('digit-keydown', {
            index: index,
            key: $event.key
          })
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.canConfirm && _vm.$emit('confirm')
        }],
        "paste": function($event) {
          index === 0 ? _vm.$emit('paste', $event) : null
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__confirm aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canConfirm
    },
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Validando...' : 'Confirmar Código') + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-token-step__resend aso-flow-button aso-flow-button--quiet aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canResend
    },
    on: {
      "click": function($event) {
        return _vm.$emit('resend')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.resendLabel) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.credenciadaItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.device != 'xs') ? _c('div', [_vm._v("\r\n  ©" + _vm._s(_vm.toDate(null, true, 'YYYY')) + " Todos os Direitos Reservados a "), _c('b', [_vm._v(_vm._s(_vm.cliente.logged.nome))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    class: _vm.getError ? 'is-error' : '',
    attrs: {
      "title": _vm.info,
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.label) ? _c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.label) + "\n\n      "), (_vm.info) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.getError && _vm.getError.length) ? _c('div', {
    staticClass: "text-left mt-1",
    staticStyle: {
      "color": "#e66666",
      "font-size": "9pt"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.getError.join(', ')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.fatorRiscoItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Laboratorios', {
    attrs: {
      "parent": this
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('Config', {
    attrs: {
      "consulta": _vm.formData.result
    }
  }), _vm._v(" "), (false) ? _c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir o ASO desta consulta"
    },
    on: {
      "click": _vm.onASO
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir ASO\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir a Ficha Clínica desta consulta"
    },
    on: {
      "click": _vm.onFemo
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir Ficha Clínica\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "disabled": "",
      "button": "",
      "title": "Clique aqui para Liberar o ASO desta consulta"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Liberar ASO\n              ")])], 1) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.config && _vm.config.loading) ? _c('span', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Processando..."
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: _vm.id,
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.data
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.itens), function(item, i) {
    return (!_vm.config || !_vm.config.hidden || !_vm.config.hidden[item.field]) ? _c('div', {
      key: i,
      class: item.class,
      style: (item.style)
    }, [(item.type == 'group') ? _c('div', {
      staticClass: "col-12 item-group"
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n          " + _vm._s(item.label) + "\n        ")]) : (item.type != 'group') ? _c('el-form-item', {
      class: _vm.error && _vm.error[item.field] ? 'is-error' : '',
      attrs: {
        "label": item.label,
        "title": item.placeholder,
        "rules": _vm.handleRules(item.rules)
      }
    }, [(item.label) ? _c('span', {
      staticStyle: {
        "color": "#636363"
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('span', [(_vm.config.label && _vm.config.label[item.field]) ? _c('label', [_vm._v(_vm._s(_vm.config.label[item.field]))]) : _c('label', [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.info && _vm.tooltipClick) ? _c('el-popover', {
      attrs: {
        "trigger": "click",
        "placement": "top",
        "width": "320",
        "title": item.label,
        "popper-class": "ed-form-info-popover-dark"
      }
    }, [_c('span', [_vm._v(_vm._s(item.info))]), _vm._v(" "), _c('a', {
      attrs: {
        "slot": "reference",
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : (item.info) ? _c('a', {
      attrs: {
        "href": "#",
        "title": item.info
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (item.title && item.title.model) ? _c('el-switch', {
      attrs: {
        "title": _vm.config.description ? _vm.config.description[item.title.model] : '',
        "active-value": 1,
        "inactive-value": 0,
        "active-text": _vm.config.title[item.title.model],
        "inactive-text": ""
      },
      model: {
        value: (_vm.data[item.title.model]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.title.model, $$v)
        },
        expression: "data[item.title.model]"
      }
    }) : _vm._e(), _vm._v(" "), (item.title && item.title.link && _vm.config.click[item.title.link]) ? _c('ed-button', {
      attrs: {
        "type": "text",
        "icon": item.title.icon,
        "value": _vm.config.title[item.title.link]
      },
      on: {
        "click": function($event) {
          _vm.config.click[item.title.link]()
        }
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (item.type == 'text' || item.type == 'password' || item.type == 'textarea' || item.type == 'email' || item.type == 'number') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      class: {
        'input-uppercase': item.mask == 'cnpj' || item.mask == 'documento'
      },
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      on: {
        "input": function($event) {
          item.mask == 'cnpj' || item.mask == 'documento' ? _vm.data[item.field] = (_vm.data[item.field] || '').toUpperCase() : null
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'number') ? _c('el-input-number', {
      attrs: {
        "min": item.min ? item.min : 0,
        "max": item.max ? item.max : 99999999999,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-text' && _vm.config.list[item.select_field]) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (item.mask ? _vm.mask[item.mask] : ''),
        expression: "item.mask ? mask[item.mask] : ''"
      }],
      attrs: {
        "type": item.type,
        "rows": item.rows ? item.rows : 2,
        "maxlength": item.maxlength ? item.maxlength : 5000,
        "clearable": item.clearable ? true : false,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "prefix-icon": item.prefix ? item.prefix : '',
        "placeholder": item.placeholder,
        "show-word-limit": item.maxlength ? true : false,
        "autocomplete": "false"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "slot": "prepend",
        "placeholder": "---",
        "value-key": "id"
      },
      slot: "prepend",
      model: {
        value: (_vm.data[item.select_field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.select_field, $$v)
        },
        expression: "data[item.select_field]"
      }
    }, _vm._l((_vm.config.list[item.select_field]), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "data": item,
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1)], 1) : (item.type == 'checkbox') ? _c('el-checkbox', {
      staticClass: "disable-checkbox-label",
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "label": "1",
        "true-label": "1",
        "false-label": "0"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'color') ? _c('el-color-picker', {
      attrs: {
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "predefine": _vm.predefineColors,
        "color-format": "hex"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'boolean') ? _c('el-switch', {
      attrs: {
        "active-value": 1,
        "inactive-value": 0,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date') ? _c('el-date-picker', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.date),
        expression: "mask.date"
      }],
      attrs: {
        "type": "date",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "picker-options": _vm.handleDateOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time') ? _c('el-time-select', {
      attrs: {
        "picker-options": _vm.handleTimeOptions(item),
        "clearable": item.clearable ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'date-range') ? _c('el-date-picker', {
      attrs: {
        "type": "daterange",
        "placeholder": "dd/mm/aaaa",
        "value-format": "dd/MM/yyyy",
        "format": "dd/MM/yyyy",
        "clearable": item.clearable ? true : false,
        "start-placeholder": "Data Inicial",
        "end-placeholder": "Data Final",
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'time-range') ? _c('el-time-picker', {
      attrs: {
        "is-range": "",
        "value-format": "HH:mm",
        "format": "HH:mm",
        "start-placeholder": "Início",
        "end-placeholder": "Fim"
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'upload') ? _c('ed-upload', {
      attrs: {
        "input": item.field,
        "currentFile": _vm.data[item.field],
        "accept": item.accept ? item.accept : '',
        "multiple": item.multiple ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      }
    }) : (item.type == 'cep') ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (_vm.mask.cep),
        expression: "mask.cep"
      }],
      attrs: {
        "maxlength": item.maxlength ? item.maxlength : 10,
        "readonly": _vm.config.readonly && _vm.config.readonly[item.field] ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field])
      },
      on: {
        "blur": _vm.handleEndereco
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-cnae') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingCnae,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": "",
        "remote": "",
        "remote-method": _vm.handleCnaeDebounce,
        "value-key": "cnae",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cnaes), function(cnae) {
      return _c('el-option', {
        key: cnae.id,
        attrs: {
          "label": cnae.cnae + ' | ' + cnae.nome,
          "value": cnae
        }
      })
    }), 1) : (item.type == 'select-uf') ? _c('el-select', {
      attrs: {
        "placeholder": "Selecione",
        "loading": _vm.loadingEstado,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "clearable": "",
        "popper-append-to-body": true
      },
      on: {
        "change": _vm.handleCidadeDebounce
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.estados), function(estado) {
      return _c('el-option', {
        key: estado.uf,
        attrs: {
          "label": estado.estado.toUpperCase(),
          "value": item.value_uf ? estado.uf : estado.uf
        }
      })
    }), 1) : (item.type == 'select-cidade') ? _c('el-select', {
      attrs: {
        "placeholder": "Pesquisa...",
        "loading": _vm.loadingCidade,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "filterable": "",
        "remote": "",
        "clearable": "",
        "remote-method": _vm.handleCidadeDebounce,
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.cidades), function(cidade) {
      return _c('el-option', {
        key: cidade.id_cidade,
        attrs: {
          "label": cidade.cidade.toUpperCase(),
          "value": cidade.id_cidade
        }
      })
    }), 1) : (item.type == 'editor') ? _c('ed-editor', {
      attrs: {
        "conteudo": _vm.data[item.field],
        "model": item.field
      }
    }) : (item.type == 'select-tipo') ? _c('ed-select-tipo', {
      attrs: {
        "items": _vm.tipos[item.tipo],
        "clearable": item.clearable ? true : false,
        "multiple": item.multiple ? true : false,
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": item.placeholder ? item.placeholder : 'Selecione',
        "valor-field": item.valor
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.type == 'select-tipo-radio') ? _c('el-radio-group', {
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-radio', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px"
        },
        attrs: {
          "label": item.valor ? _vm.toString(tipo[item.valor]) : parseInt(tipo.id),
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-tipo-checkbox') ? _c('div', _vm._l((_vm.tipos[item.tipo]), function(tipo) {
      return _c('el-checkbox', {
        key: tipo.id,
        staticStyle: {
          "padding": "5px",
          "width": "100% !important"
        },
        attrs: {
          "label": item.valor ? tipo[item.valor] : tipo.id,
          "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field] ? true : false)
        },
        model: {
          value: (_vm.data[item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data, item.field, $$v)
          },
          expression: "data[item.field]"
        }
      }, [_vm._v("\n              " + _vm._s(tipo.descricao) + "\n            ")])
    }), 1) : (item.type == 'select-custom' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "placeholder": item.placeholder ? item.placeholder : 'Pesquisar...',
        "filterable": "",
        "disabled": _vm.config.disabled && _vm.config.disabled[item.field] ? true : false,
        "multiple": item.multiple ? true : false,
        "collapse-tags": "",
        "remote": "",
        "remote-method": item.disable_remote ? null : _vm.config.click[item.field],
        "value-key": "id",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(val, j) {
      return _c('el-option', {
        key: j,
        attrs: {
          "label": _vm.handleLabelSelect(item, val),
          "value": _vm.handleValueSelect(item, val),
          "title": _vm.handleTitleSelect(item, val)
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
        }
      })])
    }), 1) : (item.type == 'select-ghe' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": "",
        "popper-append-to-body": true
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao) {
      return _c('el-option-group', {
        key: revisao.id,
        attrs: {
          "label": (revisao.parent ? revisao.parent.rev + ' (' + revisao.parent.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.parent.data_hora, true) + ') / ' : '') + revisao.rev + ' (' + revisao.descricao.toUpperCase() + ' em ' + _vm.toDate(revisao.data_hora, true) + ')'
        }
      }, _vm._l((revisao.options), function(ghe) {
        return _c('el-option', {
          key: revisao.id + ghe.id,
          attrs: {
            "label": ghe.id == '0' ? ghe.descricao : ghe.ghe + ' (' + ghe.descricao + ')',
            "value": ghe.id,
            "disabled": ghe.id == '0' || revisao.disabled || (revisao.parent && revisao.parent.disabled) || (_vm.config.disabled && _vm.config.disabled[item.field]) ? true : false,
            "title": revisao.disabled || (revisao.parent && revisao.parent.disabled) ? 'O PCMSO desde GHE está vencido. Entre em contato conosco para melhores esclarecimentos.' : ''
          }
        })
      }), 1)
    }), 1) : (item.type == 'select-revisao' && _vm.config.click && _vm.config.click[item.field] && _vm.config.list && _vm.config.list[item.field]) ? _c('el-select', {
      attrs: {
        "clearable": item.clearable ? true : false,
        "loading": _vm.config.loading[item.field],
        "disabled": _vm.config.deleted_at || (_vm.config.disabled && _vm.config.disabled[item.field]),
        "placeholder": "Selecione",
        "filterable": "",
        "popper-append-to-body": true
      },
      on: {
        "change": function($event) {
          _vm.config.change[item.field](_vm.data[item.field])
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }, _vm._l((_vm.config.list[item.field]), function(revisao, j) {
      return _c('el-option-group', {
        key: j,
        attrs: {
          "label": revisao.label,
          "value-key": "id"
        }
      }, _vm._l((revisao.options), function(val, k) {
        return _c('el-option', {
          key: k,
          attrs: {
            "label": _vm.handleLabelSelect(item, val),
            "value": _vm.handleValueSelect(item, val),
            "title": _vm.handleTitleSelect(item, val)
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.handleLabelSelectHtml(item, val))
          }
        })])
      }), 1)
    }), 1) : (item.type == 'limite-credito') ? _c('div', [_c('el-radio', {
      attrs: {
        "label": 1
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("Ilimitada")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      },
      model: {
        value: (_vm.data.ilimitada),
        callback: function($$v) {
          _vm.$set(_vm.data, "ilimitada", $$v)
        },
        expression: "data.ilimitada"
      }
    }, [_vm._v("\n              Com limite de\n              "), _c('input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.data.limite),
        expression: "data.limite"
      }],
      staticClass: "el-input__inner",
      style: ('width:200px !important;' + (_vm.data.ilimitada == 1 ? 'background:#ececec' : '')),
      attrs: {
        "placeholder": "Informe o valor",
        "prefix-icon": "fa fa-usd",
        "disabled": _vm.data.ilimitada == 1
      },
      domProps: {
        "value": (_vm.data.limite)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "limite", $event.target.value)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.error && _vm.error[item.field]) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.error[item.field][0]) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.config.obs && _vm.config.obs[item.field]) ? _c('div', {
      staticStyle: {
        "font-size": "9pt"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.config.obs[item.field])
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._t("form-itens")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._t("form-footer")], 2), _vm._v(" "), (_vm.config && _vm.config.click && _vm.config.click.save) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('ed-button', {
    attrs: {
      "loading": _vm.config.loading.save,
      "icon": "fa fa-save",
      "type": "success",
      "value": " Salvar"
    },
    on: {
      "click": _vm.handlerSave
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.usuario && _vm.data.updated_at) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('b', [_vm._v("Última Atualização:")]), _vm._v(" " + _vm._s(_vm.data.usuario.usuario) + " em " + _vm._s(_vm.toDate(_vm.data.updated_at)))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2"
  }, [_c('ed-error', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
  }, [_vm._t("form-end")], 2)], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO RISCO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar risco",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getRisco
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações sobre as atividades\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Início das Atividades",
      "name": "valor.ambiente.dtIniCondicao",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dtIniCondicao),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dtIniCondicao", $$v)
      },
      expression: "formData.ambiente.dtIniCondicao"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9",
    attrs: {
      "label": "Descrição das Atividades",
      "name": "valor.Atividades",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dscAtivDes),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dscAtivDes", $$v)
      },
      expression: "formData.ambiente.dscAtivDes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações relativas ao responsável pelos registros ambientais.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Nome do Responsavel",
      "name": "valor.responsavel.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nome", $$v)
      },
      expression: "formData.responsavel.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "CPF do Responsavel",
      "name": "valor.responsavel.cpfResp",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.cpfResp),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "cpfResp", $$v)
      },
      expression: "formData.responsavel.cpfResp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Órgão de Classe",
      "items": [{
          id: 1,
          nome: 'Conselho Regional de Medicina - CRM'
        },
        {
          id: 4,
          nome: 'Conselho Regional de Engenharia e Agronomia - CREA'
        },
        {
          id: 9,
          nome: 'Outros'
        } ],
      "name": "valor.responsavel.ideOC"
    },
    model: {
      value: (_vm.formData.responsavel.ideOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ideOC", $$v)
      },
      expression: "formData.responsavel.ideOC"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Número de Incrição de Classe",
      "name": "valor.responsavel.nrOC",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nrOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nrOC", $$v)
      },
      expression: "formData.responsavel.nrOC"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Unidade Federativa",
      "name": "valor.responsavel.ufOC",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.ufOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ufOC", $$v)
      },
      expression: "formData.responsavel.ufOC"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Agente(s) nocivo(s) ao(s) qual(is) o trabalhador está exposto. - Tabela 24\n    do eSocial\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Risco",
      "title": "Inserir Novo Risco"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("RISCO")]), _vm._v(" "), _c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("TIPO DE AVALIAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("INTENSIDADE OU CONCENTRAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("LIMITE DE TOLERÂNCIA")]), _vm._v(" "), _c('b-th', [_vm._v("UNIDADE DE MEDIDA")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.riscos.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum risco cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.riscos), function(risco, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(risco.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(risco.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      key: 'dscAgNoc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.dscAgNoc),
        callback: function($$v) {
          _vm.$set(risco, "dscAgNoc", $$v)
        },
        expression: "risco.dscAgNoc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'tpAval-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Critério quantitativo'
          },
          {
            id: 2,
            nome: 'Critério qualitativo'
          } ]
      },
      model: {
        value: (risco.tpAval),
        callback: function($$v) {
          _vm.$set(risco, "tpAval", $$v)
        },
        expression: "risco.tpAval"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'intConc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.intConc),
        callback: function($$v) {
          _vm.$set(risco, "intConc", $$v)
        },
        expression: "risco.intConc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'limTol-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.limTol),
        callback: function($$v) {
          _vm.$set(risco, "limTol", $$v)
        },
        expression: "risco.limTol"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'unMed-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'dose diária de ruído'
          },
          {
            id: 2,
            nome: 'decibel linear (dB (linear))'
          },
          {
            id: 3,
            nome: 'decibel (C) (dB(C))'
          },
          {
            id: 4,
            nome: 'decibel (A) (dB(A))'
          },
          {
            id: 5,
            nome: 'metro por segundo ao quadrado (m/s2)'
          },
          {
            id: 6,
            nome: 'metro por segundo elevado a 1,75 (m/s1,75)'
          },
          {
            id: 7,
            nome: 'parte de vapor ou gás por milhão de partes de ar contaminado (ppm)'
          },
          {
            id: 8,
            nome: 'miligrama por metro cúbico de ar (mg/m3)'
          },
          {
            id: 9,
            nome: 'fibra por centímetro cúbico (f/cm3)'
          },
          {
            id: 10,
            nome: 'grau Celsius (ºC)'
          },
          {
            id: 11,
            nome: 'metro por segundo (m/s)'
          },
          {
            id: 12,
            nome: 'porcentual'
          },
          {
            id: 13,
            nome: 'lux (lx)'
          },
          {
            id: 14,
            nome: 'unidade formadora de colônias por metro cúbico (ufc/m3)'
          },
          {
            id: 15,
            nome: 'dose diária'
          },
          {
            id: 16,
            nome: 'dose mensal'
          },
          {
            id: 17,
            nome: 'dose trimestral'
          },
          {
            id: 18,
            nome: 'dose anual'
          },
          {
            id: 19,
            nome: 'watt por metro quadrado (W/m2)'
          },
          {
            id: 20,
            nome: 'ampère por metro (A/m)'
          },
          {
            id: 21,
            nome: 'militesla (mT)'
          },
          {
            id: 22,
            nome: 'microtesla (μT)'
          },
          {
            id: 23,
            nome: 'miliampère (mA)'
          },
          {
            id: 24,
            nome: 'quilovolt por metro (kV/m)'
          },
          {
            id: 25,
            nome: 'volt por metro (V/m)'
          },
          {
            id: 26,
            nome: 'joule por metro quadrado (J/m2)'
          },
          {
            id: 27,
            nome: 'milijoule por centímetro quadrado (mJ/cm2)'
          },
          {
            id: 28,
            nome: ' milisievert (mSv)'
          },
          {
            id: 29,
            nome: 'milhão de partículas por decímetro cúbico (mppdc)'
          },
          {
            id: 30,
            nome: 'umidade relativa do ar (UR (%))'
          } ],
        "required": risco.tpAval == 1
      },
      model: {
        value: (risco.unMed),
        callback: function($$v) {
          _vm.$set(risco, "unMed", $$v)
        },
        expression: "risco.unMed"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo risco"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent && _vm.cliente.logged),
      expression: "loadingContent && cliente.logged",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "page",
      "element-loading-text": "Carregando..."
    }
  }, [(_vm.noTenant) ? _c('Erro500', {
    attrs: {
      "erro": _vm.noTenant
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.$route.meta.disablePageHeader && !_vm.loadingContent && _vm.usuario.logged && _vm.usuario.logged.point) ? _c('div', [_c('EmpresaHeader')], 1) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [(!_vm.$route.meta.disablePageHeader) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": this.navigation
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent && _vm.cliente.logged) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('EmpresaFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.formData
    }
  }), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.formData.result && _vm.formData.result.tipo_status.bloqueado == 0) ? _c('div', {
    staticClass: "col-md-12 text-center mt-5"
  }, [(_vm.formData.id_tipo_status == 54) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "size": "big",
      "loading": _vm.loadingSave,
      "value": "Salvar Consulta"
    },
    on: {
      "click": _vm.salvar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center mt-2"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-file-pdf-o",
      "type": "warning",
      "size": "big",
      "value": "Gerar Guia de Encaminhamento"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.toDate(_vm.formData.result.updated_at),
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12  mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir ASO"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1)], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 194)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Essa consulta está aguardando processamento. Espere alguns minutos e atualize essa página para verificar o andamento do registro da consulta.",
      "title": "Atenção"
    }
  })], 1) : ((_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id == 195)) ? _c('div', {
    staticClass: "col-12 mt-5 text-left"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Erro ao registrar a consulta: ' + _vm.formData.result.info,
      "title": "Atenção"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames Complementares",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" Exames Complementares")]), _vm._v(" "), _c('Exames')], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result && _vm.formData.result.tipo_status && _vm.formData.result.tipo_status.id != 194 && _vm.formData.result.tipo_status.id != 195) ? _c('el-tab-pane', {
    attrs: {
      "label": "Riscos Ocupacionais",
      "name": "tab-riscos"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Riscos Ocupacionais")]), _vm._v(" "), _c('Riscos')], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Acompanhamento",
      "name": "tab-acompanhamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" Acompanhamento")]), _vm._v(" "), _c('Acompanhamento')], 1), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Exames no PCMSO",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.formData.result.ghe.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.result) ? _c('el-tab-pane', {
    attrs: {
      "label": "Histórico de Consultas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('Historico', {
    attrs: {
      "funcionario": _vm.formData.result.funcionario,
      "id_funcao": _vm.formData.result.funcao.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO PROCEDIMENTO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar procedimento",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getProcedimento
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group"
  }, [_vm._v("Informações da Consulta")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Data da Consulta",
      "maxDaysTomorrow": 1,
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aso_dt),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aso_dt", $$v)
      },
      expression: "formData.consulta.aso_dt"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Tipo de Consulta",
      "name": "id_tipo_aso",
      "tipo": "46",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.id_tipo_aso),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "id_tipo_aso", $$v)
      },
      expression: "formData.consulta.id_tipo_aso"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Aptidão",
      "name": "id_tipo_aptidao",
      "tipo": "185",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aptidao),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aptidao", $$v)
      },
      expression: "formData.consulta.aptidao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Informações do Médico Examinador")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.medico.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "nome", $$v)
      },
      expression: "formData.medico.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.medico.crm",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm", $$v)
      },
      expression: "formData.medico.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "name": "valor.medico.crm_uf",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm_uf", $$v)
      },
      expression: "formData.medico.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações do Médico Coordenador do PCMSO\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.responsavel_pcmso.nome"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "nome", $$v)
      },
      expression: "formData.responsavel_pcmso.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.responsavel_pcmso.crm",
      "type": "number"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm", $$v)
      },
      expression: "formData.responsavel_pcmso.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "items": _vm.parent.bind.estados,
      "name": "valor.responsavel_pcmso.crm_uf"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm_uf", $$v)
      },
      expression: "formData.responsavel_pcmso.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Procedimentos - Tabela 27 do eSocial")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Exame",
      "title": "Inserir Novo Exame"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA DO EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("RESULTADO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.exames.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum exame cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.exames), function(exame, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(exame.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(exame.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-date', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "maxDaysTomorrow": 1,
        "required": ""
      },
      model: {
        value: (exame.data),
        callback: function($$v) {
          _vm.$set(exame, "data", $$v)
        },
        expression: "exame.data"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Normal'
          },
          {
            id: 2,
            nome: 'Alterado'
          },
          {
            id: 3,
            nome: 'Estável'
          },
          {
            id: 4,
            nome: 'Agravamento'
          } ],
        "required": ""
      },
      model: {
        value: (exame.resultado),
        callback: function($$v) {
          _vm.$set(exame, "resultado", $$v)
        },
        expression: "exame.resultado"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo Exame"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.certificado ? _vm.certificado.tipo_certificado_nome + ' - ' + _vm.certificado.representante : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['empresa'] ? 'is-error' : '',
    attrs: {
      "label": "INSERIR NOVO VÍNCULO",
      "prop": "empresa",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "value-key": "id"
    },
    on: {
      "change": function($event) {
        return _vm.salvar('ruleForm')
      }
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                                  " + _vm._s(item.cnpj) + "\n                            ")])])
  }), 1), _vm._v(" "), (_vm.error['empresa']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['empresa'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "loadingTable": _vm.loadingTable,
      "onRegister": null,
      "onEdit": null,
      "response": _vm.response,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getEsocialCertificado
    }
  })], 1)])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.arquivo) ? _c('div', {
    staticClass: "download",
    style: ('max-width:' + (_vm.fullWidth ? '100%' : this.window.width * 0.5 + ' px') + ' !important')
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Arquivo:")]), _vm._v(" (" + _vm._s(_vm.arquivo.id) + ") " + _vm._s(_vm.arquivo.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Tamanho:")]), _vm._v(" " + _vm._s(_vm.toMb(_vm.arquivo.size)) + " \n        "), (_vm.arquivo.width && _vm.arquivo.height) ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.arquivo.width) + "x" + _vm._s(_vm.arquivo.height) + ")\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.arquivo.id && _vm.arquivo.type && _vm.arquivo.type.indexOf('image') != -1) ? _c('div', {
    staticClass: "col-md-12 text-center pt-2 pb-2"
  }, [_c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "title": "Clique para visualizar a imagem",
      "src": _vm.displayFile(_vm.arquivo),
      "fit": "scale-down",
      "preview-src-list": [_vm.displayFile(_vm.arquivo)]
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline fa-2x"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.arquivo.id) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "value": "Baixar Arquivo",
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.downloadFile(_vm.arquivo)
      }
    }
  }), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "value": "Deletar Arquivo",
      "icon": "fa fa-times",
      "loading": _vm.loadingDelete
    },
    on: {
      "click": function($event) {
        return _vm.deleteFile(_vm.arquivo)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.arquivo.name) + " (" + _vm._s(_vm.toMb(_vm.arquivo.size)) + ")")])])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode cadastrar todas as conclusões técnicas. Essas conclusões podem ser vinculados no cadastro do LTCAT."
    }
  }), _vm._v(" "), _c('Conclusao')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-modelo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Ocultar Items no Documento\n\t\t\t")]), _vm._v(" "), _c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Aqui você pode ocultar ou exibir os items no modelo do LTCAT criado."
    }
  }), _vm._v(" "), _c('Modelo')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.item ? _vm.formData.item._nome + ' :: LOGS' : ''),
      "modal": _vm.showLogs,
      "isModal": false,
      "width": "97%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData.item && _vm.formData.item && _vm.formData.item.log_erro.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Erro",
      "name": "error"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Erro\n                  "), (_vm.formData.item && _vm.formData.item.log_erro) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_erro.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_erro || _vm.formData.item.log_erro.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum erro encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_erro), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "left"
      }
    }, [(item['risco_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("RISCO SEM VÍNCULO COM ESOCIAL")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.")])]), _vm._v(" "), _vm._l((item['risco_vinculo']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['exame_vinculo']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.")])]), _vm._v(" "), _vm._l((item['exame_vinculo']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_medico']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.")])]), _vm._v(" "), _vm._l((item['cadastro_medico']), function(exame, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                " + _vm._s(exame) + "\n                              ")])
    })], 2) : (item['cadastro_funcionario']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO TRABALHADOR INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_funcionario']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.")])]), _vm._v(" "), _vm._l((item['cadastro_reg_amb']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.posicao) ? _c('b', [_vm._v(_vm._s(posicoes.posicao) + ":")]) : _vm._e(), _vm._v(" "), (posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['cadastro_ppp_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.")])]), _vm._v(" "), _vm._l((item['cadastro_ppp_fdt']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [(posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (item['erro_cadastro_fdt']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DA FRENTE DE TRABALHO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.")])]), _vm._v(" "), _vm._l((item['erro_cadastro_fdt']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_sem_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUM RISCO FOI ENCONTRADO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.")])]), _vm._v(" "), _vm._l((item['cadastro_sem_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['error_cadastro_epi']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EPI CADASTRADO INCORRETAMENTE")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.")])]), _vm._v(" "), _vm._l((item['error_cadastro_epi']), function(epis, i) {
      return [_c('p', {
        key: i,
        staticStyle: {
          "color": "#000000"
        }
      }, [_c('b', [_vm._v(_vm._s(i))])]), _vm._v(" "), _vm._l((epis), function(epi) {
        return _c('p', {
          key: epi
        }, [_vm._v("\n                                    " + _vm._s(epi) + "\n                                  ")])
      })]
    })], 2) : (item['cadastro']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO INVÁLIDO")])]), _vm._v(" "), _vm._l((item['cadastro']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['cadastro_abs']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO ABSENTEÍSMO INVÁLIDO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro")])]), _vm._v(" "), _vm._l((item['cadastro_abs']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_setor']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("CADASTRO DO GHE (SETOR) INCORRETO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão")])]), _vm._v(" "), _vm._l((item['erro_cadastro_setor']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_atividade_funcao']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador")])]), _vm._v(" "), _vm._l((item['erro_cadastro_atividade_funcao']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_fator_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Configurações > Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado")])]), _vm._v(" "), _vm._l((item['erro_cadastro_fator_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco.msg ? risco.msg : risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_epi_risco']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("EPI NÃO CADASTRADO PARA O RISCO")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado")])]), _vm._v(" "), _vm._l((item['erro_cadastro_epi_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticStyle: {
          "padding-left": "15px"
        }
      }, [_vm._v("\n                                  " + _vm._s(risco.msg ? risco.msg : risco) + "\n                              ")])
    })], 2) : (item['erro_cadastro_reg_amb']) ? _c('span', [_c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_c('b', [_vm._v("NENHUMA MEDICAÇÃO FOI CADASTRADO PARA ESSE LTCAT")])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666",
        "font-size": "9pt"
      }
    }, [_c('i', [_vm._v("Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.")])])]) : _c('span', [_c('p', [_vm._v(_vm._s(item))])])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.formData.item && _vm.formData.item && _vm.formData.item.log_warning.length) ? _c('el-tab-pane', {
    attrs: {
      "label": "Pontos de Atenção",
      "name": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Pontos de Atenção\n                  "), (_vm.formData.item && _vm.formData.item.log_warning) ? _c('span', [_vm._v(" (" + _vm._s(_vm.formData.item.log_warning.length) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', [(!_vm.formData.item || !_vm.formData.item.log_warning || _vm.formData.item.log_warning.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        Nenhum ponto de atenção encontrado\n                      ")])]) : _vm._l((_vm.formData.item.log_warning), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "color": "#ff8300"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('span', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])])])
  })], 2)])]) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadingContent) ? _c('div', {
    staticClass: "row d-flex justify-content-center",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-md-offset-4"
  }, [_c('b-card', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tAcesso Restrito\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ed-modal', {
    attrs: {
      "title": "Recuperar Senha",
      "modal": _vm.showModal,
      "width": "50%",
      "onSave": _vm.recuperarSenha,
      "loadingSave": _vm.loadingRecuperarSenha,
      "saveName": "Recuperar Senha"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.resetitens
    }
  })], 1)]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "itens": _vm.loginItens
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-sign-in",
      "type": "primary",
      "loading": _vm.loadingSave,
      "value": "Entrar"
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }, [_vm._v("Esqueci Minha Senha")])])], 1)])])], 1)])])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showConfig,
      "title": (_vm.consulta ? 'CONFIGURAÇÕES DA CONSULTA Nº ' + _vm.consulta.id_con + ' - ' + _vm.consulta.funcionario.nome : ''),
      "width": "90%"
    }
  }, [(_vm.consulta) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('Config', {
    attrs: {
      "show": _vm.showConfig,
      "consulta": _vm.consulta
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.config.loading.table,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto o email é processado..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'ENVIAR ASO POR EMAIL' +
        (_vm.parent.consulta ? ' - CONSULTA ' + _vm.parent.consulta.id_con : ''),
      "modal": _vm.parent.showDownloadASO,
      "loadingSave": _vm.loadingSave,
      "loading": _vm.parent.loadingDownloadASO,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar novo Email\n          ")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Informe abaixo o destinatário. Você pode adicionar vários emails separado por ; (ponto e vírgula).",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Empresa",
      "prop": "id_emp",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "disabled": _vm.parent.consulta ? true : false,
      "value-key": "id"
    },
    on: {
      "change": _vm.getConsulta
    },
    model: {
      value: (_vm.empresa),
      callback: function($$v) {
        _vm.empresa = $$v
      },
      expression: "empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                      " + _vm._s(item.cnpj) + "\n                    ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Destinatário",
      "prop": "destinatario",
      "rules": [{
        required: true,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Digite o destinatário (separado por `;` ponto e vírgula)",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.destinatario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "destinatario", $$v)
      },
      expression: "formData.destinatario"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Observações",
      "prop": "obs",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "O conteúdo deste campo será anexado junto com o email enviado para o destinatário...",
      "disabled": !_vm.formData.id_emp ? true : false
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Consulta",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                  Consulta\n                  "), _c('el-checkbox', {
    attrs: {
      "disabled": !_vm.formData.id_emp || (_vm.parent.consulta ? true : false)
    },
    model: {
      value: (_vm.formData.todos),
      callback: function($$v) {
        _vm.$set(_vm.formData, "todos", $$v)
      },
      expression: "formData.todos"
    }
  }, [_vm._v("Selecionar Todas as Consultas")])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Selecione a consulta",
      "loading": _vm.loadingConsulta,
      "disabled": _vm.formData.todos == 1 ||
        !_vm.formData.id_emp ||
        (_vm.parent.consulta ? true : false),
      "value-key": "id_con"
    },
    model: {
      value: (_vm.formData.consultas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consultas", $$v)
      },
      expression: "formData.consultas"
    }
  }, _vm._l((_vm.lstConsulta), function(item) {
    return _c('el-option', {
      key: item.id_con,
      attrs: {
        "value": item,
        "label": 'CÓD ' +
          item.id_con +
          ((item.dt_cad ?
              ' | ' + _vm.toDate(item.dt_cad, true) :
              '') +
            (item.tipo_aso ?
              ' | ' + item.tipo_aso.descricao.toUpperCase() :
              '') +
            (item.tipo_status ?
              ' | ' + item.tipo_status.descricao.toUpperCase() :
              ''))
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("\n                      CÓD " + _vm._s(item.id_con) + " |\n                      " + _vm._s(item.dt_cad ? _vm.toDate(item.dt_cad, true) : "") + " |\n                      " + _vm._s(item.tipo_aso ?
      item.tipo_aso.descricao.toUpperCase() :
      "") + "\n                      " + _vm._s(item.tipo_status ?
      " | " + item.tipo_status.descricao.toUpperCase() :
      "") + "\n                    ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Anexar os Seguintes Documentos",
      "prop": "id_con",
      "rules": [{
        required: _vm.formData.tipo == 2,
        message: 'Campo Obrigatorio',
      } ]
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.formData.tipo_documento),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tipo_documento", $$v)
      },
      expression: "formData.tipo_documento"
    }
  }, _vm._l((_vm.lstTipoDocumento), function(tipo) {
    return _c('el-checkbox', {
      key: tipo.id,
      staticStyle: {
        "width": "100% !important"
      },
      attrs: {
        "label": tipo.id,
        "disabled": !_vm.formData.id_emp
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.formData.consultas.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-hover has-gutter",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "400"
    }
  }, [_vm._v("CONSULTA")]), _vm._v(" "), _c('th', [_vm._v("DOCUMENTOS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.formData.consultas), function(consulta, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_vm._v("CÓD:")]), _vm._v("\n                        " + _vm._s(consulta.id_con) + "\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.funcionario.nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_vm._v(_vm._s(consulta.empresa.nome))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            Atestado de Saúde Ocupacional\n                            "), _c('br')]), _vm._v(" "), (consulta.arquivo_aso) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_aso)
        }
      }
    }, [_c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_aso
      }
    })], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "7pt"
      }
    }, [_c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                    Páginas\n                                  ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (consulta.arquivo_aso.select_pages),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_aso, "select_pages", $$v)
        },
        expression: "consulta.arquivo_aso.select_pages"
      }
    }, _vm._l((consulta.arquivo_aso.pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)]) : _c('p', [_vm._v("Nenhum arquivo")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('b', [_c('i', {
      staticClass: "fa fa-hand-o-right",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                            Exames Complementares\n                            "), _c('br')]), _vm._v(" "), (consulta.arquivo_prontuario) ? _c('p', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(consulta.arquivo_prontuario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('Download', {
      attrs: {
        "arquivo": consulta.arquivo_prontuario
      }
    })], 1), _vm._v(" "), _c('b', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Aqui você pode escolher quais páginas do documento serão enviadas por email.",
        "placement": "top"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                  Páginas\n                                ")])])], 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "210px !important"
      },
      attrs: {
        "collapse-tags": "",
        "multiple": "",
        "placeholder": "Selecione as páginas"
      },
      model: {
        value: (
          consulta.arquivo_prontuario.select_pages
        ),
        callback: function($$v) {
          _vm.$set(consulta.arquivo_prontuario, "select_pages", $$v)
        },
        expression: "\n                                consulta.arquivo_prontuario.select_pages\n                              "
      }
    }, _vm._l((consulta.arquivo_prontuario
      .pages), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1) : _c('p', [_vm._v("Nenhum arquivo")])])])])])
  }), 0)])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n            Histórico de Envio de Emails\n          ")]), _vm._v(" "), _c('DownloadAsoEmail', {
    ref: "downloadAsoEmailComponent",
    attrs: {
      "parent": _vm.parent
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Salvar"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Novo Funcionário",
      "modal": _vm.showFormEdit,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [(_vm.formData.id == 0) ? _c('ed-input-auto-complete', {
    staticClass: "text-left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Funcionário",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.lstFuncionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "itemText": "funcionario"
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.id_funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_funcionario", $$v)
      },
      expression: "formData.id_funcionario"
    }
  }) : (_vm.formData.funcionario && _vm.formData.id > 0) ? _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Trabalhador(a)",
      "type": "text",
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.funcionario.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.funcionario, "nome", $$v)
      },
      expression: "formData.funcionario.nome"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-text-area', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Descrição das Atividades do funcionário",
      "type": "text",
      "maxlength": "999",
      "required": ""
    },
    model: {
      value: (_vm.formData.descricao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descricao", $$v)
      },
      expression: "formData.descricao"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo Funcionário",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatFuncionario,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('EmailEditar', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormEdit,
      "parent": this
    }
  }), _vm._v(" "), _c('EmailTeste', {
    attrs: {
      "exame": _vm.formData,
      "showForm": _vm.showFormTeste,
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Email",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getContaEmail,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "width": (_vm.device == 'xs' ? '97%' : _vm.width),
      "close-on-press-escape": _vm.closeESC,
      "close-on-click-modal": _vm.closeCLICK,
      "modal": _vm.isModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": _vm.handlerClose
    }
  }, [_c('span', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._t("modal-content")], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.onSave) ? _c('ed-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave,
      "icon": _vm.saveIcon,
      "value": _vm.saveName
    },
    on: {
      "click": function($event) {
        return _vm.onSave()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-button', {
    attrs: {
      "type": "danger",
      "icon": "fa fa-window-close",
      "value": "Fechar"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Exames Vinculados no PCMSO"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.parent.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conta WhatsApp' : 'Editar Conta WhatsApp',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Nome da Conta")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "Nome identificador para esta conta de WhatsApp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "500",
      "show-word-limit": "",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nome", $$v)
      },
      expression: "formData.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Phone Number ID")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    ID do número de telefone na Meta."), _c('br'), _vm._v("\n                    Encontre em: Meta Business Suite > WhatsApp > Configurações da API\n                  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "255",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.phone_number_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone_number_id", $$v)
      },
      expression: "formData.phone_number_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Business Account ID")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "ID da conta WhatsApp Business na Meta"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "255",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.business_account_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "business_account_id", $$v)
      },
      expression: "formData.business_account_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Access Token")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    Token de acesso permanente da Meta."), _c('br'), _vm._v("\n                    Gere em: Meta Business Suite > WhatsApp > Configurações da API > Token de acesso permanente\n                  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": _vm.showAccessToken ? 'text' : 'password',
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.access_token),
      callback: function($$v) {
        _vm.$set(_vm.formData, "access_token", $$v)
      },
      expression: "formData.access_token"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "title": _vm.showAccessToken ? 'Ocultar token' : 'Mostrar token'
    },
    on: {
      "click": function($event) {
        _vm.showAccessToken = !_vm.showAccessToken
      }
    },
    slot: "append"
  }, [_c('i', {
    class: _vm.showAccessToken ? 'fa fa-eye-slash' : 'fa fa-eye'
  })])], 1)], 1)], 1)])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Valor"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.parent.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_select) ? _c('el-select', {
          attrs: {
            "clearable": true,
            "placeholder": "Selecione",
            "disabled": data.item._data.ativo == 0 || (_vm.parent.formData.id_tipo_campo != 212 && _vm.parent.formData.id_tipo_campo != 217)
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.tipo_campos), function(tipo) {
          return _c('el-option', {
            key: tipo.id,
            attrs: {
              "label": tipo.descricao,
              "value": tipo.id,
              "title": tipo.obs
            }
          }, [_c('div', [_vm._v(_vm._s(tipo.descricao))]), _vm._v(" "), (tipo.obs) ? _c('div', {
            staticStyle: {
              "color": "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(tipo.obs))]) : _vm._e()])
        }), 1) : (data.field && data.field.show_boolean) ? _c('el-switch', {
          attrs: {
            "active-value": 1,
            "inactive-value": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-left item-group"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  }), _vm._v("\n\t\tVALORES DESSE CAMPO\n\t")])
}]}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Empresa",
      "items": _vm.lstEmpresa,
      "loading": _vm.loadingEmpresa,
      "clearable": "",
      "remote": ""
    },
    on: {
      "search": _vm.getEmpresa
    },
    model: {
      value: (_vm.formData.id_emp),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_emp", $$v)
      },
      expression: "formData.id_emp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
    attrs: {
      "label": "Layout",
      "items": _vm.lstLayout,
      "itemValue": "codigo",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
    attrs: {
      "label": "Periodo de Apuramento",
      "format": "MM/yyyy",
      "type": "month"
    },
    model: {
      value: (_vm.formData.periodo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "periodo", $$v)
      },
      expression: "formData.periodo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5"
  }, [_c('ed-button', {
    attrs: {
      "type": "success",
      "label": "Consultar Informações no eSocial",
      "icon": "fa fa-search",
      "loading": _vm.loading,
      "disabled": !_vm.formData.id_emp || !_vm.formData.layout || !_vm.formData.periodo ? true : false
    },
    on: {
      "click": _vm.consultar
    }
  })], 1)], 1), _vm._v(" "), (_vm.erro) ? _c('div', {
    staticClass: "consulta-esocial-erro"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.erro))])]) : _vm._e(), _vm._v(" "), (_vm.formData.strXml) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto"
  }, [_c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Layout")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.layout))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Período")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.periodo))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.empresa))])]), _vm._v(" "), _c('div', {
    staticClass: "consulta-esocial-contexto__item"
  }, [_c('span', {
    staticClass: "consulta-esocial-contexto__label"
  }, [_vm._v("Consultado em")]), _vm._v(" "), _c('span', {
    staticClass: "consulta-esocial-contexto__value"
  }, [_vm._v(_vm._s(_vm.consultadoEm.data))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('XmlViewer', {
    attrs: {
      "xml": _vm.formData.strXml
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('b', [_vm._v("Informações no eSocial")])])
}]}

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(260),
      "width": "192"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Oops! Página não encontrada...")]), _vm._v(" "), _c('p', [_vm._v("\n    Verifique se você digitou o endereço corretamente.\n  ")])])
}]}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-telefone-step"
  }, [_c('h2', {
    staticClass: "aso-telefone-step__title"
  }, [_vm._v("Termine a validação pelo seu celular.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-telefone-step__text"
  }, [_vm._v("Você receberá um token por SMS para continuar.")]), _vm._v(" "), _c('input', {
    staticClass: "aso-telefone-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "15",
      "placeholder": "(00) 00000-0000",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.telefone
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:telefone', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "aso-telefone-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canContinue
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Enviando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Inserir Laboratório",
      "modal": _vm.showForm,
      "onSave": _vm.onRegister,
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Laboratório"
    },
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum laboratório encontrado",
      "busy": _vm.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHedad,
      "stacked": this.device == 'xs'
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_money) ? _c('div', [_c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "prefix-icon": "fa fa-usd"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        })], 1) : (
          data.field && data.field.show_radio && data.item._data.laboratorio
        ) ? _c('div', [_c('el-radio', {
          attrs: {
            "label": data.item._data.laboratorio.id
          },
          model: {
            value: (_vm.parent.formData.id_lab),
            callback: function($$v) {
              _vm.$set(_vm.parent.formData, "id_lab", $$v)
            },
            expression: "parent.formData.id_lab"
          }
        }, [_vm._v("\n            Padrão\n          ")])], 1) : _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n        ")])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Rotinas Automáticas do eSocial")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "rotina-list"
  }, [(!_vm.loading && _vm.rotinas.length == 0) ? _c('div', {
    staticClass: "rotina-empty"
  }, [_vm._v("\n            Nenhuma rotina configurada.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rotinas), function(rotina) {
    return _c('div', {
      key: rotina.signature,
      staticClass: "rotina-card",
      class: 'rotina-card--' + _vm.statusModifier(rotina)
    }, [_c('div', {
      staticClass: "rotina-card__header"
    }, [_c('div', {
      staticClass: "rotina-card__title"
    }, [_c('i', {
      class: _vm.rotinaIcon(rotina.signature)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(rotina.label))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "content": _vm.rotinaDescricao(rotina.signature)
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle rotina-card__help"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "rotina-card__status",
      class: 'rotina-card__status--' + _vm.statusModifier(rotina)
    }, [_c('i', {
      class: _vm.statusIcon(rotina)
    }), _vm._v(" " + _vm._s(_vm.statusLabel(rotina)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "rotina-card__meta"
    }, [_c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("Última execução")]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v("\n                  " + _vm._s(rotina.ultima_execucao ? _vm.toDate(rotina.ultima_execucao) : "Nunca executado") + "\n                ")]), _vm._v(" "), (rotina.ultima_execucao) ? _c('span', {
      staticClass: "rotina-meta__relative"
    }, [_vm._v(_vm._s(_vm.fromNow(rotina.ultima_execucao)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("Próxima execução")]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v(_vm._s(_vm.toDate(rotina.proxima_execucao)))]), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__relative"
    }, [_vm._v(_vm._s(_vm.fromNow(rotina.proxima_execucao)))])]), _vm._v(" "), (!rotina.processando && rotina.pendente !== null) ? _c('div', {
      staticClass: "rotina-meta"
    }, [_c('span', {
      staticClass: "rotina-meta__label"
    }, [_vm._v("\n                  Pendente\n                  "), (rotina.signature == 'command:esocial.gerarLote') ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "content": "Estimativa: conta eventos sem lote/recibo em qualquer layout, sem aplicar o filtro específico de cada um."
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle rotina-card__help"
    })]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "rotina-meta__value"
    }, [_vm._v(_vm._s(rotina.pendente))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "rotina-card__toggle",
      on: {
        "click": function($event) {
          return _vm.toggleHistorico(rotina.signature)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.historico == rotina.signature ? 'fa-chevron-up' : 'fa-chevron-down'
    }), _vm._v("\n              " + _vm._s(_vm.historico == rotina.signature ? "Ocultar histórico" : "Ver histórico") + "\n            ")]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "esocial-modal-fade"
      }
    }, [(_vm.historico == rotina.signature) ? _c('div', {
      staticClass: "rotina-historico"
    }, [(_vm.loadingHistorico) ? _c('div', {
      staticClass: "rotina-historico__loading"
    }, [_c('i', {
      staticClass: "fa fa-refresh fa-spin"
    }), _vm._v(" Carregando histórico...\n                ")]) : (_vm.historicoItens.length == 0) ? _c('div', {
      staticClass: "rotina-historico__empty"
    }, [_vm._v("\n                  Nenhuma execução registrada ainda.\n                ")]) : _c('table', {
      staticClass: "rotina-historico-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Horário")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.resumoColunas(_vm.historicoItens)), function(col) {
      return _c('th', {
        key: col
      }, [_vm._v(_vm._s(col))])
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoItens), function(item) {
      return _c('tr', {
        key: item.id,
        staticClass: "rotina-historico-table__row",
        class: {
          'rotina-historico-table__row--error': item.executado == 0
        },
        on: {
          "click": function($event) {
            return _vm.openDetalhe(item)
          }
        }
      }, [_c('td', {
        staticClass: "rotina-historico-table__date"
      }, [_vm._v(_vm._s(_vm.toDate(item.updated_at)))]), _vm._v(" "), _c('td', {
        staticClass: "rotina-historico-table__status"
      }, [_c('i', {
        staticClass: "fa",
        class: item.executado == 0 ? 'fa-times-circle' : 'fa-check-circle'
      }), _vm._v("\n                        " + _vm._s(item.executado == 0 ? "Falhou" : "OK") + "\n                      ")]), _vm._v(" "), _vm._l((_vm.resumoColunas(_vm.historicoItens)), function(col) {
        return _c('td', {
          key: col,
          staticClass: "rotina-historico-table__num"
        }, [_vm._v("\n                        " + _vm._s(_vm.resumoValor(item, col)) + "\n                      ")])
      })], 2)
    }), 0)])]) : _vm._e()])], 1)
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.detalheItem) ? _c('div', {
    staticClass: "esocial-modal-overlay esocial-modal-overlay--nested",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeDetalhe($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Detalhes da execução")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": _vm.closeDetalhe
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('div', {
    staticClass: "rotina-detalhe"
  }, [_c('div', {
    staticClass: "rotina-detalhe__date"
  }, [_vm._v(_vm._s(_vm.toDate(_vm.detalheItem.updated_at)))]), _vm._v(" "), _c('div', {
    staticClass: "rotina-detalhe__msg",
    class: {
      'rotina-detalhe__msg--error': _vm.detalheItem.executado == 0
    }
  }, [_vm._v("\n            " + _vm._s(_vm.detalheItem.msg || "-") + "\n          ")]), _vm._v(" "), (_vm.resumoDe(_vm.detalheItem).length) ? _c('div', {
    staticClass: "rotina-historico__resumo"
  }, _vm._l((_vm.resumoDe(_vm.detalheItem)), function(r, idx) {
    return _c('span', {
      key: idx,
      staticClass: "rotina-historico__resumo-item"
    }, [_vm._v("\n              " + _vm._s(r.label) + ": "), _c('b', [_vm._v(_vm._s(r.valor))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errosDe(_vm.detalheItem).length) ? _c('div', {
    staticClass: "rotina-historico__erros"
  }, _vm._l((_vm.errosDe(_vm.detalheItem)), function(erro, idx) {
    return _c('span', {
      key: idx,
      staticClass: "rotina-historico__erro"
    }, [_vm._v("\n              " + _vm._s(_vm.formatErro(erro)) + "\n            ")])
  }), 0) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.response && _vm.response.status && _vm.response.status != 200 && _vm.response.status != 400) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.response.msg,
      "show-icon": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conclusão Técnica' : 'Editar Conclusão Técnica',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Conclusão Técnica",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatConclusaoTecnica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'Enviar Email de Teste :: Conta ' + (this.parent ? this.parent.formData.email : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "60%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": 'EXAMES' +
        (_vm.funcionario ? ' :: ' + _vm.funcionario.nome : '') +
        ' :: ' +
        _vm.formData.periodo[0] +
        ' a ' +
        _vm.formData.periodo[1],
      "width": "97%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabExame),
      callback: function($$v) {
        _vm.tabExame = $$v
      },
      expression: "tabExame"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#4ac467",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Dentro do Período Selecionado\n                "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#dd4040",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Fora do Período Selecionado\n                "), _c('b', [_vm._v(_vm._s(_vm.formData.periodo[0]) + " a " + _vm._s(_vm.formData.periodo[1]))]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "10px",
      "background": "#d8a027",
      "float": "left"
    }
  }, [_vm._v("\n                     \n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("\n                Exame não Realizado - Fora dos requisitos do PCMSO"), _c('br')])])]), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableDataExame,
      "tableHead": _vm.tableHeadExame,
      "tableFooter": _vm.tableFooterExame,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1), _vm._v(" "), (_vm.funcionario && _vm.formData.id_empresa) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Histórico de Consultas")]), _vm._v(" "), _c('ConsultaHistorico', {
    attrs: {
      "funcionario": _vm.funcionario,
      "empresa": {
        id: _vm.formData.id_empresa
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.funcionario && _vm.formData.id_empresa) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-pcmso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" Exames no PCMSO")]), _vm._v(" "), _c('Pcmso', {
    attrs: {
      "id_ghe": _vm.funcionario.id_ghe
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-left"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-search",
      "type": "success",
      "loading": _vm.config.loading.save,
      "value": "Pesquisar"
    },
    on: {
      "click": _vm.getPeriodico
    }
  })], 1), _vm._v(" "), (!_vm.formData.id_empresa) ? _c('ed-alert', {
    staticClass: "mt-2 text-left",
    attrs: {
      "type": "warning",
      "title": "Atenção",
      "description": "Selecione todos os campos obrigatórios."
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.formData.id_empresa) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabPeriodico),
      callback: function($$v) {
        _vm.tabPeriodico = $$v
      },
      expression: "tabPeriodico"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-ok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" Dentro do Período Selecionado (" + _vm._s(_vm.tableData.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "success",
      "description": "Os trabalhadores mostrados abaixo estão com a data dos exames DENTRO PERÍODO SELECIONADO.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "onEditAll": _vm.onConsultaLote,
      "editAllIcon": "fa fa-address-card",
      "editAllName": "Gerar Consulta",
      "editAllTitle": "Gerar Consulta para os trabalhadores selecionados",
      "disableInputSearch": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar Resultado para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1)])], 1), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataTabelaPreco.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Orçamento Aproximado",
      "name": "tab-preco"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4ac467"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamento Aproximado")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Orçamento aproximado para os periódidocos dentro do período selecionado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataTabelaPreco,
      "tableHead": _vm.tableHeadTabelaPreco,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataForaPeriodo.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-nok"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Fora\n          do Período Selecionado (" + _vm._s(_vm.tableDataForaPeriodo.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "warning",
      "description": "Os trabalhadores mostrados abaixo estão com o periódico atrasado",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataForaPeriodo,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id_empresa && _vm.tableDataError.length > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Credenciadas",
      "name": "tab-error"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#dd4040"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-flash animated"
  }), _vm._v(" Erro\n          de Cadastro(" + _vm._s(_vm.tableDataError.length) + ")")]), _vm._v(" "), _c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "type": "error",
      "description": "Os trabalhadores mostrados abaixo estão com erros no cadastro.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableDataError,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "registerName": "Inserir Novo GHE",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcat,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  }), _vm._v(" "), _c('Editar', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('Cadastrar', {
    attrs: {
      "parent": this
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.formData ? 'IMPRIMIR GUIA DE ENCAMINHAMENTO OU ASO - CONSULTA Nº ' + _vm.formData.id_con : ''),
      "width": "80%"
    }
  }, [(_vm.formData) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "color": "warning",
      "icon": "info",
      "title": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n              Disponibilizamos abaixo algumas opções para você visualizar as Guias de Encaminhamento ou o ASO dessa consulta.\r\n              "), _c('br'), _vm._v("\r\n              Certifique-se que seu navegador esteja liberado para abrir os POP-UP desse sistema. Para mais informações acesse "), _c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95472?hl=pt-BR",
      "target": "_blank"
    }
  }, [_vm._v("clique aqui")])])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData && _vm.formData.tipo_status.id == 54) ? _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-guia"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Guia de Encaminhamento")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse Guia de Encaminhamento não garante atendimento na clínica. Por favor imprimir esse Guia e entregar ao funcionário para apresentar na hora do atendimento.\r\n                ")])])]), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formData && _vm.formData.id_con && (_vm.formData.tipo_status.id == 66 || _vm.formData.tipo_status.id == 67)) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "disabled": _vm.formData.tipo_status.id != 66 && _vm.formData.tipo_status.id != 67,
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onAso
    }
  }) : _c('ed-alert', {
    attrs: {
      "type": "error",
      "class_name": "q-mb-lg",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse ASO ainda não foi liberado. Você será notificado por email quando o ASO estiver liberado.\r\n                  "), (_vm.formData.credenciada.tel_com) ? _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + " pelo telefone \r\n                    " + _vm._s(_vm.formData.credenciada.tel_com) + "\r\n                  ")]) : _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + "\r\n                  ")])])])])], 1) : _vm._e()])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[981]);


// WEBPACK FOOTER //
// static/js/app.9d0fabd71bf79d423c24.js